export const ddTrainTest = [
  { x: 1, y_train: 18, y_test: 20 },
  { x: 5.5, y_train: 4.3, y_test: 6 },
  { x: 10, y_train: 1, y_test: 2 },
  { x: 13, y_train: 0.84, y_test: 1.6 },
  { x: 16.5, y_train: 0.84, y_test: 2.7 },
  { x: 18, y_train: 0.82, y_test: 8.5 },
  { x: 19, y_train: 0.78, y_test: 22 },
  { x: 20, y_train: 0.7, y_test: 5 },
  { x: 21, y_train: 0.6, y_test: 2.5 },
  { x: 22, y_train: 0.5, y_test: 0.8 },
  { x: 23, y_train: 0.4, y_test: 0.7 },
  { x: 30, y_train: 0.2, y_test: 0.4 },
];

export const circleData = [
  { x: -2.0, y: -2.0 },
  { x: -1.9, y: -1.159 },
  { x: -1.8, y: -0.432 },
  { x: -1.7, y: 0.187 },
  { x: -1.6, y: 0.704 },
  { x: -1.5, y: 1.125 },
  { x: -1.4, y: 3.025 },
  { x: -1.3, y: 1.703 },
  { x: -1.2, y: 1.872 },
  { x: -1.1, y: 1.969 },
  { x: -1.0, y: 2.0 },
  { x: -0.9, y: 1.971 },
  { x: -0.8, y: 1.888 },
  { x: -0.7, y: 1.757 },
  { x: -0.6, y: 2.249 },
  { x: -0.5, y: 1.654 },
  { x: -0.4, y: 1.136 },
  { x: -0.3, y: 0.873 },
  { x: -0.2, y: 0.592 },
  { x: -0.1, y: 0.299 },
  { x: 0.0, y: 0.0 },
  { x: 0.1, y: -0.299 },
  { x: 0.2, y: -0.592 },
  { x: 0.3, y: -0.873 },
  { x: 0.4, y: -1.136 },
  { x: 0.5, y: -1.375 },
  { x: 0.6, y: -1.584 },
  { x: 0.7, y: -1.757 },
  { x: 0.8, y: -1.888 },
  { x: 0.9, y: -1.971 },
  { x: 1.0, y: -1.373 },
  { x: 1.1, y: -1.969 },
  { x: 1.2, y: -1.872 },
  { x: 1.3, y: -1.703 },
  { x: 1.4, y: -1.456 },
  { x: 1.5, y: -1.125 },
  { x: 1.6, y: 0.396 },
  { x: 1.7, y: -0.187 },
  { x: 1.8, y: 0.432 },
  { x: 1.9, y: 1.159 },
  { x: 2.0, y: 2.0 },
];

export const errorData = [
  { x: 0.0, mae: 1.0910991426 },
  { x: 0.6931471806, mae: 0.8181747578 },
  { x: 1.0986122887, mae: 0.7971044615 },
  { x: 1.3862943611, mae: 0.4647660562 },
  { x: 1.6094379124, mae: 0.2514536982 },
  { x: 1.7917594692, mae: 0.2652467634 },
  { x: 1.9459101491, mae: 0.249181127 },
  { x: 2.0794415417, mae: 0.2521775462 },
  { x: 2.1972245773, mae: 0.2505415803 },
  { x: 2.302585093, mae: 0.2509858005 },
  { x: 2.3978952728, mae: 0.2188991999 },
  { x: 2.4849066498, mae: 0.2154726389 },
  { x: 2.5649493575, mae: 0.2075209432 },
  { x: 2.6390573296, mae: 0.208516875 },
  { x: 2.7080502011, mae: 0.2071422797 },
  { x: 2.7725887222, mae: 0.2063782597 },
  { x: 2.8332133441, mae: 0.2045526287 },
  { x: 2.8903717579, mae: 0.2172546611 },
  { x: 2.9444389792, mae: 0.2110963572 },
  { x: 2.9957322736, mae: 0.2145090347 },
  { x: 3.0445224377, mae: 0.2140807799 },
  { x: 3.0910424534, mae: 0.213860943 },
  { x: 3.1354942159, mae: 0.4268881656 },
  { x: 3.1780538303, mae: 0.4207006326 },
  { x: 3.2188758249, mae: 0.4253120801 },
  { x: 3.258096538, mae: 0.4237838427 },
  { x: 3.295836866, mae: 0.4250961147 },
  { x: 3.3322045102, mae: 0.7642614467 },
  { x: 3.36729583, mae: 0.7770430554 },
  { x: 3.4011973817, mae: 0.889741857 },
  { x: 3.4339872045, mae: 0.89148879 },
  { x: 3.4657359028, mae: 0.930287703 },
  { x: 3.4965075615, mae: 0.9454639054 },
  { x: 3.5263605246, mae: 0.93142455 },
  { x: 3.5553480615, mae: 0.9254843954 },
  { x: 3.5835189385, mae: 0.9231894216 },
  { x: 3.6109179126, mae: 0.9445692101 },
  { x: 3.6375861597, mae: 0.9321465014 },
  { x: 3.6635616461, mae: 0.9349501972 },
  { x: 3.6888794541, mae: 0.273609448 },
  { x: 3.7135720667, mae: 0.2745275443 },
  { x: 3.7376696183, mae: 0.2851379012 },
  { x: 3.7612001157, mae: 0.2856737293 },
  { x: 3.7841896339, mae: 0.2879167799 },
  { x: 3.8066624898, mae: 0.287559599 },
  { x: 3.8286413965, mae: 0.2876371109 },
  { x: 3.8501476017, mae: 0.267427547 },
  { x: 3.8712010109, mae: 0.2699101842 },
  { x: 3.8918202981, mae: 0.2702955388 },
  { x: 3.9120230054, mae: 0.2547059729 },
  { x: 3.9318256327, mae: 0.2490843017 },
  { x: 3.9512437186, mae: 0.2507288276 },
  { x: 3.9702919136, mae: 0.2503546491 },
  { x: 3.9889840466, mae: 0.2530388572 },
  { x: 4.0073331852, mae: 0.2519133382 },
  { x: 4.0253516907, mae: 0.2521691523 },
  { x: 4.0430512678, mae: 0.2514286456 },
  { x: 4.0604430105, mae: 0.2472213925 },
  { x: 4.0775374439, mae: 0.254522695 },
  { x: 4.0943445622, mae: 0.2523344873 },
  { x: 4.1108738642, mae: 0.2503292915 },
  { x: 4.127134385, mae: 0.2506099954 },
  { x: 4.1431347264, mae: 0.2505519341 },
  { x: 4.1588830834, mae: 0.2500894093 },
  { x: 4.1743872699, mae: 0.2495172835 },
  { x: 4.189654742, mae: 0.2495166058 },
  { x: 4.2046926194, mae: 0.254876959 },
  { x: 4.2195077052, mae: 0.254666655 },
  { x: 4.2341065046, mae: 0.2545029124 },
  { x: 4.248495242, mae: 0.2494029119 },
  { x: 4.262679877, mae: 0.2486339695 },
  { x: 4.276666119, mae: 0.2483824459 },
  { x: 4.2904594411, mae: 0.248083061 },
  { x: 4.3040650932, mae: 0.2479146098 },
  { x: 4.3174881135, mae: 0.2482153682 },
  { x: 4.3307333403, mae: 0.2480877534 },
  { x: 4.3438054219, mae: 0.2480383138 },
  { x: 4.3567088267, mae: 0.2481712796 },
  { x: 4.3694478525, mae: 0.2053438044 },
  { x: 4.3820266347, mae: 0.2055725712 },
  { x: 4.3944491547, mae: 0.2055629886 },
  { x: 4.4067192473, mae: 0.2052581508 },
  { x: 4.4188406078, mae: 0.2051688631 },
  { x: 4.4308167988, mae: 0.2041168376 },
  { x: 4.4426512565, mae: 0.2042695767 },
  { x: 4.4543472963, mae: 0.2048985935 },
  { x: 4.4659081187, mae: 0.2050221859 },
  { x: 4.4773368145, mae: 0.2057687607 },
  { x: 4.4886363697, mae: 0.2056561637 },
  { x: 4.4998096703, mae: 0.2062699192 },
  { x: 4.5108595065, mae: 0.2061603696 },
  { x: 4.521788577, mae: 0.2062445661 },
  { x: 4.5325994932, mae: 0.2064863626 },
  { x: 4.5432947823, mae: 0.2064563066 },
  { x: 4.5538768916, mae: 0.2065415608 },
  { x: 4.5643481915, mae: 0.2063512343 },
  { x: 4.5747109785, mae: 0.2064530742 },
  { x: 4.5849674787, mae: 0.2067539654 },
  { x: 4.5951198501, mae: 0.2068256059 },
  { x: 4.605170186, mae: 0.2066978135 },
  { x: 4.6151205168, mae: 0.2070983108 },
  { x: 4.6249728133, mae: 0.2069940262 },
  { x: 4.6347289882, mae: 0.2068157017 },
  { x: 4.6443908991, mae: 0.2070464135 },
  { x: 4.6539603502, mae: 0.2080285581 },
  { x: 4.6634390941, mae: 0.2081501138 },
  { x: 4.6728288345, mae: 0.2085494035 },
  { x: 4.6821312271, mae: 0.2080805095 },
  { x: 4.6913478822, mae: 0.2078711489 },
  { x: 4.7004803658, mae: 0.2080952574 },
  { x: 4.7095302013, mae: 0.2079662802 },
  { x: 4.7184988713, mae: 0.2086506338 },
  { x: 4.7273878187, mae: 0.2103894699 },
  { x: 4.7361984484, mae: 0.2108302985 },
  { x: 4.7449321284, mae: 0.2104979901 },
  { x: 4.7535901911, mae: 0.2095256764 },
  { x: 4.7621739348, mae: 0.2095063043 },
  { x: 4.7706846245, mae: 0.2097305821 },
  { x: 4.7791234931, mae: 0.2097654885 },
  { x: 4.7874917428, mae: 0.2098437658 },
  { x: 4.7957905456, mae: 0.2099657698 },
  { x: 4.8040210447, mae: 0.2098831132 },
  { x: 4.8121843554, mae: 0.2099766556 },
  { x: 4.8202815656, mae: 0.2099129471 },
  { x: 4.8283137373, mae: 0.2098982009 },
  { x: 4.836281907, mae: 0.2093349597 },
  { x: 4.8441870865, mae: 0.2091692397 },
  { x: 4.8520302639, mae: 0.2095542139 },
  { x: 4.8598124044, mae: 0.2098337494 },
  { x: 4.8675344505, mae: 0.2098430326 },
  { x: 4.8751973232, mae: 0.2098426402 },
  { x: 4.8828019226, mae: 0.2099674904 },
  { x: 4.8903491282, mae: 0.2102537604 },
  { x: 4.8978398, mae: 0.2099798633 },
  { x: 4.9052747784, mae: 0.2101694338 },
  { x: 4.9126548857, mae: 0.2101775539 },
  { x: 4.9199809258, mae: 0.2101909419 },
  { x: 4.9272536852, mae: 0.2101915337 },
  { x: 4.9344739331, mae: 0.2101952195 },
  { x: 4.9416424226, mae: 0.2101223354 },
  { x: 4.9487598904, mae: 0.2100896407 },
  { x: 4.9558270576, mae: 0.2103740998 },
  { x: 4.9628446303, mae: 0.2103582187 },
  { x: 4.9698132996, mae: 0.2103970109 },
  { x: 4.9767337424, mae: 0.208864405 },
  { x: 4.9836066217, mae: 0.2084822039 },
  { x: 4.9904325868, mae: 0.2081622677 },
  { x: 4.9972122738, mae: 0.2084898973 },
  { x: 5.0039463059, mae: 0.2086008638 },
  { x: 5.0106352941, mae: 0.2088171965 },
  { x: 5.0172798368, mae: 0.2092107861 },
  { x: 5.0238805208, mae: 0.2072025577 },
  { x: 5.0304379214, mae: 0.202845835 },
  { x: 5.0369526024, mae: 0.20284156 },
  { x: 5.0434251169, mae: 0.2042750634 },
  { x: 5.0498560072, mae: 0.2044411088 },
  { x: 5.0562458053, mae: 0.2042864751 },
  { x: 5.062595033, mae: 0.2045263435 },
  { x: 5.0689042022, mae: 0.2045429515 },
  { x: 5.0751738152, mae: 0.2045192353 },
  { x: 5.081404365, mae: 0.2046343701 },
  { x: 5.0875963352, mae: 0.2051071417 },
  { x: 5.0937502008, mae: 0.205270714 },
  { x: 5.0998664278, mae: 0.2053626404 },
  { x: 5.1059454739, mae: 0.2054931937 },
  { x: 5.1119877884, mae: 0.2055776997 },
  { x: 5.1179938124, mae: 0.2055649969 },
  { x: 5.1239639794, mae: 0.2055616885 },
  { x: 5.1298987149, mae: 0.2055567018 },
  { x: 5.1357984371, mae: 0.2055569245 },
  { x: 5.1416635565, mae: 0.2057166702 },
  { x: 5.1474944768, mae: 0.2057145562 },
  { x: 5.1532915945, mae: 0.2067929588 },
  { x: 5.1590552992, mae: 0.2068002373 },
  { x: 5.1647859739, mae: 0.2073007347 },
  { x: 5.170483995, mae: 0.207354293 },
  { x: 5.1761497326, mae: 0.2075221901 },
  { x: 5.1817835503, mae: 0.2075481352 },
  { x: 5.1873858058, mae: 0.2075506918 },
  { x: 5.1929568509, mae: 0.2076088268 },
  { x: 5.1984970313, mae: 0.2077610363 },
  { x: 5.2040066871, mae: 0.2078187059 },
  { x: 5.2094861528, mae: 0.2081660265 },
  { x: 5.2149357576, mae: 0.2074868423 },
  { x: 5.2203558251, mae: 0.2075941941 },
  { x: 5.2257466737, mae: 0.2079767296 },
  { x: 5.2311086169, mae: 0.2081954936 },
  { x: 5.2364419628, mae: 0.2082016725 },
  { x: 5.2417470151, mae: 0.2085067296 },
  { x: 5.2470240722, mae: 0.2085998663 },
  { x: 5.252273428, mae: 0.2085755114 },
  { x: 5.257495372, mae: 0.2085593973 },
  { x: 5.2626901889, mae: 0.2086062483 },
  { x: 5.2678581591, mae: 0.2086061238 },
  { x: 5.2729995586, mae: 0.2086647384 },
  { x: 5.2781146592, mae: 0.2085645958 },
  { x: 5.2832037287, mae: 0.2087348622 },
  { x: 5.2882670307, mae: 0.2088080371 },
  { x: 5.2933048247, mae: 0.2088078109 },
  { x: 5.2983173665, mae: 0.2088087131 },
  { x: 5.3033049081, mae: 0.2088487151 },
  { x: 5.3082676974, mae: 0.2088490231 },
  { x: 5.313205979, mae: 0.2088614989 },
  { x: 5.3181199938, mae: 0.2089461499 },
  { x: 5.3230099791, mae: 0.2089488599 },
  { x: 5.3278761688, mae: 0.2095041837 },
  { x: 5.3327187933, mae: 0.2094570596 },
  { x: 5.3375380797, mae: 0.2094561887 },
  { x: 5.342334252, mae: 0.2096679559 },
  { x: 5.3471075307, mae: 0.2096614898 },
  { x: 5.3518581335, mae: 0.2096971583 },
  { x: 5.3565862747, mae: 0.2096805983 },
  { x: 5.3612921657, mae: 0.2098383224 },
  { x: 5.365976015, mae: 0.2094790601 },
  { x: 5.3706380281, mae: 0.2096158253 },
  { x: 5.3752784077, mae: 0.2095083643 },
  { x: 5.3798973535, mae: 0.2097109815 },
  { x: 5.3844950628, mae: 0.2100282563 },
  { x: 5.3890717298, mae: 0.2100283883 },
  { x: 5.3936275464, mae: 0.2096574863 },
  { x: 5.3981627015, mae: 0.2103609972 },
  { x: 5.4026773819, mae: 0.2103826075 },
  { x: 5.4071717715, mae: 0.2103827997 },
  { x: 5.4116460519, mae: 0.210466551 },
  { x: 5.4161004022, mae: 0.2105920833 },
  { x: 5.4205349993, mae: 0.2102175524 },
  { x: 5.4249500175, mae: 0.2102121238 },
  { x: 5.429345629, mae: 0.2102186241 },
  { x: 5.4337220036, mae: 0.2102448136 },
  { x: 5.4380793089, mae: 0.2103612379 },
  { x: 5.4424177105, mae: 0.2103608978 },
  { x: 5.4467373717, mae: 0.2103611839 },
  { x: 5.4510384536, mae: 0.2103638087 },
  { x: 5.4553211154, mae: 0.2111092565 },
  { x: 5.4595855141, mae: 0.2111566571 },
  { x: 5.463831805, mae: 0.2111666708 },
  { x: 5.4680601411, mae: 0.2113643665 },
  { x: 5.4722706737, mae: 0.2113638085 },
  { x: 5.4764635519, mae: 0.2114894388 },
  { x: 5.4806389233, mae: 0.211677829 },
  { x: 5.4847969335, mae: 0.2117342831 },
  { x: 5.4889377262, mae: 0.2117347614 },
  { x: 5.4930614433, mae: 0.2118102981 },
  { x: 5.4971682253, mae: 0.2115072823 },
  { x: 5.5012582105, mae: 0.2110240546 },
  { x: 5.5053315359, mae: 0.2112474817 },
  { x: 5.5093883366, mae: 0.2114797593 },
  { x: 5.5134287462, mae: 0.2114798821 },
  { x: 5.5174528965, mae: 0.2114808771 },
  { x: 5.5214609179, mae: 0.2118091818 },
  { x: 5.5254529391, mae: 0.2118095287 },
  { x: 5.5294290875, mae: 0.2119566714 },
  { x: 5.5333894887, mae: 0.2120556055 },
  { x: 5.537334267, mae: 0.2120658645 },
  { x: 5.5412635452, mae: 0.2121810902 },
  { x: 5.5451774445, mae: 0.2120427267 },
  { x: 5.5490760849, mae: 0.211885546 },
  { x: 5.5529595849, mae: 0.2119904217 },
  { x: 5.5568280617, mae: 0.2119906144 },
  { x: 5.560681631, mae: 0.2120225475 },
  { x: 5.5645204073, mae: 0.2120194137 },
  { x: 5.5683445038, mae: 0.2120139606 },
  { x: 5.5721540322, mae: 0.2120093271 },
  { x: 5.5759491031, mae: 0.2121495382 },
  { x: 5.579729826, mae: 0.2114449037 },
  { x: 5.5834963088, mae: 0.2116140329 },
  { x: 5.5872486584, mae: 0.2114281602 },
  { x: 5.5909869805, mae: 0.2113502962 },
  { x: 5.5947113796, mae: 0.2113346397 },
  { x: 5.598421959, mae: 0.2114907928 },
  { x: 5.6021188209, mae: 0.2113664825 },
  { x: 5.6058020663, mae: 0.2113838072 },
  { x: 5.6094717952, mae: 0.211481359 },
  { x: 5.6131281064, mae: 0.2120139068 },
  { x: 5.6167710977, mae: 0.2120129629 },
  { x: 5.6204008657, mae: 0.2118202113 },
  { x: 5.6240175062, mae: 0.2120870669 },
  { x: 5.6276211137, mae: 0.2120845361 },
  { x: 5.6312117818, mae: 0.2118917543 },
  { x: 5.6347896032, mae: 0.2121152564 },
  { x: 5.6383546693, mae: 0.211623963 },
  { x: 5.6419070709, mae: 0.21171388 },
  { x: 5.6454468976, mae: 0.2116608869 },
  { x: 5.6489742382, mae: 0.2117899561 },
  { x: 5.6524891803, mae: 0.2118830864 },
  { x: 5.6559918108, mae: 0.2120123596 },
  { x: 5.6594822158, mae: 0.2120132758 },
  { x: 5.6629604801, mae: 0.2120135457 },
  { x: 5.6664266881, mae: 0.2120698788 },
  { x: 5.669880923, mae: 0.2117569389 },
  { x: 5.6733232672, mae: 0.211696112 },
  { x: 5.6767538023, mae: 0.2116954934 },
  { x: 5.680172609, mae: 0.2118580875 },
  { x: 5.6835797673, mae: 0.211860705 },
  { x: 5.6869753563, mae: 0.211881088 },
  { x: 5.6903594543, mae: 0.2118870252 },
  { x: 5.6937321388, mae: 0.2119130268 },
  { x: 5.6970934865, mae: 0.2118725126 },
  { x: 5.7004435734, mae: 0.211872773 },
  { x: 5.7037824747, mae: 0.2118731586 },
];

export const scatterData = [
  {
    x: -2.0,
    "y-2": 1.544,
    "y-12": -2.0,
    "y-46": -2.0,
    "y-1000": -2.0,
    "y-0": 1.08,
    "y-1": 1.681,
    "y-3": -0.283,
    "y-4": -1.486,
    "y-5": -1.454,
    "y-6": -2.035,
    "y-7": -2.014,
    "y-8": -2.014,
    "y-9": -2.0,
    "y-10": -2.0,
    "y-11": -2.0,
    "y-13": -2.0,
    "y-14": -2.0,
    "y-15": -2.0,
    "y-16": -2.0,
    "y-17": -2.0,
    "y-18": -2.0,
    "y-19": -2.0,
    "y-20": -2.0,
    "y-21": -2.0,
    "y-22": -2.0,
    "y-23": -2.0,
    "y-24": -2.0,
    "y-25": -2.0,
    "y-26": -2.0,
    "y-27": -2.0,
    "y-28": -2.0,
    "y-29": -2.0,
    "y-30": -2.0,
    "y-31": -2.0,
    "y-32": -2.0,
    "y-33": -2.0,
    "y-34": -2.0,
    "y-35": -2.0,
    "y-36": -2.0,
    "y-37": -2.0,
    "y-38": -2.0,
    "y-39": -2.0,
    "y-40": -2.0,
    "y-41": -2.0,
    "y-42": -2.0,
    "y-43": -2.0,
    "y-44": -2.0,
    "y-45": -2.0,
    "y-47": -2.0,
    "y-48": -2.0,
    "y-49": -2.0,
    "y-50": -2.0,
    "y-51": -2.0,
    "y-52": -2.0,
    "y-53": -2.0,
    "y-54": -2.0,
    "y-55": -2.0,
    "y-56": -2.0,
    "y-57": -2.0,
    "y-58": -2.0,
    "y-59": -2.0,
    "y-60": -2.0,
    "y-61": -2.0,
    "y-62": -2.0,
    "y-63": -2.0,
    "y-64": -2.0,
    "y-65": -2.0,
    "y-66": -2.0,
    "y-67": -2.0,
    "y-68": -2.0,
    "y-69": -2.0,
    "y-70": -2.0,
    "y-71": -2.0,
    "y-72": -2.0,
    "y-73": -2.0,
    "y-74": -2.0,
    "y-75": -2.0,
    "y-76": -2.0,
    "y-77": -2.0,
    "y-78": -2.0,
    "y-79": -2.0,
    "y-80": -2.0,
    "y-81": -2.0,
    "y-82": -2.0,
    "y-83": -2.0,
    "y-84": -2.0,
    "y-85": -2.0,
    "y-86": -2.0,
    "y-87": -2.0,
    "y-88": -2.0,
    "y-89": -2.0,
    "y-90": -2.0,
    "y-91": -2.0,
    "y-92": -2.0,
    "y-93": -2.0,
    "y-94": -2.0,
    "y-95": -2.0,
    "y-96": -2.0,
    "y-97": -2.0,
    "y-98": -2.0,
    "y-99": -2.0,
    "y-100": -2.0,
    "y-101": -2.0,
    "y-102": -2.0,
    "y-103": -2.0,
    "y-104": -2.0,
    "y-105": -2.0,
    "y-106": -2.0,
    "y-107": -2.0,
    "y-108": -2.0,
    "y-109": -2.0,
    "y-110": -2.0,
    "y-111": -2.0,
    "y-112": -2.0,
    "y-113": -2.0,
    "y-114": -2.0,
    "y-115": -2.0,
    "y-116": -2.0,
    "y-117": -2.0,
    "y-118": -2.0,
    "y-119": -2.0,
    "y-120": -2.0,
    "y-121": -2.0,
    "y-122": -2.0,
    "y-123": -2.0,
    "y-124": -2.0,
    "y-125": -2.0,
    "y-126": -2.0,
    "y-127": -2.0,
    "y-128": -2.0,
    "y-129": -2.0,
    "y-130": -2.0,
    "y-131": -2.0,
    "y-132": -2.0,
    "y-133": -2.0,
    "y-134": -2.0,
    "y-135": -2.0,
    "y-136": -2.0,
    "y-137": -2.0,
    "y-138": -2.0,
    "y-139": -2.0,
    "y-140": -2.0,
    "y-141": -2.0,
    "y-142": -2.0,
    "y-143": -2.0,
    "y-144": -2.0,
    "y-145": -2.0,
    "y-146": -2.0,
    "y-147": -2.0,
    "y-148": -2.0,
    "y-149": -2.0,
    "y-150": -2.0,
    "y-151": -2.0,
    "y-152": -2.0,
    "y-153": -2.0,
    "y-154": -2.0,
    "y-155": -2.0,
    "y-156": -2.0,
    "y-157": -2.0,
    "y-158": -2.0,
    "y-159": -2.0,
    "y-160": -2.0,
    "y-161": -2.0,
    "y-162": -2.0,
    "y-163": -2.0,
    "y-164": -2.0,
    "y-165": -2.0,
    "y-166": -2.0,
    "y-167": -2.0,
    "y-168": -2.0,
    "y-169": -2.0,
    "y-170": -2.0,
    "y-171": -2.0,
    "y-172": -2.0,
    "y-173": -2.0,
    "y-174": -2.0,
    "y-175": -2.0,
    "y-176": -2.0,
    "y-177": -2.0,
    "y-178": -2.0,
    "y-179": -2.0,
    "y-180": -2.0,
    "y-181": -2.0,
    "y-182": -2.0,
    "y-183": -2.0,
    "y-184": -2.0,
    "y-185": -2.0,
    "y-186": -2.0,
    "y-187": -2.0,
    "y-188": -2.0,
    "y-189": -2.0,
    "y-190": -2.0,
    "y-191": -2.0,
    "y-192": -2.0,
    "y-193": -2.0,
    "y-194": -2.0,
    "y-195": -2.0,
    "y-196": -2.0,
    "y-197": -2.0,
    "y-198": -2.0,
    "y-199": -2.0,
    "y-200": -2.0,
    "y-201": -2.0,
    "y-202": -2.0,
    "y-203": -2.0,
    "y-204": -2.0,
    "y-205": -2.0,
    "y-206": -2.0,
    "y-207": -2.0,
    "y-208": -2.0,
    "y-209": -2.0,
    "y-210": -2.0,
    "y-211": -2.0,
    "y-212": -2.0,
    "y-213": -2.0,
    "y-214": -2.0,
    "y-215": -2.0,
    "y-216": -2.0,
    "y-217": -2.0,
    "y-218": -2.0,
    "y-219": -2.0,
    "y-220": -2.0,
    "y-221": -2.0,
    "y-222": -2.0,
    "y-223": -2.0,
    "y-224": -2.0,
    "y-225": -2.0,
    "y-226": -2.0,
    "y-227": -2.0,
    "y-228": -2.0,
    "y-229": -2.0,
    "y-230": -2.0,
    "y-231": -2.0,
    "y-232": -2.0,
    "y-233": -2.0,
    "y-234": -2.0,
    "y-235": -2.0,
    "y-236": -2.0,
    "y-237": -2.0,
    "y-238": -2.0,
    "y-239": -2.0,
    "y-240": -2.0,
    "y-241": -2.0,
    "y-242": -2.0,
    "y-243": -2.0,
    "y-244": -2.0,
    "y-245": -2.0,
    "y-246": -2.0,
    "y-247": -2.0,
    "y-248": -2.0,
    "y-249": -2.0,
    "y-250": -2.0,
    "y-251": -2.0,
    "y-252": -2.0,
    "y-253": -2.0,
    "y-254": -2.0,
    "y-255": -2.0,
  },
  {
    x: -1.975,
    "y-2": 1.523,
    "y-12": -1.807,
    "y-46": -1.829,
    "y-1000": -1.871,
    "y-0": 1.067,
    "y-1": 1.657,
    "y-3": -0.24,
    "y-4": -1.362,
    "y-5": -1.333,
    "y-6": -1.824,
    "y-7": -1.81,
    "y-8": -1.81,
    "y-9": -1.807,
    "y-10": -1.807,
    "y-11": -1.807,
    "y-13": -1.807,
    "y-14": -1.807,
    "y-15": -1.807,
    "y-16": -1.779,
    "y-17": -1.779,
    "y-18": -1.779,
    "y-19": -1.753,
    "y-20": -1.753,
    "y-21": -1.782,
    "y-22": -1.768,
    "y-23": -1.768,
    "y-24": -1.768,
    "y-25": -1.779,
    "y-26": -1.779,
    "y-27": -1.779,
    "y-28": -1.779,
    "y-29": -1.779,
    "y-30": -1.779,
    "y-31": -1.779,
    "y-32": -1.779,
    "y-33": -1.779,
    "y-34": -1.779,
    "y-35": -1.779,
    "y-36": -1.967,
    "y-37": -1.964,
    "y-38": -1.974,
    "y-39": -1.796,
    "y-40": -1.804,
    "y-41": -1.801,
    "y-42": -1.803,
    "y-43": -1.801,
    "y-44": -1.84,
    "y-45": -1.84,
    "y-47": -1.825,
    "y-48": -1.822,
    "y-49": -1.839,
    "y-50": -1.827,
    "y-51": -1.816,
    "y-52": -1.831,
    "y-53": -1.831,
    "y-54": -1.824,
    "y-55": -1.83,
    "y-56": -1.828,
    "y-57": -1.82,
    "y-58": -1.841,
    "y-59": -1.834,
    "y-60": -1.831,
    "y-61": -1.831,
    "y-62": -1.832,
    "y-63": -1.829,
    "y-64": -1.831,
    "y-65": -1.833,
    "y-66": -1.832,
    "y-67": -1.828,
    "y-68": -1.829,
    "y-69": -1.828,
    "y-70": -1.828,
    "y-71": -1.826,
    "y-72": -1.828,
    "y-73": -1.826,
    "y-74": -1.827,
    "y-75": -1.827,
    "y-76": -1.829,
    "y-77": -1.827,
    "y-78": -1.822,
    "y-79": -1.824,
    "y-80": -1.823,
    "y-81": -1.853,
    "y-82": -1.855,
    "y-83": -1.852,
    "y-84": -1.853,
    "y-85": -1.854,
    "y-86": -1.855,
    "y-87": -1.853,
    "y-88": -1.852,
    "y-89": -1.854,
    "y-90": -1.853,
    "y-91": -1.854,
    "y-92": -1.853,
    "y-93": -1.854,
    "y-94": -1.853,
    "y-95": -1.855,
    "y-96": -1.853,
    "y-97": -1.853,
    "y-98": -1.854,
    "y-99": -1.853,
    "y-100": -1.854,
    "y-101": -1.853,
    "y-102": -1.853,
    "y-103": -1.853,
    "y-104": -1.853,
    "y-105": -1.854,
    "y-106": -1.853,
    "y-107": -1.853,
    "y-108": -1.852,
    "y-109": -1.853,
    "y-110": -1.851,
    "y-111": -1.851,
    "y-112": -1.852,
    "y-113": -1.852,
    "y-114": -1.852,
    "y-115": -1.852,
    "y-116": -1.852,
    "y-117": -1.853,
    "y-118": -1.853,
    "y-119": -1.853,
    "y-120": -1.852,
    "y-121": -1.852,
    "y-122": -1.853,
    "y-123": -1.853,
    "y-124": -1.853,
    "y-125": -1.853,
    "y-126": -1.852,
    "y-127": -1.852,
    "y-128": -1.86,
    "y-129": -1.86,
    "y-130": -1.86,
    "y-131": -1.86,
    "y-132": -1.86,
    "y-133": -1.86,
    "y-134": -1.86,
    "y-135": -1.86,
    "y-136": -1.86,
    "y-137": -1.86,
    "y-138": -1.86,
    "y-139": -1.86,
    "y-140": -1.855,
    "y-141": -1.855,
    "y-142": -1.855,
    "y-143": -1.855,
    "y-144": -1.855,
    "y-145": -1.855,
    "y-146": -1.855,
    "y-147": -1.855,
    "y-148": -1.855,
    "y-149": -1.855,
    "y-150": -1.856,
    "y-151": -1.855,
    "y-152": -1.855,
    "y-153": -1.855,
    "y-154": -1.855,
    "y-155": -1.855,
    "y-156": -1.855,
    "y-157": -1.855,
    "y-158": -1.855,
    "y-159": -1.855,
    "y-160": -1.855,
    "y-161": -1.854,
    "y-162": -1.905,
    "y-163": -1.905,
    "y-164": -1.904,
    "y-165": -1.904,
    "y-166": -1.903,
    "y-167": -1.903,
    "y-168": -1.903,
    "y-169": -1.903,
    "y-170": -1.89,
    "y-171": -1.89,
    "y-172": -1.89,
    "y-173": -1.89,
    "y-174": -1.89,
    "y-175": -1.89,
    "y-176": -1.89,
    "y-177": -1.89,
    "y-178": -1.89,
    "y-179": -1.89,
    "y-180": -1.89,
    "y-181": -1.89,
    "y-182": -1.893,
    "y-183": -1.893,
    "y-184": -1.928,
    "y-185": -1.928,
    "y-186": -1.932,
    "y-187": -1.932,
    "y-188": -1.932,
    "y-189": -1.932,
    "y-190": -1.932,
    "y-191": -1.932,
    "y-192": -1.932,
    "y-193": -1.932,
    "y-194": -1.932,
    "y-195": -1.929,
    "y-196": -1.929,
    "y-197": -1.928,
    "y-198": -1.928,
    "y-199": -1.928,
    "y-200": -1.928,
    "y-201": -1.928,
    "y-202": -1.928,
    "y-203": -1.932,
    "y-204": -1.932,
    "y-205": -1.932,
    "y-206": -1.932,
    "y-207": -1.932,
    "y-208": -1.929,
    "y-209": -1.929,
    "y-210": -1.929,
    "y-211": -1.928,
    "y-212": -1.928,
    "y-213": -1.928,
    "y-214": -1.928,
    "y-215": -1.932,
    "y-216": -1.932,
    "y-217": -1.932,
    "y-218": -1.932,
    "y-219": -1.932,
    "y-220": -1.932,
    "y-221": -1.932,
    "y-222": -1.932,
    "y-223": -1.932,
    "y-224": -1.932,
    "y-225": -1.923,
    "y-226": -1.923,
    "y-227": -1.923,
    "y-228": -1.923,
    "y-229": -1.923,
    "y-230": -1.923,
    "y-231": -1.923,
    "y-232": -1.923,
    "y-233": -1.923,
    "y-234": -1.942,
    "y-235": -1.942,
    "y-236": -1.94,
    "y-237": -1.94,
    "y-238": -1.94,
    "y-239": -1.94,
    "y-240": -1.94,
    "y-241": -1.94,
    "y-242": -1.929,
    "y-243": -1.929,
    "y-244": -1.929,
    "y-245": -1.929,
    "y-246": -1.929,
    "y-247": -1.929,
    "y-248": -1.929,
    "y-249": -1.929,
    "y-250": -1.929,
    "y-251": -1.928,
    "y-252": -1.922,
    "y-253": -1.922,
    "y-254": -1.922,
    "y-255": -1.922,
  },
  {
    x: -1.95,
    "y-2": 1.501,
    "y-12": -1.615,
    "y-46": -1.659,
    "y-1000": -1.667,
    "y-0": 1.055,
    "y-1": 1.632,
    "y-3": -0.197,
    "y-4": -1.238,
    "y-5": -1.213,
    "y-6": -1.614,
    "y-7": -1.606,
    "y-8": -1.606,
    "y-9": -1.615,
    "y-10": -1.615,
    "y-11": -1.615,
    "y-13": -1.615,
    "y-14": -1.615,
    "y-15": -1.615,
    "y-16": -1.558,
    "y-17": -1.558,
    "y-18": -1.558,
    "y-19": -1.506,
    "y-20": -1.506,
    "y-21": -1.564,
    "y-22": -1.536,
    "y-23": -1.536,
    "y-24": -1.536,
    "y-25": -1.558,
    "y-26": -1.558,
    "y-27": -1.558,
    "y-28": -1.558,
    "y-29": -1.558,
    "y-30": -1.558,
    "y-31": -1.558,
    "y-32": -1.558,
    "y-33": -1.558,
    "y-34": -1.558,
    "y-35": -1.558,
    "y-36": -1.934,
    "y-37": -1.927,
    "y-38": -1.948,
    "y-39": -1.591,
    "y-40": -1.608,
    "y-41": -1.602,
    "y-42": -1.605,
    "y-43": -1.601,
    "y-44": -1.679,
    "y-45": -1.68,
    "y-47": -1.65,
    "y-48": -1.643,
    "y-49": -1.677,
    "y-50": -1.655,
    "y-51": -1.633,
    "y-52": -1.661,
    "y-53": -1.662,
    "y-54": -1.647,
    "y-55": -1.66,
    "y-56": -1.657,
    "y-57": -1.639,
    "y-58": -1.682,
    "y-59": -1.668,
    "y-60": -1.662,
    "y-61": -1.663,
    "y-62": -1.664,
    "y-63": -1.659,
    "y-64": -1.662,
    "y-65": -1.665,
    "y-66": -1.664,
    "y-67": -1.656,
    "y-68": -1.658,
    "y-69": -1.657,
    "y-70": -1.656,
    "y-71": -1.653,
    "y-72": -1.657,
    "y-73": -1.653,
    "y-74": -1.653,
    "y-75": -1.655,
    "y-76": -1.657,
    "y-77": -1.654,
    "y-78": -1.645,
    "y-79": -1.647,
    "y-80": -1.646,
    "y-81": -1.705,
    "y-82": -1.71,
    "y-83": -1.705,
    "y-84": -1.706,
    "y-85": -1.707,
    "y-86": -1.709,
    "y-87": -1.706,
    "y-88": -1.705,
    "y-89": -1.709,
    "y-90": -1.707,
    "y-91": -1.708,
    "y-92": -1.706,
    "y-93": -1.708,
    "y-94": -1.707,
    "y-95": -1.71,
    "y-96": -1.706,
    "y-97": -1.706,
    "y-98": -1.708,
    "y-99": -1.705,
    "y-100": -1.708,
    "y-101": -1.707,
    "y-102": -1.706,
    "y-103": -1.705,
    "y-104": -1.706,
    "y-105": -1.709,
    "y-106": -1.707,
    "y-107": -1.705,
    "y-108": -1.704,
    "y-109": -1.705,
    "y-110": -1.664,
    "y-111": -1.663,
    "y-112": -1.664,
    "y-113": -1.666,
    "y-114": -1.666,
    "y-115": -1.666,
    "y-116": -1.666,
    "y-117": -1.667,
    "y-118": -1.667,
    "y-119": -1.667,
    "y-120": -1.667,
    "y-121": -1.667,
    "y-122": -1.667,
    "y-123": -1.667,
    "y-124": -1.667,
    "y-125": -1.667,
    "y-126": -1.666,
    "y-127": -1.666,
    "y-128": -1.683,
    "y-129": -1.683,
    "y-130": -1.683,
    "y-131": -1.683,
    "y-132": -1.683,
    "y-133": -1.683,
    "y-134": -1.683,
    "y-135": -1.683,
    "y-136": -1.683,
    "y-137": -1.683,
    "y-138": -1.683,
    "y-139": -1.683,
    "y-140": -1.675,
    "y-141": -1.675,
    "y-142": -1.675,
    "y-143": -1.675,
    "y-144": -1.675,
    "y-145": -1.675,
    "y-146": -1.675,
    "y-147": -1.675,
    "y-148": -1.676,
    "y-149": -1.676,
    "y-150": -1.676,
    "y-151": -1.676,
    "y-152": -1.675,
    "y-153": -1.675,
    "y-154": -1.675,
    "y-155": -1.675,
    "y-156": -1.675,
    "y-157": -1.675,
    "y-158": -1.675,
    "y-159": -1.675,
    "y-160": -1.675,
    "y-161": -1.675,
    "y-162": -1.69,
    "y-163": -1.69,
    "y-164": -1.689,
    "y-165": -1.689,
    "y-166": -1.688,
    "y-167": -1.688,
    "y-168": -1.688,
    "y-169": -1.688,
    "y-170": -1.675,
    "y-171": -1.675,
    "y-172": -1.675,
    "y-173": -1.675,
    "y-174": -1.675,
    "y-175": -1.675,
    "y-176": -1.675,
    "y-177": -1.675,
    "y-178": -1.675,
    "y-179": -1.675,
    "y-180": -1.675,
    "y-181": -1.675,
    "y-182": -1.682,
    "y-183": -1.682,
    "y-184": -1.695,
    "y-185": -1.695,
    "y-186": -1.702,
    "y-187": -1.702,
    "y-188": -1.702,
    "y-189": -1.702,
    "y-190": -1.702,
    "y-191": -1.702,
    "y-192": -1.702,
    "y-193": -1.702,
    "y-194": -1.702,
    "y-195": -1.7,
    "y-196": -1.7,
    "y-197": -1.699,
    "y-198": -1.699,
    "y-199": -1.699,
    "y-200": -1.699,
    "y-201": -1.699,
    "y-202": -1.699,
    "y-203": -1.707,
    "y-204": -1.707,
    "y-205": -1.707,
    "y-206": -1.707,
    "y-207": -1.707,
    "y-208": -1.704,
    "y-209": -1.704,
    "y-210": -1.704,
    "y-211": -1.703,
    "y-212": -1.703,
    "y-213": -1.703,
    "y-214": -1.703,
    "y-215": -1.711,
    "y-216": -1.711,
    "y-217": -1.711,
    "y-218": -1.711,
    "y-219": -1.711,
    "y-220": -1.711,
    "y-221": -1.711,
    "y-222": -1.711,
    "y-223": -1.711,
    "y-224": -1.711,
    "y-225": -1.697,
    "y-226": -1.697,
    "y-227": -1.697,
    "y-228": -1.697,
    "y-229": -1.697,
    "y-230": -1.697,
    "y-231": -1.697,
    "y-232": -1.697,
    "y-233": -1.697,
    "y-234": -1.704,
    "y-235": -1.704,
    "y-236": -1.703,
    "y-237": -1.703,
    "y-238": -1.703,
    "y-239": -1.703,
    "y-240": -1.703,
    "y-241": -1.703,
    "y-242": -1.693,
    "y-243": -1.693,
    "y-244": -1.693,
    "y-245": -1.693,
    "y-246": -1.693,
    "y-247": -1.693,
    "y-248": -1.693,
    "y-249": -1.693,
    "y-250": -1.693,
    "y-251": -1.692,
    "y-252": -1.687,
    "y-253": -1.687,
    "y-254": -1.687,
    "y-255": -1.687,
  },
  {
    x: -1.925,
    "y-2": 1.48,
    "y-12": -1.421,
    "y-46": -1.413,
    "y-1000": -1.418,
    "y-0": 1.043,
    "y-1": 1.607,
    "y-3": -0.154,
    "y-4": -1.113,
    "y-5": -1.092,
    "y-6": -1.403,
    "y-7": -1.402,
    "y-8": -1.402,
    "y-9": -1.421,
    "y-10": -1.421,
    "y-11": -1.421,
    "y-13": -1.421,
    "y-14": -1.421,
    "y-15": -1.421,
    "y-16": -1.34,
    "y-17": -1.34,
    "y-18": -1.34,
    "y-19": -1.267,
    "y-20": -1.267,
    "y-21": -1.349,
    "y-22": -1.309,
    "y-23": -1.309,
    "y-24": -1.309,
    "y-25": -1.341,
    "y-26": -1.341,
    "y-27": -1.341,
    "y-28": -1.341,
    "y-29": -1.341,
    "y-30": -1.341,
    "y-31": -1.341,
    "y-32": -1.341,
    "y-33": -1.341,
    "y-34": -1.341,
    "y-35": -1.341,
    "y-36": -1.84,
    "y-37": -1.832,
    "y-38": -1.859,
    "y-39": -1.385,
    "y-40": -1.408,
    "y-41": -1.399,
    "y-42": -1.403,
    "y-43": -1.398,
    "y-44": -1.42,
    "y-45": -1.42,
    "y-47": -1.402,
    "y-48": -1.41,
    "y-49": -1.411,
    "y-50": -1.408,
    "y-51": -1.402,
    "y-52": -1.396,
    "y-53": -1.424,
    "y-54": -1.406,
    "y-55": -1.399,
    "y-56": -1.405,
    "y-57": -1.404,
    "y-58": -1.409,
    "y-59": -1.42,
    "y-60": -1.412,
    "y-61": -1.416,
    "y-62": -1.414,
    "y-63": -1.407,
    "y-64": -1.412,
    "y-65": -1.415,
    "y-66": -1.415,
    "y-67": -1.411,
    "y-68": -1.411,
    "y-69": -1.411,
    "y-70": -1.411,
    "y-71": -1.406,
    "y-72": -1.411,
    "y-73": -1.407,
    "y-74": -1.407,
    "y-75": -1.407,
    "y-76": -1.409,
    "y-77": -1.409,
    "y-78": -1.404,
    "y-79": -1.405,
    "y-80": -1.404,
    "y-81": -1.459,
    "y-82": -1.467,
    "y-83": -1.459,
    "y-84": -1.46,
    "y-85": -1.462,
    "y-86": -1.465,
    "y-87": -1.462,
    "y-88": -1.457,
    "y-89": -1.465,
    "y-90": -1.461,
    "y-91": -1.465,
    "y-92": -1.461,
    "y-93": -1.466,
    "y-94": -1.464,
    "y-95": -1.467,
    "y-96": -1.463,
    "y-97": -1.463,
    "y-98": -1.464,
    "y-99": -1.462,
    "y-100": -1.464,
    "y-101": -1.462,
    "y-102": -1.464,
    "y-103": -1.463,
    "y-104": -1.463,
    "y-105": -1.467,
    "y-106": -1.464,
    "y-107": -1.463,
    "y-108": -1.462,
    "y-109": -1.463,
    "y-110": -1.425,
    "y-111": -1.424,
    "y-112": -1.425,
    "y-113": -1.427,
    "y-114": -1.427,
    "y-115": -1.427,
    "y-116": -1.427,
    "y-117": -1.428,
    "y-118": -1.427,
    "y-119": -1.428,
    "y-120": -1.428,
    "y-121": -1.428,
    "y-122": -1.429,
    "y-123": -1.428,
    "y-124": -1.428,
    "y-125": -1.428,
    "y-126": -1.428,
    "y-127": -1.428,
    "y-128": -1.439,
    "y-129": -1.439,
    "y-130": -1.439,
    "y-131": -1.439,
    "y-132": -1.439,
    "y-133": -1.439,
    "y-134": -1.439,
    "y-135": -1.439,
    "y-136": -1.439,
    "y-137": -1.439,
    "y-138": -1.439,
    "y-139": -1.439,
    "y-140": -1.433,
    "y-141": -1.434,
    "y-142": -1.434,
    "y-143": -1.434,
    "y-144": -1.434,
    "y-145": -1.434,
    "y-146": -1.433,
    "y-147": -1.433,
    "y-148": -1.434,
    "y-149": -1.434,
    "y-150": -1.435,
    "y-151": -1.435,
    "y-152": -1.434,
    "y-153": -1.434,
    "y-154": -1.434,
    "y-155": -1.434,
    "y-156": -1.434,
    "y-157": -1.434,
    "y-158": -1.434,
    "y-159": -1.434,
    "y-160": -1.434,
    "y-161": -1.434,
    "y-162": -1.431,
    "y-163": -1.431,
    "y-164": -1.431,
    "y-165": -1.431,
    "y-166": -1.43,
    "y-167": -1.43,
    "y-168": -1.43,
    "y-169": -1.43,
    "y-170": -1.423,
    "y-171": -1.423,
    "y-172": -1.423,
    "y-173": -1.423,
    "y-174": -1.422,
    "y-175": -1.423,
    "y-176": -1.423,
    "y-177": -1.423,
    "y-178": -1.423,
    "y-179": -1.423,
    "y-180": -1.423,
    "y-181": -1.423,
    "y-182": -1.43,
    "y-183": -1.43,
    "y-184": -1.43,
    "y-185": -1.43,
    "y-186": -1.438,
    "y-187": -1.438,
    "y-188": -1.438,
    "y-189": -1.438,
    "y-190": -1.438,
    "y-191": -1.438,
    "y-192": -1.438,
    "y-193": -1.438,
    "y-194": -1.438,
    "y-195": -1.437,
    "y-196": -1.437,
    "y-197": -1.436,
    "y-198": -1.436,
    "y-199": -1.436,
    "y-200": -1.436,
    "y-201": -1.436,
    "y-202": -1.436,
    "y-203": -1.444,
    "y-204": -1.444,
    "y-205": -1.444,
    "y-206": -1.444,
    "y-207": -1.444,
    "y-208": -1.443,
    "y-209": -1.443,
    "y-210": -1.443,
    "y-211": -1.442,
    "y-212": -1.442,
    "y-213": -1.442,
    "y-214": -1.442,
    "y-215": -1.45,
    "y-216": -1.45,
    "y-217": -1.45,
    "y-218": -1.45,
    "y-219": -1.45,
    "y-220": -1.45,
    "y-221": -1.45,
    "y-222": -1.45,
    "y-223": -1.45,
    "y-224": -1.45,
    "y-225": -1.439,
    "y-226": -1.439,
    "y-227": -1.439,
    "y-228": -1.439,
    "y-229": -1.439,
    "y-230": -1.439,
    "y-231": -1.439,
    "y-232": -1.439,
    "y-233": -1.439,
    "y-234": -1.44,
    "y-235": -1.44,
    "y-236": -1.439,
    "y-237": -1.439,
    "y-238": -1.439,
    "y-239": -1.439,
    "y-240": -1.439,
    "y-241": -1.439,
    "y-242": -1.434,
    "y-243": -1.434,
    "y-244": -1.434,
    "y-245": -1.434,
    "y-246": -1.434,
    "y-247": -1.434,
    "y-248": -1.434,
    "y-249": -1.434,
    "y-250": -1.434,
    "y-251": -1.433,
    "y-252": -1.43,
    "y-253": -1.43,
    "y-254": -1.43,
    "y-255": -1.43,
  },
  {
    x: -1.9,
    "y-2": 1.459,
    "y-12": -1.214,
    "y-46": -1.159,
    "y-1000": -1.159,
    "y-0": 1.031,
    "y-1": 1.583,
    "y-3": -0.111,
    "y-4": -0.989,
    "y-5": -0.971,
    "y-6": -1.193,
    "y-7": -1.198,
    "y-8": -1.198,
    "y-9": -1.214,
    "y-10": -1.214,
    "y-11": -1.214,
    "y-13": -1.214,
    "y-14": -1.214,
    "y-15": -1.214,
    "y-16": -1.161,
    "y-17": -1.161,
    "y-18": -1.161,
    "y-19": -1.114,
    "y-20": -1.114,
    "y-21": -1.167,
    "y-22": -1.141,
    "y-23": -1.141,
    "y-24": -1.141,
    "y-25": -1.159,
    "y-26": -1.159,
    "y-27": -1.159,
    "y-28": -1.159,
    "y-29": -1.159,
    "y-30": -1.159,
    "y-31": -1.159,
    "y-32": -1.159,
    "y-33": -1.159,
    "y-34": -1.159,
    "y-35": -1.159,
    "y-36": -1.159,
    "y-37": -1.159,
    "y-38": -1.159,
    "y-39": -1.159,
    "y-40": -1.159,
    "y-41": -1.159,
    "y-42": -1.159,
    "y-43": -1.159,
    "y-44": -1.159,
    "y-45": -1.159,
    "y-47": -1.159,
    "y-48": -1.159,
    "y-49": -1.159,
    "y-50": -1.159,
    "y-51": -1.159,
    "y-52": -1.159,
    "y-53": -1.159,
    "y-54": -1.159,
    "y-55": -1.159,
    "y-56": -1.159,
    "y-57": -1.159,
    "y-58": -1.159,
    "y-59": -1.159,
    "y-60": -1.159,
    "y-61": -1.159,
    "y-62": -1.159,
    "y-63": -1.159,
    "y-64": -1.159,
    "y-65": -1.159,
    "y-66": -1.159,
    "y-67": -1.159,
    "y-68": -1.159,
    "y-69": -1.159,
    "y-70": -1.159,
    "y-71": -1.159,
    "y-72": -1.159,
    "y-73": -1.159,
    "y-74": -1.159,
    "y-75": -1.159,
    "y-76": -1.159,
    "y-77": -1.159,
    "y-78": -1.159,
    "y-79": -1.159,
    "y-80": -1.159,
    "y-81": -1.159,
    "y-82": -1.159,
    "y-83": -1.159,
    "y-84": -1.159,
    "y-85": -1.159,
    "y-86": -1.159,
    "y-87": -1.159,
    "y-88": -1.159,
    "y-89": -1.159,
    "y-90": -1.159,
    "y-91": -1.159,
    "y-92": -1.159,
    "y-93": -1.159,
    "y-94": -1.159,
    "y-95": -1.159,
    "y-96": -1.159,
    "y-97": -1.159,
    "y-98": -1.159,
    "y-99": -1.159,
    "y-100": -1.159,
    "y-101": -1.159,
    "y-102": -1.159,
    "y-103": -1.159,
    "y-104": -1.159,
    "y-105": -1.159,
    "y-106": -1.159,
    "y-107": -1.159,
    "y-108": -1.159,
    "y-109": -1.159,
    "y-110": -1.159,
    "y-111": -1.159,
    "y-112": -1.159,
    "y-113": -1.159,
    "y-114": -1.159,
    "y-115": -1.159,
    "y-116": -1.159,
    "y-117": -1.159,
    "y-118": -1.159,
    "y-119": -1.159,
    "y-120": -1.159,
    "y-121": -1.159,
    "y-122": -1.159,
    "y-123": -1.159,
    "y-124": -1.159,
    "y-125": -1.159,
    "y-126": -1.159,
    "y-127": -1.159,
    "y-128": -1.159,
    "y-129": -1.159,
    "y-130": -1.159,
    "y-131": -1.159,
    "y-132": -1.159,
    "y-133": -1.159,
    "y-134": -1.159,
    "y-135": -1.159,
    "y-136": -1.159,
    "y-137": -1.159,
    "y-138": -1.159,
    "y-139": -1.159,
    "y-140": -1.159,
    "y-141": -1.159,
    "y-142": -1.159,
    "y-143": -1.159,
    "y-144": -1.159,
    "y-145": -1.159,
    "y-146": -1.159,
    "y-147": -1.159,
    "y-148": -1.159,
    "y-149": -1.159,
    "y-150": -1.159,
    "y-151": -1.159,
    "y-152": -1.159,
    "y-153": -1.159,
    "y-154": -1.159,
    "y-155": -1.159,
    "y-156": -1.159,
    "y-157": -1.159,
    "y-158": -1.159,
    "y-159": -1.159,
    "y-160": -1.159,
    "y-161": -1.159,
    "y-162": -1.159,
    "y-163": -1.159,
    "y-164": -1.159,
    "y-165": -1.159,
    "y-166": -1.159,
    "y-167": -1.159,
    "y-168": -1.159,
    "y-169": -1.159,
    "y-170": -1.159,
    "y-171": -1.159,
    "y-172": -1.159,
    "y-173": -1.159,
    "y-174": -1.159,
    "y-175": -1.159,
    "y-176": -1.159,
    "y-177": -1.159,
    "y-178": -1.159,
    "y-179": -1.159,
    "y-180": -1.159,
    "y-181": -1.159,
    "y-182": -1.159,
    "y-183": -1.159,
    "y-184": -1.159,
    "y-185": -1.159,
    "y-186": -1.159,
    "y-187": -1.159,
    "y-188": -1.159,
    "y-189": -1.159,
    "y-190": -1.159,
    "y-191": -1.159,
    "y-192": -1.159,
    "y-193": -1.159,
    "y-194": -1.159,
    "y-195": -1.159,
    "y-196": -1.159,
    "y-197": -1.159,
    "y-198": -1.159,
    "y-199": -1.159,
    "y-200": -1.159,
    "y-201": -1.159,
    "y-202": -1.159,
    "y-203": -1.159,
    "y-204": -1.159,
    "y-205": -1.159,
    "y-206": -1.159,
    "y-207": -1.159,
    "y-208": -1.159,
    "y-209": -1.159,
    "y-210": -1.159,
    "y-211": -1.159,
    "y-212": -1.159,
    "y-213": -1.159,
    "y-214": -1.159,
    "y-215": -1.159,
    "y-216": -1.159,
    "y-217": -1.159,
    "y-218": -1.159,
    "y-219": -1.159,
    "y-220": -1.159,
    "y-221": -1.159,
    "y-222": -1.159,
    "y-223": -1.159,
    "y-224": -1.159,
    "y-225": -1.159,
    "y-226": -1.159,
    "y-227": -1.159,
    "y-228": -1.159,
    "y-229": -1.159,
    "y-230": -1.159,
    "y-231": -1.159,
    "y-232": -1.159,
    "y-233": -1.159,
    "y-234": -1.159,
    "y-235": -1.159,
    "y-236": -1.159,
    "y-237": -1.159,
    "y-238": -1.159,
    "y-239": -1.159,
    "y-240": -1.159,
    "y-241": -1.159,
    "y-242": -1.159,
    "y-243": -1.159,
    "y-244": -1.159,
    "y-245": -1.159,
    "y-246": -1.159,
    "y-247": -1.159,
    "y-248": -1.159,
    "y-249": -1.159,
    "y-250": -1.159,
    "y-251": -1.159,
    "y-252": -1.159,
    "y-253": -1.159,
    "y-254": -1.159,
    "y-255": -1.159,
  },
  {
    x: -1.875,
    "y-2": 1.438,
    "y-12": -1.008,
    "y-46": -0.905,
    "y-1000": -0.944,
    "y-0": 1.019,
    "y-1": 1.558,
    "y-3": -0.068,
    "y-4": -0.865,
    "y-5": -0.85,
    "y-6": -0.982,
    "y-7": -0.994,
    "y-8": -0.994,
    "y-9": -1.008,
    "y-10": -1.008,
    "y-11": -1.008,
    "y-13": -1.008,
    "y-14": -1.008,
    "y-15": -1.008,
    "y-16": -0.983,
    "y-17": -0.983,
    "y-18": -0.983,
    "y-19": -0.96,
    "y-20": -0.96,
    "y-21": -0.985,
    "y-22": -0.973,
    "y-23": -0.973,
    "y-24": -0.973,
    "y-25": -0.977,
    "y-26": -0.977,
    "y-27": -0.977,
    "y-28": -0.977,
    "y-29": -0.977,
    "y-30": -0.977,
    "y-31": -0.977,
    "y-32": -0.977,
    "y-33": -0.977,
    "y-34": -0.977,
    "y-35": -0.977,
    "y-36": -0.478,
    "y-37": -0.486,
    "y-38": -0.459,
    "y-39": -0.933,
    "y-40": -0.91,
    "y-41": -0.919,
    "y-42": -0.915,
    "y-43": -0.92,
    "y-44": -0.898,
    "y-45": -0.898,
    "y-47": -0.916,
    "y-48": -0.908,
    "y-49": -0.907,
    "y-50": -0.91,
    "y-51": -0.916,
    "y-52": -0.922,
    "y-53": -0.894,
    "y-54": -0.912,
    "y-55": -0.919,
    "y-56": -0.913,
    "y-57": -0.914,
    "y-58": -0.909,
    "y-59": -0.898,
    "y-60": -0.906,
    "y-61": -0.902,
    "y-62": -0.904,
    "y-63": -0.911,
    "y-64": -0.906,
    "y-65": -0.903,
    "y-66": -0.903,
    "y-67": -0.907,
    "y-68": -0.907,
    "y-69": -0.907,
    "y-70": -0.907,
    "y-71": -0.912,
    "y-72": -0.907,
    "y-73": -0.911,
    "y-74": -0.911,
    "y-75": -0.911,
    "y-76": -0.909,
    "y-77": -0.909,
    "y-78": -0.914,
    "y-79": -0.913,
    "y-80": -0.914,
    "y-81": -0.936,
    "y-82": -0.935,
    "y-83": -0.939,
    "y-84": -0.939,
    "y-85": -0.94,
    "y-86": -0.938,
    "y-87": -0.938,
    "y-88": -0.939,
    "y-89": -0.938,
    "y-90": -0.939,
    "y-91": -0.937,
    "y-92": -0.939,
    "y-93": -0.937,
    "y-94": -0.937,
    "y-95": -0.937,
    "y-96": -0.937,
    "y-97": -0.938,
    "y-98": -0.938,
    "y-99": -0.938,
    "y-100": -0.937,
    "y-101": -0.937,
    "y-102": -0.938,
    "y-103": -0.937,
    "y-104": -0.937,
    "y-105": -0.937,
    "y-106": -0.938,
    "y-107": -0.937,
    "y-108": -0.939,
    "y-109": -0.938,
    "y-110": -0.948,
    "y-111": -0.948,
    "y-112": -0.948,
    "y-113": -0.942,
    "y-114": -0.942,
    "y-115": -0.942,
    "y-116": -0.942,
    "y-117": -0.94,
    "y-118": -0.94,
    "y-119": -0.94,
    "y-120": -0.94,
    "y-121": -0.94,
    "y-122": -0.94,
    "y-123": -0.94,
    "y-124": -0.94,
    "y-125": -0.94,
    "y-126": -0.941,
    "y-127": -0.941,
    "y-128": -0.938,
    "y-129": -0.938,
    "y-130": -0.938,
    "y-131": -0.938,
    "y-132": -0.938,
    "y-133": -0.938,
    "y-134": -0.938,
    "y-135": -0.938,
    "y-136": -0.938,
    "y-137": -0.938,
    "y-138": -0.938,
    "y-139": -0.938,
    "y-140": -0.94,
    "y-141": -0.939,
    "y-142": -0.939,
    "y-143": -0.939,
    "y-144": -0.939,
    "y-145": -0.939,
    "y-146": -0.939,
    "y-147": -0.939,
    "y-148": -0.938,
    "y-149": -0.938,
    "y-150": -0.937,
    "y-151": -0.938,
    "y-152": -0.938,
    "y-153": -0.938,
    "y-154": -0.938,
    "y-155": -0.938,
    "y-156": -0.938,
    "y-157": -0.938,
    "y-158": -0.938,
    "y-159": -0.938,
    "y-160": -0.938,
    "y-161": -0.938,
    "y-162": -0.939,
    "y-163": -0.939,
    "y-164": -0.939,
    "y-165": -0.939,
    "y-166": -0.939,
    "y-167": -0.939,
    "y-168": -0.939,
    "y-169": -0.939,
    "y-170": -0.942,
    "y-171": -0.942,
    "y-172": -0.942,
    "y-173": -0.942,
    "y-174": -0.942,
    "y-175": -0.942,
    "y-176": -0.942,
    "y-177": -0.942,
    "y-178": -0.942,
    "y-179": -0.942,
    "y-180": -0.942,
    "y-181": -0.942,
    "y-182": -0.93,
    "y-183": -0.93,
    "y-184": -0.93,
    "y-185": -0.93,
    "y-186": -0.916,
    "y-187": -0.916,
    "y-188": -0.916,
    "y-189": -0.916,
    "y-190": -0.916,
    "y-191": -0.916,
    "y-192": -0.916,
    "y-193": -0.916,
    "y-194": -0.916,
    "y-195": -0.917,
    "y-196": -0.917,
    "y-197": -0.917,
    "y-198": -0.917,
    "y-199": -0.917,
    "y-200": -0.917,
    "y-201": -0.917,
    "y-202": -0.917,
    "y-203": -0.912,
    "y-204": -0.912,
    "y-205": -0.912,
    "y-206": -0.912,
    "y-207": -0.912,
    "y-208": -0.913,
    "y-209": -0.913,
    "y-210": -0.913,
    "y-211": -0.913,
    "y-212": -0.913,
    "y-213": -0.913,
    "y-214": -0.913,
    "y-215": -0.918,
    "y-216": -0.918,
    "y-217": -0.918,
    "y-218": -0.918,
    "y-219": -0.918,
    "y-220": -0.919,
    "y-221": -0.919,
    "y-222": -0.919,
    "y-223": -0.918,
    "y-224": -0.918,
    "y-225": -0.923,
    "y-226": -0.923,
    "y-227": -0.923,
    "y-228": -0.923,
    "y-229": -0.923,
    "y-230": -0.923,
    "y-231": -0.923,
    "y-232": -0.923,
    "y-233": -0.924,
    "y-234": -0.923,
    "y-235": -0.923,
    "y-236": -0.924,
    "y-237": -0.924,
    "y-238": -0.924,
    "y-239": -0.924,
    "y-240": -0.924,
    "y-241": -0.924,
    "y-242": -0.926,
    "y-243": -0.926,
    "y-244": -0.926,
    "y-245": -0.926,
    "y-246": -0.926,
    "y-247": -0.926,
    "y-248": -0.926,
    "y-249": -0.926,
    "y-250": -0.926,
    "y-251": -0.927,
    "y-252": -0.928,
    "y-253": -0.928,
    "y-254": -0.928,
    "y-255": -0.928,
  },
  {
    x: -1.85,
    "y-2": 1.416,
    "y-12": -0.802,
    "y-46": -0.699,
    "y-1000": -0.754,
    "y-0": 1.006,
    "y-1": 1.534,
    "y-3": -0.025,
    "y-4": -0.741,
    "y-5": -0.729,
    "y-6": -0.772,
    "y-7": -0.79,
    "y-8": -0.79,
    "y-9": -0.802,
    "y-10": -0.802,
    "y-11": -0.802,
    "y-13": -0.802,
    "y-14": -0.802,
    "y-15": -0.802,
    "y-16": -0.804,
    "y-17": -0.804,
    "y-18": -0.804,
    "y-19": -0.806,
    "y-20": -0.806,
    "y-21": -0.803,
    "y-22": -0.805,
    "y-23": -0.804,
    "y-24": -0.804,
    "y-25": -0.796,
    "y-26": -0.796,
    "y-27": -0.796,
    "y-28": -0.795,
    "y-29": -0.795,
    "y-30": -0.795,
    "y-31": -0.796,
    "y-32": -0.795,
    "y-33": -0.795,
    "y-34": -0.795,
    "y-35": -0.796,
    "y-36": -0.124,
    "y-37": -0.135,
    "y-38": -0.098,
    "y-39": -0.736,
    "y-40": -0.706,
    "y-41": -0.717,
    "y-42": -0.711,
    "y-43": -0.718,
    "y-44": -0.689,
    "y-45": -0.69,
    "y-47": -0.713,
    "y-48": -0.702,
    "y-49": -0.701,
    "y-50": -0.706,
    "y-51": -0.713,
    "y-52": -0.721,
    "y-53": -0.684,
    "y-54": -0.708,
    "y-55": -0.717,
    "y-56": -0.709,
    "y-57": -0.71,
    "y-58": -0.703,
    "y-59": -0.689,
    "y-60": -0.699,
    "y-61": -0.694,
    "y-62": -0.697,
    "y-63": -0.706,
    "y-64": -0.7,
    "y-65": -0.695,
    "y-66": -0.695,
    "y-67": -0.701,
    "y-68": -0.701,
    "y-69": -0.701,
    "y-70": -0.701,
    "y-71": -0.707,
    "y-72": -0.702,
    "y-73": -0.707,
    "y-74": -0.706,
    "y-75": -0.706,
    "y-76": -0.704,
    "y-77": -0.703,
    "y-78": -0.711,
    "y-79": -0.709,
    "y-80": -0.71,
    "y-81": -0.743,
    "y-82": -0.741,
    "y-83": -0.746,
    "y-84": -0.746,
    "y-85": -0.749,
    "y-86": -0.746,
    "y-87": -0.746,
    "y-88": -0.747,
    "y-89": -0.745,
    "y-90": -0.746,
    "y-91": -0.745,
    "y-92": -0.747,
    "y-93": -0.744,
    "y-94": -0.744,
    "y-95": -0.744,
    "y-96": -0.745,
    "y-97": -0.745,
    "y-98": -0.746,
    "y-99": -0.746,
    "y-100": -0.744,
    "y-101": -0.745,
    "y-102": -0.745,
    "y-103": -0.744,
    "y-104": -0.744,
    "y-105": -0.744,
    "y-106": -0.745,
    "y-107": -0.745,
    "y-108": -0.746,
    "y-109": -0.746,
    "y-110": -0.758,
    "y-111": -0.758,
    "y-112": -0.758,
    "y-113": -0.743,
    "y-114": -0.743,
    "y-115": -0.742,
    "y-116": -0.742,
    "y-117": -0.736,
    "y-118": -0.737,
    "y-119": -0.737,
    "y-120": -0.736,
    "y-121": -0.736,
    "y-122": -0.736,
    "y-123": -0.736,
    "y-124": -0.736,
    "y-125": -0.736,
    "y-126": -0.738,
    "y-127": -0.738,
    "y-128": -0.734,
    "y-129": -0.734,
    "y-130": -0.734,
    "y-131": -0.734,
    "y-132": -0.734,
    "y-133": -0.734,
    "y-134": -0.734,
    "y-135": -0.734,
    "y-136": -0.734,
    "y-137": -0.734,
    "y-138": -0.734,
    "y-139": -0.734,
    "y-140": -0.736,
    "y-141": -0.735,
    "y-142": -0.735,
    "y-143": -0.735,
    "y-144": -0.735,
    "y-145": -0.735,
    "y-146": -0.735,
    "y-147": -0.735,
    "y-148": -0.732,
    "y-149": -0.732,
    "y-150": -0.732,
    "y-151": -0.732,
    "y-152": -0.733,
    "y-153": -0.733,
    "y-154": -0.733,
    "y-155": -0.733,
    "y-156": -0.733,
    "y-157": -0.733,
    "y-158": -0.733,
    "y-159": -0.733,
    "y-160": -0.733,
    "y-161": -0.733,
    "y-162": -0.734,
    "y-163": -0.734,
    "y-164": -0.735,
    "y-165": -0.734,
    "y-166": -0.734,
    "y-167": -0.734,
    "y-168": -0.734,
    "y-169": -0.735,
    "y-170": -0.739,
    "y-171": -0.739,
    "y-172": -0.739,
    "y-173": -0.739,
    "y-174": -0.739,
    "y-175": -0.739,
    "y-176": -0.739,
    "y-177": -0.739,
    "y-178": -0.739,
    "y-179": -0.739,
    "y-180": -0.739,
    "y-181": -0.738,
    "y-182": -0.727,
    "y-183": -0.728,
    "y-184": -0.728,
    "y-185": -0.728,
    "y-186": -0.724,
    "y-187": -0.724,
    "y-188": -0.724,
    "y-189": -0.724,
    "y-190": -0.724,
    "y-191": -0.724,
    "y-192": -0.724,
    "y-193": -0.724,
    "y-194": -0.724,
    "y-195": -0.725,
    "y-196": -0.724,
    "y-197": -0.725,
    "y-198": -0.725,
    "y-199": -0.725,
    "y-200": -0.725,
    "y-201": -0.725,
    "y-202": -0.725,
    "y-203": -0.725,
    "y-204": -0.725,
    "y-205": -0.725,
    "y-206": -0.725,
    "y-207": -0.725,
    "y-208": -0.726,
    "y-209": -0.726,
    "y-210": -0.726,
    "y-211": -0.727,
    "y-212": -0.727,
    "y-213": -0.727,
    "y-214": -0.727,
    "y-215": -0.733,
    "y-216": -0.733,
    "y-217": -0.733,
    "y-218": -0.733,
    "y-219": -0.733,
    "y-220": -0.733,
    "y-221": -0.733,
    "y-222": -0.733,
    "y-223": -0.733,
    "y-224": -0.733,
    "y-225": -0.738,
    "y-226": -0.738,
    "y-227": -0.738,
    "y-228": -0.738,
    "y-229": -0.738,
    "y-230": -0.738,
    "y-231": -0.738,
    "y-232": -0.738,
    "y-233": -0.738,
    "y-234": -0.738,
    "y-235": -0.738,
    "y-236": -0.738,
    "y-237": -0.738,
    "y-238": -0.738,
    "y-239": -0.738,
    "y-240": -0.738,
    "y-241": -0.738,
    "y-242": -0.74,
    "y-243": -0.74,
    "y-244": -0.74,
    "y-245": -0.74,
    "y-246": -0.74,
    "y-247": -0.74,
    "y-248": -0.74,
    "y-249": -0.74,
    "y-250": -0.74,
    "y-251": -0.741,
    "y-252": -0.742,
    "y-253": -0.742,
    "y-254": -0.742,
    "y-255": -0.742,
  },
  {
    x: -1.825,
    "y-2": 1.395,
    "y-12": -0.595,
    "y-46": -0.566,
    "y-1000": -0.588,
    "y-0": 0.994,
    "y-1": 1.509,
    "y-3": 0.018,
    "y-4": -0.617,
    "y-5": -0.609,
    "y-6": -0.561,
    "y-7": -0.586,
    "y-8": -0.586,
    "y-9": -0.595,
    "y-10": -0.595,
    "y-11": -0.595,
    "y-13": -0.595,
    "y-14": -0.595,
    "y-15": -0.595,
    "y-16": -0.625,
    "y-17": -0.625,
    "y-18": -0.625,
    "y-19": -0.652,
    "y-20": -0.652,
    "y-21": -0.622,
    "y-22": -0.636,
    "y-23": -0.636,
    "y-24": -0.636,
    "y-25": -0.614,
    "y-26": -0.614,
    "y-27": -0.614,
    "y-28": -0.614,
    "y-29": -0.614,
    "y-30": -0.614,
    "y-31": -0.614,
    "y-32": -0.614,
    "y-33": -0.614,
    "y-34": -0.614,
    "y-35": -0.614,
    "y-36": -0.278,
    "y-37": -0.284,
    "y-38": -0.265,
    "y-39": -0.584,
    "y-40": -0.569,
    "y-41": -0.574,
    "y-42": -0.572,
    "y-43": -0.575,
    "y-44": -0.561,
    "y-45": -0.561,
    "y-47": -0.573,
    "y-48": -0.567,
    "y-49": -0.566,
    "y-50": -0.569,
    "y-51": -0.573,
    "y-52": -0.576,
    "y-53": -0.558,
    "y-54": -0.57,
    "y-55": -0.575,
    "y-56": -0.57,
    "y-57": -0.571,
    "y-58": -0.568,
    "y-59": -0.561,
    "y-60": -0.566,
    "y-61": -0.563,
    "y-62": -0.564,
    "y-63": -0.569,
    "y-64": -0.566,
    "y-65": -0.564,
    "y-66": -0.564,
    "y-67": -0.567,
    "y-68": -0.567,
    "y-69": -0.567,
    "y-70": -0.567,
    "y-71": -0.57,
    "y-72": -0.567,
    "y-73": -0.569,
    "y-74": -0.569,
    "y-75": -0.569,
    "y-76": -0.568,
    "y-77": -0.568,
    "y-78": -0.572,
    "y-79": -0.57,
    "y-80": -0.571,
    "y-81": -0.587,
    "y-82": -0.587,
    "y-83": -0.589,
    "y-84": -0.589,
    "y-85": -0.59,
    "y-86": -0.589,
    "y-87": -0.589,
    "y-88": -0.589,
    "y-89": -0.588,
    "y-90": -0.589,
    "y-91": -0.588,
    "y-92": -0.589,
    "y-93": -0.588,
    "y-94": -0.588,
    "y-95": -0.588,
    "y-96": -0.588,
    "y-97": -0.589,
    "y-98": -0.589,
    "y-99": -0.589,
    "y-100": -0.588,
    "y-101": -0.588,
    "y-102": -0.589,
    "y-103": -0.588,
    "y-104": -0.588,
    "y-105": -0.588,
    "y-106": -0.588,
    "y-107": -0.588,
    "y-108": -0.589,
    "y-109": -0.589,
    "y-110": -0.595,
    "y-111": -0.595,
    "y-112": -0.595,
    "y-113": -0.583,
    "y-114": -0.583,
    "y-115": -0.583,
    "y-116": -0.583,
    "y-117": -0.577,
    "y-118": -0.578,
    "y-119": -0.577,
    "y-120": -0.577,
    "y-121": -0.577,
    "y-122": -0.577,
    "y-123": -0.577,
    "y-124": -0.577,
    "y-125": -0.577,
    "y-126": -0.578,
    "y-127": -0.579,
    "y-128": -0.576,
    "y-129": -0.576,
    "y-130": -0.576,
    "y-131": -0.576,
    "y-132": -0.576,
    "y-133": -0.576,
    "y-134": -0.576,
    "y-135": -0.576,
    "y-136": -0.576,
    "y-137": -0.576,
    "y-138": -0.576,
    "y-139": -0.576,
    "y-140": -0.577,
    "y-141": -0.577,
    "y-142": -0.577,
    "y-143": -0.577,
    "y-144": -0.577,
    "y-145": -0.577,
    "y-146": -0.577,
    "y-147": -0.577,
    "y-148": -0.575,
    "y-149": -0.575,
    "y-150": -0.575,
    "y-151": -0.575,
    "y-152": -0.575,
    "y-153": -0.575,
    "y-154": -0.575,
    "y-155": -0.575,
    "y-156": -0.575,
    "y-157": -0.575,
    "y-158": -0.575,
    "y-159": -0.575,
    "y-160": -0.575,
    "y-161": -0.575,
    "y-162": -0.576,
    "y-163": -0.576,
    "y-164": -0.576,
    "y-165": -0.576,
    "y-166": -0.576,
    "y-167": -0.576,
    "y-168": -0.576,
    "y-169": -0.576,
    "y-170": -0.578,
    "y-171": -0.578,
    "y-172": -0.579,
    "y-173": -0.579,
    "y-174": -0.579,
    "y-175": -0.579,
    "y-176": -0.579,
    "y-177": -0.579,
    "y-178": -0.579,
    "y-179": -0.579,
    "y-180": -0.579,
    "y-181": -0.578,
    "y-182": -0.574,
    "y-183": -0.574,
    "y-184": -0.574,
    "y-185": -0.574,
    "y-186": -0.573,
    "y-187": -0.573,
    "y-188": -0.573,
    "y-189": -0.573,
    "y-190": -0.573,
    "y-191": -0.573,
    "y-192": -0.573,
    "y-193": -0.573,
    "y-194": -0.573,
    "y-195": -0.574,
    "y-196": -0.573,
    "y-197": -0.574,
    "y-198": -0.574,
    "y-199": -0.574,
    "y-200": -0.574,
    "y-201": -0.574,
    "y-202": -0.574,
    "y-203": -0.574,
    "y-204": -0.574,
    "y-205": -0.574,
    "y-206": -0.574,
    "y-207": -0.574,
    "y-208": -0.575,
    "y-209": -0.575,
    "y-210": -0.575,
    "y-211": -0.575,
    "y-212": -0.575,
    "y-213": -0.575,
    "y-214": -0.575,
    "y-215": -0.579,
    "y-216": -0.579,
    "y-217": -0.579,
    "y-218": -0.579,
    "y-219": -0.579,
    "y-220": -0.579,
    "y-221": -0.579,
    "y-222": -0.579,
    "y-223": -0.578,
    "y-224": -0.578,
    "y-225": -0.581,
    "y-226": -0.581,
    "y-227": -0.581,
    "y-228": -0.581,
    "y-229": -0.581,
    "y-230": -0.581,
    "y-231": -0.581,
    "y-232": -0.581,
    "y-233": -0.581,
    "y-234": -0.581,
    "y-235": -0.581,
    "y-236": -0.581,
    "y-237": -0.581,
    "y-238": -0.581,
    "y-239": -0.581,
    "y-240": -0.581,
    "y-241": -0.581,
    "y-242": -0.582,
    "y-243": -0.582,
    "y-244": -0.582,
    "y-245": -0.582,
    "y-246": -0.582,
    "y-247": -0.582,
    "y-248": -0.582,
    "y-249": -0.582,
    "y-250": -0.582,
    "y-251": -0.582,
    "y-252": -0.583,
    "y-253": -0.583,
    "y-254": -0.583,
    "y-255": -0.583,
  },
  {
    x: -1.8,
    "y-2": 1.374,
    "y-12": -0.389,
    "y-46": -0.432,
    "y-1000": -0.432,
    "y-0": 0.982,
    "y-1": 1.484,
    "y-3": 0.061,
    "y-4": -0.493,
    "y-5": -0.488,
    "y-6": -0.351,
    "y-7": -0.382,
    "y-8": -0.382,
    "y-9": -0.389,
    "y-10": -0.389,
    "y-11": -0.389,
    "y-13": -0.389,
    "y-14": -0.389,
    "y-15": -0.389,
    "y-16": -0.446,
    "y-17": -0.446,
    "y-18": -0.446,
    "y-19": -0.498,
    "y-20": -0.498,
    "y-21": -0.44,
    "y-22": -0.468,
    "y-23": -0.468,
    "y-24": -0.468,
    "y-25": -0.432,
    "y-26": -0.432,
    "y-27": -0.432,
    "y-28": -0.432,
    "y-29": -0.432,
    "y-30": -0.432,
    "y-31": -0.432,
    "y-32": -0.432,
    "y-33": -0.432,
    "y-34": -0.432,
    "y-35": -0.432,
    "y-36": -0.432,
    "y-37": -0.432,
    "y-38": -0.432,
    "y-39": -0.432,
    "y-40": -0.432,
    "y-41": -0.432,
    "y-42": -0.432,
    "y-43": -0.432,
    "y-44": -0.432,
    "y-45": -0.432,
    "y-47": -0.432,
    "y-48": -0.432,
    "y-49": -0.432,
    "y-50": -0.432,
    "y-51": -0.432,
    "y-52": -0.432,
    "y-53": -0.432,
    "y-54": -0.432,
    "y-55": -0.432,
    "y-56": -0.432,
    "y-57": -0.432,
    "y-58": -0.432,
    "y-59": -0.432,
    "y-60": -0.432,
    "y-61": -0.432,
    "y-62": -0.432,
    "y-63": -0.432,
    "y-64": -0.432,
    "y-65": -0.432,
    "y-66": -0.432,
    "y-67": -0.432,
    "y-68": -0.432,
    "y-69": -0.432,
    "y-70": -0.432,
    "y-71": -0.432,
    "y-72": -0.432,
    "y-73": -0.432,
    "y-74": -0.432,
    "y-75": -0.432,
    "y-76": -0.432,
    "y-77": -0.432,
    "y-78": -0.432,
    "y-79": -0.432,
    "y-80": -0.432,
    "y-81": -0.432,
    "y-82": -0.432,
    "y-83": -0.432,
    "y-84": -0.432,
    "y-85": -0.432,
    "y-86": -0.432,
    "y-87": -0.432,
    "y-88": -0.432,
    "y-89": -0.432,
    "y-90": -0.432,
    "y-91": -0.432,
    "y-92": -0.432,
    "y-93": -0.432,
    "y-94": -0.432,
    "y-95": -0.432,
    "y-96": -0.432,
    "y-97": -0.432,
    "y-98": -0.432,
    "y-99": -0.432,
    "y-100": -0.432,
    "y-101": -0.432,
    "y-102": -0.432,
    "y-103": -0.432,
    "y-104": -0.432,
    "y-105": -0.432,
    "y-106": -0.432,
    "y-107": -0.432,
    "y-108": -0.432,
    "y-109": -0.432,
    "y-110": -0.432,
    "y-111": -0.432,
    "y-112": -0.432,
    "y-113": -0.432,
    "y-114": -0.432,
    "y-115": -0.432,
    "y-116": -0.432,
    "y-117": -0.432,
    "y-118": -0.432,
    "y-119": -0.432,
    "y-120": -0.432,
    "y-121": -0.432,
    "y-122": -0.432,
    "y-123": -0.432,
    "y-124": -0.432,
    "y-125": -0.432,
    "y-126": -0.432,
    "y-127": -0.432,
    "y-128": -0.432,
    "y-129": -0.432,
    "y-130": -0.432,
    "y-131": -0.432,
    "y-132": -0.432,
    "y-133": -0.432,
    "y-134": -0.432,
    "y-135": -0.432,
    "y-136": -0.432,
    "y-137": -0.432,
    "y-138": -0.432,
    "y-139": -0.432,
    "y-140": -0.432,
    "y-141": -0.432,
    "y-142": -0.432,
    "y-143": -0.432,
    "y-144": -0.432,
    "y-145": -0.432,
    "y-146": -0.432,
    "y-147": -0.432,
    "y-148": -0.432,
    "y-149": -0.432,
    "y-150": -0.432,
    "y-151": -0.432,
    "y-152": -0.432,
    "y-153": -0.432,
    "y-154": -0.432,
    "y-155": -0.432,
    "y-156": -0.432,
    "y-157": -0.432,
    "y-158": -0.432,
    "y-159": -0.432,
    "y-160": -0.432,
    "y-161": -0.432,
    "y-162": -0.432,
    "y-163": -0.432,
    "y-164": -0.432,
    "y-165": -0.432,
    "y-166": -0.432,
    "y-167": -0.432,
    "y-168": -0.432,
    "y-169": -0.432,
    "y-170": -0.432,
    "y-171": -0.432,
    "y-172": -0.432,
    "y-173": -0.432,
    "y-174": -0.432,
    "y-175": -0.432,
    "y-176": -0.432,
    "y-177": -0.432,
    "y-178": -0.432,
    "y-179": -0.432,
    "y-180": -0.432,
    "y-181": -0.432,
    "y-182": -0.432,
    "y-183": -0.432,
    "y-184": -0.432,
    "y-185": -0.432,
    "y-186": -0.432,
    "y-187": -0.432,
    "y-188": -0.432,
    "y-189": -0.432,
    "y-190": -0.432,
    "y-191": -0.432,
    "y-192": -0.432,
    "y-193": -0.432,
    "y-194": -0.432,
    "y-195": -0.432,
    "y-196": -0.432,
    "y-197": -0.432,
    "y-198": -0.432,
    "y-199": -0.432,
    "y-200": -0.432,
    "y-201": -0.432,
    "y-202": -0.432,
    "y-203": -0.432,
    "y-204": -0.432,
    "y-205": -0.432,
    "y-206": -0.432,
    "y-207": -0.432,
    "y-208": -0.432,
    "y-209": -0.432,
    "y-210": -0.432,
    "y-211": -0.432,
    "y-212": -0.432,
    "y-213": -0.432,
    "y-214": -0.432,
    "y-215": -0.432,
    "y-216": -0.432,
    "y-217": -0.432,
    "y-218": -0.432,
    "y-219": -0.432,
    "y-220": -0.432,
    "y-221": -0.432,
    "y-222": -0.432,
    "y-223": -0.432,
    "y-224": -0.432,
    "y-225": -0.432,
    "y-226": -0.432,
    "y-227": -0.432,
    "y-228": -0.432,
    "y-229": -0.432,
    "y-230": -0.432,
    "y-231": -0.432,
    "y-232": -0.432,
    "y-233": -0.432,
    "y-234": -0.432,
    "y-235": -0.432,
    "y-236": -0.432,
    "y-237": -0.432,
    "y-238": -0.432,
    "y-239": -0.432,
    "y-240": -0.432,
    "y-241": -0.432,
    "y-242": -0.432,
    "y-243": -0.432,
    "y-244": -0.432,
    "y-245": -0.432,
    "y-246": -0.432,
    "y-247": -0.432,
    "y-248": -0.432,
    "y-249": -0.432,
    "y-250": -0.432,
    "y-251": -0.432,
    "y-252": -0.432,
    "y-253": -0.432,
    "y-254": -0.432,
    "y-255": -0.432,
  },
  {
    x: -1.775,
    "y-2": 1.352,
    "y-12": -0.182,
    "y-46": -0.298,
    "y-1000": -0.282,
    "y-0": 0.97,
    "y-1": 1.46,
    "y-3": 0.104,
    "y-4": -0.369,
    "y-5": -0.367,
    "y-6": -0.14,
    "y-7": -0.178,
    "y-8": -0.178,
    "y-9": -0.182,
    "y-10": -0.182,
    "y-11": -0.182,
    "y-13": -0.182,
    "y-14": -0.182,
    "y-15": -0.182,
    "y-16": -0.267,
    "y-17": -0.267,
    "y-18": -0.267,
    "y-19": -0.344,
    "y-20": -0.344,
    "y-21": -0.258,
    "y-22": -0.3,
    "y-23": -0.3,
    "y-24": -0.3,
    "y-25": -0.252,
    "y-26": -0.252,
    "y-27": -0.252,
    "y-28": -0.252,
    "y-29": -0.288,
    "y-30": -0.288,
    "y-31": -0.287,
    "y-32": -0.288,
    "y-33": -0.288,
    "y-34": -0.288,
    "y-35": -0.288,
    "y-36": -0.606,
    "y-37": -0.601,
    "y-38": -0.619,
    "y-39": -0.28,
    "y-40": -0.294,
    "y-41": -0.289,
    "y-42": -0.292,
    "y-43": -0.289,
    "y-44": -0.302,
    "y-45": -0.302,
    "y-47": -0.291,
    "y-48": -0.296,
    "y-49": -0.297,
    "y-50": -0.294,
    "y-51": -0.291,
    "y-52": -0.288,
    "y-53": -0.306,
    "y-54": -0.294,
    "y-55": -0.289,
    "y-56": -0.293,
    "y-57": -0.292,
    "y-58": -0.296,
    "y-59": -0.303,
    "y-60": -0.298,
    "y-61": -0.3,
    "y-62": -0.299,
    "y-63": -0.295,
    "y-64": -0.298,
    "y-65": -0.3,
    "y-66": -0.3,
    "y-67": -0.297,
    "y-68": -0.297,
    "y-69": -0.297,
    "y-70": -0.297,
    "y-71": -0.294,
    "y-72": -0.297,
    "y-73": -0.294,
    "y-74": -0.295,
    "y-75": -0.295,
    "y-76": -0.296,
    "y-77": -0.296,
    "y-78": -0.292,
    "y-79": -0.293,
    "y-80": -0.293,
    "y-81": -0.277,
    "y-82": -0.278,
    "y-83": -0.275,
    "y-84": -0.275,
    "y-85": -0.274,
    "y-86": -0.275,
    "y-87": -0.275,
    "y-88": -0.275,
    "y-89": -0.276,
    "y-90": -0.275,
    "y-91": -0.276,
    "y-92": -0.275,
    "y-93": -0.276,
    "y-94": -0.276,
    "y-95": -0.276,
    "y-96": -0.276,
    "y-97": -0.276,
    "y-98": -0.275,
    "y-99": -0.275,
    "y-100": -0.276,
    "y-101": -0.276,
    "y-102": -0.276,
    "y-103": -0.276,
    "y-104": -0.276,
    "y-105": -0.276,
    "y-106": -0.276,
    "y-107": -0.276,
    "y-108": -0.275,
    "y-109": -0.275,
    "y-110": -0.269,
    "y-111": -0.269,
    "y-112": -0.27,
    "y-113": -0.281,
    "y-114": -0.281,
    "y-115": -0.281,
    "y-116": -0.281,
    "y-117": -0.287,
    "y-118": -0.286,
    "y-119": -0.286,
    "y-120": -0.286,
    "y-121": -0.286,
    "y-122": -0.287,
    "y-123": -0.286,
    "y-124": -0.287,
    "y-125": -0.287,
    "y-126": -0.285,
    "y-127": -0.285,
    "y-128": -0.288,
    "y-129": -0.288,
    "y-130": -0.288,
    "y-131": -0.288,
    "y-132": -0.288,
    "y-133": -0.288,
    "y-134": -0.288,
    "y-135": -0.288,
    "y-136": -0.288,
    "y-137": -0.288,
    "y-138": -0.288,
    "y-139": -0.288,
    "y-140": -0.286,
    "y-141": -0.287,
    "y-142": -0.287,
    "y-143": -0.287,
    "y-144": -0.287,
    "y-145": -0.287,
    "y-146": -0.287,
    "y-147": -0.287,
    "y-148": -0.289,
    "y-149": -0.289,
    "y-150": -0.289,
    "y-151": -0.289,
    "y-152": -0.289,
    "y-153": -0.289,
    "y-154": -0.289,
    "y-155": -0.289,
    "y-156": -0.289,
    "y-157": -0.289,
    "y-158": -0.289,
    "y-159": -0.289,
    "y-160": -0.289,
    "y-161": -0.289,
    "y-162": -0.288,
    "y-163": -0.288,
    "y-164": -0.288,
    "y-165": -0.288,
    "y-166": -0.288,
    "y-167": -0.288,
    "y-168": -0.288,
    "y-169": -0.288,
    "y-170": -0.287,
    "y-171": -0.287,
    "y-172": -0.286,
    "y-173": -0.286,
    "y-174": -0.286,
    "y-175": -0.286,
    "y-176": -0.286,
    "y-177": -0.286,
    "y-178": -0.286,
    "y-179": -0.286,
    "y-180": -0.286,
    "y-181": -0.287,
    "y-182": -0.29,
    "y-183": -0.29,
    "y-184": -0.29,
    "y-185": -0.29,
    "y-186": -0.29,
    "y-187": -0.29,
    "y-188": -0.29,
    "y-189": -0.29,
    "y-190": -0.29,
    "y-191": -0.29,
    "y-192": -0.29,
    "y-193": -0.29,
    "y-194": -0.29,
    "y-195": -0.29,
    "y-196": -0.29,
    "y-197": -0.29,
    "y-198": -0.29,
    "y-199": -0.29,
    "y-200": -0.29,
    "y-201": -0.29,
    "y-202": -0.29,
    "y-203": -0.29,
    "y-204": -0.29,
    "y-205": -0.29,
    "y-206": -0.29,
    "y-207": -0.29,
    "y-208": -0.289,
    "y-209": -0.289,
    "y-210": -0.289,
    "y-211": -0.289,
    "y-212": -0.289,
    "y-213": -0.289,
    "y-214": -0.289,
    "y-215": -0.287,
    "y-216": -0.287,
    "y-217": -0.287,
    "y-218": -0.287,
    "y-219": -0.287,
    "y-220": -0.287,
    "y-221": -0.287,
    "y-222": -0.287,
    "y-223": -0.287,
    "y-224": -0.287,
    "y-225": -0.286,
    "y-226": -0.286,
    "y-227": -0.286,
    "y-228": -0.286,
    "y-229": -0.286,
    "y-230": -0.286,
    "y-231": -0.286,
    "y-232": -0.286,
    "y-233": -0.285,
    "y-234": -0.285,
    "y-235": -0.285,
    "y-236": -0.285,
    "y-237": -0.285,
    "y-238": -0.285,
    "y-239": -0.285,
    "y-240": -0.285,
    "y-241": -0.285,
    "y-242": -0.285,
    "y-243": -0.285,
    "y-244": -0.285,
    "y-245": -0.285,
    "y-246": -0.285,
    "y-247": -0.285,
    "y-248": -0.285,
    "y-249": -0.285,
    "y-250": -0.285,
    "y-251": -0.285,
    "y-252": -0.284,
    "y-253": -0.284,
    "y-254": -0.284,
    "y-255": -0.284,
  },
  {
    x: -1.75,
    "y-2": 1.331,
    "y-12": 0.024,
    "y-46": -0.139,
    "y-1000": -0.132,
    "y-0": 0.958,
    "y-1": 1.435,
    "y-3": 0.147,
    "y-4": -0.244,
    "y-5": -0.246,
    "y-6": 0.07,
    "y-7": 0.026,
    "y-8": 0.026,
    "y-9": 0.024,
    "y-10": 0.024,
    "y-11": 0.024,
    "y-13": 0.024,
    "y-14": 0.024,
    "y-15": 0.024,
    "y-16": -0.088,
    "y-17": -0.088,
    "y-18": -0.088,
    "y-19": -0.19,
    "y-20": -0.19,
    "y-21": -0.076,
    "y-22": -0.131,
    "y-23": -0.131,
    "y-24": -0.131,
    "y-25": -0.105,
    "y-26": -0.105,
    "y-27": -0.105,
    "y-28": -0.105,
    "y-29": -1.092,
    "y-30": -1.086,
    "y-31": -1.066,
    "y-32": -1.079,
    "y-33": -1.078,
    "y-34": -1.086,
    "y-35": -1.079,
    "y-36": -1.291,
    "y-37": -1.286,
    "y-38": -1.298,
    "y-39": -0.131,
    "y-40": -0.138,
    "y-41": -0.137,
    "y-42": -0.139,
    "y-43": -0.141,
    "y-44": -0.143,
    "y-45": -0.143,
    "y-47": -0.136,
    "y-48": -0.145,
    "y-49": -0.138,
    "y-50": -0.134,
    "y-51": -0.138,
    "y-52": -0.142,
    "y-53": -0.167,
    "y-54": -0.157,
    "y-55": -0.147,
    "y-56": -0.15,
    "y-57": -0.143,
    "y-58": -0.139,
    "y-59": -0.152,
    "y-60": -0.149,
    "y-61": -0.153,
    "y-62": -0.15,
    "y-63": -0.147,
    "y-64": -0.15,
    "y-65": -0.154,
    "y-66": -0.15,
    "y-67": -0.15,
    "y-68": -0.152,
    "y-69": -0.15,
    "y-70": -0.151,
    "y-71": -0.146,
    "y-72": -0.151,
    "y-73": -0.148,
    "y-74": -0.147,
    "y-75": -0.15,
    "y-76": -0.151,
    "y-77": -0.149,
    "y-78": -0.148,
    "y-79": -0.147,
    "y-80": -0.146,
    "y-81": -0.137,
    "y-82": -0.136,
    "y-83": -0.126,
    "y-84": -0.125,
    "y-85": -0.122,
    "y-86": -0.125,
    "y-87": -0.125,
    "y-88": -0.124,
    "y-89": -0.125,
    "y-90": -0.125,
    "y-91": -0.126,
    "y-92": -0.126,
    "y-93": -0.126,
    "y-94": -0.125,
    "y-95": -0.125,
    "y-96": -0.126,
    "y-97": -0.126,
    "y-98": -0.125,
    "y-99": -0.125,
    "y-100": -0.128,
    "y-101": -0.128,
    "y-102": -0.127,
    "y-103": -0.128,
    "y-104": -0.127,
    "y-105": -0.127,
    "y-106": -0.126,
    "y-107": -0.127,
    "y-108": -0.123,
    "y-109": -0.125,
    "y-110": -0.12,
    "y-111": -0.121,
    "y-112": -0.122,
    "y-113": -0.131,
    "y-114": -0.13,
    "y-115": -0.13,
    "y-116": -0.13,
    "y-117": -0.135,
    "y-118": -0.134,
    "y-119": -0.135,
    "y-120": -0.135,
    "y-121": -0.135,
    "y-122": -0.135,
    "y-123": -0.135,
    "y-124": -0.135,
    "y-125": -0.135,
    "y-126": -0.132,
    "y-127": -0.132,
    "y-128": -0.134,
    "y-129": -0.134,
    "y-130": -0.134,
    "y-131": -0.134,
    "y-132": -0.134,
    "y-133": -0.134,
    "y-134": -0.134,
    "y-135": -0.134,
    "y-136": -0.134,
    "y-137": -0.134,
    "y-138": -0.134,
    "y-139": -0.134,
    "y-140": -0.133,
    "y-141": -0.134,
    "y-142": -0.134,
    "y-143": -0.135,
    "y-144": -0.135,
    "y-145": -0.135,
    "y-146": -0.135,
    "y-147": -0.135,
    "y-148": -0.138,
    "y-149": -0.138,
    "y-150": -0.139,
    "y-151": -0.138,
    "y-152": -0.138,
    "y-153": -0.138,
    "y-154": -0.138,
    "y-155": -0.138,
    "y-156": -0.138,
    "y-157": -0.138,
    "y-158": -0.138,
    "y-159": -0.138,
    "y-160": -0.138,
    "y-161": -0.138,
    "y-162": -0.137,
    "y-163": -0.137,
    "y-164": -0.137,
    "y-165": -0.138,
    "y-166": -0.138,
    "y-167": -0.138,
    "y-168": -0.138,
    "y-169": -0.139,
    "y-170": -0.137,
    "y-171": -0.137,
    "y-172": -0.136,
    "y-173": -0.136,
    "y-174": -0.136,
    "y-175": -0.136,
    "y-176": -0.136,
    "y-177": -0.136,
    "y-178": -0.136,
    "y-179": -0.136,
    "y-180": -0.136,
    "y-181": -0.139,
    "y-182": -0.142,
    "y-183": -0.142,
    "y-184": -0.142,
    "y-185": -0.142,
    "y-186": -0.142,
    "y-187": -0.142,
    "y-188": -0.142,
    "y-189": -0.142,
    "y-190": -0.142,
    "y-191": -0.142,
    "y-192": -0.142,
    "y-193": -0.142,
    "y-194": -0.142,
    "y-195": -0.142,
    "y-196": -0.143,
    "y-197": -0.143,
    "y-198": -0.143,
    "y-199": -0.143,
    "y-200": -0.143,
    "y-201": -0.143,
    "y-202": -0.143,
    "y-203": -0.142,
    "y-204": -0.142,
    "y-205": -0.142,
    "y-206": -0.142,
    "y-207": -0.142,
    "y-208": -0.142,
    "y-209": -0.142,
    "y-210": -0.141,
    "y-211": -0.141,
    "y-212": -0.141,
    "y-213": -0.141,
    "y-214": -0.141,
    "y-215": -0.139,
    "y-216": -0.139,
    "y-217": -0.139,
    "y-218": -0.139,
    "y-219": -0.139,
    "y-220": -0.139,
    "y-221": -0.139,
    "y-222": -0.139,
    "y-223": -0.139,
    "y-224": -0.139,
    "y-225": -0.137,
    "y-226": -0.137,
    "y-227": -0.137,
    "y-228": -0.137,
    "y-229": -0.137,
    "y-230": -0.137,
    "y-231": -0.137,
    "y-232": -0.137,
    "y-233": -0.137,
    "y-234": -0.137,
    "y-235": -0.137,
    "y-236": -0.137,
    "y-237": -0.137,
    "y-238": -0.137,
    "y-239": -0.137,
    "y-240": -0.137,
    "y-241": -0.137,
    "y-242": -0.136,
    "y-243": -0.136,
    "y-244": -0.136,
    "y-245": -0.136,
    "y-246": -0.136,
    "y-247": -0.136,
    "y-248": -0.136,
    "y-249": -0.136,
    "y-250": -0.136,
    "y-251": -0.136,
    "y-252": -0.136,
    "y-253": -0.136,
    "y-254": -0.136,
    "y-255": -0.136,
  },
  {
    x: -1.725,
    "y-2": 1.31,
    "y-12": 0.23,
    "y-46": 0.02,
    "y-1000": 0.023,
    "y-0": 0.945,
    "y-1": 1.411,
    "y-3": 0.19,
    "y-4": -0.12,
    "y-5": -0.125,
    "y-6": 0.281,
    "y-7": 0.23,
    "y-8": 0.23,
    "y-9": 0.23,
    "y-10": 0.23,
    "y-11": 0.23,
    "y-13": 0.23,
    "y-14": 0.23,
    "y-15": 0.23,
    "y-16": 0.091,
    "y-17": 0.091,
    "y-18": 0.091,
    "y-19": -0.036,
    "y-20": -0.036,
    "y-21": 0.106,
    "y-22": 0.037,
    "y-23": 0.037,
    "y-24": 0.037,
    "y-25": 0.041,
    "y-26": 0.041,
    "y-27": 0.041,
    "y-28": 0.041,
    "y-29": -1.896,
    "y-30": -1.885,
    "y-31": -1.845,
    "y-32": -1.871,
    "y-33": -1.869,
    "y-34": -1.885,
    "y-35": -1.871,
    "y-36": -1.975,
    "y-37": -1.971,
    "y-38": -1.978,
    "y-39": 0.019,
    "y-40": 0.018,
    "y-41": 0.016,
    "y-42": 0.014,
    "y-43": 0.007,
    "y-44": 0.017,
    "y-45": 0.017,
    "y-47": 0.019,
    "y-48": 0.007,
    "y-49": 0.02,
    "y-50": 0.026,
    "y-51": 0.015,
    "y-52": 0.009,
    "y-53": -0.012,
    "y-54": -0.005,
    "y-55": 0.004,
    "y-56": 0.002,
    "y-57": 0.009,
    "y-58": 0.019,
    "y-59": 0.005,
    "y-60": 0.006,
    "y-61": 0.001,
    "y-62": 0.004,
    "y-63": 0.006,
    "y-64": 0.004,
    "y-65": 0.0,
    "y-66": 0.006,
    "y-67": 0.003,
    "y-68": 0.001,
    "y-69": 0.003,
    "y-70": 0.002,
    "y-71": 0.007,
    "y-72": 0.002,
    "y-73": 0.005,
    "y-74": 0.006,
    "y-75": 0.002,
    "y-76": 0.001,
    "y-77": 0.004,
    "y-78": 0.004,
    "y-79": 0.005,
    "y-80": 0.007,
    "y-81": 0.009,
    "y-82": 0.012,
    "y-83": 0.026,
    "y-84": 0.027,
    "y-85": 0.03,
    "y-86": 0.027,
    "y-87": 0.026,
    "y-88": 0.028,
    "y-89": 0.027,
    "y-90": 0.026,
    "y-91": 0.025,
    "y-92": 0.026,
    "y-93": 0.025,
    "y-94": 0.027,
    "y-95": 0.027,
    "y-96": 0.026,
    "y-97": 0.025,
    "y-98": 0.027,
    "y-99": 0.026,
    "y-100": 0.023,
    "y-101": 0.023,
    "y-102": 0.024,
    "y-103": 0.023,
    "y-104": 0.024,
    "y-105": 0.024,
    "y-106": 0.025,
    "y-107": 0.023,
    "y-108": 0.029,
    "y-109": 0.028,
    "y-110": 0.031,
    "y-111": 0.029,
    "y-112": 0.028,
    "y-113": 0.022,
    "y-114": 0.023,
    "y-115": 0.023,
    "y-116": 0.023,
    "y-117": 0.02,
    "y-118": 0.02,
    "y-119": 0.02,
    "y-120": 0.02,
    "y-121": 0.02,
    "y-122": 0.019,
    "y-123": 0.02,
    "y-124": 0.02,
    "y-125": 0.02,
    "y-126": 0.023,
    "y-127": 0.023,
    "y-128": 0.022,
    "y-129": 0.022,
    "y-130": 0.022,
    "y-131": 0.022,
    "y-132": 0.022,
    "y-133": 0.022,
    "y-134": 0.022,
    "y-135": 0.022,
    "y-136": 0.022,
    "y-137": 0.022,
    "y-138": 0.022,
    "y-139": 0.022,
    "y-140": 0.023,
    "y-141": 0.021,
    "y-142": 0.021,
    "y-143": 0.02,
    "y-144": 0.02,
    "y-145": 0.02,
    "y-146": 0.02,
    "y-147": 0.02,
    "y-148": 0.019,
    "y-149": 0.019,
    "y-150": 0.019,
    "y-151": 0.019,
    "y-152": 0.019,
    "y-153": 0.019,
    "y-154": 0.019,
    "y-155": 0.019,
    "y-156": 0.019,
    "y-157": 0.019,
    "y-158": 0.019,
    "y-159": 0.019,
    "y-160": 0.019,
    "y-161": 0.019,
    "y-162": 0.02,
    "y-163": 0.02,
    "y-164": 0.02,
    "y-165": 0.017,
    "y-166": 0.017,
    "y-167": 0.017,
    "y-168": 0.017,
    "y-169": 0.017,
    "y-170": 0.017,
    "y-171": 0.017,
    "y-172": 0.018,
    "y-173": 0.018,
    "y-174": 0.018,
    "y-175": 0.018,
    "y-176": 0.018,
    "y-177": 0.018,
    "y-178": 0.018,
    "y-179": 0.018,
    "y-180": 0.018,
    "y-181": 0.017,
    "y-182": 0.016,
    "y-183": 0.016,
    "y-184": 0.016,
    "y-185": 0.016,
    "y-186": 0.015,
    "y-187": 0.015,
    "y-188": 0.015,
    "y-189": 0.015,
    "y-190": 0.015,
    "y-191": 0.015,
    "y-192": 0.015,
    "y-193": 0.015,
    "y-194": 0.015,
    "y-195": 0.016,
    "y-196": 0.014,
    "y-197": 0.015,
    "y-198": 0.015,
    "y-199": 0.015,
    "y-200": 0.015,
    "y-201": 0.015,
    "y-202": 0.015,
    "y-203": 0.015,
    "y-204": 0.015,
    "y-205": 0.015,
    "y-206": 0.015,
    "y-207": 0.015,
    "y-208": 0.015,
    "y-209": 0.015,
    "y-210": 0.016,
    "y-211": 0.016,
    "y-212": 0.016,
    "y-213": 0.016,
    "y-214": 0.016,
    "y-215": 0.017,
    "y-216": 0.017,
    "y-217": 0.017,
    "y-218": 0.017,
    "y-219": 0.017,
    "y-220": 0.017,
    "y-221": 0.017,
    "y-222": 0.017,
    "y-223": 0.017,
    "y-224": 0.017,
    "y-225": 0.018,
    "y-226": 0.018,
    "y-227": 0.018,
    "y-228": 0.018,
    "y-229": 0.018,
    "y-230": 0.018,
    "y-231": 0.018,
    "y-232": 0.018,
    "y-233": 0.018,
    "y-234": 0.018,
    "y-235": 0.018,
    "y-236": 0.018,
    "y-237": 0.018,
    "y-238": 0.018,
    "y-239": 0.018,
    "y-240": 0.018,
    "y-241": 0.018,
    "y-242": 0.019,
    "y-243": 0.019,
    "y-244": 0.019,
    "y-245": 0.019,
    "y-246": 0.019,
    "y-247": 0.019,
    "y-248": 0.019,
    "y-249": 0.019,
    "y-250": 0.019,
    "y-251": 0.019,
    "y-252": 0.019,
    "y-253": 0.019,
    "y-254": 0.019,
    "y-255": 0.019,
  },
  {
    x: -1.7,
    "y-2": 1.289,
    "y-12": 0.437,
    "y-46": 0.187,
    "y-1000": 0.187,
    "y-0": 0.933,
    "y-1": 1.386,
    "y-3": 0.233,
    "y-4": 0.004,
    "y-5": -0.004,
    "y-6": 0.491,
    "y-7": 0.434,
    "y-8": 0.434,
    "y-9": 0.437,
    "y-10": 0.437,
    "y-11": 0.437,
    "y-13": 0.437,
    "y-14": 0.437,
    "y-15": 0.437,
    "y-16": 0.269,
    "y-17": 0.269,
    "y-18": 0.269,
    "y-19": 0.118,
    "y-20": 0.118,
    "y-21": 0.288,
    "y-22": 0.205,
    "y-23": 0.205,
    "y-24": 0.205,
    "y-25": 0.187,
    "y-26": 0.187,
    "y-27": 0.187,
    "y-28": 0.187,
    "y-29": 0.187,
    "y-30": 0.187,
    "y-31": 0.187,
    "y-32": 0.187,
    "y-33": 0.187,
    "y-34": 0.187,
    "y-35": 0.187,
    "y-36": 0.187,
    "y-37": 0.187,
    "y-38": 0.187,
    "y-39": 0.187,
    "y-40": 0.187,
    "y-41": 0.187,
    "y-42": 0.187,
    "y-43": 0.187,
    "y-44": 0.187,
    "y-45": 0.187,
    "y-47": 0.187,
    "y-48": 0.187,
    "y-49": 0.187,
    "y-50": 0.187,
    "y-51": 0.187,
    "y-52": 0.187,
    "y-53": 0.187,
    "y-54": 0.187,
    "y-55": 0.187,
    "y-56": 0.187,
    "y-57": 0.187,
    "y-58": 0.187,
    "y-59": 0.187,
    "y-60": 0.187,
    "y-61": 0.187,
    "y-62": 0.187,
    "y-63": 0.187,
    "y-64": 0.187,
    "y-65": 0.187,
    "y-66": 0.187,
    "y-67": 0.187,
    "y-68": 0.187,
    "y-69": 0.187,
    "y-70": 0.187,
    "y-71": 0.187,
    "y-72": 0.187,
    "y-73": 0.187,
    "y-74": 0.187,
    "y-75": 0.187,
    "y-76": 0.187,
    "y-77": 0.187,
    "y-78": 0.187,
    "y-79": 0.187,
    "y-80": 0.187,
    "y-81": 0.187,
    "y-82": 0.187,
    "y-83": 0.187,
    "y-84": 0.187,
    "y-85": 0.187,
    "y-86": 0.187,
    "y-87": 0.187,
    "y-88": 0.187,
    "y-89": 0.187,
    "y-90": 0.187,
    "y-91": 0.187,
    "y-92": 0.187,
    "y-93": 0.187,
    "y-94": 0.187,
    "y-95": 0.187,
    "y-96": 0.187,
    "y-97": 0.187,
    "y-98": 0.187,
    "y-99": 0.187,
    "y-100": 0.187,
    "y-101": 0.187,
    "y-102": 0.187,
    "y-103": 0.187,
    "y-104": 0.187,
    "y-105": 0.187,
    "y-106": 0.187,
    "y-107": 0.187,
    "y-108": 0.187,
    "y-109": 0.187,
    "y-110": 0.187,
    "y-111": 0.187,
    "y-112": 0.187,
    "y-113": 0.187,
    "y-114": 0.187,
    "y-115": 0.187,
    "y-116": 0.187,
    "y-117": 0.187,
    "y-118": 0.187,
    "y-119": 0.187,
    "y-120": 0.187,
    "y-121": 0.187,
    "y-122": 0.187,
    "y-123": 0.187,
    "y-124": 0.187,
    "y-125": 0.187,
    "y-126": 0.187,
    "y-127": 0.187,
    "y-128": 0.187,
    "y-129": 0.187,
    "y-130": 0.187,
    "y-131": 0.187,
    "y-132": 0.187,
    "y-133": 0.187,
    "y-134": 0.187,
    "y-135": 0.187,
    "y-136": 0.187,
    "y-137": 0.187,
    "y-138": 0.187,
    "y-139": 0.187,
    "y-140": 0.187,
    "y-141": 0.187,
    "y-142": 0.187,
    "y-143": 0.187,
    "y-144": 0.187,
    "y-145": 0.187,
    "y-146": 0.187,
    "y-147": 0.187,
    "y-148": 0.187,
    "y-149": 0.187,
    "y-150": 0.187,
    "y-151": 0.187,
    "y-152": 0.187,
    "y-153": 0.187,
    "y-154": 0.187,
    "y-155": 0.187,
    "y-156": 0.187,
    "y-157": 0.187,
    "y-158": 0.187,
    "y-159": 0.187,
    "y-160": 0.187,
    "y-161": 0.187,
    "y-162": 0.187,
    "y-163": 0.187,
    "y-164": 0.187,
    "y-165": 0.187,
    "y-166": 0.187,
    "y-167": 0.187,
    "y-168": 0.187,
    "y-169": 0.187,
    "y-170": 0.187,
    "y-171": 0.187,
    "y-172": 0.187,
    "y-173": 0.187,
    "y-174": 0.187,
    "y-175": 0.187,
    "y-176": 0.187,
    "y-177": 0.187,
    "y-178": 0.187,
    "y-179": 0.187,
    "y-180": 0.187,
    "y-181": 0.187,
    "y-182": 0.187,
    "y-183": 0.187,
    "y-184": 0.187,
    "y-185": 0.187,
    "y-186": 0.187,
    "y-187": 0.187,
    "y-188": 0.187,
    "y-189": 0.187,
    "y-190": 0.187,
    "y-191": 0.187,
    "y-192": 0.187,
    "y-193": 0.187,
    "y-194": 0.187,
    "y-195": 0.187,
    "y-196": 0.187,
    "y-197": 0.187,
    "y-198": 0.187,
    "y-199": 0.187,
    "y-200": 0.187,
    "y-201": 0.187,
    "y-202": 0.187,
    "y-203": 0.187,
    "y-204": 0.187,
    "y-205": 0.187,
    "y-206": 0.187,
    "y-207": 0.187,
    "y-208": 0.187,
    "y-209": 0.187,
    "y-210": 0.187,
    "y-211": 0.187,
    "y-212": 0.187,
    "y-213": 0.187,
    "y-214": 0.187,
    "y-215": 0.187,
    "y-216": 0.187,
    "y-217": 0.187,
    "y-218": 0.187,
    "y-219": 0.187,
    "y-220": 0.187,
    "y-221": 0.187,
    "y-222": 0.187,
    "y-223": 0.187,
    "y-224": 0.187,
    "y-225": 0.187,
    "y-226": 0.187,
    "y-227": 0.187,
    "y-228": 0.187,
    "y-229": 0.187,
    "y-230": 0.187,
    "y-231": 0.187,
    "y-232": 0.187,
    "y-233": 0.187,
    "y-234": 0.187,
    "y-235": 0.187,
    "y-236": 0.187,
    "y-237": 0.187,
    "y-238": 0.187,
    "y-239": 0.187,
    "y-240": 0.187,
    "y-241": 0.187,
    "y-242": 0.187,
    "y-243": 0.187,
    "y-244": 0.187,
    "y-245": 0.187,
    "y-246": 0.187,
    "y-247": 0.187,
    "y-248": 0.187,
    "y-249": 0.187,
    "y-250": 0.187,
    "y-251": 0.187,
    "y-252": 0.187,
    "y-253": 0.187,
    "y-254": 0.187,
    "y-255": 0.187,
  },
  {
    x: -1.675,
    "y-2": 1.267,
    "y-12": 0.643,
    "y-46": 0.364,
    "y-1000": 0.354,
    "y-0": 0.921,
    "y-1": 1.362,
    "y-3": 0.276,
    "y-4": 0.128,
    "y-5": 0.116,
    "y-6": 0.702,
    "y-7": 0.638,
    "y-8": 0.638,
    "y-9": 0.643,
    "y-10": 0.643,
    "y-11": 0.643,
    "y-13": 0.643,
    "y-14": 0.643,
    "y-15": 0.643,
    "y-16": 0.448,
    "y-17": 0.448,
    "y-18": 0.448,
    "y-19": 0.272,
    "y-20": 0.272,
    "y-21": 0.47,
    "y-22": 0.373,
    "y-23": 0.373,
    "y-24": 0.373,
    "y-25": 0.333,
    "y-26": 0.333,
    "y-27": 0.333,
    "y-28": 0.333,
    "y-29": 6.059,
    "y-30": 6.025,
    "y-31": 5.907,
    "y-32": 5.984,
    "y-33": 5.977,
    "y-34": 6.025,
    "y-35": 5.983,
    "y-36": 6.085,
    "y-37": 6.075,
    "y-38": 6.085,
    "y-39": 0.38,
    "y-40": 0.374,
    "y-41": 0.382,
    "y-42": 0.385,
    "y-43": 0.408,
    "y-44": 0.372,
    "y-45": 0.372,
    "y-47": 0.371,
    "y-48": 0.405,
    "y-49": 0.365,
    "y-50": 0.35,
    "y-51": 0.383,
    "y-52": 0.384,
    "y-53": 0.391,
    "y-54": 0.381,
    "y-55": 0.383,
    "y-56": 0.386,
    "y-57": 0.39,
    "y-58": 0.366,
    "y-59": 0.383,
    "y-60": 0.384,
    "y-61": 0.39,
    "y-62": 0.385,
    "y-63": 0.384,
    "y-64": 0.385,
    "y-65": 0.391,
    "y-66": 0.381,
    "y-67": 0.389,
    "y-68": 0.391,
    "y-69": 0.387,
    "y-70": 0.39,
    "y-71": 0.385,
    "y-72": 0.39,
    "y-73": 0.384,
    "y-74": 0.384,
    "y-75": 0.389,
    "y-76": 0.39,
    "y-77": 0.387,
    "y-78": 0.385,
    "y-79": 0.386,
    "y-80": 0.382,
    "y-81": 0.389,
    "y-82": 0.38,
    "y-83": 0.354,
    "y-84": 0.35,
    "y-85": 0.345,
    "y-86": 0.352,
    "y-87": 0.352,
    "y-88": 0.351,
    "y-89": 0.351,
    "y-90": 0.353,
    "y-91": 0.357,
    "y-92": 0.353,
    "y-93": 0.354,
    "y-94": 0.35,
    "y-95": 0.35,
    "y-96": 0.352,
    "y-97": 0.355,
    "y-98": 0.349,
    "y-99": 0.353,
    "y-100": 0.361,
    "y-101": 0.361,
    "y-102": 0.359,
    "y-103": 0.361,
    "y-104": 0.358,
    "y-105": 0.36,
    "y-106": 0.356,
    "y-107": 0.36,
    "y-108": 0.348,
    "y-109": 0.352,
    "y-110": 0.35,
    "y-111": 0.354,
    "y-112": 0.355,
    "y-113": 0.36,
    "y-114": 0.359,
    "y-115": 0.359,
    "y-116": 0.359,
    "y-117": 0.361,
    "y-118": 0.36,
    "y-119": 0.361,
    "y-120": 0.361,
    "y-121": 0.362,
    "y-122": 0.362,
    "y-123": 0.361,
    "y-124": 0.361,
    "y-125": 0.361,
    "y-126": 0.355,
    "y-127": 0.355,
    "y-128": 0.355,
    "y-129": 0.355,
    "y-130": 0.355,
    "y-131": 0.355,
    "y-132": 0.355,
    "y-133": 0.355,
    "y-134": 0.355,
    "y-135": 0.355,
    "y-136": 0.355,
    "y-137": 0.355,
    "y-138": 0.355,
    "y-139": 0.355,
    "y-140": 0.355,
    "y-141": 0.358,
    "y-142": 0.358,
    "y-143": 0.36,
    "y-144": 0.36,
    "y-145": 0.36,
    "y-146": 0.36,
    "y-147": 0.36,
    "y-148": 0.361,
    "y-149": 0.361,
    "y-150": 0.361,
    "y-151": 0.361,
    "y-152": 0.361,
    "y-153": 0.361,
    "y-154": 0.361,
    "y-155": 0.361,
    "y-156": 0.361,
    "y-157": 0.361,
    "y-158": 0.361,
    "y-159": 0.361,
    "y-160": 0.361,
    "y-161": 0.36,
    "y-162": 0.36,
    "y-163": 0.36,
    "y-164": 0.36,
    "y-165": 0.363,
    "y-166": 0.363,
    "y-167": 0.363,
    "y-168": 0.363,
    "y-169": 0.363,
    "y-170": 0.362,
    "y-171": 0.362,
    "y-172": 0.361,
    "y-173": 0.361,
    "y-174": 0.361,
    "y-175": 0.361,
    "y-176": 0.361,
    "y-177": 0.361,
    "y-178": 0.361,
    "y-179": 0.361,
    "y-180": 0.361,
    "y-181": 0.362,
    "y-182": 0.363,
    "y-183": 0.363,
    "y-184": 0.363,
    "y-185": 0.363,
    "y-186": 0.363,
    "y-187": 0.363,
    "y-188": 0.363,
    "y-189": 0.363,
    "y-190": 0.363,
    "y-191": 0.363,
    "y-192": 0.363,
    "y-193": 0.363,
    "y-194": 0.363,
    "y-195": 0.363,
    "y-196": 0.365,
    "y-197": 0.365,
    "y-198": 0.365,
    "y-199": 0.365,
    "y-200": 0.365,
    "y-201": 0.365,
    "y-202": 0.365,
    "y-203": 0.364,
    "y-204": 0.364,
    "y-205": 0.364,
    "y-206": 0.364,
    "y-207": 0.364,
    "y-208": 0.364,
    "y-209": 0.364,
    "y-210": 0.363,
    "y-211": 0.363,
    "y-212": 0.363,
    "y-213": 0.363,
    "y-214": 0.363,
    "y-215": 0.362,
    "y-216": 0.362,
    "y-217": 0.362,
    "y-218": 0.362,
    "y-219": 0.362,
    "y-220": 0.362,
    "y-221": 0.362,
    "y-222": 0.362,
    "y-223": 0.362,
    "y-224": 0.362,
    "y-225": 0.362,
    "y-226": 0.362,
    "y-227": 0.362,
    "y-228": 0.362,
    "y-229": 0.362,
    "y-230": 0.362,
    "y-231": 0.362,
    "y-232": 0.362,
    "y-233": 0.361,
    "y-234": 0.361,
    "y-235": 0.361,
    "y-236": 0.361,
    "y-237": 0.361,
    "y-238": 0.361,
    "y-239": 0.361,
    "y-240": 0.361,
    "y-241": 0.361,
    "y-242": 0.361,
    "y-243": 0.361,
    "y-244": 0.361,
    "y-245": 0.361,
    "y-246": 0.361,
    "y-247": 0.361,
    "y-248": 0.361,
    "y-249": 0.361,
    "y-250": 0.361,
    "y-251": 0.361,
    "y-252": 0.361,
    "y-253": 0.361,
    "y-254": 0.361,
    "y-255": 0.361,
  },
  {
    x: -1.65,
    "y-2": 1.246,
    "y-12": 0.749,
    "y-46": 0.537,
    "y-1000": 0.502,
    "y-0": 0.909,
    "y-1": 1.337,
    "y-3": 0.319,
    "y-4": 0.252,
    "y-5": 0.237,
    "y-6": 0.796,
    "y-7": 0.743,
    "y-8": 0.743,
    "y-9": 0.749,
    "y-10": 0.749,
    "y-11": 0.749,
    "y-13": 0.749,
    "y-14": 0.749,
    "y-15": 0.749,
    "y-16": 0.585,
    "y-17": 0.585,
    "y-18": 0.585,
    "y-19": 0.467,
    "y-20": 0.467,
    "y-21": 0.51,
    "y-22": 0.489,
    "y-23": 0.489,
    "y-24": 0.489,
    "y-25": 0.459,
    "y-26": 0.459,
    "y-27": 6.927,
    "y-28": 6.989,
    "y-29": 10.604,
    "y-30": 10.582,
    "y-31": 10.496,
    "y-32": 10.569,
    "y-33": 10.576,
    "y-34": 10.593,
    "y-35": 10.547,
    "y-36": 10.624,
    "y-37": 10.606,
    "y-38": 10.63,
    "y-39": 0.528,
    "y-40": 0.527,
    "y-41": 0.548,
    "y-42": 0.563,
    "y-43": 0.561,
    "y-44": 0.528,
    "y-45": 0.538,
    "y-47": 0.545,
    "y-48": 0.558,
    "y-49": 0.54,
    "y-50": 0.522,
    "y-51": 0.549,
    "y-52": 0.548,
    "y-53": 0.554,
    "y-54": 0.542,
    "y-55": 0.552,
    "y-56": 0.551,
    "y-57": 0.561,
    "y-58": 0.535,
    "y-59": 0.55,
    "y-60": 0.551,
    "y-61": 0.555,
    "y-62": 0.551,
    "y-63": 0.551,
    "y-64": 0.551,
    "y-65": 0.555,
    "y-66": 0.55,
    "y-67": 0.553,
    "y-68": 0.554,
    "y-69": 0.552,
    "y-70": 0.554,
    "y-71": 0.551,
    "y-72": 0.554,
    "y-73": 0.551,
    "y-74": 0.554,
    "y-75": 0.555,
    "y-76": 0.555,
    "y-77": 0.553,
    "y-78": 0.552,
    "y-79": 0.554,
    "y-80": 0.552,
    "y-81": 0.555,
    "y-82": 0.55,
    "y-83": 0.499,
    "y-84": 0.496,
    "y-85": 0.494,
    "y-86": 0.499,
    "y-87": 0.498,
    "y-88": 0.498,
    "y-89": 0.497,
    "y-90": 0.5,
    "y-91": 0.501,
    "y-92": 0.499,
    "y-93": 0.5,
    "y-94": 0.496,
    "y-95": 0.498,
    "y-96": 0.497,
    "y-97": 0.5,
    "y-98": 0.496,
    "y-99": 0.499,
    "y-100": 0.513,
    "y-101": 0.513,
    "y-102": 0.512,
    "y-103": 0.513,
    "y-104": 0.512,
    "y-105": 0.514,
    "y-106": 0.51,
    "y-107": 0.513,
    "y-108": 0.493,
    "y-109": 0.5,
    "y-110": 0.497,
    "y-111": 0.506,
    "y-112": 0.507,
    "y-113": 0.511,
    "y-114": 0.51,
    "y-115": 0.511,
    "y-116": 0.51,
    "y-117": 0.513,
    "y-118": 0.512,
    "y-119": 0.513,
    "y-120": 0.513,
    "y-121": 0.513,
    "y-122": 0.513,
    "y-123": 0.513,
    "y-124": 0.513,
    "y-125": 0.513,
    "y-126": 0.502,
    "y-127": 0.501,
    "y-128": 0.502,
    "y-129": 0.502,
    "y-130": 0.502,
    "y-131": 0.502,
    "y-132": 0.502,
    "y-133": 0.502,
    "y-134": 0.502,
    "y-135": 0.502,
    "y-136": 0.502,
    "y-137": 0.502,
    "y-138": 0.502,
    "y-139": 0.502,
    "y-140": 0.501,
    "y-141": 0.513,
    "y-142": 0.513,
    "y-143": 0.514,
    "y-144": 0.514,
    "y-145": 0.514,
    "y-146": 0.514,
    "y-147": 0.514,
    "y-148": 0.515,
    "y-149": 0.515,
    "y-150": 0.515,
    "y-151": 0.515,
    "y-152": 0.515,
    "y-153": 0.515,
    "y-154": 0.514,
    "y-155": 0.514,
    "y-156": 0.514,
    "y-157": 0.514,
    "y-158": 0.514,
    "y-159": 0.514,
    "y-160": 0.514,
    "y-161": 0.514,
    "y-162": 0.514,
    "y-163": 0.514,
    "y-164": 0.514,
    "y-165": 0.517,
    "y-166": 0.517,
    "y-167": 0.517,
    "y-168": 0.517,
    "y-169": 0.517,
    "y-170": 0.516,
    "y-171": 0.516,
    "y-172": 0.514,
    "y-173": 0.514,
    "y-174": 0.514,
    "y-175": 0.514,
    "y-176": 0.514,
    "y-177": 0.514,
    "y-178": 0.514,
    "y-179": 0.514,
    "y-180": 0.514,
    "y-181": 0.515,
    "y-182": 0.516,
    "y-183": 0.516,
    "y-184": 0.516,
    "y-185": 0.516,
    "y-186": 0.516,
    "y-187": 0.516,
    "y-188": 0.516,
    "y-189": 0.516,
    "y-190": 0.516,
    "y-191": 0.516,
    "y-192": 0.516,
    "y-193": 0.516,
    "y-194": 0.516,
    "y-195": 0.516,
    "y-196": 0.519,
    "y-197": 0.519,
    "y-198": 0.519,
    "y-199": 0.519,
    "y-200": 0.519,
    "y-201": 0.519,
    "y-202": 0.519,
    "y-203": 0.518,
    "y-204": 0.518,
    "y-205": 0.518,
    "y-206": 0.518,
    "y-207": 0.518,
    "y-208": 0.518,
    "y-209": 0.518,
    "y-210": 0.516,
    "y-211": 0.516,
    "y-212": 0.516,
    "y-213": 0.516,
    "y-214": 0.516,
    "y-215": 0.515,
    "y-216": 0.515,
    "y-217": 0.515,
    "y-218": 0.515,
    "y-219": 0.515,
    "y-220": 0.515,
    "y-221": 0.515,
    "y-222": 0.515,
    "y-223": 0.515,
    "y-224": 0.515,
    "y-225": 0.515,
    "y-226": 0.515,
    "y-227": 0.515,
    "y-228": 0.515,
    "y-229": 0.515,
    "y-230": 0.515,
    "y-231": 0.515,
    "y-232": 0.515,
    "y-233": 0.514,
    "y-234": 0.514,
    "y-235": 0.514,
    "y-236": 0.514,
    "y-237": 0.514,
    "y-238": 0.514,
    "y-239": 0.514,
    "y-240": 0.514,
    "y-241": 0.514,
    "y-242": 0.514,
    "y-243": 0.514,
    "y-244": 0.514,
    "y-245": 0.514,
    "y-246": 0.514,
    "y-247": 0.514,
    "y-248": 0.514,
    "y-249": 0.514,
    "y-250": 0.514,
    "y-251": 0.514,
    "y-252": 0.514,
    "y-253": 0.514,
    "y-254": 0.514,
    "y-255": 0.514,
  },
  {
    x: -1.625,
    "y-2": 1.225,
    "y-12": 0.838,
    "y-46": 0.668,
    "y-1000": 0.628,
    "y-0": 0.897,
    "y-1": 1.312,
    "y-3": 0.362,
    "y-4": 0.376,
    "y-5": 0.358,
    "y-6": 0.871,
    "y-7": 0.833,
    "y-8": 0.833,
    "y-9": 0.838,
    "y-10": 0.838,
    "y-11": 0.838,
    "y-13": 0.838,
    "y-14": 0.838,
    "y-15": 0.838,
    "y-16": 0.715,
    "y-17": 0.715,
    "y-18": 0.715,
    "y-19": 0.669,
    "y-20": 0.669,
    "y-21": 0.527,
    "y-22": 0.597,
    "y-23": 0.597,
    "y-24": 0.597,
    "y-25": 0.582,
    "y-26": 0.582,
    "y-27": 9.502,
    "y-28": 9.588,
    "y-29": 10.561,
    "y-30": 10.554,
    "y-31": 10.518,
    "y-32": 10.565,
    "y-33": 10.58,
    "y-34": 10.569,
    "y-35": 10.535,
    "y-36": 10.57,
    "y-37": 10.552,
    "y-38": 10.578,
    "y-39": 0.645,
    "y-40": 0.647,
    "y-41": 0.67,
    "y-42": 0.688,
    "y-43": 0.67,
    "y-44": 0.65,
    "y-45": 0.662,
    "y-47": 0.674,
    "y-48": 0.668,
    "y-49": 0.671,
    "y-50": 0.657,
    "y-51": 0.671,
    "y-52": 0.669,
    "y-53": 0.673,
    "y-54": 0.662,
    "y-55": 0.675,
    "y-56": 0.671,
    "y-57": 0.682,
    "y-58": 0.663,
    "y-59": 0.672,
    "y-60": 0.672,
    "y-61": 0.674,
    "y-62": 0.673,
    "y-63": 0.672,
    "y-64": 0.673,
    "y-65": 0.674,
    "y-66": 0.673,
    "y-67": 0.672,
    "y-68": 0.672,
    "y-69": 0.672,
    "y-70": 0.673,
    "y-71": 0.673,
    "y-72": 0.673,
    "y-73": 0.672,
    "y-74": 0.676,
    "y-75": 0.675,
    "y-76": 0.675,
    "y-77": 0.675,
    "y-78": 0.674,
    "y-79": 0.675,
    "y-80": 0.675,
    "y-81": 0.674,
    "y-82": 0.674,
    "y-83": 0.623,
    "y-84": 0.621,
    "y-85": 0.621,
    "y-86": 0.623,
    "y-87": 0.623,
    "y-88": 0.623,
    "y-89": 0.622,
    "y-90": 0.624,
    "y-91": 0.623,
    "y-92": 0.623,
    "y-93": 0.623,
    "y-94": 0.621,
    "y-95": 0.623,
    "y-96": 0.621,
    "y-97": 0.622,
    "y-98": 0.622,
    "y-99": 0.624,
    "y-100": 0.628,
    "y-101": 0.628,
    "y-102": 0.628,
    "y-103": 0.628,
    "y-104": 0.627,
    "y-105": 0.629,
    "y-106": 0.626,
    "y-107": 0.628,
    "y-108": 0.613,
    "y-109": 0.616,
    "y-110": 0.615,
    "y-111": 0.622,
    "y-112": 0.622,
    "y-113": 0.625,
    "y-114": 0.624,
    "y-115": 0.624,
    "y-116": 0.624,
    "y-117": 0.625,
    "y-118": 0.625,
    "y-119": 0.626,
    "y-120": 0.626,
    "y-121": 0.625,
    "y-122": 0.626,
    "y-123": 0.625,
    "y-124": 0.625,
    "y-125": 0.625,
    "y-126": 0.617,
    "y-127": 0.616,
    "y-128": 0.616,
    "y-129": 0.616,
    "y-130": 0.616,
    "y-131": 0.616,
    "y-132": 0.616,
    "y-133": 0.616,
    "y-134": 0.616,
    "y-135": 0.616,
    "y-136": 0.616,
    "y-137": 0.616,
    "y-138": 0.616,
    "y-139": 0.616,
    "y-140": 0.616,
    "y-141": 0.626,
    "y-142": 0.626,
    "y-143": 0.626,
    "y-144": 0.626,
    "y-145": 0.626,
    "y-146": 0.626,
    "y-147": 0.626,
    "y-148": 0.627,
    "y-149": 0.627,
    "y-150": 0.627,
    "y-151": 0.627,
    "y-152": 0.626,
    "y-153": 0.626,
    "y-154": 0.626,
    "y-155": 0.626,
    "y-156": 0.626,
    "y-157": 0.626,
    "y-158": 0.626,
    "y-159": 0.626,
    "y-160": 0.626,
    "y-161": 0.626,
    "y-162": 0.626,
    "y-163": 0.626,
    "y-164": 0.626,
    "y-165": 0.627,
    "y-166": 0.627,
    "y-167": 0.627,
    "y-168": 0.627,
    "y-169": 0.627,
    "y-170": 0.627,
    "y-171": 0.627,
    "y-172": 0.625,
    "y-173": 0.625,
    "y-174": 0.625,
    "y-175": 0.625,
    "y-176": 0.625,
    "y-177": 0.625,
    "y-178": 0.625,
    "y-179": 0.625,
    "y-180": 0.625,
    "y-181": 0.626,
    "y-182": 0.626,
    "y-183": 0.626,
    "y-184": 0.626,
    "y-185": 0.626,
    "y-186": 0.626,
    "y-187": 0.626,
    "y-188": 0.626,
    "y-189": 0.626,
    "y-190": 0.626,
    "y-191": 0.626,
    "y-192": 0.626,
    "y-193": 0.626,
    "y-194": 0.626,
    "y-195": 0.626,
    "y-196": 0.629,
    "y-197": 0.629,
    "y-198": 0.629,
    "y-199": 0.629,
    "y-200": 0.629,
    "y-201": 0.629,
    "y-202": 0.629,
    "y-203": 0.628,
    "y-204": 0.628,
    "y-205": 0.628,
    "y-206": 0.628,
    "y-207": 0.628,
    "y-208": 0.628,
    "y-209": 0.628,
    "y-210": 0.627,
    "y-211": 0.627,
    "y-212": 0.627,
    "y-213": 0.627,
    "y-214": 0.627,
    "y-215": 0.626,
    "y-216": 0.626,
    "y-217": 0.626,
    "y-218": 0.626,
    "y-219": 0.626,
    "y-220": 0.626,
    "y-221": 0.626,
    "y-222": 0.626,
    "y-223": 0.627,
    "y-224": 0.627,
    "y-225": 0.626,
    "y-226": 0.626,
    "y-227": 0.626,
    "y-228": 0.626,
    "y-229": 0.626,
    "y-230": 0.626,
    "y-231": 0.626,
    "y-232": 0.626,
    "y-233": 0.626,
    "y-234": 0.626,
    "y-235": 0.626,
    "y-236": 0.626,
    "y-237": 0.626,
    "y-238": 0.626,
    "y-239": 0.626,
    "y-240": 0.626,
    "y-241": 0.626,
    "y-242": 0.626,
    "y-243": 0.626,
    "y-244": 0.626,
    "y-245": 0.626,
    "y-246": 0.626,
    "y-247": 0.626,
    "y-248": 0.626,
    "y-249": 0.626,
    "y-250": 0.626,
    "y-251": 0.626,
    "y-252": 0.626,
    "y-253": 0.626,
    "y-254": 0.626,
    "y-255": 0.626,
  },
  {
    x: -1.6,
    "y-2": 1.203,
    "y-12": 0.927,
    "y-46": 0.704,
    "y-1000": 0.704,
    "y-0": 0.884,
    "y-1": 1.288,
    "y-3": 0.405,
    "y-4": 0.501,
    "y-5": 0.479,
    "y-6": 0.947,
    "y-7": 0.922,
    "y-8": 0.922,
    "y-9": 0.927,
    "y-10": 0.927,
    "y-11": 0.927,
    "y-13": 0.927,
    "y-14": 0.927,
    "y-15": 0.927,
    "y-16": 0.844,
    "y-17": 0.844,
    "y-18": 0.844,
    "y-19": 0.871,
    "y-20": 0.871,
    "y-21": 0.543,
    "y-22": 0.704,
    "y-23": 0.704,
    "y-24": 0.704,
    "y-25": 0.704,
    "y-26": 0.704,
    "y-27": 0.704,
    "y-28": 0.704,
    "y-29": 0.704,
    "y-30": 0.704,
    "y-31": 0.704,
    "y-32": 0.704,
    "y-33": 0.704,
    "y-34": 0.704,
    "y-35": 0.704,
    "y-36": 0.704,
    "y-37": 0.704,
    "y-38": 0.704,
    "y-39": 0.704,
    "y-40": 0.704,
    "y-41": 0.704,
    "y-42": 0.704,
    "y-43": 0.704,
    "y-44": 0.704,
    "y-45": 0.704,
    "y-47": 0.704,
    "y-48": 0.704,
    "y-49": 0.704,
    "y-50": 0.704,
    "y-51": 0.704,
    "y-52": 0.704,
    "y-53": 0.704,
    "y-54": 0.704,
    "y-55": 0.704,
    "y-56": 0.704,
    "y-57": 0.704,
    "y-58": 0.704,
    "y-59": 0.704,
    "y-60": 0.704,
    "y-61": 0.704,
    "y-62": 0.704,
    "y-63": 0.704,
    "y-64": 0.704,
    "y-65": 0.704,
    "y-66": 0.704,
    "y-67": 0.704,
    "y-68": 0.704,
    "y-69": 0.704,
    "y-70": 0.704,
    "y-71": 0.704,
    "y-72": 0.704,
    "y-73": 0.704,
    "y-74": 0.704,
    "y-75": 0.704,
    "y-76": 0.704,
    "y-77": 0.704,
    "y-78": 0.704,
    "y-79": 0.704,
    "y-80": 0.704,
    "y-81": 0.704,
    "y-82": 0.704,
    "y-83": 0.704,
    "y-84": 0.704,
    "y-85": 0.704,
    "y-86": 0.704,
    "y-87": 0.704,
    "y-88": 0.704,
    "y-89": 0.704,
    "y-90": 0.704,
    "y-91": 0.704,
    "y-92": 0.704,
    "y-93": 0.704,
    "y-94": 0.704,
    "y-95": 0.704,
    "y-96": 0.704,
    "y-97": 0.704,
    "y-98": 0.704,
    "y-99": 0.704,
    "y-100": 0.704,
    "y-101": 0.704,
    "y-102": 0.704,
    "y-103": 0.704,
    "y-104": 0.704,
    "y-105": 0.704,
    "y-106": 0.704,
    "y-107": 0.704,
    "y-108": 0.704,
    "y-109": 0.704,
    "y-110": 0.704,
    "y-111": 0.704,
    "y-112": 0.704,
    "y-113": 0.704,
    "y-114": 0.704,
    "y-115": 0.704,
    "y-116": 0.704,
    "y-117": 0.704,
    "y-118": 0.704,
    "y-119": 0.704,
    "y-120": 0.704,
    "y-121": 0.704,
    "y-122": 0.704,
    "y-123": 0.704,
    "y-124": 0.704,
    "y-125": 0.704,
    "y-126": 0.704,
    "y-127": 0.704,
    "y-128": 0.704,
    "y-129": 0.704,
    "y-130": 0.704,
    "y-131": 0.704,
    "y-132": 0.704,
    "y-133": 0.704,
    "y-134": 0.704,
    "y-135": 0.704,
    "y-136": 0.704,
    "y-137": 0.704,
    "y-138": 0.704,
    "y-139": 0.704,
    "y-140": 0.704,
    "y-141": 0.704,
    "y-142": 0.704,
    "y-143": 0.704,
    "y-144": 0.704,
    "y-145": 0.704,
    "y-146": 0.704,
    "y-147": 0.704,
    "y-148": 0.704,
    "y-149": 0.704,
    "y-150": 0.704,
    "y-151": 0.704,
    "y-152": 0.704,
    "y-153": 0.704,
    "y-154": 0.704,
    "y-155": 0.704,
    "y-156": 0.704,
    "y-157": 0.704,
    "y-158": 0.704,
    "y-159": 0.704,
    "y-160": 0.704,
    "y-161": 0.704,
    "y-162": 0.704,
    "y-163": 0.704,
    "y-164": 0.704,
    "y-165": 0.704,
    "y-166": 0.704,
    "y-167": 0.704,
    "y-168": 0.704,
    "y-169": 0.704,
    "y-170": 0.704,
    "y-171": 0.704,
    "y-172": 0.704,
    "y-173": 0.704,
    "y-174": 0.704,
    "y-175": 0.704,
    "y-176": 0.704,
    "y-177": 0.704,
    "y-178": 0.704,
    "y-179": 0.704,
    "y-180": 0.704,
    "y-181": 0.704,
    "y-182": 0.704,
    "y-183": 0.704,
    "y-184": 0.704,
    "y-185": 0.704,
    "y-186": 0.704,
    "y-187": 0.704,
    "y-188": 0.704,
    "y-189": 0.704,
    "y-190": 0.704,
    "y-191": 0.704,
    "y-192": 0.704,
    "y-193": 0.704,
    "y-194": 0.704,
    "y-195": 0.704,
    "y-196": 0.704,
    "y-197": 0.704,
    "y-198": 0.704,
    "y-199": 0.704,
    "y-200": 0.704,
    "y-201": 0.704,
    "y-202": 0.704,
    "y-203": 0.704,
    "y-204": 0.704,
    "y-205": 0.704,
    "y-206": 0.704,
    "y-207": 0.704,
    "y-208": 0.704,
    "y-209": 0.704,
    "y-210": 0.704,
    "y-211": 0.704,
    "y-212": 0.704,
    "y-213": 0.704,
    "y-214": 0.704,
    "y-215": 0.704,
    "y-216": 0.704,
    "y-217": 0.704,
    "y-218": 0.704,
    "y-219": 0.704,
    "y-220": 0.704,
    "y-221": 0.704,
    "y-222": 0.704,
    "y-223": 0.704,
    "y-224": 0.704,
    "y-225": 0.704,
    "y-226": 0.704,
    "y-227": 0.704,
    "y-228": 0.704,
    "y-229": 0.704,
    "y-230": 0.704,
    "y-231": 0.704,
    "y-232": 0.704,
    "y-233": 0.704,
    "y-234": 0.704,
    "y-235": 0.704,
    "y-236": 0.704,
    "y-237": 0.704,
    "y-238": 0.704,
    "y-239": 0.704,
    "y-240": 0.704,
    "y-241": 0.704,
    "y-242": 0.704,
    "y-243": 0.704,
    "y-244": 0.704,
    "y-245": 0.704,
    "y-246": 0.704,
    "y-247": 0.704,
    "y-248": 0.704,
    "y-249": 0.704,
    "y-250": 0.704,
    "y-251": 0.704,
    "y-252": 0.704,
    "y-253": 0.704,
    "y-254": 0.704,
    "y-255": 0.704,
  },
  {
    x: -1.575,
    "y-2": 1.182,
    "y-12": 1.016,
    "y-46": 0.74,
    "y-1000": 0.715,
    "y-0": 0.872,
    "y-1": 1.263,
    "y-3": 0.448,
    "y-4": 0.625,
    "y-5": 0.6,
    "y-6": 1.022,
    "y-7": 1.011,
    "y-8": 1.011,
    "y-9": 1.016,
    "y-10": 1.016,
    "y-11": 1.016,
    "y-13": 1.016,
    "y-14": 1.016,
    "y-15": 1.016,
    "y-16": 0.974,
    "y-17": 0.974,
    "y-18": 0.974,
    "y-19": 1.073,
    "y-20": 1.073,
    "y-21": 0.56,
    "y-22": 0.811,
    "y-23": 0.811,
    "y-24": 0.811,
    "y-25": 0.826,
    "y-26": 0.826,
    "y-27": -8.094,
    "y-28": -8.18,
    "y-29": -9.153,
    "y-30": -9.146,
    "y-31": -9.11,
    "y-32": -9.157,
    "y-33": -9.172,
    "y-34": -9.161,
    "y-35": -9.127,
    "y-36": -9.162,
    "y-37": -9.144,
    "y-38": -9.17,
    "y-39": 0.763,
    "y-40": 0.761,
    "y-41": 0.738,
    "y-42": 0.72,
    "y-43": 0.738,
    "y-44": 0.758,
    "y-45": 0.746,
    "y-47": 0.734,
    "y-48": 0.74,
    "y-49": 0.737,
    "y-50": 0.751,
    "y-51": 0.737,
    "y-52": 0.739,
    "y-53": 0.735,
    "y-54": 0.746,
    "y-55": 0.733,
    "y-56": 0.737,
    "y-57": 0.726,
    "y-58": 0.745,
    "y-59": 0.736,
    "y-60": 0.736,
    "y-61": 0.734,
    "y-62": 0.735,
    "y-63": 0.736,
    "y-64": 0.735,
    "y-65": 0.734,
    "y-66": 0.735,
    "y-67": 0.736,
    "y-68": 0.736,
    "y-69": 0.736,
    "y-70": 0.735,
    "y-71": 0.735,
    "y-72": 0.735,
    "y-73": 0.736,
    "y-74": 0.732,
    "y-75": 0.733,
    "y-76": 0.733,
    "y-77": 0.733,
    "y-78": 0.734,
    "y-79": 0.733,
    "y-80": 0.733,
    "y-81": 0.734,
    "y-82": 0.734,
    "y-83": 0.726,
    "y-84": 0.726,
    "y-85": 0.726,
    "y-86": 0.726,
    "y-87": 0.726,
    "y-88": 0.726,
    "y-89": 0.727,
    "y-90": 0.728,
    "y-91": 0.727,
    "y-92": 0.728,
    "y-93": 0.727,
    "y-94": 0.728,
    "y-95": 0.728,
    "y-96": 0.729,
    "y-97": 0.728,
    "y-98": 0.728,
    "y-99": 0.727,
    "y-100": 0.726,
    "y-101": 0.725,
    "y-102": 0.726,
    "y-103": 0.726,
    "y-104": 0.726,
    "y-105": 0.726,
    "y-106": 0.727,
    "y-107": 0.726,
    "y-108": 0.714,
    "y-109": 0.714,
    "y-110": 0.714,
    "y-111": 0.686,
    "y-112": 0.686,
    "y-113": 0.686,
    "y-114": 0.686,
    "y-115": 0.686,
    "y-116": 0.686,
    "y-117": 0.685,
    "y-118": 0.685,
    "y-119": 0.685,
    "y-120": 0.685,
    "y-121": 0.685,
    "y-122": 0.685,
    "y-123": 0.685,
    "y-124": 0.685,
    "y-125": 0.685,
    "y-126": 0.679,
    "y-127": 0.684,
    "y-128": 0.684,
    "y-129": 0.684,
    "y-130": 0.684,
    "y-131": 0.684,
    "y-132": 0.684,
    "y-133": 0.684,
    "y-134": 0.684,
    "y-135": 0.684,
    "y-136": 0.684,
    "y-137": 0.684,
    "y-138": 0.684,
    "y-139": 0.684,
    "y-140": 0.684,
    "y-141": 0.681,
    "y-142": 0.681,
    "y-143": 0.681,
    "y-144": 0.681,
    "y-145": 0.681,
    "y-146": 0.682,
    "y-147": 0.682,
    "y-148": 0.682,
    "y-149": 0.682,
    "y-150": 0.682,
    "y-151": 0.682,
    "y-152": 0.682,
    "y-153": 0.682,
    "y-154": 0.683,
    "y-155": 0.683,
    "y-156": 0.683,
    "y-157": 0.683,
    "y-158": 0.683,
    "y-159": 0.683,
    "y-160": 0.683,
    "y-161": 0.683,
    "y-162": 0.683,
    "y-163": 0.683,
    "y-164": 0.683,
    "y-165": 0.683,
    "y-166": 0.683,
    "y-167": 0.683,
    "y-168": 0.683,
    "y-169": 0.683,
    "y-170": 0.683,
    "y-171": 0.683,
    "y-172": 0.689,
    "y-173": 0.689,
    "y-174": 0.689,
    "y-175": 0.689,
    "y-176": 0.689,
    "y-177": 0.689,
    "y-178": 0.689,
    "y-179": 0.689,
    "y-180": 0.689,
    "y-181": 0.689,
    "y-182": 0.688,
    "y-183": 0.688,
    "y-184": 0.688,
    "y-185": 0.688,
    "y-186": 0.688,
    "y-187": 0.688,
    "y-188": 0.688,
    "y-189": 0.688,
    "y-190": 0.688,
    "y-191": 0.688,
    "y-192": 0.688,
    "y-193": 0.688,
    "y-194": 0.688,
    "y-195": 0.688,
    "y-196": 0.681,
    "y-197": 0.681,
    "y-198": 0.681,
    "y-199": 0.681,
    "y-200": 0.681,
    "y-201": 0.681,
    "y-202": 0.681,
    "y-203": 0.681,
    "y-204": 0.681,
    "y-205": 0.681,
    "y-206": 0.681,
    "y-207": 0.681,
    "y-208": 0.681,
    "y-209": 0.681,
    "y-210": 0.686,
    "y-211": 0.686,
    "y-212": 0.686,
    "y-213": 0.686,
    "y-214": 0.686,
    "y-215": 0.686,
    "y-216": 0.686,
    "y-217": 0.686,
    "y-218": 0.686,
    "y-219": 0.686,
    "y-220": 0.687,
    "y-221": 0.687,
    "y-222": 0.687,
    "y-223": 0.685,
    "y-224": 0.685,
    "y-225": 0.686,
    "y-226": 0.686,
    "y-227": 0.686,
    "y-228": 0.686,
    "y-229": 0.686,
    "y-230": 0.686,
    "y-231": 0.686,
    "y-232": 0.686,
    "y-233": 0.687,
    "y-234": 0.687,
    "y-235": 0.687,
    "y-236": 0.687,
    "y-237": 0.687,
    "y-238": 0.687,
    "y-239": 0.687,
    "y-240": 0.687,
    "y-241": 0.687,
    "y-242": 0.687,
    "y-243": 0.687,
    "y-244": 0.687,
    "y-245": 0.687,
    "y-246": 0.687,
    "y-247": 0.687,
    "y-248": 0.687,
    "y-249": 0.687,
    "y-250": 0.687,
    "y-251": 0.687,
    "y-252": 0.687,
    "y-253": 0.687,
    "y-254": 0.687,
    "y-255": 0.687,
  },
  {
    x: -1.55,
    "y-2": 1.161,
    "y-12": 1.105,
    "y-46": 0.777,
    "y-1000": 0.713,
    "y-0": 0.86,
    "y-1": 1.239,
    "y-3": 0.491,
    "y-4": 0.749,
    "y-5": 0.72,
    "y-6": 1.098,
    "y-7": 1.101,
    "y-8": 1.101,
    "y-9": 1.105,
    "y-10": 1.105,
    "y-11": 1.105,
    "y-13": 1.105,
    "y-14": 1.105,
    "y-15": 1.105,
    "y-16": 1.104,
    "y-17": 1.104,
    "y-18": 1.104,
    "y-19": 1.275,
    "y-20": 1.275,
    "y-21": 0.577,
    "y-22": 0.919,
    "y-23": 0.919,
    "y-24": 0.919,
    "y-25": 0.949,
    "y-26": 0.949,
    "y-27": -16.892,
    "y-28": -17.064,
    "y-29": -19.01,
    "y-30": -18.995,
    "y-31": -18.924,
    "y-32": -19.019,
    "y-33": -19.047,
    "y-34": -19.026,
    "y-35": -18.959,
    "y-36": -19.028,
    "y-37": -18.993,
    "y-38": -19.044,
    "y-39": 0.823,
    "y-40": 0.817,
    "y-41": 0.772,
    "y-42": 0.735,
    "y-43": 0.772,
    "y-44": 0.812,
    "y-45": 0.787,
    "y-47": 0.765,
    "y-48": 0.776,
    "y-49": 0.769,
    "y-50": 0.799,
    "y-51": 0.771,
    "y-52": 0.773,
    "y-53": 0.766,
    "y-54": 0.788,
    "y-55": 0.762,
    "y-56": 0.769,
    "y-57": 0.748,
    "y-58": 0.786,
    "y-59": 0.768,
    "y-60": 0.768,
    "y-61": 0.764,
    "y-62": 0.767,
    "y-63": 0.767,
    "y-64": 0.767,
    "y-65": 0.765,
    "y-66": 0.766,
    "y-67": 0.767,
    "y-68": 0.767,
    "y-69": 0.769,
    "y-70": 0.766,
    "y-71": 0.766,
    "y-72": 0.767,
    "y-73": 0.768,
    "y-74": 0.759,
    "y-75": 0.762,
    "y-76": 0.763,
    "y-77": 0.763,
    "y-78": 0.764,
    "y-79": 0.762,
    "y-80": 0.761,
    "y-81": 0.764,
    "y-82": 0.765,
    "y-83": 0.731,
    "y-84": 0.73,
    "y-85": 0.729,
    "y-86": 0.73,
    "y-87": 0.729,
    "y-88": 0.729,
    "y-89": 0.733,
    "y-90": 0.735,
    "y-91": 0.733,
    "y-92": 0.734,
    "y-93": 0.733,
    "y-94": 0.735,
    "y-95": 0.735,
    "y-96": 0.736,
    "y-97": 0.735,
    "y-98": 0.734,
    "y-99": 0.733,
    "y-100": 0.732,
    "y-101": 0.73,
    "y-102": 0.731,
    "y-103": 0.733,
    "y-104": 0.732,
    "y-105": 0.731,
    "y-106": 0.733,
    "y-107": 0.732,
    "y-108": 0.716,
    "y-109": 0.716,
    "y-110": 0.716,
    "y-111": 0.689,
    "y-112": 0.689,
    "y-113": 0.688,
    "y-114": 0.689,
    "y-115": 0.689,
    "y-116": 0.688,
    "y-117": 0.688,
    "y-118": 0.688,
    "y-119": 0.688,
    "y-120": 0.688,
    "y-121": 0.688,
    "y-122": 0.688,
    "y-123": 0.688,
    "y-124": 0.688,
    "y-125": 0.688,
    "y-126": 0.679,
    "y-127": 0.687,
    "y-128": 0.687,
    "y-129": 0.687,
    "y-130": 0.687,
    "y-131": 0.687,
    "y-132": 0.687,
    "y-133": 0.687,
    "y-134": 0.687,
    "y-135": 0.687,
    "y-136": 0.687,
    "y-137": 0.687,
    "y-138": 0.687,
    "y-139": 0.687,
    "y-140": 0.687,
    "y-141": 0.684,
    "y-142": 0.684,
    "y-143": 0.684,
    "y-144": 0.684,
    "y-145": 0.684,
    "y-146": 0.685,
    "y-147": 0.685,
    "y-148": 0.685,
    "y-149": 0.685,
    "y-150": 0.685,
    "y-151": 0.685,
    "y-152": 0.685,
    "y-153": 0.685,
    "y-154": 0.687,
    "y-155": 0.687,
    "y-156": 0.687,
    "y-157": 0.687,
    "y-158": 0.687,
    "y-159": 0.687,
    "y-160": 0.687,
    "y-161": 0.687,
    "y-162": 0.687,
    "y-163": 0.687,
    "y-164": 0.688,
    "y-165": 0.687,
    "y-166": 0.687,
    "y-167": 0.687,
    "y-168": 0.687,
    "y-169": 0.687,
    "y-170": 0.687,
    "y-171": 0.687,
    "y-172": 0.697,
    "y-173": 0.697,
    "y-174": 0.697,
    "y-175": 0.697,
    "y-176": 0.697,
    "y-177": 0.697,
    "y-178": 0.697,
    "y-179": 0.697,
    "y-180": 0.697,
    "y-181": 0.697,
    "y-182": 0.697,
    "y-183": 0.697,
    "y-184": 0.697,
    "y-185": 0.697,
    "y-186": 0.697,
    "y-187": 0.697,
    "y-188": 0.697,
    "y-189": 0.697,
    "y-190": 0.697,
    "y-191": 0.697,
    "y-192": 0.697,
    "y-193": 0.697,
    "y-194": 0.697,
    "y-195": 0.697,
    "y-196": 0.684,
    "y-197": 0.684,
    "y-198": 0.684,
    "y-199": 0.684,
    "y-200": 0.684,
    "y-201": 0.684,
    "y-202": 0.684,
    "y-203": 0.684,
    "y-204": 0.684,
    "y-205": 0.684,
    "y-206": 0.684,
    "y-207": 0.684,
    "y-208": 0.684,
    "y-209": 0.684,
    "y-210": 0.693,
    "y-211": 0.693,
    "y-212": 0.693,
    "y-213": 0.693,
    "y-214": 0.693,
    "y-215": 0.693,
    "y-216": 0.693,
    "y-217": 0.693,
    "y-218": 0.693,
    "y-219": 0.693,
    "y-220": 0.694,
    "y-221": 0.694,
    "y-222": 0.694,
    "y-223": 0.692,
    "y-224": 0.692,
    "y-225": 0.692,
    "y-226": 0.692,
    "y-227": 0.692,
    "y-228": 0.692,
    "y-229": 0.692,
    "y-230": 0.692,
    "y-231": 0.692,
    "y-232": 0.692,
    "y-233": 0.694,
    "y-234": 0.694,
    "y-235": 0.694,
    "y-236": 0.694,
    "y-237": 0.694,
    "y-238": 0.694,
    "y-239": 0.694,
    "y-240": 0.694,
    "y-241": 0.694,
    "y-242": 0.694,
    "y-243": 0.694,
    "y-244": 0.694,
    "y-245": 0.694,
    "y-246": 0.694,
    "y-247": 0.694,
    "y-248": 0.694,
    "y-249": 0.694,
    "y-250": 0.694,
    "y-251": 0.694,
    "y-252": 0.694,
    "y-253": 0.694,
    "y-254": 0.694,
    "y-255": 0.694,
  },
  {
    x: -1.525,
    "y-2": 1.14,
    "y-12": 1.194,
    "y-46": 0.881,
    "y-1000": 0.849,
    "y-0": 0.848,
    "y-1": 1.214,
    "y-3": 0.534,
    "y-4": 0.873,
    "y-5": 0.841,
    "y-6": 1.173,
    "y-7": 1.19,
    "y-8": 1.19,
    "y-9": 1.194,
    "y-10": 1.194,
    "y-11": 1.194,
    "y-13": 1.194,
    "y-14": 1.194,
    "y-15": 1.194,
    "y-16": 1.234,
    "y-17": 1.234,
    "y-18": 1.234,
    "y-19": 1.477,
    "y-20": 1.477,
    "y-21": 0.593,
    "y-22": -15.651,
    "y-23": -15.651,
    "y-24": -15.651,
    "y-25": -15.644,
    "y-26": -15.644,
    "y-27": -19.752,
    "y-28": -19.791,
    "y-29": -20.239,
    "y-30": -20.236,
    "y-31": -20.22,
    "y-32": -20.241,
    "y-33": -20.248,
    "y-34": -20.243,
    "y-35": -20.228,
    "y-36": -20.244,
    "y-37": -20.235,
    "y-38": -20.247,
    "y-39": 0.901,
    "y-40": 0.88,
    "y-41": 0.877,
    "y-42": 0.854,
    "y-43": 0.865,
    "y-44": 0.889,
    "y-45": 0.866,
    "y-47": 0.864,
    "y-48": 0.866,
    "y-49": 0.877,
    "y-50": 0.883,
    "y-51": 0.865,
    "y-52": 0.856,
    "y-53": 0.853,
    "y-54": 0.874,
    "y-55": 0.863,
    "y-56": 0.862,
    "y-57": 0.848,
    "y-58": 0.871,
    "y-59": 0.862,
    "y-60": 0.86,
    "y-61": 0.858,
    "y-62": 0.86,
    "y-63": 0.86,
    "y-64": 0.86,
    "y-65": 0.858,
    "y-66": 0.859,
    "y-67": 0.86,
    "y-68": 0.861,
    "y-69": 0.861,
    "y-70": 0.859,
    "y-71": 0.86,
    "y-72": 0.86,
    "y-73": 0.86,
    "y-74": 0.853,
    "y-75": 0.854,
    "y-76": 0.855,
    "y-77": 0.855,
    "y-78": 0.855,
    "y-79": 0.854,
    "y-80": 0.854,
    "y-81": 0.855,
    "y-82": 0.856,
    "y-83": 0.835,
    "y-84": 0.833,
    "y-85": 0.833,
    "y-86": 0.833,
    "y-87": 0.833,
    "y-88": 0.833,
    "y-89": 0.837,
    "y-90": 0.839,
    "y-91": 0.837,
    "y-92": 0.837,
    "y-93": 0.837,
    "y-94": 0.839,
    "y-95": 0.838,
    "y-96": 0.839,
    "y-97": 0.839,
    "y-98": 0.838,
    "y-99": 0.838,
    "y-100": 0.837,
    "y-101": 0.835,
    "y-102": 0.836,
    "y-103": 0.837,
    "y-104": 0.837,
    "y-105": 0.837,
    "y-106": 0.838,
    "y-107": 0.837,
    "y-108": 0.828,
    "y-109": 0.827,
    "y-110": 0.827,
    "y-111": 0.818,
    "y-112": 0.818,
    "y-113": 0.817,
    "y-114": 0.817,
    "y-115": 0.817,
    "y-116": 0.817,
    "y-117": 0.817,
    "y-118": 0.817,
    "y-119": 0.817,
    "y-120": 0.817,
    "y-121": 0.817,
    "y-122": 0.817,
    "y-123": 0.817,
    "y-124": 0.817,
    "y-125": 0.817,
    "y-126": 0.812,
    "y-127": 0.819,
    "y-128": 0.819,
    "y-129": 0.819,
    "y-130": 0.819,
    "y-131": 0.819,
    "y-132": 0.819,
    "y-133": 0.819,
    "y-134": 0.819,
    "y-135": 0.819,
    "y-136": 0.819,
    "y-137": 0.819,
    "y-138": 0.819,
    "y-139": 0.819,
    "y-140": 0.819,
    "y-141": 0.818,
    "y-142": 0.818,
    "y-143": 0.818,
    "y-144": 0.818,
    "y-145": 0.818,
    "y-146": 0.819,
    "y-147": 0.819,
    "y-148": 0.819,
    "y-149": 0.819,
    "y-150": 0.819,
    "y-151": 0.819,
    "y-152": 0.819,
    "y-153": 0.819,
    "y-154": 0.821,
    "y-155": 0.821,
    "y-156": 0.821,
    "y-157": 0.821,
    "y-158": 0.821,
    "y-159": 0.821,
    "y-160": 0.821,
    "y-161": 0.821,
    "y-162": 0.821,
    "y-163": 0.821,
    "y-164": 0.821,
    "y-165": 0.821,
    "y-166": 0.821,
    "y-167": 0.821,
    "y-168": 0.821,
    "y-169": 0.821,
    "y-170": 0.821,
    "y-171": 0.821,
    "y-172": 0.829,
    "y-173": 0.829,
    "y-174": 0.829,
    "y-175": 0.829,
    "y-176": 0.829,
    "y-177": 0.829,
    "y-178": 0.829,
    "y-179": 0.829,
    "y-180": 0.83,
    "y-181": 0.83,
    "y-182": 0.829,
    "y-183": 0.829,
    "y-184": 0.829,
    "y-185": 0.829,
    "y-186": 0.829,
    "y-187": 0.829,
    "y-188": 0.829,
    "y-189": 0.829,
    "y-190": 0.829,
    "y-191": 0.829,
    "y-192": 0.829,
    "y-193": 0.829,
    "y-194": 0.829,
    "y-195": 0.829,
    "y-196": 0.818,
    "y-197": 0.818,
    "y-198": 0.818,
    "y-199": 0.818,
    "y-200": 0.818,
    "y-201": 0.818,
    "y-202": 0.818,
    "y-203": 0.818,
    "y-204": 0.818,
    "y-205": 0.818,
    "y-206": 0.818,
    "y-207": 0.818,
    "y-208": 0.818,
    "y-209": 0.818,
    "y-210": 0.826,
    "y-211": 0.826,
    "y-212": 0.826,
    "y-213": 0.826,
    "y-214": 0.826,
    "y-215": 0.826,
    "y-216": 0.826,
    "y-217": 0.826,
    "y-218": 0.826,
    "y-219": 0.826,
    "y-220": 0.827,
    "y-221": 0.827,
    "y-222": 0.827,
    "y-223": 0.825,
    "y-224": 0.825,
    "y-225": 0.825,
    "y-226": 0.825,
    "y-227": 0.825,
    "y-228": 0.825,
    "y-229": 0.825,
    "y-230": 0.825,
    "y-231": 0.825,
    "y-232": 0.825,
    "y-233": 0.826,
    "y-234": 0.826,
    "y-235": 0.826,
    "y-236": 0.826,
    "y-237": 0.826,
    "y-238": 0.826,
    "y-239": 0.826,
    "y-240": 0.826,
    "y-241": 0.826,
    "y-242": 0.826,
    "y-243": 0.826,
    "y-244": 0.826,
    "y-245": 0.826,
    "y-246": 0.826,
    "y-247": 0.826,
    "y-248": 0.826,
    "y-249": 0.826,
    "y-250": 0.826,
    "y-251": 0.826,
    "y-252": 0.826,
    "y-253": 0.826,
    "y-254": 0.826,
    "y-255": 0.826,
  },
  {
    x: -1.5,
    "y-2": 1.118,
    "y-12": 1.282,
    "y-46": 1.125,
    "y-1000": 1.125,
    "y-0": 0.836,
    "y-1": 1.189,
    "y-3": 0.577,
    "y-4": 0.997,
    "y-5": 0.962,
    "y-6": 1.248,
    "y-7": 1.28,
    "y-8": 1.28,
    "y-9": 1.282,
    "y-10": 1.282,
    "y-11": 1.282,
    "y-13": 1.282,
    "y-14": 1.282,
    "y-15": 1.282,
    "y-16": 1.363,
    "y-17": 1.363,
    "y-18": 1.363,
    "y-19": 1.589,
    "y-20": 1.589,
    "y-21": 1.705,
    "y-22": 1.125,
    "y-23": 1.125,
    "y-24": 1.125,
    "y-25": 1.125,
    "y-26": 1.125,
    "y-27": 1.125,
    "y-28": 1.125,
    "y-29": 1.125,
    "y-30": 1.125,
    "y-31": 1.125,
    "y-32": 1.125,
    "y-33": 1.125,
    "y-34": 1.125,
    "y-35": 1.125,
    "y-36": 1.125,
    "y-37": 1.125,
    "y-38": 1.125,
    "y-39": 1.125,
    "y-40": 1.125,
    "y-41": 1.125,
    "y-42": 1.125,
    "y-43": 1.125,
    "y-44": 1.125,
    "y-45": 1.125,
    "y-47": 1.125,
    "y-48": 1.125,
    "y-49": 1.125,
    "y-50": 1.125,
    "y-51": 1.125,
    "y-52": 1.125,
    "y-53": 1.125,
    "y-54": 1.125,
    "y-55": 1.125,
    "y-56": 1.125,
    "y-57": 1.125,
    "y-58": 1.125,
    "y-59": 1.125,
    "y-60": 1.125,
    "y-61": 1.125,
    "y-62": 1.125,
    "y-63": 1.125,
    "y-64": 1.125,
    "y-65": 1.125,
    "y-66": 1.125,
    "y-67": 1.125,
    "y-68": 1.125,
    "y-69": 1.125,
    "y-70": 1.125,
    "y-71": 1.125,
    "y-72": 1.125,
    "y-73": 1.125,
    "y-74": 1.125,
    "y-75": 1.125,
    "y-76": 1.125,
    "y-77": 1.125,
    "y-78": 1.125,
    "y-79": 1.125,
    "y-80": 1.125,
    "y-81": 1.125,
    "y-82": 1.125,
    "y-83": 1.125,
    "y-84": 1.125,
    "y-85": 1.125,
    "y-86": 1.125,
    "y-87": 1.125,
    "y-88": 1.125,
    "y-89": 1.125,
    "y-90": 1.125,
    "y-91": 1.125,
    "y-92": 1.125,
    "y-93": 1.125,
    "y-94": 1.125,
    "y-95": 1.125,
    "y-96": 1.125,
    "y-97": 1.125,
    "y-98": 1.125,
    "y-99": 1.125,
    "y-100": 1.125,
    "y-101": 1.125,
    "y-102": 1.125,
    "y-103": 1.125,
    "y-104": 1.125,
    "y-105": 1.125,
    "y-106": 1.125,
    "y-107": 1.125,
    "y-108": 1.125,
    "y-109": 1.125,
    "y-110": 1.125,
    "y-111": 1.125,
    "y-112": 1.125,
    "y-113": 1.125,
    "y-114": 1.125,
    "y-115": 1.125,
    "y-116": 1.125,
    "y-117": 1.125,
    "y-118": 1.125,
    "y-119": 1.125,
    "y-120": 1.125,
    "y-121": 1.125,
    "y-122": 1.125,
    "y-123": 1.125,
    "y-124": 1.125,
    "y-125": 1.125,
    "y-126": 1.125,
    "y-127": 1.125,
    "y-128": 1.125,
    "y-129": 1.125,
    "y-130": 1.125,
    "y-131": 1.125,
    "y-132": 1.125,
    "y-133": 1.125,
    "y-134": 1.125,
    "y-135": 1.125,
    "y-136": 1.125,
    "y-137": 1.125,
    "y-138": 1.125,
    "y-139": 1.125,
    "y-140": 1.125,
    "y-141": 1.125,
    "y-142": 1.125,
    "y-143": 1.125,
    "y-144": 1.125,
    "y-145": 1.125,
    "y-146": 1.125,
    "y-147": 1.125,
    "y-148": 1.125,
    "y-149": 1.125,
    "y-150": 1.125,
    "y-151": 1.125,
    "y-152": 1.125,
    "y-153": 1.125,
    "y-154": 1.125,
    "y-155": 1.125,
    "y-156": 1.125,
    "y-157": 1.125,
    "y-158": 1.125,
    "y-159": 1.125,
    "y-160": 1.125,
    "y-161": 1.125,
    "y-162": 1.125,
    "y-163": 1.125,
    "y-164": 1.125,
    "y-165": 1.125,
    "y-166": 1.125,
    "y-167": 1.125,
    "y-168": 1.125,
    "y-169": 1.125,
    "y-170": 1.125,
    "y-171": 1.125,
    "y-172": 1.125,
    "y-173": 1.125,
    "y-174": 1.125,
    "y-175": 1.125,
    "y-176": 1.125,
    "y-177": 1.125,
    "y-178": 1.125,
    "y-179": 1.125,
    "y-180": 1.125,
    "y-181": 1.125,
    "y-182": 1.125,
    "y-183": 1.125,
    "y-184": 1.125,
    "y-185": 1.125,
    "y-186": 1.125,
    "y-187": 1.125,
    "y-188": 1.125,
    "y-189": 1.125,
    "y-190": 1.125,
    "y-191": 1.125,
    "y-192": 1.125,
    "y-193": 1.125,
    "y-194": 1.125,
    "y-195": 1.125,
    "y-196": 1.125,
    "y-197": 1.125,
    "y-198": 1.125,
    "y-199": 1.125,
    "y-200": 1.125,
    "y-201": 1.125,
    "y-202": 1.125,
    "y-203": 1.125,
    "y-204": 1.125,
    "y-205": 1.125,
    "y-206": 1.125,
    "y-207": 1.125,
    "y-208": 1.125,
    "y-209": 1.125,
    "y-210": 1.125,
    "y-211": 1.125,
    "y-212": 1.125,
    "y-213": 1.125,
    "y-214": 1.125,
    "y-215": 1.125,
    "y-216": 1.125,
    "y-217": 1.125,
    "y-218": 1.125,
    "y-219": 1.125,
    "y-220": 1.125,
    "y-221": 1.125,
    "y-222": 1.125,
    "y-223": 1.125,
    "y-224": 1.125,
    "y-225": 1.125,
    "y-226": 1.125,
    "y-227": 1.125,
    "y-228": 1.125,
    "y-229": 1.125,
    "y-230": 1.125,
    "y-231": 1.125,
    "y-232": 1.125,
    "y-233": 1.125,
    "y-234": 1.125,
    "y-235": 1.125,
    "y-236": 1.125,
    "y-237": 1.125,
    "y-238": 1.125,
    "y-239": 1.125,
    "y-240": 1.125,
    "y-241": 1.125,
    "y-242": 1.125,
    "y-243": 1.125,
    "y-244": 1.125,
    "y-245": 1.125,
    "y-246": 1.125,
    "y-247": 1.125,
    "y-248": 1.125,
    "y-249": 1.125,
    "y-250": 1.125,
    "y-251": 1.125,
    "y-252": 1.125,
    "y-253": 1.125,
    "y-254": 1.125,
    "y-255": 1.125,
  },
  {
    x: -1.475,
    "y-2": 1.097,
    "y-12": 1.371,
    "y-46": 1.644,
    "y-1000": 1.65,
    "y-0": 0.823,
    "y-1": 1.165,
    "y-3": 0.62,
    "y-4": 1.121,
    "y-5": 1.083,
    "y-6": 1.324,
    "y-7": 1.369,
    "y-8": 1.369,
    "y-9": 1.371,
    "y-10": 1.371,
    "y-11": 1.371,
    "y-13": 1.371,
    "y-14": 1.371,
    "y-15": 1.371,
    "y-16": 1.493,
    "y-17": 1.493,
    "y-18": 1.493,
    "y-19": 1.673,
    "y-20": 1.673,
    "y-21": 1.907,
    "y-22": 4.017,
    "y-23": 4.017,
    "y-24": 4.017,
    "y-25": 4.017,
    "y-26": 4.017,
    "y-27": 4.017,
    "y-28": 4.017,
    "y-29": 4.017,
    "y-30": 4.017,
    "y-31": 4.017,
    "y-32": 4.017,
    "y-33": 4.017,
    "y-34": 4.017,
    "y-35": 4.017,
    "y-36": 4.017,
    "y-37": 4.017,
    "y-38": 4.017,
    "y-39": 1.582,
    "y-40": 1.585,
    "y-41": 1.584,
    "y-42": 1.586,
    "y-43": 1.586,
    "y-44": 1.583,
    "y-45": 1.586,
    "y-47": 1.648,
    "y-48": 1.648,
    "y-49": 1.646,
    "y-50": 1.646,
    "y-51": 1.706,
    "y-52": 1.705,
    "y-53": 1.704,
    "y-54": 1.699,
    "y-55": 1.697,
    "y-56": 1.701,
    "y-57": 1.702,
    "y-58": 1.694,
    "y-59": 1.699,
    "y-60": 1.699,
    "y-61": 1.699,
    "y-62": 1.699,
    "y-63": 1.699,
    "y-64": 1.697,
    "y-65": 1.697,
    "y-66": 1.697,
    "y-67": 1.697,
    "y-68": 1.696,
    "y-69": 1.696,
    "y-70": 1.696,
    "y-71": 1.696,
    "y-72": 1.697,
    "y-73": 1.697,
    "y-74": 1.715,
    "y-75": 1.712,
    "y-76": 1.713,
    "y-77": 1.713,
    "y-78": 1.712,
    "y-79": 1.713,
    "y-80": 1.713,
    "y-81": 1.713,
    "y-82": 1.712,
    "y-83": 1.719,
    "y-84": 1.72,
    "y-85": 1.721,
    "y-86": 1.719,
    "y-87": 1.72,
    "y-88": 1.719,
    "y-89": 1.708,
    "y-90": 1.707,
    "y-91": 1.708,
    "y-92": 1.708,
    "y-93": 1.708,
    "y-94": 1.708,
    "y-95": 1.708,
    "y-96": 1.707,
    "y-97": 1.708,
    "y-98": 1.707,
    "y-99": 1.707,
    "y-100": 1.706,
    "y-101": 1.708,
    "y-102": 1.708,
    "y-103": 1.707,
    "y-104": 1.708,
    "y-105": 1.708,
    "y-106": 1.707,
    "y-107": 1.708,
    "y-108": 1.711,
    "y-109": 1.711,
    "y-110": 1.711,
    "y-111": 1.713,
    "y-112": 1.713,
    "y-113": 1.713,
    "y-114": 1.713,
    "y-115": 1.713,
    "y-116": 1.713,
    "y-117": 1.713,
    "y-118": 1.713,
    "y-119": 1.713,
    "y-120": 1.713,
    "y-121": 1.713,
    "y-122": 1.713,
    "y-123": 1.713,
    "y-124": 1.713,
    "y-125": 1.713,
    "y-126": 1.715,
    "y-127": 1.7,
    "y-128": 1.7,
    "y-129": 1.7,
    "y-130": 1.7,
    "y-131": 1.7,
    "y-132": 1.7,
    "y-133": 1.7,
    "y-134": 1.7,
    "y-135": 1.7,
    "y-136": 1.7,
    "y-137": 1.7,
    "y-138": 1.7,
    "y-139": 1.7,
    "y-140": 1.7,
    "y-141": 1.7,
    "y-142": 1.7,
    "y-143": 1.7,
    "y-144": 1.7,
    "y-145": 1.7,
    "y-146": 1.698,
    "y-147": 1.698,
    "y-148": 1.698,
    "y-149": 1.698,
    "y-150": 1.698,
    "y-151": 1.698,
    "y-152": 1.698,
    "y-153": 1.698,
    "y-154": 1.694,
    "y-155": 1.694,
    "y-156": 1.694,
    "y-157": 1.693,
    "y-158": 1.693,
    "y-159": 1.693,
    "y-160": 1.693,
    "y-161": 1.693,
    "y-162": 1.693,
    "y-163": 1.693,
    "y-164": 1.693,
    "y-165": 1.693,
    "y-166": 1.693,
    "y-167": 1.693,
    "y-168": 1.693,
    "y-169": 1.693,
    "y-170": 1.693,
    "y-171": 1.693,
    "y-172": 1.674,
    "y-173": 1.674,
    "y-174": 1.674,
    "y-175": 1.674,
    "y-176": 1.674,
    "y-177": 1.674,
    "y-178": 1.674,
    "y-179": 1.674,
    "y-180": 1.674,
    "y-181": 1.674,
    "y-182": 1.674,
    "y-183": 1.674,
    "y-184": 1.674,
    "y-185": 1.674,
    "y-186": 1.674,
    "y-187": 1.674,
    "y-188": 1.674,
    "y-189": 1.674,
    "y-190": 1.674,
    "y-191": 1.674,
    "y-192": 1.674,
    "y-193": 1.674,
    "y-194": 1.674,
    "y-195": 1.674,
    "y-196": 1.702,
    "y-197": 1.702,
    "y-198": 1.702,
    "y-199": 1.702,
    "y-200": 1.702,
    "y-201": 1.702,
    "y-202": 1.702,
    "y-203": 1.702,
    "y-204": 1.702,
    "y-205": 1.702,
    "y-206": 1.702,
    "y-207": 1.702,
    "y-208": 1.702,
    "y-209": 1.702,
    "y-210": 1.684,
    "y-211": 1.684,
    "y-212": 1.684,
    "y-213": 1.684,
    "y-214": 1.684,
    "y-215": 1.684,
    "y-216": 1.684,
    "y-217": 1.684,
    "y-218": 1.684,
    "y-219": 1.684,
    "y-220": 1.682,
    "y-221": 1.682,
    "y-222": 1.682,
    "y-223": 1.687,
    "y-224": 1.687,
    "y-225": 1.687,
    "y-226": 1.687,
    "y-227": 1.687,
    "y-228": 1.687,
    "y-229": 1.687,
    "y-230": 1.687,
    "y-231": 1.687,
    "y-232": 1.687,
    "y-233": 1.684,
    "y-234": 1.684,
    "y-235": 1.684,
    "y-236": 1.684,
    "y-237": 1.684,
    "y-238": 1.684,
    "y-239": 1.684,
    "y-240": 1.684,
    "y-241": 1.684,
    "y-242": 1.684,
    "y-243": 1.684,
    "y-244": 1.684,
    "y-245": 1.684,
    "y-246": 1.684,
    "y-247": 1.684,
    "y-248": 1.684,
    "y-249": 1.684,
    "y-250": 1.684,
    "y-251": 1.684,
    "y-252": 1.684,
    "y-253": 1.684,
    "y-254": 1.684,
    "y-255": 1.684,
  },
  {
    x: -1.45,
    "y-2": 1.076,
    "y-12": 1.46,
    "y-46": 2.193,
    "y-1000": 2.254,
    "y-0": 0.811,
    "y-1": 1.14,
    "y-3": 0.663,
    "y-4": 1.246,
    "y-5": 1.204,
    "y-6": 1.399,
    "y-7": 1.458,
    "y-8": 1.458,
    "y-9": 1.46,
    "y-10": 1.46,
    "y-11": 1.46,
    "y-13": 1.46,
    "y-14": 1.46,
    "y-15": 1.46,
    "y-16": 1.623,
    "y-17": 1.623,
    "y-18": 1.623,
    "y-19": 1.757,
    "y-20": 1.757,
    "y-21": 1.948,
    "y-22": 3.687,
    "y-23": 3.687,
    "y-24": 3.687,
    "y-25": 3.687,
    "y-26": 3.687,
    "y-27": 3.687,
    "y-28": 3.687,
    "y-29": 3.687,
    "y-30": 3.687,
    "y-31": 3.687,
    "y-32": 3.687,
    "y-33": 3.687,
    "y-34": 3.687,
    "y-35": 3.687,
    "y-36": 3.687,
    "y-37": 3.687,
    "y-38": 3.687,
    "y-39": 2.063,
    "y-40": 2.065,
    "y-41": 2.064,
    "y-42": 2.066,
    "y-43": 2.066,
    "y-44": 2.064,
    "y-45": 2.066,
    "y-47": 2.199,
    "y-48": 2.197,
    "y-49": 2.196,
    "y-50": 2.196,
    "y-51": 2.321,
    "y-52": 2.318,
    "y-53": 2.314,
    "y-54": 2.309,
    "y-55": 2.303,
    "y-56": 2.311,
    "y-57": 2.311,
    "y-58": 2.297,
    "y-59": 2.307,
    "y-60": 2.307,
    "y-61": 2.306,
    "y-62": 2.305,
    "y-63": 2.306,
    "y-64": 2.302,
    "y-65": 2.302,
    "y-66": 2.301,
    "y-67": 2.301,
    "y-68": 2.299,
    "y-69": 2.299,
    "y-70": 2.3,
    "y-71": 2.3,
    "y-72": 2.302,
    "y-73": 2.302,
    "y-74": 2.325,
    "y-75": 2.322,
    "y-76": 2.324,
    "y-77": 2.322,
    "y-78": 2.321,
    "y-79": 2.323,
    "y-80": 2.323,
    "y-81": 2.323,
    "y-82": 2.322,
    "y-83": 2.33,
    "y-84": 2.331,
    "y-85": 2.332,
    "y-86": 2.33,
    "y-87": 2.331,
    "y-88": 2.329,
    "y-89": 2.31,
    "y-90": 2.309,
    "y-91": 2.31,
    "y-92": 2.31,
    "y-93": 2.309,
    "y-94": 2.309,
    "y-95": 2.309,
    "y-96": 2.308,
    "y-97": 2.31,
    "y-98": 2.309,
    "y-99": 2.308,
    "y-100": 2.307,
    "y-101": 2.309,
    "y-102": 2.309,
    "y-103": 2.308,
    "y-104": 2.309,
    "y-105": 2.309,
    "y-106": 2.308,
    "y-107": 2.309,
    "y-108": 2.312,
    "y-109": 2.312,
    "y-110": 2.313,
    "y-111": 2.315,
    "y-112": 2.315,
    "y-113": 2.315,
    "y-114": 2.316,
    "y-115": 2.316,
    "y-116": 2.315,
    "y-117": 2.316,
    "y-118": 2.316,
    "y-119": 2.315,
    "y-120": 2.315,
    "y-121": 2.315,
    "y-122": 2.316,
    "y-123": 2.315,
    "y-124": 2.315,
    "y-125": 2.315,
    "y-126": 2.317,
    "y-127": 2.291,
    "y-128": 2.291,
    "y-129": 2.291,
    "y-130": 2.291,
    "y-131": 2.291,
    "y-132": 2.291,
    "y-133": 2.291,
    "y-134": 2.291,
    "y-135": 2.291,
    "y-136": 2.291,
    "y-137": 2.291,
    "y-138": 2.291,
    "y-139": 2.291,
    "y-140": 2.291,
    "y-141": 2.291,
    "y-142": 2.291,
    "y-143": 2.291,
    "y-144": 2.291,
    "y-145": 2.291,
    "y-146": 2.287,
    "y-147": 2.287,
    "y-148": 2.287,
    "y-149": 2.287,
    "y-150": 2.287,
    "y-151": 2.287,
    "y-152": 2.287,
    "y-153": 2.287,
    "y-154": 2.28,
    "y-155": 2.28,
    "y-156": 2.28,
    "y-157": 2.279,
    "y-158": 2.279,
    "y-159": 2.279,
    "y-160": 2.279,
    "y-161": 2.279,
    "y-162": 2.279,
    "y-163": 2.279,
    "y-164": 2.279,
    "y-165": 2.279,
    "y-166": 2.279,
    "y-167": 2.279,
    "y-168": 2.279,
    "y-169": 2.279,
    "y-170": 2.279,
    "y-171": 2.279,
    "y-172": 2.244,
    "y-173": 2.244,
    "y-174": 2.244,
    "y-175": 2.244,
    "y-176": 2.244,
    "y-177": 2.244,
    "y-178": 2.244,
    "y-179": 2.244,
    "y-180": 2.244,
    "y-181": 2.244,
    "y-182": 2.244,
    "y-183": 2.244,
    "y-184": 2.244,
    "y-185": 2.244,
    "y-186": 2.244,
    "y-187": 2.244,
    "y-188": 2.244,
    "y-189": 2.244,
    "y-190": 2.244,
    "y-191": 2.244,
    "y-192": 2.244,
    "y-193": 2.244,
    "y-194": 2.244,
    "y-195": 2.244,
    "y-196": 2.31,
    "y-197": 2.31,
    "y-198": 2.31,
    "y-199": 2.31,
    "y-200": 2.31,
    "y-201": 2.31,
    "y-202": 2.31,
    "y-203": 2.31,
    "y-204": 2.31,
    "y-205": 2.31,
    "y-206": 2.31,
    "y-207": 2.31,
    "y-208": 2.31,
    "y-209": 2.31,
    "y-210": 2.276,
    "y-211": 2.276,
    "y-212": 2.276,
    "y-213": 2.276,
    "y-214": 2.276,
    "y-215": 2.276,
    "y-216": 2.276,
    "y-217": 2.276,
    "y-218": 2.276,
    "y-219": 2.276,
    "y-220": 2.272,
    "y-221": 2.272,
    "y-222": 2.272,
    "y-223": 2.282,
    "y-224": 2.282,
    "y-225": 2.282,
    "y-226": 2.282,
    "y-227": 2.282,
    "y-228": 2.282,
    "y-229": 2.282,
    "y-230": 2.282,
    "y-231": 2.282,
    "y-232": 2.282,
    "y-233": 2.275,
    "y-234": 2.275,
    "y-235": 2.275,
    "y-236": 2.275,
    "y-237": 2.275,
    "y-238": 2.275,
    "y-239": 2.275,
    "y-240": 2.275,
    "y-241": 2.275,
    "y-242": 2.275,
    "y-243": 2.275,
    "y-244": 2.275,
    "y-245": 2.275,
    "y-246": 2.275,
    "y-247": 2.275,
    "y-248": 2.275,
    "y-249": 2.275,
    "y-250": 2.275,
    "y-251": 2.275,
    "y-252": 2.275,
    "y-253": 2.275,
    "y-254": 2.275,
    "y-255": 2.275,
  },
  {
    x: -1.425,
    "y-2": 1.054,
    "y-12": 1.549,
    "y-46": 2.742,
    "y-1000": 2.73,
    "y-0": 0.799,
    "y-1": 1.116,
    "y-3": 0.706,
    "y-4": 1.37,
    "y-5": 1.324,
    "y-6": 1.474,
    "y-7": 1.548,
    "y-8": 1.548,
    "y-9": 1.549,
    "y-10": 1.549,
    "y-11": 1.549,
    "y-13": 1.549,
    "y-14": 1.549,
    "y-15": 1.549,
    "y-16": 1.753,
    "y-17": 1.753,
    "y-18": 1.753,
    "y-19": 1.841,
    "y-20": 1.841,
    "y-21": 1.989,
    "y-22": 3.356,
    "y-23": 3.356,
    "y-24": 3.356,
    "y-25": 3.356,
    "y-26": 3.356,
    "y-27": 3.356,
    "y-28": 3.356,
    "y-29": 3.356,
    "y-30": 3.356,
    "y-31": 3.356,
    "y-32": 3.356,
    "y-33": 3.356,
    "y-34": 3.356,
    "y-35": 3.356,
    "y-36": 3.356,
    "y-37": 3.356,
    "y-38": 3.356,
    "y-39": 2.544,
    "y-40": 2.545,
    "y-41": 2.545,
    "y-42": 2.546,
    "y-43": 2.546,
    "y-44": 2.545,
    "y-45": 2.546,
    "y-47": 2.749,
    "y-48": 2.747,
    "y-49": 2.746,
    "y-50": 2.747,
    "y-51": 2.937,
    "y-52": 2.931,
    "y-53": 2.925,
    "y-54": 2.918,
    "y-55": 2.909,
    "y-56": 2.921,
    "y-57": 2.92,
    "y-58": 2.9,
    "y-59": 2.915,
    "y-60": 2.914,
    "y-61": 2.912,
    "y-62": 2.912,
    "y-63": 2.913,
    "y-64": 2.906,
    "y-65": 2.906,
    "y-66": 2.905,
    "y-67": 2.905,
    "y-68": 2.903,
    "y-69": 2.903,
    "y-70": 2.904,
    "y-71": 2.904,
    "y-72": 2.906,
    "y-73": 2.907,
    "y-74": 2.915,
    "y-75": 2.912,
    "y-76": 2.914,
    "y-77": 2.912,
    "y-78": 2.912,
    "y-79": 2.912,
    "y-80": 2.913,
    "y-81": 2.913,
    "y-82": 2.912,
    "y-83": 2.916,
    "y-84": 2.917,
    "y-85": 2.917,
    "y-86": 2.916,
    "y-87": 2.916,
    "y-88": 2.916,
    "y-89": 2.891,
    "y-90": 2.89,
    "y-91": 2.891,
    "y-92": 2.89,
    "y-93": 2.89,
    "y-94": 2.89,
    "y-95": 2.89,
    "y-96": 2.889,
    "y-97": 2.891,
    "y-98": 2.89,
    "y-99": 2.889,
    "y-100": 2.887,
    "y-101": 2.89,
    "y-102": 2.891,
    "y-103": 2.889,
    "y-104": 2.89,
    "y-105": 2.89,
    "y-106": 2.888,
    "y-107": 2.89,
    "y-108": 2.891,
    "y-109": 2.892,
    "y-110": 2.892,
    "y-111": 2.893,
    "y-112": 2.893,
    "y-113": 2.893,
    "y-114": 2.893,
    "y-115": 2.893,
    "y-116": 2.893,
    "y-117": 2.893,
    "y-118": 2.893,
    "y-119": 2.893,
    "y-120": 2.893,
    "y-121": 2.892,
    "y-122": 2.893,
    "y-123": 2.893,
    "y-124": 2.893,
    "y-125": 2.893,
    "y-126": 2.894,
    "y-127": 2.862,
    "y-128": 2.862,
    "y-129": 2.862,
    "y-130": 2.862,
    "y-131": 2.862,
    "y-132": 2.862,
    "y-133": 2.862,
    "y-134": 2.862,
    "y-135": 2.862,
    "y-136": 2.862,
    "y-137": 2.862,
    "y-138": 2.862,
    "y-139": 2.862,
    "y-140": 2.862,
    "y-141": 2.862,
    "y-142": 2.862,
    "y-143": 2.862,
    "y-144": 2.862,
    "y-145": 2.862,
    "y-146": 2.858,
    "y-147": 2.858,
    "y-148": 2.858,
    "y-149": 2.858,
    "y-150": 2.858,
    "y-151": 2.858,
    "y-152": 2.858,
    "y-153": 2.858,
    "y-154": 2.849,
    "y-155": 2.849,
    "y-156": 2.849,
    "y-157": 2.848,
    "y-158": 2.848,
    "y-159": 2.848,
    "y-160": 2.848,
    "y-161": 2.848,
    "y-162": 2.848,
    "y-163": 2.848,
    "y-164": 2.848,
    "y-165": 2.848,
    "y-166": 2.848,
    "y-167": 2.848,
    "y-168": 2.848,
    "y-169": 2.848,
    "y-170": 2.848,
    "y-171": 2.848,
    "y-172": 2.806,
    "y-173": 2.806,
    "y-174": 2.806,
    "y-175": 2.806,
    "y-176": 2.806,
    "y-177": 2.806,
    "y-178": 2.806,
    "y-179": 2.806,
    "y-180": 2.806,
    "y-181": 2.806,
    "y-182": 2.806,
    "y-183": 2.806,
    "y-184": 2.806,
    "y-185": 2.806,
    "y-186": 2.806,
    "y-187": 2.806,
    "y-188": 2.806,
    "y-189": 2.806,
    "y-190": 2.806,
    "y-191": 2.806,
    "y-192": 2.806,
    "y-193": 2.806,
    "y-194": 2.806,
    "y-195": 2.806,
    "y-196": 2.865,
    "y-197": 2.865,
    "y-198": 2.865,
    "y-199": 2.865,
    "y-200": 2.865,
    "y-201": 2.865,
    "y-202": 2.865,
    "y-203": 2.865,
    "y-204": 2.865,
    "y-205": 2.865,
    "y-206": 2.865,
    "y-207": 2.865,
    "y-208": 2.865,
    "y-209": 2.865,
    "y-210": 2.827,
    "y-211": 2.827,
    "y-212": 2.827,
    "y-213": 2.827,
    "y-214": 2.827,
    "y-215": 2.827,
    "y-216": 2.827,
    "y-217": 2.827,
    "y-218": 2.827,
    "y-219": 2.827,
    "y-220": 2.822,
    "y-221": 2.822,
    "y-222": 2.822,
    "y-223": 2.825,
    "y-224": 2.825,
    "y-225": 2.825,
    "y-226": 2.825,
    "y-227": 2.825,
    "y-228": 2.825,
    "y-229": 2.825,
    "y-230": 2.825,
    "y-231": 2.825,
    "y-232": 2.825,
    "y-233": 2.819,
    "y-234": 2.819,
    "y-235": 2.819,
    "y-236": 2.819,
    "y-237": 2.819,
    "y-238": 2.819,
    "y-239": 2.819,
    "y-240": 2.819,
    "y-241": 2.819,
    "y-242": 2.819,
    "y-243": 2.819,
    "y-244": 2.819,
    "y-245": 2.819,
    "y-246": 2.819,
    "y-247": 2.819,
    "y-248": 2.819,
    "y-249": 2.819,
    "y-250": 2.819,
    "y-251": 2.819,
    "y-252": 2.819,
    "y-253": 2.819,
    "y-254": 2.819,
    "y-255": 2.819,
  },
  {
    x: -1.4,
    "y-2": 1.033,
    "y-12": 1.638,
    "y-46": 3.025,
    "y-1000": 3.025,
    "y-0": 0.787,
    "y-1": 1.091,
    "y-3": 0.749,
    "y-4": 1.494,
    "y-5": 1.445,
    "y-6": 1.55,
    "y-7": 1.637,
    "y-8": 1.637,
    "y-9": 1.638,
    "y-10": 1.638,
    "y-11": 1.638,
    "y-13": 1.638,
    "y-14": 1.638,
    "y-15": 1.638,
    "y-16": 1.882,
    "y-17": 1.882,
    "y-18": 1.882,
    "y-19": 1.925,
    "y-20": 1.925,
    "y-21": 2.03,
    "y-22": 3.025,
    "y-23": 3.025,
    "y-24": 3.025,
    "y-25": 3.025,
    "y-26": 3.025,
    "y-27": 3.025,
    "y-28": 3.025,
    "y-29": 3.025,
    "y-30": 3.025,
    "y-31": 3.025,
    "y-32": 3.025,
    "y-33": 3.025,
    "y-34": 3.025,
    "y-35": 3.025,
    "y-36": 3.025,
    "y-37": 3.025,
    "y-38": 3.025,
    "y-39": 3.025,
    "y-40": 3.025,
    "y-41": 3.025,
    "y-42": 3.025,
    "y-43": 3.025,
    "y-44": 3.025,
    "y-45": 3.025,
    "y-47": 3.025,
    "y-48": 3.025,
    "y-49": 3.025,
    "y-50": 3.025,
    "y-51": 3.025,
    "y-52": 3.025,
    "y-53": 3.025,
    "y-54": 3.025,
    "y-55": 3.025,
    "y-56": 3.025,
    "y-57": 3.025,
    "y-58": 3.025,
    "y-59": 3.025,
    "y-60": 3.025,
    "y-61": 3.025,
    "y-62": 3.025,
    "y-63": 3.025,
    "y-64": 3.025,
    "y-65": 3.025,
    "y-66": 3.025,
    "y-67": 3.025,
    "y-68": 3.025,
    "y-69": 3.025,
    "y-70": 3.025,
    "y-71": 3.025,
    "y-72": 3.025,
    "y-73": 3.025,
    "y-74": 3.025,
    "y-75": 3.025,
    "y-76": 3.025,
    "y-77": 3.025,
    "y-78": 3.025,
    "y-79": 3.025,
    "y-80": 3.025,
    "y-81": 3.025,
    "y-82": 3.025,
    "y-83": 3.025,
    "y-84": 3.025,
    "y-85": 3.025,
    "y-86": 3.025,
    "y-87": 3.025,
    "y-88": 3.025,
    "y-89": 3.025,
    "y-90": 3.025,
    "y-91": 3.025,
    "y-92": 3.025,
    "y-93": 3.025,
    "y-94": 3.025,
    "y-95": 3.025,
    "y-96": 3.025,
    "y-97": 3.025,
    "y-98": 3.025,
    "y-99": 3.025,
    "y-100": 3.025,
    "y-101": 3.025,
    "y-102": 3.025,
    "y-103": 3.025,
    "y-104": 3.025,
    "y-105": 3.025,
    "y-106": 3.025,
    "y-107": 3.025,
    "y-108": 3.025,
    "y-109": 3.025,
    "y-110": 3.025,
    "y-111": 3.025,
    "y-112": 3.025,
    "y-113": 3.025,
    "y-114": 3.025,
    "y-115": 3.025,
    "y-116": 3.025,
    "y-117": 3.025,
    "y-118": 3.025,
    "y-119": 3.025,
    "y-120": 3.025,
    "y-121": 3.025,
    "y-122": 3.025,
    "y-123": 3.025,
    "y-124": 3.025,
    "y-125": 3.025,
    "y-126": 3.025,
    "y-127": 3.025,
    "y-128": 3.025,
    "y-129": 3.025,
    "y-130": 3.025,
    "y-131": 3.025,
    "y-132": 3.025,
    "y-133": 3.025,
    "y-134": 3.025,
    "y-135": 3.025,
    "y-136": 3.025,
    "y-137": 3.025,
    "y-138": 3.025,
    "y-139": 3.025,
    "y-140": 3.025,
    "y-141": 3.025,
    "y-142": 3.025,
    "y-143": 3.025,
    "y-144": 3.025,
    "y-145": 3.025,
    "y-146": 3.025,
    "y-147": 3.025,
    "y-148": 3.025,
    "y-149": 3.025,
    "y-150": 3.025,
    "y-151": 3.025,
    "y-152": 3.025,
    "y-153": 3.025,
    "y-154": 3.025,
    "y-155": 3.025,
    "y-156": 3.025,
    "y-157": 3.025,
    "y-158": 3.025,
    "y-159": 3.025,
    "y-160": 3.025,
    "y-161": 3.025,
    "y-162": 3.025,
    "y-163": 3.025,
    "y-164": 3.025,
    "y-165": 3.025,
    "y-166": 3.025,
    "y-167": 3.025,
    "y-168": 3.025,
    "y-169": 3.025,
    "y-170": 3.025,
    "y-171": 3.025,
    "y-172": 3.025,
    "y-173": 3.025,
    "y-174": 3.025,
    "y-175": 3.025,
    "y-176": 3.025,
    "y-177": 3.025,
    "y-178": 3.025,
    "y-179": 3.025,
    "y-180": 3.025,
    "y-181": 3.025,
    "y-182": 3.025,
    "y-183": 3.025,
    "y-184": 3.025,
    "y-185": 3.025,
    "y-186": 3.025,
    "y-187": 3.025,
    "y-188": 3.025,
    "y-189": 3.025,
    "y-190": 3.025,
    "y-191": 3.025,
    "y-192": 3.025,
    "y-193": 3.025,
    "y-194": 3.025,
    "y-195": 3.025,
    "y-196": 3.025,
    "y-197": 3.025,
    "y-198": 3.025,
    "y-199": 3.025,
    "y-200": 3.025,
    "y-201": 3.025,
    "y-202": 3.025,
    "y-203": 3.025,
    "y-204": 3.025,
    "y-205": 3.025,
    "y-206": 3.025,
    "y-207": 3.025,
    "y-208": 3.025,
    "y-209": 3.025,
    "y-210": 3.025,
    "y-211": 3.025,
    "y-212": 3.025,
    "y-213": 3.025,
    "y-214": 3.025,
    "y-215": 3.025,
    "y-216": 3.025,
    "y-217": 3.025,
    "y-218": 3.025,
    "y-219": 3.025,
    "y-220": 3.025,
    "y-221": 3.025,
    "y-222": 3.025,
    "y-223": 3.025,
    "y-224": 3.025,
    "y-225": 3.025,
    "y-226": 3.025,
    "y-227": 3.025,
    "y-228": 3.025,
    "y-229": 3.025,
    "y-230": 3.025,
    "y-231": 3.025,
    "y-232": 3.025,
    "y-233": 3.025,
    "y-234": 3.025,
    "y-235": 3.025,
    "y-236": 3.025,
    "y-237": 3.025,
    "y-238": 3.025,
    "y-239": 3.025,
    "y-240": 3.025,
    "y-241": 3.025,
    "y-242": 3.025,
    "y-243": 3.025,
    "y-244": 3.025,
    "y-245": 3.025,
    "y-246": 3.025,
    "y-247": 3.025,
    "y-248": 3.025,
    "y-249": 3.025,
    "y-250": 3.025,
    "y-251": 3.025,
    "y-252": 3.025,
    "y-253": 3.025,
    "y-254": 3.025,
    "y-255": 3.025,
  },
  {
    x: -1.375,
    "y-2": 1.012,
    "y-12": 1.727,
    "y-46": 2.791,
    "y-1000": 2.998,
    "y-0": 0.775,
    "y-1": 1.066,
    "y-3": 0.792,
    "y-4": 1.618,
    "y-5": 1.566,
    "y-6": 1.625,
    "y-7": 1.727,
    "y-8": 1.727,
    "y-9": 1.727,
    "y-10": 1.727,
    "y-11": 1.727,
    "y-13": 1.727,
    "y-14": 1.727,
    "y-15": 1.727,
    "y-16": 2.012,
    "y-17": 2.012,
    "y-18": 2.012,
    "y-19": 2.009,
    "y-20": 2.009,
    "y-21": 2.071,
    "y-22": 2.695,
    "y-23": 2.695,
    "y-24": 2.695,
    "y-25": 2.695,
    "y-26": 2.695,
    "y-27": 2.695,
    "y-28": 2.695,
    "y-29": 2.695,
    "y-30": 2.695,
    "y-31": 2.695,
    "y-32": 2.695,
    "y-33": 2.695,
    "y-34": 2.695,
    "y-35": 2.695,
    "y-36": 2.695,
    "y-37": 2.695,
    "y-38": 2.695,
    "y-39": 3.507,
    "y-40": 3.506,
    "y-41": 3.506,
    "y-42": 3.505,
    "y-43": 3.505,
    "y-44": 3.506,
    "y-45": 3.505,
    "y-47": 2.766,
    "y-48": 2.773,
    "y-49": 2.776,
    "y-50": 2.773,
    "y-51": 2.722,
    "y-52": 2.704,
    "y-53": 2.722,
    "y-54": 2.743,
    "y-55": 2.759,
    "y-56": 2.724,
    "y-57": 2.752,
    "y-58": 2.769,
    "y-59": 2.756,
    "y-60": 2.759,
    "y-61": 2.763,
    "y-62": 2.761,
    "y-63": 2.759,
    "y-64": 2.775,
    "y-65": 2.775,
    "y-66": 2.777,
    "y-67": 2.775,
    "y-68": 2.78,
    "y-69": 2.78,
    "y-70": 2.777,
    "y-71": 2.779,
    "y-72": 2.775,
    "y-73": 2.772,
    "y-74": 2.77,
    "y-75": 2.773,
    "y-76": 2.77,
    "y-77": 2.772,
    "y-78": 2.772,
    "y-79": 2.773,
    "y-80": 2.773,
    "y-81": 2.772,
    "y-82": 2.772,
    "y-83": 2.77,
    "y-84": 2.77,
    "y-85": 2.77,
    "y-86": 2.771,
    "y-87": 2.771,
    "y-88": 2.771,
    "y-89": 2.818,
    "y-90": 2.821,
    "y-91": 2.819,
    "y-92": 2.822,
    "y-93": 2.819,
    "y-94": 2.822,
    "y-95": 2.82,
    "y-96": 2.821,
    "y-97": 2.819,
    "y-98": 2.82,
    "y-99": 2.82,
    "y-100": 2.823,
    "y-101": 2.82,
    "y-102": 2.819,
    "y-103": 2.821,
    "y-104": 2.821,
    "y-105": 2.82,
    "y-106": 2.821,
    "y-107": 2.82,
    "y-108": 2.819,
    "y-109": 2.819,
    "y-110": 2.819,
    "y-111": 2.818,
    "y-112": 2.818,
    "y-113": 2.818,
    "y-114": 2.818,
    "y-115": 2.818,
    "y-116": 2.818,
    "y-117": 2.818,
    "y-118": 2.818,
    "y-119": 2.818,
    "y-120": 2.819,
    "y-121": 2.819,
    "y-122": 2.818,
    "y-123": 2.819,
    "y-124": 2.818,
    "y-125": 2.818,
    "y-126": 2.818,
    "y-127": 2.876,
    "y-128": 2.876,
    "y-129": 2.876,
    "y-130": 2.876,
    "y-131": 2.876,
    "y-132": 2.876,
    "y-133": 2.876,
    "y-134": 2.876,
    "y-135": 2.876,
    "y-136": 2.876,
    "y-137": 2.876,
    "y-138": 2.876,
    "y-139": 2.876,
    "y-140": 2.876,
    "y-141": 2.876,
    "y-142": 2.876,
    "y-143": 2.876,
    "y-144": 2.876,
    "y-145": 2.876,
    "y-146": 2.885,
    "y-147": 2.885,
    "y-148": 2.885,
    "y-149": 2.885,
    "y-150": 2.885,
    "y-151": 2.885,
    "y-152": 2.885,
    "y-153": 2.885,
    "y-154": 2.902,
    "y-155": 2.902,
    "y-156": 2.902,
    "y-157": 2.903,
    "y-158": 2.903,
    "y-159": 2.903,
    "y-160": 2.903,
    "y-161": 2.903,
    "y-162": 2.903,
    "y-163": 2.903,
    "y-164": 2.903,
    "y-165": 2.903,
    "y-166": 2.903,
    "y-167": 2.903,
    "y-168": 2.903,
    "y-169": 2.903,
    "y-170": 2.903,
    "y-171": 2.903,
    "y-172": 2.98,
    "y-173": 2.98,
    "y-174": 2.98,
    "y-175": 2.98,
    "y-176": 2.98,
    "y-177": 2.98,
    "y-178": 2.98,
    "y-179": 2.98,
    "y-180": 2.981,
    "y-181": 2.981,
    "y-182": 2.981,
    "y-183": 2.981,
    "y-184": 2.981,
    "y-185": 2.981,
    "y-186": 2.981,
    "y-187": 2.981,
    "y-188": 2.981,
    "y-189": 2.981,
    "y-190": 2.981,
    "y-191": 2.981,
    "y-192": 2.981,
    "y-193": 2.981,
    "y-194": 2.981,
    "y-195": 2.981,
    "y-196": 2.947,
    "y-197": 2.947,
    "y-198": 2.947,
    "y-199": 2.947,
    "y-200": 2.947,
    "y-201": 2.947,
    "y-202": 2.947,
    "y-203": 2.947,
    "y-204": 2.947,
    "y-205": 2.947,
    "y-206": 2.947,
    "y-207": 2.947,
    "y-208": 2.947,
    "y-209": 2.947,
    "y-210": 3.007,
    "y-211": 3.007,
    "y-212": 3.007,
    "y-213": 3.007,
    "y-214": 3.007,
    "y-215": 3.007,
    "y-216": 3.007,
    "y-217": 3.007,
    "y-218": 3.007,
    "y-219": 3.007,
    "y-220": 3.015,
    "y-221": 3.015,
    "y-222": 3.015,
    "y-223": 3.013,
    "y-224": 3.013,
    "y-225": 3.013,
    "y-226": 3.013,
    "y-227": 3.013,
    "y-228": 3.013,
    "y-229": 3.013,
    "y-230": 3.013,
    "y-231": 3.013,
    "y-232": 3.013,
    "y-233": 3.023,
    "y-234": 3.023,
    "y-235": 3.023,
    "y-236": 3.023,
    "y-237": 3.023,
    "y-238": 3.023,
    "y-239": 3.023,
    "y-240": 3.023,
    "y-241": 3.023,
    "y-242": 3.023,
    "y-243": 3.023,
    "y-244": 3.023,
    "y-245": 3.023,
    "y-246": 3.023,
    "y-247": 3.023,
    "y-248": 3.023,
    "y-249": 3.023,
    "y-250": 3.023,
    "y-251": 3.023,
    "y-252": 3.023,
    "y-253": 3.023,
    "y-254": 3.023,
    "y-255": 3.023,
  },
  {
    x: -1.35,
    "y-2": 0.991,
    "y-12": 1.816,
    "y-46": 2.543,
    "y-1000": 2.635,
    "y-0": 0.762,
    "y-1": 1.042,
    "y-3": 0.835,
    "y-4": 1.742,
    "y-5": 1.687,
    "y-6": 1.7,
    "y-7": 1.816,
    "y-8": 1.816,
    "y-9": 1.816,
    "y-10": 1.816,
    "y-11": 1.816,
    "y-13": 1.816,
    "y-14": 1.816,
    "y-15": 1.816,
    "y-16": 2.142,
    "y-17": 2.142,
    "y-18": 2.142,
    "y-19": 2.093,
    "y-20": 2.093,
    "y-21": 2.112,
    "y-22": 2.364,
    "y-23": 2.364,
    "y-24": 2.364,
    "y-25": 2.364,
    "y-26": 2.364,
    "y-27": 2.364,
    "y-28": 2.364,
    "y-29": 2.364,
    "y-30": 2.364,
    "y-31": 2.364,
    "y-32": 2.364,
    "y-33": 2.364,
    "y-34": 2.364,
    "y-35": 2.364,
    "y-36": 2.364,
    "y-37": 2.364,
    "y-38": 2.364,
    "y-39": 3.876,
    "y-40": 3.875,
    "y-41": 3.875,
    "y-42": 3.874,
    "y-43": 3.874,
    "y-44": 3.875,
    "y-45": 3.874,
    "y-47": 2.496,
    "y-48": 2.509,
    "y-49": 2.515,
    "y-50": 2.51,
    "y-51": 2.415,
    "y-52": 2.381,
    "y-53": 2.415,
    "y-54": 2.425,
    "y-55": 2.448,
    "y-56": 2.398,
    "y-57": 2.434,
    "y-58": 2.472,
    "y-59": 2.443,
    "y-60": 2.45,
    "y-61": 2.456,
    "y-62": 2.454,
    "y-63": 2.45,
    "y-64": 2.457,
    "y-65": 2.456,
    "y-66": 2.459,
    "y-67": 2.456,
    "y-68": 2.463,
    "y-69": 2.463,
    "y-70": 2.46,
    "y-71": 2.462,
    "y-72": 2.446,
    "y-73": 2.441,
    "y-74": 2.436,
    "y-75": 2.443,
    "y-76": 2.438,
    "y-77": 2.442,
    "y-78": 2.44,
    "y-79": 2.442,
    "y-80": 2.443,
    "y-81": 2.44,
    "y-82": 2.442,
    "y-83": 2.439,
    "y-84": 2.438,
    "y-85": 2.438,
    "y-86": 2.439,
    "y-87": 2.439,
    "y-88": 2.439,
    "y-89": 2.49,
    "y-90": 2.496,
    "y-91": 2.493,
    "y-92": 2.496,
    "y-93": 2.492,
    "y-94": 2.497,
    "y-95": 2.495,
    "y-96": 2.496,
    "y-97": 2.491,
    "y-98": 2.494,
    "y-99": 2.495,
    "y-100": 2.499,
    "y-101": 2.494,
    "y-102": 2.492,
    "y-103": 2.497,
    "y-104": 2.495,
    "y-105": 2.494,
    "y-106": 2.495,
    "y-107": 2.494,
    "y-108": 2.493,
    "y-109": 2.493,
    "y-110": 2.493,
    "y-111": 2.491,
    "y-112": 2.492,
    "y-113": 2.492,
    "y-114": 2.491,
    "y-115": 2.491,
    "y-116": 2.491,
    "y-117": 2.491,
    "y-118": 2.492,
    "y-119": 2.492,
    "y-120": 2.493,
    "y-121": 2.493,
    "y-122": 2.492,
    "y-123": 2.492,
    "y-124": 2.492,
    "y-125": 2.492,
    "y-126": 2.491,
    "y-127": 2.526,
    "y-128": 2.526,
    "y-129": 2.526,
    "y-130": 2.526,
    "y-131": 2.526,
    "y-132": 2.526,
    "y-133": 2.526,
    "y-134": 2.526,
    "y-135": 2.526,
    "y-136": 2.526,
    "y-137": 2.526,
    "y-138": 2.526,
    "y-139": 2.526,
    "y-140": 2.526,
    "y-141": 2.526,
    "y-142": 2.526,
    "y-143": 2.526,
    "y-144": 2.526,
    "y-145": 2.526,
    "y-146": 2.525,
    "y-147": 2.525,
    "y-148": 2.525,
    "y-149": 2.525,
    "y-150": 2.525,
    "y-151": 2.525,
    "y-152": 2.525,
    "y-153": 2.525,
    "y-154": 2.556,
    "y-155": 2.556,
    "y-156": 2.556,
    "y-157": 2.558,
    "y-158": 2.559,
    "y-159": 2.559,
    "y-160": 2.559,
    "y-161": 2.559,
    "y-162": 2.559,
    "y-163": 2.559,
    "y-164": 2.559,
    "y-165": 2.558,
    "y-166": 2.558,
    "y-167": 2.558,
    "y-168": 2.558,
    "y-169": 2.558,
    "y-170": 2.558,
    "y-171": 2.558,
    "y-172": 2.701,
    "y-173": 2.701,
    "y-174": 2.701,
    "y-175": 2.701,
    "y-176": 2.701,
    "y-177": 2.701,
    "y-178": 2.701,
    "y-179": 2.701,
    "y-180": 2.703,
    "y-181": 2.703,
    "y-182": 2.703,
    "y-183": 2.703,
    "y-184": 2.703,
    "y-185": 2.703,
    "y-186": 2.703,
    "y-187": 2.703,
    "y-188": 2.703,
    "y-189": 2.703,
    "y-190": 2.703,
    "y-191": 2.703,
    "y-192": 2.703,
    "y-193": 2.703,
    "y-194": 2.703,
    "y-195": 2.703,
    "y-196": 2.657,
    "y-197": 2.657,
    "y-198": 2.657,
    "y-199": 2.657,
    "y-200": 2.657,
    "y-201": 2.657,
    "y-202": 2.657,
    "y-203": 2.657,
    "y-204": 2.657,
    "y-205": 2.657,
    "y-206": 2.657,
    "y-207": 2.657,
    "y-208": 2.657,
    "y-209": 2.657,
    "y-210": 2.678,
    "y-211": 2.678,
    "y-212": 2.678,
    "y-213": 2.678,
    "y-214": 2.678,
    "y-215": 2.678,
    "y-216": 2.678,
    "y-217": 2.678,
    "y-218": 2.678,
    "y-219": 2.678,
    "y-220": 2.692,
    "y-221": 2.692,
    "y-222": 2.692,
    "y-223": 2.69,
    "y-224": 2.69,
    "y-225": 2.69,
    "y-226": 2.69,
    "y-227": 2.69,
    "y-228": 2.69,
    "y-229": 2.69,
    "y-230": 2.69,
    "y-231": 2.69,
    "y-232": 2.69,
    "y-233": 2.708,
    "y-234": 2.708,
    "y-235": 2.708,
    "y-236": 2.708,
    "y-237": 2.708,
    "y-238": 2.708,
    "y-239": 2.708,
    "y-240": 2.708,
    "y-241": 2.708,
    "y-242": 2.708,
    "y-243": 2.708,
    "y-244": 2.708,
    "y-245": 2.708,
    "y-246": 2.708,
    "y-247": 2.708,
    "y-248": 2.708,
    "y-249": 2.708,
    "y-250": 2.708,
    "y-251": 2.708,
    "y-252": 2.708,
    "y-253": 2.708,
    "y-254": 2.708,
    "y-255": 2.708,
  },
  {
    x: -1.325,
    "y-2": 0.969,
    "y-12": 1.905,
    "y-46": 2.123,
    "y-1000": 2.108,
    "y-0": 0.75,
    "y-1": 1.017,
    "y-3": 0.878,
    "y-4": 1.866,
    "y-5": 1.808,
    "y-6": 1.776,
    "y-7": 1.905,
    "y-8": 1.905,
    "y-9": 1.905,
    "y-10": 1.905,
    "y-11": 1.905,
    "y-13": 1.905,
    "y-14": 1.905,
    "y-15": 1.905,
    "y-16": 2.272,
    "y-17": 2.272,
    "y-18": 2.272,
    "y-19": 2.177,
    "y-20": 2.177,
    "y-21": 2.153,
    "y-22": 2.034,
    "y-23": 2.034,
    "y-24": 2.034,
    "y-25": 2.034,
    "y-26": 2.034,
    "y-27": 2.034,
    "y-28": 2.034,
    "y-29": 2.034,
    "y-30": 2.034,
    "y-31": 2.034,
    "y-32": 2.034,
    "y-33": 2.034,
    "y-34": 2.034,
    "y-35": 2.034,
    "y-36": 2.034,
    "y-37": 2.034,
    "y-38": 2.034,
    "y-39": 2.79,
    "y-40": 2.789,
    "y-41": 2.789,
    "y-42": 2.788,
    "y-43": 2.789,
    "y-44": 2.789,
    "y-45": 2.788,
    "y-47": 2.1,
    "y-48": 2.106,
    "y-49": 2.109,
    "y-50": 2.107,
    "y-51": 2.059,
    "y-52": 2.042,
    "y-53": 2.059,
    "y-54": 2.064,
    "y-55": 2.075,
    "y-56": 2.05,
    "y-57": 2.069,
    "y-58": 2.087,
    "y-59": 2.073,
    "y-60": 2.076,
    "y-61": 2.079,
    "y-62": 2.078,
    "y-63": 2.076,
    "y-64": 1.979,
    "y-65": 1.978,
    "y-66": 1.979,
    "y-67": 1.978,
    "y-68": 1.984,
    "y-69": 1.985,
    "y-70": 1.983,
    "y-71": 1.984,
    "y-72": 1.951,
    "y-73": 1.948,
    "y-74": 1.944,
    "y-75": 1.951,
    "y-76": 1.947,
    "y-77": 1.95,
    "y-78": 1.949,
    "y-79": 1.95,
    "y-80": 1.95,
    "y-81": 1.95,
    "y-82": 1.95,
    "y-83": 1.949,
    "y-84": 1.947,
    "y-85": 1.947,
    "y-86": 1.95,
    "y-87": 1.949,
    "y-88": 1.949,
    "y-89": 1.958,
    "y-90": 1.964,
    "y-91": 1.961,
    "y-92": 1.963,
    "y-93": 1.961,
    "y-94": 1.965,
    "y-95": 1.964,
    "y-96": 1.963,
    "y-97": 1.959,
    "y-98": 1.962,
    "y-99": 1.962,
    "y-100": 1.967,
    "y-101": 1.961,
    "y-102": 1.961,
    "y-103": 1.965,
    "y-104": 1.963,
    "y-105": 1.962,
    "y-106": 1.962,
    "y-107": 1.962,
    "y-108": 1.962,
    "y-109": 1.962,
    "y-110": 1.961,
    "y-111": 1.961,
    "y-112": 1.961,
    "y-113": 1.961,
    "y-114": 1.961,
    "y-115": 1.961,
    "y-116": 1.961,
    "y-117": 1.96,
    "y-118": 1.961,
    "y-119": 1.961,
    "y-120": 1.962,
    "y-121": 1.962,
    "y-122": 1.961,
    "y-123": 1.962,
    "y-124": 1.962,
    "y-125": 1.962,
    "y-126": 1.961,
    "y-127": 1.966,
    "y-128": 1.966,
    "y-129": 1.966,
    "y-130": 1.966,
    "y-131": 1.966,
    "y-132": 1.966,
    "y-133": 1.966,
    "y-134": 1.966,
    "y-135": 1.966,
    "y-136": 1.966,
    "y-137": 1.966,
    "y-138": 1.966,
    "y-139": 1.966,
    "y-140": 1.966,
    "y-141": 1.966,
    "y-142": 1.966,
    "y-143": 1.966,
    "y-144": 1.966,
    "y-145": 1.966,
    "y-146": 1.935,
    "y-147": 1.935,
    "y-148": 1.935,
    "y-149": 1.935,
    "y-150": 1.935,
    "y-151": 1.935,
    "y-152": 1.935,
    "y-153": 1.935,
    "y-154": 1.967,
    "y-155": 1.967,
    "y-156": 1.967,
    "y-157": 1.97,
    "y-158": 1.97,
    "y-159": 1.97,
    "y-160": 1.97,
    "y-161": 1.97,
    "y-162": 1.97,
    "y-163": 1.97,
    "y-164": 1.97,
    "y-165": 1.97,
    "y-166": 1.97,
    "y-167": 1.97,
    "y-168": 1.97,
    "y-169": 1.97,
    "y-170": 1.97,
    "y-171": 1.97,
    "y-172": 2.119,
    "y-173": 2.119,
    "y-174": 2.119,
    "y-175": 2.119,
    "y-176": 2.119,
    "y-177": 2.119,
    "y-178": 2.119,
    "y-179": 2.119,
    "y-180": 2.12,
    "y-181": 2.12,
    "y-182": 2.12,
    "y-183": 2.12,
    "y-184": 2.12,
    "y-185": 2.12,
    "y-186": 2.12,
    "y-187": 2.12,
    "y-188": 2.12,
    "y-189": 2.12,
    "y-190": 2.12,
    "y-191": 2.12,
    "y-192": 2.12,
    "y-193": 2.12,
    "y-194": 2.12,
    "y-195": 2.12,
    "y-196": 2.097,
    "y-197": 2.097,
    "y-198": 2.097,
    "y-199": 2.097,
    "y-200": 2.097,
    "y-201": 2.097,
    "y-202": 2.097,
    "y-203": 2.097,
    "y-204": 2.097,
    "y-205": 2.097,
    "y-206": 2.097,
    "y-207": 2.097,
    "y-208": 2.097,
    "y-209": 2.097,
    "y-210": 2.096,
    "y-211": 2.096,
    "y-212": 2.096,
    "y-213": 2.096,
    "y-214": 2.096,
    "y-215": 2.096,
    "y-216": 2.096,
    "y-217": 2.096,
    "y-218": 2.096,
    "y-219": 2.096,
    "y-220": 2.111,
    "y-221": 2.111,
    "y-222": 2.111,
    "y-223": 2.11,
    "y-224": 2.11,
    "y-225": 2.11,
    "y-226": 2.11,
    "y-227": 2.11,
    "y-228": 2.11,
    "y-229": 2.11,
    "y-230": 2.11,
    "y-231": 2.11,
    "y-232": 2.11,
    "y-233": 2.128,
    "y-234": 2.128,
    "y-235": 2.128,
    "y-236": 2.128,
    "y-237": 2.128,
    "y-238": 2.128,
    "y-239": 2.128,
    "y-240": 2.128,
    "y-241": 2.128,
    "y-242": 2.128,
    "y-243": 2.128,
    "y-244": 2.128,
    "y-245": 2.128,
    "y-246": 2.128,
    "y-247": 2.128,
    "y-248": 2.128,
    "y-249": 2.128,
    "y-250": 2.128,
    "y-251": 2.128,
    "y-252": 2.128,
    "y-253": 2.128,
    "y-254": 2.128,
    "y-255": 2.128,
  },
  {
    x: -1.3,
    "y-2": 0.948,
    "y-12": 1.994,
    "y-46": 1.703,
    "y-1000": 1.703,
    "y-0": 0.738,
    "y-1": 0.993,
    "y-3": 0.921,
    "y-4": 1.99,
    "y-5": 1.928,
    "y-6": 1.851,
    "y-7": 1.995,
    "y-8": 1.995,
    "y-9": 1.994,
    "y-10": 1.994,
    "y-11": 1.994,
    "y-13": 1.994,
    "y-14": 1.994,
    "y-15": 1.994,
    "y-16": 2.401,
    "y-17": 2.401,
    "y-18": 2.401,
    "y-19": 2.261,
    "y-20": 2.261,
    "y-21": 2.194,
    "y-22": 1.703,
    "y-23": 1.703,
    "y-24": 1.703,
    "y-25": 1.703,
    "y-26": 1.703,
    "y-27": 1.703,
    "y-28": 1.703,
    "y-29": 1.703,
    "y-30": 1.703,
    "y-31": 1.703,
    "y-32": 1.703,
    "y-33": 1.703,
    "y-34": 1.703,
    "y-35": 1.703,
    "y-36": 1.703,
    "y-37": 1.703,
    "y-38": 1.703,
    "y-39": 1.703,
    "y-40": 1.703,
    "y-41": 1.703,
    "y-42": 1.703,
    "y-43": 1.703,
    "y-44": 1.703,
    "y-45": 1.703,
    "y-47": 1.703,
    "y-48": 1.703,
    "y-49": 1.703,
    "y-50": 1.703,
    "y-51": 1.703,
    "y-52": 1.703,
    "y-53": 1.703,
    "y-54": 1.703,
    "y-55": 1.703,
    "y-56": 1.703,
    "y-57": 1.703,
    "y-58": 1.703,
    "y-59": 1.703,
    "y-60": 1.703,
    "y-61": 1.703,
    "y-62": 1.703,
    "y-63": 1.703,
    "y-64": 1.703,
    "y-65": 1.703,
    "y-66": 1.703,
    "y-67": 1.703,
    "y-68": 1.703,
    "y-69": 1.703,
    "y-70": 1.703,
    "y-71": 1.703,
    "y-72": 1.703,
    "y-73": 1.703,
    "y-74": 1.703,
    "y-75": 1.703,
    "y-76": 1.703,
    "y-77": 1.703,
    "y-78": 1.703,
    "y-79": 1.703,
    "y-80": 1.703,
    "y-81": 1.703,
    "y-82": 1.703,
    "y-83": 1.703,
    "y-84": 1.703,
    "y-85": 1.703,
    "y-86": 1.703,
    "y-87": 1.703,
    "y-88": 1.703,
    "y-89": 1.703,
    "y-90": 1.703,
    "y-91": 1.703,
    "y-92": 1.703,
    "y-93": 1.703,
    "y-94": 1.703,
    "y-95": 1.703,
    "y-96": 1.703,
    "y-97": 1.703,
    "y-98": 1.703,
    "y-99": 1.703,
    "y-100": 1.703,
    "y-101": 1.703,
    "y-102": 1.703,
    "y-103": 1.703,
    "y-104": 1.703,
    "y-105": 1.703,
    "y-106": 1.703,
    "y-107": 1.703,
    "y-108": 1.703,
    "y-109": 1.703,
    "y-110": 1.703,
    "y-111": 1.703,
    "y-112": 1.703,
    "y-113": 1.703,
    "y-114": 1.703,
    "y-115": 1.703,
    "y-116": 1.703,
    "y-117": 1.703,
    "y-118": 1.703,
    "y-119": 1.703,
    "y-120": 1.703,
    "y-121": 1.703,
    "y-122": 1.703,
    "y-123": 1.703,
    "y-124": 1.703,
    "y-125": 1.703,
    "y-126": 1.703,
    "y-127": 1.703,
    "y-128": 1.703,
    "y-129": 1.703,
    "y-130": 1.703,
    "y-131": 1.703,
    "y-132": 1.703,
    "y-133": 1.703,
    "y-134": 1.703,
    "y-135": 1.703,
    "y-136": 1.703,
    "y-137": 1.703,
    "y-138": 1.703,
    "y-139": 1.703,
    "y-140": 1.703,
    "y-141": 1.703,
    "y-142": 1.703,
    "y-143": 1.703,
    "y-144": 1.703,
    "y-145": 1.703,
    "y-146": 1.703,
    "y-147": 1.703,
    "y-148": 1.703,
    "y-149": 1.703,
    "y-150": 1.703,
    "y-151": 1.703,
    "y-152": 1.703,
    "y-153": 1.703,
    "y-154": 1.703,
    "y-155": 1.703,
    "y-156": 1.703,
    "y-157": 1.703,
    "y-158": 1.703,
    "y-159": 1.703,
    "y-160": 1.703,
    "y-161": 1.703,
    "y-162": 1.703,
    "y-163": 1.703,
    "y-164": 1.703,
    "y-165": 1.703,
    "y-166": 1.703,
    "y-167": 1.703,
    "y-168": 1.703,
    "y-169": 1.703,
    "y-170": 1.703,
    "y-171": 1.703,
    "y-172": 1.703,
    "y-173": 1.703,
    "y-174": 1.703,
    "y-175": 1.703,
    "y-176": 1.703,
    "y-177": 1.703,
    "y-178": 1.703,
    "y-179": 1.703,
    "y-180": 1.703,
    "y-181": 1.703,
    "y-182": 1.703,
    "y-183": 1.703,
    "y-184": 1.703,
    "y-185": 1.703,
    "y-186": 1.703,
    "y-187": 1.703,
    "y-188": 1.703,
    "y-189": 1.703,
    "y-190": 1.703,
    "y-191": 1.703,
    "y-192": 1.703,
    "y-193": 1.703,
    "y-194": 1.703,
    "y-195": 1.703,
    "y-196": 1.703,
    "y-197": 1.703,
    "y-198": 1.703,
    "y-199": 1.703,
    "y-200": 1.703,
    "y-201": 1.703,
    "y-202": 1.703,
    "y-203": 1.703,
    "y-204": 1.703,
    "y-205": 1.703,
    "y-206": 1.703,
    "y-207": 1.703,
    "y-208": 1.703,
    "y-209": 1.703,
    "y-210": 1.703,
    "y-211": 1.703,
    "y-212": 1.703,
    "y-213": 1.703,
    "y-214": 1.703,
    "y-215": 1.703,
    "y-216": 1.703,
    "y-217": 1.703,
    "y-218": 1.703,
    "y-219": 1.703,
    "y-220": 1.703,
    "y-221": 1.703,
    "y-222": 1.703,
    "y-223": 1.703,
    "y-224": 1.703,
    "y-225": 1.703,
    "y-226": 1.703,
    "y-227": 1.703,
    "y-228": 1.703,
    "y-229": 1.703,
    "y-230": 1.703,
    "y-231": 1.703,
    "y-232": 1.703,
    "y-233": 1.703,
    "y-234": 1.703,
    "y-235": 1.703,
    "y-236": 1.703,
    "y-237": 1.703,
    "y-238": 1.703,
    "y-239": 1.703,
    "y-240": 1.703,
    "y-241": 1.703,
    "y-242": 1.703,
    "y-243": 1.703,
    "y-244": 1.703,
    "y-245": 1.703,
    "y-246": 1.703,
    "y-247": 1.703,
    "y-248": 1.703,
    "y-249": 1.703,
    "y-250": 1.703,
    "y-251": 1.703,
    "y-252": 1.703,
    "y-253": 1.703,
    "y-254": 1.703,
    "y-255": 1.703,
  },
  {
    x: -1.275,
    "y-2": 0.927,
    "y-12": 2.083,
    "y-46": 1.51,
    "y-1000": 1.59,
    "y-0": 0.726,
    "y-1": 0.968,
    "y-3": 0.964,
    "y-4": 2.115,
    "y-5": 2.049,
    "y-6": 1.926,
    "y-7": 2.084,
    "y-8": 2.084,
    "y-9": 2.083,
    "y-10": 2.083,
    "y-11": 2.083,
    "y-13": 2.083,
    "y-14": 2.083,
    "y-15": 2.083,
    "y-16": 2.403,
    "y-17": 2.403,
    "y-18": 2.403,
    "y-19": 2.256,
    "y-20": 2.256,
    "y-21": 2.175,
    "y-22": 1.555,
    "y-23": 1.555,
    "y-24": 1.555,
    "y-25": 1.555,
    "y-26": 1.555,
    "y-27": 1.555,
    "y-28": 1.555,
    "y-29": 1.555,
    "y-30": 1.555,
    "y-31": 1.555,
    "y-32": 1.555,
    "y-33": 1.555,
    "y-34": 1.555,
    "y-35": 1.555,
    "y-36": 1.555,
    "y-37": 1.555,
    "y-38": 1.555,
    "y-39": 1.17,
    "y-40": 1.17,
    "y-41": 1.17,
    "y-42": 1.17,
    "y-43": 1.17,
    "y-44": 1.17,
    "y-45": 1.17,
    "y-47": 1.521,
    "y-48": 1.518,
    "y-49": 1.517,
    "y-50": 1.518,
    "y-51": 1.542,
    "y-52": 1.551,
    "y-53": 1.542,
    "y-54": 1.54,
    "y-55": 1.534,
    "y-56": 1.547,
    "y-57": 1.537,
    "y-58": 1.528,
    "y-59": 1.535,
    "y-60": 1.533,
    "y-61": 1.532,
    "y-62": 1.532,
    "y-63": 1.533,
    "y-64": 1.586,
    "y-65": 1.586,
    "y-66": 1.586,
    "y-67": 1.586,
    "y-68": 1.584,
    "y-69": 1.583,
    "y-70": 1.584,
    "y-71": 1.584,
    "y-72": 1.6,
    "y-73": 1.601,
    "y-74": 1.603,
    "y-75": 1.6,
    "y-76": 1.602,
    "y-77": 1.6,
    "y-78": 1.601,
    "y-79": 1.6,
    "y-80": 1.6,
    "y-81": 1.6,
    "y-82": 1.6,
    "y-83": 1.601,
    "y-84": 1.602,
    "y-85": 1.602,
    "y-86": 1.6,
    "y-87": 1.601,
    "y-88": 1.601,
    "y-89": 1.596,
    "y-90": 1.593,
    "y-91": 1.595,
    "y-92": 1.594,
    "y-93": 1.595,
    "y-94": 1.593,
    "y-95": 1.593,
    "y-96": 1.594,
    "y-97": 1.596,
    "y-98": 1.594,
    "y-99": 1.594,
    "y-100": 1.592,
    "y-101": 1.595,
    "y-102": 1.595,
    "y-103": 1.593,
    "y-104": 1.594,
    "y-105": 1.594,
    "y-106": 1.594,
    "y-107": 1.594,
    "y-108": 1.594,
    "y-109": 1.594,
    "y-110": 1.595,
    "y-111": 1.595,
    "y-112": 1.595,
    "y-113": 1.595,
    "y-114": 1.595,
    "y-115": 1.595,
    "y-116": 1.595,
    "y-117": 1.595,
    "y-118": 1.595,
    "y-119": 1.595,
    "y-120": 1.594,
    "y-121": 1.594,
    "y-122": 1.595,
    "y-123": 1.594,
    "y-124": 1.594,
    "y-125": 1.594,
    "y-126": 1.595,
    "y-127": 1.593,
    "y-128": 1.593,
    "y-129": 1.593,
    "y-130": 1.593,
    "y-131": 1.593,
    "y-132": 1.593,
    "y-133": 1.593,
    "y-134": 1.593,
    "y-135": 1.593,
    "y-136": 1.593,
    "y-137": 1.593,
    "y-138": 1.593,
    "y-139": 1.593,
    "y-140": 1.593,
    "y-141": 1.593,
    "y-142": 1.593,
    "y-143": 1.593,
    "y-144": 1.593,
    "y-145": 1.593,
    "y-146": 1.608,
    "y-147": 1.608,
    "y-148": 1.608,
    "y-149": 1.608,
    "y-150": 1.608,
    "y-151": 1.608,
    "y-152": 1.608,
    "y-153": 1.608,
    "y-154": 1.565,
    "y-155": 1.565,
    "y-156": 1.565,
    "y-157": 1.562,
    "y-158": 1.562,
    "y-159": 1.562,
    "y-160": 1.562,
    "y-161": 1.562,
    "y-162": 1.562,
    "y-163": 1.562,
    "y-164": 1.562,
    "y-165": 1.562,
    "y-166": 1.562,
    "y-167": 1.562,
    "y-168": 1.562,
    "y-169": 1.562,
    "y-170": 1.562,
    "y-171": 1.562,
    "y-172": 1.617,
    "y-173": 1.617,
    "y-174": 1.617,
    "y-175": 1.617,
    "y-176": 1.617,
    "y-177": 1.617,
    "y-178": 1.617,
    "y-179": 1.617,
    "y-180": 1.614,
    "y-181": 1.614,
    "y-182": 1.614,
    "y-183": 1.614,
    "y-184": 1.614,
    "y-185": 1.614,
    "y-186": 1.614,
    "y-187": 1.614,
    "y-188": 1.614,
    "y-189": 1.614,
    "y-190": 1.614,
    "y-191": 1.614,
    "y-192": 1.614,
    "y-193": 1.614,
    "y-194": 1.614,
    "y-195": 1.614,
    "y-196": 1.621,
    "y-197": 1.621,
    "y-198": 1.621,
    "y-199": 1.621,
    "y-200": 1.621,
    "y-201": 1.621,
    "y-202": 1.621,
    "y-203": 1.621,
    "y-204": 1.621,
    "y-205": 1.621,
    "y-206": 1.621,
    "y-207": 1.621,
    "y-208": 1.621,
    "y-209": 1.621,
    "y-210": 1.621,
    "y-211": 1.621,
    "y-212": 1.621,
    "y-213": 1.621,
    "y-214": 1.621,
    "y-215": 1.621,
    "y-216": 1.621,
    "y-217": 1.621,
    "y-218": 1.621,
    "y-219": 1.621,
    "y-220": 1.593,
    "y-221": 1.593,
    "y-222": 1.593,
    "y-223": 1.593,
    "y-224": 1.593,
    "y-225": 1.593,
    "y-226": 1.593,
    "y-227": 1.593,
    "y-228": 1.593,
    "y-229": 1.593,
    "y-230": 1.593,
    "y-231": 1.593,
    "y-232": 1.593,
    "y-233": 1.558,
    "y-234": 1.558,
    "y-235": 1.558,
    "y-236": 1.558,
    "y-237": 1.558,
    "y-238": 1.558,
    "y-239": 1.558,
    "y-240": 1.558,
    "y-241": 1.558,
    "y-242": 1.558,
    "y-243": 1.558,
    "y-244": 1.558,
    "y-245": 1.558,
    "y-246": 1.558,
    "y-247": 1.558,
    "y-248": 1.558,
    "y-249": 1.558,
    "y-250": 1.558,
    "y-251": 1.558,
    "y-252": 1.558,
    "y-253": 1.558,
    "y-254": 1.558,
    "y-255": 1.558,
  },
  {
    x: -1.25,
    "y-2": 0.905,
    "y-12": 2.172,
    "y-46": 1.63,
    "y-1000": 1.613,
    "y-0": 0.714,
    "y-1": 0.943,
    "y-3": 1.007,
    "y-4": 2.239,
    "y-5": 2.17,
    "y-6": 2.002,
    "y-7": 2.174,
    "y-8": 2.174,
    "y-9": 2.172,
    "y-10": 2.172,
    "y-11": 2.172,
    "y-13": 2.172,
    "y-14": 2.172,
    "y-15": 2.172,
    "y-16": 2.226,
    "y-17": 2.226,
    "y-18": 2.226,
    "y-19": 2.128,
    "y-20": 2.128,
    "y-21": 2.074,
    "y-22": 1.661,
    "y-23": 1.661,
    "y-24": 1.661,
    "y-25": 1.661,
    "y-26": 1.661,
    "y-27": 1.661,
    "y-28": 1.661,
    "y-29": 1.661,
    "y-30": 1.661,
    "y-31": 1.661,
    "y-32": 1.661,
    "y-33": 1.661,
    "y-34": 1.661,
    "y-35": 1.661,
    "y-36": 1.661,
    "y-37": 1.661,
    "y-38": 1.661,
    "y-39": 1.404,
    "y-40": 1.404,
    "y-41": 1.404,
    "y-42": 1.404,
    "y-43": 1.404,
    "y-44": 1.404,
    "y-45": 1.404,
    "y-47": 1.638,
    "y-48": 1.636,
    "y-49": 1.635,
    "y-50": 1.636,
    "y-51": 1.652,
    "y-52": 1.658,
    "y-53": 1.652,
    "y-54": 1.65,
    "y-55": 1.647,
    "y-56": 1.655,
    "y-57": 1.649,
    "y-58": 1.642,
    "y-59": 1.647,
    "y-60": 1.646,
    "y-61": 1.645,
    "y-62": 1.646,
    "y-63": 1.646,
    "y-64": 1.681,
    "y-65": 1.682,
    "y-66": 1.681,
    "y-67": 1.682,
    "y-68": 1.68,
    "y-69": 1.679,
    "y-70": 1.68,
    "y-71": 1.68,
    "y-72": 1.69,
    "y-73": 1.692,
    "y-74": 1.693,
    "y-75": 1.691,
    "y-76": 1.692,
    "y-77": 1.691,
    "y-78": 1.691,
    "y-79": 1.691,
    "y-80": 1.691,
    "y-81": 1.691,
    "y-82": 1.691,
    "y-83": 1.691,
    "y-84": 1.692,
    "y-85": 1.692,
    "y-86": 1.691,
    "y-87": 1.691,
    "y-88": 1.691,
    "y-89": 1.688,
    "y-90": 1.686,
    "y-91": 1.687,
    "y-92": 1.687,
    "y-93": 1.687,
    "y-94": 1.686,
    "y-95": 1.686,
    "y-96": 1.687,
    "y-97": 1.688,
    "y-98": 1.687,
    "y-99": 1.687,
    "y-100": 1.685,
    "y-101": 1.687,
    "y-102": 1.687,
    "y-103": 1.686,
    "y-104": 1.687,
    "y-105": 1.687,
    "y-106": 1.687,
    "y-107": 1.687,
    "y-108": 1.687,
    "y-109": 1.687,
    "y-110": 1.687,
    "y-111": 1.687,
    "y-112": 1.687,
    "y-113": 1.687,
    "y-114": 1.687,
    "y-115": 1.687,
    "y-116": 1.687,
    "y-117": 1.687,
    "y-118": 1.687,
    "y-119": 1.687,
    "y-120": 1.687,
    "y-121": 1.687,
    "y-122": 1.687,
    "y-123": 1.687,
    "y-124": 1.687,
    "y-125": 1.687,
    "y-126": 1.687,
    "y-127": 1.686,
    "y-128": 1.686,
    "y-129": 1.686,
    "y-130": 1.686,
    "y-131": 1.686,
    "y-132": 1.686,
    "y-133": 1.686,
    "y-134": 1.686,
    "y-135": 1.686,
    "y-136": 1.686,
    "y-137": 1.686,
    "y-138": 1.686,
    "y-139": 1.686,
    "y-140": 1.686,
    "y-141": 1.686,
    "y-142": 1.686,
    "y-143": 1.686,
    "y-144": 1.686,
    "y-145": 1.686,
    "y-146": 1.696,
    "y-147": 1.696,
    "y-148": 1.696,
    "y-149": 1.696,
    "y-150": 1.696,
    "y-151": 1.696,
    "y-152": 1.696,
    "y-153": 1.696,
    "y-154": 1.598,
    "y-155": 1.598,
    "y-156": 1.598,
    "y-157": 1.59,
    "y-158": 1.589,
    "y-159": 1.589,
    "y-160": 1.589,
    "y-161": 1.589,
    "y-162": 1.589,
    "y-163": 1.589,
    "y-164": 1.589,
    "y-165": 1.589,
    "y-166": 1.589,
    "y-167": 1.589,
    "y-168": 1.589,
    "y-169": 1.589,
    "y-170": 1.589,
    "y-171": 1.589,
    "y-172": 1.65,
    "y-173": 1.65,
    "y-174": 1.65,
    "y-175": 1.65,
    "y-176": 1.65,
    "y-177": 1.65,
    "y-178": 1.65,
    "y-179": 1.65,
    "y-180": 1.643,
    "y-181": 1.643,
    "y-182": 1.643,
    "y-183": 1.643,
    "y-184": 1.643,
    "y-185": 1.643,
    "y-186": 1.643,
    "y-187": 1.643,
    "y-188": 1.643,
    "y-189": 1.643,
    "y-190": 1.643,
    "y-191": 1.643,
    "y-192": 1.643,
    "y-193": 1.643,
    "y-194": 1.643,
    "y-195": 1.643,
    "y-196": 1.651,
    "y-197": 1.651,
    "y-198": 1.651,
    "y-199": 1.651,
    "y-200": 1.651,
    "y-201": 1.651,
    "y-202": 1.651,
    "y-203": 1.651,
    "y-204": 1.651,
    "y-205": 1.651,
    "y-206": 1.651,
    "y-207": 1.651,
    "y-208": 1.651,
    "y-209": 1.651,
    "y-210": 1.651,
    "y-211": 1.651,
    "y-212": 1.651,
    "y-213": 1.651,
    "y-214": 1.651,
    "y-215": 1.651,
    "y-216": 1.651,
    "y-217": 1.651,
    "y-218": 1.651,
    "y-219": 1.651,
    "y-220": 1.588,
    "y-221": 1.588,
    "y-222": 1.588,
    "y-223": 1.589,
    "y-224": 1.589,
    "y-225": 1.589,
    "y-226": 1.589,
    "y-227": 1.589,
    "y-228": 1.589,
    "y-229": 1.589,
    "y-230": 1.589,
    "y-231": 1.589,
    "y-232": 1.589,
    "y-233": 1.529,
    "y-234": 1.529,
    "y-235": 1.529,
    "y-236": 1.529,
    "y-237": 1.529,
    "y-238": 1.529,
    "y-239": 1.529,
    "y-240": 1.529,
    "y-241": 1.529,
    "y-242": 1.529,
    "y-243": 1.529,
    "y-244": 1.529,
    "y-245": 1.529,
    "y-246": 1.529,
    "y-247": 1.529,
    "y-248": 1.529,
    "y-249": 1.529,
    "y-250": 1.529,
    "y-251": 1.529,
    "y-252": 1.529,
    "y-253": 1.529,
    "y-254": 1.529,
    "y-255": 1.529,
  },
  {
    x: -1.225,
    "y-2": 0.884,
    "y-12": 2.261,
    "y-46": 1.751,
    "y-1000": 1.739,
    "y-0": 0.701,
    "y-1": 0.919,
    "y-3": 1.05,
    "y-4": 2.363,
    "y-5": 2.291,
    "y-6": 2.077,
    "y-7": 2.263,
    "y-8": 2.263,
    "y-9": 2.261,
    "y-10": 2.261,
    "y-11": 2.261,
    "y-13": 2.261,
    "y-14": 2.261,
    "y-15": 2.261,
    "y-16": 2.049,
    "y-17": 2.049,
    "y-18": 2.049,
    "y-19": 2.0,
    "y-20": 2.0,
    "y-21": 1.973,
    "y-22": 1.766,
    "y-23": 1.766,
    "y-24": 1.766,
    "y-25": 1.766,
    "y-26": 1.766,
    "y-27": 1.766,
    "y-28": 1.766,
    "y-29": 1.766,
    "y-30": 1.766,
    "y-31": 1.766,
    "y-32": 1.766,
    "y-33": 1.766,
    "y-34": 1.766,
    "y-35": 1.766,
    "y-36": 1.766,
    "y-37": 1.766,
    "y-38": 1.766,
    "y-39": 1.638,
    "y-40": 1.638,
    "y-41": 1.638,
    "y-42": 1.638,
    "y-43": 1.638,
    "y-44": 1.638,
    "y-45": 1.638,
    "y-47": 1.755,
    "y-48": 1.754,
    "y-49": 1.754,
    "y-50": 1.754,
    "y-51": 1.762,
    "y-52": 1.765,
    "y-53": 1.762,
    "y-54": 1.761,
    "y-55": 1.759,
    "y-56": 1.764,
    "y-57": 1.76,
    "y-58": 1.757,
    "y-59": 1.76,
    "y-60": 1.759,
    "y-61": 1.759,
    "y-62": 1.759,
    "y-63": 1.759,
    "y-64": 1.777,
    "y-65": 1.777,
    "y-66": 1.777,
    "y-67": 1.777,
    "y-68": 1.776,
    "y-69": 1.776,
    "y-70": 1.776,
    "y-71": 1.776,
    "y-72": 1.781,
    "y-73": 1.782,
    "y-74": 1.782,
    "y-75": 1.781,
    "y-76": 1.782,
    "y-77": 1.781,
    "y-78": 1.782,
    "y-79": 1.781,
    "y-80": 1.781,
    "y-81": 1.781,
    "y-82": 1.781,
    "y-83": 1.782,
    "y-84": 1.782,
    "y-85": 1.782,
    "y-86": 1.781,
    "y-87": 1.782,
    "y-88": 1.782,
    "y-89": 1.78,
    "y-90": 1.779,
    "y-91": 1.78,
    "y-92": 1.78,
    "y-93": 1.78,
    "y-94": 1.779,
    "y-95": 1.779,
    "y-96": 1.779,
    "y-97": 1.78,
    "y-98": 1.78,
    "y-99": 1.78,
    "y-100": 1.779,
    "y-101": 1.78,
    "y-102": 1.78,
    "y-103": 1.779,
    "y-104": 1.779,
    "y-105": 1.78,
    "y-106": 1.78,
    "y-107": 1.78,
    "y-108": 1.78,
    "y-109": 1.78,
    "y-110": 1.78,
    "y-111": 1.78,
    "y-112": 1.78,
    "y-113": 1.78,
    "y-114": 1.78,
    "y-115": 1.78,
    "y-116": 1.78,
    "y-117": 1.78,
    "y-118": 1.78,
    "y-119": 1.78,
    "y-120": 1.78,
    "y-121": 1.78,
    "y-122": 1.78,
    "y-123": 1.78,
    "y-124": 1.78,
    "y-125": 1.78,
    "y-126": 1.78,
    "y-127": 1.779,
    "y-128": 1.779,
    "y-129": 1.779,
    "y-130": 1.779,
    "y-131": 1.779,
    "y-132": 1.779,
    "y-133": 1.779,
    "y-134": 1.779,
    "y-135": 1.779,
    "y-136": 1.779,
    "y-137": 1.779,
    "y-138": 1.779,
    "y-139": 1.779,
    "y-140": 1.779,
    "y-141": 1.779,
    "y-142": 1.779,
    "y-143": 1.779,
    "y-144": 1.779,
    "y-145": 1.779,
    "y-146": 1.784,
    "y-147": 1.784,
    "y-148": 1.784,
    "y-149": 1.784,
    "y-150": 1.784,
    "y-151": 1.784,
    "y-152": 1.784,
    "y-153": 1.784,
    "y-154": 1.718,
    "y-155": 1.718,
    "y-156": 1.718,
    "y-157": 1.702,
    "y-158": 1.701,
    "y-159": 1.701,
    "y-160": 1.701,
    "y-161": 1.701,
    "y-162": 1.701,
    "y-163": 1.701,
    "y-164": 1.701,
    "y-165": 1.701,
    "y-166": 1.701,
    "y-167": 1.701,
    "y-168": 1.701,
    "y-169": 1.701,
    "y-170": 1.701,
    "y-171": 1.701,
    "y-172": 1.741,
    "y-173": 1.741,
    "y-174": 1.741,
    "y-175": 1.741,
    "y-176": 1.741,
    "y-177": 1.741,
    "y-178": 1.741,
    "y-179": 1.741,
    "y-180": 1.733,
    "y-181": 1.733,
    "y-182": 1.733,
    "y-183": 1.733,
    "y-184": 1.733,
    "y-185": 1.733,
    "y-186": 1.733,
    "y-187": 1.733,
    "y-188": 1.733,
    "y-189": 1.733,
    "y-190": 1.733,
    "y-191": 1.733,
    "y-192": 1.733,
    "y-193": 1.733,
    "y-194": 1.733,
    "y-195": 1.733,
    "y-196": 1.738,
    "y-197": 1.738,
    "y-198": 1.738,
    "y-199": 1.738,
    "y-200": 1.738,
    "y-201": 1.738,
    "y-202": 1.738,
    "y-203": 1.738,
    "y-204": 1.738,
    "y-205": 1.738,
    "y-206": 1.738,
    "y-207": 1.738,
    "y-208": 1.738,
    "y-209": 1.738,
    "y-210": 1.738,
    "y-211": 1.738,
    "y-212": 1.738,
    "y-213": 1.738,
    "y-214": 1.738,
    "y-215": 1.738,
    "y-216": 1.738,
    "y-217": 1.738,
    "y-218": 1.738,
    "y-219": 1.738,
    "y-220": 1.71,
    "y-221": 1.71,
    "y-222": 1.71,
    "y-223": 1.71,
    "y-224": 1.71,
    "y-225": 1.71,
    "y-226": 1.71,
    "y-227": 1.71,
    "y-228": 1.71,
    "y-229": 1.71,
    "y-230": 1.71,
    "y-231": 1.71,
    "y-232": 1.71,
    "y-233": 1.687,
    "y-234": 1.687,
    "y-235": 1.687,
    "y-236": 1.687,
    "y-237": 1.687,
    "y-238": 1.687,
    "y-239": 1.687,
    "y-240": 1.687,
    "y-241": 1.687,
    "y-242": 1.687,
    "y-243": 1.687,
    "y-244": 1.687,
    "y-245": 1.687,
    "y-246": 1.687,
    "y-247": 1.687,
    "y-248": 1.687,
    "y-249": 1.687,
    "y-250": 1.687,
    "y-251": 1.687,
    "y-252": 1.687,
    "y-253": 1.687,
    "y-254": 1.687,
    "y-255": 1.687,
  },
  {
    x: -1.2,
    "y-2": 0.863,
    "y-12": 2.35,
    "y-46": 1.872,
    "y-1000": 1.872,
    "y-0": 0.689,
    "y-1": 0.894,
    "y-3": 1.093,
    "y-4": 2.487,
    "y-5": 2.412,
    "y-6": 2.153,
    "y-7": 2.352,
    "y-8": 2.352,
    "y-9": 2.35,
    "y-10": 2.35,
    "y-11": 2.35,
    "y-13": 2.35,
    "y-14": 2.35,
    "y-15": 2.35,
    "y-16": 1.872,
    "y-17": 1.872,
    "y-18": 1.872,
    "y-19": 1.872,
    "y-20": 1.872,
    "y-21": 1.872,
    "y-22": 1.872,
    "y-23": 1.872,
    "y-24": 1.872,
    "y-25": 1.872,
    "y-26": 1.872,
    "y-27": 1.872,
    "y-28": 1.872,
    "y-29": 1.872,
    "y-30": 1.872,
    "y-31": 1.872,
    "y-32": 1.872,
    "y-33": 1.872,
    "y-34": 1.872,
    "y-35": 1.872,
    "y-36": 1.872,
    "y-37": 1.872,
    "y-38": 1.872,
    "y-39": 1.872,
    "y-40": 1.872,
    "y-41": 1.872,
    "y-42": 1.872,
    "y-43": 1.872,
    "y-44": 1.872,
    "y-45": 1.872,
    "y-47": 1.872,
    "y-48": 1.872,
    "y-49": 1.872,
    "y-50": 1.872,
    "y-51": 1.872,
    "y-52": 1.872,
    "y-53": 1.872,
    "y-54": 1.872,
    "y-55": 1.872,
    "y-56": 1.872,
    "y-57": 1.872,
    "y-58": 1.872,
    "y-59": 1.872,
    "y-60": 1.872,
    "y-61": 1.872,
    "y-62": 1.872,
    "y-63": 1.872,
    "y-64": 1.872,
    "y-65": 1.872,
    "y-66": 1.872,
    "y-67": 1.872,
    "y-68": 1.872,
    "y-69": 1.872,
    "y-70": 1.872,
    "y-71": 1.872,
    "y-72": 1.872,
    "y-73": 1.872,
    "y-74": 1.872,
    "y-75": 1.872,
    "y-76": 1.872,
    "y-77": 1.872,
    "y-78": 1.872,
    "y-79": 1.872,
    "y-80": 1.872,
    "y-81": 1.872,
    "y-82": 1.872,
    "y-83": 1.872,
    "y-84": 1.872,
    "y-85": 1.872,
    "y-86": 1.872,
    "y-87": 1.872,
    "y-88": 1.872,
    "y-89": 1.872,
    "y-90": 1.872,
    "y-91": 1.872,
    "y-92": 1.872,
    "y-93": 1.872,
    "y-94": 1.872,
    "y-95": 1.872,
    "y-96": 1.872,
    "y-97": 1.872,
    "y-98": 1.872,
    "y-99": 1.872,
    "y-100": 1.872,
    "y-101": 1.872,
    "y-102": 1.872,
    "y-103": 1.872,
    "y-104": 1.872,
    "y-105": 1.872,
    "y-106": 1.872,
    "y-107": 1.872,
    "y-108": 1.872,
    "y-109": 1.872,
    "y-110": 1.872,
    "y-111": 1.872,
    "y-112": 1.872,
    "y-113": 1.872,
    "y-114": 1.872,
    "y-115": 1.872,
    "y-116": 1.872,
    "y-117": 1.872,
    "y-118": 1.872,
    "y-119": 1.872,
    "y-120": 1.872,
    "y-121": 1.872,
    "y-122": 1.872,
    "y-123": 1.872,
    "y-124": 1.872,
    "y-125": 1.872,
    "y-126": 1.872,
    "y-127": 1.872,
    "y-128": 1.872,
    "y-129": 1.872,
    "y-130": 1.872,
    "y-131": 1.872,
    "y-132": 1.872,
    "y-133": 1.872,
    "y-134": 1.872,
    "y-135": 1.872,
    "y-136": 1.872,
    "y-137": 1.872,
    "y-138": 1.872,
    "y-139": 1.872,
    "y-140": 1.872,
    "y-141": 1.872,
    "y-142": 1.872,
    "y-143": 1.872,
    "y-144": 1.872,
    "y-145": 1.872,
    "y-146": 1.872,
    "y-147": 1.872,
    "y-148": 1.872,
    "y-149": 1.872,
    "y-150": 1.872,
    "y-151": 1.872,
    "y-152": 1.872,
    "y-153": 1.872,
    "y-154": 1.872,
    "y-155": 1.872,
    "y-156": 1.872,
    "y-157": 1.872,
    "y-158": 1.872,
    "y-159": 1.872,
    "y-160": 1.872,
    "y-161": 1.872,
    "y-162": 1.872,
    "y-163": 1.872,
    "y-164": 1.872,
    "y-165": 1.872,
    "y-166": 1.872,
    "y-167": 1.872,
    "y-168": 1.872,
    "y-169": 1.872,
    "y-170": 1.872,
    "y-171": 1.872,
    "y-172": 1.872,
    "y-173": 1.872,
    "y-174": 1.872,
    "y-175": 1.872,
    "y-176": 1.872,
    "y-177": 1.872,
    "y-178": 1.872,
    "y-179": 1.872,
    "y-180": 1.872,
    "y-181": 1.872,
    "y-182": 1.872,
    "y-183": 1.872,
    "y-184": 1.872,
    "y-185": 1.872,
    "y-186": 1.872,
    "y-187": 1.872,
    "y-188": 1.872,
    "y-189": 1.872,
    "y-190": 1.872,
    "y-191": 1.872,
    "y-192": 1.872,
    "y-193": 1.872,
    "y-194": 1.872,
    "y-195": 1.872,
    "y-196": 1.872,
    "y-197": 1.872,
    "y-198": 1.872,
    "y-199": 1.872,
    "y-200": 1.872,
    "y-201": 1.872,
    "y-202": 1.872,
    "y-203": 1.872,
    "y-204": 1.872,
    "y-205": 1.872,
    "y-206": 1.872,
    "y-207": 1.872,
    "y-208": 1.872,
    "y-209": 1.872,
    "y-210": 1.872,
    "y-211": 1.872,
    "y-212": 1.872,
    "y-213": 1.872,
    "y-214": 1.872,
    "y-215": 1.872,
    "y-216": 1.872,
    "y-217": 1.872,
    "y-218": 1.872,
    "y-219": 1.872,
    "y-220": 1.872,
    "y-221": 1.872,
    "y-222": 1.872,
    "y-223": 1.872,
    "y-224": 1.872,
    "y-225": 1.872,
    "y-226": 1.872,
    "y-227": 1.872,
    "y-228": 1.872,
    "y-229": 1.872,
    "y-230": 1.872,
    "y-231": 1.872,
    "y-232": 1.872,
    "y-233": 1.872,
    "y-234": 1.872,
    "y-235": 1.872,
    "y-236": 1.872,
    "y-237": 1.872,
    "y-238": 1.872,
    "y-239": 1.872,
    "y-240": 1.872,
    "y-241": 1.872,
    "y-242": 1.872,
    "y-243": 1.872,
    "y-244": 1.872,
    "y-245": 1.872,
    "y-246": 1.872,
    "y-247": 1.872,
    "y-248": 1.872,
    "y-249": 1.872,
    "y-250": 1.872,
    "y-251": 1.872,
    "y-252": 1.872,
    "y-253": 1.872,
    "y-254": 1.872,
    "y-255": 1.872,
  },
  {
    x: -1.175,
    "y-2": 0.842,
    "y-12": 2.24,
    "y-46": 1.866,
    "y-1000": 1.939,
    "y-0": 0.677,
    "y-1": 0.87,
    "y-3": 1.136,
    "y-4": 2.507,
    "y-5": 2.44,
    "y-6": 2.174,
    "y-7": 2.237,
    "y-8": 2.241,
    "y-9": 2.24,
    "y-10": 2.24,
    "y-11": 2.24,
    "y-13": 2.266,
    "y-14": 2.266,
    "y-15": 2.266,
    "y-16": 1.869,
    "y-17": 1.869,
    "y-18": 1.869,
    "y-19": 1.882,
    "y-20": 1.882,
    "y-21": 1.889,
    "y-22": 1.941,
    "y-23": 1.941,
    "y-24": 1.941,
    "y-25": 1.941,
    "y-26": 1.941,
    "y-27": 1.941,
    "y-28": 1.941,
    "y-29": 1.941,
    "y-30": 1.941,
    "y-31": 1.941,
    "y-32": 1.953,
    "y-33": 1.953,
    "y-34": 1.953,
    "y-35": 1.862,
    "y-36": 1.862,
    "y-37": 1.862,
    "y-38": 1.862,
    "y-39": 1.894,
    "y-40": 1.894,
    "y-41": 1.894,
    "y-42": 1.894,
    "y-43": 1.894,
    "y-44": 1.894,
    "y-45": 1.894,
    "y-47": 1.865,
    "y-48": 1.865,
    "y-49": 1.865,
    "y-50": 1.865,
    "y-51": 1.863,
    "y-52": 1.862,
    "y-53": 1.863,
    "y-54": 1.863,
    "y-55": 1.864,
    "y-56": 1.862,
    "y-57": 1.863,
    "y-58": 1.864,
    "y-59": 1.884,
    "y-60": 1.901,
    "y-61": 1.901,
    "y-62": 1.901,
    "y-63": 1.901,
    "y-64": 1.896,
    "y-65": 1.896,
    "y-66": 1.896,
    "y-67": 1.896,
    "y-68": 1.918,
    "y-69": 1.918,
    "y-70": 1.915,
    "y-71": 1.916,
    "y-72": 1.912,
    "y-73": 1.913,
    "y-74": 1.915,
    "y-75": 1.912,
    "y-76": 1.915,
    "y-77": 1.913,
    "y-78": 1.912,
    "y-79": 1.915,
    "y-80": 1.914,
    "y-81": 1.913,
    "y-82": 1.915,
    "y-83": 1.912,
    "y-84": 1.916,
    "y-85": 1.914,
    "y-86": 1.913,
    "y-87": 1.915,
    "y-88": 1.92,
    "y-89": 1.919,
    "y-90": 1.905,
    "y-91": 1.905,
    "y-92": 1.904,
    "y-93": 1.905,
    "y-94": 1.908,
    "y-95": 1.908,
    "y-96": 1.913,
    "y-97": 1.909,
    "y-98": 1.908,
    "y-99": 1.911,
    "y-100": 1.909,
    "y-101": 1.91,
    "y-102": 1.911,
    "y-103": 1.913,
    "y-104": 1.911,
    "y-105": 1.912,
    "y-106": 1.91,
    "y-107": 1.911,
    "y-108": 1.911,
    "y-109": 1.912,
    "y-110": 1.911,
    "y-111": 1.91,
    "y-112": 1.911,
    "y-113": 1.91,
    "y-114": 1.91,
    "y-115": 1.911,
    "y-116": 1.911,
    "y-117": 1.91,
    "y-118": 1.91,
    "y-119": 1.918,
    "y-120": 1.918,
    "y-121": 1.918,
    "y-122": 1.918,
    "y-123": 1.918,
    "y-124": 1.918,
    "y-125": 1.918,
    "y-126": 1.918,
    "y-127": 1.918,
    "y-128": 1.918,
    "y-129": 1.918,
    "y-130": 1.918,
    "y-131": 1.918,
    "y-132": 1.918,
    "y-133": 1.918,
    "y-134": 1.918,
    "y-135": 1.918,
    "y-136": 1.918,
    "y-137": 1.918,
    "y-138": 1.918,
    "y-139": 1.918,
    "y-140": 1.918,
    "y-141": 1.918,
    "y-142": 1.918,
    "y-143": 1.918,
    "y-144": 1.918,
    "y-145": 1.918,
    "y-146": 1.917,
    "y-147": 1.917,
    "y-148": 1.917,
    "y-149": 1.917,
    "y-150": 1.917,
    "y-151": 1.917,
    "y-152": 1.917,
    "y-153": 1.917,
    "y-154": 1.937,
    "y-155": 1.937,
    "y-156": 1.937,
    "y-157": 1.943,
    "y-158": 1.943,
    "y-159": 1.943,
    "y-160": 1.943,
    "y-161": 1.943,
    "y-162": 1.943,
    "y-163": 1.943,
    "y-164": 1.943,
    "y-165": 1.943,
    "y-166": 1.943,
    "y-167": 1.943,
    "y-168": 1.943,
    "y-169": 1.943,
    "y-170": 1.943,
    "y-171": 1.943,
    "y-172": 1.931,
    "y-173": 1.931,
    "y-174": 1.931,
    "y-175": 1.931,
    "y-176": 1.931,
    "y-177": 1.931,
    "y-178": 1.931,
    "y-179": 1.931,
    "y-180": 1.935,
    "y-181": 1.935,
    "y-182": 1.935,
    "y-183": 1.935,
    "y-184": 1.935,
    "y-185": 1.935,
    "y-186": 1.935,
    "y-187": 1.935,
    "y-188": 1.935,
    "y-189": 1.935,
    "y-190": 1.935,
    "y-191": 1.935,
    "y-192": 1.935,
    "y-193": 1.935,
    "y-194": 1.935,
    "y-195": 1.935,
    "y-196": 1.934,
    "y-197": 1.934,
    "y-198": 1.934,
    "y-199": 1.934,
    "y-200": 1.934,
    "y-201": 1.934,
    "y-202": 1.934,
    "y-203": 1.934,
    "y-204": 1.934,
    "y-205": 1.934,
    "y-206": 1.934,
    "y-207": 1.934,
    "y-208": 1.934,
    "y-209": 1.934,
    "y-210": 1.934,
    "y-211": 1.934,
    "y-212": 1.934,
    "y-213": 1.934,
    "y-214": 1.933,
    "y-215": 1.933,
    "y-216": 1.933,
    "y-217": 1.933,
    "y-218": 1.933,
    "y-219": 1.934,
    "y-220": 1.941,
    "y-221": 1.941,
    "y-222": 1.941,
    "y-223": 1.941,
    "y-224": 1.941,
    "y-225": 1.941,
    "y-226": 1.941,
    "y-227": 1.941,
    "y-228": 1.941,
    "y-229": 1.941,
    "y-230": 1.941,
    "y-231": 1.941,
    "y-232": 1.941,
    "y-233": 1.948,
    "y-234": 1.948,
    "y-235": 1.948,
    "y-236": 1.948,
    "y-237": 1.948,
    "y-238": 1.948,
    "y-239": 1.948,
    "y-240": 1.948,
    "y-241": 1.948,
    "y-242": 1.948,
    "y-243": 1.948,
    "y-244": 1.948,
    "y-245": 1.948,
    "y-246": 1.948,
    "y-247": 1.948,
    "y-248": 1.948,
    "y-249": 1.948,
    "y-250": 1.948,
    "y-251": 1.948,
    "y-252": 1.948,
    "y-253": 1.948,
    "y-254": 1.948,
    "y-255": 1.948,
  },
  {
    x: -1.15,
    "y-2": 0.82,
    "y-12": 2.013,
    "y-46": 1.785,
    "y-1000": 1.966,
    "y-0": 0.665,
    "y-1": 0.845,
    "y-3": 1.179,
    "y-4": 2.466,
    "y-5": 2.415,
    "y-6": 2.165,
    "y-7": 2.002,
    "y-8": 2.014,
    "y-9": 2.013,
    "y-10": 2.013,
    "y-11": 2.013,
    "y-13": 2.081,
    "y-14": 2.081,
    "y-15": 2.081,
    "y-16": 1.968,
    "y-17": 1.968,
    "y-18": 1.968,
    "y-19": 1.971,
    "y-20": 1.971,
    "y-21": 1.973,
    "y-22": 1.988,
    "y-23": 1.988,
    "y-24": 1.988,
    "y-25": 1.988,
    "y-26": 1.988,
    "y-27": 1.988,
    "y-28": 1.988,
    "y-29": 1.988,
    "y-30": 1.988,
    "y-31": 1.988,
    "y-32": 2.019,
    "y-33": 2.019,
    "y-34": 2.019,
    "y-35": 1.784,
    "y-36": 1.784,
    "y-37": 1.784,
    "y-38": 1.784,
    "y-39": 1.793,
    "y-40": 1.793,
    "y-41": 1.793,
    "y-42": 1.793,
    "y-43": 1.793,
    "y-44": 1.793,
    "y-45": 1.793,
    "y-47": 1.785,
    "y-48": 1.785,
    "y-49": 1.785,
    "y-50": 1.785,
    "y-51": 1.785,
    "y-52": 1.784,
    "y-53": 1.785,
    "y-54": 1.785,
    "y-55": 1.785,
    "y-56": 1.784,
    "y-57": 1.785,
    "y-58": 1.785,
    "y-59": 1.837,
    "y-60": 1.881,
    "y-61": 1.881,
    "y-62": 1.881,
    "y-63": 1.881,
    "y-64": 1.879,
    "y-65": 1.879,
    "y-66": 1.879,
    "y-67": 1.879,
    "y-68": 1.936,
    "y-69": 1.935,
    "y-70": 1.926,
    "y-71": 1.928,
    "y-72": 1.923,
    "y-73": 1.927,
    "y-74": 1.931,
    "y-75": 1.924,
    "y-76": 1.932,
    "y-77": 1.926,
    "y-78": 1.922,
    "y-79": 1.929,
    "y-80": 1.929,
    "y-81": 1.925,
    "y-82": 1.929,
    "y-83": 1.923,
    "y-84": 1.933,
    "y-85": 1.928,
    "y-86": 1.925,
    "y-87": 1.93,
    "y-88": 1.943,
    "y-89": 1.94,
    "y-90": 1.927,
    "y-91": 1.925,
    "y-92": 1.923,
    "y-93": 1.926,
    "y-94": 1.931,
    "y-95": 1.931,
    "y-96": 1.942,
    "y-97": 1.935,
    "y-98": 1.93,
    "y-99": 1.938,
    "y-100": 1.933,
    "y-101": 1.939,
    "y-102": 1.937,
    "y-103": 1.942,
    "y-104": 1.938,
    "y-105": 1.939,
    "y-106": 1.936,
    "y-107": 1.937,
    "y-108": 1.937,
    "y-109": 1.94,
    "y-110": 1.938,
    "y-111": 1.936,
    "y-112": 1.939,
    "y-113": 1.935,
    "y-114": 1.936,
    "y-115": 1.938,
    "y-116": 1.939,
    "y-117": 1.937,
    "y-118": 1.937,
    "y-119": 1.939,
    "y-120": 1.941,
    "y-121": 1.939,
    "y-122": 1.939,
    "y-123": 1.941,
    "y-124": 1.94,
    "y-125": 1.94,
    "y-126": 1.94,
    "y-127": 1.94,
    "y-128": 1.94,
    "y-129": 1.94,
    "y-130": 1.94,
    "y-131": 1.94,
    "y-132": 1.94,
    "y-133": 1.94,
    "y-134": 1.94,
    "y-135": 1.94,
    "y-136": 1.94,
    "y-137": 1.94,
    "y-138": 1.94,
    "y-139": 1.94,
    "y-140": 1.94,
    "y-141": 1.94,
    "y-142": 1.94,
    "y-143": 1.94,
    "y-144": 1.94,
    "y-145": 1.94,
    "y-146": 1.939,
    "y-147": 1.939,
    "y-148": 1.939,
    "y-149": 1.939,
    "y-150": 1.939,
    "y-151": 1.939,
    "y-152": 1.939,
    "y-153": 1.939,
    "y-154": 1.956,
    "y-155": 1.956,
    "y-156": 1.956,
    "y-157": 1.961,
    "y-158": 1.962,
    "y-159": 1.962,
    "y-160": 1.962,
    "y-161": 1.962,
    "y-162": 1.962,
    "y-163": 1.962,
    "y-164": 1.962,
    "y-165": 1.962,
    "y-166": 1.962,
    "y-167": 1.962,
    "y-168": 1.962,
    "y-169": 1.962,
    "y-170": 1.962,
    "y-171": 1.962,
    "y-172": 1.951,
    "y-173": 1.951,
    "y-174": 1.951,
    "y-175": 1.951,
    "y-176": 1.951,
    "y-177": 1.951,
    "y-178": 1.951,
    "y-179": 1.951,
    "y-180": 1.952,
    "y-181": 1.952,
    "y-182": 1.952,
    "y-183": 1.952,
    "y-184": 1.952,
    "y-185": 1.952,
    "y-186": 1.952,
    "y-187": 1.952,
    "y-188": 1.952,
    "y-189": 1.952,
    "y-190": 1.953,
    "y-191": 1.953,
    "y-192": 1.953,
    "y-193": 1.953,
    "y-194": 1.953,
    "y-195": 1.953,
    "y-196": 1.951,
    "y-197": 1.951,
    "y-198": 1.951,
    "y-199": 1.951,
    "y-200": 1.951,
    "y-201": 1.951,
    "y-202": 1.951,
    "y-203": 1.951,
    "y-204": 1.951,
    "y-205": 1.951,
    "y-206": 1.951,
    "y-207": 1.951,
    "y-208": 1.951,
    "y-209": 1.951,
    "y-210": 1.951,
    "y-211": 1.951,
    "y-212": 1.951,
    "y-213": 1.951,
    "y-214": 1.951,
    "y-215": 1.951,
    "y-216": 1.951,
    "y-217": 1.951,
    "y-218": 1.951,
    "y-219": 1.951,
    "y-220": 1.957,
    "y-221": 1.957,
    "y-222": 1.957,
    "y-223": 1.957,
    "y-224": 1.957,
    "y-225": 1.957,
    "y-226": 1.958,
    "y-227": 1.958,
    "y-228": 1.958,
    "y-229": 1.958,
    "y-230": 1.958,
    "y-231": 1.958,
    "y-232": 1.958,
    "y-233": 1.962,
    "y-234": 1.962,
    "y-235": 1.962,
    "y-236": 1.962,
    "y-237": 1.962,
    "y-238": 1.962,
    "y-239": 1.962,
    "y-240": 1.963,
    "y-241": 1.963,
    "y-242": 1.963,
    "y-243": 1.963,
    "y-244": 1.963,
    "y-245": 1.963,
    "y-246": 1.963,
    "y-247": 1.963,
    "y-248": 1.963,
    "y-249": 1.963,
    "y-250": 1.963,
    "y-251": 1.963,
    "y-252": 1.963,
    "y-253": 1.963,
    "y-254": 1.963,
    "y-255": 1.963,
  },
  {
    x: -1.125,
    "y-2": 0.799,
    "y-12": 1.926,
    "y-46": 1.834,
    "y-1000": 1.97,
    "y-0": 0.653,
    "y-1": 0.821,
    "y-3": 1.222,
    "y-4": 2.425,
    "y-5": 2.39,
    "y-6": 2.155,
    "y-7": 1.912,
    "y-8": 1.926,
    "y-9": 1.926,
    "y-10": 1.926,
    "y-11": 1.926,
    "y-13": 2.002,
    "y-14": 2.002,
    "y-15": 2.002,
    "y-16": 2.002,
    "y-17": 2.002,
    "y-18": 2.002,
    "y-19": 2.002,
    "y-20": 2.002,
    "y-21": 2.002,
    "y-22": 2.002,
    "y-23": 2.002,
    "y-24": 2.002,
    "y-25": 2.002,
    "y-26": 2.002,
    "y-27": 2.002,
    "y-28": 2.002,
    "y-29": 2.002,
    "y-30": 2.002,
    "y-31": 2.002,
    "y-32": 2.038,
    "y-33": 2.038,
    "y-34": 2.038,
    "y-35": 1.834,
    "y-36": 1.834,
    "y-37": 1.834,
    "y-38": 1.834,
    "y-39": 1.834,
    "y-40": 1.834,
    "y-41": 1.834,
    "y-42": 1.834,
    "y-43": 1.834,
    "y-44": 1.834,
    "y-45": 1.834,
    "y-47": 1.834,
    "y-48": 1.834,
    "y-49": 1.834,
    "y-50": 1.834,
    "y-51": 1.834,
    "y-52": 1.834,
    "y-53": 1.834,
    "y-54": 1.834,
    "y-55": 1.834,
    "y-56": 1.834,
    "y-57": 1.834,
    "y-58": 1.834,
    "y-59": 1.875,
    "y-60": 1.909,
    "y-61": 1.909,
    "y-62": 1.909,
    "y-63": 1.909,
    "y-64": 1.909,
    "y-65": 1.909,
    "y-66": 1.909,
    "y-67": 1.909,
    "y-68": 1.953,
    "y-69": 1.952,
    "y-70": 1.945,
    "y-71": 1.947,
    "y-72": 1.943,
    "y-73": 1.946,
    "y-74": 1.95,
    "y-75": 1.944,
    "y-76": 1.95,
    "y-77": 1.946,
    "y-78": 1.942,
    "y-79": 1.948,
    "y-80": 1.947,
    "y-81": 1.945,
    "y-82": 1.948,
    "y-83": 1.943,
    "y-84": 1.951,
    "y-85": 1.947,
    "y-86": 1.945,
    "y-87": 1.948,
    "y-88": 1.958,
    "y-89": 1.956,
    "y-90": 1.948,
    "y-91": 1.947,
    "y-92": 1.945,
    "y-93": 1.948,
    "y-94": 1.951,
    "y-95": 1.951,
    "y-96": 1.959,
    "y-97": 1.954,
    "y-98": 1.95,
    "y-99": 1.957,
    "y-100": 1.952,
    "y-101": 1.958,
    "y-102": 1.956,
    "y-103": 1.96,
    "y-104": 1.956,
    "y-105": 1.957,
    "y-106": 1.955,
    "y-107": 1.956,
    "y-108": 1.956,
    "y-109": 1.958,
    "y-110": 1.957,
    "y-111": 1.955,
    "y-112": 1.957,
    "y-113": 1.954,
    "y-114": 1.955,
    "y-115": 1.957,
    "y-116": 1.957,
    "y-117": 1.956,
    "y-118": 1.956,
    "y-119": 1.956,
    "y-120": 1.957,
    "y-121": 1.956,
    "y-122": 1.956,
    "y-123": 1.957,
    "y-124": 1.956,
    "y-125": 1.956,
    "y-126": 1.956,
    "y-127": 1.956,
    "y-128": 1.956,
    "y-129": 1.956,
    "y-130": 1.956,
    "y-131": 1.956,
    "y-132": 1.956,
    "y-133": 1.956,
    "y-134": 1.956,
    "y-135": 1.956,
    "y-136": 1.956,
    "y-137": 1.956,
    "y-138": 1.956,
    "y-139": 1.956,
    "y-140": 1.956,
    "y-141": 1.956,
    "y-142": 1.956,
    "y-143": 1.956,
    "y-144": 1.956,
    "y-145": 1.956,
    "y-146": 1.956,
    "y-147": 1.956,
    "y-148": 1.956,
    "y-149": 1.956,
    "y-150": 1.956,
    "y-151": 1.956,
    "y-152": 1.956,
    "y-153": 1.956,
    "y-154": 1.966,
    "y-155": 1.966,
    "y-156": 1.966,
    "y-157": 1.969,
    "y-158": 1.969,
    "y-159": 1.969,
    "y-160": 1.969,
    "y-161": 1.969,
    "y-162": 1.969,
    "y-163": 1.969,
    "y-164": 1.969,
    "y-165": 1.969,
    "y-166": 1.969,
    "y-167": 1.969,
    "y-168": 1.969,
    "y-169": 1.969,
    "y-170": 1.969,
    "y-171": 1.969,
    "y-172": 1.963,
    "y-173": 1.963,
    "y-174": 1.963,
    "y-175": 1.963,
    "y-176": 1.963,
    "y-177": 1.963,
    "y-178": 1.963,
    "y-179": 1.963,
    "y-180": 1.963,
    "y-181": 1.963,
    "y-182": 1.963,
    "y-183": 1.963,
    "y-184": 1.963,
    "y-185": 1.963,
    "y-186": 1.963,
    "y-187": 1.963,
    "y-188": 1.963,
    "y-189": 1.963,
    "y-190": 1.963,
    "y-191": 1.963,
    "y-192": 1.963,
    "y-193": 1.963,
    "y-194": 1.963,
    "y-195": 1.963,
    "y-196": 1.962,
    "y-197": 1.962,
    "y-198": 1.962,
    "y-199": 1.962,
    "y-200": 1.962,
    "y-201": 1.962,
    "y-202": 1.962,
    "y-203": 1.962,
    "y-204": 1.962,
    "y-205": 1.962,
    "y-206": 1.962,
    "y-207": 1.962,
    "y-208": 1.962,
    "y-209": 1.962,
    "y-210": 1.962,
    "y-211": 1.962,
    "y-212": 1.962,
    "y-213": 1.962,
    "y-214": 1.962,
    "y-215": 1.962,
    "y-216": 1.962,
    "y-217": 1.962,
    "y-218": 1.962,
    "y-219": 1.962,
    "y-220": 1.966,
    "y-221": 1.966,
    "y-222": 1.966,
    "y-223": 1.966,
    "y-224": 1.966,
    "y-225": 1.966,
    "y-226": 1.966,
    "y-227": 1.966,
    "y-228": 1.966,
    "y-229": 1.966,
    "y-230": 1.966,
    "y-231": 1.966,
    "y-232": 1.966,
    "y-233": 1.969,
    "y-234": 1.969,
    "y-235": 1.969,
    "y-236": 1.969,
    "y-237": 1.969,
    "y-238": 1.969,
    "y-239": 1.969,
    "y-240": 1.969,
    "y-241": 1.969,
    "y-242": 1.969,
    "y-243": 1.969,
    "y-244": 1.969,
    "y-245": 1.969,
    "y-246": 1.969,
    "y-247": 1.969,
    "y-248": 1.969,
    "y-249": 1.969,
    "y-250": 1.969,
    "y-251": 1.969,
    "y-252": 1.969,
    "y-253": 1.969,
    "y-254": 1.969,
    "y-255": 1.969,
  },
  {
    x: -1.1,
    "y-2": 0.778,
    "y-12": 1.93,
    "y-46": 1.969,
    "y-1000": 1.969,
    "y-0": 0.64,
    "y-1": 0.796,
    "y-3": 1.265,
    "y-4": 2.385,
    "y-5": 2.365,
    "y-6": 2.145,
    "y-7": 1.918,
    "y-8": 1.93,
    "y-9": 1.93,
    "y-10": 1.93,
    "y-11": 1.93,
    "y-13": 1.995,
    "y-14": 1.995,
    "y-15": 1.995,
    "y-16": 1.995,
    "y-17": 1.995,
    "y-18": 1.995,
    "y-19": 1.995,
    "y-20": 1.995,
    "y-21": 1.995,
    "y-22": 1.995,
    "y-23": 1.995,
    "y-24": 1.995,
    "y-25": 1.995,
    "y-26": 1.995,
    "y-27": 1.995,
    "y-28": 1.995,
    "y-29": 1.995,
    "y-30": 1.995,
    "y-31": 1.995,
    "y-32": 2.024,
    "y-33": 2.024,
    "y-34": 2.024,
    "y-35": 1.969,
    "y-36": 1.969,
    "y-37": 1.969,
    "y-38": 1.969,
    "y-39": 1.969,
    "y-40": 1.969,
    "y-41": 1.969,
    "y-42": 1.969,
    "y-43": 1.969,
    "y-44": 1.969,
    "y-45": 1.969,
    "y-47": 1.969,
    "y-48": 1.969,
    "y-49": 1.969,
    "y-50": 1.969,
    "y-51": 1.969,
    "y-52": 1.969,
    "y-53": 1.969,
    "y-54": 1.969,
    "y-55": 1.969,
    "y-56": 1.969,
    "y-57": 1.969,
    "y-58": 1.969,
    "y-59": 1.969,
    "y-60": 1.969,
    "y-61": 1.969,
    "y-62": 1.969,
    "y-63": 1.969,
    "y-64": 1.969,
    "y-65": 1.969,
    "y-66": 1.969,
    "y-67": 1.969,
    "y-68": 1.969,
    "y-69": 1.969,
    "y-70": 1.969,
    "y-71": 1.969,
    "y-72": 1.969,
    "y-73": 1.969,
    "y-74": 1.969,
    "y-75": 1.969,
    "y-76": 1.969,
    "y-77": 1.969,
    "y-78": 1.969,
    "y-79": 1.969,
    "y-80": 1.969,
    "y-81": 1.969,
    "y-82": 1.969,
    "y-83": 1.969,
    "y-84": 1.969,
    "y-85": 1.969,
    "y-86": 1.969,
    "y-87": 1.969,
    "y-88": 1.969,
    "y-89": 1.969,
    "y-90": 1.969,
    "y-91": 1.969,
    "y-92": 1.969,
    "y-93": 1.969,
    "y-94": 1.969,
    "y-95": 1.969,
    "y-96": 1.969,
    "y-97": 1.969,
    "y-98": 1.969,
    "y-99": 1.969,
    "y-100": 1.969,
    "y-101": 1.969,
    "y-102": 1.969,
    "y-103": 1.969,
    "y-104": 1.969,
    "y-105": 1.969,
    "y-106": 1.969,
    "y-107": 1.969,
    "y-108": 1.969,
    "y-109": 1.969,
    "y-110": 1.969,
    "y-111": 1.969,
    "y-112": 1.969,
    "y-113": 1.969,
    "y-114": 1.969,
    "y-115": 1.969,
    "y-116": 1.969,
    "y-117": 1.969,
    "y-118": 1.969,
    "y-119": 1.969,
    "y-120": 1.969,
    "y-121": 1.969,
    "y-122": 1.969,
    "y-123": 1.969,
    "y-124": 1.969,
    "y-125": 1.969,
    "y-126": 1.969,
    "y-127": 1.969,
    "y-128": 1.969,
    "y-129": 1.969,
    "y-130": 1.969,
    "y-131": 1.969,
    "y-132": 1.969,
    "y-133": 1.969,
    "y-134": 1.969,
    "y-135": 1.969,
    "y-136": 1.969,
    "y-137": 1.969,
    "y-138": 1.969,
    "y-139": 1.969,
    "y-140": 1.969,
    "y-141": 1.969,
    "y-142": 1.969,
    "y-143": 1.969,
    "y-144": 1.969,
    "y-145": 1.969,
    "y-146": 1.969,
    "y-147": 1.969,
    "y-148": 1.969,
    "y-149": 1.969,
    "y-150": 1.969,
    "y-151": 1.969,
    "y-152": 1.969,
    "y-153": 1.969,
    "y-154": 1.969,
    "y-155": 1.969,
    "y-156": 1.969,
    "y-157": 1.969,
    "y-158": 1.969,
    "y-159": 1.969,
    "y-160": 1.969,
    "y-161": 1.969,
    "y-162": 1.969,
    "y-163": 1.969,
    "y-164": 1.969,
    "y-165": 1.969,
    "y-166": 1.969,
    "y-167": 1.969,
    "y-168": 1.969,
    "y-169": 1.969,
    "y-170": 1.969,
    "y-171": 1.969,
    "y-172": 1.969,
    "y-173": 1.969,
    "y-174": 1.969,
    "y-175": 1.969,
    "y-176": 1.969,
    "y-177": 1.969,
    "y-178": 1.969,
    "y-179": 1.969,
    "y-180": 1.969,
    "y-181": 1.969,
    "y-182": 1.969,
    "y-183": 1.969,
    "y-184": 1.969,
    "y-185": 1.969,
    "y-186": 1.969,
    "y-187": 1.969,
    "y-188": 1.969,
    "y-189": 1.969,
    "y-190": 1.969,
    "y-191": 1.969,
    "y-192": 1.969,
    "y-193": 1.969,
    "y-194": 1.969,
    "y-195": 1.969,
    "y-196": 1.969,
    "y-197": 1.969,
    "y-198": 1.969,
    "y-199": 1.969,
    "y-200": 1.969,
    "y-201": 1.969,
    "y-202": 1.969,
    "y-203": 1.969,
    "y-204": 1.969,
    "y-205": 1.969,
    "y-206": 1.969,
    "y-207": 1.969,
    "y-208": 1.969,
    "y-209": 1.969,
    "y-210": 1.969,
    "y-211": 1.969,
    "y-212": 1.969,
    "y-213": 1.969,
    "y-214": 1.969,
    "y-215": 1.969,
    "y-216": 1.969,
    "y-217": 1.969,
    "y-218": 1.969,
    "y-219": 1.969,
    "y-220": 1.969,
    "y-221": 1.969,
    "y-222": 1.969,
    "y-223": 1.969,
    "y-224": 1.969,
    "y-225": 1.969,
    "y-226": 1.969,
    "y-227": 1.969,
    "y-228": 1.969,
    "y-229": 1.969,
    "y-230": 1.969,
    "y-231": 1.969,
    "y-232": 1.969,
    "y-233": 1.969,
    "y-234": 1.969,
    "y-235": 1.969,
    "y-236": 1.969,
    "y-237": 1.969,
    "y-238": 1.969,
    "y-239": 1.969,
    "y-240": 1.969,
    "y-241": 1.969,
    "y-242": 1.969,
    "y-243": 1.969,
    "y-244": 1.969,
    "y-245": 1.969,
    "y-246": 1.969,
    "y-247": 1.969,
    "y-248": 1.969,
    "y-249": 1.969,
    "y-250": 1.969,
    "y-251": 1.969,
    "y-252": 1.969,
    "y-253": 1.969,
    "y-254": 1.969,
    "y-255": 1.969,
  },
  {
    x: -1.075,
    "y-2": 0.756,
    "y-12": 1.934,
    "y-46": 2.087,
    "y-1000": 1.972,
    "y-0": 0.628,
    "y-1": 0.771,
    "y-3": 1.308,
    "y-4": 2.344,
    "y-5": 2.34,
    "y-6": 2.136,
    "y-7": 1.925,
    "y-8": 1.934,
    "y-9": 1.934,
    "y-10": 1.934,
    "y-11": 1.934,
    "y-13": 1.987,
    "y-14": 1.987,
    "y-15": 1.987,
    "y-16": 1.987,
    "y-17": 1.987,
    "y-18": 1.987,
    "y-19": 1.987,
    "y-20": 1.987,
    "y-21": 1.987,
    "y-22": 1.987,
    "y-23": 1.987,
    "y-24": 1.987,
    "y-25": 1.987,
    "y-26": 1.987,
    "y-27": 1.987,
    "y-28": 1.987,
    "y-29": 1.987,
    "y-30": 1.987,
    "y-31": 1.987,
    "y-32": 2.011,
    "y-33": 2.011,
    "y-34": 2.011,
    "y-35": 2.087,
    "y-36": 2.087,
    "y-37": 2.087,
    "y-38": 2.087,
    "y-39": 2.087,
    "y-40": 2.087,
    "y-41": 2.087,
    "y-42": 2.087,
    "y-43": 2.087,
    "y-44": 2.087,
    "y-45": 2.087,
    "y-47": 2.087,
    "y-48": 2.087,
    "y-49": 2.087,
    "y-50": 2.087,
    "y-51": 2.087,
    "y-52": 2.087,
    "y-53": 2.087,
    "y-54": 2.087,
    "y-55": 2.087,
    "y-56": 2.087,
    "y-57": 2.087,
    "y-58": 2.087,
    "y-59": 2.051,
    "y-60": 2.022,
    "y-61": 2.022,
    "y-62": 2.022,
    "y-63": 2.022,
    "y-64": 2.022,
    "y-65": 2.022,
    "y-66": 2.022,
    "y-67": 2.022,
    "y-68": 2.022,
    "y-69": 2.022,
    "y-70": 2.022,
    "y-71": 2.022,
    "y-72": 2.022,
    "y-73": 2.022,
    "y-74": 2.022,
    "y-75": 2.022,
    "y-76": 2.022,
    "y-77": 2.022,
    "y-78": 2.022,
    "y-79": 2.022,
    "y-80": 2.022,
    "y-81": 2.022,
    "y-82": 2.022,
    "y-83": 2.022,
    "y-84": 2.022,
    "y-85": 2.022,
    "y-86": 2.022,
    "y-87": 2.022,
    "y-88": 2.002,
    "y-89": 2.003,
    "y-90": 2.004,
    "y-91": 2.006,
    "y-92": 2.004,
    "y-93": 2.003,
    "y-94": 2.002,
    "y-95": 2.002,
    "y-96": 1.991,
    "y-97": 1.989,
    "y-98": 1.991,
    "y-99": 1.99,
    "y-100": 1.991,
    "y-101": 1.984,
    "y-102": 1.984,
    "y-103": 1.982,
    "y-104": 1.984,
    "y-105": 1.984,
    "y-106": 1.983,
    "y-107": 1.984,
    "y-108": 1.983,
    "y-109": 1.983,
    "y-110": 1.983,
    "y-111": 1.984,
    "y-112": 1.983,
    "y-113": 1.984,
    "y-114": 1.984,
    "y-115": 1.983,
    "y-116": 1.983,
    "y-117": 1.983,
    "y-118": 1.983,
    "y-119": 1.983,
    "y-120": 1.983,
    "y-121": 1.983,
    "y-122": 1.983,
    "y-123": 1.982,
    "y-124": 1.983,
    "y-125": 1.983,
    "y-126": 1.983,
    "y-127": 1.983,
    "y-128": 1.983,
    "y-129": 1.983,
    "y-130": 1.983,
    "y-131": 1.983,
    "y-132": 1.983,
    "y-133": 1.983,
    "y-134": 1.983,
    "y-135": 1.983,
    "y-136": 1.983,
    "y-137": 1.983,
    "y-138": 1.983,
    "y-139": 1.983,
    "y-140": 1.983,
    "y-141": 1.983,
    "y-142": 1.983,
    "y-143": 1.983,
    "y-144": 1.983,
    "y-145": 1.983,
    "y-146": 1.983,
    "y-147": 1.983,
    "y-148": 1.983,
    "y-149": 1.983,
    "y-150": 1.983,
    "y-151": 1.983,
    "y-152": 1.983,
    "y-153": 1.983,
    "y-154": 1.978,
    "y-155": 1.978,
    "y-156": 1.978,
    "y-157": 1.977,
    "y-158": 1.977,
    "y-159": 1.977,
    "y-160": 1.977,
    "y-161": 1.977,
    "y-162": 1.977,
    "y-163": 1.977,
    "y-164": 1.977,
    "y-165": 1.977,
    "y-166": 1.977,
    "y-167": 1.977,
    "y-168": 1.977,
    "y-169": 1.977,
    "y-170": 1.977,
    "y-171": 1.977,
    "y-172": 1.98,
    "y-173": 1.98,
    "y-174": 1.98,
    "y-175": 1.98,
    "y-176": 1.98,
    "y-177": 1.98,
    "y-178": 1.98,
    "y-179": 1.98,
    "y-180": 1.979,
    "y-181": 1.979,
    "y-182": 1.979,
    "y-183": 1.979,
    "y-184": 1.979,
    "y-185": 1.98,
    "y-186": 1.98,
    "y-187": 1.979,
    "y-188": 1.979,
    "y-189": 1.979,
    "y-190": 1.979,
    "y-191": 1.979,
    "y-192": 1.979,
    "y-193": 1.979,
    "y-194": 1.979,
    "y-195": 1.979,
    "y-196": 1.98,
    "y-197": 1.98,
    "y-198": 1.98,
    "y-199": 1.98,
    "y-200": 1.98,
    "y-201": 1.98,
    "y-202": 1.98,
    "y-203": 1.98,
    "y-204": 1.979,
    "y-205": 1.979,
    "y-206": 1.979,
    "y-207": 1.979,
    "y-208": 1.979,
    "y-209": 1.979,
    "y-210": 1.98,
    "y-211": 1.98,
    "y-212": 1.98,
    "y-213": 1.98,
    "y-214": 1.98,
    "y-215": 1.98,
    "y-216": 1.98,
    "y-217": 1.98,
    "y-218": 1.98,
    "y-219": 1.98,
    "y-220": 1.978,
    "y-221": 1.978,
    "y-222": 1.978,
    "y-223": 1.978,
    "y-224": 1.978,
    "y-225": 1.978,
    "y-226": 1.977,
    "y-227": 1.977,
    "y-228": 1.977,
    "y-229": 1.977,
    "y-230": 1.977,
    "y-231": 1.977,
    "y-232": 1.977,
    "y-233": 1.975,
    "y-234": 1.975,
    "y-235": 1.975,
    "y-236": 1.975,
    "y-237": 1.975,
    "y-238": 1.975,
    "y-239": 1.975,
    "y-240": 1.975,
    "y-241": 1.975,
    "y-242": 1.975,
    "y-243": 1.975,
    "y-244": 1.975,
    "y-245": 1.975,
    "y-246": 1.975,
    "y-247": 1.975,
    "y-248": 1.975,
    "y-249": 1.975,
    "y-250": 1.975,
    "y-251": 1.975,
    "y-252": 1.975,
    "y-253": 1.975,
    "y-254": 1.975,
    "y-255": 1.975,
  },
  {
    x: -1.05,
    "y-2": 0.735,
    "y-12": 1.939,
    "y-46": 2.066,
    "y-1000": 1.982,
    "y-0": 0.616,
    "y-1": 0.747,
    "y-3": 1.351,
    "y-4": 2.303,
    "y-5": 2.315,
    "y-6": 2.126,
    "y-7": 1.931,
    "y-8": 1.939,
    "y-9": 1.939,
    "y-10": 1.939,
    "y-11": 1.939,
    "y-13": 1.98,
    "y-14": 1.98,
    "y-15": 1.98,
    "y-16": 1.98,
    "y-17": 1.98,
    "y-18": 1.98,
    "y-19": 1.98,
    "y-20": 1.98,
    "y-21": 1.98,
    "y-22": 1.98,
    "y-23": 1.98,
    "y-24": 1.98,
    "y-25": 1.98,
    "y-26": 1.98,
    "y-27": 1.98,
    "y-28": 1.98,
    "y-29": 1.98,
    "y-30": 1.98,
    "y-31": 1.98,
    "y-32": 1.997,
    "y-33": 1.997,
    "y-34": 1.997,
    "y-35": 2.066,
    "y-36": 2.066,
    "y-37": 2.066,
    "y-38": 2.066,
    "y-39": 2.066,
    "y-40": 2.066,
    "y-41": 2.066,
    "y-42": 2.066,
    "y-43": 2.066,
    "y-44": 2.066,
    "y-45": 2.066,
    "y-47": 2.066,
    "y-48": 2.066,
    "y-49": 2.066,
    "y-50": 2.066,
    "y-51": 2.066,
    "y-52": 2.066,
    "y-53": 2.066,
    "y-54": 2.066,
    "y-55": 2.066,
    "y-56": 2.066,
    "y-57": 2.066,
    "y-58": 2.066,
    "y-59": 2.037,
    "y-60": 2.014,
    "y-61": 2.014,
    "y-62": 2.014,
    "y-63": 2.014,
    "y-64": 2.014,
    "y-65": 2.014,
    "y-66": 2.014,
    "y-67": 2.015,
    "y-68": 2.014,
    "y-69": 2.014,
    "y-70": 2.015,
    "y-71": 2.015,
    "y-72": 2.015,
    "y-73": 2.014,
    "y-74": 2.014,
    "y-75": 2.014,
    "y-76": 2.014,
    "y-77": 2.014,
    "y-78": 2.014,
    "y-79": 2.014,
    "y-80": 2.014,
    "y-81": 2.014,
    "y-82": 2.015,
    "y-83": 2.014,
    "y-84": 2.014,
    "y-85": 2.014,
    "y-86": 2.014,
    "y-87": 2.014,
    "y-88": 2.001,
    "y-89": 2.002,
    "y-90": 2.003,
    "y-91": 2.004,
    "y-92": 2.014,
    "y-93": 2.013,
    "y-94": 2.013,
    "y-95": 2.013,
    "y-96": 2.01,
    "y-97": 2.006,
    "y-98": 2.007,
    "y-99": 2.006,
    "y-100": 2.007,
    "y-101": 1.996,
    "y-102": 1.995,
    "y-103": 1.994,
    "y-104": 1.996,
    "y-105": 1.994,
    "y-106": 1.994,
    "y-107": 1.995,
    "y-108": 1.995,
    "y-109": 1.994,
    "y-110": 1.995,
    "y-111": 1.996,
    "y-112": 1.995,
    "y-113": 1.996,
    "y-114": 1.996,
    "y-115": 1.995,
    "y-116": 1.995,
    "y-117": 1.995,
    "y-118": 1.995,
    "y-119": 1.995,
    "y-120": 1.995,
    "y-121": 1.995,
    "y-122": 1.995,
    "y-123": 1.995,
    "y-124": 1.995,
    "y-125": 1.995,
    "y-126": 1.995,
    "y-127": 1.995,
    "y-128": 1.995,
    "y-129": 1.995,
    "y-130": 1.995,
    "y-131": 1.995,
    "y-132": 1.995,
    "y-133": 1.995,
    "y-134": 1.995,
    "y-135": 1.995,
    "y-136": 1.995,
    "y-137": 1.995,
    "y-138": 1.995,
    "y-139": 1.995,
    "y-140": 1.995,
    "y-141": 1.995,
    "y-142": 1.995,
    "y-143": 1.995,
    "y-144": 1.995,
    "y-145": 1.995,
    "y-146": 1.995,
    "y-147": 1.995,
    "y-148": 1.995,
    "y-149": 1.995,
    "y-150": 1.995,
    "y-151": 1.995,
    "y-152": 1.995,
    "y-153": 1.995,
    "y-154": 1.991,
    "y-155": 1.991,
    "y-156": 1.991,
    "y-157": 1.989,
    "y-158": 1.989,
    "y-159": 1.989,
    "y-160": 1.989,
    "y-161": 1.989,
    "y-162": 1.989,
    "y-163": 1.989,
    "y-164": 1.989,
    "y-165": 1.989,
    "y-166": 1.989,
    "y-167": 1.989,
    "y-168": 1.989,
    "y-169": 1.989,
    "y-170": 1.989,
    "y-171": 1.989,
    "y-172": 1.992,
    "y-173": 1.992,
    "y-174": 1.992,
    "y-175": 1.992,
    "y-176": 1.992,
    "y-177": 1.992,
    "y-178": 1.992,
    "y-179": 1.992,
    "y-180": 1.992,
    "y-181": 1.992,
    "y-182": 1.992,
    "y-183": 1.992,
    "y-184": 1.992,
    "y-185": 1.992,
    "y-186": 1.992,
    "y-187": 1.992,
    "y-188": 1.992,
    "y-189": 1.992,
    "y-190": 1.991,
    "y-191": 1.991,
    "y-192": 1.991,
    "y-193": 1.991,
    "y-194": 1.991,
    "y-195": 1.991,
    "y-196": 1.992,
    "y-197": 1.992,
    "y-198": 1.992,
    "y-199": 1.992,
    "y-200": 1.992,
    "y-201": 1.992,
    "y-202": 1.992,
    "y-203": 1.992,
    "y-204": 1.992,
    "y-205": 1.992,
    "y-206": 1.992,
    "y-207": 1.992,
    "y-208": 1.992,
    "y-209": 1.992,
    "y-210": 1.992,
    "y-211": 1.992,
    "y-212": 1.992,
    "y-213": 1.992,
    "y-214": 1.992,
    "y-215": 1.992,
    "y-216": 1.992,
    "y-217": 1.992,
    "y-218": 1.992,
    "y-219": 1.992,
    "y-220": 1.99,
    "y-221": 1.991,
    "y-222": 1.991,
    "y-223": 1.991,
    "y-224": 1.991,
    "y-225": 1.991,
    "y-226": 1.99,
    "y-227": 1.99,
    "y-228": 1.99,
    "y-229": 1.99,
    "y-230": 1.99,
    "y-231": 1.99,
    "y-232": 1.99,
    "y-233": 1.989,
    "y-234": 1.989,
    "y-235": 1.989,
    "y-236": 1.989,
    "y-237": 1.989,
    "y-238": 1.989,
    "y-239": 1.989,
    "y-240": 1.988,
    "y-241": 1.988,
    "y-242": 1.988,
    "y-243": 1.988,
    "y-244": 1.988,
    "y-245": 1.988,
    "y-246": 1.988,
    "y-247": 1.988,
    "y-248": 1.988,
    "y-249": 1.988,
    "y-250": 1.988,
    "y-251": 1.988,
    "y-252": 1.988,
    "y-253": 1.988,
    "y-254": 1.988,
    "y-255": 1.988,
  },
  {
    x: -1.025,
    "y-2": 0.714,
    "y-12": 1.943,
    "y-46": 2.046,
    "y-1000": 1.993,
    "y-0": 0.604,
    "y-1": 0.722,
    "y-3": 1.394,
    "y-4": 2.262,
    "y-5": 2.29,
    "y-6": 2.117,
    "y-7": 1.937,
    "y-8": 1.943,
    "y-9": 1.943,
    "y-10": 1.943,
    "y-11": 1.943,
    "y-13": 1.972,
    "y-14": 1.972,
    "y-15": 1.972,
    "y-16": 1.972,
    "y-17": 1.972,
    "y-18": 1.972,
    "y-19": 1.972,
    "y-20": 1.972,
    "y-21": 1.972,
    "y-22": 1.972,
    "y-23": 1.972,
    "y-24": 1.972,
    "y-25": 1.972,
    "y-26": 1.972,
    "y-27": 1.972,
    "y-28": 1.972,
    "y-29": 1.972,
    "y-30": 1.972,
    "y-31": 1.972,
    "y-32": 1.984,
    "y-33": 1.984,
    "y-34": 1.984,
    "y-35": 2.046,
    "y-36": 2.046,
    "y-37": 2.046,
    "y-38": 2.046,
    "y-39": 2.046,
    "y-40": 2.046,
    "y-41": 2.046,
    "y-42": 2.046,
    "y-43": 2.046,
    "y-44": 2.046,
    "y-45": 2.046,
    "y-47": 2.046,
    "y-48": 2.046,
    "y-49": 2.046,
    "y-50": 2.046,
    "y-51": 2.046,
    "y-52": 2.046,
    "y-53": 2.046,
    "y-54": 2.046,
    "y-55": 2.046,
    "y-56": 2.046,
    "y-57": 2.046,
    "y-58": 2.046,
    "y-59": 2.023,
    "y-60": 2.007,
    "y-61": 2.007,
    "y-62": 2.007,
    "y-63": 2.007,
    "y-64": 2.007,
    "y-65": 2.007,
    "y-66": 2.007,
    "y-67": 2.007,
    "y-68": 2.007,
    "y-69": 2.007,
    "y-70": 2.007,
    "y-71": 2.007,
    "y-72": 2.007,
    "y-73": 2.007,
    "y-74": 2.007,
    "y-75": 2.007,
    "y-76": 2.007,
    "y-77": 2.007,
    "y-78": 2.007,
    "y-79": 2.007,
    "y-80": 2.007,
    "y-81": 2.007,
    "y-82": 2.007,
    "y-83": 2.007,
    "y-84": 2.007,
    "y-85": 2.007,
    "y-86": 2.007,
    "y-87": 2.007,
    "y-88": 2.001,
    "y-89": 2.001,
    "y-90": 2.001,
    "y-91": 2.002,
    "y-92": 2.007,
    "y-93": 2.007,
    "y-94": 2.006,
    "y-95": 2.006,
    "y-96": 2.009,
    "y-97": 2.006,
    "y-98": 2.007,
    "y-99": 2.007,
    "y-100": 2.007,
    "y-101": 2.0,
    "y-102": 1.999,
    "y-103": 1.999,
    "y-104": 1.999,
    "y-105": 1.999,
    "y-106": 1.998,
    "y-107": 1.999,
    "y-108": 1.999,
    "y-109": 1.999,
    "y-110": 1.999,
    "y-111": 1.999,
    "y-112": 1.999,
    "y-113": 1.999,
    "y-114": 2.0,
    "y-115": 1.999,
    "y-116": 2.002,
    "y-117": 2.002,
    "y-118": 2.002,
    "y-119": 2.002,
    "y-120": 2.002,
    "y-121": 2.002,
    "y-122": 2.002,
    "y-123": 2.002,
    "y-124": 2.002,
    "y-125": 2.002,
    "y-126": 2.002,
    "y-127": 2.002,
    "y-128": 2.002,
    "y-129": 2.002,
    "y-130": 2.002,
    "y-131": 2.002,
    "y-132": 2.002,
    "y-133": 2.002,
    "y-134": 2.002,
    "y-135": 2.002,
    "y-136": 2.002,
    "y-137": 2.002,
    "y-138": 2.002,
    "y-139": 2.002,
    "y-140": 2.002,
    "y-141": 2.002,
    "y-142": 2.002,
    "y-143": 2.002,
    "y-144": 2.002,
    "y-145": 2.002,
    "y-146": 2.002,
    "y-147": 2.002,
    "y-148": 2.002,
    "y-149": 2.002,
    "y-150": 2.002,
    "y-151": 2.002,
    "y-152": 2.002,
    "y-153": 2.002,
    "y-154": 2.0,
    "y-155": 2.0,
    "y-156": 2.0,
    "y-157": 1.999,
    "y-158": 1.999,
    "y-159": 1.999,
    "y-160": 1.999,
    "y-161": 1.999,
    "y-162": 1.999,
    "y-163": 1.999,
    "y-164": 1.999,
    "y-165": 1.999,
    "y-166": 1.999,
    "y-167": 1.999,
    "y-168": 1.999,
    "y-169": 1.999,
    "y-170": 1.999,
    "y-171": 1.999,
    "y-172": 2.0,
    "y-173": 2.0,
    "y-174": 2.0,
    "y-175": 2.0,
    "y-176": 2.0,
    "y-177": 2.0,
    "y-178": 2.0,
    "y-179": 2.0,
    "y-180": 2.0,
    "y-181": 2.0,
    "y-182": 2.0,
    "y-183": 2.0,
    "y-184": 2.0,
    "y-185": 2.001,
    "y-186": 2.001,
    "y-187": 2.0,
    "y-188": 2.0,
    "y-189": 2.0,
    "y-190": 1.999,
    "y-191": 1.999,
    "y-192": 1.999,
    "y-193": 1.999,
    "y-194": 2.0,
    "y-195": 2.0,
    "y-196": 2.0,
    "y-197": 2.0,
    "y-198": 2.0,
    "y-199": 2.0,
    "y-200": 2.0,
    "y-201": 2.0,
    "y-202": 2.0,
    "y-203": 2.0,
    "y-204": 2.0,
    "y-205": 2.0,
    "y-206": 2.0,
    "y-207": 2.0,
    "y-208": 2.0,
    "y-209": 2.0,
    "y-210": 2.0,
    "y-211": 2.0,
    "y-212": 2.0,
    "y-213": 2.0,
    "y-214": 2.001,
    "y-215": 2.001,
    "y-216": 2.001,
    "y-217": 2.001,
    "y-218": 2.001,
    "y-219": 2.0,
    "y-220": 2.0,
    "y-221": 2.001,
    "y-222": 2.001,
    "y-223": 2.001,
    "y-224": 2.001,
    "y-225": 2.001,
    "y-226": 1.999,
    "y-227": 1.999,
    "y-228": 1.999,
    "y-229": 2.0,
    "y-230": 2.0,
    "y-231": 2.0,
    "y-232": 2.0,
    "y-233": 1.999,
    "y-234": 1.999,
    "y-235": 1.999,
    "y-236": 1.999,
    "y-237": 1.999,
    "y-238": 1.999,
    "y-239": 1.999,
    "y-240": 1.999,
    "y-241": 1.999,
    "y-242": 1.999,
    "y-243": 1.999,
    "y-244": 1.999,
    "y-245": 1.999,
    "y-246": 1.999,
    "y-247": 1.999,
    "y-248": 1.999,
    "y-249": 1.999,
    "y-250": 1.999,
    "y-251": 1.999,
    "y-252": 1.999,
    "y-253": 1.999,
    "y-254": 1.999,
    "y-255": 1.999,
  },
  {
    x: -1.0,
    "y-2": 0.693,
    "y-12": 1.947,
    "y-46": 2.026,
    "y-1000": 2.0,
    "y-0": 0.592,
    "y-1": 0.698,
    "y-3": 1.437,
    "y-4": 2.222,
    "y-5": 2.266,
    "y-6": 2.107,
    "y-7": 1.943,
    "y-8": 1.947,
    "y-9": 1.947,
    "y-10": 1.947,
    "y-11": 1.947,
    "y-13": 1.965,
    "y-14": 1.965,
    "y-15": 1.965,
    "y-16": 1.965,
    "y-17": 1.965,
    "y-18": 1.965,
    "y-19": 1.965,
    "y-20": 1.965,
    "y-21": 1.965,
    "y-22": 1.965,
    "y-23": 1.965,
    "y-24": 1.965,
    "y-25": 1.965,
    "y-26": 1.965,
    "y-27": 1.965,
    "y-28": 1.965,
    "y-29": 1.965,
    "y-30": 1.965,
    "y-31": 1.965,
    "y-32": 1.971,
    "y-33": 1.971,
    "y-34": 1.971,
    "y-35": 2.026,
    "y-36": 2.026,
    "y-37": 2.026,
    "y-38": 2.026,
    "y-39": 2.026,
    "y-40": 2.026,
    "y-41": 2.026,
    "y-42": 2.026,
    "y-43": 2.026,
    "y-44": 2.026,
    "y-45": 2.026,
    "y-47": 2.026,
    "y-48": 2.026,
    "y-49": 2.026,
    "y-50": 2.026,
    "y-51": 2.026,
    "y-52": 2.026,
    "y-53": 2.026,
    "y-54": 2.026,
    "y-55": 2.026,
    "y-56": 2.026,
    "y-57": 2.026,
    "y-58": 2.026,
    "y-59": 2.009,
    "y-60": 2.0,
    "y-61": 2.0,
    "y-62": 2.0,
    "y-63": 2.0,
    "y-64": 2.0,
    "y-65": 2.0,
    "y-66": 2.0,
    "y-67": 2.0,
    "y-68": 2.0,
    "y-69": 2.0,
    "y-70": 2.0,
    "y-71": 2.0,
    "y-72": 2.0,
    "y-73": 2.0,
    "y-74": 2.0,
    "y-75": 2.0,
    "y-76": 2.0,
    "y-77": 2.0,
    "y-78": 2.0,
    "y-79": 2.0,
    "y-80": 2.0,
    "y-81": 2.0,
    "y-82": 2.0,
    "y-83": 2.0,
    "y-84": 2.0,
    "y-85": 2.0,
    "y-86": 2.0,
    "y-87": 2.0,
    "y-88": 2.0,
    "y-89": 2.0,
    "y-90": 2.0,
    "y-91": 2.0,
    "y-92": 2.0,
    "y-93": 2.0,
    "y-94": 2.0,
    "y-95": 2.0,
    "y-96": 2.0,
    "y-97": 2.0,
    "y-98": 2.0,
    "y-99": 2.0,
    "y-100": 2.0,
    "y-101": 2.0,
    "y-102": 2.0,
    "y-103": 2.0,
    "y-104": 2.0,
    "y-105": 2.0,
    "y-106": 2.0,
    "y-107": 2.0,
    "y-108": 2.0,
    "y-109": 2.0,
    "y-110": 2.0,
    "y-111": 2.0,
    "y-112": 2.0,
    "y-113": 2.0,
    "y-114": 2.0,
    "y-115": 2.0,
    "y-116": 2.0,
    "y-117": 2.0,
    "y-118": 2.0,
    "y-119": 2.0,
    "y-120": 2.0,
    "y-121": 2.0,
    "y-122": 2.0,
    "y-123": 2.0,
    "y-124": 2.0,
    "y-125": 2.0,
    "y-126": 2.0,
    "y-127": 2.0,
    "y-128": 2.0,
    "y-129": 2.0,
    "y-130": 2.0,
    "y-131": 2.0,
    "y-132": 2.0,
    "y-133": 2.0,
    "y-134": 2.0,
    "y-135": 2.0,
    "y-136": 2.0,
    "y-137": 2.0,
    "y-138": 2.0,
    "y-139": 2.0,
    "y-140": 2.0,
    "y-141": 2.0,
    "y-142": 2.0,
    "y-143": 2.0,
    "y-144": 2.0,
    "y-145": 2.0,
    "y-146": 2.0,
    "y-147": 2.0,
    "y-148": 2.0,
    "y-149": 2.0,
    "y-150": 2.0,
    "y-151": 2.0,
    "y-152": 2.0,
    "y-153": 2.0,
    "y-154": 2.0,
    "y-155": 2.0,
    "y-156": 2.0,
    "y-157": 2.0,
    "y-158": 2.0,
    "y-159": 2.0,
    "y-160": 2.0,
    "y-161": 2.0,
    "y-162": 2.0,
    "y-163": 2.0,
    "y-164": 2.0,
    "y-165": 2.0,
    "y-166": 2.0,
    "y-167": 2.0,
    "y-168": 2.0,
    "y-169": 2.0,
    "y-170": 2.0,
    "y-171": 2.0,
    "y-172": 2.0,
    "y-173": 2.0,
    "y-174": 2.0,
    "y-175": 2.0,
    "y-176": 2.0,
    "y-177": 2.0,
    "y-178": 2.0,
    "y-179": 2.0,
    "y-180": 2.0,
    "y-181": 2.0,
    "y-182": 2.0,
    "y-183": 2.0,
    "y-184": 2.0,
    "y-185": 2.0,
    "y-186": 2.0,
    "y-187": 2.0,
    "y-188": 2.0,
    "y-189": 2.0,
    "y-190": 2.0,
    "y-191": 2.0,
    "y-192": 2.0,
    "y-193": 2.0,
    "y-194": 2.0,
    "y-195": 2.0,
    "y-196": 2.0,
    "y-197": 2.0,
    "y-198": 2.0,
    "y-199": 2.0,
    "y-200": 2.0,
    "y-201": 2.0,
    "y-202": 2.0,
    "y-203": 2.0,
    "y-204": 2.0,
    "y-205": 2.0,
    "y-206": 2.0,
    "y-207": 2.0,
    "y-208": 2.0,
    "y-209": 2.0,
    "y-210": 2.0,
    "y-211": 2.0,
    "y-212": 2.0,
    "y-213": 2.0,
    "y-214": 2.0,
    "y-215": 2.0,
    "y-216": 2.0,
    "y-217": 2.0,
    "y-218": 2.0,
    "y-219": 2.0,
    "y-220": 2.0,
    "y-221": 2.0,
    "y-222": 2.0,
    "y-223": 2.0,
    "y-224": 2.0,
    "y-225": 2.0,
    "y-226": 2.0,
    "y-227": 2.0,
    "y-228": 2.0,
    "y-229": 2.0,
    "y-230": 2.0,
    "y-231": 2.0,
    "y-232": 2.0,
    "y-233": 2.0,
    "y-234": 2.0,
    "y-235": 2.0,
    "y-236": 2.0,
    "y-237": 2.0,
    "y-238": 2.0,
    "y-239": 2.0,
    "y-240": 2.0,
    "y-241": 2.0,
    "y-242": 2.0,
    "y-243": 2.0,
    "y-244": 2.0,
    "y-245": 2.0,
    "y-246": 2.0,
    "y-247": 2.0,
    "y-248": 2.0,
    "y-249": 2.0,
    "y-250": 2.0,
    "y-251": 2.0,
    "y-252": 2.0,
    "y-253": 2.0,
    "y-254": 2.0,
    "y-255": 2.0,
  },
  {
    x: -0.975,
    "y-2": 0.671,
    "y-12": 1.951,
    "y-46": 2.006,
    "y-1000": 1.998,
    "y-0": 0.579,
    "y-1": 0.673,
    "y-3": 1.48,
    "y-4": 2.181,
    "y-5": 2.241,
    "y-6": 2.097,
    "y-7": 1.95,
    "y-8": 1.951,
    "y-9": 1.951,
    "y-10": 1.951,
    "y-11": 1.951,
    "y-13": 1.957,
    "y-14": 1.957,
    "y-15": 1.957,
    "y-16": 1.957,
    "y-17": 1.957,
    "y-18": 1.957,
    "y-19": 1.957,
    "y-20": 1.957,
    "y-21": 1.957,
    "y-22": 1.957,
    "y-23": 1.957,
    "y-24": 1.957,
    "y-25": 1.957,
    "y-26": 1.957,
    "y-27": 1.957,
    "y-28": 1.957,
    "y-29": 1.957,
    "y-30": 1.957,
    "y-31": 1.957,
    "y-32": 1.957,
    "y-33": 1.957,
    "y-34": 1.957,
    "y-35": 2.006,
    "y-36": 2.006,
    "y-37": 2.006,
    "y-38": 2.006,
    "y-39": 2.005,
    "y-40": 2.005,
    "y-41": 2.005,
    "y-42": 2.005,
    "y-43": 2.005,
    "y-44": 2.006,
    "y-45": 2.006,
    "y-47": 2.005,
    "y-48": 2.005,
    "y-49": 2.006,
    "y-50": 2.006,
    "y-51": 2.005,
    "y-52": 2.005,
    "y-53": 2.005,
    "y-54": 2.006,
    "y-55": 2.005,
    "y-56": 2.006,
    "y-57": 2.005,
    "y-58": 2.005,
    "y-59": 1.995,
    "y-60": 1.993,
    "y-61": 1.993,
    "y-62": 1.993,
    "y-63": 1.993,
    "y-64": 1.993,
    "y-65": 1.993,
    "y-66": 1.993,
    "y-67": 1.993,
    "y-68": 1.993,
    "y-69": 1.993,
    "y-70": 1.993,
    "y-71": 1.993,
    "y-72": 1.993,
    "y-73": 1.993,
    "y-74": 1.993,
    "y-75": 1.993,
    "y-76": 1.993,
    "y-77": 1.993,
    "y-78": 1.993,
    "y-79": 1.993,
    "y-80": 1.993,
    "y-81": 1.993,
    "y-82": 1.993,
    "y-83": 1.993,
    "y-84": 1.993,
    "y-85": 1.993,
    "y-86": 1.993,
    "y-87": 1.993,
    "y-88": 1.999,
    "y-89": 1.999,
    "y-90": 1.999,
    "y-91": 1.998,
    "y-92": 1.993,
    "y-93": 1.993,
    "y-94": 1.994,
    "y-95": 1.994,
    "y-96": 1.991,
    "y-97": 1.994,
    "y-98": 1.993,
    "y-99": 1.993,
    "y-100": 1.993,
    "y-101": 1.999,
    "y-102": 2.0,
    "y-103": 2.0,
    "y-104": 2.0,
    "y-105": 2.001,
    "y-106": 2.001,
    "y-107": 2.0,
    "y-108": 2.0,
    "y-109": 2.0,
    "y-110": 2.0,
    "y-111": 2.0,
    "y-112": 2.0,
    "y-113": 2.0,
    "y-114": 2.0,
    "y-115": 2.0,
    "y-116": 1.997,
    "y-117": 1.997,
    "y-118": 1.997,
    "y-119": 1.997,
    "y-120": 1.997,
    "y-121": 1.997,
    "y-122": 1.997,
    "y-123": 1.997,
    "y-124": 1.997,
    "y-125": 1.997,
    "y-126": 1.997,
    "y-127": 1.997,
    "y-128": 1.997,
    "y-129": 1.997,
    "y-130": 1.997,
    "y-131": 1.997,
    "y-132": 1.997,
    "y-133": 1.997,
    "y-134": 1.997,
    "y-135": 1.997,
    "y-136": 1.997,
    "y-137": 1.997,
    "y-138": 1.997,
    "y-139": 1.997,
    "y-140": 1.997,
    "y-141": 1.997,
    "y-142": 1.997,
    "y-143": 1.997,
    "y-144": 1.997,
    "y-145": 1.997,
    "y-146": 1.997,
    "y-147": 1.998,
    "y-148": 1.998,
    "y-149": 1.998,
    "y-150": 1.998,
    "y-151": 1.998,
    "y-152": 1.998,
    "y-153": 1.998,
    "y-154": 1.999,
    "y-155": 1.999,
    "y-156": 1.999,
    "y-157": 2.0,
    "y-158": 2.0,
    "y-159": 2.0,
    "y-160": 2.0,
    "y-161": 2.0,
    "y-162": 2.0,
    "y-163": 2.0,
    "y-164": 2.0,
    "y-165": 2.0,
    "y-166": 2.0,
    "y-167": 2.0,
    "y-168": 2.0,
    "y-169": 2.0,
    "y-170": 2.0,
    "y-171": 2.0,
    "y-172": 1.999,
    "y-173": 1.999,
    "y-174": 1.999,
    "y-175": 1.999,
    "y-176": 1.999,
    "y-177": 1.999,
    "y-178": 1.999,
    "y-179": 1.999,
    "y-180": 1.999,
    "y-181": 1.999,
    "y-182": 1.999,
    "y-183": 1.999,
    "y-184": 1.999,
    "y-185": 1.999,
    "y-186": 1.999,
    "y-187": 1.999,
    "y-188": 1.999,
    "y-189": 1.999,
    "y-190": 2.0,
    "y-191": 2.0,
    "y-192": 2.0,
    "y-193": 2.0,
    "y-194": 1.999,
    "y-195": 1.999,
    "y-196": 1.999,
    "y-197": 1.999,
    "y-198": 1.999,
    "y-199": 1.999,
    "y-200": 1.999,
    "y-201": 1.999,
    "y-202": 1.999,
    "y-203": 1.999,
    "y-204": 1.999,
    "y-205": 1.999,
    "y-206": 1.999,
    "y-207": 1.999,
    "y-208": 1.999,
    "y-209": 1.999,
    "y-210": 1.999,
    "y-211": 1.999,
    "y-212": 1.999,
    "y-213": 1.999,
    "y-214": 1.999,
    "y-215": 1.999,
    "y-216": 1.999,
    "y-217": 1.999,
    "y-218": 1.999,
    "y-219": 1.999,
    "y-220": 2.0,
    "y-221": 1.998,
    "y-222": 1.998,
    "y-223": 1.998,
    "y-224": 1.998,
    "y-225": 1.998,
    "y-226": 2.0,
    "y-227": 2.0,
    "y-228": 2.0,
    "y-229": 2.0,
    "y-230": 2.0,
    "y-231": 2.0,
    "y-232": 2.0,
    "y-233": 2.001,
    "y-234": 2.001,
    "y-235": 2.001,
    "y-236": 2.001,
    "y-237": 2.001,
    "y-238": 2.0,
    "y-239": 2.0,
    "y-240": 1.998,
    "y-241": 1.998,
    "y-242": 1.998,
    "y-243": 1.998,
    "y-244": 1.998,
    "y-245": 1.998,
    "y-246": 1.998,
    "y-247": 1.998,
    "y-248": 1.998,
    "y-249": 1.998,
    "y-250": 1.998,
    "y-251": 1.998,
    "y-252": 1.998,
    "y-253": 1.998,
    "y-254": 1.998,
    "y-255": 1.998,
  },
  {
    x: -0.95,
    "y-2": 0.65,
    "y-12": 1.956,
    "y-46": 1.985,
    "y-1000": 1.989,
    "y-0": 0.567,
    "y-1": 0.648,
    "y-3": 1.523,
    "y-4": 2.14,
    "y-5": 2.216,
    "y-6": 2.088,
    "y-7": 1.956,
    "y-8": 1.956,
    "y-9": 1.956,
    "y-10": 1.956,
    "y-11": 1.956,
    "y-13": 1.949,
    "y-14": 1.949,
    "y-15": 1.949,
    "y-16": 1.949,
    "y-17": 1.949,
    "y-18": 1.949,
    "y-19": 1.949,
    "y-20": 1.949,
    "y-21": 1.949,
    "y-22": 1.949,
    "y-23": 1.949,
    "y-24": 1.949,
    "y-25": 1.949,
    "y-26": 1.949,
    "y-27": 1.949,
    "y-28": 1.949,
    "y-29": 1.949,
    "y-30": 1.949,
    "y-31": 1.949,
    "y-32": 1.944,
    "y-33": 1.944,
    "y-34": 1.944,
    "y-35": 1.985,
    "y-36": 1.985,
    "y-37": 1.985,
    "y-38": 1.985,
    "y-39": 1.985,
    "y-40": 1.985,
    "y-41": 1.985,
    "y-42": 1.985,
    "y-43": 1.985,
    "y-44": 1.985,
    "y-45": 1.985,
    "y-47": 1.985,
    "y-48": 1.985,
    "y-49": 1.985,
    "y-50": 1.985,
    "y-51": 1.985,
    "y-52": 1.985,
    "y-53": 1.985,
    "y-54": 1.985,
    "y-55": 1.985,
    "y-56": 1.985,
    "y-57": 1.985,
    "y-58": 1.985,
    "y-59": 1.981,
    "y-60": 1.986,
    "y-61": 1.986,
    "y-62": 1.986,
    "y-63": 1.986,
    "y-64": 1.986,
    "y-65": 1.986,
    "y-66": 1.985,
    "y-67": 1.986,
    "y-68": 1.985,
    "y-69": 1.986,
    "y-70": 1.986,
    "y-71": 1.986,
    "y-72": 1.986,
    "y-73": 1.986,
    "y-74": 1.986,
    "y-75": 1.985,
    "y-76": 1.986,
    "y-77": 1.986,
    "y-78": 1.986,
    "y-79": 1.985,
    "y-80": 1.985,
    "y-81": 1.985,
    "y-82": 1.986,
    "y-83": 1.985,
    "y-84": 1.986,
    "y-85": 1.985,
    "y-86": 1.985,
    "y-87": 1.985,
    "y-88": 1.999,
    "y-89": 1.998,
    "y-90": 1.997,
    "y-91": 1.996,
    "y-92": 1.986,
    "y-93": 1.987,
    "y-94": 1.987,
    "y-95": 1.987,
    "y-96": 1.983,
    "y-97": 1.987,
    "y-98": 1.986,
    "y-99": 1.987,
    "y-100": 1.987,
    "y-101": 1.99,
    "y-102": 1.99,
    "y-103": 1.99,
    "y-104": 1.99,
    "y-105": 1.991,
    "y-106": 1.99,
    "y-107": 1.99,
    "y-108": 1.99,
    "y-109": 1.99,
    "y-110": 1.99,
    "y-111": 1.99,
    "y-112": 1.99,
    "y-113": 1.99,
    "y-114": 1.99,
    "y-115": 1.99,
    "y-116": 1.988,
    "y-117": 1.988,
    "y-118": 1.988,
    "y-119": 1.988,
    "y-120": 1.988,
    "y-121": 1.988,
    "y-122": 1.988,
    "y-123": 1.988,
    "y-124": 1.988,
    "y-125": 1.988,
    "y-126": 1.988,
    "y-127": 1.988,
    "y-128": 1.988,
    "y-129": 1.988,
    "y-130": 1.988,
    "y-131": 1.988,
    "y-132": 1.988,
    "y-133": 1.988,
    "y-134": 1.988,
    "y-135": 1.988,
    "y-136": 1.988,
    "y-137": 1.988,
    "y-138": 1.988,
    "y-139": 1.988,
    "y-140": 1.988,
    "y-141": 1.988,
    "y-142": 1.988,
    "y-143": 1.988,
    "y-144": 1.988,
    "y-145": 1.988,
    "y-146": 1.988,
    "y-147": 1.989,
    "y-148": 1.989,
    "y-149": 1.989,
    "y-150": 1.989,
    "y-151": 1.989,
    "y-152": 1.989,
    "y-153": 1.989,
    "y-154": 1.99,
    "y-155": 1.99,
    "y-156": 1.99,
    "y-157": 1.99,
    "y-158": 1.991,
    "y-159": 1.991,
    "y-160": 1.991,
    "y-161": 1.991,
    "y-162": 1.991,
    "y-163": 1.991,
    "y-164": 1.991,
    "y-165": 1.991,
    "y-166": 1.991,
    "y-167": 1.991,
    "y-168": 1.991,
    "y-169": 1.991,
    "y-170": 1.991,
    "y-171": 1.991,
    "y-172": 1.99,
    "y-173": 1.99,
    "y-174": 1.99,
    "y-175": 1.99,
    "y-176": 1.99,
    "y-177": 1.99,
    "y-178": 1.99,
    "y-179": 1.99,
    "y-180": 1.99,
    "y-181": 1.99,
    "y-182": 1.99,
    "y-183": 1.99,
    "y-184": 1.99,
    "y-185": 1.99,
    "y-186": 1.99,
    "y-187": 1.99,
    "y-188": 1.99,
    "y-189": 1.99,
    "y-190": 1.993,
    "y-191": 1.993,
    "y-192": 1.993,
    "y-193": 1.993,
    "y-194": 1.992,
    "y-195": 1.992,
    "y-196": 1.991,
    "y-197": 1.991,
    "y-198": 1.991,
    "y-199": 1.991,
    "y-200": 1.991,
    "y-201": 1.991,
    "y-202": 1.991,
    "y-203": 1.991,
    "y-204": 1.991,
    "y-205": 1.991,
    "y-206": 1.991,
    "y-207": 1.991,
    "y-208": 1.991,
    "y-209": 1.991,
    "y-210": 1.991,
    "y-211": 1.991,
    "y-212": 1.991,
    "y-213": 1.991,
    "y-214": 1.99,
    "y-215": 1.99,
    "y-216": 1.99,
    "y-217": 1.99,
    "y-218": 1.99,
    "y-219": 1.991,
    "y-220": 1.991,
    "y-221": 1.99,
    "y-222": 1.99,
    "y-223": 1.99,
    "y-224": 1.99,
    "y-225": 1.99,
    "y-226": 1.991,
    "y-227": 1.991,
    "y-228": 1.991,
    "y-229": 1.991,
    "y-230": 1.991,
    "y-231": 1.991,
    "y-232": 1.991,
    "y-233": 1.991,
    "y-234": 1.991,
    "y-235": 1.991,
    "y-236": 1.991,
    "y-237": 1.991,
    "y-238": 1.991,
    "y-239": 1.991,
    "y-240": 1.988,
    "y-241": 1.988,
    "y-242": 1.988,
    "y-243": 1.989,
    "y-244": 1.989,
    "y-245": 1.989,
    "y-246": 1.989,
    "y-247": 1.989,
    "y-248": 1.989,
    "y-249": 1.989,
    "y-250": 1.989,
    "y-251": 1.989,
    "y-252": 1.989,
    "y-253": 1.989,
    "y-254": 1.989,
    "y-255": 1.989,
  },
  {
    x: -0.925,
    "y-2": 0.629,
    "y-12": 1.96,
    "y-46": 1.965,
    "y-1000": 1.98,
    "y-0": 0.555,
    "y-1": 0.624,
    "y-3": 1.566,
    "y-4": 2.099,
    "y-5": 2.191,
    "y-6": 2.078,
    "y-7": 1.962,
    "y-8": 1.96,
    "y-9": 1.96,
    "y-10": 1.96,
    "y-11": 1.96,
    "y-13": 1.942,
    "y-14": 1.942,
    "y-15": 1.942,
    "y-16": 1.942,
    "y-17": 1.942,
    "y-18": 1.942,
    "y-19": 1.942,
    "y-20": 1.942,
    "y-21": 1.942,
    "y-22": 1.942,
    "y-23": 1.942,
    "y-24": 1.942,
    "y-25": 1.942,
    "y-26": 1.942,
    "y-27": 1.942,
    "y-28": 1.942,
    "y-29": 1.942,
    "y-30": 1.942,
    "y-31": 1.942,
    "y-32": 1.93,
    "y-33": 1.93,
    "y-34": 1.93,
    "y-35": 1.965,
    "y-36": 1.965,
    "y-37": 1.965,
    "y-38": 1.965,
    "y-39": 1.965,
    "y-40": 1.965,
    "y-41": 1.965,
    "y-42": 1.965,
    "y-43": 1.965,
    "y-44": 1.965,
    "y-45": 1.965,
    "y-47": 1.965,
    "y-48": 1.965,
    "y-49": 1.965,
    "y-50": 1.965,
    "y-51": 1.965,
    "y-52": 1.965,
    "y-53": 1.965,
    "y-54": 1.965,
    "y-55": 1.965,
    "y-56": 1.965,
    "y-57": 1.965,
    "y-58": 1.965,
    "y-59": 1.967,
    "y-60": 1.978,
    "y-61": 1.978,
    "y-62": 1.978,
    "y-63": 1.978,
    "y-64": 1.978,
    "y-65": 1.978,
    "y-66": 1.978,
    "y-67": 1.978,
    "y-68": 1.978,
    "y-69": 1.978,
    "y-70": 1.978,
    "y-71": 1.978,
    "y-72": 1.978,
    "y-73": 1.978,
    "y-74": 1.978,
    "y-75": 1.978,
    "y-76": 1.978,
    "y-77": 1.978,
    "y-78": 1.978,
    "y-79": 1.978,
    "y-80": 1.978,
    "y-81": 1.978,
    "y-82": 1.978,
    "y-83": 1.978,
    "y-84": 1.978,
    "y-85": 1.978,
    "y-86": 1.978,
    "y-87": 1.978,
    "y-88": 1.998,
    "y-89": 1.997,
    "y-90": 1.996,
    "y-91": 1.994,
    "y-92": 1.98,
    "y-93": 1.98,
    "y-94": 1.981,
    "y-95": 1.981,
    "y-96": 1.974,
    "y-97": 1.981,
    "y-98": 1.979,
    "y-99": 1.98,
    "y-100": 1.98,
    "y-101": 1.981,
    "y-102": 1.98,
    "y-103": 1.98,
    "y-104": 1.98,
    "y-105": 1.981,
    "y-106": 1.98,
    "y-107": 1.98,
    "y-108": 1.98,
    "y-109": 1.98,
    "y-110": 1.98,
    "y-111": 1.98,
    "y-112": 1.98,
    "y-113": 1.98,
    "y-114": 1.98,
    "y-115": 1.98,
    "y-116": 1.979,
    "y-117": 1.979,
    "y-118": 1.979,
    "y-119": 1.979,
    "y-120": 1.979,
    "y-121": 1.979,
    "y-122": 1.979,
    "y-123": 1.979,
    "y-124": 1.979,
    "y-125": 1.979,
    "y-126": 1.979,
    "y-127": 1.979,
    "y-128": 1.979,
    "y-129": 1.979,
    "y-130": 1.979,
    "y-131": 1.979,
    "y-132": 1.979,
    "y-133": 1.979,
    "y-134": 1.979,
    "y-135": 1.979,
    "y-136": 1.979,
    "y-137": 1.979,
    "y-138": 1.979,
    "y-139": 1.979,
    "y-140": 1.979,
    "y-141": 1.979,
    "y-142": 1.979,
    "y-143": 1.979,
    "y-144": 1.979,
    "y-145": 1.979,
    "y-146": 1.979,
    "y-147": 1.981,
    "y-148": 1.981,
    "y-149": 1.98,
    "y-150": 1.98,
    "y-151": 1.98,
    "y-152": 1.98,
    "y-153": 1.98,
    "y-154": 1.981,
    "y-155": 1.981,
    "y-156": 1.981,
    "y-157": 1.981,
    "y-158": 1.981,
    "y-159": 1.981,
    "y-160": 1.981,
    "y-161": 1.981,
    "y-162": 1.981,
    "y-163": 1.981,
    "y-164": 1.981,
    "y-165": 1.981,
    "y-166": 1.981,
    "y-167": 1.981,
    "y-168": 1.981,
    "y-169": 1.981,
    "y-170": 1.981,
    "y-171": 1.981,
    "y-172": 1.981,
    "y-173": 1.981,
    "y-174": 1.981,
    "y-175": 1.981,
    "y-176": 1.981,
    "y-177": 1.981,
    "y-178": 1.981,
    "y-179": 1.981,
    "y-180": 1.981,
    "y-181": 1.981,
    "y-182": 1.981,
    "y-183": 1.981,
    "y-184": 1.981,
    "y-185": 1.981,
    "y-186": 1.981,
    "y-187": 1.981,
    "y-188": 1.981,
    "y-189": 1.981,
    "y-190": 1.982,
    "y-191": 1.982,
    "y-192": 1.982,
    "y-193": 1.982,
    "y-194": 1.98,
    "y-195": 1.98,
    "y-196": 1.98,
    "y-197": 1.98,
    "y-198": 1.98,
    "y-199": 1.98,
    "y-200": 1.98,
    "y-201": 1.98,
    "y-202": 1.98,
    "y-203": 1.98,
    "y-204": 1.98,
    "y-205": 1.98,
    "y-206": 1.98,
    "y-207": 1.98,
    "y-208": 1.98,
    "y-209": 1.98,
    "y-210": 1.98,
    "y-211": 1.98,
    "y-212": 1.98,
    "y-213": 1.98,
    "y-214": 1.979,
    "y-215": 1.979,
    "y-216": 1.979,
    "y-217": 1.979,
    "y-218": 1.979,
    "y-219": 1.979,
    "y-220": 1.98,
    "y-221": 1.979,
    "y-222": 1.979,
    "y-223": 1.979,
    "y-224": 1.979,
    "y-225": 1.979,
    "y-226": 1.98,
    "y-227": 1.979,
    "y-228": 1.979,
    "y-229": 1.979,
    "y-230": 1.979,
    "y-231": 1.979,
    "y-232": 1.979,
    "y-233": 1.979,
    "y-234": 1.979,
    "y-235": 1.979,
    "y-236": 1.979,
    "y-237": 1.979,
    "y-238": 1.979,
    "y-239": 1.979,
    "y-240": 1.977,
    "y-241": 1.977,
    "y-242": 1.977,
    "y-243": 1.978,
    "y-244": 1.978,
    "y-245": 1.978,
    "y-246": 1.978,
    "y-247": 1.978,
    "y-248": 1.978,
    "y-249": 1.978,
    "y-250": 1.978,
    "y-251": 1.978,
    "y-252": 1.978,
    "y-253": 1.978,
    "y-254": 1.977,
    "y-255": 1.977,
  },
  {
    x: -0.9,
    "y-2": 0.607,
    "y-12": 1.964,
    "y-46": 1.945,
    "y-1000": 1.971,
    "y-0": 0.543,
    "y-1": 0.599,
    "y-3": 1.609,
    "y-4": 2.059,
    "y-5": 2.166,
    "y-6": 2.069,
    "y-7": 1.968,
    "y-8": 1.964,
    "y-9": 1.964,
    "y-10": 1.964,
    "y-11": 1.964,
    "y-13": 1.934,
    "y-14": 1.934,
    "y-15": 1.934,
    "y-16": 1.934,
    "y-17": 1.934,
    "y-18": 1.934,
    "y-19": 1.934,
    "y-20": 1.934,
    "y-21": 1.934,
    "y-22": 1.934,
    "y-23": 1.934,
    "y-24": 1.934,
    "y-25": 1.934,
    "y-26": 1.934,
    "y-27": 1.934,
    "y-28": 1.934,
    "y-29": 1.934,
    "y-30": 1.934,
    "y-31": 1.934,
    "y-32": 1.917,
    "y-33": 1.917,
    "y-34": 1.917,
    "y-35": 1.945,
    "y-36": 1.945,
    "y-37": 1.945,
    "y-38": 1.945,
    "y-39": 1.945,
    "y-40": 1.945,
    "y-41": 1.945,
    "y-42": 1.945,
    "y-43": 1.945,
    "y-44": 1.945,
    "y-45": 1.945,
    "y-47": 1.945,
    "y-48": 1.945,
    "y-49": 1.945,
    "y-50": 1.945,
    "y-51": 1.945,
    "y-52": 1.945,
    "y-53": 1.945,
    "y-54": 1.945,
    "y-55": 1.945,
    "y-56": 1.945,
    "y-57": 1.945,
    "y-58": 1.945,
    "y-59": 1.953,
    "y-60": 1.971,
    "y-61": 1.971,
    "y-62": 1.971,
    "y-63": 1.971,
    "y-64": 1.971,
    "y-65": 1.971,
    "y-66": 1.971,
    "y-67": 1.971,
    "y-68": 1.971,
    "y-69": 1.971,
    "y-70": 1.971,
    "y-71": 1.971,
    "y-72": 1.971,
    "y-73": 1.971,
    "y-74": 1.971,
    "y-75": 1.971,
    "y-76": 1.971,
    "y-77": 1.971,
    "y-78": 1.971,
    "y-79": 1.971,
    "y-80": 1.971,
    "y-81": 1.971,
    "y-82": 1.971,
    "y-83": 1.971,
    "y-84": 1.971,
    "y-85": 1.971,
    "y-86": 1.971,
    "y-87": 1.971,
    "y-88": 1.971,
    "y-89": 1.971,
    "y-90": 1.971,
    "y-91": 1.971,
    "y-92": 1.971,
    "y-93": 1.971,
    "y-94": 1.971,
    "y-95": 1.971,
    "y-96": 1.971,
    "y-97": 1.971,
    "y-98": 1.971,
    "y-99": 1.971,
    "y-100": 1.971,
    "y-101": 1.971,
    "y-102": 1.971,
    "y-103": 1.971,
    "y-104": 1.971,
    "y-105": 1.971,
    "y-106": 1.971,
    "y-107": 1.971,
    "y-108": 1.971,
    "y-109": 1.971,
    "y-110": 1.971,
    "y-111": 1.971,
    "y-112": 1.971,
    "y-113": 1.971,
    "y-114": 1.971,
    "y-115": 1.971,
    "y-116": 1.971,
    "y-117": 1.971,
    "y-118": 1.971,
    "y-119": 1.971,
    "y-120": 1.971,
    "y-121": 1.971,
    "y-122": 1.971,
    "y-123": 1.971,
    "y-124": 1.971,
    "y-125": 1.971,
    "y-126": 1.971,
    "y-127": 1.971,
    "y-128": 1.971,
    "y-129": 1.971,
    "y-130": 1.971,
    "y-131": 1.971,
    "y-132": 1.971,
    "y-133": 1.971,
    "y-134": 1.971,
    "y-135": 1.971,
    "y-136": 1.971,
    "y-137": 1.971,
    "y-138": 1.971,
    "y-139": 1.971,
    "y-140": 1.971,
    "y-141": 1.971,
    "y-142": 1.971,
    "y-143": 1.971,
    "y-144": 1.971,
    "y-145": 1.971,
    "y-146": 1.971,
    "y-147": 1.971,
    "y-148": 1.971,
    "y-149": 1.971,
    "y-150": 1.971,
    "y-151": 1.971,
    "y-152": 1.971,
    "y-153": 1.971,
    "y-154": 1.971,
    "y-155": 1.971,
    "y-156": 1.971,
    "y-157": 1.971,
    "y-158": 1.971,
    "y-159": 1.971,
    "y-160": 1.971,
    "y-161": 1.971,
    "y-162": 1.971,
    "y-163": 1.971,
    "y-164": 1.971,
    "y-165": 1.971,
    "y-166": 1.971,
    "y-167": 1.971,
    "y-168": 1.971,
    "y-169": 1.971,
    "y-170": 1.971,
    "y-171": 1.971,
    "y-172": 1.971,
    "y-173": 1.971,
    "y-174": 1.971,
    "y-175": 1.971,
    "y-176": 1.971,
    "y-177": 1.971,
    "y-178": 1.971,
    "y-179": 1.971,
    "y-180": 1.971,
    "y-181": 1.971,
    "y-182": 1.971,
    "y-183": 1.971,
    "y-184": 1.971,
    "y-185": 1.971,
    "y-186": 1.971,
    "y-187": 1.971,
    "y-188": 1.971,
    "y-189": 1.971,
    "y-190": 1.971,
    "y-191": 1.971,
    "y-192": 1.971,
    "y-193": 1.971,
    "y-194": 1.971,
    "y-195": 1.971,
    "y-196": 1.971,
    "y-197": 1.971,
    "y-198": 1.971,
    "y-199": 1.971,
    "y-200": 1.971,
    "y-201": 1.971,
    "y-202": 1.971,
    "y-203": 1.971,
    "y-204": 1.971,
    "y-205": 1.971,
    "y-206": 1.971,
    "y-207": 1.971,
    "y-208": 1.971,
    "y-209": 1.971,
    "y-210": 1.971,
    "y-211": 1.971,
    "y-212": 1.971,
    "y-213": 1.971,
    "y-214": 1.971,
    "y-215": 1.971,
    "y-216": 1.971,
    "y-217": 1.971,
    "y-218": 1.971,
    "y-219": 1.971,
    "y-220": 1.971,
    "y-221": 1.971,
    "y-222": 1.971,
    "y-223": 1.971,
    "y-224": 1.971,
    "y-225": 1.971,
    "y-226": 1.971,
    "y-227": 1.971,
    "y-228": 1.971,
    "y-229": 1.971,
    "y-230": 1.971,
    "y-231": 1.971,
    "y-232": 1.971,
    "y-233": 1.971,
    "y-234": 1.971,
    "y-235": 1.971,
    "y-236": 1.971,
    "y-237": 1.971,
    "y-238": 1.971,
    "y-239": 1.971,
    "y-240": 1.971,
    "y-241": 1.971,
    "y-242": 1.971,
    "y-243": 1.971,
    "y-244": 1.971,
    "y-245": 1.971,
    "y-246": 1.971,
    "y-247": 1.971,
    "y-248": 1.971,
    "y-249": 1.971,
    "y-250": 1.971,
    "y-251": 1.971,
    "y-252": 1.971,
    "y-253": 1.971,
    "y-254": 1.971,
    "y-255": 1.971,
  },
  {
    x: -0.875,
    "y-2": 0.586,
    "y-12": 1.968,
    "y-46": 1.924,
    "y-1000": 1.964,
    "y-0": 0.531,
    "y-1": 0.575,
    "y-3": 1.652,
    "y-4": 2.018,
    "y-5": 2.141,
    "y-6": 2.059,
    "y-7": 1.975,
    "y-8": 1.968,
    "y-9": 1.968,
    "y-10": 1.968,
    "y-11": 1.968,
    "y-13": 1.927,
    "y-14": 1.927,
    "y-15": 1.927,
    "y-16": 1.927,
    "y-17": 1.927,
    "y-18": 1.927,
    "y-19": 1.927,
    "y-20": 1.927,
    "y-21": 1.927,
    "y-22": 1.927,
    "y-23": 1.927,
    "y-24": 1.927,
    "y-25": 1.927,
    "y-26": 1.927,
    "y-27": 1.927,
    "y-28": 1.927,
    "y-29": 1.927,
    "y-30": 1.927,
    "y-31": 1.927,
    "y-32": 1.904,
    "y-33": 1.904,
    "y-34": 1.904,
    "y-35": 1.924,
    "y-36": 1.924,
    "y-37": 1.924,
    "y-38": 1.924,
    "y-39": 1.924,
    "y-40": 1.924,
    "y-41": 1.924,
    "y-42": 1.924,
    "y-43": 1.924,
    "y-44": 1.924,
    "y-45": 1.924,
    "y-47": 1.924,
    "y-48": 1.924,
    "y-49": 1.924,
    "y-50": 1.924,
    "y-51": 1.924,
    "y-52": 1.924,
    "y-53": 1.924,
    "y-54": 1.924,
    "y-55": 1.924,
    "y-56": 1.924,
    "y-57": 1.924,
    "y-58": 1.924,
    "y-59": 1.939,
    "y-60": 1.964,
    "y-61": 1.964,
    "y-62": 1.964,
    "y-63": 1.964,
    "y-64": 1.964,
    "y-65": 1.964,
    "y-66": 1.964,
    "y-67": 1.964,
    "y-68": 1.964,
    "y-69": 1.964,
    "y-70": 1.964,
    "y-71": 1.964,
    "y-72": 1.964,
    "y-73": 1.964,
    "y-74": 1.964,
    "y-75": 1.964,
    "y-76": 1.964,
    "y-77": 1.964,
    "y-78": 1.964,
    "y-79": 1.964,
    "y-80": 1.964,
    "y-81": 1.964,
    "y-82": 1.964,
    "y-83": 1.964,
    "y-84": 1.964,
    "y-85": 1.964,
    "y-86": 1.964,
    "y-87": 1.964,
    "y-88": 1.942,
    "y-89": 1.944,
    "y-90": 1.944,
    "y-91": 1.947,
    "y-92": 1.962,
    "y-93": 1.962,
    "y-94": 1.961,
    "y-95": 1.961,
    "y-96": 1.968,
    "y-97": 1.961,
    "y-98": 1.963,
    "y-99": 1.962,
    "y-100": 1.962,
    "y-101": 1.961,
    "y-102": 1.962,
    "y-103": 1.962,
    "y-104": 1.962,
    "y-105": 1.961,
    "y-106": 1.962,
    "y-107": 1.962,
    "y-108": 1.962,
    "y-109": 1.962,
    "y-110": 1.962,
    "y-111": 1.963,
    "y-112": 1.962,
    "y-113": 1.962,
    "y-114": 1.962,
    "y-115": 1.962,
    "y-116": 1.963,
    "y-117": 1.963,
    "y-118": 1.963,
    "y-119": 1.963,
    "y-120": 1.963,
    "y-121": 1.963,
    "y-122": 1.963,
    "y-123": 1.963,
    "y-124": 1.963,
    "y-125": 1.963,
    "y-126": 1.963,
    "y-127": 1.963,
    "y-128": 1.963,
    "y-129": 1.963,
    "y-130": 1.963,
    "y-131": 1.963,
    "y-132": 1.963,
    "y-133": 1.963,
    "y-134": 1.963,
    "y-135": 1.963,
    "y-136": 1.963,
    "y-137": 1.963,
    "y-138": 1.963,
    "y-139": 1.963,
    "y-140": 1.963,
    "y-141": 1.963,
    "y-142": 1.963,
    "y-143": 1.963,
    "y-144": 1.963,
    "y-145": 1.963,
    "y-146": 1.963,
    "y-147": 1.96,
    "y-148": 1.96,
    "y-149": 1.962,
    "y-150": 1.962,
    "y-151": 1.962,
    "y-152": 1.962,
    "y-153": 1.962,
    "y-154": 1.961,
    "y-155": 1.961,
    "y-156": 1.961,
    "y-157": 1.961,
    "y-158": 1.961,
    "y-159": 1.961,
    "y-160": 1.961,
    "y-161": 1.961,
    "y-162": 1.961,
    "y-163": 1.961,
    "y-164": 1.961,
    "y-165": 1.961,
    "y-166": 1.961,
    "y-167": 1.961,
    "y-168": 1.961,
    "y-169": 1.961,
    "y-170": 1.961,
    "y-171": 1.961,
    "y-172": 1.961,
    "y-173": 1.961,
    "y-174": 1.961,
    "y-175": 1.961,
    "y-176": 1.961,
    "y-177": 1.961,
    "y-178": 1.961,
    "y-179": 1.961,
    "y-180": 1.961,
    "y-181": 1.961,
    "y-182": 1.961,
    "y-183": 1.961,
    "y-184": 1.961,
    "y-185": 1.962,
    "y-186": 1.962,
    "y-187": 1.962,
    "y-188": 1.962,
    "y-189": 1.962,
    "y-190": 1.962,
    "y-191": 1.962,
    "y-192": 1.962,
    "y-193": 1.962,
    "y-194": 1.965,
    "y-195": 1.965,
    "y-196": 1.965,
    "y-197": 1.965,
    "y-198": 1.965,
    "y-199": 1.965,
    "y-200": 1.965,
    "y-201": 1.965,
    "y-202": 1.966,
    "y-203": 1.966,
    "y-204": 1.966,
    "y-205": 1.966,
    "y-206": 1.966,
    "y-207": 1.966,
    "y-208": 1.966,
    "y-209": 1.966,
    "y-210": 1.966,
    "y-211": 1.966,
    "y-212": 1.966,
    "y-213": 1.966,
    "y-214": 1.969,
    "y-215": 1.969,
    "y-216": 1.969,
    "y-217": 1.969,
    "y-218": 1.969,
    "y-219": 1.968,
    "y-220": 1.967,
    "y-221": 1.968,
    "y-222": 1.968,
    "y-223": 1.968,
    "y-224": 1.968,
    "y-225": 1.968,
    "y-226": 1.968,
    "y-227": 1.968,
    "y-228": 1.968,
    "y-229": 1.969,
    "y-230": 1.969,
    "y-231": 1.969,
    "y-232": 1.969,
    "y-233": 1.969,
    "y-234": 1.969,
    "y-235": 1.969,
    "y-236": 1.969,
    "y-237": 1.969,
    "y-238": 1.97,
    "y-239": 1.97,
    "y-240": 1.971,
    "y-241": 1.971,
    "y-242": 1.971,
    "y-243": 1.97,
    "y-244": 1.97,
    "y-245": 1.97,
    "y-246": 1.97,
    "y-247": 1.97,
    "y-248": 1.97,
    "y-249": 1.969,
    "y-250": 1.969,
    "y-251": 1.969,
    "y-252": 1.969,
    "y-253": 1.969,
    "y-254": 1.97,
    "y-255": 1.97,
  },
  {
    x: -0.85,
    "y-2": 0.565,
    "y-12": 1.972,
    "y-46": 1.904,
    "y-1000": 1.951,
    "y-0": 0.518,
    "y-1": 0.55,
    "y-3": 1.695,
    "y-4": 1.977,
    "y-5": 2.116,
    "y-6": 2.049,
    "y-7": 1.981,
    "y-8": 1.972,
    "y-9": 1.972,
    "y-10": 1.972,
    "y-11": 1.972,
    "y-13": 1.919,
    "y-14": 1.919,
    "y-15": 1.919,
    "y-16": 1.919,
    "y-17": 1.919,
    "y-18": 1.919,
    "y-19": 1.919,
    "y-20": 1.919,
    "y-21": 1.919,
    "y-22": 1.919,
    "y-23": 1.919,
    "y-24": 1.919,
    "y-25": 1.919,
    "y-26": 1.919,
    "y-27": 1.919,
    "y-28": 1.919,
    "y-29": 1.919,
    "y-30": 1.919,
    "y-31": 1.919,
    "y-32": 1.89,
    "y-33": 1.89,
    "y-34": 1.89,
    "y-35": 1.904,
    "y-36": 1.904,
    "y-37": 1.904,
    "y-38": 1.904,
    "y-39": 1.904,
    "y-40": 1.904,
    "y-41": 1.904,
    "y-42": 1.904,
    "y-43": 1.904,
    "y-44": 1.904,
    "y-45": 1.904,
    "y-47": 1.904,
    "y-48": 1.904,
    "y-49": 1.904,
    "y-50": 1.904,
    "y-51": 1.904,
    "y-52": 1.904,
    "y-53": 1.904,
    "y-54": 1.904,
    "y-55": 1.904,
    "y-56": 1.904,
    "y-57": 1.904,
    "y-58": 1.904,
    "y-59": 1.925,
    "y-60": 1.942,
    "y-61": 1.942,
    "y-62": 1.942,
    "y-63": 1.942,
    "y-64": 1.942,
    "y-65": 1.942,
    "y-66": 1.942,
    "y-67": 1.942,
    "y-68": 1.942,
    "y-69": 1.942,
    "y-70": 1.942,
    "y-71": 1.942,
    "y-72": 1.942,
    "y-73": 1.942,
    "y-74": 1.942,
    "y-75": 1.942,
    "y-76": 1.942,
    "y-77": 1.942,
    "y-78": 1.942,
    "y-79": 1.942,
    "y-80": 1.942,
    "y-81": 1.942,
    "y-82": 1.942,
    "y-83": 1.942,
    "y-84": 1.942,
    "y-85": 1.942,
    "y-86": 1.942,
    "y-87": 1.942,
    "y-88": 1.922,
    "y-89": 1.924,
    "y-90": 1.924,
    "y-91": 1.926,
    "y-92": 1.941,
    "y-93": 1.94,
    "y-94": 1.94,
    "y-95": 1.94,
    "y-96": 1.946,
    "y-97": 1.939,
    "y-98": 1.941,
    "y-99": 1.94,
    "y-100": 1.94,
    "y-101": 1.939,
    "y-102": 1.94,
    "y-103": 1.941,
    "y-104": 1.94,
    "y-105": 1.939,
    "y-106": 1.94,
    "y-107": 1.941,
    "y-108": 1.941,
    "y-109": 1.941,
    "y-110": 1.941,
    "y-111": 1.941,
    "y-112": 1.941,
    "y-113": 1.941,
    "y-114": 1.941,
    "y-115": 1.941,
    "y-116": 1.942,
    "y-117": 1.941,
    "y-118": 1.942,
    "y-119": 1.942,
    "y-120": 1.941,
    "y-121": 1.941,
    "y-122": 1.942,
    "y-123": 1.941,
    "y-124": 1.941,
    "y-125": 1.941,
    "y-126": 1.941,
    "y-127": 1.941,
    "y-128": 1.941,
    "y-129": 1.941,
    "y-130": 1.941,
    "y-131": 1.941,
    "y-132": 1.941,
    "y-133": 1.941,
    "y-134": 1.941,
    "y-135": 1.941,
    "y-136": 1.941,
    "y-137": 1.941,
    "y-138": 1.941,
    "y-139": 1.941,
    "y-140": 1.941,
    "y-141": 1.941,
    "y-142": 1.941,
    "y-143": 1.941,
    "y-144": 1.941,
    "y-145": 1.941,
    "y-146": 1.941,
    "y-147": 1.94,
    "y-148": 1.94,
    "y-149": 1.946,
    "y-150": 1.946,
    "y-151": 1.946,
    "y-152": 1.946,
    "y-153": 1.946,
    "y-154": 1.946,
    "y-155": 1.946,
    "y-156": 1.946,
    "y-157": 1.946,
    "y-158": 1.946,
    "y-159": 1.946,
    "y-160": 1.946,
    "y-161": 1.946,
    "y-162": 1.946,
    "y-163": 1.946,
    "y-164": 1.946,
    "y-165": 1.946,
    "y-166": 1.946,
    "y-167": 1.946,
    "y-168": 1.946,
    "y-169": 1.946,
    "y-170": 1.946,
    "y-171": 1.946,
    "y-172": 1.946,
    "y-173": 1.946,
    "y-174": 1.946,
    "y-175": 1.946,
    "y-176": 1.946,
    "y-177": 1.946,
    "y-178": 1.946,
    "y-179": 1.946,
    "y-180": 1.946,
    "y-181": 1.946,
    "y-182": 1.946,
    "y-183": 1.946,
    "y-184": 1.946,
    "y-185": 1.946,
    "y-186": 1.946,
    "y-187": 1.947,
    "y-188": 1.947,
    "y-189": 1.947,
    "y-190": 1.947,
    "y-191": 1.947,
    "y-192": 1.947,
    "y-193": 1.947,
    "y-194": 1.949,
    "y-195": 1.949,
    "y-196": 1.949,
    "y-197": 1.949,
    "y-198": 1.949,
    "y-199": 1.949,
    "y-200": 1.949,
    "y-201": 1.949,
    "y-202": 1.95,
    "y-203": 1.95,
    "y-204": 1.95,
    "y-205": 1.95,
    "y-206": 1.95,
    "y-207": 1.95,
    "y-208": 1.95,
    "y-209": 1.95,
    "y-210": 1.95,
    "y-211": 1.95,
    "y-212": 1.95,
    "y-213": 1.95,
    "y-214": 1.959,
    "y-215": 1.959,
    "y-216": 1.959,
    "y-217": 1.959,
    "y-218": 1.959,
    "y-219": 1.957,
    "y-220": 1.957,
    "y-221": 1.957,
    "y-222": 1.957,
    "y-223": 1.957,
    "y-224": 1.957,
    "y-225": 1.957,
    "y-226": 1.957,
    "y-227": 1.957,
    "y-228": 1.957,
    "y-229": 1.96,
    "y-230": 1.96,
    "y-231": 1.96,
    "y-232": 1.96,
    "y-233": 1.959,
    "y-234": 1.959,
    "y-235": 1.959,
    "y-236": 1.959,
    "y-237": 1.959,
    "y-238": 1.964,
    "y-239": 1.964,
    "y-240": 1.965,
    "y-241": 1.965,
    "y-242": 1.965,
    "y-243": 1.963,
    "y-244": 1.963,
    "y-245": 1.963,
    "y-246": 1.963,
    "y-247": 1.963,
    "y-248": 1.963,
    "y-249": 1.962,
    "y-250": 1.962,
    "y-251": 1.962,
    "y-252": 1.962,
    "y-253": 1.962,
    "y-254": 1.964,
    "y-255": 1.964,
  },
  {
    x: -0.825,
    "y-2": 0.544,
    "y-12": 1.977,
    "y-46": 1.884,
    "y-1000": 1.932,
    "y-0": 0.506,
    "y-1": 0.525,
    "y-3": 1.738,
    "y-4": 1.936,
    "y-5": 2.091,
    "y-6": 2.04,
    "y-7": 1.987,
    "y-8": 1.977,
    "y-9": 1.977,
    "y-10": 1.977,
    "y-11": 1.977,
    "y-13": 1.911,
    "y-14": 1.911,
    "y-15": 1.911,
    "y-16": 1.911,
    "y-17": 1.911,
    "y-18": 1.911,
    "y-19": 1.911,
    "y-20": 1.911,
    "y-21": 1.911,
    "y-22": 1.911,
    "y-23": 1.911,
    "y-24": 1.911,
    "y-25": 1.911,
    "y-26": 1.911,
    "y-27": 1.911,
    "y-28": 1.911,
    "y-29": 1.911,
    "y-30": 1.911,
    "y-31": 1.911,
    "y-32": 1.877,
    "y-33": 1.877,
    "y-34": 1.877,
    "y-35": 1.884,
    "y-36": 1.884,
    "y-37": 1.884,
    "y-38": 1.884,
    "y-39": 1.884,
    "y-40": 1.884,
    "y-41": 1.884,
    "y-42": 1.884,
    "y-43": 1.884,
    "y-44": 1.884,
    "y-45": 1.884,
    "y-47": 1.884,
    "y-48": 1.884,
    "y-49": 1.884,
    "y-50": 1.884,
    "y-51": 1.884,
    "y-52": 1.884,
    "y-53": 1.884,
    "y-54": 1.884,
    "y-55": 1.884,
    "y-56": 1.884,
    "y-57": 1.884,
    "y-58": 1.884,
    "y-59": 1.911,
    "y-60": 1.915,
    "y-61": 1.915,
    "y-62": 1.915,
    "y-63": 1.915,
    "y-64": 1.915,
    "y-65": 1.915,
    "y-66": 1.915,
    "y-67": 1.915,
    "y-68": 1.915,
    "y-69": 1.915,
    "y-70": 1.915,
    "y-71": 1.915,
    "y-72": 1.915,
    "y-73": 1.915,
    "y-74": 1.915,
    "y-75": 1.915,
    "y-76": 1.915,
    "y-77": 1.915,
    "y-78": 1.915,
    "y-79": 1.915,
    "y-80": 1.915,
    "y-81": 1.915,
    "y-82": 1.915,
    "y-83": 1.915,
    "y-84": 1.915,
    "y-85": 1.915,
    "y-86": 1.915,
    "y-87": 1.915,
    "y-88": 1.905,
    "y-89": 1.906,
    "y-90": 1.906,
    "y-91": 1.907,
    "y-92": 1.914,
    "y-93": 1.914,
    "y-94": 1.914,
    "y-95": 1.914,
    "y-96": 1.917,
    "y-97": 1.914,
    "y-98": 1.915,
    "y-99": 1.914,
    "y-100": 1.914,
    "y-101": 1.914,
    "y-102": 1.914,
    "y-103": 1.914,
    "y-104": 1.914,
    "y-105": 1.914,
    "y-106": 1.914,
    "y-107": 1.914,
    "y-108": 1.914,
    "y-109": 1.914,
    "y-110": 1.914,
    "y-111": 1.914,
    "y-112": 1.914,
    "y-113": 1.914,
    "y-114": 1.914,
    "y-115": 1.914,
    "y-116": 1.915,
    "y-117": 1.915,
    "y-118": 1.915,
    "y-119": 1.915,
    "y-120": 1.915,
    "y-121": 1.915,
    "y-122": 1.915,
    "y-123": 1.915,
    "y-124": 1.915,
    "y-125": 1.915,
    "y-126": 1.915,
    "y-127": 1.915,
    "y-128": 1.915,
    "y-129": 1.915,
    "y-130": 1.915,
    "y-131": 1.915,
    "y-132": 1.915,
    "y-133": 1.915,
    "y-134": 1.915,
    "y-135": 1.915,
    "y-136": 1.915,
    "y-137": 1.915,
    "y-138": 1.915,
    "y-139": 1.915,
    "y-140": 1.915,
    "y-141": 1.915,
    "y-142": 1.915,
    "y-143": 1.915,
    "y-144": 1.915,
    "y-145": 1.914,
    "y-146": 1.914,
    "y-147": 1.917,
    "y-148": 1.917,
    "y-149": 1.928,
    "y-150": 1.928,
    "y-151": 1.928,
    "y-152": 1.928,
    "y-153": 1.928,
    "y-154": 1.928,
    "y-155": 1.928,
    "y-156": 1.928,
    "y-157": 1.928,
    "y-158": 1.928,
    "y-159": 1.928,
    "y-160": 1.928,
    "y-161": 1.928,
    "y-162": 1.928,
    "y-163": 1.928,
    "y-164": 1.928,
    "y-165": 1.928,
    "y-166": 1.928,
    "y-167": 1.928,
    "y-168": 1.928,
    "y-169": 1.928,
    "y-170": 1.928,
    "y-171": 1.928,
    "y-172": 1.928,
    "y-173": 1.928,
    "y-174": 1.928,
    "y-175": 1.928,
    "y-176": 1.928,
    "y-177": 1.928,
    "y-178": 1.928,
    "y-179": 1.928,
    "y-180": 1.928,
    "y-181": 1.928,
    "y-182": 1.928,
    "y-183": 1.928,
    "y-184": 1.928,
    "y-185": 1.929,
    "y-186": 1.929,
    "y-187": 1.929,
    "y-188": 1.929,
    "y-189": 1.929,
    "y-190": 1.929,
    "y-191": 1.929,
    "y-192": 1.929,
    "y-193": 1.929,
    "y-194": 1.93,
    "y-195": 1.93,
    "y-196": 1.93,
    "y-197": 1.93,
    "y-198": 1.93,
    "y-199": 1.93,
    "y-200": 1.93,
    "y-201": 1.93,
    "y-202": 1.93,
    "y-203": 1.93,
    "y-204": 1.93,
    "y-205": 1.93,
    "y-206": 1.93,
    "y-207": 1.93,
    "y-208": 1.93,
    "y-209": 1.93,
    "y-210": 1.93,
    "y-211": 1.93,
    "y-212": 1.93,
    "y-213": 1.93,
    "y-214": 1.936,
    "y-215": 1.936,
    "y-216": 1.936,
    "y-217": 1.935,
    "y-218": 1.935,
    "y-219": 1.934,
    "y-220": 1.934,
    "y-221": 1.934,
    "y-222": 1.934,
    "y-223": 1.934,
    "y-224": 1.934,
    "y-225": 1.934,
    "y-226": 1.934,
    "y-227": 1.934,
    "y-228": 1.934,
    "y-229": 1.936,
    "y-230": 1.936,
    "y-231": 1.936,
    "y-232": 1.936,
    "y-233": 1.936,
    "y-234": 1.936,
    "y-235": 1.936,
    "y-236": 1.936,
    "y-237": 1.936,
    "y-238": 1.946,
    "y-239": 1.946,
    "y-240": 1.946,
    "y-241": 1.946,
    "y-242": 1.946,
    "y-243": 1.944,
    "y-244": 1.944,
    "y-245": 1.944,
    "y-246": 1.944,
    "y-247": 1.944,
    "y-248": 1.944,
    "y-249": 1.943,
    "y-250": 1.943,
    "y-251": 1.943,
    "y-252": 1.943,
    "y-253": 1.943,
    "y-254": 1.945,
    "y-255": 1.945,
  },
  {
    x: -0.8,
    "y-2": 0.522,
    "y-12": 1.981,
    "y-46": 1.863,
    "y-1000": 1.888,
    "y-0": 0.494,
    "y-1": 0.501,
    "y-3": 1.781,
    "y-4": 1.896,
    "y-5": 2.066,
    "y-6": 2.03,
    "y-7": 1.993,
    "y-8": 1.981,
    "y-9": 1.981,
    "y-10": 1.981,
    "y-11": 1.981,
    "y-13": 1.904,
    "y-14": 1.904,
    "y-15": 1.904,
    "y-16": 1.904,
    "y-17": 1.904,
    "y-18": 1.904,
    "y-19": 1.904,
    "y-20": 1.904,
    "y-21": 1.904,
    "y-22": 1.904,
    "y-23": 1.904,
    "y-24": 1.904,
    "y-25": 1.904,
    "y-26": 1.904,
    "y-27": 1.904,
    "y-28": 1.904,
    "y-29": 1.904,
    "y-30": 1.904,
    "y-31": 1.904,
    "y-32": 1.863,
    "y-33": 1.863,
    "y-34": 1.863,
    "y-35": 1.863,
    "y-36": 1.863,
    "y-37": 1.863,
    "y-38": 1.863,
    "y-39": 1.863,
    "y-40": 1.863,
    "y-41": 1.863,
    "y-42": 1.863,
    "y-43": 1.863,
    "y-44": 1.863,
    "y-45": 1.863,
    "y-47": 1.863,
    "y-48": 1.863,
    "y-49": 1.863,
    "y-50": 1.863,
    "y-51": 1.863,
    "y-52": 1.863,
    "y-53": 1.863,
    "y-54": 1.863,
    "y-55": 1.863,
    "y-56": 1.863,
    "y-57": 1.863,
    "y-58": 1.863,
    "y-59": 1.897,
    "y-60": 1.888,
    "y-61": 1.888,
    "y-62": 1.888,
    "y-63": 1.888,
    "y-64": 1.888,
    "y-65": 1.888,
    "y-66": 1.888,
    "y-67": 1.888,
    "y-68": 1.888,
    "y-69": 1.888,
    "y-70": 1.888,
    "y-71": 1.888,
    "y-72": 1.888,
    "y-73": 1.888,
    "y-74": 1.888,
    "y-75": 1.888,
    "y-76": 1.888,
    "y-77": 1.888,
    "y-78": 1.888,
    "y-79": 1.888,
    "y-80": 1.888,
    "y-81": 1.888,
    "y-82": 1.888,
    "y-83": 1.888,
    "y-84": 1.888,
    "y-85": 1.888,
    "y-86": 1.888,
    "y-87": 1.888,
    "y-88": 1.888,
    "y-89": 1.888,
    "y-90": 1.888,
    "y-91": 1.888,
    "y-92": 1.888,
    "y-93": 1.888,
    "y-94": 1.888,
    "y-95": 1.888,
    "y-96": 1.888,
    "y-97": 1.888,
    "y-98": 1.888,
    "y-99": 1.888,
    "y-100": 1.888,
    "y-101": 1.888,
    "y-102": 1.888,
    "y-103": 1.888,
    "y-104": 1.888,
    "y-105": 1.888,
    "y-106": 1.888,
    "y-107": 1.888,
    "y-108": 1.888,
    "y-109": 1.888,
    "y-110": 1.888,
    "y-111": 1.888,
    "y-112": 1.888,
    "y-113": 1.888,
    "y-114": 1.888,
    "y-115": 1.888,
    "y-116": 1.888,
    "y-117": 1.888,
    "y-118": 1.888,
    "y-119": 1.888,
    "y-120": 1.888,
    "y-121": 1.888,
    "y-122": 1.888,
    "y-123": 1.888,
    "y-124": 1.888,
    "y-125": 1.888,
    "y-126": 1.888,
    "y-127": 1.888,
    "y-128": 1.888,
    "y-129": 1.888,
    "y-130": 1.888,
    "y-131": 1.888,
    "y-132": 1.888,
    "y-133": 1.888,
    "y-134": 1.888,
    "y-135": 1.888,
    "y-136": 1.888,
    "y-137": 1.888,
    "y-138": 1.888,
    "y-139": 1.888,
    "y-140": 1.888,
    "y-141": 1.888,
    "y-142": 1.888,
    "y-143": 1.888,
    "y-144": 1.888,
    "y-145": 1.888,
    "y-146": 1.888,
    "y-147": 1.888,
    "y-148": 1.888,
    "y-149": 1.888,
    "y-150": 1.888,
    "y-151": 1.888,
    "y-152": 1.888,
    "y-153": 1.888,
    "y-154": 1.888,
    "y-155": 1.888,
    "y-156": 1.888,
    "y-157": 1.888,
    "y-158": 1.888,
    "y-159": 1.888,
    "y-160": 1.888,
    "y-161": 1.888,
    "y-162": 1.888,
    "y-163": 1.888,
    "y-164": 1.888,
    "y-165": 1.888,
    "y-166": 1.888,
    "y-167": 1.888,
    "y-168": 1.888,
    "y-169": 1.888,
    "y-170": 1.888,
    "y-171": 1.888,
    "y-172": 1.888,
    "y-173": 1.888,
    "y-174": 1.888,
    "y-175": 1.888,
    "y-176": 1.888,
    "y-177": 1.888,
    "y-178": 1.888,
    "y-179": 1.888,
    "y-180": 1.888,
    "y-181": 1.888,
    "y-182": 1.888,
    "y-183": 1.888,
    "y-184": 1.888,
    "y-185": 1.888,
    "y-186": 1.888,
    "y-187": 1.888,
    "y-188": 1.888,
    "y-189": 1.888,
    "y-190": 1.888,
    "y-191": 1.888,
    "y-192": 1.888,
    "y-193": 1.888,
    "y-194": 1.888,
    "y-195": 1.888,
    "y-196": 1.888,
    "y-197": 1.888,
    "y-198": 1.888,
    "y-199": 1.888,
    "y-200": 1.888,
    "y-201": 1.888,
    "y-202": 1.888,
    "y-203": 1.888,
    "y-204": 1.888,
    "y-205": 1.888,
    "y-206": 1.888,
    "y-207": 1.888,
    "y-208": 1.888,
    "y-209": 1.888,
    "y-210": 1.888,
    "y-211": 1.888,
    "y-212": 1.888,
    "y-213": 1.888,
    "y-214": 1.888,
    "y-215": 1.888,
    "y-216": 1.888,
    "y-217": 1.888,
    "y-218": 1.888,
    "y-219": 1.888,
    "y-220": 1.888,
    "y-221": 1.888,
    "y-222": 1.888,
    "y-223": 1.888,
    "y-224": 1.888,
    "y-225": 1.888,
    "y-226": 1.888,
    "y-227": 1.888,
    "y-228": 1.888,
    "y-229": 1.888,
    "y-230": 1.888,
    "y-231": 1.888,
    "y-232": 1.888,
    "y-233": 1.888,
    "y-234": 1.888,
    "y-235": 1.888,
    "y-236": 1.888,
    "y-237": 1.888,
    "y-238": 1.888,
    "y-239": 1.888,
    "y-240": 1.888,
    "y-241": 1.888,
    "y-242": 1.888,
    "y-243": 1.888,
    "y-244": 1.888,
    "y-245": 1.888,
    "y-246": 1.888,
    "y-247": 1.888,
    "y-248": 1.888,
    "y-249": 1.888,
    "y-250": 1.888,
    "y-251": 1.888,
    "y-252": 1.888,
    "y-253": 1.888,
    "y-254": 1.888,
    "y-255": 1.888,
  },
  {
    x: -0.775,
    "y-2": 0.501,
    "y-12": 1.985,
    "y-46": 1.843,
    "y-1000": 1.828,
    "y-0": 0.482,
    "y-1": 0.476,
    "y-3": 1.824,
    "y-4": 1.855,
    "y-5": 2.041,
    "y-6": 2.02,
    "y-7": 2.0,
    "y-8": 1.985,
    "y-9": 1.985,
    "y-10": 1.985,
    "y-11": 1.985,
    "y-13": 1.896,
    "y-14": 1.896,
    "y-15": 1.896,
    "y-16": 1.896,
    "y-17": 1.896,
    "y-18": 1.896,
    "y-19": 1.896,
    "y-20": 1.896,
    "y-21": 1.896,
    "y-22": 1.896,
    "y-23": 1.896,
    "y-24": 1.896,
    "y-25": 1.896,
    "y-26": 1.896,
    "y-27": 1.896,
    "y-28": 1.896,
    "y-29": 1.896,
    "y-30": 1.896,
    "y-31": 1.896,
    "y-32": 1.85,
    "y-33": 1.85,
    "y-34": 1.85,
    "y-35": 1.843,
    "y-36": 1.843,
    "y-37": 1.843,
    "y-38": 1.843,
    "y-39": 1.843,
    "y-40": 1.843,
    "y-41": 1.843,
    "y-42": 1.843,
    "y-43": 1.843,
    "y-44": 1.843,
    "y-45": 1.843,
    "y-47": 1.843,
    "y-48": 1.843,
    "y-49": 1.843,
    "y-50": 1.843,
    "y-51": 1.843,
    "y-52": 1.843,
    "y-53": 1.843,
    "y-54": 1.843,
    "y-55": 1.843,
    "y-56": 1.843,
    "y-57": 1.843,
    "y-58": 1.843,
    "y-59": 1.883,
    "y-60": 1.861,
    "y-61": 1.861,
    "y-62": 1.861,
    "y-63": 1.861,
    "y-64": 1.861,
    "y-65": 1.861,
    "y-66": 1.861,
    "y-67": 1.861,
    "y-68": 1.861,
    "y-69": 1.861,
    "y-70": 1.861,
    "y-71": 1.861,
    "y-72": 1.861,
    "y-73": 1.861,
    "y-74": 1.861,
    "y-75": 1.861,
    "y-76": 1.861,
    "y-77": 1.861,
    "y-78": 1.861,
    "y-79": 1.861,
    "y-80": 1.861,
    "y-81": 1.861,
    "y-82": 1.861,
    "y-83": 1.861,
    "y-84": 1.861,
    "y-85": 1.861,
    "y-86": 1.861,
    "y-87": 1.861,
    "y-88": 1.871,
    "y-89": 1.87,
    "y-90": 1.87,
    "y-91": 1.869,
    "y-92": 1.862,
    "y-93": 1.862,
    "y-94": 1.862,
    "y-95": 1.862,
    "y-96": 1.859,
    "y-97": 1.833,
    "y-98": 1.833,
    "y-99": 1.833,
    "y-100": 1.833,
    "y-101": 1.832,
    "y-102": 1.833,
    "y-103": 1.833,
    "y-104": 1.833,
    "y-105": 1.833,
    "y-106": 1.831,
    "y-107": 1.831,
    "y-108": 1.832,
    "y-109": 1.831,
    "y-110": 1.831,
    "y-111": 1.831,
    "y-112": 1.831,
    "y-113": 1.831,
    "y-114": 1.831,
    "y-115": 1.831,
    "y-116": 1.831,
    "y-117": 1.831,
    "y-118": 1.831,
    "y-119": 1.831,
    "y-120": 1.831,
    "y-121": 1.831,
    "y-122": 1.831,
    "y-123": 1.831,
    "y-124": 1.831,
    "y-125": 1.831,
    "y-126": 1.831,
    "y-127": 1.831,
    "y-128": 1.831,
    "y-129": 1.831,
    "y-130": 1.831,
    "y-131": 1.831,
    "y-132": 1.831,
    "y-133": 1.831,
    "y-134": 1.833,
    "y-135": 1.833,
    "y-136": 1.833,
    "y-137": 1.833,
    "y-138": 1.833,
    "y-139": 1.833,
    "y-140": 1.833,
    "y-141": 1.833,
    "y-142": 1.833,
    "y-143": 1.833,
    "y-144": 1.833,
    "y-145": 1.833,
    "y-146": 1.833,
    "y-147": 1.811,
    "y-148": 1.811,
    "y-149": 1.803,
    "y-150": 1.803,
    "y-151": 1.803,
    "y-152": 1.803,
    "y-153": 1.803,
    "y-154": 1.803,
    "y-155": 1.803,
    "y-156": 1.803,
    "y-157": 1.803,
    "y-158": 1.803,
    "y-159": 1.803,
    "y-160": 1.803,
    "y-161": 1.803,
    "y-162": 1.803,
    "y-163": 1.803,
    "y-164": 1.803,
    "y-165": 1.803,
    "y-166": 1.803,
    "y-167": 1.803,
    "y-168": 1.803,
    "y-169": 1.803,
    "y-170": 1.803,
    "y-171": 1.803,
    "y-172": 1.803,
    "y-173": 1.803,
    "y-174": 1.803,
    "y-175": 1.803,
    "y-176": 1.803,
    "y-177": 1.803,
    "y-178": 1.803,
    "y-179": 1.803,
    "y-180": 1.803,
    "y-181": 1.803,
    "y-182": 1.803,
    "y-183": 1.803,
    "y-184": 1.803,
    "y-185": 1.8,
    "y-186": 1.8,
    "y-187": 1.8,
    "y-188": 1.8,
    "y-189": 1.8,
    "y-190": 1.8,
    "y-191": 1.8,
    "y-192": 1.8,
    "y-193": 1.8,
    "y-194": 1.8,
    "y-195": 1.8,
    "y-196": 1.8,
    "y-197": 1.8,
    "y-198": 1.8,
    "y-199": 1.8,
    "y-200": 1.8,
    "y-201": 1.8,
    "y-202": 1.799,
    "y-203": 1.799,
    "y-204": 1.799,
    "y-205": 1.799,
    "y-206": 1.799,
    "y-207": 1.799,
    "y-208": 1.799,
    "y-209": 1.799,
    "y-210": 1.799,
    "y-211": 1.799,
    "y-212": 1.799,
    "y-213": 1.799,
    "y-214": 1.798,
    "y-215": 1.798,
    "y-216": 1.798,
    "y-217": 1.799,
    "y-218": 1.799,
    "y-219": 1.803,
    "y-220": 1.803,
    "y-221": 1.803,
    "y-222": 1.803,
    "y-223": 1.803,
    "y-224": 1.803,
    "y-225": 1.803,
    "y-226": 1.803,
    "y-227": 1.803,
    "y-228": 1.803,
    "y-229": 1.797,
    "y-230": 1.797,
    "y-231": 1.797,
    "y-232": 1.797,
    "y-233": 1.797,
    "y-234": 1.797,
    "y-235": 1.797,
    "y-236": 1.797,
    "y-237": 1.797,
    "y-238": 1.792,
    "y-239": 1.792,
    "y-240": 1.792,
    "y-241": 1.792,
    "y-242": 1.792,
    "y-243": 1.796,
    "y-244": 1.796,
    "y-245": 1.796,
    "y-246": 1.796,
    "y-247": 1.796,
    "y-248": 1.796,
    "y-249": 1.798,
    "y-250": 1.798,
    "y-251": 1.798,
    "y-252": 1.798,
    "y-253": 1.798,
    "y-254": 1.793,
    "y-255": 1.793,
  },
  {
    x: -0.75,
    "y-2": 0.48,
    "y-12": 1.989,
    "y-46": 1.823,
    "y-1000": 1.772,
    "y-0": 0.47,
    "y-1": 0.452,
    "y-3": 1.867,
    "y-4": 1.814,
    "y-5": 2.016,
    "y-6": 2.011,
    "y-7": 2.006,
    "y-8": 1.989,
    "y-9": 1.989,
    "y-10": 1.989,
    "y-11": 1.989,
    "y-13": 1.889,
    "y-14": 1.889,
    "y-15": 1.889,
    "y-16": 1.889,
    "y-17": 1.889,
    "y-18": 1.889,
    "y-19": 1.889,
    "y-20": 1.889,
    "y-21": 1.889,
    "y-22": 1.889,
    "y-23": 1.889,
    "y-24": 1.889,
    "y-25": 1.889,
    "y-26": 1.889,
    "y-27": 1.889,
    "y-28": 1.889,
    "y-29": 1.889,
    "y-30": 1.889,
    "y-31": 1.889,
    "y-32": 1.837,
    "y-33": 1.837,
    "y-34": 1.837,
    "y-35": 1.823,
    "y-36": 1.823,
    "y-37": 1.823,
    "y-38": 1.823,
    "y-39": 1.823,
    "y-40": 1.823,
    "y-41": 1.823,
    "y-42": 1.823,
    "y-43": 1.823,
    "y-44": 1.823,
    "y-45": 1.823,
    "y-47": 1.823,
    "y-48": 1.823,
    "y-49": 1.823,
    "y-50": 1.823,
    "y-51": 1.823,
    "y-52": 1.823,
    "y-53": 1.823,
    "y-54": 1.823,
    "y-55": 1.823,
    "y-56": 1.823,
    "y-57": 1.823,
    "y-58": 1.823,
    "y-59": 1.846,
    "y-60": 1.828,
    "y-61": 1.828,
    "y-62": 1.828,
    "y-63": 1.828,
    "y-64": 1.828,
    "y-65": 1.828,
    "y-66": 1.715,
    "y-67": 1.716,
    "y-68": 1.716,
    "y-69": 1.714,
    "y-70": 1.715,
    "y-71": 1.715,
    "y-72": 1.714,
    "y-73": 1.711,
    "y-74": 1.713,
    "y-75": 1.804,
    "y-76": 1.802,
    "y-77": 1.803,
    "y-78": 1.804,
    "y-79": 1.804,
    "y-80": 1.804,
    "y-81": 1.803,
    "y-82": 1.803,
    "y-83": 1.803,
    "y-84": 1.802,
    "y-85": 1.804,
    "y-86": 1.803,
    "y-87": 1.803,
    "y-88": 1.814,
    "y-89": 1.814,
    "y-90": 1.814,
    "y-91": 1.813,
    "y-92": 1.803,
    "y-93": 1.804,
    "y-94": 1.804,
    "y-95": 1.805,
    "y-96": 1.8,
    "y-97": 1.763,
    "y-98": 1.764,
    "y-99": 1.765,
    "y-100": 1.763,
    "y-101": 1.762,
    "y-102": 1.764,
    "y-103": 1.763,
    "y-104": 1.763,
    "y-105": 1.764,
    "y-106": 1.759,
    "y-107": 1.759,
    "y-108": 1.76,
    "y-109": 1.759,
    "y-110": 1.759,
    "y-111": 1.759,
    "y-112": 1.759,
    "y-113": 1.76,
    "y-114": 1.759,
    "y-115": 1.759,
    "y-116": 1.759,
    "y-117": 1.759,
    "y-118": 1.759,
    "y-119": 1.759,
    "y-120": 1.759,
    "y-121": 1.759,
    "y-122": 1.759,
    "y-123": 1.759,
    "y-124": 1.759,
    "y-125": 1.759,
    "y-126": 1.759,
    "y-127": 1.759,
    "y-128": 1.759,
    "y-129": 1.759,
    "y-130": 1.759,
    "y-131": 1.759,
    "y-132": 1.759,
    "y-133": 1.76,
    "y-134": 1.763,
    "y-135": 1.763,
    "y-136": 1.763,
    "y-137": 1.763,
    "y-138": 1.763,
    "y-139": 1.763,
    "y-140": 1.763,
    "y-141": 1.763,
    "y-142": 1.763,
    "y-143": 1.763,
    "y-144": 1.763,
    "y-145": 1.764,
    "y-146": 1.764,
    "y-147": 1.741,
    "y-148": 1.741,
    "y-149": 1.733,
    "y-150": 1.733,
    "y-151": 1.733,
    "y-152": 1.733,
    "y-153": 1.733,
    "y-154": 1.733,
    "y-155": 1.733,
    "y-156": 1.733,
    "y-157": 1.733,
    "y-158": 1.733,
    "y-159": 1.733,
    "y-160": 1.733,
    "y-161": 1.733,
    "y-162": 1.733,
    "y-163": 1.733,
    "y-164": 1.733,
    "y-165": 1.733,
    "y-166": 1.733,
    "y-167": 1.733,
    "y-168": 1.733,
    "y-169": 1.733,
    "y-170": 1.733,
    "y-171": 1.733,
    "y-172": 1.733,
    "y-173": 1.733,
    "y-174": 1.733,
    "y-175": 1.733,
    "y-176": 1.733,
    "y-177": 1.733,
    "y-178": 1.733,
    "y-179": 1.733,
    "y-180": 1.733,
    "y-181": 1.733,
    "y-182": 1.733,
    "y-183": 1.733,
    "y-184": 1.733,
    "y-185": 1.728,
    "y-186": 1.728,
    "y-187": 1.728,
    "y-188": 1.728,
    "y-189": 1.728,
    "y-190": 1.728,
    "y-191": 1.728,
    "y-192": 1.728,
    "y-193": 1.728,
    "y-194": 1.728,
    "y-195": 1.728,
    "y-196": 1.728,
    "y-197": 1.728,
    "y-198": 1.728,
    "y-199": 1.728,
    "y-200": 1.728,
    "y-201": 1.728,
    "y-202": 1.728,
    "y-203": 1.728,
    "y-204": 1.728,
    "y-205": 1.728,
    "y-206": 1.728,
    "y-207": 1.728,
    "y-208": 1.728,
    "y-209": 1.728,
    "y-210": 1.728,
    "y-211": 1.728,
    "y-212": 1.728,
    "y-213": 1.728,
    "y-214": 1.726,
    "y-215": 1.726,
    "y-216": 1.726,
    "y-217": 1.728,
    "y-218": 1.728,
    "y-219": 1.735,
    "y-220": 1.735,
    "y-221": 1.735,
    "y-222": 1.735,
    "y-223": 1.735,
    "y-224": 1.735,
    "y-225": 1.735,
    "y-226": 1.735,
    "y-227": 1.735,
    "y-228": 1.735,
    "y-229": 1.731,
    "y-230": 1.731,
    "y-231": 1.731,
    "y-232": 1.731,
    "y-233": 1.731,
    "y-234": 1.731,
    "y-235": 1.731,
    "y-236": 1.731,
    "y-237": 1.731,
    "y-238": 1.726,
    "y-239": 1.726,
    "y-240": 1.726,
    "y-241": 1.726,
    "y-242": 1.726,
    "y-243": 1.732,
    "y-244": 1.732,
    "y-245": 1.732,
    "y-246": 1.732,
    "y-247": 1.732,
    "y-248": 1.732,
    "y-249": 1.726,
    "y-250": 1.726,
    "y-251": 1.726,
    "y-252": 1.726,
    "y-253": 1.726,
    "y-254": 1.719,
    "y-255": 1.719,
  },
  {
    x: -0.725,
    "y-2": 0.459,
    "y-12": 1.994,
    "y-46": 1.803,
    "y-1000": 1.732,
    "y-0": 0.457,
    "y-1": 0.427,
    "y-3": 1.91,
    "y-4": 1.774,
    "y-5": 1.991,
    "y-6": 2.001,
    "y-7": 2.012,
    "y-8": 1.994,
    "y-9": 1.994,
    "y-10": 1.994,
    "y-11": 1.994,
    "y-13": 1.881,
    "y-14": 1.881,
    "y-15": 1.881,
    "y-16": 1.881,
    "y-17": 1.881,
    "y-18": 1.881,
    "y-19": 1.881,
    "y-20": 1.881,
    "y-21": 1.881,
    "y-22": 1.881,
    "y-23": 1.881,
    "y-24": 1.881,
    "y-25": 1.881,
    "y-26": 1.881,
    "y-27": 1.881,
    "y-28": 1.881,
    "y-29": 1.881,
    "y-30": 1.881,
    "y-31": 1.881,
    "y-32": 1.823,
    "y-33": 1.823,
    "y-34": 1.823,
    "y-35": 1.803,
    "y-36": 1.803,
    "y-37": 1.803,
    "y-38": 1.803,
    "y-39": 1.803,
    "y-40": 1.803,
    "y-41": 1.803,
    "y-42": 1.803,
    "y-43": 1.803,
    "y-44": 1.803,
    "y-45": 1.803,
    "y-47": 1.803,
    "y-48": 1.803,
    "y-49": 1.803,
    "y-50": 1.803,
    "y-51": 1.803,
    "y-52": 1.803,
    "y-53": 1.803,
    "y-54": 1.803,
    "y-55": 1.803,
    "y-56": 1.803,
    "y-57": 1.803,
    "y-58": 1.803,
    "y-59": 1.801,
    "y-60": 1.792,
    "y-61": 1.792,
    "y-62": 1.792,
    "y-63": 1.792,
    "y-64": 1.792,
    "y-65": 1.792,
    "y-66": 1.622,
    "y-67": 1.624,
    "y-68": 1.623,
    "y-69": 1.621,
    "y-70": 1.623,
    "y-71": 1.621,
    "y-72": 1.621,
    "y-73": 1.621,
    "y-74": 1.622,
    "y-75": 1.755,
    "y-76": 1.754,
    "y-77": 1.755,
    "y-78": 1.756,
    "y-79": 1.755,
    "y-80": 1.756,
    "y-81": 1.754,
    "y-82": 1.755,
    "y-83": 1.755,
    "y-84": 1.754,
    "y-85": 1.756,
    "y-86": 1.756,
    "y-87": 1.755,
    "y-88": 1.76,
    "y-89": 1.761,
    "y-90": 1.761,
    "y-91": 1.762,
    "y-92": 1.755,
    "y-93": 1.756,
    "y-94": 1.755,
    "y-95": 1.756,
    "y-96": 1.753,
    "y-97": 1.733,
    "y-98": 1.734,
    "y-99": 1.734,
    "y-100": 1.733,
    "y-101": 1.732,
    "y-102": 1.733,
    "y-103": 1.734,
    "y-104": 1.733,
    "y-105": 1.733,
    "y-106": 1.729,
    "y-107": 1.729,
    "y-108": 1.729,
    "y-109": 1.729,
    "y-110": 1.729,
    "y-111": 1.729,
    "y-112": 1.729,
    "y-113": 1.73,
    "y-114": 1.729,
    "y-115": 1.729,
    "y-116": 1.729,
    "y-117": 1.729,
    "y-118": 1.729,
    "y-119": 1.729,
    "y-120": 1.729,
    "y-121": 1.729,
    "y-122": 1.729,
    "y-123": 1.729,
    "y-124": 1.729,
    "y-125": 1.729,
    "y-126": 1.729,
    "y-127": 1.729,
    "y-128": 1.729,
    "y-129": 1.729,
    "y-130": 1.729,
    "y-131": 1.729,
    "y-132": 1.729,
    "y-133": 1.73,
    "y-134": 1.733,
    "y-135": 1.733,
    "y-136": 1.733,
    "y-137": 1.733,
    "y-138": 1.733,
    "y-139": 1.733,
    "y-140": 1.733,
    "y-141": 1.733,
    "y-142": 1.733,
    "y-143": 1.733,
    "y-144": 1.733,
    "y-145": 1.734,
    "y-146": 1.734,
    "y-147": 1.722,
    "y-148": 1.722,
    "y-149": 1.718,
    "y-150": 1.718,
    "y-151": 1.718,
    "y-152": 1.718,
    "y-153": 1.718,
    "y-154": 1.718,
    "y-155": 1.718,
    "y-156": 1.718,
    "y-157": 1.718,
    "y-158": 1.718,
    "y-159": 1.718,
    "y-160": 1.718,
    "y-161": 1.718,
    "y-162": 1.718,
    "y-163": 1.718,
    "y-164": 1.718,
    "y-165": 1.718,
    "y-166": 1.718,
    "y-167": 1.718,
    "y-168": 1.718,
    "y-169": 1.718,
    "y-170": 1.718,
    "y-171": 1.718,
    "y-172": 1.718,
    "y-173": 1.718,
    "y-174": 1.718,
    "y-175": 1.718,
    "y-176": 1.718,
    "y-177": 1.718,
    "y-178": 1.718,
    "y-179": 1.718,
    "y-180": 1.718,
    "y-181": 1.718,
    "y-182": 1.718,
    "y-183": 1.718,
    "y-184": 1.718,
    "y-185": 1.714,
    "y-186": 1.714,
    "y-187": 1.714,
    "y-188": 1.714,
    "y-189": 1.714,
    "y-190": 1.714,
    "y-191": 1.714,
    "y-192": 1.714,
    "y-193": 1.714,
    "y-194": 1.714,
    "y-195": 1.714,
    "y-196": 1.714,
    "y-197": 1.714,
    "y-198": 1.714,
    "y-199": 1.714,
    "y-200": 1.714,
    "y-201": 1.714,
    "y-202": 1.714,
    "y-203": 1.714,
    "y-204": 1.714,
    "y-205": 1.714,
    "y-206": 1.714,
    "y-207": 1.714,
    "y-208": 1.714,
    "y-209": 1.714,
    "y-210": 1.714,
    "y-211": 1.714,
    "y-212": 1.714,
    "y-213": 1.714,
    "y-214": 1.712,
    "y-215": 1.712,
    "y-216": 1.712,
    "y-217": 1.714,
    "y-218": 1.714,
    "y-219": 1.72,
    "y-220": 1.72,
    "y-221": 1.72,
    "y-222": 1.72,
    "y-223": 1.72,
    "y-224": 1.72,
    "y-225": 1.72,
    "y-226": 1.72,
    "y-227": 1.72,
    "y-228": 1.72,
    "y-229": 1.718,
    "y-230": 1.718,
    "y-231": 1.718,
    "y-232": 1.718,
    "y-233": 1.718,
    "y-234": 1.718,
    "y-235": 1.718,
    "y-236": 1.718,
    "y-237": 1.718,
    "y-238": 1.716,
    "y-239": 1.716,
    "y-240": 1.716,
    "y-241": 1.716,
    "y-242": 1.716,
    "y-243": 1.72,
    "y-244": 1.72,
    "y-245": 1.72,
    "y-246": 1.72,
    "y-247": 1.72,
    "y-248": 1.72,
    "y-249": 1.692,
    "y-250": 1.692,
    "y-251": 1.692,
    "y-252": 1.692,
    "y-253": 1.692,
    "y-254": 1.69,
    "y-255": 1.69,
  },
  {
    x: -0.7,
    "y-2": 0.437,
    "y-12": 1.998,
    "y-46": 1.782,
    "y-1000": 1.757,
    "y-0": 0.445,
    "y-1": 0.402,
    "y-3": 1.953,
    "y-4": 1.733,
    "y-5": 1.966,
    "y-6": 1.992,
    "y-7": 2.018,
    "y-8": 1.998,
    "y-9": 1.998,
    "y-10": 1.998,
    "y-11": 1.998,
    "y-13": 1.873,
    "y-14": 1.873,
    "y-15": 1.873,
    "y-16": 1.873,
    "y-17": 1.873,
    "y-18": 1.873,
    "y-19": 1.873,
    "y-20": 1.873,
    "y-21": 1.873,
    "y-22": 1.873,
    "y-23": 1.873,
    "y-24": 1.873,
    "y-25": 1.873,
    "y-26": 1.873,
    "y-27": 1.873,
    "y-28": 1.873,
    "y-29": 1.873,
    "y-30": 1.873,
    "y-31": 1.873,
    "y-32": 1.81,
    "y-33": 1.81,
    "y-34": 1.81,
    "y-35": 1.782,
    "y-36": 1.782,
    "y-37": 1.782,
    "y-38": 1.782,
    "y-39": 1.782,
    "y-40": 1.782,
    "y-41": 1.782,
    "y-42": 1.782,
    "y-43": 1.782,
    "y-44": 1.782,
    "y-45": 1.782,
    "y-47": 1.782,
    "y-48": 1.782,
    "y-49": 1.782,
    "y-50": 1.782,
    "y-51": 1.782,
    "y-52": 1.782,
    "y-53": 1.782,
    "y-54": 1.782,
    "y-55": 1.782,
    "y-56": 1.782,
    "y-57": 1.782,
    "y-58": 1.782,
    "y-59": 1.757,
    "y-60": 1.757,
    "y-61": 1.757,
    "y-62": 1.757,
    "y-63": 1.757,
    "y-64": 1.757,
    "y-65": 1.757,
    "y-66": 1.757,
    "y-67": 1.757,
    "y-68": 1.757,
    "y-69": 1.757,
    "y-70": 1.757,
    "y-71": 1.757,
    "y-72": 1.757,
    "y-73": 1.757,
    "y-74": 1.757,
    "y-75": 1.757,
    "y-76": 1.757,
    "y-77": 1.757,
    "y-78": 1.757,
    "y-79": 1.757,
    "y-80": 1.757,
    "y-81": 1.757,
    "y-82": 1.757,
    "y-83": 1.757,
    "y-84": 1.757,
    "y-85": 1.757,
    "y-86": 1.757,
    "y-87": 1.757,
    "y-88": 1.757,
    "y-89": 1.757,
    "y-90": 1.757,
    "y-91": 1.757,
    "y-92": 1.757,
    "y-93": 1.757,
    "y-94": 1.757,
    "y-95": 1.757,
    "y-96": 1.757,
    "y-97": 1.757,
    "y-98": 1.757,
    "y-99": 1.757,
    "y-100": 1.757,
    "y-101": 1.757,
    "y-102": 1.757,
    "y-103": 1.757,
    "y-104": 1.757,
    "y-105": 1.757,
    "y-106": 1.757,
    "y-107": 1.757,
    "y-108": 1.757,
    "y-109": 1.757,
    "y-110": 1.757,
    "y-111": 1.757,
    "y-112": 1.757,
    "y-113": 1.757,
    "y-114": 1.757,
    "y-115": 1.757,
    "y-116": 1.757,
    "y-117": 1.757,
    "y-118": 1.757,
    "y-119": 1.757,
    "y-120": 1.757,
    "y-121": 1.757,
    "y-122": 1.757,
    "y-123": 1.757,
    "y-124": 1.757,
    "y-125": 1.757,
    "y-126": 1.757,
    "y-127": 1.757,
    "y-128": 1.757,
    "y-129": 1.757,
    "y-130": 1.757,
    "y-131": 1.757,
    "y-132": 1.757,
    "y-133": 1.757,
    "y-134": 1.757,
    "y-135": 1.757,
    "y-136": 1.757,
    "y-137": 1.757,
    "y-138": 1.757,
    "y-139": 1.757,
    "y-140": 1.757,
    "y-141": 1.757,
    "y-142": 1.757,
    "y-143": 1.757,
    "y-144": 1.757,
    "y-145": 1.757,
    "y-146": 1.757,
    "y-147": 1.757,
    "y-148": 1.757,
    "y-149": 1.757,
    "y-150": 1.757,
    "y-151": 1.757,
    "y-152": 1.757,
    "y-153": 1.757,
    "y-154": 1.757,
    "y-155": 1.757,
    "y-156": 1.757,
    "y-157": 1.757,
    "y-158": 1.757,
    "y-159": 1.757,
    "y-160": 1.757,
    "y-161": 1.757,
    "y-162": 1.757,
    "y-163": 1.757,
    "y-164": 1.757,
    "y-165": 1.757,
    "y-166": 1.757,
    "y-167": 1.757,
    "y-168": 1.757,
    "y-169": 1.757,
    "y-170": 1.757,
    "y-171": 1.757,
    "y-172": 1.757,
    "y-173": 1.757,
    "y-174": 1.757,
    "y-175": 1.757,
    "y-176": 1.757,
    "y-177": 1.757,
    "y-178": 1.757,
    "y-179": 1.757,
    "y-180": 1.757,
    "y-181": 1.757,
    "y-182": 1.757,
    "y-183": 1.757,
    "y-184": 1.757,
    "y-185": 1.757,
    "y-186": 1.757,
    "y-187": 1.757,
    "y-188": 1.757,
    "y-189": 1.757,
    "y-190": 1.757,
    "y-191": 1.757,
    "y-192": 1.757,
    "y-193": 1.757,
    "y-194": 1.757,
    "y-195": 1.757,
    "y-196": 1.757,
    "y-197": 1.757,
    "y-198": 1.757,
    "y-199": 1.757,
    "y-200": 1.757,
    "y-201": 1.757,
    "y-202": 1.757,
    "y-203": 1.757,
    "y-204": 1.757,
    "y-205": 1.757,
    "y-206": 1.757,
    "y-207": 1.757,
    "y-208": 1.757,
    "y-209": 1.757,
    "y-210": 1.757,
    "y-211": 1.757,
    "y-212": 1.757,
    "y-213": 1.757,
    "y-214": 1.757,
    "y-215": 1.757,
    "y-216": 1.757,
    "y-217": 1.757,
    "y-218": 1.757,
    "y-219": 1.757,
    "y-220": 1.757,
    "y-221": 1.757,
    "y-222": 1.757,
    "y-223": 1.757,
    "y-224": 1.757,
    "y-225": 1.757,
    "y-226": 1.757,
    "y-227": 1.757,
    "y-228": 1.757,
    "y-229": 1.757,
    "y-230": 1.757,
    "y-231": 1.757,
    "y-232": 1.757,
    "y-233": 1.757,
    "y-234": 1.757,
    "y-235": 1.757,
    "y-236": 1.757,
    "y-237": 1.757,
    "y-238": 1.757,
    "y-239": 1.757,
    "y-240": 1.757,
    "y-241": 1.757,
    "y-242": 1.757,
    "y-243": 1.757,
    "y-244": 1.757,
    "y-245": 1.757,
    "y-246": 1.757,
    "y-247": 1.757,
    "y-248": 1.757,
    "y-249": 1.757,
    "y-250": 1.757,
    "y-251": 1.757,
    "y-252": 1.757,
    "y-253": 1.757,
    "y-254": 1.757,
    "y-255": 1.757,
  },
  {
    x: -0.675,
    "y-2": 0.416,
    "y-12": 2.002,
    "y-46": 1.762,
    "y-1000": 1.886,
    "y-0": 0.433,
    "y-1": 0.378,
    "y-3": 1.996,
    "y-4": 1.692,
    "y-5": 1.941,
    "y-6": 1.982,
    "y-7": 2.025,
    "y-8": 2.002,
    "y-9": 2.002,
    "y-10": 2.002,
    "y-11": 2.002,
    "y-13": 1.866,
    "y-14": 1.866,
    "y-15": 1.866,
    "y-16": 1.866,
    "y-17": 1.866,
    "y-18": 1.866,
    "y-19": 1.866,
    "y-20": 1.866,
    "y-21": 1.866,
    "y-22": 1.866,
    "y-23": 1.866,
    "y-24": 1.866,
    "y-25": 1.866,
    "y-26": 1.866,
    "y-27": 1.866,
    "y-28": 1.866,
    "y-29": 1.866,
    "y-30": 1.866,
    "y-31": 1.866,
    "y-32": 1.796,
    "y-33": 1.796,
    "y-34": 1.796,
    "y-35": 1.762,
    "y-36": 1.762,
    "y-37": 1.762,
    "y-38": 1.762,
    "y-39": 1.762,
    "y-40": 1.762,
    "y-41": 1.762,
    "y-42": 1.762,
    "y-43": 1.762,
    "y-44": 1.762,
    "y-45": 1.762,
    "y-47": 1.762,
    "y-48": 1.762,
    "y-49": 1.762,
    "y-50": 1.762,
    "y-51": 1.762,
    "y-52": 1.762,
    "y-53": 1.762,
    "y-54": 1.762,
    "y-55": 1.762,
    "y-56": 1.762,
    "y-57": 1.762,
    "y-58": 1.762,
    "y-59": 1.713,
    "y-60": 1.722,
    "y-61": 1.722,
    "y-62": 1.722,
    "y-63": 1.722,
    "y-64": 1.722,
    "y-65": 1.722,
    "y-66": 1.892,
    "y-67": 1.89,
    "y-68": 1.891,
    "y-69": 1.893,
    "y-70": 1.891,
    "y-71": 1.893,
    "y-72": 1.893,
    "y-73": 1.893,
    "y-74": 1.892,
    "y-75": 1.918,
    "y-76": 1.92,
    "y-77": 1.92,
    "y-78": 1.92,
    "y-79": 1.917,
    "y-80": 1.917,
    "y-81": 1.919,
    "y-82": 1.918,
    "y-83": 1.919,
    "y-84": 1.919,
    "y-85": 1.918,
    "y-86": 1.919,
    "y-87": 1.917,
    "y-88": 1.918,
    "y-89": 1.918,
    "y-90": 1.916,
    "y-91": 1.918,
    "y-92": 1.92,
    "y-93": 1.919,
    "y-94": 1.918,
    "y-95": 1.919,
    "y-96": 1.918,
    "y-97": 1.919,
    "y-98": 1.92,
    "y-99": 1.921,
    "y-100": 1.92,
    "y-101": 1.92,
    "y-102": 1.92,
    "y-103": 1.92,
    "y-104": 1.92,
    "y-105": 1.92,
    "y-106": 1.933,
    "y-107": 1.933,
    "y-108": 1.933,
    "y-109": 1.933,
    "y-110": 1.933,
    "y-111": 1.933,
    "y-112": 1.933,
    "y-113": 1.933,
    "y-114": 1.933,
    "y-115": 1.933,
    "y-116": 1.933,
    "y-117": 1.933,
    "y-118": 1.933,
    "y-119": 1.933,
    "y-120": 1.933,
    "y-121": 1.934,
    "y-122": 1.933,
    "y-123": 1.933,
    "y-124": 1.933,
    "y-125": 1.933,
    "y-126": 1.933,
    "y-127": 1.933,
    "y-128": 1.933,
    "y-129": 1.933,
    "y-130": 1.933,
    "y-131": 1.933,
    "y-132": 1.933,
    "y-133": 1.931,
    "y-134": 1.92,
    "y-135": 1.92,
    "y-136": 1.92,
    "y-137": 1.92,
    "y-138": 1.92,
    "y-139": 1.92,
    "y-140": 1.92,
    "y-141": 1.92,
    "y-142": 1.92,
    "y-143": 1.92,
    "y-144": 1.92,
    "y-145": 1.917,
    "y-146": 1.917,
    "y-147": 1.92,
    "y-148": 1.92,
    "y-149": 1.92,
    "y-150": 1.92,
    "y-151": 1.92,
    "y-152": 1.92,
    "y-153": 1.92,
    "y-154": 1.92,
    "y-155": 1.92,
    "y-156": 1.92,
    "y-157": 1.92,
    "y-158": 1.92,
    "y-159": 1.92,
    "y-160": 1.92,
    "y-161": 1.92,
    "y-162": 1.92,
    "y-163": 1.92,
    "y-164": 1.92,
    "y-165": 1.92,
    "y-166": 1.92,
    "y-167": 1.92,
    "y-168": 1.92,
    "y-169": 1.92,
    "y-170": 1.92,
    "y-171": 1.92,
    "y-172": 1.92,
    "y-173": 1.92,
    "y-174": 1.92,
    "y-175": 1.92,
    "y-176": 1.92,
    "y-177": 1.92,
    "y-178": 1.92,
    "y-179": 1.92,
    "y-180": 1.92,
    "y-181": 1.92,
    "y-182": 1.92,
    "y-183": 1.92,
    "y-184": 1.92,
    "y-185": 1.931,
    "y-186": 1.931,
    "y-187": 1.931,
    "y-188": 1.931,
    "y-189": 1.931,
    "y-190": 1.931,
    "y-191": 1.931,
    "y-192": 1.931,
    "y-193": 1.931,
    "y-194": 1.931,
    "y-195": 1.931,
    "y-196": 1.931,
    "y-197": 1.931,
    "y-198": 1.931,
    "y-199": 1.931,
    "y-200": 1.931,
    "y-201": 1.931,
    "y-202": 1.931,
    "y-203": 1.931,
    "y-204": 1.931,
    "y-205": 1.931,
    "y-206": 1.931,
    "y-207": 1.931,
    "y-208": 1.931,
    "y-209": 1.931,
    "y-210": 1.931,
    "y-211": 1.931,
    "y-212": 1.931,
    "y-213": 1.931,
    "y-214": 1.932,
    "y-215": 1.932,
    "y-216": 1.932,
    "y-217": 1.927,
    "y-218": 1.927,
    "y-219": 1.912,
    "y-220": 1.912,
    "y-221": 1.912,
    "y-222": 1.912,
    "y-223": 1.912,
    "y-224": 1.912,
    "y-225": 1.912,
    "y-226": 1.912,
    "y-227": 1.912,
    "y-228": 1.912,
    "y-229": 1.912,
    "y-230": 1.912,
    "y-231": 1.912,
    "y-232": 1.912,
    "y-233": 1.912,
    "y-234": 1.912,
    "y-235": 1.912,
    "y-236": 1.912,
    "y-237": 1.912,
    "y-238": 1.913,
    "y-239": 1.913,
    "y-240": 1.913,
    "y-241": 1.913,
    "y-242": 1.913,
    "y-243": 1.902,
    "y-244": 1.902,
    "y-245": 1.902,
    "y-246": 1.902,
    "y-247": 1.902,
    "y-248": 1.902,
    "y-249": 1.911,
    "y-250": 1.911,
    "y-251": 1.911,
    "y-252": 1.911,
    "y-253": 1.911,
    "y-254": 1.912,
    "y-255": 1.912,
  },
  {
    x: -0.65,
    "y-2": 0.395,
    "y-12": 2.006,
    "y-46": 1.742,
    "y-1000": 2.042,
    "y-0": 0.421,
    "y-1": 0.353,
    "y-3": 2.039,
    "y-4": 1.651,
    "y-5": 1.916,
    "y-6": 1.972,
    "y-7": 2.031,
    "y-8": 2.006,
    "y-9": 2.006,
    "y-10": 2.006,
    "y-11": 2.006,
    "y-13": 1.858,
    "y-14": 1.858,
    "y-15": 1.858,
    "y-16": 1.858,
    "y-17": 1.858,
    "y-18": 1.858,
    "y-19": 1.858,
    "y-20": 1.858,
    "y-21": 1.858,
    "y-22": 1.858,
    "y-23": 1.858,
    "y-24": 1.858,
    "y-25": 1.858,
    "y-26": 1.858,
    "y-27": 1.858,
    "y-28": 1.858,
    "y-29": 1.858,
    "y-30": 1.858,
    "y-31": 1.858,
    "y-32": 1.783,
    "y-33": 1.783,
    "y-34": 1.783,
    "y-35": 1.742,
    "y-36": 1.742,
    "y-37": 1.742,
    "y-38": 1.742,
    "y-39": 1.742,
    "y-40": 1.742,
    "y-41": 1.742,
    "y-42": 1.742,
    "y-43": 1.742,
    "y-44": 1.742,
    "y-45": 1.742,
    "y-47": 1.742,
    "y-48": 1.742,
    "y-49": 1.742,
    "y-50": 1.742,
    "y-51": 1.742,
    "y-52": 1.742,
    "y-53": 1.742,
    "y-54": 1.742,
    "y-55": 1.742,
    "y-56": 1.742,
    "y-57": 1.742,
    "y-58": 1.742,
    "y-59": 1.668,
    "y-60": 1.686,
    "y-61": 1.686,
    "y-62": 1.686,
    "y-63": 1.686,
    "y-64": 1.686,
    "y-65": 1.686,
    "y-66": 2.027,
    "y-67": 2.024,
    "y-68": 2.024,
    "y-69": 2.028,
    "y-70": 2.026,
    "y-71": 2.028,
    "y-72": 2.028,
    "y-73": 2.028,
    "y-74": 2.026,
    "y-75": 2.081,
    "y-76": 2.085,
    "y-77": 2.085,
    "y-78": 2.085,
    "y-79": 2.08,
    "y-80": 2.08,
    "y-81": 2.082,
    "y-82": 2.082,
    "y-83": 2.083,
    "y-84": 2.083,
    "y-85": 2.081,
    "y-86": 2.083,
    "y-87": 2.079,
    "y-88": 2.08,
    "y-89": 2.081,
    "y-90": 2.078,
    "y-91": 2.08,
    "y-92": 2.085,
    "y-93": 2.084,
    "y-94": 2.081,
    "y-95": 2.082,
    "y-96": 2.082,
    "y-97": 2.083,
    "y-98": 2.086,
    "y-99": 2.086,
    "y-100": 2.086,
    "y-101": 2.085,
    "y-102": 2.085,
    "y-103": 2.084,
    "y-104": 2.085,
    "y-105": 2.085,
    "y-106": 2.106,
    "y-107": 2.106,
    "y-108": 2.106,
    "y-109": 2.105,
    "y-110": 2.106,
    "y-111": 2.106,
    "y-112": 2.106,
    "y-113": 2.105,
    "y-114": 2.105,
    "y-115": 2.106,
    "y-116": 2.106,
    "y-117": 2.106,
    "y-118": 2.105,
    "y-119": 2.106,
    "y-120": 2.106,
    "y-121": 2.107,
    "y-122": 2.106,
    "y-123": 2.106,
    "y-124": 2.106,
    "y-125": 2.106,
    "y-126": 2.106,
    "y-127": 2.106,
    "y-128": 2.106,
    "y-129": 2.106,
    "y-130": 2.106,
    "y-131": 2.106,
    "y-132": 2.106,
    "y-133": 2.101,
    "y-134": 2.082,
    "y-135": 2.082,
    "y-136": 2.082,
    "y-137": 2.082,
    "y-138": 2.082,
    "y-139": 2.082,
    "y-140": 2.082,
    "y-141": 2.082,
    "y-142": 2.082,
    "y-143": 2.082,
    "y-144": 2.082,
    "y-145": 2.076,
    "y-146": 2.076,
    "y-147": 2.08,
    "y-148": 2.08,
    "y-149": 2.082,
    "y-150": 2.082,
    "y-151": 2.082,
    "y-152": 2.082,
    "y-153": 2.082,
    "y-154": 2.082,
    "y-155": 2.082,
    "y-156": 2.082,
    "y-157": 2.082,
    "y-158": 2.082,
    "y-159": 2.082,
    "y-160": 2.082,
    "y-161": 2.082,
    "y-162": 2.082,
    "y-163": 2.082,
    "y-164": 2.082,
    "y-165": 2.082,
    "y-166": 2.082,
    "y-167": 2.082,
    "y-168": 2.082,
    "y-169": 2.082,
    "y-170": 2.082,
    "y-171": 2.082,
    "y-172": 2.082,
    "y-173": 2.082,
    "y-174": 2.082,
    "y-175": 2.082,
    "y-176": 2.082,
    "y-177": 2.082,
    "y-178": 2.082,
    "y-179": 2.082,
    "y-180": 2.082,
    "y-181": 2.082,
    "y-182": 2.082,
    "y-183": 2.082,
    "y-184": 2.082,
    "y-185": 2.105,
    "y-186": 2.105,
    "y-187": 2.105,
    "y-188": 2.105,
    "y-189": 2.105,
    "y-190": 2.105,
    "y-191": 2.105,
    "y-192": 2.105,
    "y-193": 2.105,
    "y-194": 2.105,
    "y-195": 2.105,
    "y-196": 2.105,
    "y-197": 2.105,
    "y-198": 2.105,
    "y-199": 2.105,
    "y-200": 2.105,
    "y-201": 2.105,
    "y-202": 2.105,
    "y-203": 2.105,
    "y-204": 2.105,
    "y-205": 2.105,
    "y-206": 2.105,
    "y-207": 2.105,
    "y-208": 2.105,
    "y-209": 2.105,
    "y-210": 2.105,
    "y-211": 2.105,
    "y-212": 2.105,
    "y-213": 2.105,
    "y-214": 2.106,
    "y-215": 2.106,
    "y-216": 2.106,
    "y-217": 2.097,
    "y-218": 2.097,
    "y-219": 2.068,
    "y-220": 2.068,
    "y-221": 2.068,
    "y-222": 2.068,
    "y-223": 2.068,
    "y-224": 2.068,
    "y-225": 2.068,
    "y-226": 2.068,
    "y-227": 2.068,
    "y-228": 2.068,
    "y-229": 2.069,
    "y-230": 2.069,
    "y-231": 2.069,
    "y-232": 2.069,
    "y-233": 2.069,
    "y-234": 2.069,
    "y-235": 2.069,
    "y-236": 2.069,
    "y-237": 2.069,
    "y-238": 2.07,
    "y-239": 2.07,
    "y-240": 2.07,
    "y-241": 2.07,
    "y-242": 2.07,
    "y-243": 2.05,
    "y-244": 2.05,
    "y-245": 2.05,
    "y-246": 2.05,
    "y-247": 2.05,
    "y-248": 2.05,
    "y-249": 2.066,
    "y-250": 2.066,
    "y-251": 2.066,
    "y-252": 2.066,
    "y-253": 2.066,
    "y-254": 2.067,
    "y-255": 2.067,
  },
  {
    x: -0.625,
    "y-2": 0.373,
    "y-12": 2.01,
    "y-46": 1.798,
    "y-1000": 2.19,
    "y-0": 0.408,
    "y-1": 0.329,
    "y-3": 2.082,
    "y-4": 1.611,
    "y-5": 1.891,
    "y-6": 1.963,
    "y-7": 2.037,
    "y-8": 2.01,
    "y-9": 2.01,
    "y-10": 2.01,
    "y-11": 2.01,
    "y-13": 1.884,
    "y-14": 1.884,
    "y-15": 1.884,
    "y-16": 1.884,
    "y-17": 1.884,
    "y-18": 1.884,
    "y-19": 1.884,
    "y-20": 1.884,
    "y-21": 1.884,
    "y-22": 1.884,
    "y-23": 1.884,
    "y-24": 1.884,
    "y-25": 1.884,
    "y-26": 1.884,
    "y-27": 1.884,
    "y-28": 1.884,
    "y-29": 1.884,
    "y-30": 1.884,
    "y-31": 1.884,
    "y-32": 1.839,
    "y-33": 1.839,
    "y-34": 1.839,
    "y-35": 1.798,
    "y-36": 1.798,
    "y-37": 1.798,
    "y-38": 1.798,
    "y-39": 1.798,
    "y-40": 1.798,
    "y-41": 1.798,
    "y-42": 1.798,
    "y-43": 1.798,
    "y-44": 1.798,
    "y-45": 1.798,
    "y-47": 1.798,
    "y-48": 1.798,
    "y-49": 1.798,
    "y-50": 1.798,
    "y-51": 1.798,
    "y-52": 1.798,
    "y-53": 1.798,
    "y-54": 1.798,
    "y-55": 1.798,
    "y-56": 1.798,
    "y-57": 1.798,
    "y-58": 1.798,
    "y-59": 1.718,
    "y-60": 1.74,
    "y-61": 1.74,
    "y-62": 1.74,
    "y-63": 1.74,
    "y-64": 1.74,
    "y-65": 1.74,
    "y-66": 2.155,
    "y-67": 2.151,
    "y-68": 2.152,
    "y-69": 2.157,
    "y-70": 2.154,
    "y-71": 2.157,
    "y-72": 2.157,
    "y-73": 2.157,
    "y-74": 2.155,
    "y-75": 2.222,
    "y-76": 2.226,
    "y-77": 2.226,
    "y-78": 2.226,
    "y-79": 2.22,
    "y-80": 2.22,
    "y-81": 2.223,
    "y-82": 2.223,
    "y-83": 2.224,
    "y-84": 2.225,
    "y-85": 2.222,
    "y-86": 2.224,
    "y-87": 2.219,
    "y-88": 2.221,
    "y-89": 2.222,
    "y-90": 2.218,
    "y-91": 2.221,
    "y-92": 2.226,
    "y-93": 2.225,
    "y-94": 2.222,
    "y-95": 2.224,
    "y-96": 2.223,
    "y-97": 2.224,
    "y-98": 2.228,
    "y-99": 2.228,
    "y-100": 2.227,
    "y-101": 2.227,
    "y-102": 2.226,
    "y-103": 2.226,
    "y-104": 2.226,
    "y-105": 2.226,
    "y-106": 2.233,
    "y-107": 2.232,
    "y-108": 2.233,
    "y-109": 2.232,
    "y-110": 2.233,
    "y-111": 2.233,
    "y-112": 2.233,
    "y-113": 2.232,
    "y-114": 2.232,
    "y-115": 2.232,
    "y-116": 2.232,
    "y-117": 2.233,
    "y-118": 2.232,
    "y-119": 2.232,
    "y-120": 2.233,
    "y-121": 2.233,
    "y-122": 2.233,
    "y-123": 2.232,
    "y-124": 2.232,
    "y-125": 2.232,
    "y-126": 2.232,
    "y-127": 2.232,
    "y-128": 2.232,
    "y-129": 2.232,
    "y-130": 2.232,
    "y-131": 2.232,
    "y-132": 2.232,
    "y-133": 2.228,
    "y-134": 2.211,
    "y-135": 2.211,
    "y-136": 2.211,
    "y-137": 2.211,
    "y-138": 2.211,
    "y-139": 2.211,
    "y-140": 2.211,
    "y-141": 2.211,
    "y-142": 2.211,
    "y-143": 2.211,
    "y-144": 2.211,
    "y-145": 2.205,
    "y-146": 2.205,
    "y-147": 2.208,
    "y-148": 2.208,
    "y-149": 2.209,
    "y-150": 2.209,
    "y-151": 2.209,
    "y-152": 2.209,
    "y-153": 2.209,
    "y-154": 2.209,
    "y-155": 2.209,
    "y-156": 2.209,
    "y-157": 2.209,
    "y-158": 2.209,
    "y-159": 2.209,
    "y-160": 2.209,
    "y-161": 2.209,
    "y-162": 2.209,
    "y-163": 2.209,
    "y-164": 2.209,
    "y-165": 2.209,
    "y-166": 2.209,
    "y-167": 2.209,
    "y-168": 2.209,
    "y-169": 2.209,
    "y-170": 2.209,
    "y-171": 2.209,
    "y-172": 2.209,
    "y-173": 2.209,
    "y-174": 2.209,
    "y-175": 2.209,
    "y-176": 2.209,
    "y-177": 2.209,
    "y-178": 2.209,
    "y-179": 2.209,
    "y-180": 2.209,
    "y-181": 2.209,
    "y-182": 2.209,
    "y-183": 2.209,
    "y-184": 2.209,
    "y-185": 2.22,
    "y-186": 2.22,
    "y-187": 2.22,
    "y-188": 2.22,
    "y-189": 2.22,
    "y-190": 2.22,
    "y-191": 2.22,
    "y-192": 2.22,
    "y-193": 2.22,
    "y-194": 2.22,
    "y-195": 2.22,
    "y-196": 2.22,
    "y-197": 2.22,
    "y-198": 2.22,
    "y-199": 2.22,
    "y-200": 2.22,
    "y-201": 2.22,
    "y-202": 2.22,
    "y-203": 2.22,
    "y-204": 2.22,
    "y-205": 2.22,
    "y-206": 2.22,
    "y-207": 2.22,
    "y-208": 2.22,
    "y-209": 2.22,
    "y-210": 2.22,
    "y-211": 2.22,
    "y-212": 2.22,
    "y-213": 2.22,
    "y-214": 2.221,
    "y-215": 2.221,
    "y-216": 2.221,
    "y-217": 2.213,
    "y-218": 2.213,
    "y-219": 2.19,
    "y-220": 2.19,
    "y-221": 2.19,
    "y-222": 2.19,
    "y-223": 2.19,
    "y-224": 2.19,
    "y-225": 2.19,
    "y-226": 2.19,
    "y-227": 2.19,
    "y-228": 2.19,
    "y-229": 2.191,
    "y-230": 2.191,
    "y-231": 2.191,
    "y-232": 2.191,
    "y-233": 2.191,
    "y-234": 2.191,
    "y-235": 2.191,
    "y-236": 2.191,
    "y-237": 2.191,
    "y-238": 2.191,
    "y-239": 2.191,
    "y-240": 2.191,
    "y-241": 2.191,
    "y-242": 2.191,
    "y-243": 2.175,
    "y-244": 2.175,
    "y-245": 2.175,
    "y-246": 2.175,
    "y-247": 2.175,
    "y-248": 2.175,
    "y-249": 2.185,
    "y-250": 2.185,
    "y-251": 2.185,
    "y-252": 2.185,
    "y-253": 2.185,
    "y-254": 2.185,
    "y-255": 2.185,
  },
  {
    x: -0.6,
    "y-2": 0.352,
    "y-12": 2.015,
    "y-46": 2.249,
    "y-1000": 2.249,
    "y-0": 0.396,
    "y-1": 0.304,
    "y-3": 2.125,
    "y-4": 1.57,
    "y-5": 1.866,
    "y-6": 1.953,
    "y-7": 2.043,
    "y-8": 2.015,
    "y-9": 2.015,
    "y-10": 2.015,
    "y-11": 2.015,
    "y-13": 2.079,
    "y-14": 2.079,
    "y-15": 2.079,
    "y-16": 2.079,
    "y-17": 2.079,
    "y-18": 2.079,
    "y-19": 2.079,
    "y-20": 2.079,
    "y-21": 2.079,
    "y-22": 2.079,
    "y-23": 2.079,
    "y-24": 2.079,
    "y-25": 2.079,
    "y-26": 2.079,
    "y-27": 2.079,
    "y-28": 2.079,
    "y-29": 2.079,
    "y-30": 2.079,
    "y-31": 2.079,
    "y-32": 2.249,
    "y-33": 2.249,
    "y-34": 2.249,
    "y-35": 2.249,
    "y-36": 2.249,
    "y-37": 2.249,
    "y-38": 2.249,
    "y-39": 2.249,
    "y-40": 2.249,
    "y-41": 2.249,
    "y-42": 2.249,
    "y-43": 2.249,
    "y-44": 2.249,
    "y-45": 2.249,
    "y-47": 2.249,
    "y-48": 2.249,
    "y-49": 2.249,
    "y-50": 2.249,
    "y-51": 2.249,
    "y-52": 2.249,
    "y-53": 2.249,
    "y-54": 2.249,
    "y-55": 2.249,
    "y-56": 2.249,
    "y-57": 2.249,
    "y-58": 2.249,
    "y-59": 2.249,
    "y-60": 2.249,
    "y-61": 2.249,
    "y-62": 2.249,
    "y-63": 2.249,
    "y-64": 2.249,
    "y-65": 2.249,
    "y-66": 2.249,
    "y-67": 2.249,
    "y-68": 2.249,
    "y-69": 2.249,
    "y-70": 2.249,
    "y-71": 2.249,
    "y-72": 2.249,
    "y-73": 2.249,
    "y-74": 2.249,
    "y-75": 2.249,
    "y-76": 2.249,
    "y-77": 2.249,
    "y-78": 2.249,
    "y-79": 2.249,
    "y-80": 2.249,
    "y-81": 2.249,
    "y-82": 2.249,
    "y-83": 2.249,
    "y-84": 2.249,
    "y-85": 2.249,
    "y-86": 2.249,
    "y-87": 2.249,
    "y-88": 2.249,
    "y-89": 2.249,
    "y-90": 2.249,
    "y-91": 2.249,
    "y-92": 2.249,
    "y-93": 2.249,
    "y-94": 2.249,
    "y-95": 2.249,
    "y-96": 2.249,
    "y-97": 2.249,
    "y-98": 2.249,
    "y-99": 2.249,
    "y-100": 2.249,
    "y-101": 2.249,
    "y-102": 2.249,
    "y-103": 2.249,
    "y-104": 2.249,
    "y-105": 2.249,
    "y-106": 2.249,
    "y-107": 2.249,
    "y-108": 2.249,
    "y-109": 2.249,
    "y-110": 2.249,
    "y-111": 2.249,
    "y-112": 2.249,
    "y-113": 2.249,
    "y-114": 2.249,
    "y-115": 2.249,
    "y-116": 2.249,
    "y-117": 2.249,
    "y-118": 2.249,
    "y-119": 2.249,
    "y-120": 2.249,
    "y-121": 2.249,
    "y-122": 2.249,
    "y-123": 2.249,
    "y-124": 2.249,
    "y-125": 2.249,
    "y-126": 2.249,
    "y-127": 2.249,
    "y-128": 2.249,
    "y-129": 2.249,
    "y-130": 2.249,
    "y-131": 2.249,
    "y-132": 2.249,
    "y-133": 2.249,
    "y-134": 2.249,
    "y-135": 2.249,
    "y-136": 2.249,
    "y-137": 2.249,
    "y-138": 2.249,
    "y-139": 2.249,
    "y-140": 2.249,
    "y-141": 2.249,
    "y-142": 2.249,
    "y-143": 2.249,
    "y-144": 2.249,
    "y-145": 2.249,
    "y-146": 2.249,
    "y-147": 2.249,
    "y-148": 2.249,
    "y-149": 2.249,
    "y-150": 2.249,
    "y-151": 2.249,
    "y-152": 2.249,
    "y-153": 2.249,
    "y-154": 2.249,
    "y-155": 2.249,
    "y-156": 2.249,
    "y-157": 2.249,
    "y-158": 2.249,
    "y-159": 2.249,
    "y-160": 2.249,
    "y-161": 2.249,
    "y-162": 2.249,
    "y-163": 2.249,
    "y-164": 2.249,
    "y-165": 2.249,
    "y-166": 2.249,
    "y-167": 2.249,
    "y-168": 2.249,
    "y-169": 2.249,
    "y-170": 2.249,
    "y-171": 2.249,
    "y-172": 2.249,
    "y-173": 2.249,
    "y-174": 2.249,
    "y-175": 2.249,
    "y-176": 2.249,
    "y-177": 2.249,
    "y-178": 2.249,
    "y-179": 2.249,
    "y-180": 2.249,
    "y-181": 2.249,
    "y-182": 2.249,
    "y-183": 2.249,
    "y-184": 2.249,
    "y-185": 2.249,
    "y-186": 2.249,
    "y-187": 2.249,
    "y-188": 2.249,
    "y-189": 2.249,
    "y-190": 2.249,
    "y-191": 2.249,
    "y-192": 2.249,
    "y-193": 2.249,
    "y-194": 2.249,
    "y-195": 2.249,
    "y-196": 2.249,
    "y-197": 2.249,
    "y-198": 2.249,
    "y-199": 2.249,
    "y-200": 2.249,
    "y-201": 2.249,
    "y-202": 2.249,
    "y-203": 2.249,
    "y-204": 2.249,
    "y-205": 2.249,
    "y-206": 2.249,
    "y-207": 2.249,
    "y-208": 2.249,
    "y-209": 2.249,
    "y-210": 2.249,
    "y-211": 2.249,
    "y-212": 2.249,
    "y-213": 2.249,
    "y-214": 2.249,
    "y-215": 2.249,
    "y-216": 2.249,
    "y-217": 2.249,
    "y-218": 2.249,
    "y-219": 2.249,
    "y-220": 2.249,
    "y-221": 2.249,
    "y-222": 2.249,
    "y-223": 2.249,
    "y-224": 2.249,
    "y-225": 2.249,
    "y-226": 2.249,
    "y-227": 2.249,
    "y-228": 2.249,
    "y-229": 2.249,
    "y-230": 2.249,
    "y-231": 2.249,
    "y-232": 2.249,
    "y-233": 2.249,
    "y-234": 2.249,
    "y-235": 2.249,
    "y-236": 2.249,
    "y-237": 2.249,
    "y-238": 2.249,
    "y-239": 2.249,
    "y-240": 2.249,
    "y-241": 2.249,
    "y-242": 2.249,
    "y-243": 2.249,
    "y-244": 2.249,
    "y-245": 2.249,
    "y-246": 2.249,
    "y-247": 2.249,
    "y-248": 2.249,
    "y-249": 2.249,
    "y-250": 2.249,
    "y-251": 2.249,
    "y-252": 2.249,
    "y-253": 2.249,
    "y-254": 2.249,
    "y-255": 2.249,
  },
  {
    x: -0.575,
    "y-2": 0.331,
    "y-12": 2.019,
    "y-46": 2.552,
    "y-1000": 2.221,
    "y-0": 0.384,
    "y-1": 0.28,
    "y-3": 2.168,
    "y-4": 1.529,
    "y-5": 1.841,
    "y-6": 1.944,
    "y-7": 2.049,
    "y-8": 2.019,
    "y-9": 2.019,
    "y-10": 2.019,
    "y-11": 2.019,
    "y-13": 2.274,
    "y-14": 2.274,
    "y-15": 2.274,
    "y-16": 2.274,
    "y-17": 2.274,
    "y-18": 2.274,
    "y-19": 2.274,
    "y-20": 2.274,
    "y-21": 2.274,
    "y-22": 2.274,
    "y-23": 2.274,
    "y-24": 2.274,
    "y-25": 2.274,
    "y-26": 2.274,
    "y-27": 2.274,
    "y-28": 2.274,
    "y-29": 2.274,
    "y-30": 2.274,
    "y-31": 2.274,
    "y-32": 2.66,
    "y-33": 2.437,
    "y-34": 2.427,
    "y-35": 2.462,
    "y-36": 2.461,
    "y-37": 2.457,
    "y-38": 2.461,
    "y-39": 2.461,
    "y-40": 2.463,
    "y-41": 2.464,
    "y-42": 2.458,
    "y-43": 2.551,
    "y-44": 2.554,
    "y-45": 2.549,
    "y-47": 2.555,
    "y-48": 2.548,
    "y-49": 2.548,
    "y-50": 2.543,
    "y-51": 2.553,
    "y-52": 2.548,
    "y-53": 2.548,
    "y-54": 2.553,
    "y-55": 2.543,
    "y-56": 2.553,
    "y-57": 2.609,
    "y-58": 2.605,
    "y-59": 2.673,
    "y-60": 2.654,
    "y-61": 2.653,
    "y-62": 2.653,
    "y-63": 2.654,
    "y-64": 2.655,
    "y-65": 2.655,
    "y-66": 2.305,
    "y-67": 2.307,
    "y-68": 2.307,
    "y-69": 2.302,
    "y-70": 2.306,
    "y-71": 2.304,
    "y-72": 2.302,
    "y-73": 2.303,
    "y-74": 2.306,
    "y-75": 2.248,
    "y-76": 2.243,
    "y-77": 2.243,
    "y-78": 2.245,
    "y-79": 2.25,
    "y-80": 2.249,
    "y-81": 2.247,
    "y-82": 2.247,
    "y-83": 2.246,
    "y-84": 2.246,
    "y-85": 2.248,
    "y-86": 2.246,
    "y-87": 2.252,
    "y-88": 2.249,
    "y-89": 2.248,
    "y-90": 2.251,
    "y-91": 2.249,
    "y-92": 2.244,
    "y-93": 2.245,
    "y-94": 2.248,
    "y-95": 2.246,
    "y-96": 2.247,
    "y-97": 2.246,
    "y-98": 2.243,
    "y-99": 2.243,
    "y-100": 2.243,
    "y-101": 2.243,
    "y-102": 2.245,
    "y-103": 2.244,
    "y-104": 2.244,
    "y-105": 2.244,
    "y-106": 2.238,
    "y-107": 2.239,
    "y-108": 2.239,
    "y-109": 2.239,
    "y-110": 2.239,
    "y-111": 2.239,
    "y-112": 2.239,
    "y-113": 2.24,
    "y-114": 2.24,
    "y-115": 2.239,
    "y-116": 2.24,
    "y-117": 2.238,
    "y-118": 2.24,
    "y-119": 2.24,
    "y-120": 2.239,
    "y-121": 2.238,
    "y-122": 2.239,
    "y-123": 2.24,
    "y-124": 2.239,
    "y-125": 2.239,
    "y-126": 2.239,
    "y-127": 2.239,
    "y-128": 2.239,
    "y-129": 2.239,
    "y-130": 2.239,
    "y-131": 2.239,
    "y-132": 2.239,
    "y-133": 2.244,
    "y-134": 2.261,
    "y-135": 2.261,
    "y-136": 2.261,
    "y-137": 2.261,
    "y-138": 2.261,
    "y-139": 2.261,
    "y-140": 2.261,
    "y-141": 2.261,
    "y-142": 2.261,
    "y-143": 2.261,
    "y-144": 2.261,
    "y-145": 2.267,
    "y-146": 2.267,
    "y-147": 2.265,
    "y-148": 2.265,
    "y-149": 2.264,
    "y-150": 2.264,
    "y-151": 2.264,
    "y-152": 2.264,
    "y-153": 2.264,
    "y-154": 2.264,
    "y-155": 2.264,
    "y-156": 2.264,
    "y-157": 2.264,
    "y-158": 2.264,
    "y-159": 2.264,
    "y-160": 2.264,
    "y-161": 2.264,
    "y-162": 2.264,
    "y-163": 2.264,
    "y-164": 2.264,
    "y-165": 2.264,
    "y-166": 2.264,
    "y-167": 2.264,
    "y-168": 2.264,
    "y-169": 2.264,
    "y-170": 2.264,
    "y-171": 2.264,
    "y-172": 2.264,
    "y-173": 2.264,
    "y-174": 2.264,
    "y-175": 2.264,
    "y-176": 2.264,
    "y-177": 2.264,
    "y-178": 2.264,
    "y-179": 2.264,
    "y-180": 2.264,
    "y-181": 2.264,
    "y-182": 2.264,
    "y-183": 2.264,
    "y-184": 2.264,
    "y-185": 2.254,
    "y-186": 2.254,
    "y-187": 2.254,
    "y-188": 2.254,
    "y-189": 2.254,
    "y-190": 2.254,
    "y-191": 2.254,
    "y-192": 2.254,
    "y-193": 2.254,
    "y-194": 2.254,
    "y-195": 2.254,
    "y-196": 2.254,
    "y-197": 2.254,
    "y-198": 2.254,
    "y-199": 2.254,
    "y-200": 2.254,
    "y-201": 2.254,
    "y-202": 2.254,
    "y-203": 2.254,
    "y-204": 2.254,
    "y-205": 2.254,
    "y-206": 2.254,
    "y-207": 2.254,
    "y-208": 2.254,
    "y-209": 2.254,
    "y-210": 2.254,
    "y-211": 2.254,
    "y-212": 2.254,
    "y-213": 2.254,
    "y-214": 2.254,
    "y-215": 2.254,
    "y-216": 2.254,
    "y-217": 2.261,
    "y-218": 2.261,
    "y-219": 2.289,
    "y-220": 2.289,
    "y-221": 2.289,
    "y-222": 2.289,
    "y-223": 2.289,
    "y-224": 2.289,
    "y-225": 2.289,
    "y-226": 2.289,
    "y-227": 2.289,
    "y-228": 2.289,
    "y-229": 2.288,
    "y-230": 2.288,
    "y-231": 2.288,
    "y-232": 2.288,
    "y-233": 2.288,
    "y-234": 2.288,
    "y-235": 2.288,
    "y-236": 2.288,
    "y-237": 2.288,
    "y-238": 2.288,
    "y-239": 2.288,
    "y-240": 2.288,
    "y-241": 2.288,
    "y-242": 2.288,
    "y-243": 2.307,
    "y-244": 2.307,
    "y-245": 2.307,
    "y-246": 2.307,
    "y-247": 2.307,
    "y-248": 2.307,
    "y-249": 2.298,
    "y-250": 2.298,
    "y-251": 2.298,
    "y-252": 2.298,
    "y-253": 2.298,
    "y-254": 2.298,
    "y-255": 2.298,
  },
  {
    x: -0.55,
    "y-2": 0.31,
    "y-12": 1.913,
    "y-46": 2.245,
    "y-1000": 2.049,
    "y-0": 0.372,
    "y-1": 0.255,
    "y-3": 2.114,
    "y-4": 1.472,
    "y-5": 1.733,
    "y-6": 1.827,
    "y-7": 1.924,
    "y-8": 1.913,
    "y-9": 1.913,
    "y-10": 1.913,
    "y-11": 1.913,
    "y-13": 2.16,
    "y-14": 2.16,
    "y-15": 2.16,
    "y-16": 2.16,
    "y-17": 2.16,
    "y-18": 2.16,
    "y-19": 2.16,
    "y-20": 2.16,
    "y-21": 2.16,
    "y-22": 2.16,
    "y-23": 2.16,
    "y-24": 2.16,
    "y-25": 2.16,
    "y-26": 2.16,
    "y-27": 2.16,
    "y-28": 2.16,
    "y-29": 2.16,
    "y-30": 2.16,
    "y-31": 2.16,
    "y-32": 2.419,
    "y-33": 2.106,
    "y-34": 2.093,
    "y-35": 2.118,
    "y-36": 2.117,
    "y-37": 2.111,
    "y-38": 2.117,
    "y-39": 2.117,
    "y-40": 2.12,
    "y-41": 2.122,
    "y-42": 2.114,
    "y-43": 2.244,
    "y-44": 2.248,
    "y-45": 2.241,
    "y-47": 2.249,
    "y-48": 2.239,
    "y-49": 2.239,
    "y-50": 2.233,
    "y-51": 2.246,
    "y-52": 2.24,
    "y-53": 2.24,
    "y-54": 2.246,
    "y-55": 2.232,
    "y-56": 2.246,
    "y-57": 2.225,
    "y-58": 2.222,
    "y-59": 2.259,
    "y-60": 2.249,
    "y-61": 2.248,
    "y-62": 2.248,
    "y-63": 2.25,
    "y-64": 2.252,
    "y-65": 2.251,
    "y-66": 2.058,
    "y-67": 2.058,
    "y-68": 2.058,
    "y-69": 2.056,
    "y-70": 2.058,
    "y-71": 2.057,
    "y-72": 2.055,
    "y-73": 2.057,
    "y-74": 2.059,
    "y-75": 2.026,
    "y-76": 2.023,
    "y-77": 2.022,
    "y-78": 2.024,
    "y-79": 2.027,
    "y-80": 2.025,
    "y-81": 2.025,
    "y-82": 2.025,
    "y-83": 2.024,
    "y-84": 2.024,
    "y-85": 2.026,
    "y-86": 2.024,
    "y-87": 2.029,
    "y-88": 2.026,
    "y-89": 2.025,
    "y-90": 2.028,
    "y-91": 2.026,
    "y-92": 2.023,
    "y-93": 2.024,
    "y-94": 2.025,
    "y-95": 2.025,
    "y-96": 2.025,
    "y-97": 2.025,
    "y-98": 2.022,
    "y-99": 2.024,
    "y-100": 2.022,
    "y-101": 2.023,
    "y-102": 2.024,
    "y-103": 2.023,
    "y-104": 2.024,
    "y-105": 2.024,
    "y-106": 2.02,
    "y-107": 2.02,
    "y-108": 2.02,
    "y-109": 2.021,
    "y-110": 2.02,
    "y-111": 2.02,
    "y-112": 2.02,
    "y-113": 2.021,
    "y-114": 2.021,
    "y-115": 2.02,
    "y-116": 2.021,
    "y-117": 2.02,
    "y-118": 2.021,
    "y-119": 2.021,
    "y-120": 2.02,
    "y-121": 2.02,
    "y-122": 2.02,
    "y-123": 2.021,
    "y-124": 2.02,
    "y-125": 2.02,
    "y-126": 2.02,
    "y-127": 2.02,
    "y-128": 2.02,
    "y-129": 2.02,
    "y-130": 2.02,
    "y-131": 2.02,
    "y-132": 2.02,
    "y-133": 2.029,
    "y-134": 2.057,
    "y-135": 2.057,
    "y-136": 2.057,
    "y-137": 2.057,
    "y-138": 2.057,
    "y-139": 2.057,
    "y-140": 2.057,
    "y-141": 2.057,
    "y-142": 2.057,
    "y-143": 2.057,
    "y-144": 2.057,
    "y-145": 2.069,
    "y-146": 2.069,
    "y-147": 2.068,
    "y-148": 2.068,
    "y-149": 2.067,
    "y-150": 2.067,
    "y-151": 2.067,
    "y-152": 2.067,
    "y-153": 2.067,
    "y-154": 2.067,
    "y-155": 2.067,
    "y-156": 2.067,
    "y-157": 2.067,
    "y-158": 2.067,
    "y-159": 2.067,
    "y-160": 2.067,
    "y-161": 2.067,
    "y-162": 2.067,
    "y-163": 2.067,
    "y-164": 2.067,
    "y-165": 2.067,
    "y-166": 2.067,
    "y-167": 2.067,
    "y-168": 2.067,
    "y-169": 2.067,
    "y-170": 2.067,
    "y-171": 2.067,
    "y-172": 2.067,
    "y-173": 2.067,
    "y-174": 2.067,
    "y-175": 2.067,
    "y-176": 2.067,
    "y-177": 2.067,
    "y-178": 2.067,
    "y-179": 2.067,
    "y-180": 2.067,
    "y-181": 2.067,
    "y-182": 2.067,
    "y-183": 2.067,
    "y-184": 2.067,
    "y-185": 2.06,
    "y-186": 2.06,
    "y-187": 2.06,
    "y-188": 2.06,
    "y-189": 2.06,
    "y-190": 2.06,
    "y-191": 2.06,
    "y-192": 2.06,
    "y-193": 2.06,
    "y-194": 2.06,
    "y-195": 2.06,
    "y-196": 2.06,
    "y-197": 2.06,
    "y-198": 2.06,
    "y-199": 2.06,
    "y-200": 2.06,
    "y-201": 2.06,
    "y-202": 2.06,
    "y-203": 2.06,
    "y-204": 2.06,
    "y-205": 2.06,
    "y-206": 2.06,
    "y-207": 2.06,
    "y-208": 2.06,
    "y-209": 2.06,
    "y-210": 2.06,
    "y-211": 2.06,
    "y-212": 2.06,
    "y-213": 2.06,
    "y-214": 2.06,
    "y-215": 2.06,
    "y-216": 2.06,
    "y-217": 2.075,
    "y-218": 2.075,
    "y-219": 2.099,
    "y-220": 2.099,
    "y-221": 2.099,
    "y-222": 2.099,
    "y-223": 2.099,
    "y-224": 2.099,
    "y-225": 2.099,
    "y-226": 2.099,
    "y-227": 2.099,
    "y-228": 2.099,
    "y-229": 2.099,
    "y-230": 2.099,
    "y-231": 2.099,
    "y-232": 2.099,
    "y-233": 2.099,
    "y-234": 2.099,
    "y-235": 2.099,
    "y-236": 2.099,
    "y-237": 2.099,
    "y-238": 2.098,
    "y-239": 2.098,
    "y-240": 2.098,
    "y-241": 2.098,
    "y-242": 2.098,
    "y-243": 2.112,
    "y-244": 2.112,
    "y-245": 2.112,
    "y-246": 2.112,
    "y-247": 2.112,
    "y-248": 2.112,
    "y-249": 2.105,
    "y-250": 2.105,
    "y-251": 2.105,
    "y-252": 2.105,
    "y-253": 2.105,
    "y-254": 2.105,
    "y-255": 2.105,
  },
  {
    x: -0.525,
    "y-2": 0.288,
    "y-12": 1.784,
    "y-46": 1.95,
    "y-1000": 1.85,
    "y-0": 0.36,
    "y-1": 0.23,
    "y-3": 2.038,
    "y-4": 1.411,
    "y-5": 1.606,
    "y-6": 1.686,
    "y-7": 1.769,
    "y-8": 1.784,
    "y-9": 1.784,
    "y-10": 1.784,
    "y-11": 1.784,
    "y-13": 1.98,
    "y-14": 1.98,
    "y-15": 1.98,
    "y-16": 1.98,
    "y-17": 1.98,
    "y-18": 1.98,
    "y-19": 1.98,
    "y-20": 1.98,
    "y-21": 1.98,
    "y-22": 1.98,
    "y-23": 1.98,
    "y-24": 1.98,
    "y-25": 1.98,
    "y-26": 1.98,
    "y-27": 1.98,
    "y-28": 1.98,
    "y-29": 1.98,
    "y-30": 1.98,
    "y-31": 1.98,
    "y-32": 2.037,
    "y-33": 1.88,
    "y-34": 1.874,
    "y-35": 1.886,
    "y-36": 1.886,
    "y-37": 1.883,
    "y-38": 1.886,
    "y-39": 1.886,
    "y-40": 1.887,
    "y-41": 1.888,
    "y-42": 1.884,
    "y-43": 1.949,
    "y-44": 1.951,
    "y-45": 1.948,
    "y-47": 1.952,
    "y-48": 1.947,
    "y-49": 1.947,
    "y-50": 1.944,
    "y-51": 1.95,
    "y-52": 1.947,
    "y-53": 1.947,
    "y-54": 1.95,
    "y-55": 1.943,
    "y-56": 1.95,
    "y-57": 1.81,
    "y-58": 1.81,
    "y-59": 1.813,
    "y-60": 1.812,
    "y-61": 1.812,
    "y-62": 1.812,
    "y-63": 1.815,
    "y-64": 1.816,
    "y-65": 1.815,
    "y-66": 1.801,
    "y-67": 1.799,
    "y-68": 1.8,
    "y-69": 1.801,
    "y-70": 1.8,
    "y-71": 1.799,
    "y-72": 1.799,
    "y-73": 1.8,
    "y-74": 1.8,
    "y-75": 1.797,
    "y-76": 1.797,
    "y-77": 1.796,
    "y-78": 1.797,
    "y-79": 1.797,
    "y-80": 1.796,
    "y-81": 1.796,
    "y-82": 1.796,
    "y-83": 1.796,
    "y-84": 1.796,
    "y-85": 1.797,
    "y-86": 1.797,
    "y-87": 1.797,
    "y-88": 1.796,
    "y-89": 1.796,
    "y-90": 1.797,
    "y-91": 1.797,
    "y-92": 1.797,
    "y-93": 1.797,
    "y-94": 1.796,
    "y-95": 1.797,
    "y-96": 1.797,
    "y-97": 1.796,
    "y-98": 1.795,
    "y-99": 1.797,
    "y-100": 1.796,
    "y-101": 1.796,
    "y-102": 1.797,
    "y-103": 1.796,
    "y-104": 1.797,
    "y-105": 1.796,
    "y-106": 1.797,
    "y-107": 1.796,
    "y-108": 1.796,
    "y-109": 1.796,
    "y-110": 1.796,
    "y-111": 1.796,
    "y-112": 1.796,
    "y-113": 1.796,
    "y-114": 1.796,
    "y-115": 1.796,
    "y-116": 1.796,
    "y-117": 1.796,
    "y-118": 1.796,
    "y-119": 1.796,
    "y-120": 1.796,
    "y-121": 1.796,
    "y-122": 1.796,
    "y-123": 1.796,
    "y-124": 1.796,
    "y-125": 1.796,
    "y-126": 1.796,
    "y-127": 1.796,
    "y-128": 1.796,
    "y-129": 1.796,
    "y-130": 1.796,
    "y-131": 1.796,
    "y-132": 1.796,
    "y-133": 1.806,
    "y-134": 1.834,
    "y-135": 1.834,
    "y-136": 1.834,
    "y-137": 1.834,
    "y-138": 1.834,
    "y-139": 1.834,
    "y-140": 1.834,
    "y-141": 1.834,
    "y-142": 1.834,
    "y-143": 1.834,
    "y-144": 1.834,
    "y-145": 1.851,
    "y-146": 1.851,
    "y-147": 1.85,
    "y-148": 1.85,
    "y-149": 1.85,
    "y-150": 1.85,
    "y-151": 1.85,
    "y-152": 1.85,
    "y-153": 1.85,
    "y-154": 1.85,
    "y-155": 1.85,
    "y-156": 1.85,
    "y-157": 1.85,
    "y-158": 1.85,
    "y-159": 1.85,
    "y-160": 1.85,
    "y-161": 1.85,
    "y-162": 1.85,
    "y-163": 1.85,
    "y-164": 1.85,
    "y-165": 1.85,
    "y-166": 1.85,
    "y-167": 1.85,
    "y-168": 1.85,
    "y-169": 1.85,
    "y-170": 1.85,
    "y-171": 1.85,
    "y-172": 1.85,
    "y-173": 1.85,
    "y-174": 1.85,
    "y-175": 1.85,
    "y-176": 1.85,
    "y-177": 1.85,
    "y-178": 1.85,
    "y-179": 1.85,
    "y-180": 1.85,
    "y-181": 1.85,
    "y-182": 1.85,
    "y-183": 1.85,
    "y-184": 1.85,
    "y-185": 1.847,
    "y-186": 1.847,
    "y-187": 1.847,
    "y-188": 1.847,
    "y-189": 1.847,
    "y-190": 1.847,
    "y-191": 1.847,
    "y-192": 1.847,
    "y-193": 1.847,
    "y-194": 1.847,
    "y-195": 1.847,
    "y-196": 1.847,
    "y-197": 1.847,
    "y-198": 1.847,
    "y-199": 1.847,
    "y-200": 1.847,
    "y-201": 1.847,
    "y-202": 1.847,
    "y-203": 1.847,
    "y-204": 1.847,
    "y-205": 1.847,
    "y-206": 1.847,
    "y-207": 1.847,
    "y-208": 1.847,
    "y-209": 1.847,
    "y-210": 1.847,
    "y-211": 1.847,
    "y-212": 1.847,
    "y-213": 1.847,
    "y-214": 1.847,
    "y-215": 1.847,
    "y-216": 1.847,
    "y-217": 1.867,
    "y-218": 1.867,
    "y-219": 1.873,
    "y-220": 1.873,
    "y-221": 1.873,
    "y-222": 1.873,
    "y-223": 1.873,
    "y-224": 1.873,
    "y-225": 1.873,
    "y-226": 1.873,
    "y-227": 1.873,
    "y-228": 1.873,
    "y-229": 1.873,
    "y-230": 1.873,
    "y-231": 1.873,
    "y-232": 1.873,
    "y-233": 1.873,
    "y-234": 1.873,
    "y-235": 1.873,
    "y-236": 1.873,
    "y-237": 1.873,
    "y-238": 1.873,
    "y-239": 1.873,
    "y-240": 1.873,
    "y-241": 1.873,
    "y-242": 1.873,
    "y-243": 1.876,
    "y-244": 1.876,
    "y-245": 1.876,
    "y-246": 1.876,
    "y-247": 1.876,
    "y-248": 1.876,
    "y-249": 1.873,
    "y-250": 1.873,
    "y-251": 1.873,
    "y-252": 1.873,
    "y-253": 1.873,
    "y-254": 1.873,
    "y-255": 1.873,
  },
  {
    x: -0.5,
    "y-2": 0.267,
    "y-12": 1.654,
    "y-46": 1.654,
    "y-1000": 1.654,
    "y-0": 0.347,
    "y-1": 0.206,
    "y-3": 1.962,
    "y-4": 1.35,
    "y-5": 1.48,
    "y-6": 1.546,
    "y-7": 1.614,
    "y-8": 1.654,
    "y-9": 1.654,
    "y-10": 1.654,
    "y-11": 1.654,
    "y-13": 1.799,
    "y-14": 1.799,
    "y-15": 1.799,
    "y-16": 1.799,
    "y-17": 1.799,
    "y-18": 1.799,
    "y-19": 1.799,
    "y-20": 1.799,
    "y-21": 1.799,
    "y-22": 1.799,
    "y-23": 1.799,
    "y-24": 1.799,
    "y-25": 1.799,
    "y-26": 1.799,
    "y-27": 1.799,
    "y-28": 1.799,
    "y-29": 1.799,
    "y-30": 1.799,
    "y-31": 1.799,
    "y-32": 1.654,
    "y-33": 1.654,
    "y-34": 1.654,
    "y-35": 1.654,
    "y-36": 1.654,
    "y-37": 1.654,
    "y-38": 1.654,
    "y-39": 1.654,
    "y-40": 1.654,
    "y-41": 1.654,
    "y-42": 1.654,
    "y-43": 1.654,
    "y-44": 1.654,
    "y-45": 1.654,
    "y-47": 1.654,
    "y-48": 1.654,
    "y-49": 1.654,
    "y-50": 1.654,
    "y-51": 1.654,
    "y-52": 1.654,
    "y-53": 1.654,
    "y-54": 1.654,
    "y-55": 1.654,
    "y-56": 1.654,
    "y-57": 1.654,
    "y-58": 1.654,
    "y-59": 1.654,
    "y-60": 1.654,
    "y-61": 1.654,
    "y-62": 1.654,
    "y-63": 1.654,
    "y-64": 1.654,
    "y-65": 1.654,
    "y-66": 1.654,
    "y-67": 1.654,
    "y-68": 1.654,
    "y-69": 1.654,
    "y-70": 1.654,
    "y-71": 1.654,
    "y-72": 1.654,
    "y-73": 1.654,
    "y-74": 1.654,
    "y-75": 1.654,
    "y-76": 1.654,
    "y-77": 1.654,
    "y-78": 1.654,
    "y-79": 1.654,
    "y-80": 1.654,
    "y-81": 1.654,
    "y-82": 1.654,
    "y-83": 1.654,
    "y-84": 1.654,
    "y-85": 1.654,
    "y-86": 1.654,
    "y-87": 1.654,
    "y-88": 1.654,
    "y-89": 1.654,
    "y-90": 1.654,
    "y-91": 1.654,
    "y-92": 1.654,
    "y-93": 1.654,
    "y-94": 1.654,
    "y-95": 1.654,
    "y-96": 1.654,
    "y-97": 1.654,
    "y-98": 1.654,
    "y-99": 1.654,
    "y-100": 1.654,
    "y-101": 1.654,
    "y-102": 1.654,
    "y-103": 1.654,
    "y-104": 1.654,
    "y-105": 1.654,
    "y-106": 1.654,
    "y-107": 1.654,
    "y-108": 1.654,
    "y-109": 1.654,
    "y-110": 1.654,
    "y-111": 1.654,
    "y-112": 1.654,
    "y-113": 1.654,
    "y-114": 1.654,
    "y-115": 1.654,
    "y-116": 1.654,
    "y-117": 1.654,
    "y-118": 1.654,
    "y-119": 1.654,
    "y-120": 1.654,
    "y-121": 1.654,
    "y-122": 1.654,
    "y-123": 1.654,
    "y-124": 1.654,
    "y-125": 1.654,
    "y-126": 1.654,
    "y-127": 1.654,
    "y-128": 1.654,
    "y-129": 1.654,
    "y-130": 1.654,
    "y-131": 1.654,
    "y-132": 1.654,
    "y-133": 1.654,
    "y-134": 1.654,
    "y-135": 1.654,
    "y-136": 1.654,
    "y-137": 1.654,
    "y-138": 1.654,
    "y-139": 1.654,
    "y-140": 1.654,
    "y-141": 1.654,
    "y-142": 1.654,
    "y-143": 1.654,
    "y-144": 1.654,
    "y-145": 1.654,
    "y-146": 1.654,
    "y-147": 1.654,
    "y-148": 1.654,
    "y-149": 1.654,
    "y-150": 1.654,
    "y-151": 1.654,
    "y-152": 1.654,
    "y-153": 1.654,
    "y-154": 1.654,
    "y-155": 1.654,
    "y-156": 1.654,
    "y-157": 1.654,
    "y-158": 1.654,
    "y-159": 1.654,
    "y-160": 1.654,
    "y-161": 1.654,
    "y-162": 1.654,
    "y-163": 1.654,
    "y-164": 1.654,
    "y-165": 1.654,
    "y-166": 1.654,
    "y-167": 1.654,
    "y-168": 1.654,
    "y-169": 1.654,
    "y-170": 1.654,
    "y-171": 1.654,
    "y-172": 1.654,
    "y-173": 1.654,
    "y-174": 1.654,
    "y-175": 1.654,
    "y-176": 1.654,
    "y-177": 1.654,
    "y-178": 1.654,
    "y-179": 1.654,
    "y-180": 1.654,
    "y-181": 1.654,
    "y-182": 1.654,
    "y-183": 1.654,
    "y-184": 1.654,
    "y-185": 1.654,
    "y-186": 1.654,
    "y-187": 1.654,
    "y-188": 1.654,
    "y-189": 1.654,
    "y-190": 1.654,
    "y-191": 1.654,
    "y-192": 1.654,
    "y-193": 1.654,
    "y-194": 1.654,
    "y-195": 1.654,
    "y-196": 1.654,
    "y-197": 1.654,
    "y-198": 1.654,
    "y-199": 1.654,
    "y-200": 1.654,
    "y-201": 1.654,
    "y-202": 1.654,
    "y-203": 1.654,
    "y-204": 1.654,
    "y-205": 1.654,
    "y-206": 1.654,
    "y-207": 1.654,
    "y-208": 1.654,
    "y-209": 1.654,
    "y-210": 1.654,
    "y-211": 1.654,
    "y-212": 1.654,
    "y-213": 1.654,
    "y-214": 1.654,
    "y-215": 1.654,
    "y-216": 1.654,
    "y-217": 1.654,
    "y-218": 1.654,
    "y-219": 1.654,
    "y-220": 1.654,
    "y-221": 1.654,
    "y-222": 1.654,
    "y-223": 1.654,
    "y-224": 1.654,
    "y-225": 1.654,
    "y-226": 1.654,
    "y-227": 1.654,
    "y-228": 1.654,
    "y-229": 1.654,
    "y-230": 1.654,
    "y-231": 1.654,
    "y-232": 1.654,
    "y-233": 1.654,
    "y-234": 1.654,
    "y-235": 1.654,
    "y-236": 1.654,
    "y-237": 1.654,
    "y-238": 1.654,
    "y-239": 1.654,
    "y-240": 1.654,
    "y-241": 1.654,
    "y-242": 1.654,
    "y-243": 1.654,
    "y-244": 1.654,
    "y-245": 1.654,
    "y-246": 1.654,
    "y-247": 1.654,
    "y-248": 1.654,
    "y-249": 1.654,
    "y-250": 1.654,
    "y-251": 1.654,
    "y-252": 1.654,
    "y-253": 1.654,
    "y-254": 1.654,
    "y-255": 1.654,
  },
  {
    x: -0.475,
    "y-2": 0.246,
    "y-12": 1.525,
    "y-46": 1.359,
    "y-1000": 1.489,
    "y-0": 0.335,
    "y-1": 0.181,
    "y-3": 1.886,
    "y-4": 1.289,
    "y-5": 1.353,
    "y-6": 1.406,
    "y-7": 1.46,
    "y-8": 1.525,
    "y-9": 1.525,
    "y-10": 1.525,
    "y-11": 1.525,
    "y-13": 1.618,
    "y-14": 1.618,
    "y-15": 1.618,
    "y-16": 1.618,
    "y-17": 1.618,
    "y-18": 1.618,
    "y-19": 1.618,
    "y-20": 1.618,
    "y-21": 1.618,
    "y-22": 1.618,
    "y-23": 1.618,
    "y-24": 1.618,
    "y-25": 1.618,
    "y-26": 1.618,
    "y-27": 1.618,
    "y-28": 1.618,
    "y-29": 1.618,
    "y-30": 1.618,
    "y-31": 1.618,
    "y-32": 1.272,
    "y-33": 1.429,
    "y-34": 1.435,
    "y-35": 1.423,
    "y-36": 1.423,
    "y-37": 1.426,
    "y-38": 1.423,
    "y-39": 1.423,
    "y-40": 1.422,
    "y-41": 1.421,
    "y-42": 1.425,
    "y-43": 1.36,
    "y-44": 1.358,
    "y-45": 1.361,
    "y-47": 1.357,
    "y-48": 1.362,
    "y-49": 1.362,
    "y-50": 1.365,
    "y-51": 1.359,
    "y-52": 1.362,
    "y-53": 1.362,
    "y-54": 1.359,
    "y-55": 1.365,
    "y-56": 1.359,
    "y-57": 1.499,
    "y-58": 1.499,
    "y-59": 1.496,
    "y-60": 1.497,
    "y-61": 1.497,
    "y-62": 1.497,
    "y-63": 1.494,
    "y-64": 1.493,
    "y-65": 1.494,
    "y-66": 1.508,
    "y-67": 1.51,
    "y-68": 1.509,
    "y-69": 1.508,
    "y-70": 1.509,
    "y-71": 1.51,
    "y-72": 1.51,
    "y-73": 1.509,
    "y-74": 1.509,
    "y-75": 1.512,
    "y-76": 1.512,
    "y-77": 1.513,
    "y-78": 1.512,
    "y-79": 1.512,
    "y-80": 1.513,
    "y-81": 1.513,
    "y-82": 1.513,
    "y-83": 1.513,
    "y-84": 1.513,
    "y-85": 1.512,
    "y-86": 1.512,
    "y-87": 1.512,
    "y-88": 1.513,
    "y-89": 1.513,
    "y-90": 1.512,
    "y-91": 1.512,
    "y-92": 1.512,
    "y-93": 1.512,
    "y-94": 1.513,
    "y-95": 1.512,
    "y-96": 1.512,
    "y-97": 1.513,
    "y-98": 1.514,
    "y-99": 1.512,
    "y-100": 1.513,
    "y-101": 1.513,
    "y-102": 1.512,
    "y-103": 1.513,
    "y-104": 1.512,
    "y-105": 1.513,
    "y-106": 1.512,
    "y-107": 1.513,
    "y-108": 1.513,
    "y-109": 1.513,
    "y-110": 1.513,
    "y-111": 1.513,
    "y-112": 1.513,
    "y-113": 1.513,
    "y-114": 1.513,
    "y-115": 1.513,
    "y-116": 1.513,
    "y-117": 1.513,
    "y-118": 1.513,
    "y-119": 1.513,
    "y-120": 1.513,
    "y-121": 1.513,
    "y-122": 1.513,
    "y-123": 1.513,
    "y-124": 1.513,
    "y-125": 1.513,
    "y-126": 1.513,
    "y-127": 1.513,
    "y-128": 1.513,
    "y-129": 1.513,
    "y-130": 1.513,
    "y-131": 1.513,
    "y-132": 1.513,
    "y-133": 1.503,
    "y-134": 1.511,
    "y-135": 1.511,
    "y-136": 1.511,
    "y-137": 1.511,
    "y-138": 1.511,
    "y-139": 1.511,
    "y-140": 1.511,
    "y-141": 1.511,
    "y-142": 1.511,
    "y-143": 1.511,
    "y-144": 1.511,
    "y-145": 1.483,
    "y-146": 1.483,
    "y-147": 1.483,
    "y-148": 1.483,
    "y-149": 1.484,
    "y-150": 1.484,
    "y-151": 1.484,
    "y-152": 1.484,
    "y-153": 1.484,
    "y-154": 1.484,
    "y-155": 1.484,
    "y-156": 1.484,
    "y-157": 1.484,
    "y-158": 1.484,
    "y-159": 1.484,
    "y-160": 1.484,
    "y-161": 1.484,
    "y-162": 1.484,
    "y-163": 1.484,
    "y-164": 1.484,
    "y-165": 1.484,
    "y-166": 1.484,
    "y-167": 1.484,
    "y-168": 1.484,
    "y-169": 1.484,
    "y-170": 1.484,
    "y-171": 1.484,
    "y-172": 1.484,
    "y-173": 1.484,
    "y-174": 1.484,
    "y-175": 1.484,
    "y-176": 1.484,
    "y-177": 1.484,
    "y-178": 1.484,
    "y-179": 1.484,
    "y-180": 1.484,
    "y-181": 1.484,
    "y-182": 1.484,
    "y-183": 1.484,
    "y-184": 1.484,
    "y-185": 1.485,
    "y-186": 1.485,
    "y-187": 1.485,
    "y-188": 1.485,
    "y-189": 1.485,
    "y-190": 1.485,
    "y-191": 1.485,
    "y-192": 1.485,
    "y-193": 1.485,
    "y-194": 1.485,
    "y-195": 1.485,
    "y-196": 1.485,
    "y-197": 1.485,
    "y-198": 1.485,
    "y-199": 1.485,
    "y-200": 1.485,
    "y-201": 1.485,
    "y-202": 1.485,
    "y-203": 1.485,
    "y-204": 1.485,
    "y-205": 1.485,
    "y-206": 1.485,
    "y-207": 1.485,
    "y-208": 1.485,
    "y-209": 1.485,
    "y-210": 1.485,
    "y-211": 1.485,
    "y-212": 1.485,
    "y-213": 1.485,
    "y-214": 1.485,
    "y-215": 1.485,
    "y-216": 1.485,
    "y-217": 1.497,
    "y-218": 1.497,
    "y-219": 1.496,
    "y-220": 1.496,
    "y-221": 1.496,
    "y-222": 1.496,
    "y-223": 1.496,
    "y-224": 1.496,
    "y-225": 1.496,
    "y-226": 1.496,
    "y-227": 1.496,
    "y-228": 1.496,
    "y-229": 1.496,
    "y-230": 1.496,
    "y-231": 1.496,
    "y-232": 1.496,
    "y-233": 1.496,
    "y-234": 1.496,
    "y-235": 1.496,
    "y-236": 1.496,
    "y-237": 1.496,
    "y-238": 1.496,
    "y-239": 1.496,
    "y-240": 1.496,
    "y-241": 1.496,
    "y-242": 1.496,
    "y-243": 1.495,
    "y-244": 1.495,
    "y-245": 1.495,
    "y-246": 1.495,
    "y-247": 1.495,
    "y-248": 1.495,
    "y-249": 1.496,
    "y-250": 1.496,
    "y-251": 1.496,
    "y-252": 1.496,
    "y-253": 1.496,
    "y-254": 1.496,
    "y-255": 1.496,
  },
  {
    x: -0.45,
    "y-2": 0.224,
    "y-12": 1.395,
    "y-46": 1.064,
    "y-1000": 1.351,
    "y-0": 0.323,
    "y-1": 0.157,
    "y-3": 1.81,
    "y-4": 1.228,
    "y-5": 1.227,
    "y-6": 1.266,
    "y-7": 1.305,
    "y-8": 1.395,
    "y-9": 1.395,
    "y-10": 1.395,
    "y-11": 1.395,
    "y-13": 1.438,
    "y-14": 1.438,
    "y-15": 1.438,
    "y-16": 1.438,
    "y-17": 1.438,
    "y-18": 1.438,
    "y-19": 1.438,
    "y-20": 1.438,
    "y-21": 1.438,
    "y-22": 1.438,
    "y-23": 1.438,
    "y-24": 1.438,
    "y-25": 1.438,
    "y-26": 1.438,
    "y-27": 1.438,
    "y-28": 1.438,
    "y-29": 1.438,
    "y-30": 1.438,
    "y-31": 1.438,
    "y-32": 0.89,
    "y-33": 1.203,
    "y-34": 1.216,
    "y-35": 1.191,
    "y-36": 1.192,
    "y-37": 1.198,
    "y-38": 1.192,
    "y-39": 1.192,
    "y-40": 1.189,
    "y-41": 1.187,
    "y-42": 1.195,
    "y-43": 1.065,
    "y-44": 1.061,
    "y-45": 1.068,
    "y-47": 1.06,
    "y-48": 1.07,
    "y-49": 1.07,
    "y-50": 1.076,
    "y-51": 1.063,
    "y-52": 1.069,
    "y-53": 1.069,
    "y-54": 1.063,
    "y-55": 1.076,
    "y-56": 1.063,
    "y-57": 1.344,
    "y-58": 1.343,
    "y-59": 1.337,
    "y-60": 1.339,
    "y-61": 1.339,
    "y-62": 1.339,
    "y-63": 1.333,
    "y-64": 1.332,
    "y-65": 1.334,
    "y-66": 1.362,
    "y-67": 1.366,
    "y-68": 1.364,
    "y-69": 1.362,
    "y-70": 1.363,
    "y-71": 1.365,
    "y-72": 1.365,
    "y-73": 1.364,
    "y-74": 1.363,
    "y-75": 1.369,
    "y-76": 1.369,
    "y-77": 1.371,
    "y-78": 1.37,
    "y-79": 1.369,
    "y-80": 1.372,
    "y-81": 1.371,
    "y-82": 1.371,
    "y-83": 1.371,
    "y-84": 1.371,
    "y-85": 1.369,
    "y-86": 1.37,
    "y-87": 1.37,
    "y-88": 1.371,
    "y-89": 1.371,
    "y-90": 1.37,
    "y-91": 1.369,
    "y-92": 1.37,
    "y-93": 1.37,
    "y-94": 1.372,
    "y-95": 1.37,
    "y-96": 1.37,
    "y-97": 1.371,
    "y-98": 1.373,
    "y-99": 1.369,
    "y-100": 1.372,
    "y-101": 1.372,
    "y-102": 1.37,
    "y-103": 1.372,
    "y-104": 1.37,
    "y-105": 1.371,
    "y-106": 1.369,
    "y-107": 1.372,
    "y-108": 1.372,
    "y-109": 1.372,
    "y-110": 1.372,
    "y-111": 1.372,
    "y-112": 1.372,
    "y-113": 1.372,
    "y-114": 1.372,
    "y-115": 1.372,
    "y-116": 1.372,
    "y-117": 1.372,
    "y-118": 1.372,
    "y-119": 1.372,
    "y-120": 1.372,
    "y-121": 1.371,
    "y-122": 1.372,
    "y-123": 1.372,
    "y-124": 1.372,
    "y-125": 1.372,
    "y-126": 1.372,
    "y-127": 1.372,
    "y-128": 1.372,
    "y-129": 1.372,
    "y-130": 1.372,
    "y-131": 1.372,
    "y-132": 1.372,
    "y-133": 1.351,
    "y-134": 1.367,
    "y-135": 1.367,
    "y-136": 1.367,
    "y-137": 1.367,
    "y-138": 1.367,
    "y-139": 1.367,
    "y-140": 1.367,
    "y-141": 1.367,
    "y-142": 1.367,
    "y-143": 1.367,
    "y-144": 1.367,
    "y-145": 1.334,
    "y-146": 1.334,
    "y-147": 1.335,
    "y-148": 1.335,
    "y-149": 1.335,
    "y-150": 1.335,
    "y-151": 1.335,
    "y-152": 1.335,
    "y-153": 1.335,
    "y-154": 1.335,
    "y-155": 1.335,
    "y-156": 1.335,
    "y-157": 1.335,
    "y-158": 1.335,
    "y-159": 1.335,
    "y-160": 1.335,
    "y-161": 1.335,
    "y-162": 1.335,
    "y-163": 1.335,
    "y-164": 1.335,
    "y-165": 1.335,
    "y-166": 1.335,
    "y-167": 1.335,
    "y-168": 1.335,
    "y-169": 1.335,
    "y-170": 1.335,
    "y-171": 1.335,
    "y-172": 1.335,
    "y-173": 1.335,
    "y-174": 1.335,
    "y-175": 1.335,
    "y-176": 1.335,
    "y-177": 1.335,
    "y-178": 1.335,
    "y-179": 1.335,
    "y-180": 1.335,
    "y-181": 1.335,
    "y-182": 1.335,
    "y-183": 1.335,
    "y-184": 1.335,
    "y-185": 1.337,
    "y-186": 1.337,
    "y-187": 1.337,
    "y-188": 1.337,
    "y-189": 1.337,
    "y-190": 1.337,
    "y-191": 1.337,
    "y-192": 1.337,
    "y-193": 1.337,
    "y-194": 1.337,
    "y-195": 1.337,
    "y-196": 1.337,
    "y-197": 1.337,
    "y-198": 1.337,
    "y-199": 1.337,
    "y-200": 1.337,
    "y-201": 1.337,
    "y-202": 1.337,
    "y-203": 1.337,
    "y-204": 1.337,
    "y-205": 1.337,
    "y-206": 1.337,
    "y-207": 1.337,
    "y-208": 1.337,
    "y-209": 1.337,
    "y-210": 1.337,
    "y-211": 1.337,
    "y-212": 1.337,
    "y-213": 1.337,
    "y-214": 1.338,
    "y-215": 1.338,
    "y-216": 1.338,
    "y-217": 1.353,
    "y-218": 1.353,
    "y-219": 1.352,
    "y-220": 1.352,
    "y-221": 1.352,
    "y-222": 1.352,
    "y-223": 1.352,
    "y-224": 1.352,
    "y-225": 1.352,
    "y-226": 1.352,
    "y-227": 1.352,
    "y-228": 1.352,
    "y-229": 1.352,
    "y-230": 1.352,
    "y-231": 1.352,
    "y-232": 1.352,
    "y-233": 1.352,
    "y-234": 1.352,
    "y-235": 1.352,
    "y-236": 1.352,
    "y-237": 1.352,
    "y-238": 1.352,
    "y-239": 1.352,
    "y-240": 1.352,
    "y-241": 1.352,
    "y-242": 1.352,
    "y-243": 1.351,
    "y-244": 1.351,
    "y-245": 1.351,
    "y-246": 1.351,
    "y-247": 1.351,
    "y-248": 1.351,
    "y-249": 1.353,
    "y-250": 1.353,
    "y-251": 1.353,
    "y-252": 1.353,
    "y-253": 1.353,
    "y-254": 1.353,
    "y-255": 1.353,
  },
  {
    x: -0.425,
    "y-2": 0.203,
    "y-12": 1.266,
    "y-46": 0.769,
    "y-1000": 1.232,
    "y-0": 0.311,
    "y-1": 0.132,
    "y-3": 1.735,
    "y-4": 1.167,
    "y-5": 1.101,
    "y-6": 1.125,
    "y-7": 1.151,
    "y-8": 1.266,
    "y-9": 1.266,
    "y-10": 1.266,
    "y-11": 1.266,
    "y-13": 1.257,
    "y-14": 1.257,
    "y-15": 1.257,
    "y-16": 1.257,
    "y-17": 1.257,
    "y-18": 1.257,
    "y-19": 1.257,
    "y-20": 1.257,
    "y-21": 1.257,
    "y-22": 1.257,
    "y-23": 1.257,
    "y-24": 1.257,
    "y-25": 1.257,
    "y-26": 1.257,
    "y-27": 1.257,
    "y-28": 1.257,
    "y-29": 1.257,
    "y-30": 1.257,
    "y-31": 1.257,
    "y-32": 0.508,
    "y-33": 0.977,
    "y-34": 0.996,
    "y-35": 0.959,
    "y-36": 0.961,
    "y-37": 0.97,
    "y-38": 0.961,
    "y-39": 0.961,
    "y-40": 0.956,
    "y-41": 0.954,
    "y-42": 0.966,
    "y-43": 0.771,
    "y-44": 0.764,
    "y-45": 0.775,
    "y-47": 0.763,
    "y-48": 0.778,
    "y-49": 0.778,
    "y-50": 0.787,
    "y-51": 0.768,
    "y-52": 0.777,
    "y-53": 0.777,
    "y-54": 0.767,
    "y-55": 0.787,
    "y-56": 0.767,
    "y-57": 1.189,
    "y-58": 1.187,
    "y-59": 1.178,
    "y-60": 1.181,
    "y-61": 1.181,
    "y-62": 1.181,
    "y-63": 1.172,
    "y-64": 1.171,
    "y-65": 1.173,
    "y-66": 1.216,
    "y-67": 1.221,
    "y-68": 1.219,
    "y-69": 1.216,
    "y-70": 1.218,
    "y-71": 1.22,
    "y-72": 1.22,
    "y-73": 1.219,
    "y-74": 1.217,
    "y-75": 1.226,
    "y-76": 1.226,
    "y-77": 1.229,
    "y-78": 1.228,
    "y-79": 1.226,
    "y-80": 1.231,
    "y-81": 1.229,
    "y-82": 1.229,
    "y-83": 1.229,
    "y-84": 1.229,
    "y-85": 1.227,
    "y-86": 1.228,
    "y-87": 1.227,
    "y-88": 1.23,
    "y-89": 1.23,
    "y-90": 1.228,
    "y-91": 1.226,
    "y-92": 1.228,
    "y-93": 1.228,
    "y-94": 1.231,
    "y-95": 1.228,
    "y-96": 1.227,
    "y-97": 1.229,
    "y-98": 1.232,
    "y-99": 1.227,
    "y-100": 1.23,
    "y-101": 1.23,
    "y-102": 1.228,
    "y-103": 1.231,
    "y-104": 1.227,
    "y-105": 1.229,
    "y-106": 1.227,
    "y-107": 1.23,
    "y-108": 1.23,
    "y-109": 1.23,
    "y-110": 1.23,
    "y-111": 1.23,
    "y-112": 1.23,
    "y-113": 1.23,
    "y-114": 1.23,
    "y-115": 1.23,
    "y-116": 1.23,
    "y-117": 1.23,
    "y-118": 1.23,
    "y-119": 1.23,
    "y-120": 1.23,
    "y-121": 1.23,
    "y-122": 1.23,
    "y-123": 1.23,
    "y-124": 1.23,
    "y-125": 1.23,
    "y-126": 1.23,
    "y-127": 1.23,
    "y-128": 1.23,
    "y-129": 1.231,
    "y-130": 1.231,
    "y-131": 1.231,
    "y-132": 1.231,
    "y-133": 1.2,
    "y-134": 1.223,
    "y-135": 1.223,
    "y-136": 1.223,
    "y-137": 1.223,
    "y-138": 1.223,
    "y-139": 1.223,
    "y-140": 1.223,
    "y-141": 1.223,
    "y-142": 1.223,
    "y-143": 1.223,
    "y-144": 1.223,
    "y-145": 1.214,
    "y-146": 1.214,
    "y-147": 1.215,
    "y-148": 1.215,
    "y-149": 1.215,
    "y-150": 1.215,
    "y-151": 1.215,
    "y-152": 1.215,
    "y-153": 1.215,
    "y-154": 1.215,
    "y-155": 1.215,
    "y-156": 1.215,
    "y-157": 1.215,
    "y-158": 1.215,
    "y-159": 1.215,
    "y-160": 1.215,
    "y-161": 1.215,
    "y-162": 1.215,
    "y-163": 1.215,
    "y-164": 1.215,
    "y-165": 1.215,
    "y-166": 1.215,
    "y-167": 1.215,
    "y-168": 1.215,
    "y-169": 1.215,
    "y-170": 1.215,
    "y-171": 1.215,
    "y-172": 1.215,
    "y-173": 1.215,
    "y-174": 1.215,
    "y-175": 1.215,
    "y-176": 1.215,
    "y-177": 1.215,
    "y-178": 1.215,
    "y-179": 1.215,
    "y-180": 1.215,
    "y-181": 1.215,
    "y-182": 1.215,
    "y-183": 1.215,
    "y-184": 1.215,
    "y-185": 1.216,
    "y-186": 1.216,
    "y-187": 1.216,
    "y-188": 1.216,
    "y-189": 1.216,
    "y-190": 1.216,
    "y-191": 1.216,
    "y-192": 1.216,
    "y-193": 1.216,
    "y-194": 1.216,
    "y-195": 1.216,
    "y-196": 1.216,
    "y-197": 1.216,
    "y-198": 1.216,
    "y-199": 1.216,
    "y-200": 1.216,
    "y-201": 1.216,
    "y-202": 1.216,
    "y-203": 1.216,
    "y-204": 1.216,
    "y-205": 1.216,
    "y-206": 1.216,
    "y-207": 1.216,
    "y-208": 1.216,
    "y-209": 1.216,
    "y-210": 1.216,
    "y-211": 1.216,
    "y-212": 1.216,
    "y-213": 1.216,
    "y-214": 1.217,
    "y-215": 1.217,
    "y-216": 1.217,
    "y-217": 1.227,
    "y-218": 1.227,
    "y-219": 1.226,
    "y-220": 1.226,
    "y-221": 1.226,
    "y-222": 1.226,
    "y-223": 1.226,
    "y-224": 1.226,
    "y-225": 1.226,
    "y-226": 1.226,
    "y-227": 1.226,
    "y-228": 1.226,
    "y-229": 1.226,
    "y-230": 1.226,
    "y-231": 1.226,
    "y-232": 1.226,
    "y-233": 1.226,
    "y-234": 1.226,
    "y-235": 1.227,
    "y-236": 1.227,
    "y-237": 1.227,
    "y-238": 1.227,
    "y-239": 1.227,
    "y-240": 1.227,
    "y-241": 1.227,
    "y-242": 1.227,
    "y-243": 1.226,
    "y-244": 1.226,
    "y-245": 1.226,
    "y-246": 1.226,
    "y-247": 1.226,
    "y-248": 1.226,
    "y-249": 1.227,
    "y-250": 1.227,
    "y-251": 1.227,
    "y-252": 1.227,
    "y-253": 1.227,
    "y-254": 1.227,
    "y-255": 1.227,
  },
  {
    x: -0.4,
    "y-2": 0.182,
    "y-12": 1.136,
    "y-46": 1.136,
    "y-1000": 1.136,
    "y-0": 0.299,
    "y-1": 0.107,
    "y-3": 1.659,
    "y-4": 1.106,
    "y-5": 0.974,
    "y-6": 0.985,
    "y-7": 0.996,
    "y-8": 1.136,
    "y-9": 1.136,
    "y-10": 1.136,
    "y-11": 1.136,
    "y-13": 1.076,
    "y-14": 1.076,
    "y-15": 1.076,
    "y-16": 1.076,
    "y-17": 1.076,
    "y-18": 1.076,
    "y-19": 1.076,
    "y-20": 1.076,
    "y-21": 1.076,
    "y-22": 1.076,
    "y-23": 1.076,
    "y-24": 1.076,
    "y-25": 1.076,
    "y-26": 1.076,
    "y-27": 1.076,
    "y-28": 1.076,
    "y-29": 1.076,
    "y-30": 1.076,
    "y-31": 1.076,
    "y-32": 1.136,
    "y-33": 1.136,
    "y-34": 1.136,
    "y-35": 1.136,
    "y-36": 1.136,
    "y-37": 1.136,
    "y-38": 1.136,
    "y-39": 1.136,
    "y-40": 1.136,
    "y-41": 1.136,
    "y-42": 1.136,
    "y-43": 1.136,
    "y-44": 1.136,
    "y-45": 1.136,
    "y-47": 1.136,
    "y-48": 1.136,
    "y-49": 1.136,
    "y-50": 1.136,
    "y-51": 1.136,
    "y-52": 1.136,
    "y-53": 1.136,
    "y-54": 1.136,
    "y-55": 1.136,
    "y-56": 1.136,
    "y-57": 1.136,
    "y-58": 1.136,
    "y-59": 1.136,
    "y-60": 1.136,
    "y-61": 1.136,
    "y-62": 1.136,
    "y-63": 1.136,
    "y-64": 1.136,
    "y-65": 1.136,
    "y-66": 1.136,
    "y-67": 1.136,
    "y-68": 1.136,
    "y-69": 1.136,
    "y-70": 1.136,
    "y-71": 1.136,
    "y-72": 1.136,
    "y-73": 1.136,
    "y-74": 1.136,
    "y-75": 1.136,
    "y-76": 1.136,
    "y-77": 1.136,
    "y-78": 1.136,
    "y-79": 1.136,
    "y-80": 1.136,
    "y-81": 1.136,
    "y-82": 1.136,
    "y-83": 1.136,
    "y-84": 1.136,
    "y-85": 1.136,
    "y-86": 1.136,
    "y-87": 1.136,
    "y-88": 1.136,
    "y-89": 1.136,
    "y-90": 1.136,
    "y-91": 1.136,
    "y-92": 1.136,
    "y-93": 1.136,
    "y-94": 1.136,
    "y-95": 1.136,
    "y-96": 1.136,
    "y-97": 1.136,
    "y-98": 1.136,
    "y-99": 1.136,
    "y-100": 1.136,
    "y-101": 1.136,
    "y-102": 1.136,
    "y-103": 1.136,
    "y-104": 1.136,
    "y-105": 1.136,
    "y-106": 1.136,
    "y-107": 1.136,
    "y-108": 1.136,
    "y-109": 1.136,
    "y-110": 1.136,
    "y-111": 1.136,
    "y-112": 1.136,
    "y-113": 1.136,
    "y-114": 1.136,
    "y-115": 1.136,
    "y-116": 1.136,
    "y-117": 1.136,
    "y-118": 1.136,
    "y-119": 1.136,
    "y-120": 1.136,
    "y-121": 1.136,
    "y-122": 1.136,
    "y-123": 1.136,
    "y-124": 1.136,
    "y-125": 1.136,
    "y-126": 1.136,
    "y-127": 1.136,
    "y-128": 1.136,
    "y-129": 1.136,
    "y-130": 1.136,
    "y-131": 1.136,
    "y-132": 1.136,
    "y-133": 1.136,
    "y-134": 1.136,
    "y-135": 1.136,
    "y-136": 1.136,
    "y-137": 1.136,
    "y-138": 1.136,
    "y-139": 1.136,
    "y-140": 1.136,
    "y-141": 1.136,
    "y-142": 1.136,
    "y-143": 1.136,
    "y-144": 1.136,
    "y-145": 1.136,
    "y-146": 1.136,
    "y-147": 1.136,
    "y-148": 1.136,
    "y-149": 1.136,
    "y-150": 1.136,
    "y-151": 1.136,
    "y-152": 1.136,
    "y-153": 1.136,
    "y-154": 1.136,
    "y-155": 1.136,
    "y-156": 1.136,
    "y-157": 1.136,
    "y-158": 1.136,
    "y-159": 1.136,
    "y-160": 1.136,
    "y-161": 1.136,
    "y-162": 1.136,
    "y-163": 1.136,
    "y-164": 1.136,
    "y-165": 1.136,
    "y-166": 1.136,
    "y-167": 1.136,
    "y-168": 1.136,
    "y-169": 1.136,
    "y-170": 1.136,
    "y-171": 1.136,
    "y-172": 1.136,
    "y-173": 1.136,
    "y-174": 1.136,
    "y-175": 1.136,
    "y-176": 1.136,
    "y-177": 1.136,
    "y-178": 1.136,
    "y-179": 1.136,
    "y-180": 1.136,
    "y-181": 1.136,
    "y-182": 1.136,
    "y-183": 1.136,
    "y-184": 1.136,
    "y-185": 1.136,
    "y-186": 1.136,
    "y-187": 1.136,
    "y-188": 1.136,
    "y-189": 1.136,
    "y-190": 1.136,
    "y-191": 1.136,
    "y-192": 1.136,
    "y-193": 1.136,
    "y-194": 1.136,
    "y-195": 1.136,
    "y-196": 1.136,
    "y-197": 1.136,
    "y-198": 1.136,
    "y-199": 1.136,
    "y-200": 1.136,
    "y-201": 1.136,
    "y-202": 1.136,
    "y-203": 1.136,
    "y-204": 1.136,
    "y-205": 1.136,
    "y-206": 1.136,
    "y-207": 1.136,
    "y-208": 1.136,
    "y-209": 1.136,
    "y-210": 1.136,
    "y-211": 1.136,
    "y-212": 1.136,
    "y-213": 1.136,
    "y-214": 1.136,
    "y-215": 1.136,
    "y-216": 1.136,
    "y-217": 1.136,
    "y-218": 1.136,
    "y-219": 1.136,
    "y-220": 1.136,
    "y-221": 1.136,
    "y-222": 1.136,
    "y-223": 1.136,
    "y-224": 1.136,
    "y-225": 1.136,
    "y-226": 1.136,
    "y-227": 1.136,
    "y-228": 1.136,
    "y-229": 1.136,
    "y-230": 1.136,
    "y-231": 1.136,
    "y-232": 1.136,
    "y-233": 1.136,
    "y-234": 1.136,
    "y-235": 1.136,
    "y-236": 1.136,
    "y-237": 1.136,
    "y-238": 1.136,
    "y-239": 1.136,
    "y-240": 1.136,
    "y-241": 1.136,
    "y-242": 1.136,
    "y-243": 1.136,
    "y-244": 1.136,
    "y-245": 1.136,
    "y-246": 1.136,
    "y-247": 1.136,
    "y-248": 1.136,
    "y-249": 1.136,
    "y-250": 1.136,
    "y-251": 1.136,
    "y-252": 1.136,
    "y-253": 1.136,
    "y-254": 1.136,
    "y-255": 1.136,
  },
  {
    x: -0.375,
    "y-2": 0.161,
    "y-12": 1.007,
    "y-46": 1.313,
    "y-1000": 1.059,
    "y-0": 0.286,
    "y-1": 0.083,
    "y-3": 1.583,
    "y-4": 1.045,
    "y-5": 0.848,
    "y-6": 0.845,
    "y-7": 0.842,
    "y-8": 1.007,
    "y-9": 1.007,
    "y-10": 1.007,
    "y-11": 1.007,
    "y-13": 0.896,
    "y-14": 0.896,
    "y-15": 0.896,
    "y-16": 0.896,
    "y-17": 0.896,
    "y-18": 0.896,
    "y-19": 0.896,
    "y-20": 0.896,
    "y-21": 0.896,
    "y-22": 0.896,
    "y-23": 0.896,
    "y-24": 0.896,
    "y-25": 0.896,
    "y-26": 0.896,
    "y-27": 0.896,
    "y-28": 0.896,
    "y-29": 0.896,
    "y-30": 0.896,
    "y-31": 0.896,
    "y-32": 1.971,
    "y-33": 1.374,
    "y-34": 1.349,
    "y-35": 1.397,
    "y-36": 1.394,
    "y-37": 1.383,
    "y-38": 1.394,
    "y-39": 1.394,
    "y-40": 1.4,
    "y-41": 1.404,
    "y-42": 1.388,
    "y-43": 1.316,
    "y-44": 1.323,
    "y-45": 1.32,
    "y-47": 1.322,
    "y-48": 1.303,
    "y-49": 1.318,
    "y-50": 1.306,
    "y-51": 1.322,
    "y-52": 1.311,
    "y-53": 1.313,
    "y-54": 1.317,
    "y-55": 1.298,
    "y-56": 1.315,
    "y-57": 1.086,
    "y-58": 1.095,
    "y-59": 1.095,
    "y-60": 1.098,
    "y-61": 1.094,
    "y-62": 1.097,
    "y-63": 1.089,
    "y-64": 1.09,
    "y-65": 1.088,
    "y-66": 1.08,
    "y-67": 1.078,
    "y-68": 1.079,
    "y-69": 1.082,
    "y-70": 1.084,
    "y-71": 1.079,
    "y-72": 1.077,
    "y-73": 1.08,
    "y-74": 1.082,
    "y-75": 1.076,
    "y-76": 1.081,
    "y-77": 1.076,
    "y-78": 1.079,
    "y-79": 1.083,
    "y-80": 1.073,
    "y-81": 1.082,
    "y-82": 1.075,
    "y-83": 1.075,
    "y-84": 1.078,
    "y-85": 1.076,
    "y-86": 1.078,
    "y-87": 1.077,
    "y-88": 1.076,
    "y-89": 1.077,
    "y-90": 1.078,
    "y-91": 1.077,
    "y-92": 1.08,
    "y-93": 1.076,
    "y-94": 1.078,
    "y-95": 1.077,
    "y-96": 1.075,
    "y-97": 1.079,
    "y-98": 1.075,
    "y-99": 1.076,
    "y-100": 1.077,
    "y-101": 1.076,
    "y-102": 1.077,
    "y-103": 1.077,
    "y-104": 1.079,
    "y-105": 1.076,
    "y-106": 1.079,
    "y-107": 1.073,
    "y-108": 1.073,
    "y-109": 1.073,
    "y-110": 1.072,
    "y-111": 1.073,
    "y-112": 1.073,
    "y-113": 1.072,
    "y-114": 1.073,
    "y-115": 1.073,
    "y-116": 1.072,
    "y-117": 1.073,
    "y-118": 1.073,
    "y-119": 1.072,
    "y-120": 1.073,
    "y-121": 1.072,
    "y-122": 1.073,
    "y-123": 1.073,
    "y-124": 1.072,
    "y-125": 1.072,
    "y-126": 1.072,
    "y-127": 1.072,
    "y-128": 1.072,
    "y-129": 1.071,
    "y-130": 1.071,
    "y-131": 1.071,
    "y-132": 1.071,
    "y-133": 1.076,
    "y-134": 1.071,
    "y-135": 1.071,
    "y-136": 1.071,
    "y-137": 1.071,
    "y-138": 1.071,
    "y-139": 1.071,
    "y-140": 1.071,
    "y-141": 1.071,
    "y-142": 1.071,
    "y-143": 1.071,
    "y-144": 1.071,
    "y-145": 1.073,
    "y-146": 1.073,
    "y-147": 1.073,
    "y-148": 1.073,
    "y-149": 1.073,
    "y-150": 1.073,
    "y-151": 1.073,
    "y-152": 1.073,
    "y-153": 1.073,
    "y-154": 1.073,
    "y-155": 1.073,
    "y-156": 1.073,
    "y-157": 1.073,
    "y-158": 1.073,
    "y-159": 1.073,
    "y-160": 1.073,
    "y-161": 1.073,
    "y-162": 1.073,
    "y-163": 1.073,
    "y-164": 1.073,
    "y-165": 1.073,
    "y-166": 1.073,
    "y-167": 1.073,
    "y-168": 1.073,
    "y-169": 1.073,
    "y-170": 1.073,
    "y-171": 1.073,
    "y-172": 1.073,
    "y-173": 1.073,
    "y-174": 1.073,
    "y-175": 1.073,
    "y-176": 1.073,
    "y-177": 1.073,
    "y-178": 1.073,
    "y-179": 1.073,
    "y-180": 1.073,
    "y-181": 1.073,
    "y-182": 1.073,
    "y-183": 1.073,
    "y-184": 1.073,
    "y-185": 1.073,
    "y-186": 1.073,
    "y-187": 1.073,
    "y-188": 1.073,
    "y-189": 1.073,
    "y-190": 1.073,
    "y-191": 1.073,
    "y-192": 1.073,
    "y-193": 1.073,
    "y-194": 1.073,
    "y-195": 1.073,
    "y-196": 1.073,
    "y-197": 1.073,
    "y-198": 1.073,
    "y-199": 1.073,
    "y-200": 1.073,
    "y-201": 1.073,
    "y-202": 1.073,
    "y-203": 1.073,
    "y-204": 1.073,
    "y-205": 1.073,
    "y-206": 1.072,
    "y-207": 1.072,
    "y-208": 1.072,
    "y-209": 1.072,
    "y-210": 1.072,
    "y-211": 1.072,
    "y-212": 1.072,
    "y-213": 1.072,
    "y-214": 1.072,
    "y-215": 1.072,
    "y-216": 1.072,
    "y-217": 1.07,
    "y-218": 1.07,
    "y-219": 1.07,
    "y-220": 1.07,
    "y-221": 1.07,
    "y-222": 1.07,
    "y-223": 1.07,
    "y-224": 1.07,
    "y-225": 1.07,
    "y-226": 1.07,
    "y-227": 1.07,
    "y-228": 1.07,
    "y-229": 1.07,
    "y-230": 1.07,
    "y-231": 1.07,
    "y-232": 1.07,
    "y-233": 1.07,
    "y-234": 1.07,
    "y-235": 1.07,
    "y-236": 1.07,
    "y-237": 1.07,
    "y-238": 1.069,
    "y-239": 1.069,
    "y-240": 1.069,
    "y-241": 1.069,
    "y-242": 1.069,
    "y-243": 1.07,
    "y-244": 1.07,
    "y-245": 1.07,
    "y-246": 1.07,
    "y-247": 1.07,
    "y-248": 1.07,
    "y-249": 1.069,
    "y-250": 1.069,
    "y-251": 1.069,
    "y-252": 1.069,
    "y-253": 1.069,
    "y-254": 1.069,
    "y-255": 1.069,
  },
  {
    x: -0.35,
    "y-2": 0.139,
    "y-12": 0.982,
    "y-46": 1.078,
    "y-1000": 0.994,
    "y-0": 0.274,
    "y-1": 0.058,
    "y-3": 1.507,
    "y-4": 0.985,
    "y-5": 0.762,
    "y-6": 0.753,
    "y-7": 0.743,
    "y-8": 0.767,
    "y-9": 0.767,
    "y-10": 0.966,
    "y-11": 0.982,
    "y-13": 0.944,
    "y-14": 0.958,
    "y-15": 0.956,
    "y-16": 0.956,
    "y-17": 0.956,
    "y-18": 0.956,
    "y-19": 0.956,
    "y-20": 0.957,
    "y-21": 0.957,
    "y-22": 0.957,
    "y-23": 0.957,
    "y-24": 0.957,
    "y-25": 0.957,
    "y-26": 0.957,
    "y-27": 0.957,
    "y-28": 0.957,
    "y-29": 0.957,
    "y-30": 0.957,
    "y-31": 0.957,
    "y-32": 1.388,
    "y-33": 1.144,
    "y-34": 1.134,
    "y-35": 1.154,
    "y-36": 1.153,
    "y-37": 1.148,
    "y-38": 1.152,
    "y-39": 1.152,
    "y-40": 1.155,
    "y-41": 1.156,
    "y-42": 1.149,
    "y-43": 1.08,
    "y-44": 1.082,
    "y-45": 1.082,
    "y-47": 1.082,
    "y-48": 1.074,
    "y-49": 1.082,
    "y-50": 1.077,
    "y-51": 1.082,
    "y-52": 1.078,
    "y-53": 1.079,
    "y-54": 1.08,
    "y-55": 1.073,
    "y-56": 1.079,
    "y-57": 1.024,
    "y-58": 1.028,
    "y-59": 1.027,
    "y-60": 1.029,
    "y-61": 1.027,
    "y-62": 1.028,
    "y-63": 1.026,
    "y-64": 1.026,
    "y-65": 1.025,
    "y-66": 1.024,
    "y-67": 1.023,
    "y-68": 1.024,
    "y-69": 1.025,
    "y-70": 1.026,
    "y-71": 1.024,
    "y-72": 1.023,
    "y-73": 1.024,
    "y-74": 1.025,
    "y-75": 1.023,
    "y-76": 1.024,
    "y-77": 1.022,
    "y-78": 1.024,
    "y-79": 1.025,
    "y-80": 1.021,
    "y-81": 1.025,
    "y-82": 1.019,
    "y-83": 1.019,
    "y-84": 1.021,
    "y-85": 1.02,
    "y-86": 1.021,
    "y-87": 1.02,
    "y-88": 1.02,
    "y-89": 1.02,
    "y-90": 1.02,
    "y-91": 1.02,
    "y-92": 1.021,
    "y-93": 1.02,
    "y-94": 1.021,
    "y-95": 1.02,
    "y-96": 1.019,
    "y-97": 1.021,
    "y-98": 1.02,
    "y-99": 1.02,
    "y-100": 1.02,
    "y-101": 1.02,
    "y-102": 1.02,
    "y-103": 1.02,
    "y-104": 1.021,
    "y-105": 1.02,
    "y-106": 1.021,
    "y-107": 1.013,
    "y-108": 1.013,
    "y-109": 1.013,
    "y-110": 1.013,
    "y-111": 1.013,
    "y-112": 1.013,
    "y-113": 1.013,
    "y-114": 1.013,
    "y-115": 1.013,
    "y-116": 1.013,
    "y-117": 1.013,
    "y-118": 1.013,
    "y-119": 1.013,
    "y-120": 1.013,
    "y-121": 1.013,
    "y-122": 1.013,
    "y-123": 1.013,
    "y-124": 1.012,
    "y-125": 1.012,
    "y-126": 1.012,
    "y-127": 1.012,
    "y-128": 1.012,
    "y-129": 1.011,
    "y-130": 1.011,
    "y-131": 1.011,
    "y-132": 1.011,
    "y-133": 1.012,
    "y-134": 1.012,
    "y-135": 1.012,
    "y-136": 1.012,
    "y-137": 1.012,
    "y-138": 1.012,
    "y-139": 1.012,
    "y-140": 1.012,
    "y-141": 1.012,
    "y-142": 1.012,
    "y-143": 1.012,
    "y-144": 1.012,
    "y-145": 1.012,
    "y-146": 1.012,
    "y-147": 1.012,
    "y-148": 1.012,
    "y-149": 1.012,
    "y-150": 1.012,
    "y-151": 1.012,
    "y-152": 1.012,
    "y-153": 1.012,
    "y-154": 1.012,
    "y-155": 1.012,
    "y-156": 1.012,
    "y-157": 1.012,
    "y-158": 1.012,
    "y-159": 1.012,
    "y-160": 1.012,
    "y-161": 1.012,
    "y-162": 1.012,
    "y-163": 1.012,
    "y-164": 1.012,
    "y-165": 1.012,
    "y-166": 1.012,
    "y-167": 1.012,
    "y-168": 1.012,
    "y-169": 1.012,
    "y-170": 1.012,
    "y-171": 1.012,
    "y-172": 1.012,
    "y-173": 1.012,
    "y-174": 1.012,
    "y-175": 1.012,
    "y-176": 1.012,
    "y-177": 1.012,
    "y-178": 1.012,
    "y-179": 1.012,
    "y-180": 1.012,
    "y-181": 1.012,
    "y-182": 1.012,
    "y-183": 1.012,
    "y-184": 1.012,
    "y-185": 1.012,
    "y-186": 1.012,
    "y-187": 1.012,
    "y-188": 1.012,
    "y-189": 1.012,
    "y-190": 1.012,
    "y-191": 1.012,
    "y-192": 1.012,
    "y-193": 1.012,
    "y-194": 1.012,
    "y-195": 1.012,
    "y-196": 1.012,
    "y-197": 1.012,
    "y-198": 1.012,
    "y-199": 1.012,
    "y-200": 1.012,
    "y-201": 1.012,
    "y-202": 1.012,
    "y-203": 1.012,
    "y-204": 1.012,
    "y-205": 1.012,
    "y-206": 1.011,
    "y-207": 1.011,
    "y-208": 1.011,
    "y-209": 1.011,
    "y-210": 1.011,
    "y-211": 1.011,
    "y-212": 1.011,
    "y-213": 1.011,
    "y-214": 1.011,
    "y-215": 1.011,
    "y-216": 1.011,
    "y-217": 1.011,
    "y-218": 1.011,
    "y-219": 1.011,
    "y-220": 1.011,
    "y-221": 1.011,
    "y-222": 1.011,
    "y-223": 1.011,
    "y-224": 1.011,
    "y-225": 1.011,
    "y-226": 1.011,
    "y-227": 1.011,
    "y-228": 1.011,
    "y-229": 1.011,
    "y-230": 1.011,
    "y-231": 1.011,
    "y-232": 1.011,
    "y-233": 1.011,
    "y-234": 1.011,
    "y-235": 1.011,
    "y-236": 1.011,
    "y-237": 1.011,
    "y-238": 1.011,
    "y-239": 1.011,
    "y-240": 1.011,
    "y-241": 1.011,
    "y-242": 1.011,
    "y-243": 1.011,
    "y-244": 1.011,
    "y-245": 1.011,
    "y-246": 1.011,
    "y-247": 1.011,
    "y-248": 1.011,
    "y-249": 1.011,
    "y-250": 1.011,
    "y-251": 1.011,
    "y-252": 1.011,
    "y-253": 1.011,
    "y-254": 1.011,
    "y-255": 1.011,
  },
  {
    x: -0.325,
    "y-2": 0.118,
    "y-12": 0.939,
    "y-46": 0.954,
    "y-1000": 0.934,
    "y-0": 0.262,
    "y-1": 0.034,
    "y-3": 1.432,
    "y-4": 0.924,
    "y-5": 0.707,
    "y-6": 0.698,
    "y-7": 0.689,
    "y-8": 0.653,
    "y-9": 0.653,
    "y-10": 0.918,
    "y-11": 0.939,
    "y-13": 0.939,
    "y-14": 0.957,
    "y-15": 0.955,
    "y-16": 0.955,
    "y-17": 0.955,
    "y-18": 0.954,
    "y-19": 0.954,
    "y-20": 0.955,
    "y-21": 0.955,
    "y-22": 0.955,
    "y-23": 0.955,
    "y-24": 0.955,
    "y-25": 0.955,
    "y-26": 0.955,
    "y-27": 0.955,
    "y-28": 0.955,
    "y-29": 0.955,
    "y-30": 0.955,
    "y-31": 0.955,
    "y-32": 0.955,
    "y-33": 0.955,
    "y-34": 0.955,
    "y-35": 0.955,
    "y-36": 0.955,
    "y-37": 0.955,
    "y-38": 0.955,
    "y-39": 0.955,
    "y-40": 0.955,
    "y-41": 0.955,
    "y-42": 0.954,
    "y-43": 0.954,
    "y-44": 0.954,
    "y-45": 0.954,
    "y-47": 0.954,
    "y-48": 0.954,
    "y-49": 0.954,
    "y-50": 0.954,
    "y-51": 0.954,
    "y-52": 0.954,
    "y-53": 0.954,
    "y-54": 0.954,
    "y-55": 0.954,
    "y-56": 0.954,
    "y-57": 0.954,
    "y-58": 0.954,
    "y-59": 0.954,
    "y-60": 0.954,
    "y-61": 0.954,
    "y-62": 0.954,
    "y-63": 0.954,
    "y-64": 0.954,
    "y-65": 0.954,
    "y-66": 0.954,
    "y-67": 0.954,
    "y-68": 0.954,
    "y-69": 0.954,
    "y-70": 0.954,
    "y-71": 0.954,
    "y-72": 0.954,
    "y-73": 0.954,
    "y-74": 0.954,
    "y-75": 0.954,
    "y-76": 0.954,
    "y-77": 0.954,
    "y-78": 0.954,
    "y-79": 0.954,
    "y-80": 0.954,
    "y-81": 0.954,
    "y-82": 0.951,
    "y-83": 0.951,
    "y-84": 0.951,
    "y-85": 0.951,
    "y-86": 0.951,
    "y-87": 0.951,
    "y-88": 0.951,
    "y-89": 0.951,
    "y-90": 0.951,
    "y-91": 0.951,
    "y-92": 0.951,
    "y-93": 0.951,
    "y-94": 0.951,
    "y-95": 0.951,
    "y-96": 0.951,
    "y-97": 0.951,
    "y-98": 0.951,
    "y-99": 0.951,
    "y-100": 0.951,
    "y-101": 0.951,
    "y-102": 0.951,
    "y-103": 0.951,
    "y-104": 0.951,
    "y-105": 0.951,
    "y-106": 0.951,
    "y-107": 0.944,
    "y-108": 0.944,
    "y-109": 0.944,
    "y-110": 0.944,
    "y-111": 0.944,
    "y-112": 0.944,
    "y-113": 0.944,
    "y-114": 0.944,
    "y-115": 0.944,
    "y-116": 0.944,
    "y-117": 0.944,
    "y-118": 0.944,
    "y-119": 0.944,
    "y-120": 0.944,
    "y-121": 0.944,
    "y-122": 0.944,
    "y-123": 0.944,
    "y-124": 0.943,
    "y-125": 0.943,
    "y-126": 0.943,
    "y-127": 0.943,
    "y-128": 0.943,
    "y-129": 0.943,
    "y-130": 0.943,
    "y-131": 0.943,
    "y-132": 0.943,
    "y-133": 0.943,
    "y-134": 0.943,
    "y-135": 0.943,
    "y-136": 0.943,
    "y-137": 0.943,
    "y-138": 0.943,
    "y-139": 0.943,
    "y-140": 0.943,
    "y-141": 0.943,
    "y-142": 0.943,
    "y-143": 0.943,
    "y-144": 0.943,
    "y-145": 0.943,
    "y-146": 0.943,
    "y-147": 0.943,
    "y-148": 0.943,
    "y-149": 0.943,
    "y-150": 0.943,
    "y-151": 0.943,
    "y-152": 0.943,
    "y-153": 0.943,
    "y-154": 0.943,
    "y-155": 0.943,
    "y-156": 0.943,
    "y-157": 0.943,
    "y-158": 0.943,
    "y-159": 0.943,
    "y-160": 0.943,
    "y-161": 0.943,
    "y-162": 0.943,
    "y-163": 0.943,
    "y-164": 0.943,
    "y-165": 0.943,
    "y-166": 0.943,
    "y-167": 0.943,
    "y-168": 0.943,
    "y-169": 0.943,
    "y-170": 0.943,
    "y-171": 0.943,
    "y-172": 0.943,
    "y-173": 0.943,
    "y-174": 0.943,
    "y-175": 0.943,
    "y-176": 0.943,
    "y-177": 0.943,
    "y-178": 0.943,
    "y-179": 0.943,
    "y-180": 0.943,
    "y-181": 0.943,
    "y-182": 0.943,
    "y-183": 0.943,
    "y-184": 0.943,
    "y-185": 0.943,
    "y-186": 0.943,
    "y-187": 0.943,
    "y-188": 0.943,
    "y-189": 0.943,
    "y-190": 0.943,
    "y-191": 0.943,
    "y-192": 0.943,
    "y-193": 0.943,
    "y-194": 0.943,
    "y-195": 0.943,
    "y-196": 0.943,
    "y-197": 0.943,
    "y-198": 0.943,
    "y-199": 0.943,
    "y-200": 0.943,
    "y-201": 0.943,
    "y-202": 0.943,
    "y-203": 0.943,
    "y-204": 0.943,
    "y-205": 0.943,
    "y-206": 0.943,
    "y-207": 0.943,
    "y-208": 0.943,
    "y-209": 0.943,
    "y-210": 0.943,
    "y-211": 0.943,
    "y-212": 0.943,
    "y-213": 0.943,
    "y-214": 0.943,
    "y-215": 0.943,
    "y-216": 0.943,
    "y-217": 0.943,
    "y-218": 0.943,
    "y-219": 0.943,
    "y-220": 0.943,
    "y-221": 0.943,
    "y-222": 0.943,
    "y-223": 0.943,
    "y-224": 0.943,
    "y-225": 0.943,
    "y-226": 0.943,
    "y-227": 0.943,
    "y-228": 0.943,
    "y-229": 0.943,
    "y-230": 0.943,
    "y-231": 0.943,
    "y-232": 0.943,
    "y-233": 0.943,
    "y-234": 0.943,
    "y-235": 0.943,
    "y-236": 0.943,
    "y-237": 0.943,
    "y-238": 0.943,
    "y-239": 0.943,
    "y-240": 0.943,
    "y-241": 0.943,
    "y-242": 0.943,
    "y-243": 0.943,
    "y-244": 0.943,
    "y-245": 0.943,
    "y-246": 0.943,
    "y-247": 0.943,
    "y-248": 0.943,
    "y-249": 0.943,
    "y-250": 0.943,
    "y-251": 0.943,
    "y-252": 0.943,
    "y-253": 0.943,
    "y-254": 0.943,
    "y-255": 0.943,
  },
  {
    x: -0.3,
    "y-2": 0.097,
    "y-12": 0.867,
    "y-46": 0.88,
    "y-1000": 0.873,
    "y-0": 0.25,
    "y-1": 0.009,
    "y-3": 1.356,
    "y-4": 0.863,
    "y-5": 0.652,
    "y-6": 0.644,
    "y-7": 0.635,
    "y-8": 0.6,
    "y-9": 0.6,
    "y-10": 0.848,
    "y-11": 0.867,
    "y-13": 0.867,
    "y-14": 0.883,
    "y-15": 0.881,
    "y-16": 0.881,
    "y-17": 0.881,
    "y-18": 0.881,
    "y-19": 0.881,
    "y-20": 0.882,
    "y-21": 0.882,
    "y-22": 0.882,
    "y-23": 0.882,
    "y-24": 0.882,
    "y-25": 0.882,
    "y-26": 0.881,
    "y-27": 0.881,
    "y-28": 0.881,
    "y-29": 0.881,
    "y-30": 0.881,
    "y-31": 0.881,
    "y-32": 0.881,
    "y-33": 0.881,
    "y-34": 0.882,
    "y-35": 0.882,
    "y-36": 0.882,
    "y-37": 0.882,
    "y-38": 0.881,
    "y-39": 0.881,
    "y-40": 0.881,
    "y-41": 0.881,
    "y-42": 0.88,
    "y-43": 0.88,
    "y-44": 0.88,
    "y-45": 0.88,
    "y-47": 0.88,
    "y-48": 0.88,
    "y-49": 0.88,
    "y-50": 0.88,
    "y-51": 0.88,
    "y-52": 0.88,
    "y-53": 0.88,
    "y-54": 0.88,
    "y-55": 0.88,
    "y-56": 0.88,
    "y-57": 0.88,
    "y-58": 0.88,
    "y-59": 0.88,
    "y-60": 0.88,
    "y-61": 0.88,
    "y-62": 0.88,
    "y-63": 0.88,
    "y-64": 0.88,
    "y-65": 0.88,
    "y-66": 0.88,
    "y-67": 0.88,
    "y-68": 0.88,
    "y-69": 0.88,
    "y-70": 0.88,
    "y-71": 0.88,
    "y-72": 0.88,
    "y-73": 0.88,
    "y-74": 0.88,
    "y-75": 0.88,
    "y-76": 0.88,
    "y-77": 0.88,
    "y-78": 0.88,
    "y-79": 0.88,
    "y-80": 0.88,
    "y-81": 0.88,
    "y-82": 0.878,
    "y-83": 0.878,
    "y-84": 0.878,
    "y-85": 0.878,
    "y-86": 0.878,
    "y-87": 0.878,
    "y-88": 0.878,
    "y-89": 0.878,
    "y-90": 0.878,
    "y-91": 0.878,
    "y-92": 0.878,
    "y-93": 0.878,
    "y-94": 0.878,
    "y-95": 0.878,
    "y-96": 0.878,
    "y-97": 0.878,
    "y-98": 0.878,
    "y-99": 0.878,
    "y-100": 0.878,
    "y-101": 0.878,
    "y-102": 0.878,
    "y-103": 0.878,
    "y-104": 0.878,
    "y-105": 0.878,
    "y-106": 0.878,
    "y-107": 0.874,
    "y-108": 0.874,
    "y-109": 0.874,
    "y-110": 0.874,
    "y-111": 0.874,
    "y-112": 0.874,
    "y-113": 0.874,
    "y-114": 0.874,
    "y-115": 0.874,
    "y-116": 0.874,
    "y-117": 0.874,
    "y-118": 0.874,
    "y-119": 0.874,
    "y-120": 0.874,
    "y-121": 0.874,
    "y-122": 0.874,
    "y-123": 0.874,
    "y-124": 0.873,
    "y-125": 0.873,
    "y-126": 0.873,
    "y-127": 0.873,
    "y-128": 0.873,
    "y-129": 0.873,
    "y-130": 0.873,
    "y-131": 0.873,
    "y-132": 0.873,
    "y-133": 0.873,
    "y-134": 0.873,
    "y-135": 0.873,
    "y-136": 0.873,
    "y-137": 0.873,
    "y-138": 0.873,
    "y-139": 0.873,
    "y-140": 0.873,
    "y-141": 0.873,
    "y-142": 0.873,
    "y-143": 0.873,
    "y-144": 0.873,
    "y-145": 0.873,
    "y-146": 0.873,
    "y-147": 0.873,
    "y-148": 0.873,
    "y-149": 0.873,
    "y-150": 0.873,
    "y-151": 0.873,
    "y-152": 0.873,
    "y-153": 0.873,
    "y-154": 0.873,
    "y-155": 0.873,
    "y-156": 0.873,
    "y-157": 0.873,
    "y-158": 0.873,
    "y-159": 0.873,
    "y-160": 0.873,
    "y-161": 0.873,
    "y-162": 0.873,
    "y-163": 0.873,
    "y-164": 0.873,
    "y-165": 0.873,
    "y-166": 0.873,
    "y-167": 0.873,
    "y-168": 0.873,
    "y-169": 0.873,
    "y-170": 0.873,
    "y-171": 0.873,
    "y-172": 0.873,
    "y-173": 0.873,
    "y-174": 0.873,
    "y-175": 0.873,
    "y-176": 0.873,
    "y-177": 0.873,
    "y-178": 0.873,
    "y-179": 0.873,
    "y-180": 0.873,
    "y-181": 0.873,
    "y-182": 0.873,
    "y-183": 0.873,
    "y-184": 0.873,
    "y-185": 0.873,
    "y-186": 0.873,
    "y-187": 0.873,
    "y-188": 0.873,
    "y-189": 0.873,
    "y-190": 0.873,
    "y-191": 0.873,
    "y-192": 0.873,
    "y-193": 0.873,
    "y-194": 0.873,
    "y-195": 0.873,
    "y-196": 0.873,
    "y-197": 0.873,
    "y-198": 0.873,
    "y-199": 0.873,
    "y-200": 0.873,
    "y-201": 0.873,
    "y-202": 0.873,
    "y-203": 0.873,
    "y-204": 0.873,
    "y-205": 0.873,
    "y-206": 0.873,
    "y-207": 0.873,
    "y-208": 0.873,
    "y-209": 0.873,
    "y-210": 0.873,
    "y-211": 0.873,
    "y-212": 0.873,
    "y-213": 0.873,
    "y-214": 0.873,
    "y-215": 0.873,
    "y-216": 0.873,
    "y-217": 0.873,
    "y-218": 0.873,
    "y-219": 0.873,
    "y-220": 0.873,
    "y-221": 0.873,
    "y-222": 0.873,
    "y-223": 0.873,
    "y-224": 0.873,
    "y-225": 0.873,
    "y-226": 0.873,
    "y-227": 0.873,
    "y-228": 0.873,
    "y-229": 0.873,
    "y-230": 0.873,
    "y-231": 0.873,
    "y-232": 0.873,
    "y-233": 0.873,
    "y-234": 0.873,
    "y-235": 0.873,
    "y-236": 0.873,
    "y-237": 0.873,
    "y-238": 0.873,
    "y-239": 0.873,
    "y-240": 0.873,
    "y-241": 0.873,
    "y-242": 0.873,
    "y-243": 0.873,
    "y-244": 0.873,
    "y-245": 0.873,
    "y-246": 0.873,
    "y-247": 0.873,
    "y-248": 0.873,
    "y-249": 0.873,
    "y-250": 0.873,
    "y-251": 0.873,
    "y-252": 0.873,
    "y-253": 0.873,
    "y-254": 0.873,
    "y-255": 0.873,
  },
  {
    x: -0.275,
    "y-2": 0.075,
    "y-12": 0.795,
    "y-46": 0.807,
    "y-1000": 0.807,
    "y-0": 0.238,
    "y-1": -0.016,
    "y-3": 1.28,
    "y-4": 0.802,
    "y-5": 0.598,
    "y-6": 0.589,
    "y-7": 0.581,
    "y-8": 0.547,
    "y-9": 0.547,
    "y-10": 0.778,
    "y-11": 0.795,
    "y-13": 0.795,
    "y-14": 0.809,
    "y-15": 0.807,
    "y-16": 0.807,
    "y-17": 0.807,
    "y-18": 0.807,
    "y-19": 0.807,
    "y-20": 0.808,
    "y-21": 0.808,
    "y-22": 0.808,
    "y-23": 0.808,
    "y-24": 0.808,
    "y-25": 0.808,
    "y-26": 0.808,
    "y-27": 0.808,
    "y-28": 0.808,
    "y-29": 0.808,
    "y-30": 0.808,
    "y-31": 0.808,
    "y-32": 0.808,
    "y-33": 0.808,
    "y-34": 0.808,
    "y-35": 0.808,
    "y-36": 0.808,
    "y-37": 0.808,
    "y-38": 0.807,
    "y-39": 0.807,
    "y-40": 0.807,
    "y-41": 0.807,
    "y-42": 0.807,
    "y-43": 0.807,
    "y-44": 0.807,
    "y-45": 0.807,
    "y-47": 0.807,
    "y-48": 0.807,
    "y-49": 0.807,
    "y-50": 0.807,
    "y-51": 0.807,
    "y-52": 0.807,
    "y-53": 0.807,
    "y-54": 0.807,
    "y-55": 0.807,
    "y-56": 0.807,
    "y-57": 0.807,
    "y-58": 0.807,
    "y-59": 0.807,
    "y-60": 0.807,
    "y-61": 0.807,
    "y-62": 0.807,
    "y-63": 0.807,
    "y-64": 0.807,
    "y-65": 0.807,
    "y-66": 0.807,
    "y-67": 0.807,
    "y-68": 0.807,
    "y-69": 0.807,
    "y-70": 0.807,
    "y-71": 0.807,
    "y-72": 0.807,
    "y-73": 0.807,
    "y-74": 0.807,
    "y-75": 0.807,
    "y-76": 0.807,
    "y-77": 0.807,
    "y-78": 0.807,
    "y-79": 0.807,
    "y-80": 0.807,
    "y-81": 0.807,
    "y-82": 0.805,
    "y-83": 0.805,
    "y-84": 0.805,
    "y-85": 0.805,
    "y-86": 0.805,
    "y-87": 0.805,
    "y-88": 0.805,
    "y-89": 0.805,
    "y-90": 0.805,
    "y-91": 0.805,
    "y-92": 0.805,
    "y-93": 0.805,
    "y-94": 0.805,
    "y-95": 0.805,
    "y-96": 0.805,
    "y-97": 0.805,
    "y-98": 0.805,
    "y-99": 0.805,
    "y-100": 0.805,
    "y-101": 0.805,
    "y-102": 0.805,
    "y-103": 0.805,
    "y-104": 0.805,
    "y-105": 0.805,
    "y-106": 0.805,
    "y-107": 0.803,
    "y-108": 0.803,
    "y-109": 0.803,
    "y-110": 0.803,
    "y-111": 0.803,
    "y-112": 0.803,
    "y-113": 0.803,
    "y-114": 0.803,
    "y-115": 0.803,
    "y-116": 0.803,
    "y-117": 0.803,
    "y-118": 0.803,
    "y-119": 0.803,
    "y-120": 0.803,
    "y-121": 0.803,
    "y-122": 0.803,
    "y-123": 0.803,
    "y-124": 0.803,
    "y-125": 0.803,
    "y-126": 0.803,
    "y-127": 0.803,
    "y-128": 0.803,
    "y-129": 0.803,
    "y-130": 0.803,
    "y-131": 0.803,
    "y-132": 0.803,
    "y-133": 0.803,
    "y-134": 0.803,
    "y-135": 0.803,
    "y-136": 0.803,
    "y-137": 0.803,
    "y-138": 0.803,
    "y-139": 0.803,
    "y-140": 0.803,
    "y-141": 0.803,
    "y-142": 0.803,
    "y-143": 0.803,
    "y-144": 0.803,
    "y-145": 0.803,
    "y-146": 0.803,
    "y-147": 0.803,
    "y-148": 0.803,
    "y-149": 0.803,
    "y-150": 0.803,
    "y-151": 0.803,
    "y-152": 0.803,
    "y-153": 0.803,
    "y-154": 0.803,
    "y-155": 0.803,
    "y-156": 0.803,
    "y-157": 0.803,
    "y-158": 0.803,
    "y-159": 0.803,
    "y-160": 0.803,
    "y-161": 0.803,
    "y-162": 0.803,
    "y-163": 0.803,
    "y-164": 0.803,
    "y-165": 0.803,
    "y-166": 0.803,
    "y-167": 0.803,
    "y-168": 0.803,
    "y-169": 0.803,
    "y-170": 0.803,
    "y-171": 0.803,
    "y-172": 0.803,
    "y-173": 0.803,
    "y-174": 0.803,
    "y-175": 0.803,
    "y-176": 0.803,
    "y-177": 0.803,
    "y-178": 0.803,
    "y-179": 0.803,
    "y-180": 0.803,
    "y-181": 0.803,
    "y-182": 0.803,
    "y-183": 0.803,
    "y-184": 0.803,
    "y-185": 0.803,
    "y-186": 0.803,
    "y-187": 0.803,
    "y-188": 0.803,
    "y-189": 0.803,
    "y-190": 0.803,
    "y-191": 0.803,
    "y-192": 0.803,
    "y-193": 0.803,
    "y-194": 0.803,
    "y-195": 0.803,
    "y-196": 0.803,
    "y-197": 0.803,
    "y-198": 0.803,
    "y-199": 0.803,
    "y-200": 0.803,
    "y-201": 0.803,
    "y-202": 0.803,
    "y-203": 0.803,
    "y-204": 0.803,
    "y-205": 0.803,
    "y-206": 0.803,
    "y-207": 0.803,
    "y-208": 0.803,
    "y-209": 0.803,
    "y-210": 0.803,
    "y-211": 0.803,
    "y-212": 0.803,
    "y-213": 0.803,
    "y-214": 0.803,
    "y-215": 0.803,
    "y-216": 0.803,
    "y-217": 0.803,
    "y-218": 0.803,
    "y-219": 0.803,
    "y-220": 0.803,
    "y-221": 0.803,
    "y-222": 0.803,
    "y-223": 0.803,
    "y-224": 0.803,
    "y-225": 0.803,
    "y-226": 0.803,
    "y-227": 0.803,
    "y-228": 0.803,
    "y-229": 0.803,
    "y-230": 0.803,
    "y-231": 0.803,
    "y-232": 0.803,
    "y-233": 0.803,
    "y-234": 0.803,
    "y-235": 0.803,
    "y-236": 0.803,
    "y-237": 0.803,
    "y-238": 0.803,
    "y-239": 0.803,
    "y-240": 0.803,
    "y-241": 0.803,
    "y-242": 0.803,
    "y-243": 0.803,
    "y-244": 0.803,
    "y-245": 0.803,
    "y-246": 0.803,
    "y-247": 0.803,
    "y-248": 0.803,
    "y-249": 0.803,
    "y-250": 0.803,
    "y-251": 0.803,
    "y-252": 0.803,
    "y-253": 0.803,
    "y-254": 0.803,
    "y-255": 0.803,
  },
  {
    x: -0.25,
    "y-2": 0.054,
    "y-12": 0.724,
    "y-46": 0.733,
    "y-1000": 0.736,
    "y-0": 0.225,
    "y-1": -0.04,
    "y-3": 1.204,
    "y-4": 0.741,
    "y-5": 0.543,
    "y-6": 0.535,
    "y-7": 0.527,
    "y-8": 0.494,
    "y-9": 0.494,
    "y-10": 0.708,
    "y-11": 0.723,
    "y-13": 0.724,
    "y-14": 0.735,
    "y-15": 0.734,
    "y-16": 0.734,
    "y-17": 0.734,
    "y-18": 0.734,
    "y-19": 0.734,
    "y-20": 0.734,
    "y-21": 0.734,
    "y-22": 0.734,
    "y-23": 0.734,
    "y-24": 0.734,
    "y-25": 0.734,
    "y-26": 0.734,
    "y-27": 0.734,
    "y-28": 0.734,
    "y-29": 0.734,
    "y-30": 0.734,
    "y-31": 0.734,
    "y-32": 0.734,
    "y-33": 0.734,
    "y-34": 0.734,
    "y-35": 0.734,
    "y-36": 0.734,
    "y-37": 0.734,
    "y-38": 0.734,
    "y-39": 0.734,
    "y-40": 0.734,
    "y-41": 0.734,
    "y-42": 0.733,
    "y-43": 0.733,
    "y-44": 0.733,
    "y-45": 0.733,
    "y-47": 0.733,
    "y-48": 0.733,
    "y-49": 0.733,
    "y-50": 0.733,
    "y-51": 0.733,
    "y-52": 0.733,
    "y-53": 0.733,
    "y-54": 0.733,
    "y-55": 0.733,
    "y-56": 0.733,
    "y-57": 0.733,
    "y-58": 0.733,
    "y-59": 0.733,
    "y-60": 0.733,
    "y-61": 0.733,
    "y-62": 0.733,
    "y-63": 0.733,
    "y-64": 0.733,
    "y-65": 0.733,
    "y-66": 0.733,
    "y-67": 0.733,
    "y-68": 0.733,
    "y-69": 0.733,
    "y-70": 0.733,
    "y-71": 0.733,
    "y-72": 0.733,
    "y-73": 0.733,
    "y-74": 0.733,
    "y-75": 0.733,
    "y-76": 0.733,
    "y-77": 0.733,
    "y-78": 0.733,
    "y-79": 0.733,
    "y-80": 0.733,
    "y-81": 0.733,
    "y-82": 0.732,
    "y-83": 0.732,
    "y-84": 0.732,
    "y-85": 0.732,
    "y-86": 0.732,
    "y-87": 0.732,
    "y-88": 0.732,
    "y-89": 0.732,
    "y-90": 0.732,
    "y-91": 0.732,
    "y-92": 0.732,
    "y-93": 0.732,
    "y-94": 0.732,
    "y-95": 0.732,
    "y-96": 0.732,
    "y-97": 0.732,
    "y-98": 0.732,
    "y-99": 0.732,
    "y-100": 0.732,
    "y-101": 0.732,
    "y-102": 0.732,
    "y-103": 0.732,
    "y-104": 0.732,
    "y-105": 0.732,
    "y-106": 0.732,
    "y-107": 0.732,
    "y-108": 0.732,
    "y-109": 0.732,
    "y-110": 0.732,
    "y-111": 0.732,
    "y-112": 0.732,
    "y-113": 0.732,
    "y-114": 0.732,
    "y-115": 0.732,
    "y-116": 0.732,
    "y-117": 0.732,
    "y-118": 0.732,
    "y-119": 0.732,
    "y-120": 0.732,
    "y-121": 0.732,
    "y-122": 0.732,
    "y-123": 0.732,
    "y-124": 0.733,
    "y-125": 0.733,
    "y-126": 0.732,
    "y-127": 0.733,
    "y-128": 0.733,
    "y-129": 0.732,
    "y-130": 0.732,
    "y-131": 0.733,
    "y-132": 0.732,
    "y-133": 0.732,
    "y-134": 0.733,
    "y-135": 0.733,
    "y-136": 0.733,
    "y-137": 0.733,
    "y-138": 0.733,
    "y-139": 0.733,
    "y-140": 0.733,
    "y-141": 0.733,
    "y-142": 0.733,
    "y-143": 0.732,
    "y-144": 0.733,
    "y-145": 0.733,
    "y-146": 0.733,
    "y-147": 0.733,
    "y-148": 0.733,
    "y-149": 0.733,
    "y-150": 0.733,
    "y-151": 0.733,
    "y-152": 0.733,
    "y-153": 0.733,
    "y-154": 0.733,
    "y-155": 0.732,
    "y-156": 0.733,
    "y-157": 0.733,
    "y-158": 0.733,
    "y-159": 0.733,
    "y-160": 0.733,
    "y-161": 0.733,
    "y-162": 0.733,
    "y-163": 0.733,
    "y-164": 0.733,
    "y-165": 0.732,
    "y-166": 0.733,
    "y-167": 0.732,
    "y-168": 0.733,
    "y-169": 0.733,
    "y-170": 0.733,
    "y-171": 0.733,
    "y-172": 0.733,
    "y-173": 0.733,
    "y-174": 0.732,
    "y-175": 0.733,
    "y-176": 0.733,
    "y-177": 0.732,
    "y-178": 0.733,
    "y-179": 0.732,
    "y-180": 0.732,
    "y-181": 0.733,
    "y-182": 0.733,
    "y-183": 0.733,
    "y-184": 0.733,
    "y-185": 0.733,
    "y-186": 0.733,
    "y-187": 0.732,
    "y-188": 0.732,
    "y-189": 0.732,
    "y-190": 0.732,
    "y-191": 0.733,
    "y-192": 0.733,
    "y-193": 0.732,
    "y-194": 0.733,
    "y-195": 0.732,
    "y-196": 0.733,
    "y-197": 0.733,
    "y-198": 0.732,
    "y-199": 0.732,
    "y-200": 0.732,
    "y-201": 0.732,
    "y-202": 0.732,
    "y-203": 0.732,
    "y-204": 0.732,
    "y-205": 0.732,
    "y-206": 0.733,
    "y-207": 0.733,
    "y-208": 0.733,
    "y-209": 0.733,
    "y-210": 0.733,
    "y-211": 0.733,
    "y-212": 0.733,
    "y-213": 0.733,
    "y-214": 0.733,
    "y-215": 0.733,
    "y-216": 0.733,
    "y-217": 0.733,
    "y-218": 0.733,
    "y-219": 0.733,
    "y-220": 0.733,
    "y-221": 0.733,
    "y-222": 0.733,
    "y-223": 0.733,
    "y-224": 0.733,
    "y-225": 0.733,
    "y-226": 0.733,
    "y-227": 0.733,
    "y-228": 0.733,
    "y-229": 0.733,
    "y-230": 0.733,
    "y-231": 0.733,
    "y-232": 0.733,
    "y-233": 0.733,
    "y-234": 0.733,
    "y-235": 0.733,
    "y-236": 0.733,
    "y-237": 0.733,
    "y-238": 0.733,
    "y-239": 0.733,
    "y-240": 0.733,
    "y-241": 0.733,
    "y-242": 0.733,
    "y-243": 0.733,
    "y-244": 0.733,
    "y-245": 0.733,
    "y-246": 0.733,
    "y-247": 0.733,
    "y-248": 0.733,
    "y-249": 0.733,
    "y-250": 0.733,
    "y-251": 0.733,
    "y-252": 0.733,
    "y-253": 0.733,
    "y-254": 0.733,
    "y-255": 0.733,
  },
  {
    x: -0.225,
    "y-2": 0.033,
    "y-12": 0.652,
    "y-46": 0.66,
    "y-1000": 0.665,
    "y-0": 0.213,
    "y-1": -0.065,
    "y-3": 1.129,
    "y-4": 0.68,
    "y-5": 0.488,
    "y-6": 0.48,
    "y-7": 0.472,
    "y-8": 0.44,
    "y-9": 0.44,
    "y-10": 0.638,
    "y-11": 0.652,
    "y-13": 0.652,
    "y-14": 0.661,
    "y-15": 0.66,
    "y-16": 0.66,
    "y-17": 0.66,
    "y-18": 0.66,
    "y-19": 0.66,
    "y-20": 0.661,
    "y-21": 0.661,
    "y-22": 0.661,
    "y-23": 0.661,
    "y-24": 0.661,
    "y-25": 0.661,
    "y-26": 0.661,
    "y-27": 0.661,
    "y-28": 0.661,
    "y-29": 0.661,
    "y-30": 0.661,
    "y-31": 0.661,
    "y-32": 0.661,
    "y-33": 0.661,
    "y-34": 0.661,
    "y-35": 0.661,
    "y-36": 0.661,
    "y-37": 0.661,
    "y-38": 0.66,
    "y-39": 0.66,
    "y-40": 0.66,
    "y-41": 0.66,
    "y-42": 0.66,
    "y-43": 0.66,
    "y-44": 0.66,
    "y-45": 0.66,
    "y-47": 0.66,
    "y-48": 0.66,
    "y-49": 0.66,
    "y-50": 0.66,
    "y-51": 0.66,
    "y-52": 0.66,
    "y-53": 0.66,
    "y-54": 0.66,
    "y-55": 0.66,
    "y-56": 0.66,
    "y-57": 0.66,
    "y-58": 0.66,
    "y-59": 0.66,
    "y-60": 0.66,
    "y-61": 0.66,
    "y-62": 0.66,
    "y-63": 0.66,
    "y-64": 0.66,
    "y-65": 0.66,
    "y-66": 0.66,
    "y-67": 0.66,
    "y-68": 0.66,
    "y-69": 0.66,
    "y-70": 0.66,
    "y-71": 0.66,
    "y-72": 0.66,
    "y-73": 0.66,
    "y-74": 0.66,
    "y-75": 0.66,
    "y-76": 0.66,
    "y-77": 0.66,
    "y-78": 0.66,
    "y-79": 0.66,
    "y-80": 0.66,
    "y-81": 0.66,
    "y-82": 0.659,
    "y-83": 0.659,
    "y-84": 0.659,
    "y-85": 0.659,
    "y-86": 0.659,
    "y-87": 0.659,
    "y-88": 0.659,
    "y-89": 0.659,
    "y-90": 0.659,
    "y-91": 0.659,
    "y-92": 0.659,
    "y-93": 0.659,
    "y-94": 0.659,
    "y-95": 0.659,
    "y-96": 0.659,
    "y-97": 0.659,
    "y-98": 0.659,
    "y-99": 0.659,
    "y-100": 0.659,
    "y-101": 0.659,
    "y-102": 0.659,
    "y-103": 0.659,
    "y-104": 0.659,
    "y-105": 0.659,
    "y-106": 0.659,
    "y-107": 0.661,
    "y-108": 0.661,
    "y-109": 0.661,
    "y-110": 0.661,
    "y-111": 0.661,
    "y-112": 0.661,
    "y-113": 0.661,
    "y-114": 0.661,
    "y-115": 0.661,
    "y-116": 0.661,
    "y-117": 0.661,
    "y-118": 0.661,
    "y-119": 0.661,
    "y-120": 0.661,
    "y-121": 0.661,
    "y-122": 0.661,
    "y-123": 0.661,
    "y-124": 0.662,
    "y-125": 0.662,
    "y-126": 0.662,
    "y-127": 0.662,
    "y-128": 0.662,
    "y-129": 0.662,
    "y-130": 0.662,
    "y-131": 0.662,
    "y-132": 0.662,
    "y-133": 0.662,
    "y-134": 0.662,
    "y-135": 0.662,
    "y-136": 0.662,
    "y-137": 0.662,
    "y-138": 0.662,
    "y-139": 0.662,
    "y-140": 0.662,
    "y-141": 0.662,
    "y-142": 0.662,
    "y-143": 0.662,
    "y-144": 0.662,
    "y-145": 0.662,
    "y-146": 0.662,
    "y-147": 0.662,
    "y-148": 0.662,
    "y-149": 0.662,
    "y-150": 0.662,
    "y-151": 0.662,
    "y-152": 0.662,
    "y-153": 0.662,
    "y-154": 0.662,
    "y-155": 0.662,
    "y-156": 0.662,
    "y-157": 0.662,
    "y-158": 0.662,
    "y-159": 0.662,
    "y-160": 0.662,
    "y-161": 0.662,
    "y-162": 0.662,
    "y-163": 0.662,
    "y-164": 0.662,
    "y-165": 0.662,
    "y-166": 0.662,
    "y-167": 0.662,
    "y-168": 0.662,
    "y-169": 0.662,
    "y-170": 0.662,
    "y-171": 0.662,
    "y-172": 0.662,
    "y-173": 0.662,
    "y-174": 0.662,
    "y-175": 0.662,
    "y-176": 0.662,
    "y-177": 0.662,
    "y-178": 0.662,
    "y-179": 0.662,
    "y-180": 0.662,
    "y-181": 0.662,
    "y-182": 0.662,
    "y-183": 0.662,
    "y-184": 0.662,
    "y-185": 0.662,
    "y-186": 0.662,
    "y-187": 0.662,
    "y-188": 0.662,
    "y-189": 0.662,
    "y-190": 0.662,
    "y-191": 0.662,
    "y-192": 0.662,
    "y-193": 0.662,
    "y-194": 0.662,
    "y-195": 0.662,
    "y-196": 0.662,
    "y-197": 0.662,
    "y-198": 0.662,
    "y-199": 0.662,
    "y-200": 0.662,
    "y-201": 0.662,
    "y-202": 0.662,
    "y-203": 0.662,
    "y-204": 0.662,
    "y-205": 0.662,
    "y-206": 0.663,
    "y-207": 0.663,
    "y-208": 0.663,
    "y-209": 0.663,
    "y-210": 0.663,
    "y-211": 0.663,
    "y-212": 0.663,
    "y-213": 0.663,
    "y-214": 0.663,
    "y-215": 0.663,
    "y-216": 0.663,
    "y-217": 0.663,
    "y-218": 0.663,
    "y-219": 0.663,
    "y-220": 0.663,
    "y-221": 0.663,
    "y-222": 0.663,
    "y-223": 0.663,
    "y-224": 0.663,
    "y-225": 0.663,
    "y-226": 0.663,
    "y-227": 0.663,
    "y-228": 0.663,
    "y-229": 0.663,
    "y-230": 0.663,
    "y-231": 0.663,
    "y-232": 0.663,
    "y-233": 0.663,
    "y-234": 0.663,
    "y-235": 0.663,
    "y-236": 0.663,
    "y-237": 0.663,
    "y-238": 0.663,
    "y-239": 0.663,
    "y-240": 0.663,
    "y-241": 0.663,
    "y-242": 0.663,
    "y-243": 0.663,
    "y-244": 0.663,
    "y-245": 0.663,
    "y-246": 0.663,
    "y-247": 0.663,
    "y-248": 0.663,
    "y-249": 0.663,
    "y-250": 0.663,
    "y-251": 0.663,
    "y-252": 0.663,
    "y-253": 0.663,
    "y-254": 0.663,
    "y-255": 0.663,
  },
  {
    x: -0.2,
    "y-2": 0.012,
    "y-12": 0.58,
    "y-46": 0.587,
    "y-1000": 0.592,
    "y-0": 0.201,
    "y-1": -0.089,
    "y-3": 1.053,
    "y-4": 0.619,
    "y-5": 0.434,
    "y-6": 0.426,
    "y-7": 0.418,
    "y-8": 0.387,
    "y-9": 0.387,
    "y-10": 0.568,
    "y-11": 0.58,
    "y-13": 0.58,
    "y-14": 0.587,
    "y-15": 0.587,
    "y-16": 0.587,
    "y-17": 0.587,
    "y-18": 0.587,
    "y-19": 0.587,
    "y-20": 0.587,
    "y-21": 0.587,
    "y-22": 0.587,
    "y-23": 0.587,
    "y-24": 0.587,
    "y-25": 0.587,
    "y-26": 0.587,
    "y-27": 0.587,
    "y-28": 0.587,
    "y-29": 0.587,
    "y-30": 0.587,
    "y-31": 0.587,
    "y-32": 0.587,
    "y-33": 0.587,
    "y-34": 0.587,
    "y-35": 0.587,
    "y-36": 0.587,
    "y-37": 0.587,
    "y-38": 0.587,
    "y-39": 0.587,
    "y-40": 0.587,
    "y-41": 0.587,
    "y-42": 0.587,
    "y-43": 0.587,
    "y-44": 0.587,
    "y-45": 0.587,
    "y-47": 0.587,
    "y-48": 0.587,
    "y-49": 0.587,
    "y-50": 0.587,
    "y-51": 0.587,
    "y-52": 0.587,
    "y-53": 0.587,
    "y-54": 0.587,
    "y-55": 0.587,
    "y-56": 0.587,
    "y-57": 0.587,
    "y-58": 0.587,
    "y-59": 0.587,
    "y-60": 0.587,
    "y-61": 0.587,
    "y-62": 0.587,
    "y-63": 0.587,
    "y-64": 0.587,
    "y-65": 0.587,
    "y-66": 0.587,
    "y-67": 0.587,
    "y-68": 0.587,
    "y-69": 0.587,
    "y-70": 0.587,
    "y-71": 0.587,
    "y-72": 0.587,
    "y-73": 0.587,
    "y-74": 0.587,
    "y-75": 0.587,
    "y-76": 0.587,
    "y-77": 0.587,
    "y-78": 0.587,
    "y-79": 0.587,
    "y-80": 0.587,
    "y-81": 0.587,
    "y-82": 0.587,
    "y-83": 0.587,
    "y-84": 0.587,
    "y-85": 0.587,
    "y-86": 0.587,
    "y-87": 0.587,
    "y-88": 0.587,
    "y-89": 0.587,
    "y-90": 0.587,
    "y-91": 0.587,
    "y-92": 0.587,
    "y-93": 0.587,
    "y-94": 0.587,
    "y-95": 0.587,
    "y-96": 0.587,
    "y-97": 0.587,
    "y-98": 0.587,
    "y-99": 0.587,
    "y-100": 0.587,
    "y-101": 0.587,
    "y-102": 0.587,
    "y-103": 0.587,
    "y-104": 0.587,
    "y-105": 0.587,
    "y-106": 0.587,
    "y-107": 0.59,
    "y-108": 0.59,
    "y-109": 0.59,
    "y-110": 0.59,
    "y-111": 0.59,
    "y-112": 0.59,
    "y-113": 0.59,
    "y-114": 0.59,
    "y-115": 0.59,
    "y-116": 0.59,
    "y-117": 0.59,
    "y-118": 0.59,
    "y-119": 0.59,
    "y-120": 0.59,
    "y-121": 0.59,
    "y-122": 0.59,
    "y-123": 0.59,
    "y-124": 0.592,
    "y-125": 0.592,
    "y-126": 0.592,
    "y-127": 0.592,
    "y-128": 0.592,
    "y-129": 0.592,
    "y-130": 0.592,
    "y-131": 0.592,
    "y-132": 0.592,
    "y-133": 0.592,
    "y-134": 0.592,
    "y-135": 0.592,
    "y-136": 0.592,
    "y-137": 0.592,
    "y-138": 0.592,
    "y-139": 0.592,
    "y-140": 0.592,
    "y-141": 0.592,
    "y-142": 0.592,
    "y-143": 0.592,
    "y-144": 0.592,
    "y-145": 0.592,
    "y-146": 0.592,
    "y-147": 0.592,
    "y-148": 0.592,
    "y-149": 0.592,
    "y-150": 0.592,
    "y-151": 0.592,
    "y-152": 0.592,
    "y-153": 0.592,
    "y-154": 0.592,
    "y-155": 0.592,
    "y-156": 0.592,
    "y-157": 0.592,
    "y-158": 0.592,
    "y-159": 0.592,
    "y-160": 0.592,
    "y-161": 0.592,
    "y-162": 0.592,
    "y-163": 0.592,
    "y-164": 0.592,
    "y-165": 0.592,
    "y-166": 0.592,
    "y-167": 0.592,
    "y-168": 0.592,
    "y-169": 0.592,
    "y-170": 0.592,
    "y-171": 0.592,
    "y-172": 0.592,
    "y-173": 0.592,
    "y-174": 0.592,
    "y-175": 0.592,
    "y-176": 0.592,
    "y-177": 0.592,
    "y-178": 0.592,
    "y-179": 0.592,
    "y-180": 0.592,
    "y-181": 0.592,
    "y-182": 0.592,
    "y-183": 0.592,
    "y-184": 0.592,
    "y-185": 0.592,
    "y-186": 0.592,
    "y-187": 0.592,
    "y-188": 0.592,
    "y-189": 0.592,
    "y-190": 0.592,
    "y-191": 0.592,
    "y-192": 0.592,
    "y-193": 0.592,
    "y-194": 0.592,
    "y-195": 0.592,
    "y-196": 0.592,
    "y-197": 0.592,
    "y-198": 0.592,
    "y-199": 0.592,
    "y-200": 0.592,
    "y-201": 0.592,
    "y-202": 0.592,
    "y-203": 0.592,
    "y-204": 0.592,
    "y-205": 0.592,
    "y-206": 0.592,
    "y-207": 0.592,
    "y-208": 0.592,
    "y-209": 0.592,
    "y-210": 0.592,
    "y-211": 0.592,
    "y-212": 0.592,
    "y-213": 0.592,
    "y-214": 0.592,
    "y-215": 0.592,
    "y-216": 0.592,
    "y-217": 0.592,
    "y-218": 0.592,
    "y-219": 0.592,
    "y-220": 0.592,
    "y-221": 0.592,
    "y-222": 0.592,
    "y-223": 0.592,
    "y-224": 0.592,
    "y-225": 0.592,
    "y-226": 0.592,
    "y-227": 0.592,
    "y-228": 0.592,
    "y-229": 0.592,
    "y-230": 0.592,
    "y-231": 0.592,
    "y-232": 0.592,
    "y-233": 0.592,
    "y-234": 0.592,
    "y-235": 0.592,
    "y-236": 0.592,
    "y-237": 0.592,
    "y-238": 0.592,
    "y-239": 0.592,
    "y-240": 0.592,
    "y-241": 0.592,
    "y-242": 0.592,
    "y-243": 0.592,
    "y-244": 0.592,
    "y-245": 0.592,
    "y-246": 0.592,
    "y-247": 0.592,
    "y-248": 0.592,
    "y-249": 0.592,
    "y-250": 0.592,
    "y-251": 0.592,
    "y-252": 0.592,
    "y-253": 0.592,
    "y-254": 0.592,
    "y-255": 0.592,
  },
  {
    x: -0.175,
    "y-2": -0.01,
    "y-12": 0.508,
    "y-46": 0.513,
    "y-1000": 0.519,
    "y-0": 0.189,
    "y-1": -0.114,
    "y-3": 0.977,
    "y-4": 0.558,
    "y-5": 0.379,
    "y-6": 0.372,
    "y-7": 0.364,
    "y-8": 0.334,
    "y-9": 0.334,
    "y-10": 0.498,
    "y-11": 0.508,
    "y-13": 0.508,
    "y-14": 0.513,
    "y-15": 0.513,
    "y-16": 0.513,
    "y-17": 0.513,
    "y-18": 0.513,
    "y-19": 0.513,
    "y-20": 0.513,
    "y-21": 0.513,
    "y-22": 0.513,
    "y-23": 0.513,
    "y-24": 0.513,
    "y-25": 0.513,
    "y-26": 0.513,
    "y-27": 0.513,
    "y-28": 0.513,
    "y-29": 0.513,
    "y-30": 0.513,
    "y-31": 0.513,
    "y-32": 0.513,
    "y-33": 0.513,
    "y-34": 0.513,
    "y-35": 0.513,
    "y-36": 0.513,
    "y-37": 0.513,
    "y-38": 0.513,
    "y-39": 0.513,
    "y-40": 0.513,
    "y-41": 0.513,
    "y-42": 0.513,
    "y-43": 0.513,
    "y-44": 0.513,
    "y-45": 0.513,
    "y-47": 0.513,
    "y-48": 0.513,
    "y-49": 0.513,
    "y-50": 0.513,
    "y-51": 0.513,
    "y-52": 0.513,
    "y-53": 0.513,
    "y-54": 0.513,
    "y-55": 0.513,
    "y-56": 0.513,
    "y-57": 0.513,
    "y-58": 0.513,
    "y-59": 0.513,
    "y-60": 0.513,
    "y-61": 0.513,
    "y-62": 0.513,
    "y-63": 0.513,
    "y-64": 0.513,
    "y-65": 0.513,
    "y-66": 0.513,
    "y-67": 0.513,
    "y-68": 0.513,
    "y-69": 0.513,
    "y-70": 0.513,
    "y-71": 0.513,
    "y-72": 0.513,
    "y-73": 0.513,
    "y-74": 0.513,
    "y-75": 0.513,
    "y-76": 0.513,
    "y-77": 0.513,
    "y-78": 0.513,
    "y-79": 0.513,
    "y-80": 0.513,
    "y-81": 0.513,
    "y-82": 0.514,
    "y-83": 0.514,
    "y-84": 0.514,
    "y-85": 0.514,
    "y-86": 0.514,
    "y-87": 0.514,
    "y-88": 0.514,
    "y-89": 0.514,
    "y-90": 0.514,
    "y-91": 0.514,
    "y-92": 0.514,
    "y-93": 0.514,
    "y-94": 0.514,
    "y-95": 0.514,
    "y-96": 0.514,
    "y-97": 0.514,
    "y-98": 0.514,
    "y-99": 0.514,
    "y-100": 0.514,
    "y-101": 0.514,
    "y-102": 0.514,
    "y-103": 0.514,
    "y-104": 0.514,
    "y-105": 0.514,
    "y-106": 0.514,
    "y-107": 0.52,
    "y-108": 0.52,
    "y-109": 0.52,
    "y-110": 0.52,
    "y-111": 0.52,
    "y-112": 0.52,
    "y-113": 0.52,
    "y-114": 0.52,
    "y-115": 0.52,
    "y-116": 0.52,
    "y-117": 0.52,
    "y-118": 0.52,
    "y-119": 0.52,
    "y-120": 0.52,
    "y-121": 0.52,
    "y-122": 0.52,
    "y-123": 0.52,
    "y-124": 0.522,
    "y-125": 0.522,
    "y-126": 0.522,
    "y-127": 0.522,
    "y-128": 0.522,
    "y-129": 0.522,
    "y-130": 0.522,
    "y-131": 0.522,
    "y-132": 0.522,
    "y-133": 0.522,
    "y-134": 0.522,
    "y-135": 0.522,
    "y-136": 0.522,
    "y-137": 0.522,
    "y-138": 0.522,
    "y-139": 0.522,
    "y-140": 0.522,
    "y-141": 0.522,
    "y-142": 0.522,
    "y-143": 0.522,
    "y-144": 0.522,
    "y-145": 0.522,
    "y-146": 0.522,
    "y-147": 0.522,
    "y-148": 0.522,
    "y-149": 0.522,
    "y-150": 0.522,
    "y-151": 0.522,
    "y-152": 0.522,
    "y-153": 0.522,
    "y-154": 0.522,
    "y-155": 0.522,
    "y-156": 0.522,
    "y-157": 0.522,
    "y-158": 0.522,
    "y-159": 0.522,
    "y-160": 0.522,
    "y-161": 0.522,
    "y-162": 0.522,
    "y-163": 0.522,
    "y-164": 0.522,
    "y-165": 0.522,
    "y-166": 0.522,
    "y-167": 0.522,
    "y-168": 0.522,
    "y-169": 0.522,
    "y-170": 0.522,
    "y-171": 0.522,
    "y-172": 0.522,
    "y-173": 0.522,
    "y-174": 0.522,
    "y-175": 0.522,
    "y-176": 0.522,
    "y-177": 0.522,
    "y-178": 0.522,
    "y-179": 0.522,
    "y-180": 0.522,
    "y-181": 0.522,
    "y-182": 0.522,
    "y-183": 0.522,
    "y-184": 0.522,
    "y-185": 0.522,
    "y-186": 0.522,
    "y-187": 0.522,
    "y-188": 0.522,
    "y-189": 0.522,
    "y-190": 0.522,
    "y-191": 0.522,
    "y-192": 0.522,
    "y-193": 0.522,
    "y-194": 0.522,
    "y-195": 0.522,
    "y-196": 0.522,
    "y-197": 0.522,
    "y-198": 0.522,
    "y-199": 0.522,
    "y-200": 0.522,
    "y-201": 0.522,
    "y-202": 0.522,
    "y-203": 0.522,
    "y-204": 0.522,
    "y-205": 0.522,
    "y-206": 0.52,
    "y-207": 0.52,
    "y-208": 0.52,
    "y-209": 0.52,
    "y-210": 0.52,
    "y-211": 0.52,
    "y-212": 0.52,
    "y-213": 0.52,
    "y-214": 0.52,
    "y-215": 0.52,
    "y-216": 0.52,
    "y-217": 0.519,
    "y-218": 0.519,
    "y-219": 0.519,
    "y-220": 0.519,
    "y-221": 0.519,
    "y-222": 0.519,
    "y-223": 0.519,
    "y-224": 0.519,
    "y-225": 0.519,
    "y-226": 0.519,
    "y-227": 0.519,
    "y-228": 0.519,
    "y-229": 0.519,
    "y-230": 0.519,
    "y-231": 0.519,
    "y-232": 0.519,
    "y-233": 0.519,
    "y-234": 0.519,
    "y-235": 0.519,
    "y-236": 0.519,
    "y-237": 0.519,
    "y-238": 0.519,
    "y-239": 0.519,
    "y-240": 0.519,
    "y-241": 0.519,
    "y-242": 0.519,
    "y-243": 0.519,
    "y-244": 0.519,
    "y-245": 0.519,
    "y-246": 0.519,
    "y-247": 0.519,
    "y-248": 0.519,
    "y-249": 0.519,
    "y-250": 0.519,
    "y-251": 0.519,
    "y-252": 0.519,
    "y-253": 0.519,
    "y-254": 0.519,
    "y-255": 0.519,
  },
  {
    x: -0.15,
    "y-2": -0.031,
    "y-12": 0.437,
    "y-46": 0.44,
    "y-1000": 0.446,
    "y-0": 0.177,
    "y-1": -0.138,
    "y-3": 0.901,
    "y-4": 0.497,
    "y-5": 0.324,
    "y-6": 0.317,
    "y-7": 0.31,
    "y-8": 0.281,
    "y-9": 0.281,
    "y-10": 0.428,
    "y-11": 0.436,
    "y-13": 0.437,
    "y-14": 0.44,
    "y-15": 0.44,
    "y-16": 0.44,
    "y-17": 0.44,
    "y-18": 0.44,
    "y-19": 0.44,
    "y-20": 0.44,
    "y-21": 0.44,
    "y-22": 0.44,
    "y-23": 0.44,
    "y-24": 0.44,
    "y-25": 0.44,
    "y-26": 0.44,
    "y-27": 0.44,
    "y-28": 0.44,
    "y-29": 0.44,
    "y-30": 0.44,
    "y-31": 0.44,
    "y-32": 0.44,
    "y-33": 0.44,
    "y-34": 0.44,
    "y-35": 0.44,
    "y-36": 0.44,
    "y-37": 0.44,
    "y-38": 0.44,
    "y-39": 0.44,
    "y-40": 0.44,
    "y-41": 0.44,
    "y-42": 0.44,
    "y-43": 0.44,
    "y-44": 0.44,
    "y-45": 0.44,
    "y-47": 0.44,
    "y-48": 0.44,
    "y-49": 0.44,
    "y-50": 0.44,
    "y-51": 0.44,
    "y-52": 0.44,
    "y-53": 0.44,
    "y-54": 0.44,
    "y-55": 0.44,
    "y-56": 0.44,
    "y-57": 0.44,
    "y-58": 0.44,
    "y-59": 0.44,
    "y-60": 0.44,
    "y-61": 0.44,
    "y-62": 0.44,
    "y-63": 0.44,
    "y-64": 0.44,
    "y-65": 0.44,
    "y-66": 0.44,
    "y-67": 0.44,
    "y-68": 0.44,
    "y-69": 0.44,
    "y-70": 0.44,
    "y-71": 0.44,
    "y-72": 0.44,
    "y-73": 0.44,
    "y-74": 0.44,
    "y-75": 0.44,
    "y-76": 0.44,
    "y-77": 0.44,
    "y-78": 0.44,
    "y-79": 0.44,
    "y-80": 0.44,
    "y-81": 0.44,
    "y-82": 0.441,
    "y-83": 0.441,
    "y-84": 0.441,
    "y-85": 0.441,
    "y-86": 0.441,
    "y-87": 0.441,
    "y-88": 0.441,
    "y-89": 0.441,
    "y-90": 0.441,
    "y-91": 0.441,
    "y-92": 0.441,
    "y-93": 0.441,
    "y-94": 0.441,
    "y-95": 0.441,
    "y-96": 0.441,
    "y-97": 0.441,
    "y-98": 0.441,
    "y-99": 0.441,
    "y-100": 0.441,
    "y-101": 0.441,
    "y-102": 0.441,
    "y-103": 0.441,
    "y-104": 0.441,
    "y-105": 0.441,
    "y-106": 0.441,
    "y-107": 0.449,
    "y-108": 0.449,
    "y-109": 0.449,
    "y-110": 0.449,
    "y-111": 0.449,
    "y-112": 0.449,
    "y-113": 0.449,
    "y-114": 0.449,
    "y-115": 0.449,
    "y-116": 0.449,
    "y-117": 0.449,
    "y-118": 0.449,
    "y-119": 0.449,
    "y-120": 0.449,
    "y-121": 0.449,
    "y-122": 0.449,
    "y-123": 0.449,
    "y-124": 0.45,
    "y-125": 0.45,
    "y-126": 0.45,
    "y-127": 0.45,
    "y-128": 0.45,
    "y-129": 0.45,
    "y-130": 0.45,
    "y-131": 0.45,
    "y-132": 0.45,
    "y-133": 0.45,
    "y-134": 0.45,
    "y-135": 0.45,
    "y-136": 0.45,
    "y-137": 0.45,
    "y-138": 0.45,
    "y-139": 0.45,
    "y-140": 0.45,
    "y-141": 0.45,
    "y-142": 0.45,
    "y-143": 0.45,
    "y-144": 0.45,
    "y-145": 0.45,
    "y-146": 0.45,
    "y-147": 0.45,
    "y-148": 0.45,
    "y-149": 0.45,
    "y-150": 0.45,
    "y-151": 0.45,
    "y-152": 0.45,
    "y-153": 0.45,
    "y-154": 0.45,
    "y-155": 0.45,
    "y-156": 0.45,
    "y-157": 0.45,
    "y-158": 0.45,
    "y-159": 0.45,
    "y-160": 0.45,
    "y-161": 0.45,
    "y-162": 0.45,
    "y-163": 0.45,
    "y-164": 0.45,
    "y-165": 0.45,
    "y-166": 0.45,
    "y-167": 0.45,
    "y-168": 0.45,
    "y-169": 0.45,
    "y-170": 0.45,
    "y-171": 0.45,
    "y-172": 0.45,
    "y-173": 0.45,
    "y-174": 0.45,
    "y-175": 0.45,
    "y-176": 0.45,
    "y-177": 0.45,
    "y-178": 0.45,
    "y-179": 0.45,
    "y-180": 0.45,
    "y-181": 0.45,
    "y-182": 0.45,
    "y-183": 0.45,
    "y-184": 0.45,
    "y-185": 0.45,
    "y-186": 0.45,
    "y-187": 0.45,
    "y-188": 0.45,
    "y-189": 0.45,
    "y-190": 0.45,
    "y-191": 0.449,
    "y-192": 0.449,
    "y-193": 0.449,
    "y-194": 0.449,
    "y-195": 0.449,
    "y-196": 0.449,
    "y-197": 0.449,
    "y-198": 0.449,
    "y-199": 0.449,
    "y-200": 0.449,
    "y-201": 0.449,
    "y-202": 0.449,
    "y-203": 0.449,
    "y-204": 0.449,
    "y-205": 0.449,
    "y-206": 0.447,
    "y-207": 0.447,
    "y-208": 0.447,
    "y-209": 0.447,
    "y-210": 0.447,
    "y-211": 0.447,
    "y-212": 0.447,
    "y-213": 0.447,
    "y-214": 0.447,
    "y-215": 0.447,
    "y-216": 0.447,
    "y-217": 0.447,
    "y-218": 0.447,
    "y-219": 0.447,
    "y-220": 0.447,
    "y-221": 0.447,
    "y-222": 0.447,
    "y-223": 0.447,
    "y-224": 0.447,
    "y-225": 0.447,
    "y-226": 0.447,
    "y-227": 0.447,
    "y-228": 0.447,
    "y-229": 0.447,
    "y-230": 0.447,
    "y-231": 0.447,
    "y-232": 0.447,
    "y-233": 0.447,
    "y-234": 0.447,
    "y-235": 0.447,
    "y-236": 0.447,
    "y-237": 0.447,
    "y-238": 0.447,
    "y-239": 0.447,
    "y-240": 0.447,
    "y-241": 0.447,
    "y-242": 0.447,
    "y-243": 0.447,
    "y-244": 0.447,
    "y-245": 0.447,
    "y-246": 0.447,
    "y-247": 0.447,
    "y-248": 0.447,
    "y-249": 0.447,
    "y-250": 0.447,
    "y-251": 0.447,
    "y-252": 0.447,
    "y-253": 0.447,
    "y-254": 0.447,
    "y-255": 0.447,
  },
  {
    x: -0.125,
    "y-2": -0.052,
    "y-12": 0.365,
    "y-46": 0.366,
    "y-1000": 0.373,
    "y-0": 0.164,
    "y-1": -0.163,
    "y-3": 0.826,
    "y-4": 0.437,
    "y-5": 0.27,
    "y-6": 0.263,
    "y-7": 0.256,
    "y-8": 0.228,
    "y-9": 0.228,
    "y-10": 0.358,
    "y-11": 0.365,
    "y-13": 0.365,
    "y-14": 0.366,
    "y-15": 0.366,
    "y-16": 0.366,
    "y-17": 0.366,
    "y-18": 0.366,
    "y-19": 0.366,
    "y-20": 0.366,
    "y-21": 0.366,
    "y-22": 0.366,
    "y-23": 0.366,
    "y-24": 0.366,
    "y-25": 0.366,
    "y-26": 0.366,
    "y-27": 0.366,
    "y-28": 0.366,
    "y-29": 0.366,
    "y-30": 0.366,
    "y-31": 0.366,
    "y-32": 0.366,
    "y-33": 0.366,
    "y-34": 0.366,
    "y-35": 0.366,
    "y-36": 0.366,
    "y-37": 0.366,
    "y-38": 0.366,
    "y-39": 0.366,
    "y-40": 0.366,
    "y-41": 0.366,
    "y-42": 0.366,
    "y-43": 0.366,
    "y-44": 0.366,
    "y-45": 0.366,
    "y-47": 0.366,
    "y-48": 0.366,
    "y-49": 0.366,
    "y-50": 0.366,
    "y-51": 0.366,
    "y-52": 0.366,
    "y-53": 0.366,
    "y-54": 0.366,
    "y-55": 0.366,
    "y-56": 0.366,
    "y-57": 0.366,
    "y-58": 0.366,
    "y-59": 0.366,
    "y-60": 0.366,
    "y-61": 0.366,
    "y-62": 0.366,
    "y-63": 0.366,
    "y-64": 0.366,
    "y-65": 0.366,
    "y-66": 0.366,
    "y-67": 0.366,
    "y-68": 0.366,
    "y-69": 0.366,
    "y-70": 0.366,
    "y-71": 0.366,
    "y-72": 0.366,
    "y-73": 0.366,
    "y-74": 0.366,
    "y-75": 0.366,
    "y-76": 0.366,
    "y-77": 0.366,
    "y-78": 0.366,
    "y-79": 0.366,
    "y-80": 0.366,
    "y-81": 0.366,
    "y-82": 0.368,
    "y-83": 0.368,
    "y-84": 0.368,
    "y-85": 0.368,
    "y-86": 0.368,
    "y-87": 0.368,
    "y-88": 0.368,
    "y-89": 0.368,
    "y-90": 0.368,
    "y-91": 0.368,
    "y-92": 0.368,
    "y-93": 0.368,
    "y-94": 0.368,
    "y-95": 0.368,
    "y-96": 0.368,
    "y-97": 0.368,
    "y-98": 0.368,
    "y-99": 0.368,
    "y-100": 0.368,
    "y-101": 0.368,
    "y-102": 0.368,
    "y-103": 0.368,
    "y-104": 0.368,
    "y-105": 0.368,
    "y-106": 0.368,
    "y-107": 0.376,
    "y-108": 0.376,
    "y-109": 0.376,
    "y-110": 0.376,
    "y-111": 0.376,
    "y-112": 0.376,
    "y-113": 0.376,
    "y-114": 0.376,
    "y-115": 0.376,
    "y-116": 0.376,
    "y-117": 0.376,
    "y-118": 0.376,
    "y-119": 0.376,
    "y-120": 0.376,
    "y-121": 0.376,
    "y-122": 0.376,
    "y-123": 0.376,
    "y-124": 0.374,
    "y-125": 0.374,
    "y-126": 0.374,
    "y-127": 0.374,
    "y-128": 0.374,
    "y-129": 0.374,
    "y-130": 0.374,
    "y-131": 0.374,
    "y-132": 0.374,
    "y-133": 0.374,
    "y-134": 0.374,
    "y-135": 0.374,
    "y-136": 0.374,
    "y-137": 0.374,
    "y-138": 0.374,
    "y-139": 0.374,
    "y-140": 0.374,
    "y-141": 0.374,
    "y-142": 0.374,
    "y-143": 0.374,
    "y-144": 0.374,
    "y-145": 0.374,
    "y-146": 0.374,
    "y-147": 0.374,
    "y-148": 0.374,
    "y-149": 0.374,
    "y-150": 0.374,
    "y-151": 0.374,
    "y-152": 0.374,
    "y-153": 0.374,
    "y-154": 0.374,
    "y-155": 0.374,
    "y-156": 0.374,
    "y-157": 0.374,
    "y-158": 0.374,
    "y-159": 0.374,
    "y-160": 0.374,
    "y-161": 0.374,
    "y-162": 0.374,
    "y-163": 0.374,
    "y-164": 0.374,
    "y-165": 0.374,
    "y-166": 0.374,
    "y-167": 0.374,
    "y-168": 0.374,
    "y-169": 0.374,
    "y-170": 0.374,
    "y-171": 0.374,
    "y-172": 0.374,
    "y-173": 0.374,
    "y-174": 0.374,
    "y-175": 0.374,
    "y-176": 0.374,
    "y-177": 0.374,
    "y-178": 0.374,
    "y-179": 0.374,
    "y-180": 0.374,
    "y-181": 0.374,
    "y-182": 0.374,
    "y-183": 0.374,
    "y-184": 0.374,
    "y-185": 0.374,
    "y-186": 0.374,
    "y-187": 0.374,
    "y-188": 0.374,
    "y-189": 0.374,
    "y-190": 0.374,
    "y-191": 0.374,
    "y-192": 0.374,
    "y-193": 0.374,
    "y-194": 0.374,
    "y-195": 0.374,
    "y-196": 0.374,
    "y-197": 0.374,
    "y-198": 0.374,
    "y-199": 0.374,
    "y-200": 0.374,
    "y-201": 0.374,
    "y-202": 0.374,
    "y-203": 0.374,
    "y-204": 0.374,
    "y-205": 0.374,
    "y-206": 0.374,
    "y-207": 0.374,
    "y-208": 0.374,
    "y-209": 0.374,
    "y-210": 0.374,
    "y-211": 0.374,
    "y-212": 0.374,
    "y-213": 0.374,
    "y-214": 0.374,
    "y-215": 0.374,
    "y-216": 0.374,
    "y-217": 0.374,
    "y-218": 0.374,
    "y-219": 0.374,
    "y-220": 0.374,
    "y-221": 0.374,
    "y-222": 0.374,
    "y-223": 0.374,
    "y-224": 0.374,
    "y-225": 0.374,
    "y-226": 0.374,
    "y-227": 0.374,
    "y-228": 0.374,
    "y-229": 0.374,
    "y-230": 0.374,
    "y-231": 0.374,
    "y-232": 0.374,
    "y-233": 0.374,
    "y-234": 0.374,
    "y-235": 0.374,
    "y-236": 0.374,
    "y-237": 0.374,
    "y-238": 0.374,
    "y-239": 0.374,
    "y-240": 0.374,
    "y-241": 0.374,
    "y-242": 0.374,
    "y-243": 0.374,
    "y-244": 0.374,
    "y-245": 0.374,
    "y-246": 0.374,
    "y-247": 0.374,
    "y-248": 0.374,
    "y-249": 0.374,
    "y-250": 0.374,
    "y-251": 0.374,
    "y-252": 0.374,
    "y-253": 0.374,
    "y-254": 0.374,
    "y-255": 0.374,
  },
  {
    x: -0.1,
    "y-2": -0.074,
    "y-12": 0.293,
    "y-46": 0.293,
    "y-1000": 0.299,
    "y-0": 0.152,
    "y-1": -0.188,
    "y-3": 0.75,
    "y-4": 0.376,
    "y-5": 0.215,
    "y-6": 0.208,
    "y-7": 0.202,
    "y-8": 0.174,
    "y-9": 0.174,
    "y-10": 0.288,
    "y-11": 0.293,
    "y-13": 0.293,
    "y-14": 0.292,
    "y-15": 0.293,
    "y-16": 0.293,
    "y-17": 0.293,
    "y-18": 0.293,
    "y-19": 0.293,
    "y-20": 0.292,
    "y-21": 0.292,
    "y-22": 0.292,
    "y-23": 0.292,
    "y-24": 0.292,
    "y-25": 0.292,
    "y-26": 0.292,
    "y-27": 0.292,
    "y-28": 0.292,
    "y-29": 0.292,
    "y-30": 0.292,
    "y-31": 0.292,
    "y-32": 0.292,
    "y-33": 0.292,
    "y-34": 0.292,
    "y-35": 0.292,
    "y-36": 0.292,
    "y-37": 0.292,
    "y-38": 0.293,
    "y-39": 0.293,
    "y-40": 0.293,
    "y-41": 0.293,
    "y-42": 0.293,
    "y-43": 0.293,
    "y-44": 0.293,
    "y-45": 0.293,
    "y-47": 0.293,
    "y-48": 0.293,
    "y-49": 0.293,
    "y-50": 0.293,
    "y-51": 0.293,
    "y-52": 0.293,
    "y-53": 0.293,
    "y-54": 0.293,
    "y-55": 0.293,
    "y-56": 0.293,
    "y-57": 0.293,
    "y-58": 0.293,
    "y-59": 0.293,
    "y-60": 0.293,
    "y-61": 0.293,
    "y-62": 0.293,
    "y-63": 0.293,
    "y-64": 0.293,
    "y-65": 0.293,
    "y-66": 0.293,
    "y-67": 0.293,
    "y-68": 0.293,
    "y-69": 0.293,
    "y-70": 0.293,
    "y-71": 0.293,
    "y-72": 0.293,
    "y-73": 0.293,
    "y-74": 0.293,
    "y-75": 0.293,
    "y-76": 0.293,
    "y-77": 0.293,
    "y-78": 0.293,
    "y-79": 0.293,
    "y-80": 0.293,
    "y-81": 0.293,
    "y-82": 0.295,
    "y-83": 0.295,
    "y-84": 0.295,
    "y-85": 0.295,
    "y-86": 0.295,
    "y-87": 0.295,
    "y-88": 0.295,
    "y-89": 0.295,
    "y-90": 0.295,
    "y-91": 0.295,
    "y-92": 0.295,
    "y-93": 0.295,
    "y-94": 0.295,
    "y-95": 0.295,
    "y-96": 0.295,
    "y-97": 0.295,
    "y-98": 0.295,
    "y-99": 0.295,
    "y-100": 0.295,
    "y-101": 0.295,
    "y-102": 0.295,
    "y-103": 0.295,
    "y-104": 0.295,
    "y-105": 0.295,
    "y-106": 0.295,
    "y-107": 0.3,
    "y-108": 0.3,
    "y-109": 0.3,
    "y-110": 0.3,
    "y-111": 0.3,
    "y-112": 0.3,
    "y-113": 0.3,
    "y-114": 0.3,
    "y-115": 0.3,
    "y-116": 0.3,
    "y-117": 0.3,
    "y-118": 0.3,
    "y-119": 0.3,
    "y-120": 0.3,
    "y-121": 0.3,
    "y-122": 0.3,
    "y-123": 0.3,
    "y-124": 0.299,
    "y-125": 0.299,
    "y-126": 0.299,
    "y-127": 0.299,
    "y-128": 0.299,
    "y-129": 0.299,
    "y-130": 0.299,
    "y-131": 0.299,
    "y-132": 0.299,
    "y-133": 0.299,
    "y-134": 0.299,
    "y-135": 0.299,
    "y-136": 0.299,
    "y-137": 0.299,
    "y-138": 0.299,
    "y-139": 0.299,
    "y-140": 0.299,
    "y-141": 0.299,
    "y-142": 0.299,
    "y-143": 0.299,
    "y-144": 0.299,
    "y-145": 0.299,
    "y-146": 0.299,
    "y-147": 0.299,
    "y-148": 0.299,
    "y-149": 0.299,
    "y-150": 0.299,
    "y-151": 0.299,
    "y-152": 0.299,
    "y-153": 0.299,
    "y-154": 0.299,
    "y-155": 0.299,
    "y-156": 0.299,
    "y-157": 0.299,
    "y-158": 0.299,
    "y-159": 0.299,
    "y-160": 0.299,
    "y-161": 0.299,
    "y-162": 0.299,
    "y-163": 0.299,
    "y-164": 0.299,
    "y-165": 0.299,
    "y-166": 0.299,
    "y-167": 0.299,
    "y-168": 0.299,
    "y-169": 0.299,
    "y-170": 0.299,
    "y-171": 0.299,
    "y-172": 0.299,
    "y-173": 0.299,
    "y-174": 0.299,
    "y-175": 0.299,
    "y-176": 0.299,
    "y-177": 0.299,
    "y-178": 0.299,
    "y-179": 0.299,
    "y-180": 0.299,
    "y-181": 0.299,
    "y-182": 0.299,
    "y-183": 0.299,
    "y-184": 0.299,
    "y-185": 0.299,
    "y-186": 0.299,
    "y-187": 0.299,
    "y-188": 0.299,
    "y-189": 0.299,
    "y-190": 0.299,
    "y-191": 0.299,
    "y-192": 0.299,
    "y-193": 0.299,
    "y-194": 0.299,
    "y-195": 0.299,
    "y-196": 0.299,
    "y-197": 0.299,
    "y-198": 0.299,
    "y-199": 0.299,
    "y-200": 0.299,
    "y-201": 0.299,
    "y-202": 0.299,
    "y-203": 0.299,
    "y-204": 0.299,
    "y-205": 0.299,
    "y-206": 0.299,
    "y-207": 0.299,
    "y-208": 0.299,
    "y-209": 0.299,
    "y-210": 0.299,
    "y-211": 0.299,
    "y-212": 0.299,
    "y-213": 0.299,
    "y-214": 0.299,
    "y-215": 0.299,
    "y-216": 0.299,
    "y-217": 0.299,
    "y-218": 0.299,
    "y-219": 0.299,
    "y-220": 0.299,
    "y-221": 0.299,
    "y-222": 0.299,
    "y-223": 0.299,
    "y-224": 0.299,
    "y-225": 0.299,
    "y-226": 0.299,
    "y-227": 0.299,
    "y-228": 0.299,
    "y-229": 0.299,
    "y-230": 0.299,
    "y-231": 0.299,
    "y-232": 0.299,
    "y-233": 0.299,
    "y-234": 0.299,
    "y-235": 0.299,
    "y-236": 0.299,
    "y-237": 0.299,
    "y-238": 0.299,
    "y-239": 0.299,
    "y-240": 0.299,
    "y-241": 0.299,
    "y-242": 0.299,
    "y-243": 0.299,
    "y-244": 0.299,
    "y-245": 0.299,
    "y-246": 0.299,
    "y-247": 0.299,
    "y-248": 0.299,
    "y-249": 0.299,
    "y-250": 0.299,
    "y-251": 0.299,
    "y-252": 0.299,
    "y-253": 0.299,
    "y-254": 0.299,
    "y-255": 0.299,
  },
  {
    x: -0.075,
    "y-2": -0.095,
    "y-12": 0.221,
    "y-46": 0.22,
    "y-1000": 0.225,
    "y-0": 0.14,
    "y-1": -0.212,
    "y-3": 0.674,
    "y-4": 0.315,
    "y-5": 0.16,
    "y-6": 0.154,
    "y-7": 0.147,
    "y-8": 0.121,
    "y-9": 0.121,
    "y-10": 0.218,
    "y-11": 0.221,
    "y-13": 0.221,
    "y-14": 0.218,
    "y-15": 0.219,
    "y-16": 0.219,
    "y-17": 0.219,
    "y-18": 0.219,
    "y-19": 0.219,
    "y-20": 0.219,
    "y-21": 0.219,
    "y-22": 0.219,
    "y-23": 0.219,
    "y-24": 0.219,
    "y-25": 0.219,
    "y-26": 0.219,
    "y-27": 0.219,
    "y-28": 0.219,
    "y-29": 0.219,
    "y-30": 0.219,
    "y-31": 0.219,
    "y-32": 0.219,
    "y-33": 0.219,
    "y-34": 0.219,
    "y-35": 0.219,
    "y-36": 0.219,
    "y-37": 0.219,
    "y-38": 0.219,
    "y-39": 0.219,
    "y-40": 0.219,
    "y-41": 0.219,
    "y-42": 0.22,
    "y-43": 0.22,
    "y-44": 0.22,
    "y-45": 0.22,
    "y-47": 0.22,
    "y-48": 0.22,
    "y-49": 0.22,
    "y-50": 0.22,
    "y-51": 0.22,
    "y-52": 0.22,
    "y-53": 0.22,
    "y-54": 0.22,
    "y-55": 0.22,
    "y-56": 0.22,
    "y-57": 0.22,
    "y-58": 0.22,
    "y-59": 0.22,
    "y-60": 0.22,
    "y-61": 0.22,
    "y-62": 0.22,
    "y-63": 0.22,
    "y-64": 0.22,
    "y-65": 0.22,
    "y-66": 0.22,
    "y-67": 0.22,
    "y-68": 0.22,
    "y-69": 0.22,
    "y-70": 0.22,
    "y-71": 0.22,
    "y-72": 0.22,
    "y-73": 0.22,
    "y-74": 0.22,
    "y-75": 0.22,
    "y-76": 0.22,
    "y-77": 0.22,
    "y-78": 0.22,
    "y-79": 0.22,
    "y-80": 0.22,
    "y-81": 0.22,
    "y-82": 0.223,
    "y-83": 0.223,
    "y-84": 0.223,
    "y-85": 0.223,
    "y-86": 0.223,
    "y-87": 0.223,
    "y-88": 0.223,
    "y-89": 0.223,
    "y-90": 0.223,
    "y-91": 0.223,
    "y-92": 0.223,
    "y-93": 0.223,
    "y-94": 0.223,
    "y-95": 0.223,
    "y-96": 0.223,
    "y-97": 0.223,
    "y-98": 0.223,
    "y-99": 0.223,
    "y-100": 0.223,
    "y-101": 0.223,
    "y-102": 0.223,
    "y-103": 0.223,
    "y-104": 0.223,
    "y-105": 0.223,
    "y-106": 0.223,
    "y-107": 0.225,
    "y-108": 0.225,
    "y-109": 0.225,
    "y-110": 0.225,
    "y-111": 0.225,
    "y-112": 0.225,
    "y-113": 0.225,
    "y-114": 0.225,
    "y-115": 0.225,
    "y-116": 0.225,
    "y-117": 0.225,
    "y-118": 0.225,
    "y-119": 0.225,
    "y-120": 0.225,
    "y-121": 0.225,
    "y-122": 0.225,
    "y-123": 0.225,
    "y-124": 0.224,
    "y-125": 0.224,
    "y-126": 0.224,
    "y-127": 0.224,
    "y-128": 0.224,
    "y-129": 0.224,
    "y-130": 0.224,
    "y-131": 0.224,
    "y-132": 0.224,
    "y-133": 0.224,
    "y-134": 0.224,
    "y-135": 0.224,
    "y-136": 0.224,
    "y-137": 0.224,
    "y-138": 0.224,
    "y-139": 0.224,
    "y-140": 0.224,
    "y-141": 0.224,
    "y-142": 0.224,
    "y-143": 0.224,
    "y-144": 0.224,
    "y-145": 0.224,
    "y-146": 0.224,
    "y-147": 0.224,
    "y-148": 0.224,
    "y-149": 0.224,
    "y-150": 0.224,
    "y-151": 0.224,
    "y-152": 0.224,
    "y-153": 0.224,
    "y-154": 0.224,
    "y-155": 0.224,
    "y-156": 0.224,
    "y-157": 0.224,
    "y-158": 0.224,
    "y-159": 0.224,
    "y-160": 0.224,
    "y-161": 0.224,
    "y-162": 0.224,
    "y-163": 0.224,
    "y-164": 0.224,
    "y-165": 0.224,
    "y-166": 0.224,
    "y-167": 0.224,
    "y-168": 0.224,
    "y-169": 0.224,
    "y-170": 0.224,
    "y-171": 0.224,
    "y-172": 0.224,
    "y-173": 0.224,
    "y-174": 0.224,
    "y-175": 0.224,
    "y-176": 0.224,
    "y-177": 0.224,
    "y-178": 0.224,
    "y-179": 0.224,
    "y-180": 0.224,
    "y-181": 0.224,
    "y-182": 0.224,
    "y-183": 0.224,
    "y-184": 0.224,
    "y-185": 0.224,
    "y-186": 0.224,
    "y-187": 0.224,
    "y-188": 0.224,
    "y-189": 0.224,
    "y-190": 0.224,
    "y-191": 0.224,
    "y-192": 0.224,
    "y-193": 0.224,
    "y-194": 0.224,
    "y-195": 0.224,
    "y-196": 0.224,
    "y-197": 0.224,
    "y-198": 0.224,
    "y-199": 0.224,
    "y-200": 0.224,
    "y-201": 0.224,
    "y-202": 0.224,
    "y-203": 0.224,
    "y-204": 0.224,
    "y-205": 0.224,
    "y-206": 0.224,
    "y-207": 0.224,
    "y-208": 0.224,
    "y-209": 0.224,
    "y-210": 0.224,
    "y-211": 0.224,
    "y-212": 0.224,
    "y-213": 0.224,
    "y-214": 0.224,
    "y-215": 0.224,
    "y-216": 0.224,
    "y-217": 0.224,
    "y-218": 0.224,
    "y-219": 0.224,
    "y-220": 0.224,
    "y-221": 0.224,
    "y-222": 0.224,
    "y-223": 0.224,
    "y-224": 0.224,
    "y-225": 0.224,
    "y-226": 0.224,
    "y-227": 0.224,
    "y-228": 0.224,
    "y-229": 0.224,
    "y-230": 0.224,
    "y-231": 0.224,
    "y-232": 0.224,
    "y-233": 0.224,
    "y-234": 0.224,
    "y-235": 0.224,
    "y-236": 0.224,
    "y-237": 0.224,
    "y-238": 0.224,
    "y-239": 0.224,
    "y-240": 0.224,
    "y-241": 0.224,
    "y-242": 0.224,
    "y-243": 0.224,
    "y-244": 0.224,
    "y-245": 0.224,
    "y-246": 0.224,
    "y-247": 0.224,
    "y-248": 0.224,
    "y-249": 0.224,
    "y-250": 0.224,
    "y-251": 0.224,
    "y-252": 0.224,
    "y-253": 0.224,
    "y-254": 0.224,
    "y-255": 0.224,
  },
  {
    x: -0.05,
    "y-2": -0.116,
    "y-12": 0.149,
    "y-46": 0.146,
    "y-1000": 0.15,
    "y-0": 0.128,
    "y-1": -0.237,
    "y-3": 0.598,
    "y-4": 0.254,
    "y-5": 0.106,
    "y-6": 0.1,
    "y-7": 0.093,
    "y-8": 0.068,
    "y-9": 0.068,
    "y-10": 0.148,
    "y-11": 0.15,
    "y-13": 0.149,
    "y-14": 0.144,
    "y-15": 0.145,
    "y-16": 0.145,
    "y-17": 0.146,
    "y-18": 0.146,
    "y-19": 0.146,
    "y-20": 0.145,
    "y-21": 0.145,
    "y-22": 0.145,
    "y-23": 0.145,
    "y-24": 0.145,
    "y-25": 0.145,
    "y-26": 0.145,
    "y-27": 0.145,
    "y-28": 0.145,
    "y-29": 0.145,
    "y-30": 0.145,
    "y-31": 0.145,
    "y-32": 0.145,
    "y-33": 0.145,
    "y-34": 0.145,
    "y-35": 0.145,
    "y-36": 0.145,
    "y-37": 0.145,
    "y-38": 0.146,
    "y-39": 0.145,
    "y-40": 0.146,
    "y-41": 0.146,
    "y-42": 0.146,
    "y-43": 0.146,
    "y-44": 0.146,
    "y-45": 0.146,
    "y-47": 0.146,
    "y-48": 0.146,
    "y-49": 0.146,
    "y-50": 0.146,
    "y-51": 0.146,
    "y-52": 0.146,
    "y-53": 0.146,
    "y-54": 0.146,
    "y-55": 0.146,
    "y-56": 0.146,
    "y-57": 0.146,
    "y-58": 0.146,
    "y-59": 0.146,
    "y-60": 0.146,
    "y-61": 0.146,
    "y-62": 0.146,
    "y-63": 0.146,
    "y-64": 0.146,
    "y-65": 0.146,
    "y-66": 0.146,
    "y-67": 0.146,
    "y-68": 0.146,
    "y-69": 0.146,
    "y-70": 0.146,
    "y-71": 0.146,
    "y-72": 0.146,
    "y-73": 0.146,
    "y-74": 0.146,
    "y-75": 0.146,
    "y-76": 0.146,
    "y-77": 0.146,
    "y-78": 0.146,
    "y-79": 0.146,
    "y-80": 0.146,
    "y-81": 0.146,
    "y-82": 0.15,
    "y-83": 0.15,
    "y-84": 0.15,
    "y-85": 0.15,
    "y-86": 0.15,
    "y-87": 0.15,
    "y-88": 0.15,
    "y-89": 0.15,
    "y-90": 0.15,
    "y-91": 0.15,
    "y-92": 0.15,
    "y-93": 0.15,
    "y-94": 0.15,
    "y-95": 0.15,
    "y-96": 0.15,
    "y-97": 0.15,
    "y-98": 0.15,
    "y-99": 0.15,
    "y-100": 0.15,
    "y-101": 0.15,
    "y-102": 0.15,
    "y-103": 0.15,
    "y-104": 0.15,
    "y-105": 0.15,
    "y-106": 0.15,
    "y-107": 0.15,
    "y-108": 0.15,
    "y-109": 0.15,
    "y-110": 0.15,
    "y-111": 0.15,
    "y-112": 0.15,
    "y-113": 0.15,
    "y-114": 0.15,
    "y-115": 0.15,
    "y-116": 0.15,
    "y-117": 0.15,
    "y-118": 0.15,
    "y-119": 0.15,
    "y-120": 0.15,
    "y-121": 0.15,
    "y-122": 0.15,
    "y-123": 0.15,
    "y-124": 0.15,
    "y-125": 0.15,
    "y-126": 0.15,
    "y-127": 0.15,
    "y-128": 0.15,
    "y-129": 0.15,
    "y-130": 0.15,
    "y-131": 0.15,
    "y-132": 0.15,
    "y-133": 0.15,
    "y-134": 0.15,
    "y-135": 0.15,
    "y-136": 0.149,
    "y-137": 0.149,
    "y-138": 0.149,
    "y-139": 0.149,
    "y-140": 0.149,
    "y-141": 0.149,
    "y-142": 0.149,
    "y-143": 0.149,
    "y-144": 0.149,
    "y-145": 0.149,
    "y-146": 0.149,
    "y-147": 0.149,
    "y-148": 0.149,
    "y-149": 0.149,
    "y-150": 0.149,
    "y-151": 0.149,
    "y-152": 0.149,
    "y-153": 0.149,
    "y-154": 0.149,
    "y-155": 0.149,
    "y-156": 0.149,
    "y-157": 0.149,
    "y-158": 0.149,
    "y-159": 0.149,
    "y-160": 0.149,
    "y-161": 0.149,
    "y-162": 0.149,
    "y-163": 0.149,
    "y-164": 0.149,
    "y-165": 0.149,
    "y-166": 0.149,
    "y-167": 0.149,
    "y-168": 0.149,
    "y-169": 0.149,
    "y-170": 0.149,
    "y-171": 0.149,
    "y-172": 0.149,
    "y-173": 0.149,
    "y-174": 0.149,
    "y-175": 0.149,
    "y-176": 0.149,
    "y-177": 0.149,
    "y-178": 0.149,
    "y-179": 0.149,
    "y-180": 0.149,
    "y-181": 0.149,
    "y-182": 0.149,
    "y-183": 0.149,
    "y-184": 0.149,
    "y-185": 0.149,
    "y-186": 0.149,
    "y-187": 0.149,
    "y-188": 0.149,
    "y-189": 0.149,
    "y-190": 0.149,
    "y-191": 0.149,
    "y-192": 0.149,
    "y-193": 0.149,
    "y-194": 0.149,
    "y-195": 0.149,
    "y-196": 0.149,
    "y-197": 0.149,
    "y-198": 0.149,
    "y-199": 0.149,
    "y-200": 0.149,
    "y-201": 0.149,
    "y-202": 0.149,
    "y-203": 0.149,
    "y-204": 0.149,
    "y-205": 0.149,
    "y-206": 0.15,
    "y-207": 0.15,
    "y-208": 0.15,
    "y-209": 0.15,
    "y-210": 0.15,
    "y-211": 0.15,
    "y-212": 0.15,
    "y-213": 0.15,
    "y-214": 0.15,
    "y-215": 0.15,
    "y-216": 0.15,
    "y-217": 0.15,
    "y-218": 0.15,
    "y-219": 0.15,
    "y-220": 0.15,
    "y-221": 0.15,
    "y-222": 0.15,
    "y-223": 0.15,
    "y-224": 0.15,
    "y-225": 0.15,
    "y-226": 0.15,
    "y-227": 0.15,
    "y-228": 0.15,
    "y-229": 0.15,
    "y-230": 0.15,
    "y-231": 0.15,
    "y-232": 0.15,
    "y-233": 0.15,
    "y-234": 0.15,
    "y-235": 0.15,
    "y-236": 0.15,
    "y-237": 0.15,
    "y-238": 0.15,
    "y-239": 0.15,
    "y-240": 0.15,
    "y-241": 0.15,
    "y-242": 0.15,
    "y-243": 0.15,
    "y-244": 0.15,
    "y-245": 0.15,
    "y-246": 0.15,
    "y-247": 0.15,
    "y-248": 0.15,
    "y-249": 0.15,
    "y-250": 0.15,
    "y-251": 0.15,
    "y-252": 0.15,
    "y-253": 0.15,
    "y-254": 0.15,
    "y-255": 0.15,
  },
  {
    x: -0.025,
    "y-2": -0.137,
    "y-12": 0.078,
    "y-46": 0.073,
    "y-1000": 0.075,
    "y-0": 0.116,
    "y-1": -0.261,
    "y-3": 0.523,
    "y-4": 0.193,
    "y-5": 0.051,
    "y-6": 0.045,
    "y-7": 0.039,
    "y-8": 0.015,
    "y-9": 0.015,
    "y-10": 0.078,
    "y-11": 0.078,
    "y-13": 0.078,
    "y-14": 0.07,
    "y-15": 0.072,
    "y-16": 0.072,
    "y-17": 0.072,
    "y-18": 0.072,
    "y-19": 0.072,
    "y-20": 0.071,
    "y-21": 0.071,
    "y-22": 0.071,
    "y-23": 0.071,
    "y-24": 0.071,
    "y-25": 0.071,
    "y-26": 0.072,
    "y-27": 0.072,
    "y-28": 0.072,
    "y-29": 0.072,
    "y-30": 0.072,
    "y-31": 0.072,
    "y-32": 0.072,
    "y-33": 0.072,
    "y-34": 0.071,
    "y-35": 0.071,
    "y-36": 0.071,
    "y-37": 0.071,
    "y-38": 0.072,
    "y-39": 0.072,
    "y-40": 0.072,
    "y-41": 0.072,
    "y-42": 0.073,
    "y-43": 0.073,
    "y-44": 0.073,
    "y-45": 0.073,
    "y-47": 0.073,
    "y-48": 0.073,
    "y-49": 0.073,
    "y-50": 0.073,
    "y-51": 0.073,
    "y-52": 0.073,
    "y-53": 0.073,
    "y-54": 0.073,
    "y-55": 0.073,
    "y-56": 0.073,
    "y-57": 0.073,
    "y-58": 0.073,
    "y-59": 0.073,
    "y-60": 0.073,
    "y-61": 0.073,
    "y-62": 0.073,
    "y-63": 0.073,
    "y-64": 0.073,
    "y-65": 0.073,
    "y-66": 0.073,
    "y-67": 0.073,
    "y-68": 0.073,
    "y-69": 0.073,
    "y-70": 0.073,
    "y-71": 0.073,
    "y-72": 0.073,
    "y-73": 0.073,
    "y-74": 0.073,
    "y-75": 0.073,
    "y-76": 0.073,
    "y-77": 0.073,
    "y-78": 0.073,
    "y-79": 0.073,
    "y-80": 0.073,
    "y-81": 0.073,
    "y-82": 0.077,
    "y-83": 0.077,
    "y-84": 0.077,
    "y-85": 0.077,
    "y-86": 0.077,
    "y-87": 0.077,
    "y-88": 0.077,
    "y-89": 0.077,
    "y-90": 0.077,
    "y-91": 0.077,
    "y-92": 0.077,
    "y-93": 0.077,
    "y-94": 0.077,
    "y-95": 0.077,
    "y-96": 0.077,
    "y-97": 0.077,
    "y-98": 0.077,
    "y-99": 0.077,
    "y-100": 0.077,
    "y-101": 0.077,
    "y-102": 0.077,
    "y-103": 0.077,
    "y-104": 0.077,
    "y-105": 0.077,
    "y-106": 0.077,
    "y-107": 0.075,
    "y-108": 0.075,
    "y-109": 0.075,
    "y-110": 0.075,
    "y-111": 0.075,
    "y-112": 0.075,
    "y-113": 0.075,
    "y-114": 0.075,
    "y-115": 0.075,
    "y-116": 0.075,
    "y-117": 0.075,
    "y-118": 0.075,
    "y-119": 0.075,
    "y-120": 0.075,
    "y-121": 0.075,
    "y-122": 0.075,
    "y-123": 0.075,
    "y-124": 0.075,
    "y-125": 0.075,
    "y-126": 0.075,
    "y-127": 0.075,
    "y-128": 0.075,
    "y-129": 0.075,
    "y-130": 0.075,
    "y-131": 0.075,
    "y-132": 0.075,
    "y-133": 0.075,
    "y-134": 0.075,
    "y-135": 0.075,
    "y-136": 0.075,
    "y-137": 0.075,
    "y-138": 0.075,
    "y-139": 0.075,
    "y-140": 0.075,
    "y-141": 0.075,
    "y-142": 0.075,
    "y-143": 0.075,
    "y-144": 0.075,
    "y-145": 0.075,
    "y-146": 0.075,
    "y-147": 0.075,
    "y-148": 0.075,
    "y-149": 0.075,
    "y-150": 0.075,
    "y-151": 0.075,
    "y-152": 0.075,
    "y-153": 0.075,
    "y-154": 0.075,
    "y-155": 0.075,
    "y-156": 0.075,
    "y-157": 0.075,
    "y-158": 0.075,
    "y-159": 0.075,
    "y-160": 0.075,
    "y-161": 0.075,
    "y-162": 0.075,
    "y-163": 0.075,
    "y-164": 0.075,
    "y-165": 0.075,
    "y-166": 0.075,
    "y-167": 0.075,
    "y-168": 0.075,
    "y-169": 0.075,
    "y-170": 0.075,
    "y-171": 0.075,
    "y-172": 0.075,
    "y-173": 0.075,
    "y-174": 0.075,
    "y-175": 0.075,
    "y-176": 0.075,
    "y-177": 0.075,
    "y-178": 0.075,
    "y-179": 0.075,
    "y-180": 0.075,
    "y-181": 0.075,
    "y-182": 0.075,
    "y-183": 0.075,
    "y-184": 0.075,
    "y-185": 0.075,
    "y-186": 0.075,
    "y-187": 0.075,
    "y-188": 0.075,
    "y-189": 0.075,
    "y-190": 0.075,
    "y-191": 0.075,
    "y-192": 0.075,
    "y-193": 0.075,
    "y-194": 0.075,
    "y-195": 0.075,
    "y-196": 0.075,
    "y-197": 0.075,
    "y-198": 0.075,
    "y-199": 0.075,
    "y-200": 0.075,
    "y-201": 0.075,
    "y-202": 0.075,
    "y-203": 0.075,
    "y-204": 0.075,
    "y-205": 0.075,
    "y-206": 0.075,
    "y-207": 0.075,
    "y-208": 0.075,
    "y-209": 0.075,
    "y-210": 0.075,
    "y-211": 0.075,
    "y-212": 0.075,
    "y-213": 0.075,
    "y-214": 0.075,
    "y-215": 0.075,
    "y-216": 0.075,
    "y-217": 0.075,
    "y-218": 0.075,
    "y-219": 0.075,
    "y-220": 0.075,
    "y-221": 0.075,
    "y-222": 0.075,
    "y-223": 0.075,
    "y-224": 0.075,
    "y-225": 0.075,
    "y-226": 0.075,
    "y-227": 0.075,
    "y-228": 0.075,
    "y-229": 0.075,
    "y-230": 0.075,
    "y-231": 0.075,
    "y-232": 0.075,
    "y-233": 0.075,
    "y-234": 0.075,
    "y-235": 0.075,
    "y-236": 0.075,
    "y-237": 0.075,
    "y-238": 0.075,
    "y-239": 0.075,
    "y-240": 0.075,
    "y-241": 0.075,
    "y-242": 0.075,
    "y-243": 0.075,
    "y-244": 0.075,
    "y-245": 0.075,
    "y-246": 0.075,
    "y-247": 0.075,
    "y-248": 0.075,
    "y-249": 0.075,
    "y-250": 0.075,
    "y-251": 0.075,
    "y-252": 0.075,
    "y-253": 0.075,
    "y-254": 0.075,
    "y-255": 0.075,
  },
  {
    x: 0.0,
    "y-2": -0.159,
    "y-12": 0.006,
    "y-46": -0.001,
    "y-1000": 0.0,
    "y-0": 0.103,
    "y-1": -0.286,
    "y-3": 0.447,
    "y-4": 0.132,
    "y-5": -0.004,
    "y-6": -0.009,
    "y-7": -0.015,
    "y-8": -0.038,
    "y-9": -0.038,
    "y-10": 0.008,
    "y-11": 0.006,
    "y-13": 0.006,
    "y-14": -0.003,
    "y-15": -0.002,
    "y-16": -0.002,
    "y-17": -0.002,
    "y-18": -0.002,
    "y-19": -0.002,
    "y-20": -0.002,
    "y-21": -0.002,
    "y-22": -0.002,
    "y-23": -0.002,
    "y-24": -0.002,
    "y-25": -0.002,
    "y-26": -0.002,
    "y-27": -0.002,
    "y-28": -0.002,
    "y-29": -0.002,
    "y-30": -0.002,
    "y-31": -0.002,
    "y-32": -0.002,
    "y-33": -0.002,
    "y-34": -0.002,
    "y-35": -0.002,
    "y-36": -0.002,
    "y-37": -0.002,
    "y-38": -0.002,
    "y-39": -0.002,
    "y-40": -0.002,
    "y-41": -0.002,
    "y-42": -0.001,
    "y-43": -0.001,
    "y-44": -0.001,
    "y-45": -0.001,
    "y-47": -0.001,
    "y-48": -0.001,
    "y-49": -0.001,
    "y-50": -0.001,
    "y-51": -0.001,
    "y-52": -0.001,
    "y-53": -0.001,
    "y-54": -0.001,
    "y-55": -0.001,
    "y-56": -0.001,
    "y-57": -0.001,
    "y-58": -0.001,
    "y-59": -0.001,
    "y-60": -0.001,
    "y-61": -0.001,
    "y-62": -0.001,
    "y-63": -0.001,
    "y-64": -0.001,
    "y-65": -0.001,
    "y-66": -0.001,
    "y-67": -0.001,
    "y-68": -0.001,
    "y-69": -0.001,
    "y-70": -0.001,
    "y-71": -0.001,
    "y-72": -0.001,
    "y-73": -0.001,
    "y-74": -0.001,
    "y-75": -0.001,
    "y-76": -0.001,
    "y-77": -0.001,
    "y-78": -0.001,
    "y-79": -0.001,
    "y-80": -0.001,
    "y-81": -0.001,
    "y-82": 0.004,
    "y-83": 0.004,
    "y-84": 0.004,
    "y-85": 0.004,
    "y-86": 0.004,
    "y-87": 0.004,
    "y-88": 0.004,
    "y-89": 0.004,
    "y-90": 0.004,
    "y-91": 0.004,
    "y-92": 0.004,
    "y-93": 0.004,
    "y-94": 0.004,
    "y-95": 0.004,
    "y-96": 0.004,
    "y-97": 0.004,
    "y-98": 0.004,
    "y-99": 0.004,
    "y-100": 0.004,
    "y-101": 0.004,
    "y-102": 0.004,
    "y-103": 0.004,
    "y-104": 0.004,
    "y-105": 0.004,
    "y-106": 0.004,
    "y-107": 0.0,
    "y-108": 0.0,
    "y-109": 0.0,
    "y-110": 0.0,
    "y-111": 0.0,
    "y-112": 0.0,
    "y-113": 0.0,
    "y-114": 0.0,
    "y-115": 0.0,
    "y-116": 0.0,
    "y-117": 0.0,
    "y-118": 0.0,
    "y-119": 0.0,
    "y-120": 0.0,
    "y-121": 0.0,
    "y-122": 0.0,
    "y-123": 0.0,
    "y-124": 0.0,
    "y-125": 0.0,
    "y-126": 0.0,
    "y-127": 0.0,
    "y-128": 0.0,
    "y-129": 0.0,
    "y-130": 0.0,
    "y-131": 0.0,
    "y-132": 0.0,
    "y-133": 0.0,
    "y-134": 0.0,
    "y-135": 0.0,
    "y-136": 0.0,
    "y-137": 0.0,
    "y-138": 0.0,
    "y-139": 0.0,
    "y-140": 0.0,
    "y-141": 0.0,
    "y-142": 0.0,
    "y-143": 0.0,
    "y-144": 0.0,
    "y-145": 0.0,
    "y-146": 0.0,
    "y-147": 0.0,
    "y-148": 0.0,
    "y-149": 0.0,
    "y-150": 0.0,
    "y-151": 0.0,
    "y-152": 0.0,
    "y-153": 0.0,
    "y-154": 0.0,
    "y-155": 0.0,
    "y-156": 0.0,
    "y-157": 0.0,
    "y-158": 0.0,
    "y-159": 0.0,
    "y-160": 0.0,
    "y-161": 0.0,
    "y-162": 0.0,
    "y-163": 0.0,
    "y-164": 0.0,
    "y-165": 0.0,
    "y-166": 0.0,
    "y-167": 0.0,
    "y-168": 0.0,
    "y-169": 0.0,
    "y-170": 0.0,
    "y-171": 0.0,
    "y-172": 0.0,
    "y-173": 0.0,
    "y-174": 0.0,
    "y-175": 0.0,
    "y-176": 0.0,
    "y-177": 0.0,
    "y-178": 0.0,
    "y-179": 0.0,
    "y-180": 0.0,
    "y-181": 0.0,
    "y-182": 0.0,
    "y-183": 0.0,
    "y-184": 0.0,
    "y-185": 0.0,
    "y-186": 0.0,
    "y-187": 0.0,
    "y-188": 0.0,
    "y-189": 0.0,
    "y-190": 0.0,
    "y-191": 0.0,
    "y-192": 0.0,
    "y-193": 0.0,
    "y-194": 0.0,
    "y-195": 0.0,
    "y-196": 0.0,
    "y-197": 0.0,
    "y-198": 0.0,
    "y-199": 0.0,
    "y-200": 0.0,
    "y-201": 0.0,
    "y-202": 0.0,
    "y-203": 0.0,
    "y-204": 0.0,
    "y-205": 0.0,
    "y-206": 0.0,
    "y-207": 0.0,
    "y-208": 0.0,
    "y-209": 0.0,
    "y-210": 0.0,
    "y-211": 0.0,
    "y-212": 0.0,
    "y-213": 0.0,
    "y-214": 0.0,
    "y-215": 0.0,
    "y-216": 0.0,
    "y-217": 0.0,
    "y-218": 0.0,
    "y-219": 0.0,
    "y-220": 0.0,
    "y-221": 0.0,
    "y-222": 0.0,
    "y-223": 0.0,
    "y-224": 0.0,
    "y-225": 0.0,
    "y-226": 0.0,
    "y-227": 0.0,
    "y-228": 0.0,
    "y-229": 0.0,
    "y-230": 0.0,
    "y-231": 0.0,
    "y-232": 0.0,
    "y-233": 0.0,
    "y-234": 0.0,
    "y-235": 0.0,
    "y-236": 0.0,
    "y-237": 0.0,
    "y-238": 0.0,
    "y-239": 0.0,
    "y-240": 0.0,
    "y-241": 0.0,
    "y-242": 0.0,
    "y-243": 0.0,
    "y-244": 0.0,
    "y-245": 0.0,
    "y-246": 0.0,
    "y-247": 0.0,
    "y-248": 0.0,
    "y-249": 0.0,
    "y-250": 0.0,
    "y-251": 0.0,
    "y-252": 0.0,
    "y-253": 0.0,
    "y-254": 0.0,
    "y-255": 0.0,
  },
  {
    x: 0.025,
    "y-2": -0.18,
    "y-12": -0.066,
    "y-46": -0.074,
    "y-1000": -0.075,
    "y-0": 0.091,
    "y-1": -0.311,
    "y-3": 0.371,
    "y-4": 0.071,
    "y-5": -0.058,
    "y-6": -0.064,
    "y-7": -0.069,
    "y-8": -0.091,
    "y-9": -0.091,
    "y-10": -0.062,
    "y-11": -0.066,
    "y-13": -0.066,
    "y-14": -0.077,
    "y-15": -0.075,
    "y-16": -0.075,
    "y-17": -0.075,
    "y-18": -0.075,
    "y-19": -0.075,
    "y-20": -0.076,
    "y-21": -0.076,
    "y-22": -0.076,
    "y-23": -0.076,
    "y-24": -0.076,
    "y-25": -0.076,
    "y-26": -0.076,
    "y-27": -0.076,
    "y-28": -0.076,
    "y-29": -0.076,
    "y-30": -0.076,
    "y-31": -0.076,
    "y-32": -0.076,
    "y-33": -0.076,
    "y-34": -0.076,
    "y-35": -0.076,
    "y-36": -0.076,
    "y-37": -0.076,
    "y-38": -0.075,
    "y-39": -0.075,
    "y-40": -0.075,
    "y-41": -0.075,
    "y-42": -0.074,
    "y-43": -0.074,
    "y-44": -0.074,
    "y-45": -0.074,
    "y-47": -0.074,
    "y-48": -0.074,
    "y-49": -0.074,
    "y-50": -0.074,
    "y-51": -0.074,
    "y-52": -0.074,
    "y-53": -0.074,
    "y-54": -0.074,
    "y-55": -0.074,
    "y-56": -0.074,
    "y-57": -0.074,
    "y-58": -0.074,
    "y-59": -0.074,
    "y-60": -0.074,
    "y-61": -0.074,
    "y-62": -0.074,
    "y-63": -0.074,
    "y-64": -0.074,
    "y-65": -0.074,
    "y-66": -0.074,
    "y-67": -0.074,
    "y-68": -0.074,
    "y-69": -0.074,
    "y-70": -0.074,
    "y-71": -0.074,
    "y-72": -0.074,
    "y-73": -0.074,
    "y-74": -0.074,
    "y-75": -0.074,
    "y-76": -0.074,
    "y-77": -0.074,
    "y-78": -0.074,
    "y-79": -0.074,
    "y-80": -0.074,
    "y-81": -0.074,
    "y-82": -0.069,
    "y-83": -0.069,
    "y-84": -0.069,
    "y-85": -0.069,
    "y-86": -0.069,
    "y-87": -0.069,
    "y-88": -0.069,
    "y-89": -0.069,
    "y-90": -0.069,
    "y-91": -0.069,
    "y-92": -0.069,
    "y-93": -0.069,
    "y-94": -0.069,
    "y-95": -0.069,
    "y-96": -0.069,
    "y-97": -0.069,
    "y-98": -0.069,
    "y-99": -0.069,
    "y-100": -0.069,
    "y-101": -0.069,
    "y-102": -0.069,
    "y-103": -0.069,
    "y-104": -0.069,
    "y-105": -0.069,
    "y-106": -0.069,
    "y-107": -0.076,
    "y-108": -0.076,
    "y-109": -0.076,
    "y-110": -0.076,
    "y-111": -0.076,
    "y-112": -0.076,
    "y-113": -0.076,
    "y-114": -0.076,
    "y-115": -0.076,
    "y-116": -0.076,
    "y-117": -0.076,
    "y-118": -0.076,
    "y-119": -0.076,
    "y-120": -0.076,
    "y-121": -0.076,
    "y-122": -0.076,
    "y-123": -0.076,
    "y-124": -0.075,
    "y-125": -0.075,
    "y-126": -0.075,
    "y-127": -0.075,
    "y-128": -0.075,
    "y-129": -0.075,
    "y-130": -0.075,
    "y-131": -0.075,
    "y-132": -0.075,
    "y-133": -0.075,
    "y-134": -0.075,
    "y-135": -0.075,
    "y-136": -0.074,
    "y-137": -0.074,
    "y-138": -0.074,
    "y-139": -0.074,
    "y-140": -0.074,
    "y-141": -0.074,
    "y-142": -0.074,
    "y-143": -0.074,
    "y-144": -0.074,
    "y-145": -0.074,
    "y-146": -0.074,
    "y-147": -0.074,
    "y-148": -0.074,
    "y-149": -0.074,
    "y-150": -0.074,
    "y-151": -0.074,
    "y-152": -0.074,
    "y-153": -0.074,
    "y-154": -0.074,
    "y-155": -0.074,
    "y-156": -0.074,
    "y-157": -0.074,
    "y-158": -0.074,
    "y-159": -0.074,
    "y-160": -0.074,
    "y-161": -0.074,
    "y-162": -0.074,
    "y-163": -0.074,
    "y-164": -0.074,
    "y-165": -0.074,
    "y-166": -0.074,
    "y-167": -0.074,
    "y-168": -0.074,
    "y-169": -0.074,
    "y-170": -0.074,
    "y-171": -0.074,
    "y-172": -0.074,
    "y-173": -0.074,
    "y-174": -0.074,
    "y-175": -0.074,
    "y-176": -0.074,
    "y-177": -0.074,
    "y-178": -0.074,
    "y-179": -0.074,
    "y-180": -0.074,
    "y-181": -0.074,
    "y-182": -0.074,
    "y-183": -0.074,
    "y-184": -0.074,
    "y-185": -0.074,
    "y-186": -0.074,
    "y-187": -0.074,
    "y-188": -0.074,
    "y-189": -0.074,
    "y-190": -0.074,
    "y-191": -0.075,
    "y-192": -0.075,
    "y-193": -0.075,
    "y-194": -0.075,
    "y-195": -0.075,
    "y-196": -0.075,
    "y-197": -0.075,
    "y-198": -0.075,
    "y-199": -0.075,
    "y-200": -0.075,
    "y-201": -0.075,
    "y-202": -0.075,
    "y-203": -0.075,
    "y-204": -0.075,
    "y-205": -0.075,
    "y-206": -0.075,
    "y-207": -0.075,
    "y-208": -0.075,
    "y-209": -0.075,
    "y-210": -0.075,
    "y-211": -0.075,
    "y-212": -0.075,
    "y-213": -0.075,
    "y-214": -0.075,
    "y-215": -0.075,
    "y-216": -0.075,
    "y-217": -0.075,
    "y-218": -0.075,
    "y-219": -0.075,
    "y-220": -0.075,
    "y-221": -0.075,
    "y-222": -0.075,
    "y-223": -0.075,
    "y-224": -0.075,
    "y-225": -0.075,
    "y-226": -0.075,
    "y-227": -0.075,
    "y-228": -0.075,
    "y-229": -0.075,
    "y-230": -0.075,
    "y-231": -0.075,
    "y-232": -0.075,
    "y-233": -0.075,
    "y-234": -0.075,
    "y-235": -0.075,
    "y-236": -0.075,
    "y-237": -0.075,
    "y-238": -0.075,
    "y-239": -0.075,
    "y-240": -0.075,
    "y-241": -0.075,
    "y-242": -0.075,
    "y-243": -0.075,
    "y-244": -0.075,
    "y-245": -0.075,
    "y-246": -0.075,
    "y-247": -0.075,
    "y-248": -0.075,
    "y-249": -0.075,
    "y-250": -0.075,
    "y-251": -0.075,
    "y-252": -0.075,
    "y-253": -0.075,
    "y-254": -0.075,
    "y-255": -0.075,
  },
  {
    x: 0.05,
    "y-2": -0.201,
    "y-12": -0.138,
    "y-46": -0.147,
    "y-1000": -0.15,
    "y-0": 0.079,
    "y-1": -0.335,
    "y-3": 0.295,
    "y-4": 0.01,
    "y-5": -0.113,
    "y-6": -0.118,
    "y-7": -0.123,
    "y-8": -0.145,
    "y-9": -0.145,
    "y-10": -0.132,
    "y-11": -0.137,
    "y-13": -0.138,
    "y-14": -0.151,
    "y-15": -0.149,
    "y-16": -0.149,
    "y-17": -0.149,
    "y-18": -0.149,
    "y-19": -0.149,
    "y-20": -0.15,
    "y-21": -0.15,
    "y-22": -0.15,
    "y-23": -0.15,
    "y-24": -0.15,
    "y-25": -0.15,
    "y-26": -0.149,
    "y-27": -0.149,
    "y-28": -0.149,
    "y-29": -0.149,
    "y-30": -0.149,
    "y-31": -0.149,
    "y-32": -0.149,
    "y-33": -0.149,
    "y-34": -0.15,
    "y-35": -0.15,
    "y-36": -0.15,
    "y-37": -0.15,
    "y-38": -0.149,
    "y-39": -0.149,
    "y-40": -0.149,
    "y-41": -0.149,
    "y-42": -0.147,
    "y-43": -0.147,
    "y-44": -0.147,
    "y-45": -0.147,
    "y-47": -0.147,
    "y-48": -0.147,
    "y-49": -0.147,
    "y-50": -0.147,
    "y-51": -0.147,
    "y-52": -0.147,
    "y-53": -0.147,
    "y-54": -0.147,
    "y-55": -0.147,
    "y-56": -0.147,
    "y-57": -0.147,
    "y-58": -0.147,
    "y-59": -0.147,
    "y-60": -0.147,
    "y-61": -0.147,
    "y-62": -0.147,
    "y-63": -0.147,
    "y-64": -0.147,
    "y-65": -0.147,
    "y-66": -0.147,
    "y-67": -0.147,
    "y-68": -0.147,
    "y-69": -0.147,
    "y-70": -0.147,
    "y-71": -0.147,
    "y-72": -0.147,
    "y-73": -0.147,
    "y-74": -0.147,
    "y-75": -0.147,
    "y-76": -0.147,
    "y-77": -0.147,
    "y-78": -0.147,
    "y-79": -0.147,
    "y-80": -0.147,
    "y-81": -0.147,
    "y-82": -0.145,
    "y-83": -0.145,
    "y-84": -0.145,
    "y-85": -0.145,
    "y-86": -0.145,
    "y-87": -0.145,
    "y-88": -0.145,
    "y-89": -0.145,
    "y-90": -0.145,
    "y-91": -0.145,
    "y-92": -0.145,
    "y-93": -0.145,
    "y-94": -0.145,
    "y-95": -0.145,
    "y-96": -0.145,
    "y-97": -0.145,
    "y-98": -0.145,
    "y-99": -0.145,
    "y-100": -0.145,
    "y-101": -0.145,
    "y-102": -0.145,
    "y-103": -0.145,
    "y-104": -0.145,
    "y-105": -0.145,
    "y-106": -0.145,
    "y-107": -0.15,
    "y-108": -0.15,
    "y-109": -0.15,
    "y-110": -0.15,
    "y-111": -0.15,
    "y-112": -0.15,
    "y-113": -0.15,
    "y-114": -0.15,
    "y-115": -0.15,
    "y-116": -0.15,
    "y-117": -0.15,
    "y-118": -0.15,
    "y-119": -0.15,
    "y-120": -0.15,
    "y-121": -0.15,
    "y-122": -0.15,
    "y-123": -0.15,
    "y-124": -0.15,
    "y-125": -0.149,
    "y-126": -0.149,
    "y-127": -0.149,
    "y-128": -0.149,
    "y-129": -0.149,
    "y-130": -0.149,
    "y-131": -0.149,
    "y-132": -0.149,
    "y-133": -0.149,
    "y-134": -0.149,
    "y-135": -0.149,
    "y-136": -0.149,
    "y-137": -0.149,
    "y-138": -0.149,
    "y-139": -0.149,
    "y-140": -0.149,
    "y-141": -0.149,
    "y-142": -0.149,
    "y-143": -0.149,
    "y-144": -0.149,
    "y-145": -0.149,
    "y-146": -0.149,
    "y-147": -0.149,
    "y-148": -0.149,
    "y-149": -0.149,
    "y-150": -0.149,
    "y-151": -0.149,
    "y-152": -0.149,
    "y-153": -0.149,
    "y-154": -0.149,
    "y-155": -0.149,
    "y-156": -0.149,
    "y-157": -0.149,
    "y-158": -0.149,
    "y-159": -0.149,
    "y-160": -0.149,
    "y-161": -0.149,
    "y-162": -0.149,
    "y-163": -0.149,
    "y-164": -0.149,
    "y-165": -0.149,
    "y-166": -0.149,
    "y-167": -0.149,
    "y-168": -0.149,
    "y-169": -0.149,
    "y-170": -0.149,
    "y-171": -0.149,
    "y-172": -0.149,
    "y-173": -0.149,
    "y-174": -0.149,
    "y-175": -0.149,
    "y-176": -0.149,
    "y-177": -0.149,
    "y-178": -0.149,
    "y-179": -0.149,
    "y-180": -0.149,
    "y-181": -0.149,
    "y-182": -0.149,
    "y-183": -0.149,
    "y-184": -0.149,
    "y-185": -0.149,
    "y-186": -0.149,
    "y-187": -0.149,
    "y-188": -0.149,
    "y-189": -0.149,
    "y-190": -0.149,
    "y-191": -0.149,
    "y-192": -0.149,
    "y-193": -0.149,
    "y-194": -0.149,
    "y-195": -0.149,
    "y-196": -0.149,
    "y-197": -0.149,
    "y-198": -0.149,
    "y-199": -0.149,
    "y-200": -0.149,
    "y-201": -0.15,
    "y-202": -0.15,
    "y-203": -0.15,
    "y-204": -0.15,
    "y-205": -0.15,
    "y-206": -0.15,
    "y-207": -0.15,
    "y-208": -0.15,
    "y-209": -0.15,
    "y-210": -0.15,
    "y-211": -0.15,
    "y-212": -0.15,
    "y-213": -0.15,
    "y-214": -0.15,
    "y-215": -0.15,
    "y-216": -0.15,
    "y-217": -0.15,
    "y-218": -0.15,
    "y-219": -0.15,
    "y-220": -0.15,
    "y-221": -0.15,
    "y-222": -0.15,
    "y-223": -0.15,
    "y-224": -0.15,
    "y-225": -0.15,
    "y-226": -0.15,
    "y-227": -0.15,
    "y-228": -0.15,
    "y-229": -0.15,
    "y-230": -0.15,
    "y-231": -0.15,
    "y-232": -0.15,
    "y-233": -0.15,
    "y-234": -0.15,
    "y-235": -0.15,
    "y-236": -0.15,
    "y-237": -0.15,
    "y-238": -0.15,
    "y-239": -0.15,
    "y-240": -0.15,
    "y-241": -0.15,
    "y-242": -0.15,
    "y-243": -0.15,
    "y-244": -0.15,
    "y-245": -0.15,
    "y-246": -0.15,
    "y-247": -0.15,
    "y-248": -0.15,
    "y-249": -0.15,
    "y-250": -0.15,
    "y-251": -0.15,
    "y-252": -0.15,
    "y-253": -0.15,
    "y-254": -0.15,
    "y-255": -0.15,
  },
  {
    x: 0.075,
    "y-2": -0.223,
    "y-12": -0.209,
    "y-46": -0.221,
    "y-1000": -0.225,
    "y-0": 0.067,
    "y-1": -0.36,
    "y-3": 0.219,
    "y-4": -0.051,
    "y-5": -0.167,
    "y-6": -0.172,
    "y-7": -0.178,
    "y-8": -0.198,
    "y-9": -0.198,
    "y-10": -0.202,
    "y-11": -0.209,
    "y-13": -0.209,
    "y-14": -0.225,
    "y-15": -0.222,
    "y-16": -0.222,
    "y-17": -0.222,
    "y-18": -0.222,
    "y-19": -0.222,
    "y-20": -0.224,
    "y-21": -0.224,
    "y-22": -0.224,
    "y-23": -0.224,
    "y-24": -0.224,
    "y-25": -0.224,
    "y-26": -0.223,
    "y-27": -0.223,
    "y-28": -0.223,
    "y-29": -0.223,
    "y-30": -0.223,
    "y-31": -0.223,
    "y-32": -0.223,
    "y-33": -0.223,
    "y-34": -0.223,
    "y-35": -0.223,
    "y-36": -0.223,
    "y-37": -0.223,
    "y-38": -0.222,
    "y-39": -0.222,
    "y-40": -0.222,
    "y-41": -0.222,
    "y-42": -0.221,
    "y-43": -0.221,
    "y-44": -0.221,
    "y-45": -0.221,
    "y-47": -0.221,
    "y-48": -0.221,
    "y-49": -0.221,
    "y-50": -0.221,
    "y-51": -0.221,
    "y-52": -0.221,
    "y-53": -0.221,
    "y-54": -0.221,
    "y-55": -0.221,
    "y-56": -0.221,
    "y-57": -0.221,
    "y-58": -0.221,
    "y-59": -0.221,
    "y-60": -0.221,
    "y-61": -0.221,
    "y-62": -0.221,
    "y-63": -0.221,
    "y-64": -0.221,
    "y-65": -0.221,
    "y-66": -0.221,
    "y-67": -0.221,
    "y-68": -0.221,
    "y-69": -0.221,
    "y-70": -0.221,
    "y-71": -0.221,
    "y-72": -0.221,
    "y-73": -0.221,
    "y-74": -0.221,
    "y-75": -0.221,
    "y-76": -0.221,
    "y-77": -0.221,
    "y-78": -0.221,
    "y-79": -0.221,
    "y-80": -0.221,
    "y-81": -0.221,
    "y-82": -0.222,
    "y-83": -0.222,
    "y-84": -0.222,
    "y-85": -0.222,
    "y-86": -0.222,
    "y-87": -0.222,
    "y-88": -0.222,
    "y-89": -0.222,
    "y-90": -0.222,
    "y-91": -0.222,
    "y-92": -0.222,
    "y-93": -0.222,
    "y-94": -0.222,
    "y-95": -0.222,
    "y-96": -0.222,
    "y-97": -0.222,
    "y-98": -0.222,
    "y-99": -0.222,
    "y-100": -0.222,
    "y-101": -0.222,
    "y-102": -0.222,
    "y-103": -0.222,
    "y-104": -0.222,
    "y-105": -0.222,
    "y-106": -0.222,
    "y-107": -0.225,
    "y-108": -0.225,
    "y-109": -0.225,
    "y-110": -0.225,
    "y-111": -0.225,
    "y-112": -0.225,
    "y-113": -0.225,
    "y-114": -0.225,
    "y-115": -0.225,
    "y-116": -0.225,
    "y-117": -0.225,
    "y-118": -0.225,
    "y-119": -0.225,
    "y-120": -0.225,
    "y-121": -0.225,
    "y-122": -0.225,
    "y-123": -0.225,
    "y-124": -0.224,
    "y-125": -0.224,
    "y-126": -0.224,
    "y-127": -0.224,
    "y-128": -0.224,
    "y-129": -0.224,
    "y-130": -0.224,
    "y-131": -0.224,
    "y-132": -0.224,
    "y-133": -0.224,
    "y-134": -0.224,
    "y-135": -0.224,
    "y-136": -0.224,
    "y-137": -0.224,
    "y-138": -0.224,
    "y-139": -0.224,
    "y-140": -0.224,
    "y-141": -0.224,
    "y-142": -0.224,
    "y-143": -0.224,
    "y-144": -0.224,
    "y-145": -0.224,
    "y-146": -0.224,
    "y-147": -0.224,
    "y-148": -0.224,
    "y-149": -0.224,
    "y-150": -0.224,
    "y-151": -0.224,
    "y-152": -0.224,
    "y-153": -0.224,
    "y-154": -0.224,
    "y-155": -0.224,
    "y-156": -0.224,
    "y-157": -0.224,
    "y-158": -0.224,
    "y-159": -0.224,
    "y-160": -0.224,
    "y-161": -0.224,
    "y-162": -0.224,
    "y-163": -0.224,
    "y-164": -0.224,
    "y-165": -0.224,
    "y-166": -0.224,
    "y-167": -0.224,
    "y-168": -0.224,
    "y-169": -0.224,
    "y-170": -0.224,
    "y-171": -0.224,
    "y-172": -0.224,
    "y-173": -0.224,
    "y-174": -0.224,
    "y-175": -0.224,
    "y-176": -0.224,
    "y-177": -0.224,
    "y-178": -0.224,
    "y-179": -0.224,
    "y-180": -0.224,
    "y-181": -0.224,
    "y-182": -0.224,
    "y-183": -0.224,
    "y-184": -0.224,
    "y-185": -0.224,
    "y-186": -0.224,
    "y-187": -0.224,
    "y-188": -0.224,
    "y-189": -0.224,
    "y-190": -0.224,
    "y-191": -0.224,
    "y-192": -0.224,
    "y-193": -0.224,
    "y-194": -0.224,
    "y-195": -0.224,
    "y-196": -0.224,
    "y-197": -0.224,
    "y-198": -0.224,
    "y-199": -0.224,
    "y-200": -0.224,
    "y-201": -0.224,
    "y-202": -0.224,
    "y-203": -0.224,
    "y-204": -0.224,
    "y-205": -0.224,
    "y-206": -0.224,
    "y-207": -0.224,
    "y-208": -0.224,
    "y-209": -0.224,
    "y-210": -0.224,
    "y-211": -0.224,
    "y-212": -0.224,
    "y-213": -0.224,
    "y-214": -0.224,
    "y-215": -0.224,
    "y-216": -0.224,
    "y-217": -0.224,
    "y-218": -0.224,
    "y-219": -0.224,
    "y-220": -0.224,
    "y-221": -0.224,
    "y-222": -0.224,
    "y-223": -0.224,
    "y-224": -0.224,
    "y-225": -0.224,
    "y-226": -0.224,
    "y-227": -0.224,
    "y-228": -0.224,
    "y-229": -0.224,
    "y-230": -0.224,
    "y-231": -0.224,
    "y-232": -0.224,
    "y-233": -0.224,
    "y-234": -0.224,
    "y-235": -0.224,
    "y-236": -0.224,
    "y-237": -0.224,
    "y-238": -0.224,
    "y-239": -0.224,
    "y-240": -0.224,
    "y-241": -0.224,
    "y-242": -0.224,
    "y-243": -0.224,
    "y-244": -0.224,
    "y-245": -0.224,
    "y-246": -0.224,
    "y-247": -0.224,
    "y-248": -0.224,
    "y-249": -0.224,
    "y-250": -0.224,
    "y-251": -0.224,
    "y-252": -0.224,
    "y-253": -0.224,
    "y-254": -0.224,
    "y-255": -0.224,
  },
  {
    x: 0.1,
    "y-2": -0.244,
    "y-12": -0.281,
    "y-46": -0.294,
    "y-1000": -0.299,
    "y-0": 0.055,
    "y-1": -0.384,
    "y-3": 0.144,
    "y-4": -0.112,
    "y-5": -0.222,
    "y-6": -0.227,
    "y-7": -0.232,
    "y-8": -0.251,
    "y-9": -0.251,
    "y-10": -0.272,
    "y-11": -0.281,
    "y-13": -0.281,
    "y-14": -0.299,
    "y-15": -0.296,
    "y-16": -0.296,
    "y-17": -0.296,
    "y-18": -0.296,
    "y-19": -0.296,
    "y-20": -0.297,
    "y-21": -0.297,
    "y-22": -0.297,
    "y-23": -0.297,
    "y-24": -0.297,
    "y-25": -0.297,
    "y-26": -0.297,
    "y-27": -0.297,
    "y-28": -0.297,
    "y-29": -0.297,
    "y-30": -0.297,
    "y-31": -0.297,
    "y-32": -0.297,
    "y-33": -0.297,
    "y-34": -0.297,
    "y-35": -0.297,
    "y-36": -0.297,
    "y-37": -0.297,
    "y-38": -0.296,
    "y-39": -0.296,
    "y-40": -0.296,
    "y-41": -0.296,
    "y-42": -0.294,
    "y-43": -0.294,
    "y-44": -0.294,
    "y-45": -0.294,
    "y-47": -0.294,
    "y-48": -0.294,
    "y-49": -0.294,
    "y-50": -0.294,
    "y-51": -0.294,
    "y-52": -0.294,
    "y-53": -0.294,
    "y-54": -0.294,
    "y-55": -0.294,
    "y-56": -0.294,
    "y-57": -0.294,
    "y-58": -0.294,
    "y-59": -0.294,
    "y-60": -0.294,
    "y-61": -0.294,
    "y-62": -0.294,
    "y-63": -0.294,
    "y-64": -0.294,
    "y-65": -0.294,
    "y-66": -0.294,
    "y-67": -0.294,
    "y-68": -0.294,
    "y-69": -0.294,
    "y-70": -0.294,
    "y-71": -0.294,
    "y-72": -0.294,
    "y-73": -0.294,
    "y-74": -0.294,
    "y-75": -0.294,
    "y-76": -0.294,
    "y-77": -0.294,
    "y-78": -0.294,
    "y-79": -0.294,
    "y-80": -0.294,
    "y-81": -0.294,
    "y-82": -0.299,
    "y-83": -0.299,
    "y-84": -0.299,
    "y-85": -0.299,
    "y-86": -0.299,
    "y-87": -0.299,
    "y-88": -0.299,
    "y-89": -0.299,
    "y-90": -0.299,
    "y-91": -0.299,
    "y-92": -0.299,
    "y-93": -0.299,
    "y-94": -0.299,
    "y-95": -0.299,
    "y-96": -0.299,
    "y-97": -0.299,
    "y-98": -0.299,
    "y-99": -0.299,
    "y-100": -0.299,
    "y-101": -0.299,
    "y-102": -0.299,
    "y-103": -0.299,
    "y-104": -0.299,
    "y-105": -0.299,
    "y-106": -0.299,
    "y-107": -0.299,
    "y-108": -0.299,
    "y-109": -0.299,
    "y-110": -0.299,
    "y-111": -0.299,
    "y-112": -0.299,
    "y-113": -0.299,
    "y-114": -0.299,
    "y-115": -0.299,
    "y-116": -0.299,
    "y-117": -0.299,
    "y-118": -0.299,
    "y-119": -0.299,
    "y-120": -0.299,
    "y-121": -0.299,
    "y-122": -0.299,
    "y-123": -0.299,
    "y-124": -0.299,
    "y-125": -0.299,
    "y-126": -0.299,
    "y-127": -0.299,
    "y-128": -0.299,
    "y-129": -0.299,
    "y-130": -0.299,
    "y-131": -0.299,
    "y-132": -0.299,
    "y-133": -0.299,
    "y-134": -0.299,
    "y-135": -0.299,
    "y-136": -0.299,
    "y-137": -0.299,
    "y-138": -0.299,
    "y-139": -0.299,
    "y-140": -0.299,
    "y-141": -0.299,
    "y-142": -0.299,
    "y-143": -0.299,
    "y-144": -0.299,
    "y-145": -0.299,
    "y-146": -0.299,
    "y-147": -0.299,
    "y-148": -0.299,
    "y-149": -0.299,
    "y-150": -0.299,
    "y-151": -0.299,
    "y-152": -0.299,
    "y-153": -0.299,
    "y-154": -0.299,
    "y-155": -0.299,
    "y-156": -0.299,
    "y-157": -0.299,
    "y-158": -0.299,
    "y-159": -0.299,
    "y-160": -0.299,
    "y-161": -0.299,
    "y-162": -0.299,
    "y-163": -0.299,
    "y-164": -0.299,
    "y-165": -0.299,
    "y-166": -0.299,
    "y-167": -0.299,
    "y-168": -0.299,
    "y-169": -0.299,
    "y-170": -0.299,
    "y-171": -0.299,
    "y-172": -0.299,
    "y-173": -0.299,
    "y-174": -0.299,
    "y-175": -0.299,
    "y-176": -0.299,
    "y-177": -0.299,
    "y-178": -0.299,
    "y-179": -0.299,
    "y-180": -0.299,
    "y-181": -0.299,
    "y-182": -0.299,
    "y-183": -0.299,
    "y-184": -0.299,
    "y-185": -0.299,
    "y-186": -0.299,
    "y-187": -0.299,
    "y-188": -0.299,
    "y-189": -0.299,
    "y-190": -0.299,
    "y-191": -0.299,
    "y-192": -0.299,
    "y-193": -0.299,
    "y-194": -0.299,
    "y-195": -0.299,
    "y-196": -0.299,
    "y-197": -0.299,
    "y-198": -0.299,
    "y-199": -0.299,
    "y-200": -0.299,
    "y-201": -0.299,
    "y-202": -0.299,
    "y-203": -0.299,
    "y-204": -0.299,
    "y-205": -0.299,
    "y-206": -0.299,
    "y-207": -0.299,
    "y-208": -0.299,
    "y-209": -0.299,
    "y-210": -0.299,
    "y-211": -0.299,
    "y-212": -0.299,
    "y-213": -0.299,
    "y-214": -0.299,
    "y-215": -0.299,
    "y-216": -0.299,
    "y-217": -0.299,
    "y-218": -0.299,
    "y-219": -0.299,
    "y-220": -0.299,
    "y-221": -0.299,
    "y-222": -0.299,
    "y-223": -0.299,
    "y-224": -0.299,
    "y-225": -0.299,
    "y-226": -0.299,
    "y-227": -0.299,
    "y-228": -0.299,
    "y-229": -0.299,
    "y-230": -0.299,
    "y-231": -0.299,
    "y-232": -0.299,
    "y-233": -0.299,
    "y-234": -0.299,
    "y-235": -0.299,
    "y-236": -0.299,
    "y-237": -0.299,
    "y-238": -0.299,
    "y-239": -0.299,
    "y-240": -0.299,
    "y-241": -0.299,
    "y-242": -0.299,
    "y-243": -0.299,
    "y-244": -0.299,
    "y-245": -0.299,
    "y-246": -0.299,
    "y-247": -0.299,
    "y-248": -0.299,
    "y-249": -0.299,
    "y-250": -0.299,
    "y-251": -0.299,
    "y-252": -0.299,
    "y-253": -0.299,
    "y-254": -0.299,
    "y-255": -0.299,
  },
  {
    x: 0.125,
    "y-2": -0.265,
    "y-12": -0.353,
    "y-46": -0.368,
    "y-1000": -0.373,
    "y-0": 0.042,
    "y-1": -0.409,
    "y-3": 0.068,
    "y-4": -0.172,
    "y-5": -0.277,
    "y-6": -0.281,
    "y-7": -0.286,
    "y-8": -0.304,
    "y-9": -0.304,
    "y-10": -0.342,
    "y-11": -0.353,
    "y-13": -0.353,
    "y-14": -0.373,
    "y-15": -0.369,
    "y-16": -0.369,
    "y-17": -0.369,
    "y-18": -0.369,
    "y-19": -0.369,
    "y-20": -0.371,
    "y-21": -0.371,
    "y-22": -0.371,
    "y-23": -0.371,
    "y-24": -0.371,
    "y-25": -0.371,
    "y-26": -0.37,
    "y-27": -0.37,
    "y-28": -0.37,
    "y-29": -0.37,
    "y-30": -0.37,
    "y-31": -0.37,
    "y-32": -0.37,
    "y-33": -0.37,
    "y-34": -0.371,
    "y-35": -0.371,
    "y-36": -0.371,
    "y-37": -0.371,
    "y-38": -0.369,
    "y-39": -0.369,
    "y-40": -0.369,
    "y-41": -0.369,
    "y-42": -0.368,
    "y-43": -0.368,
    "y-44": -0.368,
    "y-45": -0.368,
    "y-47": -0.368,
    "y-48": -0.368,
    "y-49": -0.368,
    "y-50": -0.368,
    "y-51": -0.368,
    "y-52": -0.368,
    "y-53": -0.368,
    "y-54": -0.368,
    "y-55": -0.368,
    "y-56": -0.368,
    "y-57": -0.368,
    "y-58": -0.368,
    "y-59": -0.368,
    "y-60": -0.368,
    "y-61": -0.368,
    "y-62": -0.368,
    "y-63": -0.368,
    "y-64": -0.368,
    "y-65": -0.368,
    "y-66": -0.368,
    "y-67": -0.368,
    "y-68": -0.368,
    "y-69": -0.368,
    "y-70": -0.368,
    "y-71": -0.368,
    "y-72": -0.368,
    "y-73": -0.368,
    "y-74": -0.368,
    "y-75": -0.368,
    "y-76": -0.368,
    "y-77": -0.368,
    "y-78": -0.368,
    "y-79": -0.368,
    "y-80": -0.368,
    "y-81": -0.368,
    "y-82": -0.376,
    "y-83": -0.376,
    "y-84": -0.376,
    "y-85": -0.376,
    "y-86": -0.376,
    "y-87": -0.376,
    "y-88": -0.376,
    "y-89": -0.376,
    "y-90": -0.376,
    "y-91": -0.376,
    "y-92": -0.376,
    "y-93": -0.376,
    "y-94": -0.376,
    "y-95": -0.376,
    "y-96": -0.376,
    "y-97": -0.376,
    "y-98": -0.375,
    "y-99": -0.375,
    "y-100": -0.376,
    "y-101": -0.375,
    "y-102": -0.376,
    "y-103": -0.376,
    "y-104": -0.376,
    "y-105": -0.376,
    "y-106": -0.375,
    "y-107": -0.373,
    "y-108": -0.373,
    "y-109": -0.373,
    "y-110": -0.373,
    "y-111": -0.373,
    "y-112": -0.373,
    "y-113": -0.373,
    "y-114": -0.373,
    "y-115": -0.373,
    "y-116": -0.373,
    "y-117": -0.373,
    "y-118": -0.373,
    "y-119": -0.373,
    "y-120": -0.373,
    "y-121": -0.373,
    "y-122": -0.373,
    "y-123": -0.373,
    "y-124": -0.374,
    "y-125": -0.374,
    "y-126": -0.374,
    "y-127": -0.374,
    "y-128": -0.374,
    "y-129": -0.374,
    "y-130": -0.374,
    "y-131": -0.374,
    "y-132": -0.374,
    "y-133": -0.374,
    "y-134": -0.374,
    "y-135": -0.374,
    "y-136": -0.374,
    "y-137": -0.374,
    "y-138": -0.374,
    "y-139": -0.374,
    "y-140": -0.374,
    "y-141": -0.374,
    "y-142": -0.374,
    "y-143": -0.374,
    "y-144": -0.374,
    "y-145": -0.374,
    "y-146": -0.374,
    "y-147": -0.374,
    "y-148": -0.374,
    "y-149": -0.374,
    "y-150": -0.374,
    "y-151": -0.374,
    "y-152": -0.374,
    "y-153": -0.374,
    "y-154": -0.374,
    "y-155": -0.374,
    "y-156": -0.374,
    "y-157": -0.374,
    "y-158": -0.374,
    "y-159": -0.374,
    "y-160": -0.374,
    "y-161": -0.374,
    "y-162": -0.374,
    "y-163": -0.374,
    "y-164": -0.374,
    "y-165": -0.374,
    "y-166": -0.374,
    "y-167": -0.374,
    "y-168": -0.374,
    "y-169": -0.374,
    "y-170": -0.374,
    "y-171": -0.373,
    "y-172": -0.373,
    "y-173": -0.373,
    "y-174": -0.373,
    "y-175": -0.373,
    "y-176": -0.373,
    "y-177": -0.373,
    "y-178": -0.373,
    "y-179": -0.373,
    "y-180": -0.373,
    "y-181": -0.373,
    "y-182": -0.373,
    "y-183": -0.373,
    "y-184": -0.373,
    "y-185": -0.373,
    "y-186": -0.373,
    "y-187": -0.373,
    "y-188": -0.373,
    "y-189": -0.373,
    "y-190": -0.373,
    "y-191": -0.373,
    "y-192": -0.373,
    "y-193": -0.373,
    "y-194": -0.373,
    "y-195": -0.373,
    "y-196": -0.373,
    "y-197": -0.373,
    "y-198": -0.373,
    "y-199": -0.373,
    "y-200": -0.373,
    "y-201": -0.373,
    "y-202": -0.373,
    "y-203": -0.373,
    "y-204": -0.373,
    "y-205": -0.373,
    "y-206": -0.373,
    "y-207": -0.373,
    "y-208": -0.373,
    "y-209": -0.373,
    "y-210": -0.373,
    "y-211": -0.373,
    "y-212": -0.373,
    "y-213": -0.373,
    "y-214": -0.373,
    "y-215": -0.373,
    "y-216": -0.373,
    "y-217": -0.373,
    "y-218": -0.373,
    "y-219": -0.373,
    "y-220": -0.373,
    "y-221": -0.373,
    "y-222": -0.373,
    "y-223": -0.373,
    "y-224": -0.373,
    "y-225": -0.373,
    "y-226": -0.373,
    "y-227": -0.373,
    "y-228": -0.373,
    "y-229": -0.373,
    "y-230": -0.373,
    "y-231": -0.373,
    "y-232": -0.373,
    "y-233": -0.373,
    "y-234": -0.373,
    "y-235": -0.373,
    "y-236": -0.373,
    "y-237": -0.373,
    "y-238": -0.373,
    "y-239": -0.373,
    "y-240": -0.373,
    "y-241": -0.373,
    "y-242": -0.373,
    "y-243": -0.373,
    "y-244": -0.373,
    "y-245": -0.373,
    "y-246": -0.373,
    "y-247": -0.373,
    "y-248": -0.373,
    "y-249": -0.373,
    "y-250": -0.373,
    "y-251": -0.373,
    "y-252": -0.373,
    "y-253": -0.373,
    "y-254": -0.373,
    "y-255": -0.373,
  },
  {
    x: 0.15,
    "y-2": -0.286,
    "y-12": -0.425,
    "y-46": -0.442,
    "y-1000": -0.446,
    "y-0": 0.03,
    "y-1": -0.434,
    "y-3": -0.008,
    "y-4": -0.233,
    "y-5": -0.331,
    "y-6": -0.336,
    "y-7": -0.34,
    "y-8": -0.357,
    "y-9": -0.357,
    "y-10": -0.412,
    "y-11": -0.424,
    "y-13": -0.425,
    "y-14": -0.447,
    "y-15": -0.443,
    "y-16": -0.443,
    "y-17": -0.443,
    "y-18": -0.443,
    "y-19": -0.443,
    "y-20": -0.445,
    "y-21": -0.445,
    "y-22": -0.445,
    "y-23": -0.445,
    "y-24": -0.445,
    "y-25": -0.445,
    "y-26": -0.444,
    "y-27": -0.444,
    "y-28": -0.444,
    "y-29": -0.444,
    "y-30": -0.444,
    "y-31": -0.444,
    "y-32": -0.444,
    "y-33": -0.444,
    "y-34": -0.444,
    "y-35": -0.444,
    "y-36": -0.444,
    "y-37": -0.444,
    "y-38": -0.443,
    "y-39": -0.443,
    "y-40": -0.443,
    "y-41": -0.443,
    "y-42": -0.442,
    "y-43": -0.442,
    "y-44": -0.442,
    "y-45": -0.442,
    "y-47": -0.442,
    "y-48": -0.442,
    "y-49": -0.442,
    "y-50": -0.442,
    "y-51": -0.442,
    "y-52": -0.442,
    "y-53": -0.442,
    "y-54": -0.442,
    "y-55": -0.442,
    "y-56": -0.442,
    "y-57": -0.442,
    "y-58": -0.442,
    "y-59": -0.442,
    "y-60": -0.442,
    "y-61": -0.442,
    "y-62": -0.442,
    "y-63": -0.442,
    "y-64": -0.442,
    "y-65": -0.442,
    "y-66": -0.442,
    "y-67": -0.442,
    "y-68": -0.442,
    "y-69": -0.442,
    "y-70": -0.442,
    "y-71": -0.442,
    "y-72": -0.442,
    "y-73": -0.442,
    "y-74": -0.442,
    "y-75": -0.442,
    "y-76": -0.442,
    "y-77": -0.442,
    "y-78": -0.442,
    "y-79": -0.444,
    "y-80": -0.441,
    "y-81": -0.442,
    "y-82": -0.448,
    "y-83": -0.448,
    "y-84": -0.449,
    "y-85": -0.448,
    "y-86": -0.448,
    "y-87": -0.45,
    "y-88": -0.449,
    "y-89": -0.448,
    "y-90": -0.449,
    "y-91": -0.448,
    "y-92": -0.45,
    "y-93": -0.448,
    "y-94": -0.45,
    "y-95": -0.448,
    "y-96": -0.45,
    "y-97": -0.45,
    "y-98": -0.447,
    "y-99": -0.447,
    "y-100": -0.448,
    "y-101": -0.448,
    "y-102": -0.449,
    "y-103": -0.45,
    "y-104": -0.45,
    "y-105": -0.448,
    "y-106": -0.447,
    "y-107": -0.447,
    "y-108": -0.447,
    "y-109": -0.447,
    "y-110": -0.447,
    "y-111": -0.447,
    "y-112": -0.447,
    "y-113": -0.447,
    "y-114": -0.447,
    "y-115": -0.447,
    "y-116": -0.447,
    "y-117": -0.447,
    "y-118": -0.447,
    "y-119": -0.447,
    "y-120": -0.447,
    "y-121": -0.447,
    "y-122": -0.447,
    "y-123": -0.447,
    "y-124": -0.447,
    "y-125": -0.447,
    "y-126": -0.447,
    "y-127": -0.447,
    "y-128": -0.447,
    "y-129": -0.447,
    "y-130": -0.447,
    "y-131": -0.447,
    "y-132": -0.447,
    "y-133": -0.447,
    "y-134": -0.447,
    "y-135": -0.447,
    "y-136": -0.447,
    "y-137": -0.447,
    "y-138": -0.447,
    "y-139": -0.447,
    "y-140": -0.447,
    "y-141": -0.447,
    "y-142": -0.447,
    "y-143": -0.447,
    "y-144": -0.447,
    "y-145": -0.447,
    "y-146": -0.447,
    "y-147": -0.447,
    "y-148": -0.447,
    "y-149": -0.447,
    "y-150": -0.447,
    "y-151": -0.447,
    "y-152": -0.447,
    "y-153": -0.447,
    "y-154": -0.447,
    "y-155": -0.447,
    "y-156": -0.447,
    "y-157": -0.447,
    "y-158": -0.447,
    "y-159": -0.447,
    "y-160": -0.447,
    "y-161": -0.447,
    "y-162": -0.447,
    "y-163": -0.447,
    "y-164": -0.447,
    "y-165": -0.447,
    "y-166": -0.447,
    "y-167": -0.447,
    "y-168": -0.447,
    "y-169": -0.447,
    "y-170": -0.447,
    "y-171": -0.447,
    "y-172": -0.447,
    "y-173": -0.447,
    "y-174": -0.447,
    "y-175": -0.447,
    "y-176": -0.447,
    "y-177": -0.447,
    "y-178": -0.447,
    "y-179": -0.447,
    "y-180": -0.447,
    "y-181": -0.447,
    "y-182": -0.447,
    "y-183": -0.447,
    "y-184": -0.447,
    "y-185": -0.447,
    "y-186": -0.447,
    "y-187": -0.447,
    "y-188": -0.447,
    "y-189": -0.447,
    "y-190": -0.447,
    "y-191": -0.447,
    "y-192": -0.447,
    "y-193": -0.447,
    "y-194": -0.447,
    "y-195": -0.447,
    "y-196": -0.447,
    "y-197": -0.447,
    "y-198": -0.447,
    "y-199": -0.446,
    "y-200": -0.446,
    "y-201": -0.446,
    "y-202": -0.446,
    "y-203": -0.446,
    "y-204": -0.446,
    "y-205": -0.446,
    "y-206": -0.446,
    "y-207": -0.446,
    "y-208": -0.446,
    "y-209": -0.447,
    "y-210": -0.447,
    "y-211": -0.447,
    "y-212": -0.447,
    "y-213": -0.447,
    "y-214": -0.447,
    "y-215": -0.447,
    "y-216": -0.447,
    "y-217": -0.447,
    "y-218": -0.447,
    "y-219": -0.447,
    "y-220": -0.447,
    "y-221": -0.447,
    "y-222": -0.447,
    "y-223": -0.447,
    "y-224": -0.447,
    "y-225": -0.447,
    "y-226": -0.447,
    "y-227": -0.447,
    "y-228": -0.447,
    "y-229": -0.447,
    "y-230": -0.447,
    "y-231": -0.447,
    "y-232": -0.447,
    "y-233": -0.447,
    "y-234": -0.447,
    "y-235": -0.447,
    "y-236": -0.447,
    "y-237": -0.447,
    "y-238": -0.447,
    "y-239": -0.447,
    "y-240": -0.447,
    "y-241": -0.447,
    "y-242": -0.447,
    "y-243": -0.447,
    "y-244": -0.447,
    "y-245": -0.447,
    "y-246": -0.447,
    "y-247": -0.447,
    "y-248": -0.447,
    "y-249": -0.447,
    "y-250": -0.447,
    "y-251": -0.447,
    "y-252": -0.447,
    "y-253": -0.447,
    "y-254": -0.447,
    "y-255": -0.447,
  },
  {
    x: 0.175,
    "y-2": -0.308,
    "y-12": -0.496,
    "y-46": -0.517,
    "y-1000": -0.52,
    "y-0": 0.018,
    "y-1": -0.458,
    "y-3": -0.084,
    "y-4": -0.294,
    "y-5": -0.386,
    "y-6": -0.39,
    "y-7": -0.394,
    "y-8": -0.411,
    "y-9": -0.411,
    "y-10": -0.482,
    "y-11": -0.496,
    "y-13": -0.496,
    "y-14": -0.52,
    "y-15": -0.516,
    "y-16": -0.516,
    "y-17": -0.516,
    "y-18": -0.516,
    "y-19": -0.516,
    "y-20": -0.518,
    "y-21": -0.518,
    "y-22": -0.518,
    "y-23": -0.518,
    "y-24": -0.518,
    "y-25": -0.518,
    "y-26": -0.518,
    "y-27": -0.518,
    "y-28": -0.518,
    "y-29": -0.518,
    "y-30": -0.518,
    "y-31": -0.518,
    "y-32": -0.518,
    "y-33": -0.518,
    "y-34": -0.518,
    "y-35": -0.518,
    "y-36": -0.518,
    "y-37": -0.518,
    "y-38": -0.516,
    "y-39": -0.516,
    "y-40": -0.516,
    "y-41": -0.516,
    "y-42": -0.517,
    "y-43": -0.517,
    "y-44": -0.517,
    "y-45": -0.517,
    "y-47": -0.517,
    "y-48": -0.517,
    "y-49": -0.517,
    "y-50": -0.517,
    "y-51": -0.517,
    "y-52": -0.517,
    "y-53": -0.517,
    "y-54": -0.517,
    "y-55": -0.517,
    "y-56": -0.517,
    "y-57": -0.517,
    "y-58": -0.517,
    "y-59": -0.517,
    "y-60": -0.517,
    "y-61": -0.517,
    "y-62": -0.517,
    "y-63": -0.517,
    "y-64": -0.517,
    "y-65": -0.517,
    "y-66": -0.517,
    "y-67": -0.517,
    "y-68": -0.517,
    "y-69": -0.517,
    "y-70": -0.517,
    "y-71": -0.517,
    "y-72": -0.517,
    "y-73": -0.517,
    "y-74": -0.517,
    "y-75": -0.517,
    "y-76": -0.517,
    "y-77": -0.517,
    "y-78": -0.517,
    "y-79": -0.519,
    "y-80": -0.516,
    "y-81": -0.516,
    "y-82": -0.521,
    "y-83": -0.52,
    "y-84": -0.522,
    "y-85": -0.521,
    "y-86": -0.521,
    "y-87": -0.523,
    "y-88": -0.52,
    "y-89": -0.52,
    "y-90": -0.521,
    "y-91": -0.52,
    "y-92": -0.522,
    "y-93": -0.521,
    "y-94": -0.524,
    "y-95": -0.52,
    "y-96": -0.522,
    "y-97": -0.522,
    "y-98": -0.519,
    "y-99": -0.519,
    "y-100": -0.52,
    "y-101": -0.52,
    "y-102": -0.52,
    "y-103": -0.523,
    "y-104": -0.522,
    "y-105": -0.52,
    "y-106": -0.519,
    "y-107": -0.52,
    "y-108": -0.52,
    "y-109": -0.52,
    "y-110": -0.52,
    "y-111": -0.52,
    "y-112": -0.52,
    "y-113": -0.52,
    "y-114": -0.52,
    "y-115": -0.52,
    "y-116": -0.52,
    "y-117": -0.52,
    "y-118": -0.52,
    "y-119": -0.52,
    "y-120": -0.52,
    "y-121": -0.52,
    "y-122": -0.52,
    "y-123": -0.52,
    "y-124": -0.52,
    "y-125": -0.52,
    "y-126": -0.52,
    "y-127": -0.52,
    "y-128": -0.52,
    "y-129": -0.52,
    "y-130": -0.52,
    "y-131": -0.52,
    "y-132": -0.52,
    "y-133": -0.52,
    "y-134": -0.52,
    "y-135": -0.52,
    "y-136": -0.52,
    "y-137": -0.52,
    "y-138": -0.52,
    "y-139": -0.52,
    "y-140": -0.52,
    "y-141": -0.52,
    "y-142": -0.52,
    "y-143": -0.52,
    "y-144": -0.52,
    "y-145": -0.52,
    "y-146": -0.52,
    "y-147": -0.52,
    "y-148": -0.52,
    "y-149": -0.52,
    "y-150": -0.52,
    "y-151": -0.52,
    "y-152": -0.52,
    "y-153": -0.52,
    "y-154": -0.52,
    "y-155": -0.52,
    "y-156": -0.52,
    "y-157": -0.52,
    "y-158": -0.52,
    "y-159": -0.52,
    "y-160": -0.52,
    "y-161": -0.52,
    "y-162": -0.52,
    "y-163": -0.52,
    "y-164": -0.52,
    "y-165": -0.52,
    "y-166": -0.52,
    "y-167": -0.52,
    "y-168": -0.52,
    "y-169": -0.52,
    "y-170": -0.52,
    "y-171": -0.52,
    "y-172": -0.52,
    "y-173": -0.52,
    "y-174": -0.52,
    "y-175": -0.52,
    "y-176": -0.52,
    "y-177": -0.52,
    "y-178": -0.52,
    "y-179": -0.52,
    "y-180": -0.52,
    "y-181": -0.52,
    "y-182": -0.52,
    "y-183": -0.52,
    "y-184": -0.52,
    "y-185": -0.52,
    "y-186": -0.52,
    "y-187": -0.52,
    "y-188": -0.52,
    "y-189": -0.52,
    "y-190": -0.52,
    "y-191": -0.52,
    "y-192": -0.52,
    "y-193": -0.52,
    "y-194": -0.52,
    "y-195": -0.52,
    "y-196": -0.52,
    "y-197": -0.52,
    "y-198": -0.52,
    "y-199": -0.519,
    "y-200": -0.519,
    "y-201": -0.519,
    "y-202": -0.519,
    "y-203": -0.519,
    "y-204": -0.519,
    "y-205": -0.519,
    "y-206": -0.519,
    "y-207": -0.519,
    "y-208": -0.519,
    "y-209": -0.52,
    "y-210": -0.52,
    "y-211": -0.52,
    "y-212": -0.52,
    "y-213": -0.52,
    "y-214": -0.52,
    "y-215": -0.52,
    "y-216": -0.52,
    "y-217": -0.52,
    "y-218": -0.52,
    "y-219": -0.52,
    "y-220": -0.52,
    "y-221": -0.52,
    "y-222": -0.52,
    "y-223": -0.52,
    "y-224": -0.52,
    "y-225": -0.52,
    "y-226": -0.52,
    "y-227": -0.52,
    "y-228": -0.52,
    "y-229": -0.52,
    "y-230": -0.52,
    "y-231": -0.52,
    "y-232": -0.52,
    "y-233": -0.52,
    "y-234": -0.52,
    "y-235": -0.52,
    "y-236": -0.52,
    "y-237": -0.52,
    "y-238": -0.52,
    "y-239": -0.52,
    "y-240": -0.52,
    "y-241": -0.52,
    "y-242": -0.52,
    "y-243": -0.52,
    "y-244": -0.52,
    "y-245": -0.52,
    "y-246": -0.52,
    "y-247": -0.52,
    "y-248": -0.52,
    "y-249": -0.52,
    "y-250": -0.52,
    "y-251": -0.52,
    "y-252": -0.52,
    "y-253": -0.52,
    "y-254": -0.52,
    "y-255": -0.52,
  },
  {
    x: 0.2,
    "y-2": -0.329,
    "y-12": -0.568,
    "y-46": -0.592,
    "y-1000": -0.592,
    "y-0": 0.006,
    "y-1": -0.483,
    "y-3": -0.159,
    "y-4": -0.355,
    "y-5": -0.441,
    "y-6": -0.444,
    "y-7": -0.448,
    "y-8": -0.464,
    "y-9": -0.464,
    "y-10": -0.552,
    "y-11": -0.568,
    "y-13": -0.568,
    "y-14": -0.594,
    "y-15": -0.59,
    "y-16": -0.59,
    "y-17": -0.59,
    "y-18": -0.59,
    "y-19": -0.59,
    "y-20": -0.592,
    "y-21": -0.592,
    "y-22": -0.592,
    "y-23": -0.592,
    "y-24": -0.592,
    "y-25": -0.592,
    "y-26": -0.591,
    "y-27": -0.591,
    "y-28": -0.591,
    "y-29": -0.591,
    "y-30": -0.591,
    "y-31": -0.591,
    "y-32": -0.591,
    "y-33": -0.591,
    "y-34": -0.592,
    "y-35": -0.592,
    "y-36": -0.592,
    "y-37": -0.592,
    "y-38": -0.59,
    "y-39": -0.59,
    "y-40": -0.59,
    "y-41": -0.59,
    "y-42": -0.592,
    "y-43": -0.592,
    "y-44": -0.592,
    "y-45": -0.592,
    "y-47": -0.592,
    "y-48": -0.592,
    "y-49": -0.592,
    "y-50": -0.592,
    "y-51": -0.592,
    "y-52": -0.592,
    "y-53": -0.592,
    "y-54": -0.592,
    "y-55": -0.592,
    "y-56": -0.592,
    "y-57": -0.592,
    "y-58": -0.592,
    "y-59": -0.592,
    "y-60": -0.592,
    "y-61": -0.592,
    "y-62": -0.592,
    "y-63": -0.592,
    "y-64": -0.592,
    "y-65": -0.592,
    "y-66": -0.592,
    "y-67": -0.592,
    "y-68": -0.592,
    "y-69": -0.592,
    "y-70": -0.592,
    "y-71": -0.592,
    "y-72": -0.592,
    "y-73": -0.592,
    "y-74": -0.592,
    "y-75": -0.592,
    "y-76": -0.592,
    "y-77": -0.592,
    "y-78": -0.592,
    "y-79": -0.592,
    "y-80": -0.592,
    "y-81": -0.592,
    "y-82": -0.592,
    "y-83": -0.592,
    "y-84": -0.592,
    "y-85": -0.592,
    "y-86": -0.592,
    "y-87": -0.592,
    "y-88": -0.592,
    "y-89": -0.592,
    "y-90": -0.592,
    "y-91": -0.592,
    "y-92": -0.592,
    "y-93": -0.592,
    "y-94": -0.592,
    "y-95": -0.592,
    "y-96": -0.592,
    "y-97": -0.592,
    "y-98": -0.592,
    "y-99": -0.592,
    "y-100": -0.592,
    "y-101": -0.592,
    "y-102": -0.592,
    "y-103": -0.592,
    "y-104": -0.592,
    "y-105": -0.592,
    "y-106": -0.592,
    "y-107": -0.592,
    "y-108": -0.592,
    "y-109": -0.592,
    "y-110": -0.592,
    "y-111": -0.592,
    "y-112": -0.592,
    "y-113": -0.592,
    "y-114": -0.592,
    "y-115": -0.592,
    "y-116": -0.592,
    "y-117": -0.592,
    "y-118": -0.592,
    "y-119": -0.592,
    "y-120": -0.592,
    "y-121": -0.592,
    "y-122": -0.592,
    "y-123": -0.592,
    "y-124": -0.592,
    "y-125": -0.592,
    "y-126": -0.592,
    "y-127": -0.592,
    "y-128": -0.592,
    "y-129": -0.592,
    "y-130": -0.592,
    "y-131": -0.592,
    "y-132": -0.592,
    "y-133": -0.592,
    "y-134": -0.592,
    "y-135": -0.592,
    "y-136": -0.592,
    "y-137": -0.592,
    "y-138": -0.592,
    "y-139": -0.592,
    "y-140": -0.592,
    "y-141": -0.592,
    "y-142": -0.592,
    "y-143": -0.592,
    "y-144": -0.592,
    "y-145": -0.592,
    "y-146": -0.592,
    "y-147": -0.592,
    "y-148": -0.592,
    "y-149": -0.592,
    "y-150": -0.592,
    "y-151": -0.592,
    "y-152": -0.592,
    "y-153": -0.592,
    "y-154": -0.592,
    "y-155": -0.592,
    "y-156": -0.592,
    "y-157": -0.592,
    "y-158": -0.592,
    "y-159": -0.592,
    "y-160": -0.592,
    "y-161": -0.592,
    "y-162": -0.592,
    "y-163": -0.592,
    "y-164": -0.592,
    "y-165": -0.592,
    "y-166": -0.592,
    "y-167": -0.592,
    "y-168": -0.592,
    "y-169": -0.592,
    "y-170": -0.592,
    "y-171": -0.592,
    "y-172": -0.592,
    "y-173": -0.592,
    "y-174": -0.592,
    "y-175": -0.592,
    "y-176": -0.592,
    "y-177": -0.592,
    "y-178": -0.592,
    "y-179": -0.592,
    "y-180": -0.592,
    "y-181": -0.592,
    "y-182": -0.592,
    "y-183": -0.592,
    "y-184": -0.592,
    "y-185": -0.592,
    "y-186": -0.592,
    "y-187": -0.592,
    "y-188": -0.592,
    "y-189": -0.592,
    "y-190": -0.592,
    "y-191": -0.592,
    "y-192": -0.592,
    "y-193": -0.592,
    "y-194": -0.592,
    "y-195": -0.592,
    "y-196": -0.592,
    "y-197": -0.592,
    "y-198": -0.592,
    "y-199": -0.592,
    "y-200": -0.592,
    "y-201": -0.592,
    "y-202": -0.592,
    "y-203": -0.592,
    "y-204": -0.592,
    "y-205": -0.592,
    "y-206": -0.592,
    "y-207": -0.592,
    "y-208": -0.592,
    "y-209": -0.592,
    "y-210": -0.592,
    "y-211": -0.592,
    "y-212": -0.592,
    "y-213": -0.592,
    "y-214": -0.592,
    "y-215": -0.592,
    "y-216": -0.592,
    "y-217": -0.592,
    "y-218": -0.592,
    "y-219": -0.592,
    "y-220": -0.592,
    "y-221": -0.592,
    "y-222": -0.592,
    "y-223": -0.592,
    "y-224": -0.592,
    "y-225": -0.592,
    "y-226": -0.592,
    "y-227": -0.592,
    "y-228": -0.592,
    "y-229": -0.592,
    "y-230": -0.592,
    "y-231": -0.592,
    "y-232": -0.592,
    "y-233": -0.592,
    "y-234": -0.592,
    "y-235": -0.592,
    "y-236": -0.592,
    "y-237": -0.592,
    "y-238": -0.592,
    "y-239": -0.592,
    "y-240": -0.592,
    "y-241": -0.592,
    "y-242": -0.592,
    "y-243": -0.592,
    "y-244": -0.592,
    "y-245": -0.592,
    "y-246": -0.592,
    "y-247": -0.592,
    "y-248": -0.592,
    "y-249": -0.592,
    "y-250": -0.592,
    "y-251": -0.592,
    "y-252": -0.592,
    "y-253": -0.592,
    "y-254": -0.592,
    "y-255": -0.592,
  },
  {
    x: 0.225,
    "y-2": -0.35,
    "y-12": -0.64,
    "y-46": -0.655,
    "y-1000": -0.664,
    "y-0": -0.006,
    "y-1": -0.507,
    "y-3": -0.235,
    "y-4": -0.416,
    "y-5": -0.495,
    "y-6": -0.499,
    "y-7": -0.503,
    "y-8": -0.517,
    "y-9": -0.517,
    "y-10": -0.622,
    "y-11": -0.64,
    "y-13": -0.64,
    "y-14": -0.666,
    "y-15": -0.663,
    "y-16": -0.663,
    "y-17": -0.663,
    "y-18": -0.663,
    "y-19": -0.663,
    "y-20": -0.665,
    "y-21": -0.665,
    "y-22": -0.665,
    "y-23": -0.665,
    "y-24": -0.665,
    "y-25": -0.665,
    "y-26": -0.664,
    "y-27": -0.664,
    "y-28": -0.664,
    "y-29": -0.664,
    "y-30": -0.664,
    "y-31": -0.664,
    "y-32": -0.664,
    "y-33": -0.664,
    "y-34": -0.664,
    "y-35": -0.664,
    "y-36": -0.664,
    "y-37": -0.664,
    "y-38": -0.663,
    "y-39": -0.663,
    "y-40": -0.663,
    "y-41": -0.663,
    "y-42": -0.666,
    "y-43": -0.666,
    "y-44": -0.666,
    "y-45": -0.665,
    "y-47": -0.671,
    "y-48": -0.672,
    "y-49": -0.664,
    "y-50": -0.661,
    "y-51": -0.665,
    "y-52": -0.67,
    "y-53": -0.671,
    "y-54": -0.665,
    "y-55": -0.664,
    "y-56": -0.665,
    "y-57": -0.657,
    "y-58": -0.663,
    "y-59": -0.663,
    "y-60": -0.667,
    "y-61": -0.664,
    "y-62": -0.665,
    "y-63": -0.665,
    "y-64": -0.665,
    "y-65": -0.665,
    "y-66": -0.667,
    "y-67": -0.667,
    "y-68": -0.664,
    "y-69": -0.664,
    "y-70": -0.665,
    "y-71": -0.665,
    "y-72": -0.666,
    "y-73": -0.661,
    "y-74": -0.663,
    "y-75": -0.663,
    "y-76": -0.667,
    "y-77": -0.666,
    "y-78": -0.666,
    "y-79": -0.663,
    "y-80": -0.665,
    "y-81": -0.665,
    "y-82": -0.662,
    "y-83": -0.663,
    "y-84": -0.662,
    "y-85": -0.663,
    "y-86": -0.661,
    "y-87": -0.662,
    "y-88": -0.664,
    "y-89": -0.663,
    "y-90": -0.662,
    "y-91": -0.663,
    "y-92": -0.661,
    "y-93": -0.663,
    "y-94": -0.659,
    "y-95": -0.663,
    "y-96": -0.661,
    "y-97": -0.663,
    "y-98": -0.664,
    "y-99": -0.665,
    "y-100": -0.664,
    "y-101": -0.663,
    "y-102": -0.664,
    "y-103": -0.662,
    "y-104": -0.663,
    "y-105": -0.662,
    "y-106": -0.662,
    "y-107": -0.663,
    "y-108": -0.664,
    "y-109": -0.664,
    "y-110": -0.663,
    "y-111": -0.663,
    "y-112": -0.664,
    "y-113": -0.663,
    "y-114": -0.664,
    "y-115": -0.663,
    "y-116": -0.663,
    "y-117": -0.663,
    "y-118": -0.664,
    "y-119": -0.663,
    "y-120": -0.663,
    "y-121": -0.663,
    "y-122": -0.663,
    "y-123": -0.663,
    "y-124": -0.663,
    "y-125": -0.663,
    "y-126": -0.663,
    "y-127": -0.663,
    "y-128": -0.663,
    "y-129": -0.663,
    "y-130": -0.663,
    "y-131": -0.663,
    "y-132": -0.663,
    "y-133": -0.663,
    "y-134": -0.663,
    "y-135": -0.663,
    "y-136": -0.663,
    "y-137": -0.663,
    "y-138": -0.663,
    "y-139": -0.663,
    "y-140": -0.663,
    "y-141": -0.663,
    "y-142": -0.663,
    "y-143": -0.663,
    "y-144": -0.663,
    "y-145": -0.663,
    "y-146": -0.663,
    "y-147": -0.663,
    "y-148": -0.663,
    "y-149": -0.663,
    "y-150": -0.663,
    "y-151": -0.663,
    "y-152": -0.663,
    "y-153": -0.663,
    "y-154": -0.663,
    "y-155": -0.663,
    "y-156": -0.663,
    "y-157": -0.663,
    "y-158": -0.663,
    "y-159": -0.663,
    "y-160": -0.663,
    "y-161": -0.663,
    "y-162": -0.663,
    "y-163": -0.663,
    "y-164": -0.663,
    "y-165": -0.663,
    "y-166": -0.663,
    "y-167": -0.663,
    "y-168": -0.664,
    "y-169": -0.664,
    "y-170": -0.664,
    "y-171": -0.664,
    "y-172": -0.664,
    "y-173": -0.664,
    "y-174": -0.664,
    "y-175": -0.664,
    "y-176": -0.664,
    "y-177": -0.664,
    "y-178": -0.664,
    "y-179": -0.664,
    "y-180": -0.664,
    "y-181": -0.664,
    "y-182": -0.664,
    "y-183": -0.664,
    "y-184": -0.664,
    "y-185": -0.664,
    "y-186": -0.664,
    "y-187": -0.664,
    "y-188": -0.664,
    "y-189": -0.664,
    "y-190": -0.664,
    "y-191": -0.664,
    "y-192": -0.664,
    "y-193": -0.664,
    "y-194": -0.664,
    "y-195": -0.664,
    "y-196": -0.664,
    "y-197": -0.664,
    "y-198": -0.664,
    "y-199": -0.664,
    "y-200": -0.664,
    "y-201": -0.664,
    "y-202": -0.664,
    "y-203": -0.664,
    "y-204": -0.664,
    "y-205": -0.664,
    "y-206": -0.664,
    "y-207": -0.664,
    "y-208": -0.664,
    "y-209": -0.663,
    "y-210": -0.663,
    "y-211": -0.663,
    "y-212": -0.663,
    "y-213": -0.663,
    "y-214": -0.663,
    "y-215": -0.663,
    "y-216": -0.663,
    "y-217": -0.663,
    "y-218": -0.663,
    "y-219": -0.663,
    "y-220": -0.663,
    "y-221": -0.663,
    "y-222": -0.663,
    "y-223": -0.663,
    "y-224": -0.663,
    "y-225": -0.663,
    "y-226": -0.663,
    "y-227": -0.663,
    "y-228": -0.663,
    "y-229": -0.663,
    "y-230": -0.663,
    "y-231": -0.663,
    "y-232": -0.663,
    "y-233": -0.663,
    "y-234": -0.663,
    "y-235": -0.663,
    "y-236": -0.663,
    "y-237": -0.663,
    "y-238": -0.663,
    "y-239": -0.663,
    "y-240": -0.663,
    "y-241": -0.663,
    "y-242": -0.663,
    "y-243": -0.663,
    "y-244": -0.663,
    "y-245": -0.663,
    "y-246": -0.663,
    "y-247": -0.663,
    "y-248": -0.663,
    "y-249": -0.663,
    "y-250": -0.663,
    "y-251": -0.663,
    "y-252": -0.663,
    "y-253": -0.663,
    "y-254": -0.663,
    "y-255": -0.663,
  },
  {
    x: 0.25,
    "y-2": -0.372,
    "y-12": -0.712,
    "y-46": -0.728,
    "y-1000": -0.735,
    "y-0": -0.019,
    "y-1": -0.532,
    "y-3": -0.311,
    "y-4": -0.477,
    "y-5": -0.55,
    "y-6": -0.553,
    "y-7": -0.557,
    "y-8": -0.57,
    "y-9": -0.57,
    "y-10": -0.692,
    "y-11": -0.711,
    "y-13": -0.712,
    "y-14": -0.731,
    "y-15": -0.733,
    "y-16": -0.733,
    "y-17": -0.733,
    "y-18": -0.733,
    "y-19": -0.733,
    "y-20": -0.732,
    "y-21": -0.732,
    "y-22": -0.732,
    "y-23": -0.732,
    "y-24": -0.732,
    "y-25": -0.732,
    "y-26": -0.732,
    "y-27": -0.732,
    "y-28": -0.732,
    "y-29": -0.732,
    "y-30": -0.732,
    "y-31": -0.732,
    "y-32": -0.732,
    "y-33": -0.732,
    "y-34": -0.732,
    "y-35": -0.732,
    "y-36": -0.732,
    "y-37": -0.732,
    "y-38": -0.733,
    "y-39": -0.733,
    "y-40": -0.733,
    "y-41": -0.733,
    "y-42": -0.735,
    "y-43": -0.735,
    "y-44": -0.735,
    "y-45": -0.735,
    "y-47": -0.738,
    "y-48": -0.739,
    "y-49": -0.734,
    "y-50": -0.732,
    "y-51": -0.734,
    "y-52": -0.737,
    "y-53": -0.739,
    "y-54": -0.734,
    "y-55": -0.734,
    "y-56": -0.734,
    "y-57": -0.729,
    "y-58": -0.733,
    "y-59": -0.733,
    "y-60": -0.736,
    "y-61": -0.734,
    "y-62": -0.735,
    "y-63": -0.735,
    "y-64": -0.734,
    "y-65": -0.735,
    "y-66": -0.736,
    "y-67": -0.736,
    "y-68": -0.734,
    "y-69": -0.733,
    "y-70": -0.734,
    "y-71": -0.734,
    "y-72": -0.735,
    "y-73": -0.732,
    "y-74": -0.733,
    "y-75": -0.733,
    "y-76": -0.736,
    "y-77": -0.735,
    "y-78": -0.735,
    "y-79": -0.733,
    "y-80": -0.734,
    "y-81": -0.735,
    "y-82": -0.733,
    "y-83": -0.733,
    "y-84": -0.732,
    "y-85": -0.733,
    "y-86": -0.732,
    "y-87": -0.732,
    "y-88": -0.733,
    "y-89": -0.733,
    "y-90": -0.733,
    "y-91": -0.733,
    "y-92": -0.732,
    "y-93": -0.733,
    "y-94": -0.731,
    "y-95": -0.733,
    "y-96": -0.732,
    "y-97": -0.733,
    "y-98": -0.734,
    "y-99": -0.734,
    "y-100": -0.734,
    "y-101": -0.733,
    "y-102": -0.734,
    "y-103": -0.732,
    "y-104": -0.733,
    "y-105": -0.732,
    "y-106": -0.732,
    "y-107": -0.733,
    "y-108": -0.734,
    "y-109": -0.734,
    "y-110": -0.733,
    "y-111": -0.733,
    "y-112": -0.733,
    "y-113": -0.733,
    "y-114": -0.733,
    "y-115": -0.733,
    "y-116": -0.733,
    "y-117": -0.733,
    "y-118": -0.733,
    "y-119": -0.733,
    "y-120": -0.733,
    "y-121": -0.733,
    "y-122": -0.733,
    "y-123": -0.733,
    "y-124": -0.733,
    "y-125": -0.733,
    "y-126": -0.733,
    "y-127": -0.733,
    "y-128": -0.733,
    "y-129": -0.733,
    "y-130": -0.733,
    "y-131": -0.733,
    "y-132": -0.733,
    "y-133": -0.733,
    "y-134": -0.733,
    "y-135": -0.733,
    "y-136": -0.733,
    "y-137": -0.733,
    "y-138": -0.733,
    "y-139": -0.733,
    "y-140": -0.733,
    "y-141": -0.733,
    "y-142": -0.733,
    "y-143": -0.733,
    "y-144": -0.733,
    "y-145": -0.733,
    "y-146": -0.733,
    "y-147": -0.733,
    "y-148": -0.733,
    "y-149": -0.733,
    "y-150": -0.733,
    "y-151": -0.733,
    "y-152": -0.733,
    "y-153": -0.733,
    "y-154": -0.733,
    "y-155": -0.733,
    "y-156": -0.733,
    "y-157": -0.733,
    "y-158": -0.733,
    "y-159": -0.733,
    "y-160": -0.733,
    "y-161": -0.733,
    "y-162": -0.733,
    "y-163": -0.733,
    "y-164": -0.733,
    "y-165": -0.733,
    "y-166": -0.733,
    "y-167": -0.733,
    "y-168": -0.734,
    "y-169": -0.734,
    "y-170": -0.734,
    "y-171": -0.734,
    "y-172": -0.734,
    "y-173": -0.734,
    "y-174": -0.734,
    "y-175": -0.734,
    "y-176": -0.734,
    "y-177": -0.734,
    "y-178": -0.734,
    "y-179": -0.734,
    "y-180": -0.734,
    "y-181": -0.734,
    "y-182": -0.734,
    "y-183": -0.734,
    "y-184": -0.734,
    "y-185": -0.734,
    "y-186": -0.734,
    "y-187": -0.734,
    "y-188": -0.734,
    "y-189": -0.734,
    "y-190": -0.734,
    "y-191": -0.734,
    "y-192": -0.734,
    "y-193": -0.734,
    "y-194": -0.734,
    "y-195": -0.734,
    "y-196": -0.734,
    "y-197": -0.734,
    "y-198": -0.734,
    "y-199": -0.734,
    "y-200": -0.734,
    "y-201": -0.734,
    "y-202": -0.734,
    "y-203": -0.734,
    "y-204": -0.734,
    "y-205": -0.734,
    "y-206": -0.734,
    "y-207": -0.734,
    "y-208": -0.734,
    "y-209": -0.734,
    "y-210": -0.734,
    "y-211": -0.734,
    "y-212": -0.734,
    "y-213": -0.734,
    "y-214": -0.734,
    "y-215": -0.734,
    "y-216": -0.734,
    "y-217": -0.734,
    "y-218": -0.734,
    "y-219": -0.734,
    "y-220": -0.734,
    "y-221": -0.734,
    "y-222": -0.734,
    "y-223": -0.734,
    "y-224": -0.734,
    "y-225": -0.734,
    "y-226": -0.734,
    "y-227": -0.734,
    "y-228": -0.734,
    "y-229": -0.734,
    "y-230": -0.734,
    "y-231": -0.734,
    "y-232": -0.734,
    "y-233": -0.734,
    "y-234": -0.734,
    "y-235": -0.734,
    "y-236": -0.734,
    "y-237": -0.734,
    "y-238": -0.734,
    "y-239": -0.734,
    "y-240": -0.734,
    "y-241": -0.734,
    "y-242": -0.734,
    "y-243": -0.734,
    "y-244": -0.734,
    "y-245": -0.734,
    "y-246": -0.734,
    "y-247": -0.734,
    "y-248": -0.734,
    "y-249": -0.734,
    "y-250": -0.734,
    "y-251": -0.734,
    "y-252": -0.734,
    "y-253": -0.734,
    "y-254": -0.734,
    "y-255": -0.734,
  },
  {
    x: 0.275,
    "y-2": -0.393,
    "y-12": -0.784,
    "y-46": -0.8,
    "y-1000": -0.805,
    "y-0": -0.031,
    "y-1": -0.557,
    "y-3": -0.387,
    "y-4": -0.538,
    "y-5": -0.605,
    "y-6": -0.608,
    "y-7": -0.611,
    "y-8": -0.623,
    "y-9": -0.623,
    "y-10": -0.762,
    "y-11": -0.783,
    "y-13": -0.784,
    "y-14": -0.795,
    "y-15": -0.803,
    "y-16": -0.803,
    "y-17": -0.803,
    "y-18": -0.803,
    "y-19": -0.803,
    "y-20": -0.799,
    "y-21": -0.799,
    "y-22": -0.799,
    "y-23": -0.799,
    "y-24": -0.799,
    "y-25": -0.799,
    "y-26": -0.801,
    "y-27": -0.801,
    "y-28": -0.801,
    "y-29": -0.801,
    "y-30": -0.801,
    "y-31": -0.801,
    "y-32": -0.801,
    "y-33": -0.801,
    "y-34": -0.8,
    "y-35": -0.8,
    "y-36": -0.8,
    "y-37": -0.8,
    "y-38": -0.803,
    "y-39": -0.803,
    "y-40": -0.803,
    "y-41": -0.803,
    "y-42": -0.804,
    "y-43": -0.804,
    "y-44": -0.804,
    "y-45": -0.804,
    "y-47": -0.806,
    "y-48": -0.806,
    "y-49": -0.803,
    "y-50": -0.802,
    "y-51": -0.804,
    "y-52": -0.805,
    "y-53": -0.806,
    "y-54": -0.804,
    "y-55": -0.803,
    "y-56": -0.804,
    "y-57": -0.801,
    "y-58": -0.803,
    "y-59": -0.803,
    "y-60": -0.804,
    "y-61": -0.803,
    "y-62": -0.804,
    "y-63": -0.804,
    "y-64": -0.804,
    "y-65": -0.804,
    "y-66": -0.804,
    "y-67": -0.804,
    "y-68": -0.803,
    "y-69": -0.803,
    "y-70": -0.804,
    "y-71": -0.804,
    "y-72": -0.804,
    "y-73": -0.802,
    "y-74": -0.803,
    "y-75": -0.803,
    "y-76": -0.804,
    "y-77": -0.804,
    "y-78": -0.804,
    "y-79": -0.803,
    "y-80": -0.804,
    "y-81": -0.804,
    "y-82": -0.803,
    "y-83": -0.803,
    "y-84": -0.803,
    "y-85": -0.803,
    "y-86": -0.802,
    "y-87": -0.803,
    "y-88": -0.803,
    "y-89": -0.803,
    "y-90": -0.803,
    "y-91": -0.803,
    "y-92": -0.802,
    "y-93": -0.803,
    "y-94": -0.802,
    "y-95": -0.803,
    "y-96": -0.802,
    "y-97": -0.803,
    "y-98": -0.803,
    "y-99": -0.804,
    "y-100": -0.803,
    "y-101": -0.803,
    "y-102": -0.803,
    "y-103": -0.803,
    "y-104": -0.803,
    "y-105": -0.803,
    "y-106": -0.803,
    "y-107": -0.803,
    "y-108": -0.803,
    "y-109": -0.803,
    "y-110": -0.803,
    "y-111": -0.803,
    "y-112": -0.803,
    "y-113": -0.803,
    "y-114": -0.803,
    "y-115": -0.803,
    "y-116": -0.803,
    "y-117": -0.803,
    "y-118": -0.803,
    "y-119": -0.803,
    "y-120": -0.803,
    "y-121": -0.803,
    "y-122": -0.803,
    "y-123": -0.803,
    "y-124": -0.803,
    "y-125": -0.803,
    "y-126": -0.803,
    "y-127": -0.803,
    "y-128": -0.803,
    "y-129": -0.803,
    "y-130": -0.803,
    "y-131": -0.803,
    "y-132": -0.803,
    "y-133": -0.803,
    "y-134": -0.803,
    "y-135": -0.803,
    "y-136": -0.803,
    "y-137": -0.803,
    "y-138": -0.803,
    "y-139": -0.803,
    "y-140": -0.803,
    "y-141": -0.803,
    "y-142": -0.803,
    "y-143": -0.803,
    "y-144": -0.803,
    "y-145": -0.803,
    "y-146": -0.803,
    "y-147": -0.803,
    "y-148": -0.803,
    "y-149": -0.803,
    "y-150": -0.803,
    "y-151": -0.803,
    "y-152": -0.803,
    "y-153": -0.803,
    "y-154": -0.803,
    "y-155": -0.803,
    "y-156": -0.804,
    "y-157": -0.804,
    "y-158": -0.804,
    "y-159": -0.804,
    "y-160": -0.804,
    "y-161": -0.804,
    "y-162": -0.804,
    "y-163": -0.804,
    "y-164": -0.804,
    "y-165": -0.804,
    "y-166": -0.804,
    "y-167": -0.804,
    "y-168": -0.804,
    "y-169": -0.804,
    "y-170": -0.804,
    "y-171": -0.804,
    "y-172": -0.804,
    "y-173": -0.804,
    "y-174": -0.804,
    "y-175": -0.804,
    "y-176": -0.804,
    "y-177": -0.804,
    "y-178": -0.804,
    "y-179": -0.804,
    "y-180": -0.804,
    "y-181": -0.804,
    "y-182": -0.804,
    "y-183": -0.804,
    "y-184": -0.804,
    "y-185": -0.804,
    "y-186": -0.804,
    "y-187": -0.804,
    "y-188": -0.804,
    "y-189": -0.804,
    "y-190": -0.804,
    "y-191": -0.804,
    "y-192": -0.804,
    "y-193": -0.804,
    "y-194": -0.804,
    "y-195": -0.804,
    "y-196": -0.804,
    "y-197": -0.804,
    "y-198": -0.804,
    "y-199": -0.804,
    "y-200": -0.804,
    "y-201": -0.804,
    "y-202": -0.804,
    "y-203": -0.804,
    "y-204": -0.804,
    "y-205": -0.804,
    "y-206": -0.804,
    "y-207": -0.804,
    "y-208": -0.804,
    "y-209": -0.804,
    "y-210": -0.804,
    "y-211": -0.804,
    "y-212": -0.804,
    "y-213": -0.804,
    "y-214": -0.804,
    "y-215": -0.804,
    "y-216": -0.804,
    "y-217": -0.804,
    "y-218": -0.804,
    "y-219": -0.804,
    "y-220": -0.804,
    "y-221": -0.804,
    "y-222": -0.804,
    "y-223": -0.804,
    "y-224": -0.804,
    "y-225": -0.804,
    "y-226": -0.804,
    "y-227": -0.804,
    "y-228": -0.804,
    "y-229": -0.804,
    "y-230": -0.804,
    "y-231": -0.804,
    "y-232": -0.804,
    "y-233": -0.804,
    "y-234": -0.804,
    "y-235": -0.804,
    "y-236": -0.804,
    "y-237": -0.804,
    "y-238": -0.804,
    "y-239": -0.804,
    "y-240": -0.804,
    "y-241": -0.804,
    "y-242": -0.804,
    "y-243": -0.804,
    "y-244": -0.804,
    "y-245": -0.804,
    "y-246": -0.804,
    "y-247": -0.804,
    "y-248": -0.804,
    "y-249": -0.804,
    "y-250": -0.804,
    "y-251": -0.804,
    "y-252": -0.804,
    "y-253": -0.804,
    "y-254": -0.804,
    "y-255": -0.804,
  },
  {
    x: 0.3,
    "y-2": -0.414,
    "y-12": -0.855,
    "y-46": -0.873,
    "y-1000": -0.873,
    "y-0": -0.043,
    "y-1": -0.581,
    "y-3": -0.462,
    "y-4": -0.599,
    "y-5": -0.659,
    "y-6": -0.662,
    "y-7": -0.665,
    "y-8": -0.677,
    "y-9": -0.677,
    "y-10": -0.832,
    "y-11": -0.855,
    "y-13": -0.855,
    "y-14": -0.86,
    "y-15": -0.873,
    "y-16": -0.873,
    "y-17": -0.873,
    "y-18": -0.873,
    "y-19": -0.873,
    "y-20": -0.867,
    "y-21": -0.867,
    "y-22": -0.867,
    "y-23": -0.867,
    "y-24": -0.867,
    "y-25": -0.867,
    "y-26": -0.869,
    "y-27": -0.869,
    "y-28": -0.869,
    "y-29": -0.869,
    "y-30": -0.869,
    "y-31": -0.869,
    "y-32": -0.869,
    "y-33": -0.869,
    "y-34": -0.868,
    "y-35": -0.868,
    "y-36": -0.868,
    "y-37": -0.868,
    "y-38": -0.873,
    "y-39": -0.873,
    "y-40": -0.873,
    "y-41": -0.873,
    "y-42": -0.873,
    "y-43": -0.873,
    "y-44": -0.873,
    "y-45": -0.873,
    "y-47": -0.873,
    "y-48": -0.873,
    "y-49": -0.873,
    "y-50": -0.873,
    "y-51": -0.873,
    "y-52": -0.873,
    "y-53": -0.873,
    "y-54": -0.873,
    "y-55": -0.873,
    "y-56": -0.873,
    "y-57": -0.873,
    "y-58": -0.873,
    "y-59": -0.873,
    "y-60": -0.873,
    "y-61": -0.873,
    "y-62": -0.873,
    "y-63": -0.873,
    "y-64": -0.873,
    "y-65": -0.873,
    "y-66": -0.873,
    "y-67": -0.873,
    "y-68": -0.873,
    "y-69": -0.873,
    "y-70": -0.873,
    "y-71": -0.873,
    "y-72": -0.873,
    "y-73": -0.873,
    "y-74": -0.873,
    "y-75": -0.873,
    "y-76": -0.873,
    "y-77": -0.873,
    "y-78": -0.873,
    "y-79": -0.873,
    "y-80": -0.873,
    "y-81": -0.873,
    "y-82": -0.873,
    "y-83": -0.873,
    "y-84": -0.873,
    "y-85": -0.873,
    "y-86": -0.873,
    "y-87": -0.873,
    "y-88": -0.873,
    "y-89": -0.873,
    "y-90": -0.873,
    "y-91": -0.873,
    "y-92": -0.873,
    "y-93": -0.873,
    "y-94": -0.873,
    "y-95": -0.873,
    "y-96": -0.873,
    "y-97": -0.873,
    "y-98": -0.873,
    "y-99": -0.873,
    "y-100": -0.873,
    "y-101": -0.873,
    "y-102": -0.873,
    "y-103": -0.873,
    "y-104": -0.873,
    "y-105": -0.873,
    "y-106": -0.873,
    "y-107": -0.873,
    "y-108": -0.873,
    "y-109": -0.873,
    "y-110": -0.873,
    "y-111": -0.873,
    "y-112": -0.873,
    "y-113": -0.873,
    "y-114": -0.873,
    "y-115": -0.873,
    "y-116": -0.873,
    "y-117": -0.873,
    "y-118": -0.873,
    "y-119": -0.873,
    "y-120": -0.873,
    "y-121": -0.873,
    "y-122": -0.873,
    "y-123": -0.873,
    "y-124": -0.873,
    "y-125": -0.873,
    "y-126": -0.873,
    "y-127": -0.873,
    "y-128": -0.873,
    "y-129": -0.873,
    "y-130": -0.873,
    "y-131": -0.873,
    "y-132": -0.873,
    "y-133": -0.873,
    "y-134": -0.873,
    "y-135": -0.873,
    "y-136": -0.873,
    "y-137": -0.873,
    "y-138": -0.873,
    "y-139": -0.873,
    "y-140": -0.873,
    "y-141": -0.873,
    "y-142": -0.873,
    "y-143": -0.873,
    "y-144": -0.873,
    "y-145": -0.873,
    "y-146": -0.873,
    "y-147": -0.873,
    "y-148": -0.873,
    "y-149": -0.873,
    "y-150": -0.873,
    "y-151": -0.873,
    "y-152": -0.873,
    "y-153": -0.873,
    "y-154": -0.873,
    "y-155": -0.873,
    "y-156": -0.873,
    "y-157": -0.873,
    "y-158": -0.873,
    "y-159": -0.873,
    "y-160": -0.873,
    "y-161": -0.873,
    "y-162": -0.873,
    "y-163": -0.873,
    "y-164": -0.873,
    "y-165": -0.873,
    "y-166": -0.873,
    "y-167": -0.873,
    "y-168": -0.873,
    "y-169": -0.873,
    "y-170": -0.873,
    "y-171": -0.873,
    "y-172": -0.873,
    "y-173": -0.873,
    "y-174": -0.873,
    "y-175": -0.873,
    "y-176": -0.873,
    "y-177": -0.873,
    "y-178": -0.873,
    "y-179": -0.873,
    "y-180": -0.873,
    "y-181": -0.873,
    "y-182": -0.873,
    "y-183": -0.873,
    "y-184": -0.873,
    "y-185": -0.873,
    "y-186": -0.873,
    "y-187": -0.873,
    "y-188": -0.873,
    "y-189": -0.873,
    "y-190": -0.873,
    "y-191": -0.873,
    "y-192": -0.873,
    "y-193": -0.873,
    "y-194": -0.873,
    "y-195": -0.873,
    "y-196": -0.873,
    "y-197": -0.873,
    "y-198": -0.873,
    "y-199": -0.873,
    "y-200": -0.873,
    "y-201": -0.873,
    "y-202": -0.873,
    "y-203": -0.873,
    "y-204": -0.873,
    "y-205": -0.873,
    "y-206": -0.873,
    "y-207": -0.873,
    "y-208": -0.873,
    "y-209": -0.873,
    "y-210": -0.873,
    "y-211": -0.873,
    "y-212": -0.873,
    "y-213": -0.873,
    "y-214": -0.873,
    "y-215": -0.873,
    "y-216": -0.873,
    "y-217": -0.873,
    "y-218": -0.873,
    "y-219": -0.873,
    "y-220": -0.873,
    "y-221": -0.873,
    "y-222": -0.873,
    "y-223": -0.873,
    "y-224": -0.873,
    "y-225": -0.873,
    "y-226": -0.873,
    "y-227": -0.873,
    "y-228": -0.873,
    "y-229": -0.873,
    "y-230": -0.873,
    "y-231": -0.873,
    "y-232": -0.873,
    "y-233": -0.873,
    "y-234": -0.873,
    "y-235": -0.873,
    "y-236": -0.873,
    "y-237": -0.873,
    "y-238": -0.873,
    "y-239": -0.873,
    "y-240": -0.873,
    "y-241": -0.873,
    "y-242": -0.873,
    "y-243": -0.873,
    "y-244": -0.873,
    "y-245": -0.873,
    "y-246": -0.873,
    "y-247": -0.873,
    "y-248": -0.873,
    "y-249": -0.873,
    "y-250": -0.873,
    "y-251": -0.873,
    "y-252": -0.873,
    "y-253": -0.873,
    "y-254": -0.873,
    "y-255": -0.873,
  },
  {
    x: 0.325,
    "y-2": -0.435,
    "y-12": -0.927,
    "y-46": -0.946,
    "y-1000": -0.94,
    "y-0": -0.055,
    "y-1": -0.606,
    "y-3": -0.538,
    "y-4": -0.66,
    "y-5": -0.714,
    "y-6": -0.717,
    "y-7": -0.719,
    "y-8": -0.73,
    "y-9": -0.73,
    "y-10": -0.902,
    "y-11": -0.927,
    "y-13": -0.927,
    "y-14": -0.924,
    "y-15": -0.943,
    "y-16": -0.943,
    "y-17": -0.943,
    "y-18": -0.944,
    "y-19": -0.944,
    "y-20": -0.934,
    "y-21": -0.934,
    "y-22": -0.934,
    "y-23": -0.934,
    "y-24": -0.934,
    "y-25": -0.934,
    "y-26": -0.938,
    "y-27": -0.938,
    "y-28": -0.938,
    "y-29": -0.938,
    "y-30": -0.938,
    "y-31": -0.938,
    "y-32": -0.938,
    "y-33": -0.938,
    "y-34": -0.935,
    "y-35": -0.935,
    "y-36": -0.935,
    "y-37": -0.935,
    "y-38": -0.943,
    "y-39": -0.943,
    "y-40": -0.943,
    "y-41": -0.943,
    "y-42": -0.942,
    "y-43": -0.942,
    "y-44": -0.942,
    "y-45": -0.942,
    "y-47": -0.94,
    "y-48": -0.94,
    "y-49": -0.943,
    "y-50": -0.944,
    "y-51": -0.942,
    "y-52": -0.941,
    "y-53": -0.94,
    "y-54": -0.942,
    "y-55": -0.943,
    "y-56": -0.942,
    "y-57": -0.945,
    "y-58": -0.943,
    "y-59": -0.943,
    "y-60": -0.942,
    "y-61": -0.943,
    "y-62": -0.942,
    "y-63": -0.942,
    "y-64": -0.942,
    "y-65": -0.942,
    "y-66": -0.942,
    "y-67": -0.942,
    "y-68": -0.943,
    "y-69": -0.943,
    "y-70": -0.942,
    "y-71": -0.942,
    "y-72": -0.942,
    "y-73": -0.944,
    "y-74": -0.943,
    "y-75": -0.943,
    "y-76": -0.942,
    "y-77": -0.942,
    "y-78": -0.942,
    "y-79": -0.943,
    "y-80": -0.942,
    "y-81": -0.942,
    "y-82": -0.943,
    "y-83": -0.943,
    "y-84": -0.943,
    "y-85": -0.943,
    "y-86": -0.944,
    "y-87": -0.943,
    "y-88": -0.943,
    "y-89": -0.943,
    "y-90": -0.943,
    "y-91": -0.943,
    "y-92": -0.944,
    "y-93": -0.943,
    "y-94": -0.944,
    "y-95": -0.943,
    "y-96": -0.944,
    "y-97": -0.943,
    "y-98": -0.943,
    "y-99": -0.942,
    "y-100": -0.943,
    "y-101": -0.943,
    "y-102": -0.943,
    "y-103": -0.943,
    "y-104": -0.943,
    "y-105": -0.943,
    "y-106": -0.943,
    "y-107": -0.943,
    "y-108": -0.943,
    "y-109": -0.943,
    "y-110": -0.943,
    "y-111": -0.943,
    "y-112": -0.943,
    "y-113": -0.943,
    "y-114": -0.943,
    "y-115": -0.943,
    "y-116": -0.943,
    "y-117": -0.943,
    "y-118": -0.943,
    "y-119": -0.943,
    "y-120": -0.943,
    "y-121": -0.943,
    "y-122": -0.943,
    "y-123": -0.943,
    "y-124": -0.943,
    "y-125": -0.943,
    "y-126": -0.943,
    "y-127": -0.943,
    "y-128": -0.943,
    "y-129": -0.943,
    "y-130": -0.943,
    "y-131": -0.943,
    "y-132": -0.943,
    "y-133": -0.943,
    "y-134": -0.943,
    "y-135": -0.943,
    "y-136": -0.943,
    "y-137": -0.943,
    "y-138": -0.943,
    "y-139": -0.943,
    "y-140": -0.943,
    "y-141": -0.943,
    "y-142": -0.942,
    "y-143": -0.942,
    "y-144": -0.942,
    "y-145": -0.942,
    "y-146": -0.942,
    "y-147": -0.942,
    "y-148": -0.942,
    "y-149": -0.942,
    "y-150": -0.942,
    "y-151": -0.942,
    "y-152": -0.942,
    "y-153": -0.942,
    "y-154": -0.942,
    "y-155": -0.942,
    "y-156": -0.942,
    "y-157": -0.942,
    "y-158": -0.942,
    "y-159": -0.942,
    "y-160": -0.942,
    "y-161": -0.942,
    "y-162": -0.942,
    "y-163": -0.942,
    "y-164": -0.942,
    "y-165": -0.942,
    "y-166": -0.942,
    "y-167": -0.942,
    "y-168": -0.942,
    "y-169": -0.942,
    "y-170": -0.942,
    "y-171": -0.942,
    "y-172": -0.942,
    "y-173": -0.942,
    "y-174": -0.942,
    "y-175": -0.942,
    "y-176": -0.942,
    "y-177": -0.942,
    "y-178": -0.942,
    "y-179": -0.942,
    "y-180": -0.942,
    "y-181": -0.942,
    "y-182": -0.942,
    "y-183": -0.942,
    "y-184": -0.942,
    "y-185": -0.942,
    "y-186": -0.942,
    "y-187": -0.942,
    "y-188": -0.942,
    "y-189": -0.942,
    "y-190": -0.942,
    "y-191": -0.942,
    "y-192": -0.942,
    "y-193": -0.942,
    "y-194": -0.942,
    "y-195": -0.942,
    "y-196": -0.942,
    "y-197": -0.942,
    "y-198": -0.942,
    "y-199": -0.942,
    "y-200": -0.942,
    "y-201": -0.942,
    "y-202": -0.942,
    "y-203": -0.942,
    "y-204": -0.942,
    "y-205": -0.942,
    "y-206": -0.942,
    "y-207": -0.942,
    "y-208": -0.942,
    "y-209": -0.941,
    "y-210": -0.941,
    "y-211": -0.941,
    "y-212": -0.941,
    "y-213": -0.941,
    "y-214": -0.941,
    "y-215": -0.941,
    "y-216": -0.941,
    "y-217": -0.941,
    "y-218": -0.941,
    "y-219": -0.941,
    "y-220": -0.941,
    "y-221": -0.941,
    "y-222": -0.941,
    "y-223": -0.941,
    "y-224": -0.941,
    "y-225": -0.941,
    "y-226": -0.941,
    "y-227": -0.941,
    "y-228": -0.941,
    "y-229": -0.941,
    "y-230": -0.941,
    "y-231": -0.941,
    "y-232": -0.941,
    "y-233": -0.941,
    "y-234": -0.941,
    "y-235": -0.941,
    "y-236": -0.941,
    "y-237": -0.941,
    "y-238": -0.941,
    "y-239": -0.941,
    "y-240": -0.941,
    "y-241": -0.941,
    "y-242": -0.941,
    "y-243": -0.941,
    "y-244": -0.941,
    "y-245": -0.941,
    "y-246": -0.941,
    "y-247": -0.941,
    "y-248": -0.941,
    "y-249": -0.941,
    "y-250": -0.941,
    "y-251": -0.941,
    "y-252": -0.941,
    "y-253": -0.942,
    "y-254": -0.942,
    "y-255": -0.942,
  },
  {
    x: 0.35,
    "y-2": -0.457,
    "y-12": -0.999,
    "y-46": -1.015,
    "y-1000": -1.007,
    "y-0": -0.067,
    "y-1": -0.63,
    "y-3": -0.614,
    "y-4": -0.72,
    "y-5": -0.769,
    "y-6": -0.771,
    "y-7": -0.773,
    "y-8": -0.783,
    "y-9": -0.783,
    "y-10": -0.972,
    "y-11": -0.998,
    "y-13": -0.999,
    "y-14": -0.988,
    "y-15": -1.013,
    "y-16": -1.013,
    "y-17": -1.013,
    "y-18": -1.014,
    "y-19": -1.014,
    "y-20": -1.002,
    "y-21": -1.002,
    "y-22": -1.002,
    "y-23": -1.002,
    "y-24": -1.002,
    "y-25": -1.002,
    "y-26": -1.006,
    "y-27": -1.006,
    "y-28": -1.006,
    "y-29": -1.006,
    "y-30": -1.006,
    "y-31": -1.006,
    "y-32": -1.006,
    "y-33": -1.006,
    "y-34": -1.003,
    "y-35": -1.003,
    "y-36": -1.003,
    "y-37": -1.003,
    "y-38": -1.011,
    "y-39": -1.011,
    "y-40": -1.011,
    "y-41": -1.011,
    "y-42": -1.01,
    "y-43": -1.01,
    "y-44": -1.01,
    "y-45": -1.01,
    "y-47": -1.007,
    "y-48": -1.007,
    "y-49": -1.01,
    "y-50": -1.012,
    "y-51": -1.01,
    "y-52": -1.008,
    "y-53": -1.007,
    "y-54": -1.01,
    "y-55": -1.011,
    "y-56": -1.01,
    "y-57": -1.014,
    "y-58": -1.011,
    "y-59": -1.011,
    "y-60": -1.009,
    "y-61": -1.01,
    "y-62": -1.009,
    "y-63": -1.01,
    "y-64": -1.007,
    "y-65": -1.009,
    "y-66": -1.008,
    "y-67": -1.01,
    "y-68": -1.01,
    "y-69": -1.009,
    "y-70": -1.009,
    "y-71": -1.01,
    "y-72": -1.009,
    "y-73": -1.011,
    "y-74": -1.01,
    "y-75": -1.009,
    "y-76": -1.009,
    "y-77": -1.009,
    "y-78": -1.008,
    "y-79": -1.008,
    "y-80": -1.008,
    "y-81": -1.007,
    "y-82": -1.009,
    "y-83": -1.009,
    "y-84": -1.01,
    "y-85": -1.009,
    "y-86": -1.01,
    "y-87": -1.01,
    "y-88": -1.008,
    "y-89": -1.009,
    "y-90": -1.009,
    "y-91": -1.009,
    "y-92": -1.01,
    "y-93": -1.01,
    "y-94": -1.01,
    "y-95": -1.009,
    "y-96": -1.011,
    "y-97": -1.009,
    "y-98": -1.009,
    "y-99": -1.009,
    "y-100": -1.009,
    "y-101": -1.01,
    "y-102": -1.009,
    "y-103": -1.011,
    "y-104": -1.01,
    "y-105": -1.009,
    "y-106": -1.01,
    "y-107": -1.009,
    "y-108": -1.009,
    "y-109": -1.009,
    "y-110": -1.009,
    "y-111": -1.009,
    "y-112": -1.009,
    "y-113": -1.009,
    "y-114": -1.009,
    "y-115": -1.009,
    "y-116": -1.009,
    "y-117": -1.009,
    "y-118": -1.009,
    "y-119": -1.009,
    "y-120": -1.009,
    "y-121": -1.009,
    "y-122": -1.009,
    "y-123": -1.009,
    "y-124": -1.009,
    "y-125": -1.009,
    "y-126": -1.009,
    "y-127": -1.009,
    "y-128": -1.009,
    "y-129": -1.009,
    "y-130": -1.009,
    "y-131": -1.009,
    "y-132": -1.009,
    "y-133": -1.009,
    "y-134": -1.009,
    "y-135": -1.009,
    "y-136": -1.009,
    "y-137": -1.009,
    "y-138": -1.009,
    "y-139": -1.009,
    "y-140": -1.009,
    "y-141": -1.009,
    "y-142": -1.009,
    "y-143": -1.009,
    "y-144": -1.009,
    "y-145": -1.009,
    "y-146": -1.009,
    "y-147": -1.009,
    "y-148": -1.009,
    "y-149": -1.009,
    "y-150": -1.009,
    "y-151": -1.009,
    "y-152": -1.009,
    "y-153": -1.009,
    "y-154": -1.009,
    "y-155": -1.009,
    "y-156": -1.008,
    "y-157": -1.008,
    "y-158": -1.008,
    "y-159": -1.008,
    "y-160": -1.008,
    "y-161": -1.008,
    "y-162": -1.008,
    "y-163": -1.008,
    "y-164": -1.008,
    "y-165": -1.008,
    "y-166": -1.008,
    "y-167": -1.008,
    "y-168": -1.008,
    "y-169": -1.008,
    "y-170": -1.008,
    "y-171": -1.008,
    "y-172": -1.008,
    "y-173": -1.008,
    "y-174": -1.008,
    "y-175": -1.008,
    "y-176": -1.008,
    "y-177": -1.008,
    "y-178": -1.008,
    "y-179": -1.008,
    "y-180": -1.008,
    "y-181": -1.008,
    "y-182": -1.008,
    "y-183": -1.008,
    "y-184": -1.008,
    "y-185": -1.008,
    "y-186": -1.008,
    "y-187": -1.008,
    "y-188": -1.008,
    "y-189": -1.008,
    "y-190": -1.008,
    "y-191": -1.008,
    "y-192": -1.008,
    "y-193": -1.008,
    "y-194": -1.008,
    "y-195": -1.008,
    "y-196": -1.008,
    "y-197": -1.008,
    "y-198": -1.008,
    "y-199": -1.008,
    "y-200": -1.008,
    "y-201": -1.008,
    "y-202": -1.008,
    "y-203": -1.008,
    "y-204": -1.008,
    "y-205": -1.008,
    "y-206": -1.008,
    "y-207": -1.008,
    "y-208": -1.008,
    "y-209": -1.008,
    "y-210": -1.008,
    "y-211": -1.008,
    "y-212": -1.008,
    "y-213": -1.008,
    "y-214": -1.008,
    "y-215": -1.008,
    "y-216": -1.008,
    "y-217": -1.008,
    "y-218": -1.008,
    "y-219": -1.008,
    "y-220": -1.008,
    "y-221": -1.008,
    "y-222": -1.008,
    "y-223": -1.008,
    "y-224": -1.008,
    "y-225": -1.008,
    "y-226": -1.008,
    "y-227": -1.008,
    "y-228": -1.008,
    "y-229": -1.008,
    "y-230": -1.008,
    "y-231": -1.008,
    "y-232": -1.007,
    "y-233": -1.007,
    "y-234": -1.007,
    "y-235": -1.007,
    "y-236": -1.007,
    "y-237": -1.007,
    "y-238": -1.007,
    "y-239": -1.007,
    "y-240": -1.007,
    "y-241": -1.007,
    "y-242": -1.007,
    "y-243": -1.007,
    "y-244": -1.007,
    "y-245": -1.007,
    "y-246": -1.007,
    "y-247": -1.007,
    "y-248": -1.007,
    "y-249": -1.007,
    "y-250": -1.007,
    "y-251": -1.007,
    "y-252": -1.007,
    "y-253": -1.008,
    "y-254": -1.008,
    "y-255": -1.008,
  },
  {
    x: 0.375,
    "y-2": -0.478,
    "y-12": -1.071,
    "y-46": -1.075,
    "y-1000": -1.072,
    "y-0": -0.08,
    "y-1": -0.655,
    "y-3": -0.69,
    "y-4": -0.781,
    "y-5": -0.823,
    "y-6": -0.825,
    "y-7": -0.828,
    "y-8": -0.836,
    "y-9": -0.836,
    "y-10": -1.042,
    "y-11": -1.07,
    "y-13": -1.071,
    "y-14": -1.053,
    "y-15": -1.083,
    "y-16": -1.083,
    "y-17": -1.083,
    "y-18": -1.084,
    "y-19": -1.084,
    "y-20": -1.069,
    "y-21": -1.069,
    "y-22": -1.069,
    "y-23": -1.069,
    "y-24": -1.069,
    "y-25": -1.069,
    "y-26": -1.075,
    "y-27": -1.075,
    "y-28": -1.075,
    "y-29": -1.075,
    "y-30": -1.075,
    "y-31": -1.075,
    "y-32": -1.075,
    "y-33": -1.075,
    "y-34": -1.071,
    "y-35": -1.071,
    "y-36": -1.071,
    "y-37": -1.071,
    "y-38": -1.074,
    "y-39": -1.074,
    "y-40": -1.074,
    "y-41": -1.074,
    "y-42": -1.073,
    "y-43": -1.073,
    "y-44": -1.073,
    "y-45": -1.073,
    "y-47": -1.072,
    "y-48": -1.071,
    "y-49": -1.073,
    "y-50": -1.074,
    "y-51": -1.073,
    "y-52": -1.072,
    "y-53": -1.071,
    "y-54": -1.073,
    "y-55": -1.073,
    "y-56": -1.073,
    "y-57": -1.075,
    "y-58": -1.074,
    "y-59": -1.073,
    "y-60": -1.073,
    "y-61": -1.073,
    "y-62": -1.072,
    "y-63": -1.073,
    "y-64": -1.071,
    "y-65": -1.072,
    "y-66": -1.072,
    "y-67": -1.073,
    "y-68": -1.073,
    "y-69": -1.073,
    "y-70": -1.073,
    "y-71": -1.073,
    "y-72": -1.073,
    "y-73": -1.073,
    "y-74": -1.073,
    "y-75": -1.073,
    "y-76": -1.073,
    "y-77": -1.072,
    "y-78": -1.072,
    "y-79": -1.072,
    "y-80": -1.072,
    "y-81": -1.072,
    "y-82": -1.073,
    "y-83": -1.072,
    "y-84": -1.073,
    "y-85": -1.073,
    "y-86": -1.073,
    "y-87": -1.073,
    "y-88": -1.072,
    "y-89": -1.072,
    "y-90": -1.073,
    "y-91": -1.073,
    "y-92": -1.073,
    "y-93": -1.073,
    "y-94": -1.073,
    "y-95": -1.072,
    "y-96": -1.074,
    "y-97": -1.073,
    "y-98": -1.072,
    "y-99": -1.072,
    "y-100": -1.073,
    "y-101": -1.073,
    "y-102": -1.073,
    "y-103": -1.073,
    "y-104": -1.073,
    "y-105": -1.073,
    "y-106": -1.073,
    "y-107": -1.073,
    "y-108": -1.072,
    "y-109": -1.072,
    "y-110": -1.073,
    "y-111": -1.073,
    "y-112": -1.073,
    "y-113": -1.073,
    "y-114": -1.072,
    "y-115": -1.073,
    "y-116": -1.073,
    "y-117": -1.073,
    "y-118": -1.073,
    "y-119": -1.073,
    "y-120": -1.073,
    "y-121": -1.072,
    "y-122": -1.073,
    "y-123": -1.073,
    "y-124": -1.073,
    "y-125": -1.073,
    "y-126": -1.073,
    "y-127": -1.073,
    "y-128": -1.073,
    "y-129": -1.073,
    "y-130": -1.073,
    "y-131": -1.073,
    "y-132": -1.073,
    "y-133": -1.073,
    "y-134": -1.073,
    "y-135": -1.073,
    "y-136": -1.073,
    "y-137": -1.073,
    "y-138": -1.073,
    "y-139": -1.073,
    "y-140": -1.073,
    "y-141": -1.073,
    "y-142": -1.072,
    "y-143": -1.072,
    "y-144": -1.072,
    "y-145": -1.072,
    "y-146": -1.072,
    "y-147": -1.072,
    "y-148": -1.072,
    "y-149": -1.072,
    "y-150": -1.072,
    "y-151": -1.072,
    "y-152": -1.072,
    "y-153": -1.072,
    "y-154": -1.072,
    "y-155": -1.072,
    "y-156": -1.072,
    "y-157": -1.072,
    "y-158": -1.072,
    "y-159": -1.072,
    "y-160": -1.072,
    "y-161": -1.072,
    "y-162": -1.072,
    "y-163": -1.072,
    "y-164": -1.072,
    "y-165": -1.072,
    "y-166": -1.072,
    "y-167": -1.072,
    "y-168": -1.072,
    "y-169": -1.072,
    "y-170": -1.072,
    "y-171": -1.072,
    "y-172": -1.072,
    "y-173": -1.072,
    "y-174": -1.072,
    "y-175": -1.072,
    "y-176": -1.072,
    "y-177": -1.072,
    "y-178": -1.072,
    "y-179": -1.072,
    "y-180": -1.072,
    "y-181": -1.072,
    "y-182": -1.072,
    "y-183": -1.072,
    "y-184": -1.072,
    "y-185": -1.072,
    "y-186": -1.072,
    "y-187": -1.072,
    "y-188": -1.072,
    "y-189": -1.072,
    "y-190": -1.072,
    "y-191": -1.072,
    "y-192": -1.072,
    "y-193": -1.072,
    "y-194": -1.072,
    "y-195": -1.072,
    "y-196": -1.072,
    "y-197": -1.072,
    "y-198": -1.072,
    "y-199": -1.072,
    "y-200": -1.072,
    "y-201": -1.072,
    "y-202": -1.072,
    "y-203": -1.072,
    "y-204": -1.072,
    "y-205": -1.072,
    "y-206": -1.072,
    "y-207": -1.072,
    "y-208": -1.072,
    "y-209": -1.072,
    "y-210": -1.072,
    "y-211": -1.072,
    "y-212": -1.072,
    "y-213": -1.072,
    "y-214": -1.072,
    "y-215": -1.072,
    "y-216": -1.072,
    "y-217": -1.072,
    "y-218": -1.072,
    "y-219": -1.072,
    "y-220": -1.072,
    "y-221": -1.072,
    "y-222": -1.072,
    "y-223": -1.072,
    "y-224": -1.072,
    "y-225": -1.072,
    "y-226": -1.072,
    "y-227": -1.072,
    "y-228": -1.072,
    "y-229": -1.072,
    "y-230": -1.072,
    "y-231": -1.072,
    "y-232": -1.072,
    "y-233": -1.072,
    "y-234": -1.072,
    "y-235": -1.072,
    "y-236": -1.072,
    "y-237": -1.072,
    "y-238": -1.072,
    "y-239": -1.072,
    "y-240": -1.072,
    "y-241": -1.072,
    "y-242": -1.072,
    "y-243": -1.072,
    "y-244": -1.072,
    "y-245": -1.072,
    "y-246": -1.072,
    "y-247": -1.072,
    "y-248": -1.072,
    "y-249": -1.072,
    "y-250": -1.072,
    "y-251": -1.072,
    "y-252": -1.072,
    "y-253": -1.072,
    "y-254": -1.072,
    "y-255": -1.072,
  },
  {
    x: 0.4,
    "y-2": -0.499,
    "y-12": -1.142,
    "y-46": -1.136,
    "y-1000": -1.136,
    "y-0": -0.092,
    "y-1": -0.679,
    "y-3": -0.765,
    "y-4": -0.842,
    "y-5": -0.878,
    "y-6": -0.88,
    "y-7": -0.882,
    "y-8": -0.889,
    "y-9": -0.889,
    "y-10": -1.112,
    "y-11": -1.142,
    "y-13": -1.142,
    "y-14": -1.117,
    "y-15": -1.152,
    "y-16": -1.152,
    "y-17": -1.153,
    "y-18": -1.154,
    "y-19": -1.154,
    "y-20": -1.136,
    "y-21": -1.136,
    "y-22": -1.136,
    "y-23": -1.136,
    "y-24": -1.136,
    "y-25": -1.136,
    "y-26": -1.143,
    "y-27": -1.143,
    "y-28": -1.143,
    "y-29": -1.143,
    "y-30": -1.143,
    "y-31": -1.143,
    "y-32": -1.143,
    "y-33": -1.143,
    "y-34": -1.138,
    "y-35": -1.138,
    "y-36": -1.138,
    "y-37": -1.138,
    "y-38": -1.136,
    "y-39": -1.136,
    "y-40": -1.136,
    "y-41": -1.136,
    "y-42": -1.136,
    "y-43": -1.136,
    "y-44": -1.136,
    "y-45": -1.136,
    "y-47": -1.136,
    "y-48": -1.136,
    "y-49": -1.136,
    "y-50": -1.136,
    "y-51": -1.136,
    "y-52": -1.136,
    "y-53": -1.136,
    "y-54": -1.136,
    "y-55": -1.136,
    "y-56": -1.136,
    "y-57": -1.136,
    "y-58": -1.136,
    "y-59": -1.136,
    "y-60": -1.136,
    "y-61": -1.136,
    "y-62": -1.136,
    "y-63": -1.136,
    "y-64": -1.136,
    "y-65": -1.136,
    "y-66": -1.136,
    "y-67": -1.136,
    "y-68": -1.136,
    "y-69": -1.136,
    "y-70": -1.136,
    "y-71": -1.136,
    "y-72": -1.136,
    "y-73": -1.136,
    "y-74": -1.136,
    "y-75": -1.136,
    "y-76": -1.136,
    "y-77": -1.136,
    "y-78": -1.136,
    "y-79": -1.136,
    "y-80": -1.136,
    "y-81": -1.136,
    "y-82": -1.136,
    "y-83": -1.136,
    "y-84": -1.136,
    "y-85": -1.136,
    "y-86": -1.136,
    "y-87": -1.136,
    "y-88": -1.136,
    "y-89": -1.136,
    "y-90": -1.136,
    "y-91": -1.136,
    "y-92": -1.136,
    "y-93": -1.136,
    "y-94": -1.136,
    "y-95": -1.136,
    "y-96": -1.136,
    "y-97": -1.136,
    "y-98": -1.136,
    "y-99": -1.136,
    "y-100": -1.136,
    "y-101": -1.136,
    "y-102": -1.136,
    "y-103": -1.136,
    "y-104": -1.136,
    "y-105": -1.136,
    "y-106": -1.136,
    "y-107": -1.136,
    "y-108": -1.136,
    "y-109": -1.136,
    "y-110": -1.136,
    "y-111": -1.136,
    "y-112": -1.136,
    "y-113": -1.136,
    "y-114": -1.136,
    "y-115": -1.136,
    "y-116": -1.136,
    "y-117": -1.136,
    "y-118": -1.136,
    "y-119": -1.136,
    "y-120": -1.136,
    "y-121": -1.136,
    "y-122": -1.136,
    "y-123": -1.136,
    "y-124": -1.136,
    "y-125": -1.136,
    "y-126": -1.136,
    "y-127": -1.136,
    "y-128": -1.136,
    "y-129": -1.136,
    "y-130": -1.136,
    "y-131": -1.136,
    "y-132": -1.136,
    "y-133": -1.136,
    "y-134": -1.136,
    "y-135": -1.136,
    "y-136": -1.136,
    "y-137": -1.136,
    "y-138": -1.136,
    "y-139": -1.136,
    "y-140": -1.136,
    "y-141": -1.136,
    "y-142": -1.136,
    "y-143": -1.136,
    "y-144": -1.136,
    "y-145": -1.136,
    "y-146": -1.136,
    "y-147": -1.136,
    "y-148": -1.136,
    "y-149": -1.136,
    "y-150": -1.136,
    "y-151": -1.136,
    "y-152": -1.136,
    "y-153": -1.136,
    "y-154": -1.136,
    "y-155": -1.136,
    "y-156": -1.136,
    "y-157": -1.136,
    "y-158": -1.136,
    "y-159": -1.136,
    "y-160": -1.136,
    "y-161": -1.136,
    "y-162": -1.136,
    "y-163": -1.136,
    "y-164": -1.136,
    "y-165": -1.136,
    "y-166": -1.136,
    "y-167": -1.136,
    "y-168": -1.136,
    "y-169": -1.136,
    "y-170": -1.136,
    "y-171": -1.136,
    "y-172": -1.136,
    "y-173": -1.136,
    "y-174": -1.136,
    "y-175": -1.136,
    "y-176": -1.136,
    "y-177": -1.136,
    "y-178": -1.136,
    "y-179": -1.136,
    "y-180": -1.136,
    "y-181": -1.136,
    "y-182": -1.136,
    "y-183": -1.136,
    "y-184": -1.136,
    "y-185": -1.136,
    "y-186": -1.136,
    "y-187": -1.136,
    "y-188": -1.136,
    "y-189": -1.136,
    "y-190": -1.136,
    "y-191": -1.136,
    "y-192": -1.136,
    "y-193": -1.136,
    "y-194": -1.136,
    "y-195": -1.136,
    "y-196": -1.136,
    "y-197": -1.136,
    "y-198": -1.136,
    "y-199": -1.136,
    "y-200": -1.136,
    "y-201": -1.136,
    "y-202": -1.136,
    "y-203": -1.136,
    "y-204": -1.136,
    "y-205": -1.136,
    "y-206": -1.136,
    "y-207": -1.136,
    "y-208": -1.136,
    "y-209": -1.136,
    "y-210": -1.136,
    "y-211": -1.136,
    "y-212": -1.136,
    "y-213": -1.136,
    "y-214": -1.136,
    "y-215": -1.136,
    "y-216": -1.136,
    "y-217": -1.136,
    "y-218": -1.136,
    "y-219": -1.136,
    "y-220": -1.136,
    "y-221": -1.136,
    "y-222": -1.136,
    "y-223": -1.136,
    "y-224": -1.136,
    "y-225": -1.136,
    "y-226": -1.136,
    "y-227": -1.136,
    "y-228": -1.136,
    "y-229": -1.136,
    "y-230": -1.136,
    "y-231": -1.136,
    "y-232": -1.136,
    "y-233": -1.136,
    "y-234": -1.136,
    "y-235": -1.136,
    "y-236": -1.136,
    "y-237": -1.136,
    "y-238": -1.136,
    "y-239": -1.136,
    "y-240": -1.136,
    "y-241": -1.136,
    "y-242": -1.136,
    "y-243": -1.136,
    "y-244": -1.136,
    "y-245": -1.136,
    "y-246": -1.136,
    "y-247": -1.136,
    "y-248": -1.136,
    "y-249": -1.136,
    "y-250": -1.136,
    "y-251": -1.136,
    "y-252": -1.136,
    "y-253": -1.136,
    "y-254": -1.136,
    "y-255": -1.136,
  },
  {
    x: 0.425,
    "y-2": -0.521,
    "y-12": -1.207,
    "y-46": -1.196,
    "y-1000": -1.198,
    "y-0": -0.104,
    "y-1": -0.704,
    "y-3": -0.841,
    "y-4": -0.903,
    "y-5": -0.933,
    "y-6": -0.934,
    "y-7": -0.936,
    "y-8": -0.943,
    "y-9": -0.943,
    "y-10": -1.182,
    "y-11": -1.206,
    "y-13": -1.207,
    "y-14": -1.184,
    "y-15": -1.204,
    "y-16": -1.204,
    "y-17": -1.205,
    "y-18": -1.205,
    "y-19": -1.205,
    "y-20": -1.198,
    "y-21": -1.198,
    "y-22": -1.198,
    "y-23": -1.198,
    "y-24": -1.198,
    "y-25": -1.198,
    "y-26": -1.197,
    "y-27": -1.197,
    "y-28": -1.197,
    "y-29": -1.197,
    "y-30": -1.197,
    "y-31": -1.197,
    "y-32": -1.197,
    "y-33": -1.197,
    "y-34": -1.198,
    "y-35": -1.198,
    "y-36": -1.198,
    "y-37": -1.198,
    "y-38": -1.196,
    "y-39": -1.196,
    "y-40": -1.196,
    "y-41": -1.196,
    "y-42": -1.196,
    "y-43": -1.196,
    "y-44": -1.196,
    "y-45": -1.196,
    "y-47": -1.196,
    "y-48": -1.196,
    "y-49": -1.196,
    "y-50": -1.196,
    "y-51": -1.196,
    "y-52": -1.196,
    "y-53": -1.196,
    "y-54": -1.196,
    "y-55": -1.196,
    "y-56": -1.196,
    "y-57": -1.196,
    "y-58": -1.196,
    "y-59": -1.196,
    "y-60": -1.196,
    "y-61": -1.196,
    "y-62": -1.196,
    "y-63": -1.196,
    "y-64": -1.196,
    "y-65": -1.196,
    "y-66": -1.196,
    "y-67": -1.196,
    "y-68": -1.196,
    "y-69": -1.196,
    "y-70": -1.196,
    "y-71": -1.196,
    "y-72": -1.196,
    "y-73": -1.196,
    "y-74": -1.196,
    "y-75": -1.196,
    "y-76": -1.196,
    "y-77": -1.196,
    "y-78": -1.196,
    "y-79": -1.196,
    "y-80": -1.196,
    "y-81": -1.196,
    "y-82": -1.196,
    "y-83": -1.196,
    "y-84": -1.196,
    "y-85": -1.196,
    "y-86": -1.196,
    "y-87": -1.196,
    "y-88": -1.196,
    "y-89": -1.196,
    "y-90": -1.196,
    "y-91": -1.196,
    "y-92": -1.196,
    "y-93": -1.196,
    "y-94": -1.196,
    "y-95": -1.196,
    "y-96": -1.196,
    "y-97": -1.196,
    "y-98": -1.196,
    "y-99": -1.196,
    "y-100": -1.196,
    "y-101": -1.196,
    "y-102": -1.196,
    "y-103": -1.196,
    "y-104": -1.196,
    "y-105": -1.196,
    "y-106": -1.196,
    "y-107": -1.196,
    "y-108": -1.196,
    "y-109": -1.196,
    "y-110": -1.196,
    "y-111": -1.196,
    "y-112": -1.196,
    "y-113": -1.196,
    "y-114": -1.196,
    "y-115": -1.196,
    "y-116": -1.196,
    "y-117": -1.196,
    "y-118": -1.196,
    "y-119": -1.196,
    "y-120": -1.196,
    "y-121": -1.196,
    "y-122": -1.196,
    "y-123": -1.196,
    "y-124": -1.196,
    "y-125": -1.196,
    "y-126": -1.196,
    "y-127": -1.196,
    "y-128": -1.196,
    "y-129": -1.196,
    "y-130": -1.196,
    "y-131": -1.196,
    "y-132": -1.196,
    "y-133": -1.196,
    "y-134": -1.196,
    "y-135": -1.196,
    "y-136": -1.196,
    "y-137": -1.196,
    "y-138": -1.196,
    "y-139": -1.196,
    "y-140": -1.196,
    "y-141": -1.196,
    "y-142": -1.196,
    "y-143": -1.196,
    "y-144": -1.196,
    "y-145": -1.196,
    "y-146": -1.196,
    "y-147": -1.196,
    "y-148": -1.196,
    "y-149": -1.196,
    "y-150": -1.196,
    "y-151": -1.196,
    "y-152": -1.196,
    "y-153": -1.196,
    "y-154": -1.196,
    "y-155": -1.196,
    "y-156": -1.197,
    "y-157": -1.197,
    "y-158": -1.197,
    "y-159": -1.198,
    "y-160": -1.198,
    "y-161": -1.198,
    "y-162": -1.198,
    "y-163": -1.198,
    "y-164": -1.198,
    "y-165": -1.198,
    "y-166": -1.198,
    "y-167": -1.198,
    "y-168": -1.198,
    "y-169": -1.198,
    "y-170": -1.198,
    "y-171": -1.198,
    "y-172": -1.198,
    "y-173": -1.198,
    "y-174": -1.198,
    "y-175": -1.198,
    "y-176": -1.198,
    "y-177": -1.198,
    "y-178": -1.198,
    "y-179": -1.198,
    "y-180": -1.198,
    "y-181": -1.198,
    "y-182": -1.198,
    "y-183": -1.198,
    "y-184": -1.198,
    "y-185": -1.198,
    "y-186": -1.198,
    "y-187": -1.198,
    "y-188": -1.198,
    "y-189": -1.198,
    "y-190": -1.198,
    "y-191": -1.198,
    "y-192": -1.198,
    "y-193": -1.198,
    "y-194": -1.198,
    "y-195": -1.198,
    "y-196": -1.198,
    "y-197": -1.198,
    "y-198": -1.198,
    "y-199": -1.198,
    "y-200": -1.198,
    "y-201": -1.198,
    "y-202": -1.198,
    "y-203": -1.198,
    "y-204": -1.198,
    "y-205": -1.198,
    "y-206": -1.198,
    "y-207": -1.198,
    "y-208": -1.198,
    "y-209": -1.198,
    "y-210": -1.198,
    "y-211": -1.198,
    "y-212": -1.198,
    "y-213": -1.198,
    "y-214": -1.198,
    "y-215": -1.198,
    "y-216": -1.198,
    "y-217": -1.198,
    "y-218": -1.198,
    "y-219": -1.198,
    "y-220": -1.198,
    "y-221": -1.198,
    "y-222": -1.198,
    "y-223": -1.198,
    "y-224": -1.198,
    "y-225": -1.198,
    "y-226": -1.198,
    "y-227": -1.198,
    "y-228": -1.198,
    "y-229": -1.198,
    "y-230": -1.198,
    "y-231": -1.198,
    "y-232": -1.198,
    "y-233": -1.198,
    "y-234": -1.198,
    "y-235": -1.198,
    "y-236": -1.198,
    "y-237": -1.198,
    "y-238": -1.198,
    "y-239": -1.198,
    "y-240": -1.198,
    "y-241": -1.198,
    "y-242": -1.198,
    "y-243": -1.198,
    "y-244": -1.198,
    "y-245": -1.198,
    "y-246": -1.198,
    "y-247": -1.198,
    "y-248": -1.198,
    "y-249": -1.198,
    "y-250": -1.198,
    "y-251": -1.198,
    "y-252": -1.198,
    "y-253": -1.198,
    "y-254": -1.198,
    "y-255": -1.198,
  },
  {
    x: 0.45,
    "y-2": -0.542,
    "y-12": -1.27,
    "y-46": -1.256,
    "y-1000": -1.259,
    "y-0": -0.116,
    "y-1": -0.729,
    "y-3": -0.917,
    "y-4": -0.964,
    "y-5": -0.987,
    "y-6": -0.989,
    "y-7": -0.99,
    "y-8": -0.996,
    "y-9": -0.996,
    "y-10": -1.252,
    "y-11": -1.271,
    "y-13": -1.27,
    "y-14": -1.251,
    "y-15": -1.256,
    "y-16": -1.256,
    "y-17": -1.256,
    "y-18": -1.256,
    "y-19": -1.256,
    "y-20": -1.26,
    "y-21": -1.26,
    "y-22": -1.26,
    "y-23": -1.26,
    "y-24": -1.26,
    "y-25": -1.26,
    "y-26": -1.25,
    "y-27": -1.25,
    "y-28": -1.25,
    "y-29": -1.25,
    "y-30": -1.25,
    "y-31": -1.25,
    "y-32": -1.25,
    "y-33": -1.25,
    "y-34": -1.257,
    "y-35": -1.257,
    "y-36": -1.257,
    "y-37": -1.257,
    "y-38": -1.256,
    "y-39": -1.256,
    "y-40": -1.256,
    "y-41": -1.256,
    "y-42": -1.256,
    "y-43": -1.256,
    "y-44": -1.256,
    "y-45": -1.256,
    "y-47": -1.256,
    "y-48": -1.256,
    "y-49": -1.256,
    "y-50": -1.256,
    "y-51": -1.256,
    "y-52": -1.256,
    "y-53": -1.256,
    "y-54": -1.256,
    "y-55": -1.256,
    "y-56": -1.256,
    "y-57": -1.256,
    "y-58": -1.256,
    "y-59": -1.256,
    "y-60": -1.256,
    "y-61": -1.256,
    "y-62": -1.256,
    "y-63": -1.256,
    "y-64": -1.256,
    "y-65": -1.256,
    "y-66": -1.256,
    "y-67": -1.256,
    "y-68": -1.256,
    "y-69": -1.256,
    "y-70": -1.256,
    "y-71": -1.256,
    "y-72": -1.256,
    "y-73": -1.256,
    "y-74": -1.256,
    "y-75": -1.256,
    "y-76": -1.256,
    "y-77": -1.256,
    "y-78": -1.256,
    "y-79": -1.256,
    "y-80": -1.256,
    "y-81": -1.256,
    "y-82": -1.256,
    "y-83": -1.256,
    "y-84": -1.256,
    "y-85": -1.256,
    "y-86": -1.256,
    "y-87": -1.256,
    "y-88": -1.256,
    "y-89": -1.256,
    "y-90": -1.256,
    "y-91": -1.256,
    "y-92": -1.256,
    "y-93": -1.256,
    "y-94": -1.256,
    "y-95": -1.256,
    "y-96": -1.256,
    "y-97": -1.256,
    "y-98": -1.256,
    "y-99": -1.256,
    "y-100": -1.256,
    "y-101": -1.256,
    "y-102": -1.256,
    "y-103": -1.256,
    "y-104": -1.256,
    "y-105": -1.256,
    "y-106": -1.256,
    "y-107": -1.256,
    "y-108": -1.256,
    "y-109": -1.256,
    "y-110": -1.256,
    "y-111": -1.256,
    "y-112": -1.256,
    "y-113": -1.256,
    "y-114": -1.256,
    "y-115": -1.256,
    "y-116": -1.256,
    "y-117": -1.256,
    "y-118": -1.256,
    "y-119": -1.256,
    "y-120": -1.256,
    "y-121": -1.256,
    "y-122": -1.256,
    "y-123": -1.256,
    "y-124": -1.256,
    "y-125": -1.256,
    "y-126": -1.256,
    "y-127": -1.256,
    "y-128": -1.256,
    "y-129": -1.256,
    "y-130": -1.256,
    "y-131": -1.256,
    "y-132": -1.256,
    "y-133": -1.256,
    "y-134": -1.256,
    "y-135": -1.256,
    "y-136": -1.256,
    "y-137": -1.256,
    "y-138": -1.256,
    "y-139": -1.256,
    "y-140": -1.256,
    "y-141": -1.256,
    "y-142": -1.256,
    "y-143": -1.256,
    "y-144": -1.256,
    "y-145": -1.256,
    "y-146": -1.256,
    "y-147": -1.256,
    "y-148": -1.256,
    "y-149": -1.256,
    "y-150": -1.256,
    "y-151": -1.256,
    "y-152": -1.256,
    "y-153": -1.256,
    "y-154": -1.256,
    "y-155": -1.256,
    "y-156": -1.258,
    "y-157": -1.258,
    "y-158": -1.258,
    "y-159": -1.26,
    "y-160": -1.26,
    "y-161": -1.26,
    "y-162": -1.26,
    "y-163": -1.26,
    "y-164": -1.26,
    "y-165": -1.26,
    "y-166": -1.26,
    "y-167": -1.26,
    "y-168": -1.26,
    "y-169": -1.26,
    "y-170": -1.26,
    "y-171": -1.26,
    "y-172": -1.26,
    "y-173": -1.259,
    "y-174": -1.259,
    "y-175": -1.259,
    "y-176": -1.259,
    "y-177": -1.259,
    "y-178": -1.259,
    "y-179": -1.259,
    "y-180": -1.259,
    "y-181": -1.259,
    "y-182": -1.259,
    "y-183": -1.259,
    "y-184": -1.259,
    "y-185": -1.259,
    "y-186": -1.259,
    "y-187": -1.259,
    "y-188": -1.259,
    "y-189": -1.259,
    "y-190": -1.259,
    "y-191": -1.259,
    "y-192": -1.26,
    "y-193": -1.26,
    "y-194": -1.26,
    "y-195": -1.26,
    "y-196": -1.26,
    "y-197": -1.26,
    "y-198": -1.26,
    "y-199": -1.26,
    "y-200": -1.259,
    "y-201": -1.259,
    "y-202": -1.259,
    "y-203": -1.259,
    "y-204": -1.259,
    "y-205": -1.259,
    "y-206": -1.259,
    "y-207": -1.259,
    "y-208": -1.259,
    "y-209": -1.26,
    "y-210": -1.26,
    "y-211": -1.26,
    "y-212": -1.26,
    "y-213": -1.26,
    "y-214": -1.26,
    "y-215": -1.26,
    "y-216": -1.26,
    "y-217": -1.26,
    "y-218": -1.26,
    "y-219": -1.26,
    "y-220": -1.26,
    "y-221": -1.26,
    "y-222": -1.26,
    "y-223": -1.26,
    "y-224": -1.26,
    "y-225": -1.26,
    "y-226": -1.26,
    "y-227": -1.26,
    "y-228": -1.26,
    "y-229": -1.26,
    "y-230": -1.26,
    "y-231": -1.26,
    "y-232": -1.26,
    "y-233": -1.26,
    "y-234": -1.26,
    "y-235": -1.26,
    "y-236": -1.26,
    "y-237": -1.26,
    "y-238": -1.26,
    "y-239": -1.26,
    "y-240": -1.26,
    "y-241": -1.26,
    "y-242": -1.26,
    "y-243": -1.26,
    "y-244": -1.26,
    "y-245": -1.26,
    "y-246": -1.26,
    "y-247": -1.26,
    "y-248": -1.26,
    "y-249": -1.26,
    "y-250": -1.26,
    "y-251": -1.26,
    "y-252": -1.26,
    "y-253": -1.259,
    "y-254": -1.259,
    "y-255": -1.259,
  },
  {
    x: 0.475,
    "y-2": -0.563,
    "y-12": -1.334,
    "y-46": -1.315,
    "y-1000": -1.319,
    "y-0": -0.128,
    "y-1": -0.753,
    "y-3": -0.993,
    "y-4": -1.025,
    "y-5": -1.042,
    "y-6": -1.043,
    "y-7": -1.044,
    "y-8": -1.049,
    "y-9": -1.049,
    "y-10": -1.322,
    "y-11": -1.335,
    "y-13": -1.334,
    "y-14": -1.317,
    "y-15": -1.307,
    "y-16": -1.307,
    "y-17": -1.307,
    "y-18": -1.306,
    "y-19": -1.306,
    "y-20": -1.321,
    "y-21": -1.321,
    "y-22": -1.321,
    "y-23": -1.321,
    "y-24": -1.321,
    "y-25": -1.321,
    "y-26": -1.303,
    "y-27": -1.303,
    "y-28": -1.303,
    "y-29": -1.303,
    "y-30": -1.303,
    "y-31": -1.303,
    "y-32": -1.303,
    "y-33": -1.303,
    "y-34": -1.316,
    "y-35": -1.316,
    "y-36": -1.316,
    "y-37": -1.316,
    "y-38": -1.315,
    "y-39": -1.315,
    "y-40": -1.315,
    "y-41": -1.315,
    "y-42": -1.315,
    "y-43": -1.315,
    "y-44": -1.315,
    "y-45": -1.315,
    "y-47": -1.315,
    "y-48": -1.315,
    "y-49": -1.315,
    "y-50": -1.315,
    "y-51": -1.315,
    "y-52": -1.315,
    "y-53": -1.315,
    "y-54": -1.315,
    "y-55": -1.315,
    "y-56": -1.315,
    "y-57": -1.315,
    "y-58": -1.315,
    "y-59": -1.315,
    "y-60": -1.315,
    "y-61": -1.315,
    "y-62": -1.315,
    "y-63": -1.315,
    "y-64": -1.315,
    "y-65": -1.315,
    "y-66": -1.315,
    "y-67": -1.315,
    "y-68": -1.315,
    "y-69": -1.315,
    "y-70": -1.315,
    "y-71": -1.315,
    "y-72": -1.315,
    "y-73": -1.315,
    "y-74": -1.315,
    "y-75": -1.315,
    "y-76": -1.315,
    "y-77": -1.315,
    "y-78": -1.315,
    "y-79": -1.315,
    "y-80": -1.315,
    "y-81": -1.315,
    "y-82": -1.315,
    "y-83": -1.315,
    "y-84": -1.315,
    "y-85": -1.315,
    "y-86": -1.315,
    "y-87": -1.315,
    "y-88": -1.315,
    "y-89": -1.315,
    "y-90": -1.315,
    "y-91": -1.315,
    "y-92": -1.315,
    "y-93": -1.315,
    "y-94": -1.315,
    "y-95": -1.315,
    "y-96": -1.315,
    "y-97": -1.315,
    "y-98": -1.315,
    "y-99": -1.315,
    "y-100": -1.315,
    "y-101": -1.315,
    "y-102": -1.315,
    "y-103": -1.315,
    "y-104": -1.315,
    "y-105": -1.315,
    "y-106": -1.315,
    "y-107": -1.315,
    "y-108": -1.315,
    "y-109": -1.315,
    "y-110": -1.315,
    "y-111": -1.315,
    "y-112": -1.315,
    "y-113": -1.315,
    "y-114": -1.315,
    "y-115": -1.315,
    "y-116": -1.315,
    "y-117": -1.315,
    "y-118": -1.315,
    "y-119": -1.315,
    "y-120": -1.315,
    "y-121": -1.315,
    "y-122": -1.315,
    "y-123": -1.315,
    "y-124": -1.315,
    "y-125": -1.315,
    "y-126": -1.315,
    "y-127": -1.315,
    "y-128": -1.315,
    "y-129": -1.315,
    "y-130": -1.315,
    "y-131": -1.315,
    "y-132": -1.315,
    "y-133": -1.315,
    "y-134": -1.315,
    "y-135": -1.315,
    "y-136": -1.315,
    "y-137": -1.315,
    "y-138": -1.315,
    "y-139": -1.315,
    "y-140": -1.315,
    "y-141": -1.315,
    "y-142": -1.315,
    "y-143": -1.315,
    "y-144": -1.315,
    "y-145": -1.315,
    "y-146": -1.315,
    "y-147": -1.315,
    "y-148": -1.315,
    "y-149": -1.315,
    "y-150": -1.315,
    "y-151": -1.315,
    "y-152": -1.315,
    "y-153": -1.315,
    "y-154": -1.315,
    "y-155": -1.315,
    "y-156": -1.319,
    "y-157": -1.319,
    "y-158": -1.319,
    "y-159": -1.32,
    "y-160": -1.32,
    "y-161": -1.32,
    "y-162": -1.32,
    "y-163": -1.32,
    "y-164": -1.32,
    "y-165": -1.32,
    "y-166": -1.32,
    "y-167": -1.32,
    "y-168": -1.32,
    "y-169": -1.32,
    "y-170": -1.32,
    "y-171": -1.32,
    "y-172": -1.32,
    "y-173": -1.32,
    "y-174": -1.32,
    "y-175": -1.32,
    "y-176": -1.32,
    "y-177": -1.32,
    "y-178": -1.32,
    "y-179": -1.32,
    "y-180": -1.32,
    "y-181": -1.32,
    "y-182": -1.32,
    "y-183": -1.32,
    "y-184": -1.32,
    "y-185": -1.32,
    "y-186": -1.32,
    "y-187": -1.32,
    "y-188": -1.32,
    "y-189": -1.32,
    "y-190": -1.32,
    "y-191": -1.32,
    "y-192": -1.32,
    "y-193": -1.32,
    "y-194": -1.32,
    "y-195": -1.32,
    "y-196": -1.32,
    "y-197": -1.32,
    "y-198": -1.32,
    "y-199": -1.32,
    "y-200": -1.32,
    "y-201": -1.32,
    "y-202": -1.32,
    "y-203": -1.32,
    "y-204": -1.32,
    "y-205": -1.32,
    "y-206": -1.32,
    "y-207": -1.32,
    "y-208": -1.32,
    "y-209": -1.32,
    "y-210": -1.32,
    "y-211": -1.32,
    "y-212": -1.32,
    "y-213": -1.32,
    "y-214": -1.32,
    "y-215": -1.32,
    "y-216": -1.32,
    "y-217": -1.32,
    "y-218": -1.32,
    "y-219": -1.32,
    "y-220": -1.32,
    "y-221": -1.32,
    "y-222": -1.32,
    "y-223": -1.32,
    "y-224": -1.32,
    "y-225": -1.32,
    "y-226": -1.32,
    "y-227": -1.32,
    "y-228": -1.32,
    "y-229": -1.32,
    "y-230": -1.32,
    "y-231": -1.32,
    "y-232": -1.32,
    "y-233": -1.32,
    "y-234": -1.32,
    "y-235": -1.32,
    "y-236": -1.32,
    "y-237": -1.32,
    "y-238": -1.32,
    "y-239": -1.32,
    "y-240": -1.32,
    "y-241": -1.32,
    "y-242": -1.32,
    "y-243": -1.32,
    "y-244": -1.32,
    "y-245": -1.32,
    "y-246": -1.32,
    "y-247": -1.32,
    "y-248": -1.32,
    "y-249": -1.32,
    "y-250": -1.32,
    "y-251": -1.32,
    "y-252": -1.32,
    "y-253": -1.32,
    "y-254": -1.32,
    "y-255": -1.32,
  },
  {
    x: 0.5,
    "y-2": -0.584,
    "y-12": -1.398,
    "y-46": -1.375,
    "y-1000": -1.375,
    "y-0": -0.141,
    "y-1": -0.778,
    "y-3": -1.068,
    "y-4": -1.086,
    "y-5": -1.096,
    "y-6": -1.097,
    "y-7": -1.098,
    "y-8": -1.102,
    "y-9": -1.102,
    "y-10": -1.392,
    "y-11": -1.4,
    "y-13": -1.398,
    "y-14": -1.384,
    "y-15": -1.358,
    "y-16": -1.358,
    "y-17": -1.358,
    "y-18": -1.357,
    "y-19": -1.357,
    "y-20": -1.383,
    "y-21": -1.383,
    "y-22": -1.383,
    "y-23": -1.383,
    "y-24": -1.383,
    "y-25": -1.383,
    "y-26": -1.356,
    "y-27": -1.356,
    "y-28": -1.356,
    "y-29": -1.356,
    "y-30": -1.356,
    "y-31": -1.356,
    "y-32": -1.356,
    "y-33": -1.356,
    "y-34": -1.375,
    "y-35": -1.375,
    "y-36": -1.375,
    "y-37": -1.375,
    "y-38": -1.375,
    "y-39": -1.375,
    "y-40": -1.375,
    "y-41": -1.375,
    "y-42": -1.375,
    "y-43": -1.375,
    "y-44": -1.375,
    "y-45": -1.375,
    "y-47": -1.375,
    "y-48": -1.375,
    "y-49": -1.375,
    "y-50": -1.375,
    "y-51": -1.375,
    "y-52": -1.375,
    "y-53": -1.375,
    "y-54": -1.375,
    "y-55": -1.375,
    "y-56": -1.375,
    "y-57": -1.375,
    "y-58": -1.375,
    "y-59": -1.375,
    "y-60": -1.375,
    "y-61": -1.375,
    "y-62": -1.375,
    "y-63": -1.375,
    "y-64": -1.375,
    "y-65": -1.375,
    "y-66": -1.375,
    "y-67": -1.375,
    "y-68": -1.375,
    "y-69": -1.375,
    "y-70": -1.375,
    "y-71": -1.375,
    "y-72": -1.375,
    "y-73": -1.375,
    "y-74": -1.375,
    "y-75": -1.375,
    "y-76": -1.375,
    "y-77": -1.375,
    "y-78": -1.375,
    "y-79": -1.375,
    "y-80": -1.375,
    "y-81": -1.375,
    "y-82": -1.375,
    "y-83": -1.375,
    "y-84": -1.375,
    "y-85": -1.375,
    "y-86": -1.375,
    "y-87": -1.375,
    "y-88": -1.375,
    "y-89": -1.375,
    "y-90": -1.375,
    "y-91": -1.375,
    "y-92": -1.375,
    "y-93": -1.375,
    "y-94": -1.375,
    "y-95": -1.375,
    "y-96": -1.375,
    "y-97": -1.375,
    "y-98": -1.375,
    "y-99": -1.375,
    "y-100": -1.375,
    "y-101": -1.375,
    "y-102": -1.375,
    "y-103": -1.375,
    "y-104": -1.375,
    "y-105": -1.375,
    "y-106": -1.375,
    "y-107": -1.375,
    "y-108": -1.375,
    "y-109": -1.375,
    "y-110": -1.375,
    "y-111": -1.375,
    "y-112": -1.375,
    "y-113": -1.375,
    "y-114": -1.375,
    "y-115": -1.375,
    "y-116": -1.375,
    "y-117": -1.375,
    "y-118": -1.375,
    "y-119": -1.375,
    "y-120": -1.375,
    "y-121": -1.375,
    "y-122": -1.375,
    "y-123": -1.375,
    "y-124": -1.375,
    "y-125": -1.375,
    "y-126": -1.375,
    "y-127": -1.375,
    "y-128": -1.375,
    "y-129": -1.375,
    "y-130": -1.375,
    "y-131": -1.375,
    "y-132": -1.375,
    "y-133": -1.375,
    "y-134": -1.375,
    "y-135": -1.375,
    "y-136": -1.375,
    "y-137": -1.375,
    "y-138": -1.375,
    "y-139": -1.375,
    "y-140": -1.375,
    "y-141": -1.375,
    "y-142": -1.375,
    "y-143": -1.375,
    "y-144": -1.375,
    "y-145": -1.375,
    "y-146": -1.375,
    "y-147": -1.375,
    "y-148": -1.375,
    "y-149": -1.375,
    "y-150": -1.375,
    "y-151": -1.375,
    "y-152": -1.375,
    "y-153": -1.375,
    "y-154": -1.375,
    "y-155": -1.375,
    "y-156": -1.375,
    "y-157": -1.375,
    "y-158": -1.375,
    "y-159": -1.375,
    "y-160": -1.375,
    "y-161": -1.375,
    "y-162": -1.375,
    "y-163": -1.375,
    "y-164": -1.375,
    "y-165": -1.375,
    "y-166": -1.375,
    "y-167": -1.375,
    "y-168": -1.375,
    "y-169": -1.375,
    "y-170": -1.375,
    "y-171": -1.375,
    "y-172": -1.375,
    "y-173": -1.375,
    "y-174": -1.375,
    "y-175": -1.375,
    "y-176": -1.375,
    "y-177": -1.375,
    "y-178": -1.375,
    "y-179": -1.375,
    "y-180": -1.375,
    "y-181": -1.375,
    "y-182": -1.375,
    "y-183": -1.375,
    "y-184": -1.375,
    "y-185": -1.375,
    "y-186": -1.375,
    "y-187": -1.375,
    "y-188": -1.375,
    "y-189": -1.375,
    "y-190": -1.375,
    "y-191": -1.375,
    "y-192": -1.375,
    "y-193": -1.375,
    "y-194": -1.375,
    "y-195": -1.375,
    "y-196": -1.375,
    "y-197": -1.375,
    "y-198": -1.375,
    "y-199": -1.375,
    "y-200": -1.375,
    "y-201": -1.375,
    "y-202": -1.375,
    "y-203": -1.375,
    "y-204": -1.375,
    "y-205": -1.375,
    "y-206": -1.375,
    "y-207": -1.375,
    "y-208": -1.375,
    "y-209": -1.375,
    "y-210": -1.375,
    "y-211": -1.375,
    "y-212": -1.375,
    "y-213": -1.375,
    "y-214": -1.375,
    "y-215": -1.375,
    "y-216": -1.375,
    "y-217": -1.375,
    "y-218": -1.375,
    "y-219": -1.375,
    "y-220": -1.375,
    "y-221": -1.375,
    "y-222": -1.375,
    "y-223": -1.375,
    "y-224": -1.375,
    "y-225": -1.375,
    "y-226": -1.375,
    "y-227": -1.375,
    "y-228": -1.375,
    "y-229": -1.375,
    "y-230": -1.375,
    "y-231": -1.375,
    "y-232": -1.375,
    "y-233": -1.375,
    "y-234": -1.375,
    "y-235": -1.375,
    "y-236": -1.375,
    "y-237": -1.375,
    "y-238": -1.375,
    "y-239": -1.375,
    "y-240": -1.375,
    "y-241": -1.375,
    "y-242": -1.375,
    "y-243": -1.375,
    "y-244": -1.375,
    "y-245": -1.375,
    "y-246": -1.375,
    "y-247": -1.375,
    "y-248": -1.375,
    "y-249": -1.375,
    "y-250": -1.375,
    "y-251": -1.375,
    "y-252": -1.375,
    "y-253": -1.375,
    "y-254": -1.375,
    "y-255": -1.375,
  },
  {
    x: 0.525,
    "y-2": -0.606,
    "y-12": -1.462,
    "y-46": -1.435,
    "y-1000": -1.429,
    "y-0": -0.153,
    "y-1": -0.802,
    "y-3": -1.144,
    "y-4": -1.147,
    "y-5": -1.151,
    "y-6": -1.152,
    "y-7": -1.152,
    "y-8": -1.155,
    "y-9": -1.155,
    "y-10": -1.462,
    "y-11": -1.464,
    "y-13": -1.462,
    "y-14": -1.451,
    "y-15": -1.41,
    "y-16": -1.41,
    "y-17": -1.409,
    "y-18": -1.408,
    "y-19": -1.408,
    "y-20": -1.444,
    "y-21": -1.444,
    "y-22": -1.444,
    "y-23": -1.444,
    "y-24": -1.444,
    "y-25": -1.444,
    "y-26": -1.41,
    "y-27": -1.41,
    "y-28": -1.41,
    "y-29": -1.41,
    "y-30": -1.41,
    "y-31": -1.41,
    "y-32": -1.41,
    "y-33": -1.41,
    "y-34": -1.434,
    "y-35": -1.434,
    "y-36": -1.434,
    "y-37": -1.434,
    "y-38": -1.435,
    "y-39": -1.435,
    "y-40": -1.435,
    "y-41": -1.435,
    "y-42": -1.435,
    "y-43": -1.435,
    "y-44": -1.435,
    "y-45": -1.435,
    "y-47": -1.435,
    "y-48": -1.435,
    "y-49": -1.435,
    "y-50": -1.435,
    "y-51": -1.435,
    "y-52": -1.435,
    "y-53": -1.435,
    "y-54": -1.435,
    "y-55": -1.435,
    "y-56": -1.435,
    "y-57": -1.435,
    "y-58": -1.435,
    "y-59": -1.435,
    "y-60": -1.435,
    "y-61": -1.435,
    "y-62": -1.435,
    "y-63": -1.435,
    "y-64": -1.435,
    "y-65": -1.435,
    "y-66": -1.435,
    "y-67": -1.435,
    "y-68": -1.435,
    "y-69": -1.435,
    "y-70": -1.435,
    "y-71": -1.435,
    "y-72": -1.435,
    "y-73": -1.435,
    "y-74": -1.435,
    "y-75": -1.435,
    "y-76": -1.435,
    "y-77": -1.435,
    "y-78": -1.435,
    "y-79": -1.435,
    "y-80": -1.435,
    "y-81": -1.435,
    "y-82": -1.435,
    "y-83": -1.435,
    "y-84": -1.435,
    "y-85": -1.435,
    "y-86": -1.435,
    "y-87": -1.435,
    "y-88": -1.435,
    "y-89": -1.435,
    "y-90": -1.435,
    "y-91": -1.435,
    "y-92": -1.435,
    "y-93": -1.435,
    "y-94": -1.435,
    "y-95": -1.435,
    "y-96": -1.435,
    "y-97": -1.435,
    "y-98": -1.435,
    "y-99": -1.435,
    "y-100": -1.435,
    "y-101": -1.435,
    "y-102": -1.435,
    "y-103": -1.435,
    "y-104": -1.435,
    "y-105": -1.435,
    "y-106": -1.435,
    "y-107": -1.435,
    "y-108": -1.435,
    "y-109": -1.435,
    "y-110": -1.435,
    "y-111": -1.435,
    "y-112": -1.435,
    "y-113": -1.435,
    "y-114": -1.435,
    "y-115": -1.435,
    "y-116": -1.435,
    "y-117": -1.435,
    "y-118": -1.435,
    "y-119": -1.435,
    "y-120": -1.435,
    "y-121": -1.435,
    "y-122": -1.435,
    "y-123": -1.435,
    "y-124": -1.435,
    "y-125": -1.435,
    "y-126": -1.435,
    "y-127": -1.435,
    "y-128": -1.435,
    "y-129": -1.435,
    "y-130": -1.435,
    "y-131": -1.435,
    "y-132": -1.435,
    "y-133": -1.435,
    "y-134": -1.435,
    "y-135": -1.435,
    "y-136": -1.435,
    "y-137": -1.435,
    "y-138": -1.435,
    "y-139": -1.435,
    "y-140": -1.435,
    "y-141": -1.435,
    "y-142": -1.435,
    "y-143": -1.435,
    "y-144": -1.435,
    "y-145": -1.435,
    "y-146": -1.435,
    "y-147": -1.435,
    "y-148": -1.435,
    "y-149": -1.435,
    "y-150": -1.435,
    "y-151": -1.435,
    "y-152": -1.435,
    "y-153": -1.435,
    "y-154": -1.435,
    "y-155": -1.435,
    "y-156": -1.431,
    "y-157": -1.431,
    "y-158": -1.431,
    "y-159": -1.43,
    "y-160": -1.43,
    "y-161": -1.43,
    "y-162": -1.43,
    "y-163": -1.43,
    "y-164": -1.43,
    "y-165": -1.43,
    "y-166": -1.43,
    "y-167": -1.43,
    "y-168": -1.43,
    "y-169": -1.43,
    "y-170": -1.43,
    "y-171": -1.43,
    "y-172": -1.43,
    "y-173": -1.43,
    "y-174": -1.43,
    "y-175": -1.43,
    "y-176": -1.43,
    "y-177": -1.43,
    "y-178": -1.43,
    "y-179": -1.43,
    "y-180": -1.43,
    "y-181": -1.43,
    "y-182": -1.43,
    "y-183": -1.43,
    "y-184": -1.43,
    "y-185": -1.43,
    "y-186": -1.43,
    "y-187": -1.43,
    "y-188": -1.43,
    "y-189": -1.43,
    "y-190": -1.43,
    "y-191": -1.43,
    "y-192": -1.43,
    "y-193": -1.43,
    "y-194": -1.43,
    "y-195": -1.43,
    "y-196": -1.43,
    "y-197": -1.43,
    "y-198": -1.43,
    "y-199": -1.43,
    "y-200": -1.43,
    "y-201": -1.43,
    "y-202": -1.43,
    "y-203": -1.43,
    "y-204": -1.43,
    "y-205": -1.43,
    "y-206": -1.43,
    "y-207": -1.43,
    "y-208": -1.43,
    "y-209": -1.43,
    "y-210": -1.43,
    "y-211": -1.43,
    "y-212": -1.43,
    "y-213": -1.43,
    "y-214": -1.43,
    "y-215": -1.43,
    "y-216": -1.43,
    "y-217": -1.43,
    "y-218": -1.43,
    "y-219": -1.43,
    "y-220": -1.43,
    "y-221": -1.43,
    "y-222": -1.43,
    "y-223": -1.43,
    "y-224": -1.43,
    "y-225": -1.43,
    "y-226": -1.43,
    "y-227": -1.43,
    "y-228": -1.43,
    "y-229": -1.43,
    "y-230": -1.43,
    "y-231": -1.43,
    "y-232": -1.429,
    "y-233": -1.429,
    "y-234": -1.429,
    "y-235": -1.429,
    "y-236": -1.429,
    "y-237": -1.429,
    "y-238": -1.429,
    "y-239": -1.429,
    "y-240": -1.429,
    "y-241": -1.429,
    "y-242": -1.429,
    "y-243": -1.429,
    "y-244": -1.429,
    "y-245": -1.429,
    "y-246": -1.429,
    "y-247": -1.429,
    "y-248": -1.429,
    "y-249": -1.429,
    "y-250": -1.429,
    "y-251": -1.429,
    "y-252": -1.429,
    "y-253": -1.429,
    "y-254": -1.429,
    "y-255": -1.429,
  },
  {
    x: 0.55,
    "y-2": -0.627,
    "y-12": -1.526,
    "y-46": -1.491,
    "y-1000": -1.483,
    "y-0": -0.165,
    "y-1": -0.827,
    "y-3": -1.22,
    "y-4": -1.208,
    "y-5": -1.206,
    "y-6": -1.206,
    "y-7": -1.207,
    "y-8": -1.209,
    "y-9": -1.209,
    "y-10": -1.532,
    "y-11": -1.528,
    "y-13": -1.526,
    "y-14": -1.518,
    "y-15": -1.461,
    "y-16": -1.461,
    "y-17": -1.46,
    "y-18": -1.458,
    "y-19": -1.458,
    "y-20": -1.499,
    "y-21": -1.499,
    "y-22": -1.499,
    "y-23": -1.499,
    "y-24": -1.499,
    "y-25": -1.499,
    "y-26": -1.468,
    "y-27": -1.468,
    "y-28": -1.468,
    "y-29": -1.468,
    "y-30": -1.468,
    "y-31": -1.468,
    "y-32": -1.468,
    "y-33": -1.468,
    "y-34": -1.49,
    "y-35": -1.49,
    "y-36": -1.49,
    "y-37": -1.49,
    "y-38": -1.491,
    "y-39": -1.491,
    "y-40": -1.491,
    "y-41": -1.491,
    "y-42": -1.491,
    "y-43": -1.491,
    "y-44": -1.491,
    "y-45": -1.491,
    "y-47": -1.491,
    "y-48": -1.491,
    "y-49": -1.491,
    "y-50": -1.491,
    "y-51": -1.491,
    "y-52": -1.491,
    "y-53": -1.491,
    "y-54": -1.491,
    "y-55": -1.491,
    "y-56": -1.491,
    "y-57": -1.491,
    "y-58": -1.491,
    "y-59": -1.491,
    "y-60": -1.491,
    "y-61": -1.491,
    "y-62": -1.491,
    "y-63": -1.491,
    "y-64": -1.491,
    "y-65": -1.491,
    "y-66": -1.491,
    "y-67": -1.491,
    "y-68": -1.491,
    "y-69": -1.491,
    "y-70": -1.491,
    "y-71": -1.491,
    "y-72": -1.491,
    "y-73": -1.491,
    "y-74": -1.491,
    "y-75": -1.491,
    "y-76": -1.491,
    "y-77": -1.491,
    "y-78": -1.491,
    "y-79": -1.491,
    "y-80": -1.491,
    "y-81": -1.491,
    "y-82": -1.491,
    "y-83": -1.491,
    "y-84": -1.491,
    "y-85": -1.491,
    "y-86": -1.491,
    "y-87": -1.491,
    "y-88": -1.491,
    "y-89": -1.491,
    "y-90": -1.491,
    "y-91": -1.491,
    "y-92": -1.491,
    "y-93": -1.491,
    "y-94": -1.491,
    "y-95": -1.491,
    "y-96": -1.491,
    "y-97": -1.491,
    "y-98": -1.491,
    "y-99": -1.491,
    "y-100": -1.491,
    "y-101": -1.491,
    "y-102": -1.491,
    "y-103": -1.491,
    "y-104": -1.491,
    "y-105": -1.491,
    "y-106": -1.491,
    "y-107": -1.491,
    "y-108": -1.491,
    "y-109": -1.491,
    "y-110": -1.491,
    "y-111": -1.491,
    "y-112": -1.491,
    "y-113": -1.491,
    "y-114": -1.491,
    "y-115": -1.491,
    "y-116": -1.491,
    "y-117": -1.491,
    "y-118": -1.491,
    "y-119": -1.491,
    "y-120": -1.491,
    "y-121": -1.491,
    "y-122": -1.491,
    "y-123": -1.491,
    "y-124": -1.491,
    "y-125": -1.491,
    "y-126": -1.491,
    "y-127": -1.491,
    "y-128": -1.491,
    "y-129": -1.491,
    "y-130": -1.491,
    "y-131": -1.491,
    "y-132": -1.491,
    "y-133": -1.491,
    "y-134": -1.491,
    "y-135": -1.491,
    "y-136": -1.491,
    "y-137": -1.491,
    "y-138": -1.491,
    "y-139": -1.491,
    "y-140": -1.491,
    "y-141": -1.491,
    "y-142": -1.491,
    "y-143": -1.491,
    "y-144": -1.491,
    "y-145": -1.491,
    "y-146": -1.491,
    "y-147": -1.491,
    "y-148": -1.491,
    "y-149": -1.491,
    "y-150": -1.491,
    "y-151": -1.491,
    "y-152": -1.491,
    "y-153": -1.491,
    "y-154": -1.491,
    "y-155": -1.491,
    "y-156": -1.485,
    "y-157": -1.485,
    "y-158": -1.485,
    "y-159": -1.484,
    "y-160": -1.484,
    "y-161": -1.484,
    "y-162": -1.484,
    "y-163": -1.484,
    "y-164": -1.484,
    "y-165": -1.484,
    "y-166": -1.484,
    "y-167": -1.484,
    "y-168": -1.484,
    "y-169": -1.484,
    "y-170": -1.484,
    "y-171": -1.484,
    "y-172": -1.484,
    "y-173": -1.484,
    "y-174": -1.484,
    "y-175": -1.484,
    "y-176": -1.484,
    "y-177": -1.484,
    "y-178": -1.484,
    "y-179": -1.484,
    "y-180": -1.484,
    "y-181": -1.484,
    "y-182": -1.484,
    "y-183": -1.484,
    "y-184": -1.484,
    "y-185": -1.484,
    "y-186": -1.484,
    "y-187": -1.484,
    "y-188": -1.484,
    "y-189": -1.484,
    "y-190": -1.484,
    "y-191": -1.484,
    "y-192": -1.484,
    "y-193": -1.484,
    "y-194": -1.484,
    "y-195": -1.484,
    "y-196": -1.484,
    "y-197": -1.484,
    "y-198": -1.484,
    "y-199": -1.484,
    "y-200": -1.484,
    "y-201": -1.484,
    "y-202": -1.484,
    "y-203": -1.484,
    "y-204": -1.484,
    "y-205": -1.484,
    "y-206": -1.484,
    "y-207": -1.484,
    "y-208": -1.484,
    "y-209": -1.484,
    "y-210": -1.484,
    "y-211": -1.484,
    "y-212": -1.484,
    "y-213": -1.484,
    "y-214": -1.484,
    "y-215": -1.484,
    "y-216": -1.484,
    "y-217": -1.484,
    "y-218": -1.484,
    "y-219": -1.484,
    "y-220": -1.484,
    "y-221": -1.484,
    "y-222": -1.484,
    "y-223": -1.484,
    "y-224": -1.484,
    "y-225": -1.484,
    "y-226": -1.484,
    "y-227": -1.484,
    "y-228": -1.484,
    "y-229": -1.484,
    "y-230": -1.484,
    "y-231": -1.484,
    "y-232": -1.483,
    "y-233": -1.483,
    "y-234": -1.483,
    "y-235": -1.483,
    "y-236": -1.483,
    "y-237": -1.483,
    "y-238": -1.483,
    "y-239": -1.483,
    "y-240": -1.483,
    "y-241": -1.483,
    "y-242": -1.483,
    "y-243": -1.483,
    "y-244": -1.483,
    "y-245": -1.483,
    "y-246": -1.483,
    "y-247": -1.483,
    "y-248": -1.483,
    "y-249": -1.483,
    "y-250": -1.483,
    "y-251": -1.483,
    "y-252": -1.483,
    "y-253": -1.483,
    "y-254": -1.483,
    "y-255": -1.483,
  },
  {
    x: 0.575,
    "y-2": -0.648,
    "y-12": -1.59,
    "y-46": -1.537,
    "y-1000": -1.534,
    "y-0": -0.177,
    "y-1": -0.852,
    "y-3": -1.296,
    "y-4": -1.269,
    "y-5": -1.26,
    "y-6": -1.261,
    "y-7": -1.261,
    "y-8": -1.262,
    "y-9": -1.262,
    "y-10": -1.602,
    "y-11": -1.593,
    "y-13": -1.59,
    "y-14": -1.584,
    "y-15": -1.513,
    "y-16": -1.513,
    "y-17": -1.511,
    "y-18": -1.509,
    "y-19": -1.509,
    "y-20": -1.537,
    "y-21": -1.537,
    "y-22": -1.537,
    "y-23": -1.537,
    "y-24": -1.537,
    "y-25": -1.537,
    "y-26": -1.537,
    "y-27": -1.537,
    "y-28": -1.537,
    "y-29": -1.537,
    "y-30": -1.537,
    "y-31": -1.537,
    "y-32": -1.537,
    "y-33": -1.537,
    "y-34": -1.537,
    "y-35": -1.537,
    "y-36": -1.537,
    "y-37": -1.537,
    "y-38": -1.537,
    "y-39": -1.537,
    "y-40": -1.537,
    "y-41": -1.537,
    "y-42": -1.537,
    "y-43": -1.537,
    "y-44": -1.537,
    "y-45": -1.537,
    "y-47": -1.537,
    "y-48": -1.537,
    "y-49": -1.537,
    "y-50": -1.537,
    "y-51": -1.537,
    "y-52": -1.537,
    "y-53": -1.537,
    "y-54": -1.537,
    "y-55": -1.537,
    "y-56": -1.537,
    "y-57": -1.537,
    "y-58": -1.537,
    "y-59": -1.537,
    "y-60": -1.537,
    "y-61": -1.537,
    "y-62": -1.537,
    "y-63": -1.537,
    "y-64": -1.537,
    "y-65": -1.537,
    "y-66": -1.537,
    "y-67": -1.537,
    "y-68": -1.537,
    "y-69": -1.537,
    "y-70": -1.537,
    "y-71": -1.538,
    "y-72": -1.539,
    "y-73": -1.538,
    "y-74": -1.538,
    "y-75": -1.539,
    "y-76": -1.539,
    "y-77": -1.538,
    "y-78": -1.539,
    "y-79": -1.539,
    "y-80": -1.54,
    "y-81": -1.539,
    "y-82": -1.539,
    "y-83": -1.539,
    "y-84": -1.539,
    "y-85": -1.538,
    "y-86": -1.539,
    "y-87": -1.539,
    "y-88": -1.539,
    "y-89": -1.539,
    "y-90": -1.539,
    "y-91": -1.539,
    "y-92": -1.539,
    "y-93": -1.539,
    "y-94": -1.539,
    "y-95": -1.539,
    "y-96": -1.539,
    "y-97": -1.539,
    "y-98": -1.539,
    "y-99": -1.539,
    "y-100": -1.539,
    "y-101": -1.538,
    "y-102": -1.539,
    "y-103": -1.539,
    "y-104": -1.539,
    "y-105": -1.539,
    "y-106": -1.539,
    "y-107": -1.539,
    "y-108": -1.539,
    "y-109": -1.539,
    "y-110": -1.539,
    "y-111": -1.539,
    "y-112": -1.539,
    "y-113": -1.539,
    "y-114": -1.539,
    "y-115": -1.539,
    "y-116": -1.539,
    "y-117": -1.539,
    "y-118": -1.539,
    "y-119": -1.539,
    "y-120": -1.539,
    "y-121": -1.539,
    "y-122": -1.539,
    "y-123": -1.539,
    "y-124": -1.539,
    "y-125": -1.539,
    "y-126": -1.539,
    "y-127": -1.539,
    "y-128": -1.539,
    "y-129": -1.539,
    "y-130": -1.539,
    "y-131": -1.539,
    "y-132": -1.539,
    "y-133": -1.539,
    "y-134": -1.539,
    "y-135": -1.539,
    "y-136": -1.539,
    "y-137": -1.539,
    "y-138": -1.539,
    "y-139": -1.54,
    "y-140": -1.54,
    "y-141": -1.54,
    "y-142": -1.54,
    "y-143": -1.54,
    "y-144": -1.54,
    "y-145": -1.54,
    "y-146": -1.54,
    "y-147": -1.54,
    "y-148": -1.54,
    "y-149": -1.54,
    "y-150": -1.54,
    "y-151": -1.54,
    "y-152": -1.54,
    "y-153": -1.54,
    "y-154": -1.54,
    "y-155": -1.539,
    "y-156": -1.536,
    "y-157": -1.536,
    "y-158": -1.536,
    "y-159": -1.535,
    "y-160": -1.535,
    "y-161": -1.535,
    "y-162": -1.535,
    "y-163": -1.535,
    "y-164": -1.535,
    "y-165": -1.535,
    "y-166": -1.535,
    "y-167": -1.535,
    "y-168": -1.535,
    "y-169": -1.535,
    "y-170": -1.535,
    "y-171": -1.535,
    "y-172": -1.535,
    "y-173": -1.536,
    "y-174": -1.536,
    "y-175": -1.536,
    "y-176": -1.536,
    "y-177": -1.536,
    "y-178": -1.536,
    "y-179": -1.536,
    "y-180": -1.536,
    "y-181": -1.536,
    "y-182": -1.536,
    "y-183": -1.536,
    "y-184": -1.536,
    "y-185": -1.536,
    "y-186": -1.536,
    "y-187": -1.536,
    "y-188": -1.536,
    "y-189": -1.536,
    "y-190": -1.536,
    "y-191": -1.536,
    "y-192": -1.535,
    "y-193": -1.535,
    "y-194": -1.535,
    "y-195": -1.535,
    "y-196": -1.535,
    "y-197": -1.535,
    "y-198": -1.535,
    "y-199": -1.535,
    "y-200": -1.535,
    "y-201": -1.535,
    "y-202": -1.535,
    "y-203": -1.535,
    "y-204": -1.535,
    "y-205": -1.535,
    "y-206": -1.535,
    "y-207": -1.535,
    "y-208": -1.535,
    "y-209": -1.535,
    "y-210": -1.535,
    "y-211": -1.535,
    "y-212": -1.535,
    "y-213": -1.535,
    "y-214": -1.535,
    "y-215": -1.535,
    "y-216": -1.535,
    "y-217": -1.535,
    "y-218": -1.535,
    "y-219": -1.535,
    "y-220": -1.535,
    "y-221": -1.535,
    "y-222": -1.535,
    "y-223": -1.535,
    "y-224": -1.535,
    "y-225": -1.535,
    "y-226": -1.535,
    "y-227": -1.535,
    "y-228": -1.535,
    "y-229": -1.535,
    "y-230": -1.535,
    "y-231": -1.535,
    "y-232": -1.535,
    "y-233": -1.535,
    "y-234": -1.535,
    "y-235": -1.535,
    "y-236": -1.535,
    "y-237": -1.535,
    "y-238": -1.535,
    "y-239": -1.535,
    "y-240": -1.535,
    "y-241": -1.535,
    "y-242": -1.535,
    "y-243": -1.535,
    "y-244": -1.535,
    "y-245": -1.535,
    "y-246": -1.535,
    "y-247": -1.535,
    "y-248": -1.535,
    "y-249": -1.535,
    "y-250": -1.535,
    "y-251": -1.535,
    "y-252": -1.535,
    "y-253": -1.534,
    "y-254": -1.534,
    "y-255": -1.534,
  },
  {
    x: 0.6,
    "y-2": -0.669,
    "y-12": -1.654,
    "y-46": -1.584,
    "y-1000": -1.584,
    "y-0": -0.189,
    "y-1": -0.876,
    "y-3": -1.372,
    "y-4": -1.329,
    "y-5": -1.315,
    "y-6": -1.315,
    "y-7": -1.315,
    "y-8": -1.315,
    "y-9": -1.315,
    "y-10": -1.672,
    "y-11": -1.657,
    "y-13": -1.654,
    "y-14": -1.651,
    "y-15": -1.564,
    "y-16": -1.564,
    "y-17": -1.563,
    "y-18": -1.559,
    "y-19": -1.559,
    "y-20": -1.575,
    "y-21": -1.575,
    "y-22": -1.575,
    "y-23": -1.575,
    "y-24": -1.575,
    "y-25": -1.575,
    "y-26": -1.606,
    "y-27": -1.606,
    "y-28": -1.606,
    "y-29": -1.606,
    "y-30": -1.606,
    "y-31": -1.606,
    "y-32": -1.606,
    "y-33": -1.606,
    "y-34": -1.584,
    "y-35": -1.584,
    "y-36": -1.584,
    "y-37": -1.584,
    "y-38": -1.584,
    "y-39": -1.584,
    "y-40": -1.584,
    "y-41": -1.584,
    "y-42": -1.584,
    "y-43": -1.584,
    "y-44": -1.584,
    "y-45": -1.584,
    "y-47": -1.584,
    "y-48": -1.584,
    "y-49": -1.584,
    "y-50": -1.584,
    "y-51": -1.584,
    "y-52": -1.584,
    "y-53": -1.584,
    "y-54": -1.584,
    "y-55": -1.584,
    "y-56": -1.584,
    "y-57": -1.584,
    "y-58": -1.584,
    "y-59": -1.584,
    "y-60": -1.584,
    "y-61": -1.584,
    "y-62": -1.584,
    "y-63": -1.584,
    "y-64": -1.584,
    "y-65": -1.584,
    "y-66": -1.584,
    "y-67": -1.584,
    "y-68": -1.584,
    "y-69": -1.584,
    "y-70": -1.584,
    "y-71": -1.584,
    "y-72": -1.584,
    "y-73": -1.584,
    "y-74": -1.584,
    "y-75": -1.584,
    "y-76": -1.584,
    "y-77": -1.584,
    "y-78": -1.584,
    "y-79": -1.584,
    "y-80": -1.584,
    "y-81": -1.584,
    "y-82": -1.584,
    "y-83": -1.584,
    "y-84": -1.584,
    "y-85": -1.584,
    "y-86": -1.584,
    "y-87": -1.584,
    "y-88": -1.584,
    "y-89": -1.584,
    "y-90": -1.584,
    "y-91": -1.584,
    "y-92": -1.584,
    "y-93": -1.584,
    "y-94": -1.584,
    "y-95": -1.584,
    "y-96": -1.584,
    "y-97": -1.584,
    "y-98": -1.584,
    "y-99": -1.584,
    "y-100": -1.584,
    "y-101": -1.584,
    "y-102": -1.584,
    "y-103": -1.584,
    "y-104": -1.584,
    "y-105": -1.584,
    "y-106": -1.584,
    "y-107": -1.584,
    "y-108": -1.584,
    "y-109": -1.584,
    "y-110": -1.584,
    "y-111": -1.584,
    "y-112": -1.584,
    "y-113": -1.584,
    "y-114": -1.584,
    "y-115": -1.584,
    "y-116": -1.584,
    "y-117": -1.584,
    "y-118": -1.584,
    "y-119": -1.584,
    "y-120": -1.584,
    "y-121": -1.584,
    "y-122": -1.584,
    "y-123": -1.584,
    "y-124": -1.584,
    "y-125": -1.584,
    "y-126": -1.584,
    "y-127": -1.584,
    "y-128": -1.584,
    "y-129": -1.584,
    "y-130": -1.584,
    "y-131": -1.584,
    "y-132": -1.584,
    "y-133": -1.584,
    "y-134": -1.584,
    "y-135": -1.584,
    "y-136": -1.584,
    "y-137": -1.584,
    "y-138": -1.584,
    "y-139": -1.584,
    "y-140": -1.584,
    "y-141": -1.584,
    "y-142": -1.584,
    "y-143": -1.584,
    "y-144": -1.584,
    "y-145": -1.584,
    "y-146": -1.584,
    "y-147": -1.584,
    "y-148": -1.584,
    "y-149": -1.584,
    "y-150": -1.584,
    "y-151": -1.584,
    "y-152": -1.584,
    "y-153": -1.584,
    "y-154": -1.584,
    "y-155": -1.584,
    "y-156": -1.584,
    "y-157": -1.584,
    "y-158": -1.584,
    "y-159": -1.584,
    "y-160": -1.584,
    "y-161": -1.584,
    "y-162": -1.584,
    "y-163": -1.584,
    "y-164": -1.584,
    "y-165": -1.584,
    "y-166": -1.584,
    "y-167": -1.584,
    "y-168": -1.584,
    "y-169": -1.584,
    "y-170": -1.584,
    "y-171": -1.584,
    "y-172": -1.584,
    "y-173": -1.584,
    "y-174": -1.584,
    "y-175": -1.584,
    "y-176": -1.584,
    "y-177": -1.584,
    "y-178": -1.584,
    "y-179": -1.584,
    "y-180": -1.584,
    "y-181": -1.584,
    "y-182": -1.584,
    "y-183": -1.584,
    "y-184": -1.584,
    "y-185": -1.584,
    "y-186": -1.584,
    "y-187": -1.584,
    "y-188": -1.584,
    "y-189": -1.584,
    "y-190": -1.584,
    "y-191": -1.584,
    "y-192": -1.584,
    "y-193": -1.584,
    "y-194": -1.584,
    "y-195": -1.584,
    "y-196": -1.584,
    "y-197": -1.584,
    "y-198": -1.584,
    "y-199": -1.584,
    "y-200": -1.584,
    "y-201": -1.584,
    "y-202": -1.584,
    "y-203": -1.584,
    "y-204": -1.584,
    "y-205": -1.584,
    "y-206": -1.584,
    "y-207": -1.584,
    "y-208": -1.584,
    "y-209": -1.584,
    "y-210": -1.584,
    "y-211": -1.584,
    "y-212": -1.584,
    "y-213": -1.584,
    "y-214": -1.584,
    "y-215": -1.584,
    "y-216": -1.584,
    "y-217": -1.584,
    "y-218": -1.584,
    "y-219": -1.584,
    "y-220": -1.584,
    "y-221": -1.584,
    "y-222": -1.584,
    "y-223": -1.584,
    "y-224": -1.584,
    "y-225": -1.584,
    "y-226": -1.584,
    "y-227": -1.584,
    "y-228": -1.584,
    "y-229": -1.584,
    "y-230": -1.584,
    "y-231": -1.584,
    "y-232": -1.584,
    "y-233": -1.584,
    "y-234": -1.584,
    "y-235": -1.584,
    "y-236": -1.584,
    "y-237": -1.584,
    "y-238": -1.584,
    "y-239": -1.584,
    "y-240": -1.584,
    "y-241": -1.584,
    "y-242": -1.584,
    "y-243": -1.584,
    "y-244": -1.584,
    "y-245": -1.584,
    "y-246": -1.584,
    "y-247": -1.584,
    "y-248": -1.584,
    "y-249": -1.584,
    "y-250": -1.584,
    "y-251": -1.584,
    "y-252": -1.584,
    "y-253": -1.584,
    "y-254": -1.584,
    "y-255": -1.584,
  },
  {
    x: 0.625,
    "y-2": -0.691,
    "y-12": -1.718,
    "y-46": -1.631,
    "y-1000": -1.632,
    "y-0": -0.202,
    "y-1": -0.901,
    "y-3": -1.447,
    "y-4": -1.39,
    "y-5": -1.37,
    "y-6": -1.369,
    "y-7": -1.369,
    "y-8": -1.368,
    "y-9": -1.368,
    "y-10": -1.742,
    "y-11": -1.722,
    "y-13": -1.718,
    "y-14": -1.718,
    "y-15": -1.615,
    "y-16": -1.615,
    "y-17": -1.614,
    "y-18": -1.61,
    "y-19": -1.61,
    "y-20": -1.613,
    "y-21": -1.613,
    "y-22": -1.613,
    "y-23": -1.613,
    "y-24": -1.613,
    "y-25": -1.613,
    "y-26": -1.676,
    "y-27": -1.676,
    "y-28": -1.676,
    "y-29": -1.676,
    "y-30": -1.676,
    "y-31": -1.676,
    "y-32": -1.676,
    "y-33": -1.676,
    "y-34": -1.631,
    "y-35": -1.631,
    "y-36": -1.631,
    "y-37": -1.631,
    "y-38": -1.631,
    "y-39": -1.631,
    "y-40": -1.631,
    "y-41": -1.631,
    "y-42": -1.631,
    "y-43": -1.631,
    "y-44": -1.631,
    "y-45": -1.631,
    "y-47": -1.69,
    "y-48": -1.688,
    "y-49": -1.686,
    "y-50": -1.634,
    "y-51": -1.635,
    "y-52": -1.64,
    "y-53": -1.638,
    "y-54": -1.637,
    "y-55": -1.639,
    "y-56": -1.637,
    "y-57": -1.632,
    "y-58": -1.641,
    "y-59": -1.637,
    "y-60": -1.636,
    "y-61": -1.635,
    "y-62": -1.637,
    "y-63": -1.637,
    "y-64": -1.636,
    "y-65": -1.634,
    "y-66": -1.634,
    "y-67": -1.635,
    "y-68": -1.636,
    "y-69": -1.634,
    "y-70": -1.633,
    "y-71": -1.631,
    "y-72": -1.632,
    "y-73": -1.633,
    "y-74": -1.633,
    "y-75": -1.633,
    "y-76": -1.632,
    "y-77": -1.634,
    "y-78": -1.631,
    "y-79": -1.631,
    "y-80": -1.633,
    "y-81": -1.632,
    "y-82": -1.631,
    "y-83": -1.632,
    "y-84": -1.632,
    "y-85": -1.633,
    "y-86": -1.632,
    "y-87": -1.632,
    "y-88": -1.632,
    "y-89": -1.632,
    "y-90": -1.632,
    "y-91": -1.633,
    "y-92": -1.633,
    "y-93": -1.631,
    "y-94": -1.633,
    "y-95": -1.631,
    "y-96": -1.632,
    "y-97": -1.633,
    "y-98": -1.632,
    "y-99": -1.633,
    "y-100": -1.632,
    "y-101": -1.633,
    "y-102": -1.632,
    "y-103": -1.633,
    "y-104": -1.632,
    "y-105": -1.633,
    "y-106": -1.633,
    "y-107": -1.633,
    "y-108": -1.633,
    "y-109": -1.633,
    "y-110": -1.633,
    "y-111": -1.633,
    "y-112": -1.632,
    "y-113": -1.632,
    "y-114": -1.632,
    "y-115": -1.633,
    "y-116": -1.632,
    "y-117": -1.632,
    "y-118": -1.633,
    "y-119": -1.633,
    "y-120": -1.633,
    "y-121": -1.633,
    "y-122": -1.633,
    "y-123": -1.633,
    "y-124": -1.633,
    "y-125": -1.633,
    "y-126": -1.633,
    "y-127": -1.633,
    "y-128": -1.633,
    "y-129": -1.633,
    "y-130": -1.633,
    "y-131": -1.633,
    "y-132": -1.63,
    "y-133": -1.63,
    "y-134": -1.63,
    "y-135": -1.63,
    "y-136": -1.63,
    "y-137": -1.63,
    "y-138": -1.63,
    "y-139": -1.629,
    "y-140": -1.629,
    "y-141": -1.629,
    "y-142": -1.629,
    "y-143": -1.629,
    "y-144": -1.629,
    "y-145": -1.629,
    "y-146": -1.629,
    "y-147": -1.629,
    "y-148": -1.629,
    "y-149": -1.629,
    "y-150": -1.629,
    "y-151": -1.629,
    "y-152": -1.629,
    "y-153": -1.629,
    "y-154": -1.629,
    "y-155": -1.63,
    "y-156": -1.63,
    "y-157": -1.63,
    "y-158": -1.63,
    "y-159": -1.63,
    "y-160": -1.63,
    "y-161": -1.63,
    "y-162": -1.63,
    "y-163": -1.63,
    "y-164": -1.63,
    "y-165": -1.63,
    "y-166": -1.63,
    "y-167": -1.63,
    "y-168": -1.63,
    "y-169": -1.63,
    "y-170": -1.63,
    "y-171": -1.63,
    "y-172": -1.63,
    "y-173": -1.63,
    "y-174": -1.63,
    "y-175": -1.63,
    "y-176": -1.63,
    "y-177": -1.63,
    "y-178": -1.63,
    "y-179": -1.63,
    "y-180": -1.63,
    "y-181": -1.63,
    "y-182": -1.63,
    "y-183": -1.63,
    "y-184": -1.63,
    "y-185": -1.63,
    "y-186": -1.63,
    "y-187": -1.63,
    "y-188": -1.63,
    "y-189": -1.63,
    "y-190": -1.63,
    "y-191": -1.63,
    "y-192": -1.631,
    "y-193": -1.631,
    "y-194": -1.631,
    "y-195": -1.631,
    "y-196": -1.631,
    "y-197": -1.631,
    "y-198": -1.631,
    "y-199": -1.631,
    "y-200": -1.631,
    "y-201": -1.631,
    "y-202": -1.631,
    "y-203": -1.631,
    "y-204": -1.631,
    "y-205": -1.631,
    "y-206": -1.631,
    "y-207": -1.631,
    "y-208": -1.631,
    "y-209": -1.631,
    "y-210": -1.631,
    "y-211": -1.631,
    "y-212": -1.631,
    "y-213": -1.631,
    "y-214": -1.631,
    "y-215": -1.631,
    "y-216": -1.631,
    "y-217": -1.631,
    "y-218": -1.631,
    "y-219": -1.631,
    "y-220": -1.631,
    "y-221": -1.631,
    "y-222": -1.631,
    "y-223": -1.631,
    "y-224": -1.631,
    "y-225": -1.631,
    "y-226": -1.631,
    "y-227": -1.631,
    "y-228": -1.631,
    "y-229": -1.631,
    "y-230": -1.631,
    "y-231": -1.631,
    "y-232": -1.631,
    "y-233": -1.631,
    "y-234": -1.631,
    "y-235": -1.631,
    "y-236": -1.631,
    "y-237": -1.631,
    "y-238": -1.631,
    "y-239": -1.631,
    "y-240": -1.631,
    "y-241": -1.631,
    "y-242": -1.631,
    "y-243": -1.631,
    "y-244": -1.631,
    "y-245": -1.631,
    "y-246": -1.631,
    "y-247": -1.631,
    "y-248": -1.631,
    "y-249": -1.631,
    "y-250": -1.631,
    "y-251": -1.631,
    "y-252": -1.631,
    "y-253": -1.631,
    "y-254": -1.631,
    "y-255": -1.631,
  },
  {
    x: 0.65,
    "y-2": -0.712,
    "y-12": -1.782,
    "y-46": -1.677,
    "y-1000": -1.679,
    "y-0": -0.214,
    "y-1": -0.925,
    "y-3": -1.523,
    "y-4": -1.451,
    "y-5": -1.424,
    "y-6": -1.424,
    "y-7": -1.423,
    "y-8": -1.421,
    "y-9": -1.421,
    "y-10": -1.812,
    "y-11": -1.786,
    "y-13": -1.782,
    "y-14": -1.785,
    "y-15": -1.667,
    "y-16": -1.667,
    "y-17": -1.665,
    "y-18": -1.661,
    "y-19": -1.661,
    "y-20": -1.651,
    "y-21": -1.651,
    "y-22": -1.651,
    "y-23": -1.651,
    "y-24": -1.651,
    "y-25": -1.651,
    "y-26": -1.745,
    "y-27": -1.745,
    "y-28": -1.745,
    "y-29": -1.745,
    "y-30": -1.745,
    "y-31": -1.745,
    "y-32": -1.745,
    "y-33": -1.745,
    "y-34": -1.678,
    "y-35": -1.678,
    "y-36": -1.678,
    "y-37": -1.678,
    "y-38": -1.677,
    "y-39": -1.677,
    "y-40": -1.677,
    "y-41": -1.677,
    "y-42": -1.677,
    "y-43": -1.677,
    "y-44": -1.677,
    "y-45": -1.677,
    "y-47": -1.806,
    "y-48": -1.802,
    "y-49": -1.798,
    "y-50": -1.684,
    "y-51": -1.686,
    "y-52": -1.699,
    "y-53": -1.694,
    "y-54": -1.691,
    "y-55": -1.695,
    "y-56": -1.692,
    "y-57": -1.68,
    "y-58": -1.701,
    "y-59": -1.692,
    "y-60": -1.688,
    "y-61": -1.688,
    "y-62": -1.691,
    "y-63": -1.691,
    "y-64": -1.689,
    "y-65": -1.685,
    "y-66": -1.684,
    "y-67": -1.687,
    "y-68": -1.688,
    "y-69": -1.684,
    "y-70": -1.682,
    "y-71": -1.678,
    "y-72": -1.681,
    "y-73": -1.682,
    "y-74": -1.682,
    "y-75": -1.682,
    "y-76": -1.681,
    "y-77": -1.684,
    "y-78": -1.678,
    "y-79": -1.678,
    "y-80": -1.683,
    "y-81": -1.68,
    "y-82": -1.679,
    "y-83": -1.681,
    "y-84": -1.681,
    "y-85": -1.682,
    "y-86": -1.681,
    "y-87": -1.681,
    "y-88": -1.681,
    "y-89": -1.681,
    "y-90": -1.681,
    "y-91": -1.682,
    "y-92": -1.682,
    "y-93": -1.679,
    "y-94": -1.683,
    "y-95": -1.679,
    "y-96": -1.68,
    "y-97": -1.682,
    "y-98": -1.681,
    "y-99": -1.684,
    "y-100": -1.681,
    "y-101": -1.683,
    "y-102": -1.681,
    "y-103": -1.683,
    "y-104": -1.68,
    "y-105": -1.683,
    "y-106": -1.682,
    "y-107": -1.681,
    "y-108": -1.682,
    "y-109": -1.681,
    "y-110": -1.681,
    "y-111": -1.682,
    "y-112": -1.681,
    "y-113": -1.681,
    "y-114": -1.681,
    "y-115": -1.682,
    "y-116": -1.681,
    "y-117": -1.681,
    "y-118": -1.681,
    "y-119": -1.682,
    "y-120": -1.682,
    "y-121": -1.682,
    "y-122": -1.682,
    "y-123": -1.682,
    "y-124": -1.682,
    "y-125": -1.682,
    "y-126": -1.682,
    "y-127": -1.682,
    "y-128": -1.682,
    "y-129": -1.682,
    "y-130": -1.682,
    "y-131": -1.682,
    "y-132": -1.676,
    "y-133": -1.676,
    "y-134": -1.676,
    "y-135": -1.676,
    "y-136": -1.676,
    "y-137": -1.676,
    "y-138": -1.676,
    "y-139": -1.675,
    "y-140": -1.675,
    "y-141": -1.675,
    "y-142": -1.675,
    "y-143": -1.675,
    "y-144": -1.675,
    "y-145": -1.675,
    "y-146": -1.675,
    "y-147": -1.675,
    "y-148": -1.675,
    "y-149": -1.675,
    "y-150": -1.675,
    "y-151": -1.675,
    "y-152": -1.675,
    "y-153": -1.675,
    "y-154": -1.675,
    "y-155": -1.676,
    "y-156": -1.676,
    "y-157": -1.676,
    "y-158": -1.676,
    "y-159": -1.676,
    "y-160": -1.676,
    "y-161": -1.676,
    "y-162": -1.676,
    "y-163": -1.676,
    "y-164": -1.676,
    "y-165": -1.676,
    "y-166": -1.676,
    "y-167": -1.676,
    "y-168": -1.676,
    "y-169": -1.676,
    "y-170": -1.676,
    "y-171": -1.676,
    "y-172": -1.676,
    "y-173": -1.676,
    "y-174": -1.676,
    "y-175": -1.676,
    "y-176": -1.676,
    "y-177": -1.676,
    "y-178": -1.676,
    "y-179": -1.675,
    "y-180": -1.675,
    "y-181": -1.675,
    "y-182": -1.675,
    "y-183": -1.675,
    "y-184": -1.675,
    "y-185": -1.675,
    "y-186": -1.675,
    "y-187": -1.675,
    "y-188": -1.675,
    "y-189": -1.675,
    "y-190": -1.675,
    "y-191": -1.675,
    "y-192": -1.678,
    "y-193": -1.678,
    "y-194": -1.678,
    "y-195": -1.678,
    "y-196": -1.678,
    "y-197": -1.678,
    "y-198": -1.678,
    "y-199": -1.678,
    "y-200": -1.678,
    "y-201": -1.678,
    "y-202": -1.678,
    "y-203": -1.678,
    "y-204": -1.678,
    "y-205": -1.678,
    "y-206": -1.678,
    "y-207": -1.678,
    "y-208": -1.678,
    "y-209": -1.678,
    "y-210": -1.678,
    "y-211": -1.678,
    "y-212": -1.679,
    "y-213": -1.678,
    "y-214": -1.678,
    "y-215": -1.678,
    "y-216": -1.678,
    "y-217": -1.678,
    "y-218": -1.678,
    "y-219": -1.678,
    "y-220": -1.678,
    "y-221": -1.678,
    "y-222": -1.678,
    "y-223": -1.678,
    "y-224": -1.678,
    "y-225": -1.678,
    "y-226": -1.678,
    "y-227": -1.678,
    "y-228": -1.678,
    "y-229": -1.678,
    "y-230": -1.678,
    "y-231": -1.678,
    "y-232": -1.678,
    "y-233": -1.678,
    "y-234": -1.678,
    "y-235": -1.678,
    "y-236": -1.678,
    "y-237": -1.678,
    "y-238": -1.678,
    "y-239": -1.678,
    "y-240": -1.678,
    "y-241": -1.678,
    "y-242": -1.678,
    "y-243": -1.678,
    "y-244": -1.678,
    "y-245": -1.678,
    "y-246": -1.678,
    "y-247": -1.678,
    "y-248": -1.678,
    "y-249": -1.678,
    "y-250": -1.678,
    "y-251": -1.678,
    "y-252": -1.678,
    "y-253": -1.678,
    "y-254": -1.678,
    "y-255": -1.678,
  },
  {
    x: 0.675,
    "y-2": -0.733,
    "y-12": -1.846,
    "y-46": -1.724,
    "y-1000": -1.722,
    "y-0": -0.226,
    "y-1": -0.95,
    "y-3": -1.599,
    "y-4": -1.512,
    "y-5": -1.479,
    "y-6": -1.478,
    "y-7": -1.477,
    "y-8": -1.474,
    "y-9": -1.474,
    "y-10": -1.882,
    "y-11": -1.85,
    "y-13": -1.846,
    "y-14": -1.851,
    "y-15": -1.718,
    "y-16": -1.718,
    "y-17": -1.716,
    "y-18": -1.711,
    "y-19": -1.711,
    "y-20": -1.689,
    "y-21": -1.689,
    "y-22": -1.689,
    "y-23": -1.689,
    "y-24": -1.689,
    "y-25": -1.689,
    "y-26": -1.815,
    "y-27": -1.815,
    "y-28": -1.815,
    "y-29": -1.815,
    "y-30": -1.815,
    "y-31": -1.815,
    "y-32": -1.815,
    "y-33": -1.815,
    "y-34": -1.725,
    "y-35": -1.725,
    "y-36": -1.725,
    "y-37": -1.725,
    "y-38": -1.724,
    "y-39": -1.724,
    "y-40": -1.724,
    "y-41": -1.724,
    "y-42": -1.724,
    "y-43": -1.724,
    "y-44": -1.724,
    "y-45": -1.724,
    "y-47": -1.922,
    "y-48": -1.915,
    "y-49": -1.91,
    "y-50": -1.734,
    "y-51": -1.737,
    "y-52": -1.757,
    "y-53": -1.75,
    "y-54": -1.745,
    "y-55": -1.751,
    "y-56": -1.746,
    "y-57": -1.728,
    "y-58": -1.76,
    "y-59": -1.746,
    "y-60": -1.74,
    "y-61": -1.74,
    "y-62": -1.745,
    "y-63": -1.745,
    "y-64": -1.742,
    "y-65": -1.736,
    "y-66": -1.735,
    "y-67": -1.739,
    "y-68": -1.741,
    "y-69": -1.734,
    "y-70": -1.732,
    "y-71": -1.726,
    "y-72": -1.73,
    "y-73": -1.732,
    "y-74": -1.732,
    "y-75": -1.732,
    "y-76": -1.73,
    "y-77": -1.734,
    "y-78": -1.725,
    "y-79": -1.725,
    "y-80": -1.733,
    "y-81": -1.728,
    "y-82": -1.727,
    "y-83": -1.73,
    "y-84": -1.73,
    "y-85": -1.732,
    "y-86": -1.73,
    "y-87": -1.73,
    "y-88": -1.73,
    "y-89": -1.729,
    "y-90": -1.73,
    "y-91": -1.731,
    "y-92": -1.731,
    "y-93": -1.727,
    "y-94": -1.732,
    "y-95": -1.726,
    "y-96": -1.729,
    "y-97": -1.731,
    "y-98": -1.729,
    "y-99": -1.734,
    "y-100": -1.73,
    "y-101": -1.733,
    "y-102": -1.729,
    "y-103": -1.733,
    "y-104": -1.729,
    "y-105": -1.732,
    "y-106": -1.731,
    "y-107": -1.73,
    "y-108": -1.731,
    "y-109": -1.73,
    "y-110": -1.73,
    "y-111": -1.731,
    "y-112": -1.729,
    "y-113": -1.73,
    "y-114": -1.73,
    "y-115": -1.731,
    "y-116": -1.729,
    "y-117": -1.729,
    "y-118": -1.73,
    "y-119": -1.731,
    "y-120": -1.732,
    "y-121": -1.73,
    "y-122": -1.731,
    "y-123": -1.731,
    "y-124": -1.731,
    "y-125": -1.731,
    "y-126": -1.731,
    "y-127": -1.731,
    "y-128": -1.731,
    "y-129": -1.731,
    "y-130": -1.731,
    "y-131": -1.731,
    "y-132": -1.721,
    "y-133": -1.721,
    "y-134": -1.721,
    "y-135": -1.721,
    "y-136": -1.721,
    "y-137": -1.721,
    "y-138": -1.721,
    "y-139": -1.72,
    "y-140": -1.72,
    "y-141": -1.72,
    "y-142": -1.72,
    "y-143": -1.72,
    "y-144": -1.72,
    "y-145": -1.72,
    "y-146": -1.72,
    "y-147": -1.72,
    "y-148": -1.72,
    "y-149": -1.72,
    "y-150": -1.72,
    "y-151": -1.72,
    "y-152": -1.72,
    "y-153": -1.72,
    "y-154": -1.72,
    "y-155": -1.721,
    "y-156": -1.722,
    "y-157": -1.722,
    "y-158": -1.722,
    "y-159": -1.722,
    "y-160": -1.722,
    "y-161": -1.722,
    "y-162": -1.722,
    "y-163": -1.722,
    "y-164": -1.722,
    "y-165": -1.722,
    "y-166": -1.722,
    "y-167": -1.722,
    "y-168": -1.722,
    "y-169": -1.722,
    "y-170": -1.722,
    "y-171": -1.722,
    "y-172": -1.722,
    "y-173": -1.722,
    "y-174": -1.722,
    "y-175": -1.722,
    "y-176": -1.722,
    "y-177": -1.722,
    "y-178": -1.722,
    "y-179": -1.721,
    "y-180": -1.721,
    "y-181": -1.721,
    "y-182": -1.721,
    "y-183": -1.721,
    "y-184": -1.721,
    "y-185": -1.721,
    "y-186": -1.721,
    "y-187": -1.721,
    "y-188": -1.721,
    "y-189": -1.721,
    "y-190": -1.721,
    "y-191": -1.721,
    "y-192": -1.725,
    "y-193": -1.725,
    "y-194": -1.725,
    "y-195": -1.725,
    "y-196": -1.725,
    "y-197": -1.725,
    "y-198": -1.725,
    "y-199": -1.725,
    "y-200": -1.724,
    "y-201": -1.724,
    "y-202": -1.724,
    "y-203": -1.724,
    "y-204": -1.724,
    "y-205": -1.724,
    "y-206": -1.724,
    "y-207": -1.724,
    "y-208": -1.724,
    "y-209": -1.724,
    "y-210": -1.724,
    "y-211": -1.724,
    "y-212": -1.725,
    "y-213": -1.724,
    "y-214": -1.724,
    "y-215": -1.724,
    "y-216": -1.725,
    "y-217": -1.725,
    "y-218": -1.725,
    "y-219": -1.725,
    "y-220": -1.725,
    "y-221": -1.725,
    "y-222": -1.725,
    "y-223": -1.725,
    "y-224": -1.725,
    "y-225": -1.725,
    "y-226": -1.725,
    "y-227": -1.725,
    "y-228": -1.725,
    "y-229": -1.725,
    "y-230": -1.725,
    "y-231": -1.725,
    "y-232": -1.725,
    "y-233": -1.725,
    "y-234": -1.725,
    "y-235": -1.725,
    "y-236": -1.725,
    "y-237": -1.725,
    "y-238": -1.725,
    "y-239": -1.725,
    "y-240": -1.725,
    "y-241": -1.725,
    "y-242": -1.725,
    "y-243": -1.725,
    "y-244": -1.725,
    "y-245": -1.725,
    "y-246": -1.725,
    "y-247": -1.725,
    "y-248": -1.725,
    "y-249": -1.725,
    "y-250": -1.725,
    "y-251": -1.725,
    "y-252": -1.725,
    "y-253": -1.725,
    "y-254": -1.725,
    "y-255": -1.725,
  },
  {
    x: 0.7,
    "y-2": -0.755,
    "y-12": -1.844,
    "y-46": -1.757,
    "y-1000": -1.757,
    "y-0": -0.238,
    "y-1": -0.975,
    "y-3": -1.675,
    "y-4": -1.573,
    "y-5": -1.534,
    "y-6": -1.533,
    "y-7": -1.532,
    "y-8": -1.528,
    "y-9": -1.528,
    "y-10": -1.877,
    "y-11": -1.847,
    "y-13": -1.844,
    "y-14": -1.849,
    "y-15": -1.762,
    "y-16": -1.762,
    "y-17": -1.761,
    "y-18": -1.759,
    "y-19": -1.759,
    "y-20": -1.738,
    "y-21": -1.738,
    "y-22": -1.738,
    "y-23": -1.738,
    "y-24": -1.738,
    "y-25": -1.738,
    "y-26": -1.735,
    "y-27": -1.735,
    "y-28": -1.735,
    "y-29": -1.735,
    "y-30": -1.735,
    "y-31": -1.735,
    "y-32": -1.735,
    "y-33": -1.735,
    "y-34": -1.757,
    "y-35": -1.757,
    "y-36": -1.757,
    "y-37": -1.757,
    "y-38": -1.757,
    "y-39": -1.757,
    "y-40": -1.757,
    "y-41": -1.757,
    "y-42": -1.757,
    "y-43": -1.757,
    "y-44": -1.757,
    "y-45": -1.757,
    "y-47": -1.757,
    "y-48": -1.757,
    "y-49": -1.757,
    "y-50": -1.757,
    "y-51": -1.757,
    "y-52": -1.757,
    "y-53": -1.757,
    "y-54": -1.757,
    "y-55": -1.757,
    "y-56": -1.757,
    "y-57": -1.757,
    "y-58": -1.757,
    "y-59": -1.757,
    "y-60": -1.757,
    "y-61": -1.757,
    "y-62": -1.757,
    "y-63": -1.757,
    "y-64": -1.757,
    "y-65": -1.757,
    "y-66": -1.757,
    "y-67": -1.757,
    "y-68": -1.757,
    "y-69": -1.757,
    "y-70": -1.757,
    "y-71": -1.757,
    "y-72": -1.757,
    "y-73": -1.757,
    "y-74": -1.757,
    "y-75": -1.757,
    "y-76": -1.757,
    "y-77": -1.757,
    "y-78": -1.757,
    "y-79": -1.757,
    "y-80": -1.757,
    "y-81": -1.757,
    "y-82": -1.757,
    "y-83": -1.757,
    "y-84": -1.757,
    "y-85": -1.757,
    "y-86": -1.757,
    "y-87": -1.757,
    "y-88": -1.757,
    "y-89": -1.757,
    "y-90": -1.757,
    "y-91": -1.757,
    "y-92": -1.757,
    "y-93": -1.757,
    "y-94": -1.757,
    "y-95": -1.757,
    "y-96": -1.757,
    "y-97": -1.757,
    "y-98": -1.757,
    "y-99": -1.757,
    "y-100": -1.757,
    "y-101": -1.757,
    "y-102": -1.757,
    "y-103": -1.757,
    "y-104": -1.757,
    "y-105": -1.757,
    "y-106": -1.757,
    "y-107": -1.757,
    "y-108": -1.757,
    "y-109": -1.757,
    "y-110": -1.757,
    "y-111": -1.757,
    "y-112": -1.757,
    "y-113": -1.757,
    "y-114": -1.757,
    "y-115": -1.757,
    "y-116": -1.757,
    "y-117": -1.757,
    "y-118": -1.757,
    "y-119": -1.757,
    "y-120": -1.757,
    "y-121": -1.757,
    "y-122": -1.757,
    "y-123": -1.757,
    "y-124": -1.757,
    "y-125": -1.757,
    "y-126": -1.757,
    "y-127": -1.757,
    "y-128": -1.757,
    "y-129": -1.757,
    "y-130": -1.757,
    "y-131": -1.757,
    "y-132": -1.757,
    "y-133": -1.757,
    "y-134": -1.757,
    "y-135": -1.757,
    "y-136": -1.757,
    "y-137": -1.757,
    "y-138": -1.757,
    "y-139": -1.757,
    "y-140": -1.757,
    "y-141": -1.757,
    "y-142": -1.757,
    "y-143": -1.757,
    "y-144": -1.757,
    "y-145": -1.757,
    "y-146": -1.757,
    "y-147": -1.757,
    "y-148": -1.757,
    "y-149": -1.757,
    "y-150": -1.757,
    "y-151": -1.757,
    "y-152": -1.757,
    "y-153": -1.757,
    "y-154": -1.757,
    "y-155": -1.757,
    "y-156": -1.757,
    "y-157": -1.757,
    "y-158": -1.757,
    "y-159": -1.757,
    "y-160": -1.757,
    "y-161": -1.757,
    "y-162": -1.757,
    "y-163": -1.757,
    "y-164": -1.757,
    "y-165": -1.757,
    "y-166": -1.757,
    "y-167": -1.757,
    "y-168": -1.757,
    "y-169": -1.757,
    "y-170": -1.757,
    "y-171": -1.757,
    "y-172": -1.757,
    "y-173": -1.757,
    "y-174": -1.757,
    "y-175": -1.757,
    "y-176": -1.757,
    "y-177": -1.757,
    "y-178": -1.757,
    "y-179": -1.757,
    "y-180": -1.757,
    "y-181": -1.757,
    "y-182": -1.757,
    "y-183": -1.757,
    "y-184": -1.757,
    "y-185": -1.757,
    "y-186": -1.757,
    "y-187": -1.757,
    "y-188": -1.757,
    "y-189": -1.757,
    "y-190": -1.757,
    "y-191": -1.757,
    "y-192": -1.757,
    "y-193": -1.757,
    "y-194": -1.757,
    "y-195": -1.757,
    "y-196": -1.757,
    "y-197": -1.757,
    "y-198": -1.757,
    "y-199": -1.757,
    "y-200": -1.757,
    "y-201": -1.757,
    "y-202": -1.757,
    "y-203": -1.757,
    "y-204": -1.757,
    "y-205": -1.757,
    "y-206": -1.757,
    "y-207": -1.757,
    "y-208": -1.757,
    "y-209": -1.757,
    "y-210": -1.757,
    "y-211": -1.757,
    "y-212": -1.757,
    "y-213": -1.757,
    "y-214": -1.757,
    "y-215": -1.757,
    "y-216": -1.757,
    "y-217": -1.757,
    "y-218": -1.757,
    "y-219": -1.757,
    "y-220": -1.757,
    "y-221": -1.757,
    "y-222": -1.757,
    "y-223": -1.757,
    "y-224": -1.757,
    "y-225": -1.757,
    "y-226": -1.757,
    "y-227": -1.757,
    "y-228": -1.757,
    "y-229": -1.757,
    "y-230": -1.757,
    "y-231": -1.757,
    "y-232": -1.757,
    "y-233": -1.757,
    "y-234": -1.757,
    "y-235": -1.757,
    "y-236": -1.757,
    "y-237": -1.757,
    "y-238": -1.757,
    "y-239": -1.757,
    "y-240": -1.757,
    "y-241": -1.757,
    "y-242": -1.757,
    "y-243": -1.757,
    "y-244": -1.757,
    "y-245": -1.757,
    "y-246": -1.757,
    "y-247": -1.757,
    "y-248": -1.757,
    "y-249": -1.757,
    "y-250": -1.757,
    "y-251": -1.757,
    "y-252": -1.757,
    "y-253": -1.757,
    "y-254": -1.757,
    "y-255": -1.757,
  },
  {
    x: 0.725,
    "y-2": -0.776,
    "y-12": -1.829,
    "y-46": -1.788,
    "y-1000": -1.786,
    "y-0": -0.25,
    "y-1": -0.999,
    "y-3": -1.75,
    "y-4": -1.634,
    "y-5": -1.588,
    "y-6": -1.587,
    "y-7": -1.586,
    "y-8": -1.581,
    "y-9": -1.581,
    "y-10": -1.857,
    "y-11": -1.831,
    "y-13": -1.829,
    "y-14": -1.834,
    "y-15": -1.804,
    "y-16": -1.804,
    "y-17": -1.805,
    "y-18": -1.806,
    "y-19": -1.806,
    "y-20": -1.79,
    "y-21": -1.79,
    "y-22": -1.79,
    "y-23": -1.79,
    "y-24": -1.79,
    "y-25": -1.79,
    "y-26": -1.694,
    "y-27": -1.694,
    "y-28": -1.694,
    "y-29": -1.694,
    "y-30": -1.694,
    "y-31": -1.694,
    "y-32": -1.694,
    "y-33": -1.694,
    "y-34": -1.787,
    "y-35": -1.787,
    "y-36": -1.787,
    "y-37": -1.787,
    "y-38": -1.788,
    "y-39": -1.788,
    "y-40": -1.788,
    "y-41": -1.788,
    "y-42": -1.788,
    "y-43": -1.788,
    "y-44": -1.788,
    "y-45": -1.788,
    "y-47": -1.648,
    "y-48": -1.652,
    "y-49": -1.656,
    "y-50": -1.781,
    "y-51": -1.779,
    "y-52": -1.765,
    "y-53": -1.752,
    "y-54": -1.752,
    "y-55": -1.752,
    "y-56": -1.758,
    "y-57": -1.769,
    "y-58": -1.745,
    "y-59": -1.756,
    "y-60": -1.761,
    "y-61": -1.76,
    "y-62": -1.757,
    "y-63": -1.757,
    "y-64": -1.759,
    "y-65": -1.767,
    "y-66": -1.768,
    "y-67": -1.764,
    "y-68": -1.763,
    "y-69": -1.769,
    "y-70": -1.775,
    "y-71": -1.779,
    "y-72": -1.776,
    "y-73": -1.775,
    "y-74": -1.775,
    "y-75": -1.775,
    "y-76": -1.776,
    "y-77": -1.773,
    "y-78": -1.78,
    "y-79": -1.78,
    "y-80": -1.774,
    "y-81": -1.778,
    "y-82": -1.778,
    "y-83": -1.776,
    "y-84": -1.776,
    "y-85": -1.775,
    "y-86": -1.776,
    "y-87": -1.776,
    "y-88": -1.776,
    "y-89": -1.777,
    "y-90": -1.776,
    "y-91": -1.775,
    "y-92": -1.775,
    "y-93": -1.779,
    "y-94": -1.774,
    "y-95": -1.78,
    "y-96": -1.777,
    "y-97": -1.776,
    "y-98": -1.776,
    "y-99": -1.773,
    "y-100": -1.776,
    "y-101": -1.774,
    "y-102": -1.777,
    "y-103": -1.774,
    "y-104": -1.777,
    "y-105": -1.775,
    "y-106": -1.776,
    "y-107": -1.776,
    "y-108": -1.776,
    "y-109": -1.776,
    "y-110": -1.776,
    "y-111": -1.775,
    "y-112": -1.777,
    "y-113": -1.776,
    "y-114": -1.776,
    "y-115": -1.776,
    "y-116": -1.777,
    "y-117": -1.777,
    "y-118": -1.775,
    "y-119": -1.775,
    "y-120": -1.774,
    "y-121": -1.775,
    "y-122": -1.775,
    "y-123": -1.775,
    "y-124": -1.775,
    "y-125": -1.775,
    "y-126": -1.775,
    "y-127": -1.775,
    "y-128": -1.775,
    "y-129": -1.775,
    "y-130": -1.775,
    "y-131": -1.775,
    "y-132": -1.788,
    "y-133": -1.788,
    "y-134": -1.788,
    "y-135": -1.788,
    "y-136": -1.788,
    "y-137": -1.788,
    "y-138": -1.788,
    "y-139": -1.789,
    "y-140": -1.789,
    "y-141": -1.789,
    "y-142": -1.789,
    "y-143": -1.789,
    "y-144": -1.789,
    "y-145": -1.789,
    "y-146": -1.789,
    "y-147": -1.789,
    "y-148": -1.789,
    "y-149": -1.789,
    "y-150": -1.789,
    "y-151": -1.789,
    "y-152": -1.789,
    "y-153": -1.789,
    "y-154": -1.789,
    "y-155": -1.788,
    "y-156": -1.788,
    "y-157": -1.788,
    "y-158": -1.788,
    "y-159": -1.788,
    "y-160": -1.787,
    "y-161": -1.787,
    "y-162": -1.787,
    "y-163": -1.786,
    "y-164": -1.786,
    "y-165": -1.786,
    "y-166": -1.786,
    "y-167": -1.786,
    "y-168": -1.786,
    "y-169": -1.786,
    "y-170": -1.786,
    "y-171": -1.786,
    "y-172": -1.786,
    "y-173": -1.786,
    "y-174": -1.786,
    "y-175": -1.786,
    "y-176": -1.786,
    "y-177": -1.786,
    "y-178": -1.786,
    "y-179": -1.788,
    "y-180": -1.788,
    "y-181": -1.788,
    "y-182": -1.788,
    "y-183": -1.788,
    "y-184": -1.788,
    "y-185": -1.788,
    "y-186": -1.788,
    "y-187": -1.788,
    "y-188": -1.788,
    "y-189": -1.788,
    "y-190": -1.788,
    "y-191": -1.788,
    "y-192": -1.786,
    "y-193": -1.786,
    "y-194": -1.786,
    "y-195": -1.786,
    "y-196": -1.786,
    "y-197": -1.786,
    "y-198": -1.786,
    "y-199": -1.786,
    "y-200": -1.786,
    "y-201": -1.786,
    "y-202": -1.786,
    "y-203": -1.786,
    "y-204": -1.786,
    "y-205": -1.786,
    "y-206": -1.786,
    "y-207": -1.786,
    "y-208": -1.786,
    "y-209": -1.786,
    "y-210": -1.786,
    "y-211": -1.786,
    "y-212": -1.785,
    "y-213": -1.786,
    "y-214": -1.786,
    "y-215": -1.786,
    "y-216": -1.786,
    "y-217": -1.786,
    "y-218": -1.786,
    "y-219": -1.786,
    "y-220": -1.786,
    "y-221": -1.786,
    "y-222": -1.786,
    "y-223": -1.786,
    "y-224": -1.785,
    "y-225": -1.785,
    "y-226": -1.785,
    "y-227": -1.785,
    "y-228": -1.785,
    "y-229": -1.785,
    "y-230": -1.785,
    "y-231": -1.785,
    "y-232": -1.785,
    "y-233": -1.785,
    "y-234": -1.785,
    "y-235": -1.785,
    "y-236": -1.785,
    "y-237": -1.785,
    "y-238": -1.785,
    "y-239": -1.785,
    "y-240": -1.785,
    "y-241": -1.785,
    "y-242": -1.785,
    "y-243": -1.785,
    "y-244": -1.785,
    "y-245": -1.785,
    "y-246": -1.785,
    "y-247": -1.785,
    "y-248": -1.785,
    "y-249": -1.785,
    "y-250": -1.785,
    "y-251": -1.785,
    "y-252": -1.785,
    "y-253": -1.785,
    "y-254": -1.785,
    "y-255": -1.785,
  },
  {
    x: 0.75,
    "y-2": -0.797,
    "y-12": -1.814,
    "y-46": -1.822,
    "y-1000": -1.814,
    "y-0": -0.263,
    "y-1": -1.024,
    "y-3": -1.826,
    "y-4": -1.695,
    "y-5": -1.643,
    "y-6": -1.641,
    "y-7": -1.64,
    "y-8": -1.634,
    "y-9": -1.634,
    "y-10": -1.837,
    "y-11": -1.814,
    "y-13": -1.814,
    "y-14": -1.819,
    "y-15": -1.847,
    "y-16": -1.847,
    "y-17": -1.849,
    "y-18": -1.854,
    "y-19": -1.854,
    "y-20": -1.841,
    "y-21": -1.841,
    "y-22": -1.841,
    "y-23": -1.841,
    "y-24": -1.841,
    "y-25": -1.841,
    "y-26": -1.768,
    "y-27": -1.768,
    "y-28": -1.768,
    "y-29": -1.768,
    "y-30": -1.768,
    "y-31": -1.768,
    "y-32": -1.768,
    "y-33": -1.768,
    "y-34": -1.821,
    "y-35": -1.821,
    "y-36": -1.821,
    "y-37": -1.821,
    "y-38": -1.822,
    "y-39": -1.822,
    "y-40": -1.822,
    "y-41": -1.822,
    "y-42": -1.822,
    "y-43": -1.822,
    "y-44": -1.822,
    "y-45": -1.822,
    "y-47": -1.728,
    "y-48": -1.731,
    "y-49": -1.733,
    "y-50": -1.817,
    "y-51": -1.815,
    "y-52": -1.806,
    "y-53": -1.77,
    "y-54": -1.763,
    "y-55": -1.771,
    "y-56": -1.779,
    "y-57": -1.783,
    "y-58": -1.764,
    "y-59": -1.773,
    "y-60": -1.778,
    "y-61": -1.777,
    "y-62": -1.775,
    "y-63": -1.775,
    "y-64": -1.776,
    "y-65": -1.787,
    "y-66": -1.788,
    "y-67": -1.784,
    "y-68": -1.783,
    "y-69": -1.788,
    "y-70": -1.799,
    "y-71": -1.803,
    "y-72": -1.801,
    "y-73": -1.8,
    "y-74": -1.799,
    "y-75": -1.8,
    "y-76": -1.801,
    "y-77": -1.798,
    "y-78": -1.804,
    "y-79": -1.805,
    "y-80": -1.798,
    "y-81": -1.803,
    "y-82": -1.803,
    "y-83": -1.801,
    "y-84": -1.8,
    "y-85": -1.799,
    "y-86": -1.801,
    "y-87": -1.801,
    "y-88": -1.801,
    "y-89": -1.802,
    "y-90": -1.801,
    "y-91": -1.8,
    "y-92": -1.8,
    "y-93": -1.803,
    "y-94": -1.799,
    "y-95": -1.804,
    "y-96": -1.802,
    "y-97": -1.801,
    "y-98": -1.801,
    "y-99": -1.798,
    "y-100": -1.801,
    "y-101": -1.799,
    "y-102": -1.801,
    "y-103": -1.799,
    "y-104": -1.802,
    "y-105": -1.8,
    "y-106": -1.801,
    "y-107": -1.801,
    "y-108": -1.801,
    "y-109": -1.801,
    "y-110": -1.801,
    "y-111": -1.8,
    "y-112": -1.802,
    "y-113": -1.801,
    "y-114": -1.801,
    "y-115": -1.8,
    "y-116": -1.802,
    "y-117": -1.802,
    "y-118": -1.8,
    "y-119": -1.8,
    "y-120": -1.799,
    "y-121": -1.8,
    "y-122": -1.799,
    "y-123": -1.799,
    "y-124": -1.799,
    "y-125": -1.799,
    "y-126": -1.799,
    "y-127": -1.799,
    "y-128": -1.799,
    "y-129": -1.799,
    "y-130": -1.799,
    "y-131": -1.8,
    "y-132": -1.816,
    "y-133": -1.816,
    "y-134": -1.816,
    "y-135": -1.816,
    "y-136": -1.816,
    "y-137": -1.816,
    "y-138": -1.816,
    "y-139": -1.819,
    "y-140": -1.819,
    "y-141": -1.819,
    "y-142": -1.819,
    "y-143": -1.819,
    "y-144": -1.819,
    "y-145": -1.819,
    "y-146": -1.819,
    "y-147": -1.819,
    "y-148": -1.819,
    "y-149": -1.819,
    "y-150": -1.819,
    "y-151": -1.819,
    "y-152": -1.819,
    "y-153": -1.819,
    "y-154": -1.819,
    "y-155": -1.817,
    "y-156": -1.816,
    "y-157": -1.816,
    "y-158": -1.816,
    "y-159": -1.816,
    "y-160": -1.812,
    "y-161": -1.812,
    "y-162": -1.812,
    "y-163": -1.811,
    "y-164": -1.811,
    "y-165": -1.811,
    "y-166": -1.811,
    "y-167": -1.811,
    "y-168": -1.811,
    "y-169": -1.811,
    "y-170": -1.811,
    "y-171": -1.811,
    "y-172": -1.811,
    "y-173": -1.811,
    "y-174": -1.811,
    "y-175": -1.811,
    "y-176": -1.811,
    "y-177": -1.811,
    "y-178": -1.811,
    "y-179": -1.814,
    "y-180": -1.814,
    "y-181": -1.814,
    "y-182": -1.814,
    "y-183": -1.814,
    "y-184": -1.814,
    "y-185": -1.814,
    "y-186": -1.814,
    "y-187": -1.814,
    "y-188": -1.814,
    "y-189": -1.814,
    "y-190": -1.814,
    "y-191": -1.814,
    "y-192": -1.812,
    "y-193": -1.812,
    "y-194": -1.812,
    "y-195": -1.812,
    "y-196": -1.812,
    "y-197": -1.812,
    "y-198": -1.812,
    "y-199": -1.812,
    "y-200": -1.812,
    "y-201": -1.812,
    "y-202": -1.812,
    "y-203": -1.812,
    "y-204": -1.812,
    "y-205": -1.812,
    "y-206": -1.812,
    "y-207": -1.812,
    "y-208": -1.812,
    "y-209": -1.812,
    "y-210": -1.812,
    "y-211": -1.812,
    "y-212": -1.809,
    "y-213": -1.812,
    "y-214": -1.812,
    "y-215": -1.812,
    "y-216": -1.811,
    "y-217": -1.811,
    "y-218": -1.811,
    "y-219": -1.811,
    "y-220": -1.811,
    "y-221": -1.811,
    "y-222": -1.811,
    "y-223": -1.811,
    "y-224": -1.81,
    "y-225": -1.81,
    "y-226": -1.81,
    "y-227": -1.81,
    "y-228": -1.81,
    "y-229": -1.81,
    "y-230": -1.81,
    "y-231": -1.81,
    "y-232": -1.81,
    "y-233": -1.81,
    "y-234": -1.81,
    "y-235": -1.81,
    "y-236": -1.81,
    "y-237": -1.81,
    "y-238": -1.81,
    "y-239": -1.81,
    "y-240": -1.81,
    "y-241": -1.81,
    "y-242": -1.81,
    "y-243": -1.81,
    "y-244": -1.81,
    "y-245": -1.811,
    "y-246": -1.811,
    "y-247": -1.811,
    "y-248": -1.811,
    "y-249": -1.811,
    "y-250": -1.811,
    "y-251": -1.811,
    "y-252": -1.811,
    "y-253": -1.811,
    "y-254": -1.811,
    "y-255": -1.81,
  },
  {
    x: 0.775,
    "y-2": -0.818,
    "y-12": -1.799,
    "y-46": -1.855,
    "y-1000": -1.844,
    "y-0": -0.275,
    "y-1": -1.048,
    "y-3": -1.902,
    "y-4": -1.756,
    "y-5": -1.698,
    "y-6": -1.696,
    "y-7": -1.694,
    "y-8": -1.687,
    "y-9": -1.687,
    "y-10": -1.818,
    "y-11": -1.798,
    "y-13": -1.799,
    "y-14": -1.803,
    "y-15": -1.889,
    "y-16": -1.889,
    "y-17": -1.893,
    "y-18": -1.901,
    "y-19": -1.901,
    "y-20": -1.893,
    "y-21": -1.893,
    "y-22": -1.893,
    "y-23": -1.893,
    "y-24": -1.893,
    "y-25": -1.893,
    "y-26": -1.842,
    "y-27": -1.842,
    "y-28": -1.842,
    "y-29": -1.842,
    "y-30": -1.842,
    "y-31": -1.842,
    "y-32": -1.842,
    "y-33": -1.842,
    "y-34": -1.854,
    "y-35": -1.854,
    "y-36": -1.854,
    "y-37": -1.854,
    "y-38": -1.855,
    "y-39": -1.855,
    "y-40": -1.855,
    "y-41": -1.855,
    "y-42": -1.855,
    "y-43": -1.855,
    "y-44": -1.855,
    "y-45": -1.855,
    "y-47": -1.808,
    "y-48": -1.809,
    "y-49": -1.811,
    "y-50": -1.852,
    "y-51": -1.852,
    "y-52": -1.847,
    "y-53": -1.829,
    "y-54": -1.825,
    "y-55": -1.829,
    "y-56": -1.833,
    "y-57": -1.835,
    "y-58": -1.826,
    "y-59": -1.83,
    "y-60": -1.833,
    "y-61": -1.832,
    "y-62": -1.831,
    "y-63": -1.831,
    "y-64": -1.832,
    "y-65": -1.837,
    "y-66": -1.838,
    "y-67": -1.836,
    "y-68": -1.836,
    "y-69": -1.838,
    "y-70": -1.844,
    "y-71": -1.846,
    "y-72": -1.844,
    "y-73": -1.844,
    "y-74": -1.844,
    "y-75": -1.844,
    "y-76": -1.844,
    "y-77": -1.843,
    "y-78": -1.846,
    "y-79": -1.846,
    "y-80": -1.843,
    "y-81": -1.846,
    "y-82": -1.845,
    "y-83": -1.844,
    "y-84": -1.844,
    "y-85": -1.844,
    "y-86": -1.844,
    "y-87": -1.845,
    "y-88": -1.844,
    "y-89": -1.845,
    "y-90": -1.844,
    "y-91": -1.844,
    "y-92": -1.844,
    "y-93": -1.846,
    "y-94": -1.844,
    "y-95": -1.846,
    "y-96": -1.845,
    "y-97": -1.844,
    "y-98": -1.844,
    "y-99": -1.843,
    "y-100": -1.844,
    "y-101": -1.843,
    "y-102": -1.844,
    "y-103": -1.843,
    "y-104": -1.845,
    "y-105": -1.844,
    "y-106": -1.844,
    "y-107": -1.845,
    "y-108": -1.844,
    "y-109": -1.844,
    "y-110": -1.844,
    "y-111": -1.844,
    "y-112": -1.845,
    "y-113": -1.844,
    "y-114": -1.845,
    "y-115": -1.844,
    "y-116": -1.845,
    "y-117": -1.845,
    "y-118": -1.844,
    "y-119": -1.844,
    "y-120": -1.843,
    "y-121": -1.844,
    "y-122": -1.844,
    "y-123": -1.844,
    "y-124": -1.844,
    "y-125": -1.844,
    "y-126": -1.844,
    "y-127": -1.844,
    "y-128": -1.844,
    "y-129": -1.844,
    "y-130": -1.844,
    "y-131": -1.844,
    "y-132": -1.849,
    "y-133": -1.849,
    "y-134": -1.849,
    "y-135": -1.849,
    "y-136": -1.849,
    "y-137": -1.849,
    "y-138": -1.849,
    "y-139": -1.851,
    "y-140": -1.851,
    "y-141": -1.851,
    "y-142": -1.851,
    "y-143": -1.851,
    "y-144": -1.851,
    "y-145": -1.851,
    "y-146": -1.851,
    "y-147": -1.851,
    "y-148": -1.851,
    "y-149": -1.851,
    "y-150": -1.851,
    "y-151": -1.851,
    "y-152": -1.851,
    "y-153": -1.851,
    "y-154": -1.851,
    "y-155": -1.849,
    "y-156": -1.849,
    "y-157": -1.849,
    "y-158": -1.849,
    "y-159": -1.849,
    "y-160": -1.839,
    "y-161": -1.839,
    "y-162": -1.839,
    "y-163": -1.838,
    "y-164": -1.838,
    "y-165": -1.838,
    "y-166": -1.838,
    "y-167": -1.838,
    "y-168": -1.838,
    "y-169": -1.838,
    "y-170": -1.838,
    "y-171": -1.838,
    "y-172": -1.838,
    "y-173": -1.838,
    "y-174": -1.838,
    "y-175": -1.838,
    "y-176": -1.839,
    "y-177": -1.839,
    "y-178": -1.839,
    "y-179": -1.841,
    "y-180": -1.841,
    "y-181": -1.841,
    "y-182": -1.841,
    "y-183": -1.841,
    "y-184": -1.841,
    "y-185": -1.841,
    "y-186": -1.841,
    "y-187": -1.841,
    "y-188": -1.841,
    "y-189": -1.841,
    "y-190": -1.841,
    "y-191": -1.841,
    "y-192": -1.84,
    "y-193": -1.84,
    "y-194": -1.84,
    "y-195": -1.84,
    "y-196": -1.84,
    "y-197": -1.84,
    "y-198": -1.84,
    "y-199": -1.84,
    "y-200": -1.839,
    "y-201": -1.839,
    "y-202": -1.839,
    "y-203": -1.839,
    "y-204": -1.839,
    "y-205": -1.839,
    "y-206": -1.839,
    "y-207": -1.839,
    "y-208": -1.839,
    "y-209": -1.839,
    "y-210": -1.839,
    "y-211": -1.839,
    "y-212": -1.835,
    "y-213": -1.839,
    "y-214": -1.839,
    "y-215": -1.839,
    "y-216": -1.837,
    "y-217": -1.837,
    "y-218": -1.837,
    "y-219": -1.837,
    "y-220": -1.837,
    "y-221": -1.837,
    "y-222": -1.837,
    "y-223": -1.837,
    "y-224": -1.837,
    "y-225": -1.837,
    "y-226": -1.837,
    "y-227": -1.837,
    "y-228": -1.837,
    "y-229": -1.837,
    "y-230": -1.837,
    "y-231": -1.837,
    "y-232": -1.837,
    "y-233": -1.837,
    "y-234": -1.837,
    "y-235": -1.837,
    "y-236": -1.837,
    "y-237": -1.837,
    "y-238": -1.837,
    "y-239": -1.837,
    "y-240": -1.837,
    "y-241": -1.837,
    "y-242": -1.837,
    "y-243": -1.837,
    "y-244": -1.837,
    "y-245": -1.837,
    "y-246": -1.837,
    "y-247": -1.837,
    "y-248": -1.837,
    "y-249": -1.837,
    "y-250": -1.837,
    "y-251": -1.837,
    "y-252": -1.837,
    "y-253": -1.837,
    "y-254": -1.837,
    "y-255": -1.837,
  },
  {
    x: 0.8,
    "y-2": -0.84,
    "y-12": -1.785,
    "y-46": -1.888,
    "y-1000": -1.888,
    "y-0": -0.287,
    "y-1": -1.073,
    "y-3": -1.978,
    "y-4": -1.817,
    "y-5": -1.752,
    "y-6": -1.75,
    "y-7": -1.748,
    "y-8": -1.74,
    "y-9": -1.74,
    "y-10": -1.798,
    "y-11": -1.781,
    "y-13": -1.785,
    "y-14": -1.788,
    "y-15": -1.931,
    "y-16": -1.931,
    "y-17": -1.936,
    "y-18": -1.949,
    "y-19": -1.949,
    "y-20": -1.945,
    "y-21": -1.945,
    "y-22": -1.945,
    "y-23": -1.945,
    "y-24": -1.945,
    "y-25": -1.945,
    "y-26": -1.916,
    "y-27": -1.916,
    "y-28": -1.916,
    "y-29": -1.916,
    "y-30": -1.916,
    "y-31": -1.916,
    "y-32": -1.916,
    "y-33": -1.916,
    "y-34": -1.888,
    "y-35": -1.888,
    "y-36": -1.888,
    "y-37": -1.888,
    "y-38": -1.888,
    "y-39": -1.888,
    "y-40": -1.888,
    "y-41": -1.888,
    "y-42": -1.888,
    "y-43": -1.888,
    "y-44": -1.888,
    "y-45": -1.888,
    "y-47": -1.888,
    "y-48": -1.888,
    "y-49": -1.888,
    "y-50": -1.888,
    "y-51": -1.888,
    "y-52": -1.888,
    "y-53": -1.888,
    "y-54": -1.888,
    "y-55": -1.888,
    "y-56": -1.888,
    "y-57": -1.888,
    "y-58": -1.888,
    "y-59": -1.888,
    "y-60": -1.888,
    "y-61": -1.888,
    "y-62": -1.888,
    "y-63": -1.888,
    "y-64": -1.888,
    "y-65": -1.888,
    "y-66": -1.888,
    "y-67": -1.888,
    "y-68": -1.888,
    "y-69": -1.888,
    "y-70": -1.888,
    "y-71": -1.888,
    "y-72": -1.888,
    "y-73": -1.888,
    "y-74": -1.888,
    "y-75": -1.888,
    "y-76": -1.888,
    "y-77": -1.888,
    "y-78": -1.888,
    "y-79": -1.888,
    "y-80": -1.888,
    "y-81": -1.888,
    "y-82": -1.888,
    "y-83": -1.888,
    "y-84": -1.888,
    "y-85": -1.888,
    "y-86": -1.888,
    "y-87": -1.888,
    "y-88": -1.888,
    "y-89": -1.888,
    "y-90": -1.888,
    "y-91": -1.888,
    "y-92": -1.888,
    "y-93": -1.888,
    "y-94": -1.888,
    "y-95": -1.888,
    "y-96": -1.888,
    "y-97": -1.888,
    "y-98": -1.888,
    "y-99": -1.888,
    "y-100": -1.888,
    "y-101": -1.888,
    "y-102": -1.888,
    "y-103": -1.888,
    "y-104": -1.888,
    "y-105": -1.888,
    "y-106": -1.888,
    "y-107": -1.888,
    "y-108": -1.888,
    "y-109": -1.888,
    "y-110": -1.888,
    "y-111": -1.888,
    "y-112": -1.888,
    "y-113": -1.888,
    "y-114": -1.888,
    "y-115": -1.888,
    "y-116": -1.888,
    "y-117": -1.888,
    "y-118": -1.888,
    "y-119": -1.888,
    "y-120": -1.888,
    "y-121": -1.888,
    "y-122": -1.888,
    "y-123": -1.888,
    "y-124": -1.888,
    "y-125": -1.888,
    "y-126": -1.888,
    "y-127": -1.888,
    "y-128": -1.888,
    "y-129": -1.888,
    "y-130": -1.888,
    "y-131": -1.888,
    "y-132": -1.888,
    "y-133": -1.888,
    "y-134": -1.888,
    "y-135": -1.888,
    "y-136": -1.888,
    "y-137": -1.888,
    "y-138": -1.888,
    "y-139": -1.888,
    "y-140": -1.888,
    "y-141": -1.888,
    "y-142": -1.888,
    "y-143": -1.888,
    "y-144": -1.888,
    "y-145": -1.888,
    "y-146": -1.888,
    "y-147": -1.888,
    "y-148": -1.888,
    "y-149": -1.888,
    "y-150": -1.888,
    "y-151": -1.888,
    "y-152": -1.888,
    "y-153": -1.888,
    "y-154": -1.888,
    "y-155": -1.888,
    "y-156": -1.888,
    "y-157": -1.888,
    "y-158": -1.888,
    "y-159": -1.888,
    "y-160": -1.888,
    "y-161": -1.888,
    "y-162": -1.888,
    "y-163": -1.888,
    "y-164": -1.888,
    "y-165": -1.888,
    "y-166": -1.888,
    "y-167": -1.888,
    "y-168": -1.888,
    "y-169": -1.888,
    "y-170": -1.888,
    "y-171": -1.888,
    "y-172": -1.888,
    "y-173": -1.888,
    "y-174": -1.888,
    "y-175": -1.888,
    "y-176": -1.888,
    "y-177": -1.888,
    "y-178": -1.888,
    "y-179": -1.888,
    "y-180": -1.888,
    "y-181": -1.888,
    "y-182": -1.888,
    "y-183": -1.888,
    "y-184": -1.888,
    "y-185": -1.888,
    "y-186": -1.888,
    "y-187": -1.888,
    "y-188": -1.888,
    "y-189": -1.888,
    "y-190": -1.888,
    "y-191": -1.888,
    "y-192": -1.888,
    "y-193": -1.888,
    "y-194": -1.888,
    "y-195": -1.888,
    "y-196": -1.888,
    "y-197": -1.888,
    "y-198": -1.888,
    "y-199": -1.888,
    "y-200": -1.888,
    "y-201": -1.888,
    "y-202": -1.888,
    "y-203": -1.888,
    "y-204": -1.888,
    "y-205": -1.888,
    "y-206": -1.888,
    "y-207": -1.888,
    "y-208": -1.888,
    "y-209": -1.888,
    "y-210": -1.888,
    "y-211": -1.888,
    "y-212": -1.888,
    "y-213": -1.888,
    "y-214": -1.888,
    "y-215": -1.888,
    "y-216": -1.888,
    "y-217": -1.888,
    "y-218": -1.888,
    "y-219": -1.888,
    "y-220": -1.888,
    "y-221": -1.888,
    "y-222": -1.888,
    "y-223": -1.888,
    "y-224": -1.888,
    "y-225": -1.888,
    "y-226": -1.888,
    "y-227": -1.888,
    "y-228": -1.888,
    "y-229": -1.888,
    "y-230": -1.888,
    "y-231": -1.888,
    "y-232": -1.888,
    "y-233": -1.888,
    "y-234": -1.888,
    "y-235": -1.888,
    "y-236": -1.888,
    "y-237": -1.888,
    "y-238": -1.888,
    "y-239": -1.888,
    "y-240": -1.888,
    "y-241": -1.888,
    "y-242": -1.888,
    "y-243": -1.888,
    "y-244": -1.888,
    "y-245": -1.888,
    "y-246": -1.888,
    "y-247": -1.888,
    "y-248": -1.888,
    "y-249": -1.888,
    "y-250": -1.888,
    "y-251": -1.888,
    "y-252": -1.888,
    "y-253": -1.888,
    "y-254": -1.888,
    "y-255": -1.888,
  },
  {
    x: 0.825,
    "y-2": -0.861,
    "y-12": -1.77,
    "y-46": -1.921,
    "y-1000": -1.951,
    "y-0": -0.299,
    "y-1": -1.098,
    "y-3": -2.053,
    "y-4": -1.877,
    "y-5": -1.807,
    "y-6": -1.805,
    "y-7": -1.802,
    "y-8": -1.794,
    "y-9": -1.794,
    "y-10": -1.779,
    "y-11": -1.765,
    "y-13": -1.77,
    "y-14": -1.772,
    "y-15": -1.973,
    "y-16": -1.973,
    "y-17": -1.98,
    "y-18": -1.996,
    "y-19": -1.996,
    "y-20": -1.996,
    "y-21": -1.996,
    "y-22": -1.996,
    "y-23": -1.996,
    "y-24": -1.996,
    "y-25": -1.996,
    "y-26": -1.99,
    "y-27": -1.99,
    "y-28": -1.99,
    "y-29": -1.99,
    "y-30": -1.99,
    "y-31": -1.99,
    "y-32": -1.99,
    "y-33": -1.99,
    "y-34": -1.922,
    "y-35": -1.922,
    "y-36": -1.922,
    "y-37": -1.922,
    "y-38": -1.921,
    "y-39": -1.921,
    "y-40": -1.921,
    "y-41": -1.921,
    "y-42": -1.921,
    "y-43": -1.921,
    "y-44": -1.921,
    "y-45": -1.921,
    "y-47": -1.968,
    "y-48": -1.967,
    "y-49": -1.965,
    "y-50": -1.924,
    "y-51": -1.924,
    "y-52": -1.929,
    "y-53": -1.947,
    "y-54": -1.951,
    "y-55": -1.947,
    "y-56": -1.943,
    "y-57": -1.941,
    "y-58": -1.95,
    "y-59": -1.946,
    "y-60": -1.943,
    "y-61": -1.944,
    "y-62": -1.945,
    "y-63": -1.945,
    "y-64": -1.944,
    "y-65": -1.939,
    "y-66": -1.938,
    "y-67": -1.94,
    "y-68": -1.94,
    "y-69": -1.938,
    "y-70": -1.932,
    "y-71": -1.93,
    "y-72": -1.932,
    "y-73": -1.932,
    "y-74": -1.932,
    "y-75": -1.932,
    "y-76": -1.932,
    "y-77": -1.933,
    "y-78": -1.93,
    "y-79": -1.93,
    "y-80": -1.933,
    "y-81": -1.93,
    "y-82": -1.931,
    "y-83": -1.932,
    "y-84": -1.932,
    "y-85": -1.932,
    "y-86": -1.932,
    "y-87": -1.931,
    "y-88": -1.932,
    "y-89": -1.931,
    "y-90": -1.932,
    "y-91": -1.932,
    "y-92": -1.932,
    "y-93": -1.93,
    "y-94": -1.932,
    "y-95": -1.93,
    "y-96": -1.931,
    "y-97": -1.932,
    "y-98": -1.932,
    "y-99": -1.933,
    "y-100": -1.932,
    "y-101": -1.933,
    "y-102": -1.932,
    "y-103": -1.933,
    "y-104": -1.931,
    "y-105": -1.932,
    "y-106": -1.932,
    "y-107": -1.931,
    "y-108": -1.932,
    "y-109": -1.932,
    "y-110": -1.932,
    "y-111": -1.932,
    "y-112": -1.931,
    "y-113": -1.932,
    "y-114": -1.931,
    "y-115": -1.932,
    "y-116": -1.931,
    "y-117": -1.931,
    "y-118": -1.932,
    "y-119": -1.932,
    "y-120": -1.933,
    "y-121": -1.932,
    "y-122": -1.932,
    "y-123": -1.932,
    "y-124": -1.932,
    "y-125": -1.932,
    "y-126": -1.932,
    "y-127": -1.932,
    "y-128": -1.932,
    "y-129": -1.932,
    "y-130": -1.932,
    "y-131": -1.932,
    "y-132": -1.957,
    "y-133": -1.957,
    "y-134": -1.957,
    "y-135": -1.957,
    "y-136": -1.957,
    "y-137": -1.957,
    "y-138": -1.957,
    "y-139": -1.949,
    "y-140": -1.949,
    "y-141": -1.949,
    "y-142": -1.949,
    "y-143": -1.949,
    "y-144": -1.949,
    "y-145": -1.949,
    "y-146": -1.949,
    "y-147": -1.949,
    "y-148": -1.949,
    "y-149": -1.949,
    "y-150": -1.949,
    "y-151": -1.949,
    "y-152": -1.949,
    "y-153": -1.949,
    "y-154": -1.949,
    "y-155": -1.957,
    "y-156": -1.957,
    "y-157": -1.957,
    "y-158": -1.957,
    "y-159": -1.957,
    "y-160": -1.96,
    "y-161": -1.96,
    "y-162": -1.96,
    "y-163": -1.961,
    "y-164": -1.961,
    "y-165": -1.961,
    "y-166": -1.961,
    "y-167": -1.961,
    "y-168": -1.961,
    "y-169": -1.961,
    "y-170": -1.961,
    "y-171": -1.961,
    "y-172": -1.961,
    "y-173": -1.961,
    "y-174": -1.961,
    "y-175": -1.961,
    "y-176": -1.961,
    "y-177": -1.961,
    "y-178": -1.961,
    "y-179": -1.965,
    "y-180": -1.965,
    "y-181": -1.965,
    "y-182": -1.965,
    "y-183": -1.965,
    "y-184": -1.965,
    "y-185": -1.965,
    "y-186": -1.965,
    "y-187": -1.965,
    "y-188": -1.965,
    "y-189": -1.965,
    "y-190": -1.965,
    "y-191": -1.965,
    "y-192": -1.965,
    "y-193": -1.965,
    "y-194": -1.965,
    "y-195": -1.965,
    "y-196": -1.965,
    "y-197": -1.965,
    "y-198": -1.965,
    "y-199": -1.965,
    "y-200": -1.967,
    "y-201": -1.967,
    "y-202": -1.967,
    "y-203": -1.967,
    "y-204": -1.967,
    "y-205": -1.967,
    "y-206": -1.967,
    "y-207": -1.967,
    "y-208": -1.967,
    "y-209": -1.967,
    "y-210": -1.967,
    "y-211": -1.967,
    "y-212": -1.976,
    "y-213": -1.965,
    "y-214": -1.965,
    "y-215": -1.965,
    "y-216": -1.971,
    "y-217": -1.971,
    "y-218": -1.971,
    "y-219": -1.971,
    "y-220": -1.971,
    "y-221": -1.971,
    "y-222": -1.971,
    "y-223": -1.971,
    "y-224": -1.972,
    "y-225": -1.972,
    "y-226": -1.972,
    "y-227": -1.972,
    "y-228": -1.972,
    "y-229": -1.972,
    "y-230": -1.972,
    "y-231": -1.972,
    "y-232": -1.972,
    "y-233": -1.972,
    "y-234": -1.972,
    "y-235": -1.972,
    "y-236": -1.972,
    "y-237": -1.972,
    "y-238": -1.972,
    "y-239": -1.972,
    "y-240": -1.972,
    "y-241": -1.972,
    "y-242": -1.972,
    "y-243": -1.972,
    "y-244": -1.972,
    "y-245": -1.971,
    "y-246": -1.971,
    "y-247": -1.971,
    "y-248": -1.971,
    "y-249": -1.971,
    "y-250": -1.971,
    "y-251": -1.971,
    "y-252": -1.971,
    "y-253": -1.971,
    "y-254": -1.971,
    "y-255": -1.972,
  },
  {
    x: 0.85,
    "y-2": -0.882,
    "y-12": -1.755,
    "y-46": -1.954,
    "y-1000": -2.005,
    "y-0": -0.311,
    "y-1": -1.122,
    "y-3": -2.129,
    "y-4": -1.938,
    "y-5": -1.862,
    "y-6": -1.859,
    "y-7": -1.857,
    "y-8": -1.847,
    "y-9": -1.847,
    "y-10": -1.759,
    "y-11": -1.748,
    "y-13": -1.755,
    "y-14": -1.757,
    "y-15": -2.016,
    "y-16": -2.016,
    "y-17": -2.024,
    "y-18": -2.043,
    "y-19": -2.043,
    "y-20": -2.048,
    "y-21": -2.048,
    "y-22": -2.048,
    "y-23": -2.048,
    "y-24": -2.048,
    "y-25": -2.048,
    "y-26": -2.064,
    "y-27": -2.064,
    "y-28": -2.064,
    "y-29": -2.064,
    "y-30": -2.064,
    "y-31": -2.064,
    "y-32": -2.064,
    "y-33": -2.064,
    "y-34": -1.955,
    "y-35": -1.955,
    "y-36": -1.955,
    "y-37": -1.955,
    "y-38": -1.954,
    "y-39": -1.954,
    "y-40": -1.954,
    "y-41": -1.954,
    "y-42": -1.954,
    "y-43": -1.954,
    "y-44": -1.954,
    "y-45": -1.954,
    "y-47": -2.048,
    "y-48": -2.045,
    "y-49": -2.043,
    "y-50": -1.959,
    "y-51": -1.961,
    "y-52": -1.97,
    "y-53": -2.006,
    "y-54": -2.013,
    "y-55": -2.005,
    "y-56": -1.997,
    "y-57": -1.993,
    "y-58": -2.012,
    "y-59": -2.003,
    "y-60": -1.998,
    "y-61": -1.999,
    "y-62": -2.001,
    "y-63": -2.001,
    "y-64": -2.0,
    "y-65": -1.992,
    "y-66": -1.99,
    "y-67": -1.995,
    "y-68": -1.994,
    "y-69": -1.99,
    "y-70": -1.978,
    "y-71": -1.975,
    "y-72": -1.976,
    "y-73": -1.976,
    "y-74": -1.978,
    "y-75": -1.977,
    "y-76": -1.977,
    "y-77": -1.979,
    "y-78": -1.974,
    "y-79": -1.973,
    "y-80": -1.979,
    "y-81": -1.974,
    "y-82": -1.974,
    "y-83": -1.976,
    "y-84": -1.977,
    "y-85": -1.977,
    "y-86": -1.976,
    "y-87": -1.976,
    "y-88": -1.976,
    "y-89": -1.975,
    "y-90": -1.976,
    "y-91": -1.977,
    "y-92": -1.978,
    "y-93": -1.975,
    "y-94": -1.978,
    "y-95": -1.973,
    "y-96": -1.975,
    "y-97": -1.977,
    "y-98": -1.977,
    "y-99": -1.979,
    "y-100": -1.976,
    "y-101": -1.979,
    "y-102": -1.976,
    "y-103": -1.978,
    "y-104": -1.975,
    "y-105": -1.976,
    "y-106": -1.976,
    "y-107": -1.976,
    "y-108": -1.976,
    "y-109": -1.976,
    "y-110": -1.976,
    "y-111": -1.977,
    "y-112": -1.976,
    "y-113": -1.976,
    "y-114": -1.976,
    "y-115": -1.977,
    "y-116": -1.976,
    "y-117": -1.976,
    "y-118": -1.978,
    "y-119": -1.978,
    "y-120": -1.978,
    "y-121": -1.977,
    "y-122": -1.978,
    "y-123": -1.978,
    "y-124": -1.978,
    "y-125": -1.978,
    "y-126": -1.978,
    "y-127": -1.978,
    "y-128": -1.978,
    "y-129": -1.978,
    "y-130": -1.978,
    "y-131": -1.978,
    "y-132": -2.02,
    "y-133": -2.02,
    "y-134": -2.02,
    "y-135": -2.02,
    "y-136": -2.02,
    "y-137": -2.02,
    "y-138": -2.02,
    "y-139": -2.006,
    "y-140": -2.006,
    "y-141": -2.006,
    "y-142": -2.006,
    "y-143": -2.006,
    "y-144": -2.006,
    "y-145": -2.006,
    "y-146": -2.006,
    "y-147": -2.006,
    "y-148": -2.006,
    "y-149": -2.006,
    "y-150": -2.006,
    "y-151": -2.006,
    "y-152": -2.006,
    "y-153": -2.006,
    "y-154": -2.006,
    "y-155": -2.022,
    "y-156": -2.022,
    "y-157": -2.022,
    "y-158": -2.022,
    "y-159": -2.022,
    "y-160": -2.028,
    "y-161": -2.028,
    "y-162": -2.028,
    "y-163": -2.031,
    "y-164": -2.031,
    "y-165": -2.031,
    "y-166": -2.031,
    "y-167": -2.031,
    "y-168": -2.031,
    "y-169": -2.031,
    "y-170": -2.031,
    "y-171": -2.031,
    "y-172": -2.031,
    "y-173": -2.031,
    "y-174": -2.031,
    "y-175": -2.031,
    "y-176": -2.03,
    "y-177": -2.03,
    "y-178": -2.03,
    "y-179": -2.037,
    "y-180": -2.037,
    "y-181": -2.037,
    "y-182": -2.037,
    "y-183": -2.037,
    "y-184": -2.037,
    "y-185": -2.037,
    "y-186": -2.037,
    "y-187": -2.037,
    "y-188": -2.037,
    "y-189": -2.037,
    "y-190": -2.037,
    "y-191": -2.037,
    "y-192": -2.037,
    "y-193": -2.037,
    "y-194": -2.037,
    "y-195": -2.037,
    "y-196": -2.037,
    "y-197": -2.037,
    "y-198": -2.037,
    "y-199": -2.037,
    "y-200": -2.04,
    "y-201": -2.04,
    "y-202": -2.04,
    "y-203": -2.04,
    "y-204": -2.04,
    "y-205": -2.04,
    "y-206": -2.04,
    "y-207": -2.04,
    "y-208": -2.04,
    "y-209": -2.04,
    "y-210": -2.04,
    "y-211": -2.04,
    "y-212": -2.052,
    "y-213": -2.033,
    "y-214": -2.033,
    "y-215": -2.033,
    "y-216": -2.047,
    "y-217": -2.047,
    "y-218": -2.047,
    "y-219": -2.047,
    "y-220": -2.047,
    "y-221": -2.047,
    "y-222": -2.047,
    "y-223": -2.047,
    "y-224": -2.049,
    "y-225": -2.049,
    "y-226": -2.049,
    "y-227": -2.049,
    "y-228": -2.049,
    "y-229": -2.049,
    "y-230": -2.049,
    "y-231": -2.049,
    "y-232": -2.049,
    "y-233": -2.049,
    "y-234": -2.049,
    "y-235": -2.049,
    "y-236": -2.049,
    "y-237": -2.049,
    "y-238": -2.049,
    "y-239": -2.049,
    "y-240": -2.049,
    "y-241": -2.049,
    "y-242": -2.049,
    "y-243": -2.049,
    "y-244": -2.049,
    "y-245": -2.048,
    "y-246": -2.048,
    "y-247": -2.048,
    "y-248": -2.048,
    "y-249": -2.048,
    "y-250": -2.048,
    "y-251": -2.048,
    "y-252": -2.048,
    "y-253": -2.048,
    "y-254": -2.048,
    "y-255": -2.049,
  },
  {
    x: 0.875,
    "y-2": -0.904,
    "y-12": -1.74,
    "y-46": -1.979,
    "y-1000": -2.026,
    "y-0": -0.324,
    "y-1": -1.147,
    "y-3": -2.205,
    "y-4": -1.999,
    "y-5": -1.916,
    "y-6": -1.914,
    "y-7": -1.911,
    "y-8": -1.9,
    "y-9": -1.9,
    "y-10": -1.739,
    "y-11": -1.732,
    "y-13": -1.74,
    "y-14": -1.741,
    "y-15": -2.03,
    "y-16": -2.03,
    "y-17": -2.037,
    "y-18": -2.055,
    "y-19": -2.055,
    "y-20": -2.063,
    "y-21": -2.063,
    "y-22": -2.063,
    "y-23": -2.063,
    "y-24": -2.063,
    "y-25": -2.063,
    "y-26": -2.095,
    "y-27": -2.095,
    "y-28": -2.095,
    "y-29": -2.095,
    "y-30": -2.095,
    "y-31": -2.095,
    "y-32": -2.095,
    "y-33": -2.095,
    "y-34": -1.98,
    "y-35": -1.98,
    "y-36": -1.98,
    "y-37": -1.98,
    "y-38": -1.979,
    "y-39": -1.979,
    "y-40": -1.979,
    "y-41": -1.979,
    "y-42": -1.979,
    "y-43": -1.979,
    "y-44": -1.979,
    "y-45": -1.979,
    "y-47": -2.089,
    "y-48": -2.086,
    "y-49": -2.083,
    "y-50": -1.997,
    "y-51": -1.997,
    "y-52": -2.008,
    "y-53": -2.048,
    "y-54": -2.055,
    "y-55": -2.048,
    "y-56": -2.039,
    "y-57": -2.035,
    "y-58": -2.055,
    "y-59": -2.046,
    "y-60": -2.04,
    "y-61": -2.041,
    "y-62": -2.043,
    "y-63": -2.043,
    "y-64": -2.042,
    "y-65": -2.043,
    "y-66": -2.04,
    "y-67": -2.045,
    "y-68": -2.041,
    "y-69": -2.04,
    "y-70": -2.016,
    "y-71": -2.015,
    "y-72": -2.014,
    "y-73": -2.012,
    "y-74": -2.018,
    "y-75": -2.015,
    "y-76": -2.016,
    "y-77": -2.015,
    "y-78": -2.015,
    "y-79": -2.011,
    "y-80": -2.018,
    "y-81": -2.013,
    "y-82": -2.012,
    "y-83": -2.016,
    "y-84": -2.016,
    "y-85": -2.015,
    "y-86": -2.013,
    "y-87": -2.014,
    "y-88": -2.013,
    "y-89": -2.014,
    "y-90": -2.015,
    "y-91": -2.015,
    "y-92": -2.017,
    "y-93": -2.017,
    "y-94": -2.015,
    "y-95": -2.012,
    "y-96": -2.013,
    "y-97": -2.018,
    "y-98": -2.017,
    "y-99": -2.017,
    "y-100": -2.014,
    "y-101": -2.019,
    "y-102": -2.016,
    "y-103": -2.015,
    "y-104": -2.014,
    "y-105": -2.013,
    "y-106": -2.013,
    "y-107": -2.014,
    "y-108": -2.015,
    "y-109": -2.015,
    "y-110": -2.015,
    "y-111": -2.016,
    "y-112": -2.015,
    "y-113": -2.015,
    "y-114": -2.015,
    "y-115": -2.016,
    "y-116": -2.014,
    "y-117": -2.015,
    "y-118": -2.018,
    "y-119": -2.017,
    "y-120": -2.018,
    "y-121": -2.017,
    "y-122": -2.018,
    "y-123": -2.017,
    "y-124": -2.018,
    "y-125": -2.018,
    "y-126": -2.018,
    "y-127": -2.018,
    "y-128": -2.018,
    "y-129": -2.018,
    "y-130": -2.018,
    "y-131": -2.018,
    "y-132": -2.042,
    "y-133": -2.042,
    "y-134": -2.042,
    "y-135": -2.042,
    "y-136": -2.042,
    "y-137": -2.042,
    "y-138": -2.042,
    "y-139": -2.034,
    "y-140": -2.034,
    "y-141": -2.034,
    "y-142": -2.034,
    "y-143": -2.034,
    "y-144": -2.034,
    "y-145": -2.034,
    "y-146": -2.034,
    "y-147": -2.034,
    "y-148": -2.034,
    "y-149": -2.034,
    "y-150": -2.034,
    "y-151": -2.034,
    "y-152": -2.034,
    "y-153": -2.034,
    "y-154": -2.034,
    "y-155": -2.041,
    "y-156": -2.041,
    "y-157": -2.041,
    "y-158": -2.041,
    "y-159": -2.041,
    "y-160": -2.044,
    "y-161": -2.044,
    "y-162": -2.044,
    "y-163": -2.046,
    "y-164": -2.046,
    "y-165": -2.046,
    "y-166": -2.046,
    "y-167": -2.046,
    "y-168": -2.046,
    "y-169": -2.046,
    "y-170": -2.046,
    "y-171": -2.046,
    "y-172": -2.046,
    "y-173": -2.046,
    "y-174": -2.046,
    "y-175": -2.046,
    "y-176": -2.046,
    "y-177": -2.046,
    "y-178": -2.046,
    "y-179": -2.049,
    "y-180": -2.049,
    "y-181": -2.049,
    "y-182": -2.049,
    "y-183": -2.049,
    "y-184": -2.049,
    "y-185": -2.049,
    "y-186": -2.049,
    "y-187": -2.049,
    "y-188": -2.049,
    "y-189": -2.049,
    "y-190": -2.049,
    "y-191": -2.049,
    "y-192": -2.049,
    "y-193": -2.049,
    "y-194": -2.049,
    "y-195": -2.049,
    "y-196": -2.049,
    "y-197": -2.049,
    "y-198": -2.049,
    "y-199": -2.049,
    "y-200": -2.051,
    "y-201": -2.051,
    "y-202": -2.051,
    "y-203": -2.051,
    "y-204": -2.051,
    "y-205": -2.051,
    "y-206": -2.051,
    "y-207": -2.051,
    "y-208": -2.051,
    "y-209": -2.051,
    "y-210": -2.051,
    "y-211": -2.051,
    "y-212": -2.055,
    "y-213": -2.039,
    "y-214": -2.039,
    "y-215": -2.039,
    "y-216": -2.05,
    "y-217": -2.05,
    "y-218": -2.05,
    "y-219": -2.05,
    "y-220": -2.05,
    "y-221": -2.05,
    "y-222": -2.05,
    "y-223": -2.05,
    "y-224": -2.065,
    "y-225": -2.065,
    "y-226": -2.065,
    "y-227": -2.065,
    "y-228": -2.065,
    "y-229": -2.065,
    "y-230": -2.065,
    "y-231": -2.065,
    "y-232": -2.065,
    "y-233": -2.065,
    "y-234": -2.065,
    "y-235": -2.065,
    "y-236": -2.065,
    "y-237": -2.065,
    "y-238": -2.065,
    "y-239": -2.064,
    "y-240": -2.064,
    "y-241": -2.064,
    "y-242": -2.064,
    "y-243": -2.064,
    "y-244": -2.064,
    "y-245": -2.063,
    "y-246": -2.063,
    "y-247": -2.063,
    "y-248": -2.063,
    "y-249": -2.063,
    "y-250": -2.063,
    "y-251": -2.063,
    "y-252": -2.063,
    "y-253": -2.063,
    "y-254": -2.063,
    "y-255": -2.065,
  },
  {
    x: 0.9,
    "y-2": -0.925,
    "y-12": -1.725,
    "y-46": -1.971,
    "y-1000": -1.971,
    "y-0": -0.336,
    "y-1": -1.171,
    "y-3": -2.281,
    "y-4": -2.06,
    "y-5": -1.971,
    "y-6": -1.968,
    "y-7": -1.965,
    "y-8": -1.953,
    "y-9": -1.953,
    "y-10": -1.72,
    "y-11": -1.715,
    "y-13": -1.725,
    "y-14": -1.726,
    "y-15": -1.929,
    "y-16": -1.929,
    "y-17": -1.927,
    "y-18": -1.921,
    "y-19": -1.921,
    "y-20": -1.927,
    "y-21": -1.927,
    "y-22": -1.927,
    "y-23": -1.927,
    "y-24": -1.927,
    "y-25": -1.927,
    "y-26": -1.951,
    "y-27": -1.951,
    "y-28": -1.951,
    "y-29": -1.951,
    "y-30": -1.951,
    "y-31": -1.951,
    "y-32": -1.951,
    "y-33": -1.951,
    "y-34": -1.971,
    "y-35": -1.971,
    "y-36": -1.971,
    "y-37": -1.971,
    "y-38": -1.971,
    "y-39": -1.971,
    "y-40": -1.971,
    "y-41": -1.971,
    "y-42": -1.971,
    "y-43": -1.971,
    "y-44": -1.971,
    "y-45": -1.971,
    "y-47": -1.971,
    "y-48": -1.971,
    "y-49": -1.971,
    "y-50": -1.971,
    "y-51": -1.971,
    "y-52": -1.971,
    "y-53": -1.971,
    "y-54": -1.971,
    "y-55": -1.971,
    "y-56": -1.971,
    "y-57": -1.971,
    "y-58": -1.971,
    "y-59": -1.971,
    "y-60": -1.971,
    "y-61": -1.971,
    "y-62": -1.971,
    "y-63": -1.971,
    "y-64": -1.971,
    "y-65": -1.971,
    "y-66": -1.971,
    "y-67": -1.971,
    "y-68": -1.971,
    "y-69": -1.971,
    "y-70": -1.971,
    "y-71": -1.971,
    "y-72": -1.971,
    "y-73": -1.971,
    "y-74": -1.971,
    "y-75": -1.971,
    "y-76": -1.971,
    "y-77": -1.971,
    "y-78": -1.971,
    "y-79": -1.971,
    "y-80": -1.971,
    "y-81": -1.971,
    "y-82": -1.971,
    "y-83": -1.971,
    "y-84": -1.971,
    "y-85": -1.971,
    "y-86": -1.971,
    "y-87": -1.971,
    "y-88": -1.971,
    "y-89": -1.971,
    "y-90": -1.971,
    "y-91": -1.971,
    "y-92": -1.971,
    "y-93": -1.971,
    "y-94": -1.971,
    "y-95": -1.971,
    "y-96": -1.971,
    "y-97": -1.971,
    "y-98": -1.971,
    "y-99": -1.971,
    "y-100": -1.971,
    "y-101": -1.971,
    "y-102": -1.971,
    "y-103": -1.971,
    "y-104": -1.971,
    "y-105": -1.971,
    "y-106": -1.971,
    "y-107": -1.971,
    "y-108": -1.971,
    "y-109": -1.971,
    "y-110": -1.971,
    "y-111": -1.971,
    "y-112": -1.971,
    "y-113": -1.971,
    "y-114": -1.971,
    "y-115": -1.971,
    "y-116": -1.971,
    "y-117": -1.971,
    "y-118": -1.971,
    "y-119": -1.971,
    "y-120": -1.971,
    "y-121": -1.971,
    "y-122": -1.971,
    "y-123": -1.971,
    "y-124": -1.971,
    "y-125": -1.971,
    "y-126": -1.971,
    "y-127": -1.971,
    "y-128": -1.971,
    "y-129": -1.971,
    "y-130": -1.971,
    "y-131": -1.971,
    "y-132": -1.971,
    "y-133": -1.971,
    "y-134": -1.971,
    "y-135": -1.971,
    "y-136": -1.971,
    "y-137": -1.971,
    "y-138": -1.971,
    "y-139": -1.971,
    "y-140": -1.971,
    "y-141": -1.971,
    "y-142": -1.971,
    "y-143": -1.971,
    "y-144": -1.971,
    "y-145": -1.971,
    "y-146": -1.971,
    "y-147": -1.971,
    "y-148": -1.971,
    "y-149": -1.971,
    "y-150": -1.971,
    "y-151": -1.971,
    "y-152": -1.971,
    "y-153": -1.971,
    "y-154": -1.971,
    "y-155": -1.971,
    "y-156": -1.971,
    "y-157": -1.971,
    "y-158": -1.971,
    "y-159": -1.971,
    "y-160": -1.971,
    "y-161": -1.971,
    "y-162": -1.971,
    "y-163": -1.971,
    "y-164": -1.971,
    "y-165": -1.971,
    "y-166": -1.971,
    "y-167": -1.971,
    "y-168": -1.971,
    "y-169": -1.971,
    "y-170": -1.971,
    "y-171": -1.971,
    "y-172": -1.971,
    "y-173": -1.971,
    "y-174": -1.971,
    "y-175": -1.971,
    "y-176": -1.971,
    "y-177": -1.971,
    "y-178": -1.971,
    "y-179": -1.971,
    "y-180": -1.971,
    "y-181": -1.971,
    "y-182": -1.971,
    "y-183": -1.971,
    "y-184": -1.971,
    "y-185": -1.971,
    "y-186": -1.971,
    "y-187": -1.971,
    "y-188": -1.971,
    "y-189": -1.971,
    "y-190": -1.971,
    "y-191": -1.971,
    "y-192": -1.971,
    "y-193": -1.971,
    "y-194": -1.971,
    "y-195": -1.971,
    "y-196": -1.971,
    "y-197": -1.971,
    "y-198": -1.971,
    "y-199": -1.971,
    "y-200": -1.971,
    "y-201": -1.971,
    "y-202": -1.971,
    "y-203": -1.971,
    "y-204": -1.971,
    "y-205": -1.971,
    "y-206": -1.971,
    "y-207": -1.971,
    "y-208": -1.971,
    "y-209": -1.971,
    "y-210": -1.971,
    "y-211": -1.971,
    "y-212": -1.971,
    "y-213": -1.971,
    "y-214": -1.971,
    "y-215": -1.971,
    "y-216": -1.971,
    "y-217": -1.971,
    "y-218": -1.971,
    "y-219": -1.971,
    "y-220": -1.971,
    "y-221": -1.971,
    "y-222": -1.971,
    "y-223": -1.971,
    "y-224": -1.971,
    "y-225": -1.971,
    "y-226": -1.971,
    "y-227": -1.971,
    "y-228": -1.971,
    "y-229": -1.971,
    "y-230": -1.971,
    "y-231": -1.971,
    "y-232": -1.971,
    "y-233": -1.971,
    "y-234": -1.971,
    "y-235": -1.971,
    "y-236": -1.971,
    "y-237": -1.971,
    "y-238": -1.971,
    "y-239": -1.971,
    "y-240": -1.971,
    "y-241": -1.971,
    "y-242": -1.971,
    "y-243": -1.971,
    "y-244": -1.971,
    "y-245": -1.971,
    "y-246": -1.971,
    "y-247": -1.971,
    "y-248": -1.971,
    "y-249": -1.971,
    "y-250": -1.971,
    "y-251": -1.971,
    "y-252": -1.971,
    "y-253": -1.971,
    "y-254": -1.971,
    "y-255": -1.971,
  },
  {
    x: 0.925,
    "y-2": -0.946,
    "y-12": -1.71,
    "y-46": -1.963,
    "y-1000": -1.792,
    "y-0": -0.348,
    "y-1": -1.196,
    "y-3": -2.356,
    "y-4": -2.121,
    "y-5": -2.025,
    "y-6": -2.022,
    "y-7": -2.019,
    "y-8": -2.006,
    "y-9": -2.006,
    "y-10": -1.7,
    "y-11": -1.699,
    "y-13": -1.71,
    "y-14": -1.71,
    "y-15": -1.829,
    "y-16": -1.829,
    "y-17": -1.816,
    "y-18": -1.787,
    "y-19": -1.787,
    "y-20": -1.791,
    "y-21": -1.791,
    "y-22": -1.791,
    "y-23": -1.791,
    "y-24": -1.791,
    "y-25": -1.791,
    "y-26": -1.808,
    "y-27": -1.808,
    "y-28": -1.808,
    "y-29": -1.808,
    "y-30": -1.808,
    "y-31": -1.808,
    "y-32": -1.808,
    "y-33": -1.808,
    "y-34": -1.962,
    "y-35": -1.962,
    "y-36": -1.962,
    "y-37": -1.962,
    "y-38": -1.963,
    "y-39": -1.963,
    "y-40": -1.963,
    "y-41": -1.963,
    "y-42": -1.963,
    "y-43": -1.963,
    "y-44": -1.963,
    "y-45": -1.963,
    "y-47": -1.853,
    "y-48": -1.856,
    "y-49": -1.859,
    "y-50": -1.792,
    "y-51": -1.805,
    "y-52": -1.795,
    "y-53": -1.794,
    "y-54": -1.791,
    "y-55": -1.774,
    "y-56": -1.784,
    "y-57": -1.784,
    "y-58": -1.78,
    "y-59": -1.779,
    "y-60": -1.781,
    "y-61": -1.784,
    "y-62": -1.782,
    "y-63": -1.78,
    "y-64": -1.782,
    "y-65": -1.783,
    "y-66": -1.783,
    "y-67": -1.783,
    "y-68": -1.782,
    "y-69": -1.783,
    "y-70": -1.821,
    "y-71": -1.82,
    "y-72": -1.821,
    "y-73": -1.821,
    "y-74": -1.819,
    "y-75": -1.82,
    "y-76": -1.82,
    "y-77": -1.82,
    "y-78": -1.821,
    "y-79": -1.822,
    "y-80": -1.82,
    "y-81": -1.821,
    "y-82": -1.821,
    "y-83": -1.82,
    "y-84": -1.82,
    "y-85": -1.82,
    "y-86": -1.82,
    "y-87": -1.821,
    "y-88": -1.821,
    "y-89": -1.823,
    "y-90": -1.821,
    "y-91": -1.822,
    "y-92": -1.82,
    "y-93": -1.822,
    "y-94": -1.822,
    "y-95": -1.823,
    "y-96": -1.823,
    "y-97": -1.821,
    "y-98": -1.821,
    "y-99": -1.821,
    "y-100": -1.822,
    "y-101": -1.82,
    "y-102": -1.822,
    "y-103": -1.822,
    "y-104": -1.823,
    "y-105": -1.822,
    "y-106": -1.823,
    "y-107": -1.822,
    "y-108": -1.822,
    "y-109": -1.822,
    "y-110": -1.822,
    "y-111": -1.822,
    "y-112": -1.822,
    "y-113": -1.822,
    "y-114": -1.822,
    "y-115": -1.822,
    "y-116": -1.822,
    "y-117": -1.822,
    "y-118": -1.813,
    "y-119": -1.814,
    "y-120": -1.813,
    "y-121": -1.814,
    "y-122": -1.813,
    "y-123": -1.813,
    "y-124": -1.813,
    "y-125": -1.813,
    "y-126": -1.813,
    "y-127": -1.813,
    "y-128": -1.813,
    "y-129": -1.813,
    "y-130": -1.813,
    "y-131": -1.814,
    "y-132": -1.803,
    "y-133": -1.803,
    "y-134": -1.803,
    "y-135": -1.803,
    "y-136": -1.803,
    "y-137": -1.803,
    "y-138": -1.803,
    "y-139": -1.787,
    "y-140": -1.787,
    "y-141": -1.787,
    "y-142": -1.787,
    "y-143": -1.787,
    "y-144": -1.787,
    "y-145": -1.787,
    "y-146": -1.787,
    "y-147": -1.787,
    "y-148": -1.787,
    "y-149": -1.787,
    "y-150": -1.787,
    "y-151": -1.788,
    "y-152": -1.788,
    "y-153": -1.788,
    "y-154": -1.788,
    "y-155": -1.786,
    "y-156": -1.786,
    "y-157": -1.786,
    "y-158": -1.786,
    "y-159": -1.786,
    "y-160": -1.785,
    "y-161": -1.785,
    "y-162": -1.785,
    "y-163": -1.78,
    "y-164": -1.78,
    "y-165": -1.78,
    "y-166": -1.78,
    "y-167": -1.78,
    "y-168": -1.78,
    "y-169": -1.78,
    "y-170": -1.78,
    "y-171": -1.78,
    "y-172": -1.78,
    "y-173": -1.78,
    "y-174": -1.78,
    "y-175": -1.78,
    "y-176": -1.781,
    "y-177": -1.781,
    "y-178": -1.781,
    "y-179": -1.78,
    "y-180": -1.78,
    "y-181": -1.78,
    "y-182": -1.78,
    "y-183": -1.78,
    "y-184": -1.78,
    "y-185": -1.78,
    "y-186": -1.78,
    "y-187": -1.78,
    "y-188": -1.78,
    "y-189": -1.78,
    "y-190": -1.78,
    "y-191": -1.78,
    "y-192": -1.78,
    "y-193": -1.78,
    "y-194": -1.78,
    "y-195": -1.78,
    "y-196": -1.78,
    "y-197": -1.78,
    "y-198": -1.78,
    "y-199": -1.78,
    "y-200": -1.779,
    "y-201": -1.779,
    "y-202": -1.779,
    "y-203": -1.779,
    "y-204": -1.779,
    "y-205": -1.779,
    "y-206": -1.779,
    "y-207": -1.779,
    "y-208": -1.779,
    "y-209": -1.779,
    "y-210": -1.779,
    "y-211": -1.779,
    "y-212": -1.778,
    "y-213": -1.781,
    "y-214": -1.781,
    "y-215": -1.781,
    "y-216": -1.778,
    "y-217": -1.778,
    "y-218": -1.778,
    "y-219": -1.778,
    "y-220": -1.778,
    "y-221": -1.778,
    "y-222": -1.778,
    "y-223": -1.778,
    "y-224": -1.773,
    "y-225": -1.773,
    "y-226": -1.773,
    "y-227": -1.773,
    "y-228": -1.773,
    "y-229": -1.773,
    "y-230": -1.773,
    "y-231": -1.773,
    "y-232": -1.773,
    "y-233": -1.773,
    "y-234": -1.773,
    "y-235": -1.773,
    "y-236": -1.773,
    "y-237": -1.773,
    "y-238": -1.773,
    "y-239": -1.773,
    "y-240": -1.773,
    "y-241": -1.773,
    "y-242": -1.773,
    "y-243": -1.773,
    "y-244": -1.773,
    "y-245": -1.776,
    "y-246": -1.776,
    "y-247": -1.776,
    "y-248": -1.776,
    "y-249": -1.776,
    "y-250": -1.776,
    "y-251": -1.776,
    "y-252": -1.776,
    "y-253": -1.776,
    "y-254": -1.776,
    "y-255": -1.771,
  },
  {
    x: 0.95,
    "y-2": -0.967,
    "y-12": -1.695,
    "y-46": -1.954,
    "y-1000": -1.597,
    "y-0": -0.36,
    "y-1": -1.22,
    "y-3": -2.432,
    "y-4": -2.182,
    "y-5": -2.08,
    "y-6": -2.077,
    "y-7": -2.073,
    "y-8": -2.06,
    "y-9": -2.06,
    "y-10": -1.681,
    "y-11": -1.682,
    "y-13": -1.695,
    "y-14": -1.695,
    "y-15": -1.728,
    "y-16": -1.728,
    "y-17": -1.705,
    "y-18": -1.653,
    "y-19": -1.653,
    "y-20": -1.655,
    "y-21": -1.655,
    "y-22": -1.655,
    "y-23": -1.655,
    "y-24": -1.655,
    "y-25": -1.655,
    "y-26": -1.665,
    "y-27": -1.665,
    "y-28": -1.665,
    "y-29": -1.665,
    "y-30": -1.665,
    "y-31": -1.665,
    "y-32": -1.665,
    "y-33": -1.665,
    "y-34": -1.953,
    "y-35": -1.953,
    "y-36": -1.953,
    "y-37": -1.953,
    "y-38": -1.954,
    "y-39": -1.954,
    "y-40": -1.954,
    "y-41": -1.954,
    "y-42": -1.954,
    "y-43": -1.954,
    "y-44": -1.954,
    "y-45": -1.954,
    "y-47": -1.734,
    "y-48": -1.742,
    "y-49": -1.748,
    "y-50": -1.612,
    "y-51": -1.64,
    "y-52": -1.618,
    "y-53": -1.617,
    "y-54": -1.61,
    "y-55": -1.578,
    "y-56": -1.596,
    "y-57": -1.598,
    "y-58": -1.588,
    "y-59": -1.587,
    "y-60": -1.592,
    "y-61": -1.597,
    "y-62": -1.593,
    "y-63": -1.589,
    "y-64": -1.593,
    "y-65": -1.595,
    "y-66": -1.595,
    "y-67": -1.596,
    "y-68": -1.594,
    "y-69": -1.596,
    "y-70": -1.614,
    "y-71": -1.61,
    "y-72": -1.614,
    "y-73": -1.612,
    "y-74": -1.61,
    "y-75": -1.61,
    "y-76": -1.611,
    "y-77": -1.611,
    "y-78": -1.613,
    "y-79": -1.613,
    "y-80": -1.611,
    "y-81": -1.612,
    "y-82": -1.612,
    "y-83": -1.611,
    "y-84": -1.61,
    "y-85": -1.61,
    "y-86": -1.609,
    "y-87": -1.613,
    "y-88": -1.613,
    "y-89": -1.616,
    "y-90": -1.612,
    "y-91": -1.616,
    "y-92": -1.613,
    "y-93": -1.616,
    "y-94": -1.614,
    "y-95": -1.616,
    "y-96": -1.616,
    "y-97": -1.613,
    "y-98": -1.615,
    "y-99": -1.615,
    "y-100": -1.615,
    "y-101": -1.613,
    "y-102": -1.616,
    "y-103": -1.616,
    "y-104": -1.616,
    "y-105": -1.615,
    "y-106": -1.615,
    "y-107": -1.615,
    "y-108": -1.616,
    "y-109": -1.616,
    "y-110": -1.615,
    "y-111": -1.615,
    "y-112": -1.615,
    "y-113": -1.615,
    "y-114": -1.615,
    "y-115": -1.615,
    "y-116": -1.615,
    "y-117": -1.615,
    "y-118": -1.592,
    "y-119": -1.594,
    "y-120": -1.593,
    "y-121": -1.593,
    "y-122": -1.593,
    "y-123": -1.593,
    "y-124": -1.593,
    "y-125": -1.593,
    "y-126": -1.593,
    "y-127": -1.593,
    "y-128": -1.593,
    "y-129": -1.593,
    "y-130": -1.593,
    "y-131": -1.593,
    "y-132": -1.584,
    "y-133": -1.584,
    "y-134": -1.584,
    "y-135": -1.584,
    "y-136": -1.584,
    "y-137": -1.584,
    "y-138": -1.584,
    "y-139": -1.571,
    "y-140": -1.571,
    "y-141": -1.571,
    "y-142": -1.571,
    "y-143": -1.571,
    "y-144": -1.571,
    "y-145": -1.571,
    "y-146": -1.571,
    "y-147": -1.571,
    "y-148": -1.571,
    "y-149": -1.571,
    "y-150": -1.571,
    "y-151": -1.571,
    "y-152": -1.571,
    "y-153": -1.571,
    "y-154": -1.571,
    "y-155": -1.569,
    "y-156": -1.569,
    "y-157": -1.569,
    "y-158": -1.569,
    "y-159": -1.569,
    "y-160": -1.569,
    "y-161": -1.569,
    "y-162": -1.569,
    "y-163": -1.56,
    "y-164": -1.56,
    "y-165": -1.56,
    "y-166": -1.56,
    "y-167": -1.56,
    "y-168": -1.56,
    "y-169": -1.56,
    "y-170": -1.56,
    "y-171": -1.56,
    "y-172": -1.56,
    "y-173": -1.56,
    "y-174": -1.56,
    "y-175": -1.56,
    "y-176": -1.562,
    "y-177": -1.562,
    "y-178": -1.562,
    "y-179": -1.561,
    "y-180": -1.561,
    "y-181": -1.561,
    "y-182": -1.561,
    "y-183": -1.561,
    "y-184": -1.561,
    "y-185": -1.561,
    "y-186": -1.561,
    "y-187": -1.561,
    "y-188": -1.561,
    "y-189": -1.561,
    "y-190": -1.561,
    "y-191": -1.561,
    "y-192": -1.561,
    "y-193": -1.561,
    "y-194": -1.561,
    "y-195": -1.561,
    "y-196": -1.561,
    "y-197": -1.561,
    "y-198": -1.561,
    "y-199": -1.561,
    "y-200": -1.561,
    "y-201": -1.561,
    "y-202": -1.561,
    "y-203": -1.561,
    "y-204": -1.561,
    "y-205": -1.561,
    "y-206": -1.561,
    "y-207": -1.561,
    "y-208": -1.561,
    "y-209": -1.561,
    "y-210": -1.561,
    "y-211": -1.561,
    "y-212": -1.559,
    "y-213": -1.557,
    "y-214": -1.557,
    "y-215": -1.557,
    "y-216": -1.554,
    "y-217": -1.554,
    "y-218": -1.554,
    "y-219": -1.554,
    "y-220": -1.554,
    "y-221": -1.554,
    "y-222": -1.554,
    "y-223": -1.554,
    "y-224": -1.549,
    "y-225": -1.549,
    "y-226": -1.549,
    "y-227": -1.549,
    "y-228": -1.549,
    "y-229": -1.549,
    "y-230": -1.549,
    "y-231": -1.549,
    "y-232": -1.549,
    "y-233": -1.549,
    "y-234": -1.549,
    "y-235": -1.549,
    "y-236": -1.549,
    "y-237": -1.549,
    "y-238": -1.549,
    "y-239": -1.549,
    "y-240": -1.549,
    "y-241": -1.549,
    "y-242": -1.549,
    "y-243": -1.549,
    "y-244": -1.549,
    "y-245": -1.554,
    "y-246": -1.554,
    "y-247": -1.554,
    "y-248": -1.554,
    "y-249": -1.554,
    "y-250": -1.554,
    "y-251": -1.554,
    "y-252": -1.554,
    "y-253": -1.554,
    "y-254": -1.554,
    "y-255": -1.54,
  },
  {
    x: 0.975,
    "y-2": -0.989,
    "y-12": -1.68,
    "y-46": -1.946,
    "y-1000": -1.428,
    "y-0": -0.372,
    "y-1": -1.245,
    "y-3": -2.508,
    "y-4": -2.243,
    "y-5": -2.135,
    "y-6": -2.131,
    "y-7": -2.127,
    "y-8": -2.113,
    "y-9": -2.113,
    "y-10": -1.661,
    "y-11": -1.666,
    "y-13": -1.68,
    "y-14": -1.68,
    "y-15": -1.627,
    "y-16": -1.627,
    "y-17": -1.594,
    "y-18": -1.519,
    "y-19": -1.519,
    "y-20": -1.519,
    "y-21": -1.519,
    "y-22": -1.519,
    "y-23": -1.519,
    "y-24": -1.519,
    "y-25": -1.519,
    "y-26": -1.521,
    "y-27": -1.521,
    "y-28": -1.521,
    "y-29": -1.521,
    "y-30": -1.521,
    "y-31": -1.521,
    "y-32": -1.521,
    "y-33": -1.521,
    "y-34": -1.943,
    "y-35": -1.943,
    "y-36": -1.943,
    "y-37": -1.943,
    "y-38": -1.946,
    "y-39": -1.946,
    "y-40": -1.946,
    "y-41": -1.946,
    "y-42": -1.946,
    "y-43": -1.946,
    "y-44": -1.946,
    "y-45": -1.946,
    "y-47": -1.616,
    "y-48": -1.627,
    "y-49": -1.636,
    "y-50": -1.433,
    "y-51": -1.474,
    "y-52": -1.442,
    "y-53": -1.44,
    "y-54": -1.43,
    "y-55": -1.381,
    "y-56": -1.409,
    "y-57": -1.411,
    "y-58": -1.397,
    "y-59": -1.395,
    "y-60": -1.402,
    "y-61": -1.409,
    "y-62": -1.404,
    "y-63": -1.398,
    "y-64": -1.403,
    "y-65": -1.408,
    "y-66": -1.407,
    "y-67": -1.408,
    "y-68": -1.405,
    "y-69": -1.408,
    "y-70": -1.407,
    "y-71": -1.4,
    "y-72": -1.406,
    "y-73": -1.403,
    "y-74": -1.401,
    "y-75": -1.4,
    "y-76": -1.402,
    "y-77": -1.402,
    "y-78": -1.405,
    "y-79": -1.404,
    "y-80": -1.403,
    "y-81": -1.403,
    "y-82": -1.403,
    "y-83": -1.402,
    "y-84": -1.4,
    "y-85": -1.4,
    "y-86": -1.399,
    "y-87": -1.405,
    "y-88": -1.404,
    "y-89": -1.409,
    "y-90": -1.404,
    "y-91": -1.409,
    "y-92": -1.405,
    "y-93": -1.41,
    "y-94": -1.407,
    "y-95": -1.409,
    "y-96": -1.409,
    "y-97": -1.406,
    "y-98": -1.408,
    "y-99": -1.408,
    "y-100": -1.408,
    "y-101": -1.405,
    "y-102": -1.409,
    "y-103": -1.409,
    "y-104": -1.409,
    "y-105": -1.408,
    "y-106": -1.408,
    "y-107": -1.409,
    "y-108": -1.409,
    "y-109": -1.409,
    "y-110": -1.409,
    "y-111": -1.408,
    "y-112": -1.409,
    "y-113": -1.408,
    "y-114": -1.408,
    "y-115": -1.408,
    "y-116": -1.408,
    "y-117": -1.407,
    "y-118": -1.389,
    "y-119": -1.391,
    "y-120": -1.389,
    "y-121": -1.39,
    "y-122": -1.39,
    "y-123": -1.389,
    "y-124": -1.39,
    "y-125": -1.39,
    "y-126": -1.39,
    "y-127": -1.39,
    "y-128": -1.39,
    "y-129": -1.39,
    "y-130": -1.39,
    "y-131": -1.39,
    "y-132": -1.384,
    "y-133": -1.384,
    "y-134": -1.384,
    "y-135": -1.384,
    "y-136": -1.384,
    "y-137": -1.384,
    "y-138": -1.384,
    "y-139": -1.374,
    "y-140": -1.374,
    "y-141": -1.374,
    "y-142": -1.374,
    "y-143": -1.374,
    "y-144": -1.374,
    "y-145": -1.374,
    "y-146": -1.374,
    "y-147": -1.374,
    "y-148": -1.374,
    "y-149": -1.374,
    "y-150": -1.374,
    "y-151": -1.374,
    "y-152": -1.374,
    "y-153": -1.374,
    "y-154": -1.374,
    "y-155": -1.373,
    "y-156": -1.373,
    "y-157": -1.373,
    "y-158": -1.373,
    "y-159": -1.373,
    "y-160": -1.373,
    "y-161": -1.373,
    "y-162": -1.373,
    "y-163": -1.37,
    "y-164": -1.37,
    "y-165": -1.37,
    "y-166": -1.37,
    "y-167": -1.37,
    "y-168": -1.37,
    "y-169": -1.37,
    "y-170": -1.37,
    "y-171": -1.37,
    "y-172": -1.37,
    "y-173": -1.37,
    "y-174": -1.37,
    "y-175": -1.37,
    "y-176": -1.373,
    "y-177": -1.373,
    "y-178": -1.373,
    "y-179": -1.372,
    "y-180": -1.372,
    "y-181": -1.372,
    "y-182": -1.372,
    "y-183": -1.372,
    "y-184": -1.372,
    "y-185": -1.372,
    "y-186": -1.372,
    "y-187": -1.372,
    "y-188": -1.373,
    "y-189": -1.373,
    "y-190": -1.373,
    "y-191": -1.373,
    "y-192": -1.373,
    "y-193": -1.373,
    "y-194": -1.373,
    "y-195": -1.373,
    "y-196": -1.373,
    "y-197": -1.373,
    "y-198": -1.373,
    "y-199": -1.373,
    "y-200": -1.373,
    "y-201": -1.373,
    "y-202": -1.373,
    "y-203": -1.373,
    "y-204": -1.373,
    "y-205": -1.373,
    "y-206": -1.373,
    "y-207": -1.373,
    "y-208": -1.373,
    "y-209": -1.373,
    "y-210": -1.373,
    "y-211": -1.373,
    "y-212": -1.372,
    "y-213": -1.369,
    "y-214": -1.369,
    "y-215": -1.369,
    "y-216": -1.368,
    "y-217": -1.368,
    "y-218": -1.368,
    "y-219": -1.368,
    "y-220": -1.368,
    "y-221": -1.368,
    "y-222": -1.368,
    "y-223": -1.368,
    "y-224": -1.365,
    "y-225": -1.365,
    "y-226": -1.365,
    "y-227": -1.365,
    "y-228": -1.365,
    "y-229": -1.365,
    "y-230": -1.365,
    "y-231": -1.365,
    "y-232": -1.365,
    "y-233": -1.365,
    "y-234": -1.365,
    "y-235": -1.365,
    "y-236": -1.365,
    "y-237": -1.365,
    "y-238": -1.365,
    "y-239": -1.366,
    "y-240": -1.366,
    "y-241": -1.366,
    "y-242": -1.366,
    "y-243": -1.366,
    "y-244": -1.366,
    "y-245": -1.371,
    "y-246": -1.371,
    "y-247": -1.371,
    "y-248": -1.371,
    "y-249": -1.371,
    "y-250": -1.371,
    "y-251": -1.371,
    "y-252": -1.371,
    "y-253": -1.371,
    "y-254": -1.371,
    "y-255": -1.353,
  },
  {
    x: 1.0,
    "y-2": -1.01,
    "y-12": -1.666,
    "y-46": -1.373,
    "y-1000": -1.373,
    "y-0": -0.385,
    "y-1": -1.27,
    "y-3": -2.584,
    "y-4": -2.304,
    "y-5": -2.189,
    "y-6": -2.186,
    "y-7": -2.182,
    "y-8": -2.166,
    "y-9": -2.166,
    "y-10": -1.641,
    "y-11": -1.649,
    "y-13": -1.666,
    "y-14": -1.664,
    "y-15": -1.527,
    "y-16": -1.527,
    "y-17": -1.483,
    "y-18": -1.385,
    "y-19": -1.385,
    "y-20": -1.383,
    "y-21": -1.383,
    "y-22": -1.383,
    "y-23": -1.383,
    "y-24": -1.383,
    "y-25": -1.383,
    "y-26": -1.378,
    "y-27": -1.378,
    "y-28": -1.378,
    "y-29": -1.378,
    "y-30": -1.378,
    "y-31": -1.378,
    "y-32": -1.378,
    "y-33": -1.378,
    "y-34": -1.373,
    "y-35": -1.373,
    "y-36": -1.373,
    "y-37": -1.373,
    "y-38": -1.373,
    "y-39": -1.373,
    "y-40": -1.373,
    "y-41": -1.373,
    "y-42": -1.373,
    "y-43": -1.373,
    "y-44": -1.373,
    "y-45": -1.373,
    "y-47": -1.373,
    "y-48": -1.373,
    "y-49": -1.373,
    "y-50": -1.373,
    "y-51": -1.373,
    "y-52": -1.373,
    "y-53": -1.373,
    "y-54": -1.373,
    "y-55": -1.373,
    "y-56": -1.373,
    "y-57": -1.373,
    "y-58": -1.373,
    "y-59": -1.373,
    "y-60": -1.373,
    "y-61": -1.373,
    "y-62": -1.373,
    "y-63": -1.373,
    "y-64": -1.373,
    "y-65": -1.373,
    "y-66": -1.373,
    "y-67": -1.373,
    "y-68": -1.373,
    "y-69": -1.373,
    "y-70": -1.373,
    "y-71": -1.373,
    "y-72": -1.373,
    "y-73": -1.373,
    "y-74": -1.373,
    "y-75": -1.373,
    "y-76": -1.373,
    "y-77": -1.373,
    "y-78": -1.373,
    "y-79": -1.373,
    "y-80": -1.373,
    "y-81": -1.373,
    "y-82": -1.373,
    "y-83": -1.373,
    "y-84": -1.373,
    "y-85": -1.373,
    "y-86": -1.373,
    "y-87": -1.373,
    "y-88": -1.373,
    "y-89": -1.373,
    "y-90": -1.373,
    "y-91": -1.373,
    "y-92": -1.373,
    "y-93": -1.373,
    "y-94": -1.373,
    "y-95": -1.373,
    "y-96": -1.373,
    "y-97": -1.373,
    "y-98": -1.373,
    "y-99": -1.373,
    "y-100": -1.373,
    "y-101": -1.373,
    "y-102": -1.373,
    "y-103": -1.373,
    "y-104": -1.373,
    "y-105": -1.373,
    "y-106": -1.373,
    "y-107": -1.373,
    "y-108": -1.373,
    "y-109": -1.373,
    "y-110": -1.373,
    "y-111": -1.373,
    "y-112": -1.373,
    "y-113": -1.373,
    "y-114": -1.373,
    "y-115": -1.373,
    "y-116": -1.373,
    "y-117": -1.373,
    "y-118": -1.373,
    "y-119": -1.373,
    "y-120": -1.373,
    "y-121": -1.373,
    "y-122": -1.373,
    "y-123": -1.373,
    "y-124": -1.373,
    "y-125": -1.373,
    "y-126": -1.373,
    "y-127": -1.373,
    "y-128": -1.373,
    "y-129": -1.373,
    "y-130": -1.373,
    "y-131": -1.373,
    "y-132": -1.373,
    "y-133": -1.373,
    "y-134": -1.373,
    "y-135": -1.373,
    "y-136": -1.373,
    "y-137": -1.373,
    "y-138": -1.373,
    "y-139": -1.373,
    "y-140": -1.373,
    "y-141": -1.373,
    "y-142": -1.373,
    "y-143": -1.373,
    "y-144": -1.373,
    "y-145": -1.373,
    "y-146": -1.373,
    "y-147": -1.373,
    "y-148": -1.373,
    "y-149": -1.373,
    "y-150": -1.373,
    "y-151": -1.373,
    "y-152": -1.373,
    "y-153": -1.373,
    "y-154": -1.373,
    "y-155": -1.373,
    "y-156": -1.373,
    "y-157": -1.373,
    "y-158": -1.373,
    "y-159": -1.373,
    "y-160": -1.373,
    "y-161": -1.373,
    "y-162": -1.373,
    "y-163": -1.373,
    "y-164": -1.373,
    "y-165": -1.373,
    "y-166": -1.373,
    "y-167": -1.373,
    "y-168": -1.373,
    "y-169": -1.373,
    "y-170": -1.373,
    "y-171": -1.373,
    "y-172": -1.373,
    "y-173": -1.373,
    "y-174": -1.373,
    "y-175": -1.373,
    "y-176": -1.373,
    "y-177": -1.373,
    "y-178": -1.373,
    "y-179": -1.373,
    "y-180": -1.373,
    "y-181": -1.373,
    "y-182": -1.373,
    "y-183": -1.373,
    "y-184": -1.373,
    "y-185": -1.373,
    "y-186": -1.373,
    "y-187": -1.373,
    "y-188": -1.373,
    "y-189": -1.373,
    "y-190": -1.373,
    "y-191": -1.373,
    "y-192": -1.373,
    "y-193": -1.373,
    "y-194": -1.373,
    "y-195": -1.373,
    "y-196": -1.373,
    "y-197": -1.373,
    "y-198": -1.373,
    "y-199": -1.373,
    "y-200": -1.373,
    "y-201": -1.373,
    "y-202": -1.373,
    "y-203": -1.373,
    "y-204": -1.373,
    "y-205": -1.373,
    "y-206": -1.373,
    "y-207": -1.373,
    "y-208": -1.373,
    "y-209": -1.373,
    "y-210": -1.373,
    "y-211": -1.373,
    "y-212": -1.373,
    "y-213": -1.373,
    "y-214": -1.373,
    "y-215": -1.373,
    "y-216": -1.373,
    "y-217": -1.373,
    "y-218": -1.373,
    "y-219": -1.373,
    "y-220": -1.373,
    "y-221": -1.373,
    "y-222": -1.373,
    "y-223": -1.373,
    "y-224": -1.373,
    "y-225": -1.373,
    "y-226": -1.373,
    "y-227": -1.373,
    "y-228": -1.373,
    "y-229": -1.373,
    "y-230": -1.373,
    "y-231": -1.373,
    "y-232": -1.373,
    "y-233": -1.373,
    "y-234": -1.373,
    "y-235": -1.373,
    "y-236": -1.373,
    "y-237": -1.373,
    "y-238": -1.373,
    "y-239": -1.373,
    "y-240": -1.373,
    "y-241": -1.373,
    "y-242": -1.373,
    "y-243": -1.373,
    "y-244": -1.373,
    "y-245": -1.373,
    "y-246": -1.373,
    "y-247": -1.373,
    "y-248": -1.373,
    "y-249": -1.373,
    "y-250": -1.373,
    "y-251": -1.373,
    "y-252": -1.373,
    "y-253": -1.373,
    "y-254": -1.373,
    "y-255": -1.373,
  },
  {
    x: 1.025,
    "y-2": -1.113,
    "y-12": -1.693,
    "y-46": -1.297,
    "y-1000": -1.464,
    "y-0": -0.397,
    "y-1": -1.294,
    "y-3": -2.542,
    "y-4": -2.287,
    "y-5": -2.183,
    "y-6": -2.179,
    "y-7": -2.176,
    "y-8": -2.161,
    "y-9": -2.161,
    "y-10": -1.676,
    "y-11": -1.684,
    "y-13": -1.693,
    "y-14": -1.691,
    "y-15": -1.555,
    "y-16": -1.555,
    "y-17": -1.527,
    "y-18": -1.593,
    "y-19": -1.593,
    "y-20": -1.592,
    "y-21": -1.592,
    "y-22": -1.592,
    "y-23": -1.689,
    "y-24": -1.689,
    "y-25": -1.689,
    "y-26": -1.686,
    "y-27": -1.686,
    "y-28": -1.686,
    "y-29": -1.686,
    "y-30": -1.686,
    "y-31": -1.686,
    "y-32": -1.686,
    "y-33": -1.686,
    "y-34": -1.644,
    "y-35": -1.644,
    "y-36": -1.644,
    "y-37": -1.644,
    "y-38": -1.644,
    "y-39": -1.644,
    "y-40": -1.644,
    "y-41": -1.326,
    "y-42": -1.316,
    "y-43": -1.304,
    "y-44": -1.32,
    "y-45": -1.328,
    "y-47": -1.425,
    "y-48": -1.413,
    "y-49": -1.419,
    "y-50": -1.494,
    "y-51": -1.476,
    "y-52": -1.484,
    "y-53": -1.486,
    "y-54": -1.481,
    "y-55": -1.494,
    "y-56": -1.488,
    "y-57": -1.485,
    "y-58": -1.489,
    "y-59": -1.499,
    "y-60": -1.496,
    "y-61": -1.492,
    "y-62": -1.491,
    "y-63": -1.491,
    "y-64": -1.491,
    "y-65": -1.491,
    "y-66": -1.493,
    "y-67": -1.491,
    "y-68": -1.492,
    "y-69": -1.492,
    "y-70": -1.493,
    "y-71": -1.492,
    "y-72": -1.493,
    "y-73": -1.494,
    "y-74": -1.495,
    "y-75": -1.493,
    "y-76": -1.494,
    "y-77": -1.493,
    "y-78": -1.493,
    "y-79": -1.492,
    "y-80": -1.497,
    "y-81": -1.495,
    "y-82": -1.496,
    "y-83": -1.496,
    "y-84": -1.495,
    "y-85": -1.496,
    "y-86": -1.498,
    "y-87": -1.487,
    "y-88": -1.488,
    "y-89": -1.488,
    "y-90": -1.488,
    "y-91": -1.487,
    "y-92": -1.488,
    "y-93": -1.485,
    "y-94": -1.485,
    "y-95": -1.484,
    "y-96": -1.485,
    "y-97": -1.485,
    "y-98": -1.485,
    "y-99": -1.486,
    "y-100": -1.485,
    "y-101": -1.484,
    "y-102": -1.484,
    "y-103": -1.484,
    "y-104": -1.484,
    "y-105": -1.485,
    "y-106": -1.484,
    "y-107": -1.484,
    "y-108": -1.484,
    "y-109": -1.484,
    "y-110": -1.484,
    "y-111": -1.484,
    "y-112": -1.485,
    "y-113": -1.485,
    "y-114": -1.485,
    "y-115": -1.485,
    "y-116": -1.485,
    "y-117": -1.485,
    "y-118": -1.49,
    "y-119": -1.491,
    "y-120": -1.491,
    "y-121": -1.491,
    "y-122": -1.491,
    "y-123": -1.491,
    "y-124": -1.491,
    "y-125": -1.491,
    "y-126": -1.491,
    "y-127": -1.491,
    "y-128": -1.491,
    "y-129": -1.491,
    "y-130": -1.491,
    "y-131": -1.49,
    "y-132": -1.492,
    "y-133": -1.492,
    "y-134": -1.492,
    "y-135": -1.492,
    "y-136": -1.492,
    "y-137": -1.492,
    "y-138": -1.492,
    "y-139": -1.496,
    "y-140": -1.496,
    "y-141": -1.496,
    "y-142": -1.496,
    "y-143": -1.496,
    "y-144": -1.496,
    "y-145": -1.496,
    "y-146": -1.496,
    "y-147": -1.496,
    "y-148": -1.496,
    "y-149": -1.496,
    "y-150": -1.496,
    "y-151": -1.496,
    "y-152": -1.496,
    "y-153": -1.496,
    "y-154": -1.496,
    "y-155": -1.496,
    "y-156": -1.496,
    "y-157": -1.496,
    "y-158": -1.496,
    "y-159": -1.496,
    "y-160": -1.496,
    "y-161": -1.496,
    "y-162": -1.496,
    "y-163": -1.497,
    "y-164": -1.497,
    "y-165": -1.497,
    "y-166": -1.497,
    "y-167": -1.497,
    "y-168": -1.497,
    "y-169": -1.497,
    "y-170": -1.497,
    "y-171": -1.497,
    "y-172": -1.497,
    "y-173": -1.497,
    "y-174": -1.497,
    "y-175": -1.497,
    "y-176": -1.492,
    "y-177": -1.492,
    "y-178": -1.492,
    "y-179": -1.492,
    "y-180": -1.492,
    "y-181": -1.492,
    "y-182": -1.492,
    "y-183": -1.492,
    "y-184": -1.492,
    "y-185": -1.492,
    "y-186": -1.492,
    "y-187": -1.492,
    "y-188": -1.491,
    "y-189": -1.491,
    "y-190": -1.491,
    "y-191": -1.491,
    "y-192": -1.491,
    "y-193": -1.491,
    "y-194": -1.491,
    "y-195": -1.491,
    "y-196": -1.491,
    "y-197": -1.491,
    "y-198": -1.491,
    "y-199": -1.491,
    "y-200": -1.491,
    "y-201": -1.491,
    "y-202": -1.491,
    "y-203": -1.491,
    "y-204": -1.491,
    "y-205": -1.491,
    "y-206": -1.491,
    "y-207": -1.491,
    "y-208": -1.491,
    "y-209": -1.491,
    "y-210": -1.491,
    "y-211": -1.491,
    "y-212": -1.491,
    "y-213": -1.492,
    "y-214": -1.492,
    "y-215": -1.492,
    "y-216": -1.493,
    "y-217": -1.493,
    "y-218": -1.493,
    "y-219": -1.493,
    "y-220": -1.493,
    "y-221": -1.493,
    "y-222": -1.493,
    "y-223": -1.493,
    "y-224": -1.494,
    "y-225": -1.494,
    "y-226": -1.494,
    "y-227": -1.494,
    "y-228": -1.494,
    "y-229": -1.494,
    "y-230": -1.494,
    "y-231": -1.494,
    "y-232": -1.494,
    "y-233": -1.494,
    "y-234": -1.494,
    "y-235": -1.494,
    "y-236": -1.494,
    "y-237": -1.494,
    "y-238": -1.494,
    "y-239": -1.493,
    "y-240": -1.493,
    "y-241": -1.493,
    "y-242": -1.493,
    "y-243": -1.493,
    "y-244": -1.493,
    "y-245": -1.484,
    "y-246": -1.484,
    "y-247": -1.484,
    "y-248": -1.484,
    "y-249": -1.484,
    "y-250": -1.484,
    "y-251": -1.484,
    "y-252": -1.484,
    "y-253": -1.484,
    "y-254": -1.484,
    "y-255": -1.491,
  },
  {
    x: 1.05,
    "y-2": -1.232,
    "y-12": -1.729,
    "y-46": -1.371,
    "y-1000": -1.641,
    "y-0": -0.409,
    "y-1": -1.319,
    "y-3": -2.476,
    "y-4": -2.254,
    "y-5": -2.164,
    "y-6": -2.16,
    "y-7": -2.157,
    "y-8": -2.145,
    "y-9": -2.145,
    "y-10": -1.723,
    "y-11": -1.729,
    "y-13": -1.729,
    "y-14": -1.727,
    "y-15": -1.61,
    "y-16": -1.61,
    "y-17": -1.602,
    "y-18": -1.831,
    "y-19": -1.831,
    "y-20": -1.831,
    "y-21": -1.831,
    "y-22": -1.831,
    "y-23": -2.017,
    "y-24": -2.017,
    "y-25": -2.017,
    "y-26": -2.017,
    "y-27": -2.017,
    "y-28": -2.017,
    "y-29": -2.017,
    "y-30": -2.017,
    "y-31": -2.018,
    "y-32": -2.018,
    "y-33": -2.018,
    "y-34": -2.017,
    "y-35": -2.017,
    "y-36": -2.017,
    "y-37": -2.017,
    "y-38": -2.017,
    "y-39": -2.017,
    "y-40": -2.017,
    "y-41": -1.425,
    "y-42": -1.407,
    "y-43": -1.384,
    "y-44": -1.414,
    "y-45": -1.429,
    "y-47": -1.552,
    "y-48": -1.531,
    "y-49": -1.546,
    "y-50": -1.649,
    "y-51": -1.623,
    "y-52": -1.632,
    "y-53": -1.636,
    "y-54": -1.624,
    "y-55": -1.639,
    "y-56": -1.633,
    "y-57": -1.629,
    "y-58": -1.633,
    "y-59": -1.651,
    "y-60": -1.648,
    "y-61": -1.643,
    "y-62": -1.641,
    "y-63": -1.64,
    "y-64": -1.642,
    "y-65": -1.642,
    "y-66": -1.644,
    "y-67": -1.642,
    "y-68": -1.644,
    "y-69": -1.644,
    "y-70": -1.644,
    "y-71": -1.642,
    "y-72": -1.644,
    "y-73": -1.645,
    "y-74": -1.647,
    "y-75": -1.643,
    "y-76": -1.645,
    "y-77": -1.644,
    "y-78": -1.645,
    "y-79": -1.643,
    "y-80": -1.653,
    "y-81": -1.65,
    "y-82": -1.652,
    "y-83": -1.651,
    "y-84": -1.649,
    "y-85": -1.652,
    "y-86": -1.656,
    "y-87": -1.634,
    "y-88": -1.635,
    "y-89": -1.637,
    "y-90": -1.635,
    "y-91": -1.636,
    "y-92": -1.636,
    "y-93": -1.632,
    "y-94": -1.63,
    "y-95": -1.629,
    "y-96": -1.631,
    "y-97": -1.63,
    "y-98": -1.629,
    "y-99": -1.632,
    "y-100": -1.63,
    "y-101": -1.628,
    "y-102": -1.63,
    "y-103": -1.629,
    "y-104": -1.628,
    "y-105": -1.63,
    "y-106": -1.628,
    "y-107": -1.629,
    "y-108": -1.629,
    "y-109": -1.629,
    "y-110": -1.629,
    "y-111": -1.628,
    "y-112": -1.631,
    "y-113": -1.631,
    "y-114": -1.631,
    "y-115": -1.63,
    "y-116": -1.63,
    "y-117": -1.63,
    "y-118": -1.638,
    "y-119": -1.639,
    "y-120": -1.639,
    "y-121": -1.639,
    "y-122": -1.639,
    "y-123": -1.638,
    "y-124": -1.639,
    "y-125": -1.639,
    "y-126": -1.639,
    "y-127": -1.639,
    "y-128": -1.639,
    "y-129": -1.639,
    "y-130": -1.639,
    "y-131": -1.637,
    "y-132": -1.641,
    "y-133": -1.641,
    "y-134": -1.641,
    "y-135": -1.641,
    "y-136": -1.641,
    "y-137": -1.641,
    "y-138": -1.641,
    "y-139": -1.646,
    "y-140": -1.646,
    "y-141": -1.646,
    "y-142": -1.646,
    "y-143": -1.646,
    "y-144": -1.646,
    "y-145": -1.646,
    "y-146": -1.646,
    "y-147": -1.646,
    "y-148": -1.646,
    "y-149": -1.646,
    "y-150": -1.646,
    "y-151": -1.646,
    "y-152": -1.645,
    "y-153": -1.645,
    "y-154": -1.645,
    "y-155": -1.646,
    "y-156": -1.646,
    "y-157": -1.646,
    "y-158": -1.646,
    "y-159": -1.646,
    "y-160": -1.646,
    "y-161": -1.646,
    "y-162": -1.646,
    "y-163": -1.647,
    "y-164": -1.647,
    "y-165": -1.647,
    "y-166": -1.647,
    "y-167": -1.647,
    "y-168": -1.647,
    "y-169": -1.647,
    "y-170": -1.647,
    "y-171": -1.647,
    "y-172": -1.647,
    "y-173": -1.647,
    "y-174": -1.647,
    "y-175": -1.647,
    "y-176": -1.637,
    "y-177": -1.637,
    "y-178": -1.637,
    "y-179": -1.637,
    "y-180": -1.637,
    "y-181": -1.637,
    "y-182": -1.637,
    "y-183": -1.637,
    "y-184": -1.637,
    "y-185": -1.637,
    "y-186": -1.637,
    "y-187": -1.637,
    "y-188": -1.634,
    "y-189": -1.634,
    "y-190": -1.634,
    "y-191": -1.634,
    "y-192": -1.634,
    "y-193": -1.634,
    "y-194": -1.634,
    "y-195": -1.634,
    "y-196": -1.634,
    "y-197": -1.634,
    "y-198": -1.634,
    "y-199": -1.634,
    "y-200": -1.634,
    "y-201": -1.634,
    "y-202": -1.634,
    "y-203": -1.634,
    "y-204": -1.634,
    "y-205": -1.634,
    "y-206": -1.634,
    "y-207": -1.634,
    "y-208": -1.634,
    "y-209": -1.634,
    "y-210": -1.634,
    "y-211": -1.634,
    "y-212": -1.635,
    "y-213": -1.637,
    "y-214": -1.637,
    "y-215": -1.637,
    "y-216": -1.638,
    "y-217": -1.638,
    "y-218": -1.638,
    "y-219": -1.638,
    "y-220": -1.638,
    "y-221": -1.638,
    "y-222": -1.638,
    "y-223": -1.638,
    "y-224": -1.64,
    "y-225": -1.64,
    "y-226": -1.64,
    "y-227": -1.64,
    "y-228": -1.64,
    "y-229": -1.64,
    "y-230": -1.64,
    "y-231": -1.64,
    "y-232": -1.64,
    "y-233": -1.64,
    "y-234": -1.64,
    "y-235": -1.64,
    "y-236": -1.64,
    "y-237": -1.64,
    "y-238": -1.64,
    "y-239": -1.637,
    "y-240": -1.637,
    "y-241": -1.637,
    "y-242": -1.637,
    "y-243": -1.637,
    "y-244": -1.637,
    "y-245": -1.62,
    "y-246": -1.62,
    "y-247": -1.62,
    "y-248": -1.62,
    "y-249": -1.62,
    "y-250": -1.62,
    "y-251": -1.62,
    "y-252": -1.62,
    "y-253": -1.62,
    "y-254": -1.62,
    "y-255": -1.632,
  },
  {
    x: 1.075,
    "y-2": -1.35,
    "y-12": -1.764,
    "y-46": -1.67,
    "y-1000": -1.83,
    "y-0": -0.421,
    "y-1": -1.343,
    "y-3": -2.411,
    "y-4": -2.222,
    "y-5": -2.144,
    "y-6": -2.142,
    "y-7": -2.139,
    "y-8": -2.129,
    "y-9": -2.129,
    "y-10": -1.769,
    "y-11": -1.775,
    "y-13": -1.764,
    "y-14": -1.763,
    "y-15": -1.664,
    "y-16": -1.664,
    "y-17": -1.677,
    "y-18": -1.869,
    "y-19": -1.869,
    "y-20": -1.869,
    "y-21": -1.869,
    "y-22": -1.869,
    "y-23": -1.993,
    "y-24": -1.993,
    "y-25": -1.993,
    "y-26": -1.993,
    "y-27": -1.993,
    "y-28": -1.993,
    "y-29": -1.993,
    "y-30": -1.993,
    "y-31": -1.993,
    "y-32": -1.993,
    "y-33": -1.993,
    "y-34": -1.993,
    "y-35": -1.993,
    "y-36": -1.993,
    "y-37": -1.993,
    "y-38": -1.993,
    "y-39": -1.993,
    "y-40": -1.993,
    "y-41": -1.697,
    "y-42": -1.688,
    "y-43": -1.677,
    "y-44": -1.691,
    "y-45": -1.699,
    "y-47": -1.761,
    "y-48": -1.75,
    "y-49": -1.757,
    "y-50": -1.809,
    "y-51": -1.796,
    "y-52": -1.801,
    "y-53": -1.803,
    "y-54": -1.797,
    "y-55": -1.804,
    "y-56": -1.801,
    "y-57": -1.799,
    "y-58": -1.801,
    "y-59": -1.81,
    "y-60": -1.808,
    "y-61": -1.825,
    "y-62": -1.824,
    "y-63": -1.824,
    "y-64": -1.825,
    "y-65": -1.824,
    "y-66": -1.826,
    "y-67": -1.824,
    "y-68": -1.825,
    "y-69": -1.825,
    "y-70": -1.826,
    "y-71": -1.825,
    "y-72": -1.825,
    "y-73": -1.826,
    "y-74": -1.827,
    "y-75": -1.825,
    "y-76": -1.826,
    "y-77": -1.825,
    "y-78": -1.826,
    "y-79": -1.825,
    "y-80": -1.835,
    "y-81": -1.834,
    "y-82": -1.835,
    "y-83": -1.834,
    "y-84": -1.833,
    "y-85": -1.835,
    "y-86": -1.849,
    "y-87": -1.825,
    "y-88": -1.826,
    "y-89": -1.826,
    "y-90": -1.826,
    "y-91": -1.826,
    "y-92": -1.826,
    "y-93": -1.821,
    "y-94": -1.82,
    "y-95": -1.819,
    "y-96": -1.821,
    "y-97": -1.82,
    "y-98": -1.819,
    "y-99": -1.821,
    "y-100": -1.819,
    "y-101": -1.818,
    "y-102": -1.82,
    "y-103": -1.819,
    "y-104": -1.819,
    "y-105": -1.82,
    "y-106": -1.818,
    "y-107": -1.819,
    "y-108": -1.819,
    "y-109": -1.819,
    "y-110": -1.819,
    "y-111": -1.818,
    "y-112": -1.821,
    "y-113": -1.821,
    "y-114": -1.821,
    "y-115": -1.82,
    "y-116": -1.82,
    "y-117": -1.82,
    "y-118": -1.825,
    "y-119": -1.826,
    "y-120": -1.826,
    "y-121": -1.826,
    "y-122": -1.826,
    "y-123": -1.825,
    "y-124": -1.826,
    "y-125": -1.826,
    "y-126": -1.826,
    "y-127": -1.826,
    "y-128": -1.826,
    "y-129": -1.826,
    "y-130": -1.826,
    "y-131": -1.824,
    "y-132": -1.826,
    "y-133": -1.826,
    "y-134": -1.826,
    "y-135": -1.826,
    "y-136": -1.826,
    "y-137": -1.826,
    "y-138": -1.826,
    "y-139": -1.83,
    "y-140": -1.83,
    "y-141": -1.83,
    "y-142": -1.83,
    "y-143": -1.83,
    "y-144": -1.83,
    "y-145": -1.83,
    "y-146": -1.83,
    "y-147": -1.83,
    "y-148": -1.83,
    "y-149": -1.83,
    "y-150": -1.829,
    "y-151": -1.829,
    "y-152": -1.829,
    "y-153": -1.829,
    "y-154": -1.829,
    "y-155": -1.829,
    "y-156": -1.829,
    "y-157": -1.829,
    "y-158": -1.829,
    "y-159": -1.829,
    "y-160": -1.829,
    "y-161": -1.829,
    "y-162": -1.829,
    "y-163": -1.83,
    "y-164": -1.83,
    "y-165": -1.83,
    "y-166": -1.83,
    "y-167": -1.83,
    "y-168": -1.83,
    "y-169": -1.83,
    "y-170": -1.83,
    "y-171": -1.83,
    "y-172": -1.83,
    "y-173": -1.83,
    "y-174": -1.83,
    "y-175": -1.83,
    "y-176": -1.825,
    "y-177": -1.825,
    "y-178": -1.825,
    "y-179": -1.825,
    "y-180": -1.825,
    "y-181": -1.825,
    "y-182": -1.825,
    "y-183": -1.825,
    "y-184": -1.825,
    "y-185": -1.825,
    "y-186": -1.825,
    "y-187": -1.825,
    "y-188": -1.822,
    "y-189": -1.822,
    "y-190": -1.822,
    "y-191": -1.822,
    "y-192": -1.822,
    "y-193": -1.822,
    "y-194": -1.822,
    "y-195": -1.822,
    "y-196": -1.822,
    "y-197": -1.822,
    "y-198": -1.822,
    "y-199": -1.822,
    "y-200": -1.822,
    "y-201": -1.822,
    "y-202": -1.822,
    "y-203": -1.822,
    "y-204": -1.822,
    "y-205": -1.822,
    "y-206": -1.822,
    "y-207": -1.822,
    "y-208": -1.822,
    "y-209": -1.822,
    "y-210": -1.822,
    "y-211": -1.822,
    "y-212": -1.822,
    "y-213": -1.824,
    "y-214": -1.824,
    "y-215": -1.824,
    "y-216": -1.824,
    "y-217": -1.824,
    "y-218": -1.824,
    "y-219": -1.824,
    "y-220": -1.824,
    "y-221": -1.824,
    "y-222": -1.824,
    "y-223": -1.824,
    "y-224": -1.825,
    "y-225": -1.825,
    "y-226": -1.825,
    "y-227": -1.825,
    "y-228": -1.825,
    "y-229": -1.825,
    "y-230": -1.825,
    "y-231": -1.825,
    "y-232": -1.825,
    "y-233": -1.825,
    "y-234": -1.825,
    "y-235": -1.825,
    "y-236": -1.825,
    "y-237": -1.825,
    "y-238": -1.825,
    "y-239": -1.823,
    "y-240": -1.823,
    "y-241": -1.823,
    "y-242": -1.823,
    "y-243": -1.823,
    "y-244": -1.822,
    "y-245": -1.806,
    "y-246": -1.806,
    "y-247": -1.806,
    "y-248": -1.806,
    "y-249": -1.806,
    "y-250": -1.806,
    "y-251": -1.806,
    "y-252": -1.806,
    "y-253": -1.806,
    "y-254": -1.806,
    "y-255": -1.813,
  },
  {
    x: 1.1,
    "y-2": -1.469,
    "y-12": -1.8,
    "y-46": -1.969,
    "y-1000": -1.969,
    "y-0": -0.433,
    "y-1": -1.368,
    "y-3": -2.345,
    "y-4": -2.189,
    "y-5": -2.125,
    "y-6": -2.123,
    "y-7": -2.121,
    "y-8": -2.112,
    "y-9": -2.112,
    "y-10": -1.815,
    "y-11": -1.82,
    "y-13": -1.8,
    "y-14": -1.799,
    "y-15": -1.719,
    "y-16": -1.719,
    "y-17": -1.752,
    "y-18": -1.907,
    "y-19": -1.907,
    "y-20": -1.907,
    "y-21": -1.907,
    "y-22": -1.907,
    "y-23": -1.969,
    "y-24": -1.969,
    "y-25": -1.969,
    "y-26": -1.969,
    "y-27": -1.969,
    "y-28": -1.969,
    "y-29": -1.969,
    "y-30": -1.969,
    "y-31": -1.969,
    "y-32": -1.969,
    "y-33": -1.969,
    "y-34": -1.969,
    "y-35": -1.969,
    "y-36": -1.969,
    "y-37": -1.969,
    "y-38": -1.969,
    "y-39": -1.969,
    "y-40": -1.969,
    "y-41": -1.969,
    "y-42": -1.969,
    "y-43": -1.969,
    "y-44": -1.969,
    "y-45": -1.969,
    "y-47": -1.969,
    "y-48": -1.969,
    "y-49": -1.969,
    "y-50": -1.969,
    "y-51": -1.969,
    "y-52": -1.969,
    "y-53": -1.969,
    "y-54": -1.969,
    "y-55": -1.969,
    "y-56": -1.969,
    "y-57": -1.969,
    "y-58": -1.969,
    "y-59": -1.969,
    "y-60": -1.969,
    "y-61": -1.969,
    "y-62": -1.969,
    "y-63": -1.969,
    "y-64": -1.969,
    "y-65": -1.969,
    "y-66": -1.969,
    "y-67": -1.969,
    "y-68": -1.969,
    "y-69": -1.969,
    "y-70": -1.969,
    "y-71": -1.969,
    "y-72": -1.969,
    "y-73": -1.969,
    "y-74": -1.969,
    "y-75": -1.969,
    "y-76": -1.969,
    "y-77": -1.969,
    "y-78": -1.969,
    "y-79": -1.969,
    "y-80": -1.969,
    "y-81": -1.969,
    "y-82": -1.969,
    "y-83": -1.969,
    "y-84": -1.969,
    "y-85": -1.969,
    "y-86": -1.969,
    "y-87": -1.969,
    "y-88": -1.969,
    "y-89": -1.969,
    "y-90": -1.969,
    "y-91": -1.969,
    "y-92": -1.969,
    "y-93": -1.969,
    "y-94": -1.969,
    "y-95": -1.969,
    "y-96": -1.969,
    "y-97": -1.969,
    "y-98": -1.969,
    "y-99": -1.969,
    "y-100": -1.969,
    "y-101": -1.969,
    "y-102": -1.969,
    "y-103": -1.969,
    "y-104": -1.969,
    "y-105": -1.969,
    "y-106": -1.969,
    "y-107": -1.969,
    "y-108": -1.969,
    "y-109": -1.969,
    "y-110": -1.969,
    "y-111": -1.969,
    "y-112": -1.969,
    "y-113": -1.969,
    "y-114": -1.969,
    "y-115": -1.969,
    "y-116": -1.969,
    "y-117": -1.969,
    "y-118": -1.969,
    "y-119": -1.969,
    "y-120": -1.969,
    "y-121": -1.969,
    "y-122": -1.969,
    "y-123": -1.969,
    "y-124": -1.969,
    "y-125": -1.969,
    "y-126": -1.969,
    "y-127": -1.969,
    "y-128": -1.969,
    "y-129": -1.969,
    "y-130": -1.969,
    "y-131": -1.969,
    "y-132": -1.969,
    "y-133": -1.969,
    "y-134": -1.969,
    "y-135": -1.969,
    "y-136": -1.969,
    "y-137": -1.969,
    "y-138": -1.969,
    "y-139": -1.969,
    "y-140": -1.969,
    "y-141": -1.969,
    "y-142": -1.969,
    "y-143": -1.969,
    "y-144": -1.969,
    "y-145": -1.969,
    "y-146": -1.969,
    "y-147": -1.969,
    "y-148": -1.969,
    "y-149": -1.969,
    "y-150": -1.969,
    "y-151": -1.969,
    "y-152": -1.969,
    "y-153": -1.969,
    "y-154": -1.969,
    "y-155": -1.969,
    "y-156": -1.969,
    "y-157": -1.969,
    "y-158": -1.969,
    "y-159": -1.969,
    "y-160": -1.969,
    "y-161": -1.969,
    "y-162": -1.969,
    "y-163": -1.969,
    "y-164": -1.969,
    "y-165": -1.969,
    "y-166": -1.969,
    "y-167": -1.969,
    "y-168": -1.969,
    "y-169": -1.969,
    "y-170": -1.969,
    "y-171": -1.969,
    "y-172": -1.969,
    "y-173": -1.969,
    "y-174": -1.969,
    "y-175": -1.969,
    "y-176": -1.969,
    "y-177": -1.969,
    "y-178": -1.969,
    "y-179": -1.969,
    "y-180": -1.969,
    "y-181": -1.969,
    "y-182": -1.969,
    "y-183": -1.969,
    "y-184": -1.969,
    "y-185": -1.969,
    "y-186": -1.969,
    "y-187": -1.969,
    "y-188": -1.969,
    "y-189": -1.969,
    "y-190": -1.969,
    "y-191": -1.969,
    "y-192": -1.969,
    "y-193": -1.969,
    "y-194": -1.969,
    "y-195": -1.969,
    "y-196": -1.969,
    "y-197": -1.969,
    "y-198": -1.969,
    "y-199": -1.969,
    "y-200": -1.969,
    "y-201": -1.969,
    "y-202": -1.969,
    "y-203": -1.969,
    "y-204": -1.969,
    "y-205": -1.969,
    "y-206": -1.969,
    "y-207": -1.969,
    "y-208": -1.969,
    "y-209": -1.969,
    "y-210": -1.969,
    "y-211": -1.969,
    "y-212": -1.969,
    "y-213": -1.969,
    "y-214": -1.969,
    "y-215": -1.969,
    "y-216": -1.969,
    "y-217": -1.969,
    "y-218": -1.969,
    "y-219": -1.969,
    "y-220": -1.969,
    "y-221": -1.969,
    "y-222": -1.969,
    "y-223": -1.969,
    "y-224": -1.969,
    "y-225": -1.969,
    "y-226": -1.969,
    "y-227": -1.969,
    "y-228": -1.969,
    "y-229": -1.969,
    "y-230": -1.969,
    "y-231": -1.969,
    "y-232": -1.969,
    "y-233": -1.969,
    "y-234": -1.969,
    "y-235": -1.969,
    "y-236": -1.969,
    "y-237": -1.969,
    "y-238": -1.969,
    "y-239": -1.969,
    "y-240": -1.969,
    "y-241": -1.969,
    "y-242": -1.969,
    "y-243": -1.969,
    "y-244": -1.969,
    "y-245": -1.969,
    "y-246": -1.969,
    "y-247": -1.969,
    "y-248": -1.969,
    "y-249": -1.969,
    "y-250": -1.969,
    "y-251": -1.969,
    "y-252": -1.969,
    "y-253": -1.969,
    "y-254": -1.969,
    "y-255": -1.969,
  },
  {
    x: 1.125,
    "y-2": -1.588,
    "y-12": -1.836,
    "y-46": -1.955,
    "y-1000": -2.005,
    "y-0": -0.446,
    "y-1": -1.393,
    "y-3": -2.28,
    "y-4": -2.157,
    "y-5": -2.106,
    "y-6": -2.104,
    "y-7": -2.103,
    "y-8": -2.096,
    "y-9": -2.096,
    "y-10": -1.861,
    "y-11": -1.865,
    "y-13": -1.836,
    "y-14": -1.835,
    "y-15": -1.773,
    "y-16": -1.773,
    "y-17": -1.827,
    "y-18": -1.945,
    "y-19": -1.945,
    "y-20": -1.945,
    "y-21": -1.945,
    "y-22": -1.945,
    "y-23": -1.945,
    "y-24": -1.945,
    "y-25": -1.945,
    "y-26": -1.945,
    "y-27": -1.945,
    "y-28": -1.945,
    "y-29": -1.945,
    "y-30": -1.945,
    "y-31": -1.945,
    "y-32": -1.945,
    "y-33": -1.945,
    "y-34": -1.945,
    "y-35": -1.945,
    "y-36": -1.945,
    "y-37": -1.945,
    "y-38": -1.945,
    "y-39": -1.945,
    "y-40": -1.945,
    "y-41": -1.954,
    "y-42": -1.954,
    "y-43": -1.954,
    "y-44": -1.954,
    "y-45": -1.954,
    "y-47": -1.952,
    "y-48": -1.956,
    "y-49": -1.954,
    "y-50": -1.952,
    "y-51": -1.956,
    "y-52": -1.953,
    "y-53": -1.949,
    "y-54": -1.953,
    "y-55": -1.954,
    "y-56": -1.952,
    "y-57": -1.951,
    "y-58": -1.954,
    "y-59": -1.951,
    "y-60": -1.953,
    "y-61": -1.95,
    "y-62": -1.951,
    "y-63": -1.951,
    "y-64": -1.95,
    "y-65": -1.951,
    "y-66": -1.95,
    "y-67": -1.951,
    "y-68": -1.951,
    "y-69": -1.951,
    "y-70": -1.951,
    "y-71": -1.95,
    "y-72": -1.951,
    "y-73": -1.95,
    "y-74": -1.95,
    "y-75": -1.95,
    "y-76": -1.95,
    "y-77": -1.95,
    "y-78": -1.951,
    "y-79": -1.951,
    "y-80": -1.95,
    "y-81": -1.95,
    "y-82": -1.95,
    "y-83": -1.951,
    "y-84": -1.951,
    "y-85": -1.95,
    "y-86": -1.951,
    "y-87": -1.98,
    "y-88": -1.979,
    "y-89": -1.981,
    "y-90": -1.979,
    "y-91": -1.98,
    "y-92": -1.979,
    "y-93": -1.993,
    "y-94": -1.995,
    "y-95": -1.995,
    "y-96": -1.993,
    "y-97": -1.995,
    "y-98": -1.998,
    "y-99": -1.996,
    "y-100": -1.996,
    "y-101": -1.997,
    "y-102": -1.996,
    "y-103": -1.996,
    "y-104": -1.996,
    "y-105": -1.996,
    "y-106": -1.999,
    "y-107": -1.997,
    "y-108": -1.997,
    "y-109": -1.998,
    "y-110": -1.997,
    "y-111": -1.998,
    "y-112": -1.993,
    "y-113": -1.993,
    "y-114": -1.994,
    "y-115": -1.995,
    "y-116": -1.995,
    "y-117": -1.994,
    "y-118": -1.993,
    "y-119": -1.993,
    "y-120": -1.992,
    "y-121": -1.992,
    "y-122": -1.992,
    "y-123": -1.993,
    "y-124": -1.993,
    "y-125": -1.993,
    "y-126": -1.993,
    "y-127": -1.993,
    "y-128": -1.993,
    "y-129": -1.993,
    "y-130": -1.993,
    "y-131": -1.996,
    "y-132": -1.995,
    "y-133": -1.995,
    "y-134": -1.995,
    "y-135": -1.995,
    "y-136": -1.995,
    "y-137": -1.995,
    "y-138": -1.995,
    "y-139": -1.994,
    "y-140": -1.994,
    "y-141": -1.994,
    "y-142": -1.994,
    "y-143": -1.994,
    "y-144": -1.994,
    "y-145": -1.994,
    "y-146": -1.994,
    "y-147": -1.994,
    "y-148": -1.994,
    "y-149": -1.994,
    "y-150": -1.994,
    "y-151": -1.995,
    "y-152": -1.995,
    "y-153": -1.995,
    "y-154": -1.995,
    "y-155": -1.995,
    "y-156": -1.995,
    "y-157": -1.995,
    "y-158": -1.995,
    "y-159": -1.995,
    "y-160": -1.995,
    "y-161": -1.995,
    "y-162": -1.995,
    "y-163": -1.995,
    "y-164": -1.995,
    "y-165": -1.995,
    "y-166": -1.995,
    "y-167": -1.995,
    "y-168": -1.995,
    "y-169": -1.995,
    "y-170": -1.995,
    "y-171": -1.995,
    "y-172": -1.995,
    "y-173": -1.995,
    "y-174": -1.995,
    "y-175": -1.995,
    "y-176": -1.996,
    "y-177": -1.997,
    "y-178": -1.997,
    "y-179": -1.997,
    "y-180": -1.997,
    "y-181": -1.997,
    "y-182": -1.997,
    "y-183": -1.997,
    "y-184": -1.997,
    "y-185": -1.997,
    "y-186": -1.997,
    "y-187": -1.997,
    "y-188": -2.003,
    "y-189": -2.003,
    "y-190": -2.003,
    "y-191": -2.003,
    "y-192": -2.003,
    "y-193": -2.003,
    "y-194": -2.003,
    "y-195": -2.003,
    "y-196": -2.003,
    "y-197": -2.003,
    "y-198": -2.003,
    "y-199": -2.003,
    "y-200": -2.003,
    "y-201": -2.003,
    "y-202": -2.003,
    "y-203": -2.003,
    "y-204": -2.003,
    "y-205": -2.003,
    "y-206": -2.003,
    "y-207": -2.003,
    "y-208": -2.003,
    "y-209": -2.003,
    "y-210": -2.003,
    "y-211": -2.003,
    "y-212": -2.003,
    "y-213": -2.002,
    "y-214": -2.002,
    "y-215": -2.002,
    "y-216": -2.002,
    "y-217": -2.002,
    "y-218": -2.002,
    "y-219": -2.002,
    "y-220": -2.002,
    "y-221": -2.002,
    "y-222": -2.002,
    "y-223": -2.002,
    "y-224": -2.002,
    "y-225": -2.002,
    "y-226": -2.002,
    "y-227": -2.002,
    "y-228": -2.002,
    "y-229": -2.002,
    "y-230": -2.002,
    "y-231": -2.002,
    "y-232": -2.002,
    "y-233": -2.002,
    "y-234": -2.002,
    "y-235": -2.002,
    "y-236": -2.002,
    "y-237": -2.002,
    "y-238": -2.002,
    "y-239": -2.008,
    "y-240": -2.008,
    "y-241": -2.008,
    "y-242": -2.008,
    "y-243": -2.008,
    "y-244": -2.008,
    "y-245": -2.005,
    "y-246": -2.004,
    "y-247": -2.004,
    "y-248": -2.004,
    "y-249": -2.004,
    "y-250": -2.004,
    "y-251": -2.004,
    "y-252": -2.004,
    "y-253": -2.004,
    "y-254": -2.004,
    "y-255": -2.002,
  },
  {
    x: 1.15,
    "y-2": -1.707,
    "y-12": -1.872,
    "y-46": -1.927,
    "y-1000": -1.983,
    "y-0": -0.458,
    "y-1": -1.417,
    "y-3": -2.215,
    "y-4": -2.124,
    "y-5": -2.087,
    "y-6": -2.086,
    "y-7": -2.085,
    "y-8": -2.079,
    "y-9": -2.079,
    "y-10": -1.907,
    "y-11": -1.91,
    "y-13": -1.872,
    "y-14": -1.871,
    "y-15": -1.828,
    "y-16": -1.828,
    "y-17": -1.901,
    "y-18": -1.983,
    "y-19": -1.983,
    "y-20": -1.983,
    "y-21": -1.983,
    "y-22": -1.983,
    "y-23": -1.92,
    "y-24": -1.92,
    "y-25": -1.92,
    "y-26": -1.92,
    "y-27": -1.921,
    "y-28": -1.92,
    "y-29": -1.92,
    "y-30": -1.921,
    "y-31": -1.921,
    "y-32": -1.921,
    "y-33": -1.921,
    "y-34": -1.92,
    "y-35": -1.92,
    "y-36": -1.92,
    "y-37": -1.92,
    "y-38": -1.92,
    "y-39": -1.921,
    "y-40": -1.92,
    "y-41": -1.927,
    "y-42": -1.927,
    "y-43": -1.927,
    "y-44": -1.927,
    "y-45": -1.926,
    "y-47": -1.925,
    "y-48": -1.933,
    "y-49": -1.93,
    "y-50": -1.928,
    "y-51": -1.934,
    "y-52": -1.929,
    "y-53": -1.922,
    "y-54": -1.93,
    "y-55": -1.931,
    "y-56": -1.927,
    "y-57": -1.925,
    "y-58": -1.93,
    "y-59": -1.926,
    "y-60": -1.93,
    "y-61": -1.926,
    "y-62": -1.929,
    "y-63": -1.927,
    "y-64": -1.926,
    "y-65": -1.928,
    "y-66": -1.926,
    "y-67": -1.929,
    "y-68": -1.928,
    "y-69": -1.928,
    "y-70": -1.928,
    "y-71": -1.926,
    "y-72": -1.928,
    "y-73": -1.926,
    "y-74": -1.926,
    "y-75": -1.926,
    "y-76": -1.926,
    "y-77": -1.926,
    "y-78": -1.928,
    "y-79": -1.929,
    "y-80": -1.927,
    "y-81": -1.927,
    "y-82": -1.926,
    "y-83": -1.928,
    "y-84": -1.928,
    "y-85": -1.927,
    "y-86": -1.928,
    "y-87": -1.945,
    "y-88": -1.943,
    "y-89": -1.946,
    "y-90": -1.942,
    "y-91": -1.945,
    "y-92": -1.943,
    "y-93": -1.963,
    "y-94": -1.966,
    "y-95": -1.966,
    "y-96": -1.963,
    "y-97": -1.966,
    "y-98": -1.974,
    "y-99": -1.971,
    "y-100": -1.972,
    "y-101": -1.974,
    "y-102": -1.971,
    "y-103": -1.972,
    "y-104": -1.97,
    "y-105": -1.972,
    "y-106": -1.978,
    "y-107": -1.974,
    "y-108": -1.974,
    "y-109": -1.976,
    "y-110": -1.974,
    "y-111": -1.976,
    "y-112": -1.966,
    "y-113": -1.966,
    "y-114": -1.967,
    "y-115": -1.969,
    "y-116": -1.969,
    "y-117": -1.967,
    "y-118": -1.967,
    "y-119": -1.967,
    "y-120": -1.965,
    "y-121": -1.966,
    "y-122": -1.965,
    "y-123": -1.968,
    "y-124": -1.966,
    "y-125": -1.966,
    "y-126": -1.966,
    "y-127": -1.966,
    "y-128": -1.966,
    "y-129": -1.966,
    "y-130": -1.966,
    "y-131": -1.971,
    "y-132": -1.971,
    "y-133": -1.971,
    "y-134": -1.971,
    "y-135": -1.971,
    "y-136": -1.971,
    "y-137": -1.971,
    "y-138": -1.971,
    "y-139": -1.969,
    "y-140": -1.969,
    "y-141": -1.969,
    "y-142": -1.969,
    "y-143": -1.969,
    "y-144": -1.97,
    "y-145": -1.97,
    "y-146": -1.97,
    "y-147": -1.97,
    "y-148": -1.97,
    "y-149": -1.97,
    "y-150": -1.97,
    "y-151": -1.972,
    "y-152": -1.973,
    "y-153": -1.973,
    "y-154": -1.973,
    "y-155": -1.972,
    "y-156": -1.972,
    "y-157": -1.972,
    "y-158": -1.972,
    "y-159": -1.972,
    "y-160": -1.972,
    "y-161": -1.972,
    "y-162": -1.972,
    "y-163": -1.972,
    "y-164": -1.972,
    "y-165": -1.972,
    "y-166": -1.972,
    "y-167": -1.972,
    "y-168": -1.972,
    "y-169": -1.972,
    "y-170": -1.972,
    "y-171": -1.972,
    "y-172": -1.972,
    "y-173": -1.972,
    "y-174": -1.972,
    "y-175": -1.972,
    "y-176": -1.974,
    "y-177": -1.975,
    "y-178": -1.975,
    "y-179": -1.975,
    "y-180": -1.975,
    "y-181": -1.975,
    "y-182": -1.975,
    "y-183": -1.975,
    "y-184": -1.975,
    "y-185": -1.975,
    "y-186": -1.975,
    "y-187": -1.975,
    "y-188": -1.987,
    "y-189": -1.987,
    "y-190": -1.987,
    "y-191": -1.987,
    "y-192": -1.987,
    "y-193": -1.987,
    "y-194": -1.987,
    "y-195": -1.987,
    "y-196": -1.987,
    "y-197": -1.987,
    "y-198": -1.987,
    "y-199": -1.987,
    "y-200": -1.987,
    "y-201": -1.987,
    "y-202": -1.987,
    "y-203": -1.987,
    "y-204": -1.987,
    "y-205": -1.987,
    "y-206": -1.987,
    "y-207": -1.987,
    "y-208": -1.987,
    "y-209": -1.987,
    "y-210": -1.987,
    "y-211": -1.987,
    "y-212": -1.986,
    "y-213": -1.986,
    "y-214": -1.986,
    "y-215": -1.986,
    "y-216": -1.986,
    "y-217": -1.986,
    "y-218": -1.986,
    "y-219": -1.986,
    "y-220": -1.986,
    "y-221": -1.986,
    "y-222": -1.986,
    "y-223": -1.986,
    "y-224": -1.985,
    "y-225": -1.985,
    "y-226": -1.985,
    "y-227": -1.985,
    "y-228": -1.985,
    "y-229": -1.985,
    "y-230": -1.985,
    "y-231": -1.985,
    "y-232": -1.985,
    "y-233": -1.985,
    "y-234": -1.985,
    "y-235": -1.985,
    "y-236": -1.985,
    "y-237": -1.985,
    "y-238": -1.985,
    "y-239": -1.999,
    "y-240": -1.999,
    "y-241": -1.999,
    "y-242": -1.999,
    "y-243": -1.999,
    "y-244": -1.999,
    "y-245": -1.99,
    "y-246": -1.989,
    "y-247": -1.989,
    "y-248": -1.989,
    "y-249": -1.989,
    "y-250": -1.989,
    "y-251": -1.989,
    "y-252": -1.989,
    "y-253": -1.989,
    "y-254": -1.989,
    "y-255": -1.986,
  },
  {
    x: 1.175,
    "y-2": -1.826,
    "y-12": -1.908,
    "y-46": -1.9,
    "y-1000": -1.929,
    "y-0": -0.47,
    "y-1": -1.442,
    "y-3": -2.149,
    "y-4": -2.092,
    "y-5": -2.068,
    "y-6": -2.067,
    "y-7": -2.066,
    "y-8": -2.063,
    "y-9": -2.063,
    "y-10": -1.954,
    "y-11": -1.955,
    "y-13": -1.908,
    "y-14": -1.907,
    "y-15": -1.882,
    "y-16": -1.882,
    "y-17": -1.976,
    "y-18": -2.021,
    "y-19": -2.021,
    "y-20": -2.021,
    "y-21": -2.021,
    "y-22": -2.021,
    "y-23": -1.896,
    "y-24": -1.896,
    "y-25": -1.896,
    "y-26": -1.896,
    "y-27": -1.896,
    "y-28": -1.896,
    "y-29": -1.896,
    "y-30": -1.896,
    "y-31": -1.896,
    "y-32": -1.896,
    "y-33": -1.896,
    "y-34": -1.896,
    "y-35": -1.896,
    "y-36": -1.896,
    "y-37": -1.896,
    "y-38": -1.896,
    "y-39": -1.896,
    "y-40": -1.896,
    "y-41": -1.899,
    "y-42": -1.899,
    "y-43": -1.899,
    "y-44": -1.899,
    "y-45": -1.899,
    "y-47": -1.899,
    "y-48": -1.911,
    "y-49": -1.905,
    "y-50": -1.904,
    "y-51": -1.913,
    "y-52": -1.905,
    "y-53": -1.894,
    "y-54": -1.906,
    "y-55": -1.908,
    "y-56": -1.903,
    "y-57": -1.899,
    "y-58": -1.907,
    "y-59": -1.901,
    "y-60": -1.908,
    "y-61": -1.902,
    "y-62": -1.907,
    "y-63": -1.904,
    "y-64": -1.901,
    "y-65": -1.906,
    "y-66": -1.903,
    "y-67": -1.906,
    "y-68": -1.905,
    "y-69": -1.906,
    "y-70": -1.905,
    "y-71": -1.902,
    "y-72": -1.906,
    "y-73": -1.902,
    "y-74": -1.902,
    "y-75": -1.902,
    "y-76": -1.902,
    "y-77": -1.902,
    "y-78": -1.906,
    "y-79": -1.906,
    "y-80": -1.904,
    "y-81": -1.904,
    "y-82": -1.902,
    "y-83": -1.906,
    "y-84": -1.906,
    "y-85": -1.904,
    "y-86": -1.906,
    "y-87": -1.909,
    "y-88": -1.907,
    "y-89": -1.911,
    "y-90": -1.906,
    "y-91": -1.91,
    "y-92": -1.908,
    "y-93": -1.912,
    "y-94": -1.916,
    "y-95": -1.916,
    "y-96": -1.912,
    "y-97": -1.915,
    "y-98": -1.914,
    "y-99": -1.912,
    "y-100": -1.912,
    "y-101": -1.915,
    "y-102": -1.911,
    "y-103": -1.912,
    "y-104": -1.911,
    "y-105": -1.912,
    "y-106": -1.918,
    "y-107": -1.915,
    "y-108": -1.915,
    "y-109": -1.916,
    "y-110": -1.915,
    "y-111": -1.916,
    "y-112": -1.907,
    "y-113": -1.907,
    "y-114": -1.908,
    "y-115": -1.91,
    "y-116": -1.91,
    "y-117": -1.908,
    "y-118": -1.909,
    "y-119": -1.909,
    "y-120": -1.907,
    "y-121": -1.908,
    "y-122": -1.907,
    "y-123": -1.91,
    "y-124": -1.909,
    "y-125": -1.909,
    "y-126": -1.909,
    "y-127": -1.909,
    "y-128": -1.909,
    "y-129": -1.909,
    "y-130": -1.909,
    "y-131": -1.91,
    "y-132": -1.91,
    "y-133": -1.91,
    "y-134": -1.91,
    "y-135": -1.91,
    "y-136": -1.91,
    "y-137": -1.91,
    "y-138": -1.91,
    "y-139": -1.91,
    "y-140": -1.91,
    "y-141": -1.91,
    "y-142": -1.91,
    "y-143": -1.91,
    "y-144": -1.91,
    "y-145": -1.91,
    "y-146": -1.91,
    "y-147": -1.91,
    "y-148": -1.91,
    "y-149": -1.91,
    "y-150": -1.91,
    "y-151": -1.912,
    "y-152": -1.913,
    "y-153": -1.913,
    "y-154": -1.913,
    "y-155": -1.913,
    "y-156": -1.913,
    "y-157": -1.913,
    "y-158": -1.913,
    "y-159": -1.913,
    "y-160": -1.913,
    "y-161": -1.913,
    "y-162": -1.913,
    "y-163": -1.913,
    "y-164": -1.913,
    "y-165": -1.913,
    "y-166": -1.913,
    "y-167": -1.913,
    "y-168": -1.913,
    "y-169": -1.913,
    "y-170": -1.913,
    "y-171": -1.913,
    "y-172": -1.913,
    "y-173": -1.913,
    "y-174": -1.913,
    "y-175": -1.913,
    "y-176": -1.913,
    "y-177": -1.914,
    "y-178": -1.914,
    "y-179": -1.914,
    "y-180": -1.914,
    "y-181": -1.914,
    "y-182": -1.914,
    "y-183": -1.914,
    "y-184": -1.914,
    "y-185": -1.914,
    "y-186": -1.914,
    "y-187": -1.914,
    "y-188": -1.927,
    "y-189": -1.927,
    "y-190": -1.927,
    "y-191": -1.927,
    "y-192": -1.927,
    "y-193": -1.927,
    "y-194": -1.927,
    "y-195": -1.927,
    "y-196": -1.927,
    "y-197": -1.927,
    "y-198": -1.927,
    "y-199": -1.927,
    "y-200": -1.927,
    "y-201": -1.927,
    "y-202": -1.927,
    "y-203": -1.927,
    "y-204": -1.927,
    "y-205": -1.927,
    "y-206": -1.927,
    "y-207": -1.927,
    "y-208": -1.927,
    "y-209": -1.927,
    "y-210": -1.927,
    "y-211": -1.927,
    "y-212": -1.926,
    "y-213": -1.926,
    "y-214": -1.926,
    "y-215": -1.926,
    "y-216": -1.926,
    "y-217": -1.926,
    "y-218": -1.926,
    "y-219": -1.926,
    "y-220": -1.926,
    "y-221": -1.926,
    "y-222": -1.926,
    "y-223": -1.926,
    "y-224": -1.926,
    "y-225": -1.926,
    "y-226": -1.926,
    "y-227": -1.926,
    "y-228": -1.926,
    "y-229": -1.926,
    "y-230": -1.926,
    "y-231": -1.926,
    "y-232": -1.926,
    "y-233": -1.926,
    "y-234": -1.926,
    "y-235": -1.926,
    "y-236": -1.926,
    "y-237": -1.926,
    "y-238": -1.926,
    "y-239": -1.93,
    "y-240": -1.93,
    "y-241": -1.93,
    "y-242": -1.93,
    "y-243": -1.93,
    "y-244": -1.93,
    "y-245": -1.926,
    "y-246": -1.925,
    "y-247": -1.925,
    "y-248": -1.925,
    "y-249": -1.925,
    "y-250": -1.925,
    "y-251": -1.925,
    "y-252": -1.925,
    "y-253": -1.925,
    "y-254": -1.925,
    "y-255": -1.924,
  },
  {
    x: 1.2,
    "y-2": -1.945,
    "y-12": -1.943,
    "y-46": -1.872,
    "y-1000": -1.872,
    "y-0": -0.482,
    "y-1": -1.466,
    "y-3": -2.084,
    "y-4": -2.059,
    "y-5": -2.049,
    "y-6": -2.049,
    "y-7": -2.048,
    "y-8": -2.047,
    "y-9": -2.047,
    "y-10": -2.0,
    "y-11": -2.001,
    "y-13": -1.943,
    "y-14": -1.943,
    "y-15": -1.937,
    "y-16": -1.937,
    "y-17": -2.051,
    "y-18": -2.058,
    "y-19": -2.058,
    "y-20": -2.058,
    "y-21": -2.058,
    "y-22": -2.058,
    "y-23": -1.872,
    "y-24": -1.872,
    "y-25": -1.872,
    "y-26": -1.872,
    "y-27": -1.872,
    "y-28": -1.872,
    "y-29": -1.872,
    "y-30": -1.872,
    "y-31": -1.872,
    "y-32": -1.872,
    "y-33": -1.872,
    "y-34": -1.872,
    "y-35": -1.872,
    "y-36": -1.872,
    "y-37": -1.872,
    "y-38": -1.872,
    "y-39": -1.872,
    "y-40": -1.872,
    "y-41": -1.872,
    "y-42": -1.872,
    "y-43": -1.872,
    "y-44": -1.872,
    "y-45": -1.872,
    "y-47": -1.872,
    "y-48": -1.872,
    "y-49": -1.872,
    "y-50": -1.872,
    "y-51": -1.872,
    "y-52": -1.872,
    "y-53": -1.872,
    "y-54": -1.872,
    "y-55": -1.872,
    "y-56": -1.872,
    "y-57": -1.872,
    "y-58": -1.872,
    "y-59": -1.872,
    "y-60": -1.872,
    "y-61": -1.872,
    "y-62": -1.872,
    "y-63": -1.872,
    "y-64": -1.872,
    "y-65": -1.872,
    "y-66": -1.872,
    "y-67": -1.872,
    "y-68": -1.872,
    "y-69": -1.872,
    "y-70": -1.872,
    "y-71": -1.872,
    "y-72": -1.872,
    "y-73": -1.872,
    "y-74": -1.872,
    "y-75": -1.872,
    "y-76": -1.872,
    "y-77": -1.872,
    "y-78": -1.872,
    "y-79": -1.872,
    "y-80": -1.872,
    "y-81": -1.872,
    "y-82": -1.872,
    "y-83": -1.872,
    "y-84": -1.872,
    "y-85": -1.872,
    "y-86": -1.872,
    "y-87": -1.872,
    "y-88": -1.872,
    "y-89": -1.872,
    "y-90": -1.872,
    "y-91": -1.872,
    "y-92": -1.872,
    "y-93": -1.872,
    "y-94": -1.872,
    "y-95": -1.872,
    "y-96": -1.872,
    "y-97": -1.872,
    "y-98": -1.872,
    "y-99": -1.872,
    "y-100": -1.872,
    "y-101": -1.872,
    "y-102": -1.872,
    "y-103": -1.872,
    "y-104": -1.872,
    "y-105": -1.872,
    "y-106": -1.872,
    "y-107": -1.872,
    "y-108": -1.872,
    "y-109": -1.872,
    "y-110": -1.872,
    "y-111": -1.872,
    "y-112": -1.872,
    "y-113": -1.872,
    "y-114": -1.872,
    "y-115": -1.872,
    "y-116": -1.872,
    "y-117": -1.872,
    "y-118": -1.872,
    "y-119": -1.872,
    "y-120": -1.872,
    "y-121": -1.872,
    "y-122": -1.872,
    "y-123": -1.872,
    "y-124": -1.872,
    "y-125": -1.872,
    "y-126": -1.872,
    "y-127": -1.872,
    "y-128": -1.872,
    "y-129": -1.872,
    "y-130": -1.872,
    "y-131": -1.872,
    "y-132": -1.872,
    "y-133": -1.872,
    "y-134": -1.872,
    "y-135": -1.872,
    "y-136": -1.872,
    "y-137": -1.872,
    "y-138": -1.872,
    "y-139": -1.872,
    "y-140": -1.872,
    "y-141": -1.872,
    "y-142": -1.872,
    "y-143": -1.872,
    "y-144": -1.872,
    "y-145": -1.872,
    "y-146": -1.872,
    "y-147": -1.872,
    "y-148": -1.872,
    "y-149": -1.872,
    "y-150": -1.872,
    "y-151": -1.872,
    "y-152": -1.872,
    "y-153": -1.872,
    "y-154": -1.872,
    "y-155": -1.872,
    "y-156": -1.872,
    "y-157": -1.872,
    "y-158": -1.872,
    "y-159": -1.872,
    "y-160": -1.872,
    "y-161": -1.872,
    "y-162": -1.872,
    "y-163": -1.872,
    "y-164": -1.872,
    "y-165": -1.872,
    "y-166": -1.872,
    "y-167": -1.872,
    "y-168": -1.872,
    "y-169": -1.872,
    "y-170": -1.872,
    "y-171": -1.872,
    "y-172": -1.872,
    "y-173": -1.872,
    "y-174": -1.872,
    "y-175": -1.872,
    "y-176": -1.872,
    "y-177": -1.872,
    "y-178": -1.872,
    "y-179": -1.872,
    "y-180": -1.872,
    "y-181": -1.872,
    "y-182": -1.872,
    "y-183": -1.872,
    "y-184": -1.872,
    "y-185": -1.872,
    "y-186": -1.872,
    "y-187": -1.872,
    "y-188": -1.872,
    "y-189": -1.872,
    "y-190": -1.872,
    "y-191": -1.872,
    "y-192": -1.872,
    "y-193": -1.872,
    "y-194": -1.872,
    "y-195": -1.872,
    "y-196": -1.872,
    "y-197": -1.872,
    "y-198": -1.872,
    "y-199": -1.872,
    "y-200": -1.872,
    "y-201": -1.872,
    "y-202": -1.872,
    "y-203": -1.872,
    "y-204": -1.872,
    "y-205": -1.872,
    "y-206": -1.872,
    "y-207": -1.872,
    "y-208": -1.872,
    "y-209": -1.872,
    "y-210": -1.872,
    "y-211": -1.872,
    "y-212": -1.872,
    "y-213": -1.872,
    "y-214": -1.872,
    "y-215": -1.872,
    "y-216": -1.872,
    "y-217": -1.872,
    "y-218": -1.872,
    "y-219": -1.872,
    "y-220": -1.872,
    "y-221": -1.872,
    "y-222": -1.872,
    "y-223": -1.872,
    "y-224": -1.872,
    "y-225": -1.872,
    "y-226": -1.872,
    "y-227": -1.872,
    "y-228": -1.872,
    "y-229": -1.872,
    "y-230": -1.872,
    "y-231": -1.872,
    "y-232": -1.872,
    "y-233": -1.872,
    "y-234": -1.872,
    "y-235": -1.872,
    "y-236": -1.872,
    "y-237": -1.872,
    "y-238": -1.872,
    "y-239": -1.872,
    "y-240": -1.872,
    "y-241": -1.872,
    "y-242": -1.872,
    "y-243": -1.872,
    "y-244": -1.872,
    "y-245": -1.872,
    "y-246": -1.872,
    "y-247": -1.872,
    "y-248": -1.872,
    "y-249": -1.872,
    "y-250": -1.872,
    "y-251": -1.872,
    "y-252": -1.872,
    "y-253": -1.872,
    "y-254": -1.872,
    "y-255": -1.872,
  },
  {
    x: 1.225,
    "y-2": -2.064,
    "y-12": -1.979,
    "y-46": -1.844,
    "y-1000": -1.829,
    "y-0": -0.494,
    "y-1": -1.491,
    "y-3": -2.018,
    "y-4": -2.026,
    "y-5": -2.03,
    "y-6": -2.03,
    "y-7": -2.03,
    "y-8": -2.03,
    "y-9": -2.03,
    "y-10": -2.046,
    "y-11": -2.046,
    "y-13": -1.979,
    "y-14": -1.979,
    "y-15": -1.992,
    "y-16": -1.992,
    "y-17": -2.126,
    "y-18": -2.096,
    "y-19": -2.096,
    "y-20": -2.096,
    "y-21": -2.096,
    "y-22": -2.096,
    "y-23": -1.848,
    "y-24": -1.848,
    "y-25": -1.848,
    "y-26": -1.848,
    "y-27": -1.848,
    "y-28": -1.848,
    "y-29": -1.848,
    "y-30": -1.848,
    "y-31": -1.848,
    "y-32": -1.848,
    "y-33": -1.848,
    "y-34": -1.848,
    "y-35": -1.848,
    "y-36": -1.848,
    "y-37": -1.848,
    "y-38": -1.848,
    "y-39": -1.848,
    "y-40": -1.848,
    "y-41": -1.845,
    "y-42": -1.845,
    "y-43": -1.845,
    "y-44": -1.845,
    "y-45": -1.845,
    "y-47": -1.845,
    "y-48": -1.828,
    "y-49": -1.836,
    "y-50": -1.837,
    "y-51": -1.824,
    "y-52": -1.837,
    "y-53": -1.851,
    "y-54": -1.834,
    "y-55": -1.831,
    "y-56": -1.839,
    "y-57": -1.845,
    "y-58": -1.833,
    "y-59": -1.842,
    "y-60": -1.832,
    "y-61": -1.84,
    "y-62": -1.833,
    "y-63": -1.837,
    "y-64": -1.841,
    "y-65": -1.835,
    "y-66": -1.839,
    "y-67": -1.834,
    "y-68": -1.836,
    "y-69": -1.834,
    "y-70": -1.836,
    "y-71": -1.841,
    "y-72": -1.835,
    "y-73": -1.84,
    "y-74": -1.839,
    "y-75": -1.84,
    "y-76": -1.84,
    "y-77": -1.84,
    "y-78": -1.835,
    "y-79": -1.834,
    "y-80": -1.837,
    "y-81": -1.836,
    "y-82": -1.84,
    "y-83": -1.835,
    "y-84": -1.834,
    "y-85": -1.837,
    "y-86": -1.835,
    "y-87": -1.835,
    "y-88": -1.838,
    "y-89": -1.832,
    "y-90": -1.839,
    "y-91": -1.833,
    "y-92": -1.836,
    "y-93": -1.835,
    "y-94": -1.83,
    "y-95": -1.831,
    "y-96": -1.835,
    "y-97": -1.831,
    "y-98": -1.834,
    "y-99": -1.837,
    "y-100": -1.836,
    "y-101": -1.834,
    "y-102": -1.838,
    "y-103": -1.836,
    "y-104": -1.838,
    "y-105": -1.836,
    "y-106": -1.83,
    "y-107": -1.834,
    "y-108": -1.833,
    "y-109": -1.832,
    "y-110": -1.834,
    "y-111": -1.832,
    "y-112": -1.842,
    "y-113": -1.843,
    "y-114": -1.841,
    "y-115": -1.839,
    "y-116": -1.839,
    "y-117": -1.841,
    "y-118": -1.84,
    "y-119": -1.84,
    "y-120": -1.842,
    "y-121": -1.841,
    "y-122": -1.842,
    "y-123": -1.839,
    "y-124": -1.84,
    "y-125": -1.84,
    "y-126": -1.84,
    "y-127": -1.84,
    "y-128": -1.84,
    "y-129": -1.84,
    "y-130": -1.84,
    "y-131": -1.842,
    "y-132": -1.842,
    "y-133": -1.842,
    "y-134": -1.842,
    "y-135": -1.842,
    "y-136": -1.842,
    "y-137": -1.842,
    "y-138": -1.842,
    "y-139": -1.842,
    "y-140": -1.842,
    "y-141": -1.842,
    "y-142": -1.842,
    "y-143": -1.842,
    "y-144": -1.841,
    "y-145": -1.841,
    "y-146": -1.841,
    "y-147": -1.841,
    "y-148": -1.841,
    "y-149": -1.841,
    "y-150": -1.841,
    "y-151": -1.839,
    "y-152": -1.838,
    "y-153": -1.838,
    "y-154": -1.838,
    "y-155": -1.838,
    "y-156": -1.838,
    "y-157": -1.838,
    "y-158": -1.838,
    "y-159": -1.838,
    "y-160": -1.838,
    "y-161": -1.838,
    "y-162": -1.838,
    "y-163": -1.838,
    "y-164": -1.838,
    "y-165": -1.838,
    "y-166": -1.838,
    "y-167": -1.838,
    "y-168": -1.838,
    "y-169": -1.838,
    "y-170": -1.838,
    "y-171": -1.838,
    "y-172": -1.838,
    "y-173": -1.838,
    "y-174": -1.838,
    "y-175": -1.838,
    "y-176": -1.838,
    "y-177": -1.836,
    "y-178": -1.836,
    "y-179": -1.836,
    "y-180": -1.836,
    "y-181": -1.836,
    "y-182": -1.836,
    "y-183": -1.836,
    "y-184": -1.836,
    "y-185": -1.836,
    "y-186": -1.836,
    "y-187": -1.836,
    "y-188": -1.835,
    "y-189": -1.835,
    "y-190": -1.835,
    "y-191": -1.835,
    "y-192": -1.835,
    "y-193": -1.835,
    "y-194": -1.835,
    "y-195": -1.835,
    "y-196": -1.835,
    "y-197": -1.835,
    "y-198": -1.835,
    "y-199": -1.835,
    "y-200": -1.835,
    "y-201": -1.835,
    "y-202": -1.835,
    "y-203": -1.835,
    "y-204": -1.835,
    "y-205": -1.835,
    "y-206": -1.835,
    "y-207": -1.835,
    "y-208": -1.835,
    "y-209": -1.835,
    "y-210": -1.835,
    "y-211": -1.835,
    "y-212": -1.835,
    "y-213": -1.835,
    "y-214": -1.835,
    "y-215": -1.835,
    "y-216": -1.835,
    "y-217": -1.835,
    "y-218": -1.835,
    "y-219": -1.835,
    "y-220": -1.835,
    "y-221": -1.835,
    "y-222": -1.835,
    "y-223": -1.835,
    "y-224": -1.835,
    "y-225": -1.835,
    "y-226": -1.835,
    "y-227": -1.835,
    "y-228": -1.835,
    "y-229": -1.835,
    "y-230": -1.835,
    "y-231": -1.835,
    "y-232": -1.835,
    "y-233": -1.835,
    "y-234": -1.835,
    "y-235": -1.835,
    "y-236": -1.835,
    "y-237": -1.835,
    "y-238": -1.835,
    "y-239": -1.835,
    "y-240": -1.835,
    "y-241": -1.835,
    "y-242": -1.835,
    "y-243": -1.835,
    "y-244": -1.834,
    "y-245": -1.835,
    "y-246": -1.837,
    "y-247": -1.837,
    "y-248": -1.837,
    "y-249": -1.837,
    "y-250": -1.837,
    "y-251": -1.837,
    "y-252": -1.837,
    "y-253": -1.837,
    "y-254": -1.837,
    "y-255": -1.837,
  },
  {
    x: 1.25,
    "y-2": -2.181,
    "y-12": -2.014,
    "y-46": -1.817,
    "y-1000": -1.792,
    "y-0": -0.507,
    "y-1": -1.515,
    "y-3": -1.952,
    "y-4": -1.993,
    "y-5": -2.01,
    "y-6": -2.011,
    "y-7": -2.011,
    "y-8": -2.013,
    "y-9": -2.013,
    "y-10": -2.091,
    "y-11": -2.09,
    "y-13": -2.014,
    "y-14": -2.014,
    "y-15": -2.045,
    "y-16": -2.045,
    "y-17": -2.2,
    "y-18": -2.133,
    "y-19": -2.133,
    "y-20": -2.133,
    "y-21": -2.133,
    "y-22": -2.133,
    "y-23": -1.825,
    "y-24": -1.825,
    "y-25": -1.825,
    "y-26": -1.825,
    "y-27": -1.825,
    "y-28": -1.823,
    "y-29": -1.823,
    "y-30": -1.823,
    "y-31": -1.823,
    "y-32": -1.823,
    "y-33": -1.823,
    "y-34": -1.823,
    "y-35": -1.823,
    "y-36": -1.823,
    "y-37": -1.823,
    "y-38": -1.823,
    "y-39": -1.823,
    "y-40": -1.824,
    "y-41": -1.817,
    "y-42": -1.817,
    "y-43": -1.817,
    "y-44": -1.817,
    "y-45": -1.818,
    "y-47": -1.819,
    "y-48": -1.784,
    "y-49": -1.799,
    "y-50": -1.802,
    "y-51": -1.777,
    "y-52": -1.801,
    "y-53": -1.831,
    "y-54": -1.796,
    "y-55": -1.79,
    "y-56": -1.807,
    "y-57": -1.818,
    "y-58": -1.793,
    "y-59": -1.812,
    "y-60": -1.793,
    "y-61": -1.807,
    "y-62": -1.794,
    "y-63": -1.801,
    "y-64": -1.81,
    "y-65": -1.797,
    "y-66": -1.806,
    "y-67": -1.796,
    "y-68": -1.799,
    "y-69": -1.797,
    "y-70": -1.8,
    "y-71": -1.809,
    "y-72": -1.798,
    "y-73": -1.807,
    "y-74": -1.806,
    "y-75": -1.807,
    "y-76": -1.808,
    "y-77": -1.808,
    "y-78": -1.797,
    "y-79": -1.796,
    "y-80": -1.801,
    "y-81": -1.801,
    "y-82": -1.808,
    "y-83": -1.798,
    "y-84": -1.796,
    "y-85": -1.802,
    "y-86": -1.798,
    "y-87": -1.797,
    "y-88": -1.803,
    "y-89": -1.793,
    "y-90": -1.805,
    "y-91": -1.794,
    "y-92": -1.801,
    "y-93": -1.798,
    "y-94": -1.788,
    "y-95": -1.789,
    "y-96": -1.798,
    "y-97": -1.791,
    "y-98": -1.797,
    "y-99": -1.801,
    "y-100": -1.801,
    "y-101": -1.796,
    "y-102": -1.804,
    "y-103": -1.801,
    "y-104": -1.803,
    "y-105": -1.801,
    "y-106": -1.787,
    "y-107": -1.795,
    "y-108": -1.795,
    "y-109": -1.792,
    "y-110": -1.795,
    "y-111": -1.792,
    "y-112": -1.813,
    "y-113": -1.813,
    "y-114": -1.811,
    "y-115": -1.806,
    "y-116": -1.806,
    "y-117": -1.81,
    "y-118": -1.807,
    "y-119": -1.808,
    "y-120": -1.811,
    "y-121": -1.81,
    "y-122": -1.811,
    "y-123": -1.806,
    "y-124": -1.809,
    "y-125": -1.809,
    "y-126": -1.809,
    "y-127": -1.809,
    "y-128": -1.809,
    "y-129": -1.809,
    "y-130": -1.809,
    "y-131": -1.811,
    "y-132": -1.812,
    "y-133": -1.812,
    "y-134": -1.812,
    "y-135": -1.812,
    "y-136": -1.812,
    "y-137": -1.812,
    "y-138": -1.812,
    "y-139": -1.812,
    "y-140": -1.812,
    "y-141": -1.812,
    "y-142": -1.812,
    "y-143": -1.812,
    "y-144": -1.811,
    "y-145": -1.811,
    "y-146": -1.811,
    "y-147": -1.811,
    "y-148": -1.811,
    "y-149": -1.811,
    "y-150": -1.811,
    "y-151": -1.806,
    "y-152": -1.804,
    "y-153": -1.804,
    "y-154": -1.804,
    "y-155": -1.804,
    "y-156": -1.804,
    "y-157": -1.804,
    "y-158": -1.804,
    "y-159": -1.804,
    "y-160": -1.804,
    "y-161": -1.803,
    "y-162": -1.803,
    "y-163": -1.803,
    "y-164": -1.803,
    "y-165": -1.803,
    "y-166": -1.803,
    "y-167": -1.803,
    "y-168": -1.803,
    "y-169": -1.803,
    "y-170": -1.803,
    "y-171": -1.803,
    "y-172": -1.803,
    "y-173": -1.803,
    "y-174": -1.804,
    "y-175": -1.804,
    "y-176": -1.803,
    "y-177": -1.801,
    "y-178": -1.801,
    "y-179": -1.801,
    "y-180": -1.801,
    "y-181": -1.801,
    "y-182": -1.801,
    "y-183": -1.8,
    "y-184": -1.8,
    "y-185": -1.8,
    "y-186": -1.8,
    "y-187": -1.8,
    "y-188": -1.802,
    "y-189": -1.802,
    "y-190": -1.802,
    "y-191": -1.802,
    "y-192": -1.802,
    "y-193": -1.802,
    "y-194": -1.802,
    "y-195": -1.802,
    "y-196": -1.802,
    "y-197": -1.802,
    "y-198": -1.802,
    "y-199": -1.802,
    "y-200": -1.802,
    "y-201": -1.802,
    "y-202": -1.802,
    "y-203": -1.802,
    "y-204": -1.802,
    "y-205": -1.803,
    "y-206": -1.803,
    "y-207": -1.803,
    "y-208": -1.803,
    "y-209": -1.803,
    "y-210": -1.803,
    "y-211": -1.803,
    "y-212": -1.803,
    "y-213": -1.803,
    "y-214": -1.803,
    "y-215": -1.803,
    "y-216": -1.803,
    "y-217": -1.803,
    "y-218": -1.803,
    "y-219": -1.803,
    "y-220": -1.803,
    "y-221": -1.803,
    "y-222": -1.803,
    "y-223": -1.803,
    "y-224": -1.803,
    "y-225": -1.803,
    "y-226": -1.803,
    "y-227": -1.803,
    "y-228": -1.803,
    "y-229": -1.803,
    "y-230": -1.803,
    "y-231": -1.803,
    "y-232": -1.803,
    "y-233": -1.803,
    "y-234": -1.803,
    "y-235": -1.803,
    "y-236": -1.803,
    "y-237": -1.803,
    "y-238": -1.803,
    "y-239": -1.802,
    "y-240": -1.802,
    "y-241": -1.802,
    "y-242": -1.802,
    "y-243": -1.802,
    "y-244": -1.801,
    "y-245": -1.803,
    "y-246": -1.805,
    "y-247": -1.805,
    "y-248": -1.805,
    "y-249": -1.805,
    "y-250": -1.805,
    "y-251": -1.805,
    "y-252": -1.805,
    "y-253": -1.805,
    "y-254": -1.805,
    "y-255": -1.806,
  },
  {
    x: 1.275,
    "y-2": -2.05,
    "y-12": -1.898,
    "y-46": -1.762,
    "y-1000": -1.754,
    "y-0": -0.519,
    "y-1": -1.415,
    "y-3": -1.832,
    "y-4": -1.871,
    "y-5": -1.887,
    "y-6": -1.887,
    "y-7": -1.888,
    "y-8": -1.89,
    "y-9": -1.89,
    "y-10": -1.964,
    "y-11": -1.963,
    "y-13": -1.898,
    "y-14": -1.898,
    "y-15": -1.926,
    "y-16": -1.926,
    "y-17": -2.046,
    "y-18": -1.985,
    "y-19": -1.985,
    "y-20": -1.985,
    "y-21": -1.985,
    "y-22": -1.985,
    "y-23": -1.975,
    "y-24": -1.992,
    "y-25": -1.992,
    "y-26": -1.992,
    "y-27": -1.992,
    "y-28": -1.717,
    "y-29": -1.717,
    "y-30": -1.714,
    "y-31": -1.764,
    "y-32": -1.764,
    "y-33": -1.764,
    "y-34": -1.764,
    "y-35": -1.764,
    "y-36": -1.764,
    "y-37": -1.764,
    "y-38": -1.764,
    "y-39": -1.764,
    "y-40": -1.765,
    "y-41": -1.762,
    "y-42": -1.763,
    "y-43": -1.762,
    "y-44": -1.762,
    "y-45": -1.763,
    "y-47": -1.762,
    "y-48": -1.752,
    "y-49": -1.757,
    "y-50": -1.758,
    "y-51": -1.751,
    "y-52": -1.757,
    "y-53": -1.766,
    "y-54": -1.756,
    "y-55": -1.754,
    "y-56": -1.76,
    "y-57": -1.763,
    "y-58": -1.755,
    "y-59": -1.76,
    "y-60": -1.755,
    "y-61": -1.759,
    "y-62": -1.756,
    "y-63": -1.758,
    "y-64": -1.76,
    "y-65": -1.757,
    "y-66": -1.759,
    "y-67": -1.756,
    "y-68": -1.757,
    "y-69": -1.756,
    "y-70": -1.757,
    "y-71": -1.76,
    "y-72": -1.757,
    "y-73": -1.759,
    "y-74": -1.759,
    "y-75": -1.759,
    "y-76": -1.759,
    "y-77": -1.759,
    "y-78": -1.757,
    "y-79": -1.756,
    "y-80": -1.758,
    "y-81": -1.757,
    "y-82": -1.759,
    "y-83": -1.757,
    "y-84": -1.756,
    "y-85": -1.758,
    "y-86": -1.757,
    "y-87": -1.756,
    "y-88": -1.758,
    "y-89": -1.755,
    "y-90": -1.759,
    "y-91": -1.756,
    "y-92": -1.757,
    "y-93": -1.756,
    "y-94": -1.754,
    "y-95": -1.754,
    "y-96": -1.757,
    "y-97": -1.754,
    "y-98": -1.756,
    "y-99": -1.757,
    "y-100": -1.757,
    "y-101": -1.756,
    "y-102": -1.758,
    "y-103": -1.757,
    "y-104": -1.758,
    "y-105": -1.757,
    "y-106": -1.754,
    "y-107": -1.756,
    "y-108": -1.756,
    "y-109": -1.755,
    "y-110": -1.756,
    "y-111": -1.755,
    "y-112": -1.77,
    "y-113": -1.77,
    "y-114": -1.767,
    "y-115": -1.766,
    "y-116": -1.766,
    "y-117": -1.767,
    "y-118": -1.767,
    "y-119": -1.767,
    "y-120": -1.768,
    "y-121": -1.767,
    "y-122": -1.768,
    "y-123": -1.766,
    "y-124": -1.767,
    "y-125": -1.767,
    "y-126": -1.767,
    "y-127": -1.767,
    "y-128": -1.767,
    "y-129": -1.767,
    "y-130": -1.767,
    "y-131": -1.768,
    "y-132": -1.768,
    "y-133": -1.768,
    "y-134": -1.768,
    "y-135": -1.768,
    "y-136": -1.768,
    "y-137": -1.768,
    "y-138": -1.768,
    "y-139": -1.768,
    "y-140": -1.768,
    "y-141": -1.768,
    "y-142": -1.768,
    "y-143": -1.768,
    "y-144": -1.767,
    "y-145": -1.767,
    "y-146": -1.767,
    "y-147": -1.767,
    "y-148": -1.767,
    "y-149": -1.767,
    "y-150": -1.767,
    "y-151": -1.764,
    "y-152": -1.762,
    "y-153": -1.762,
    "y-154": -1.762,
    "y-155": -1.762,
    "y-156": -1.762,
    "y-157": -1.762,
    "y-158": -1.762,
    "y-159": -1.762,
    "y-160": -1.762,
    "y-161": -1.762,
    "y-162": -1.762,
    "y-163": -1.762,
    "y-164": -1.761,
    "y-165": -1.761,
    "y-166": -1.761,
    "y-167": -1.761,
    "y-168": -1.761,
    "y-169": -1.761,
    "y-170": -1.761,
    "y-171": -1.761,
    "y-172": -1.761,
    "y-173": -1.761,
    "y-174": -1.762,
    "y-175": -1.762,
    "y-176": -1.762,
    "y-177": -1.76,
    "y-178": -1.76,
    "y-179": -1.76,
    "y-180": -1.76,
    "y-181": -1.76,
    "y-182": -1.76,
    "y-183": -1.759,
    "y-184": -1.759,
    "y-185": -1.759,
    "y-186": -1.759,
    "y-187": -1.759,
    "y-188": -1.76,
    "y-189": -1.76,
    "y-190": -1.76,
    "y-191": -1.76,
    "y-192": -1.76,
    "y-193": -1.76,
    "y-194": -1.76,
    "y-195": -1.76,
    "y-196": -1.76,
    "y-197": -1.76,
    "y-198": -1.76,
    "y-199": -1.76,
    "y-200": -1.76,
    "y-201": -1.76,
    "y-202": -1.76,
    "y-203": -1.76,
    "y-204": -1.76,
    "y-205": -1.76,
    "y-206": -1.76,
    "y-207": -1.76,
    "y-208": -1.76,
    "y-209": -1.76,
    "y-210": -1.76,
    "y-211": -1.76,
    "y-212": -1.76,
    "y-213": -1.76,
    "y-214": -1.76,
    "y-215": -1.76,
    "y-216": -1.76,
    "y-217": -1.76,
    "y-218": -1.76,
    "y-219": -1.76,
    "y-220": -1.76,
    "y-221": -1.76,
    "y-222": -1.76,
    "y-223": -1.76,
    "y-224": -1.76,
    "y-225": -1.76,
    "y-226": -1.76,
    "y-227": -1.76,
    "y-228": -1.763,
    "y-229": -1.763,
    "y-230": -1.763,
    "y-231": -1.763,
    "y-232": -1.763,
    "y-233": -1.763,
    "y-234": -1.763,
    "y-235": -1.763,
    "y-236": -1.763,
    "y-237": -1.763,
    "y-238": -1.763,
    "y-239": -1.762,
    "y-240": -1.762,
    "y-241": -1.762,
    "y-242": -1.762,
    "y-243": -1.762,
    "y-244": -1.762,
    "y-245": -1.762,
    "y-246": -1.764,
    "y-247": -1.764,
    "y-248": -1.764,
    "y-249": -1.764,
    "y-250": -1.764,
    "y-251": -1.764,
    "y-252": -1.764,
    "y-253": -1.764,
    "y-254": -1.764,
    "y-255": -1.764,
  },
  {
    x: 1.3,
    "y-2": -1.918,
    "y-12": -1.782,
    "y-46": -1.703,
    "y-1000": -1.703,
    "y-0": -0.531,
    "y-1": -1.315,
    "y-3": -1.711,
    "y-4": -1.748,
    "y-5": -1.763,
    "y-6": -1.764,
    "y-7": -1.764,
    "y-8": -1.766,
    "y-9": -1.766,
    "y-10": -1.837,
    "y-11": -1.835,
    "y-13": -1.782,
    "y-14": -1.782,
    "y-15": -1.808,
    "y-16": -1.808,
    "y-17": -1.893,
    "y-18": -1.838,
    "y-19": -1.838,
    "y-20": -1.838,
    "y-21": -1.838,
    "y-22": -1.838,
    "y-23": -1.941,
    "y-24": -1.961,
    "y-25": -1.961,
    "y-26": -1.961,
    "y-27": -1.961,
    "y-28": -1.671,
    "y-29": -1.671,
    "y-30": -1.67,
    "y-31": -1.703,
    "y-32": -1.703,
    "y-33": -1.703,
    "y-34": -1.703,
    "y-35": -1.703,
    "y-36": -1.703,
    "y-37": -1.703,
    "y-38": -1.703,
    "y-39": -1.703,
    "y-40": -1.703,
    "y-41": -1.703,
    "y-42": -1.703,
    "y-43": -1.703,
    "y-44": -1.703,
    "y-45": -1.703,
    "y-47": -1.703,
    "y-48": -1.703,
    "y-49": -1.703,
    "y-50": -1.703,
    "y-51": -1.703,
    "y-52": -1.703,
    "y-53": -1.703,
    "y-54": -1.703,
    "y-55": -1.703,
    "y-56": -1.703,
    "y-57": -1.703,
    "y-58": -1.703,
    "y-59": -1.703,
    "y-60": -1.703,
    "y-61": -1.703,
    "y-62": -1.703,
    "y-63": -1.703,
    "y-64": -1.703,
    "y-65": -1.703,
    "y-66": -1.703,
    "y-67": -1.703,
    "y-68": -1.703,
    "y-69": -1.703,
    "y-70": -1.703,
    "y-71": -1.703,
    "y-72": -1.703,
    "y-73": -1.703,
    "y-74": -1.703,
    "y-75": -1.703,
    "y-76": -1.703,
    "y-77": -1.703,
    "y-78": -1.703,
    "y-79": -1.703,
    "y-80": -1.703,
    "y-81": -1.703,
    "y-82": -1.703,
    "y-83": -1.703,
    "y-84": -1.703,
    "y-85": -1.703,
    "y-86": -1.703,
    "y-87": -1.703,
    "y-88": -1.703,
    "y-89": -1.703,
    "y-90": -1.703,
    "y-91": -1.703,
    "y-92": -1.703,
    "y-93": -1.703,
    "y-94": -1.703,
    "y-95": -1.703,
    "y-96": -1.703,
    "y-97": -1.703,
    "y-98": -1.703,
    "y-99": -1.703,
    "y-100": -1.703,
    "y-101": -1.703,
    "y-102": -1.703,
    "y-103": -1.703,
    "y-104": -1.703,
    "y-105": -1.703,
    "y-106": -1.703,
    "y-107": -1.703,
    "y-108": -1.703,
    "y-109": -1.703,
    "y-110": -1.703,
    "y-111": -1.703,
    "y-112": -1.703,
    "y-113": -1.703,
    "y-114": -1.703,
    "y-115": -1.703,
    "y-116": -1.703,
    "y-117": -1.703,
    "y-118": -1.703,
    "y-119": -1.703,
    "y-120": -1.703,
    "y-121": -1.703,
    "y-122": -1.703,
    "y-123": -1.703,
    "y-124": -1.703,
    "y-125": -1.703,
    "y-126": -1.703,
    "y-127": -1.703,
    "y-128": -1.703,
    "y-129": -1.703,
    "y-130": -1.703,
    "y-131": -1.703,
    "y-132": -1.703,
    "y-133": -1.703,
    "y-134": -1.703,
    "y-135": -1.703,
    "y-136": -1.703,
    "y-137": -1.703,
    "y-138": -1.703,
    "y-139": -1.703,
    "y-140": -1.703,
    "y-141": -1.703,
    "y-142": -1.703,
    "y-143": -1.703,
    "y-144": -1.703,
    "y-145": -1.703,
    "y-146": -1.703,
    "y-147": -1.703,
    "y-148": -1.703,
    "y-149": -1.703,
    "y-150": -1.703,
    "y-151": -1.703,
    "y-152": -1.703,
    "y-153": -1.703,
    "y-154": -1.703,
    "y-155": -1.703,
    "y-156": -1.703,
    "y-157": -1.703,
    "y-158": -1.703,
    "y-159": -1.703,
    "y-160": -1.703,
    "y-161": -1.703,
    "y-162": -1.703,
    "y-163": -1.703,
    "y-164": -1.703,
    "y-165": -1.703,
    "y-166": -1.703,
    "y-167": -1.703,
    "y-168": -1.703,
    "y-169": -1.703,
    "y-170": -1.703,
    "y-171": -1.703,
    "y-172": -1.703,
    "y-173": -1.703,
    "y-174": -1.703,
    "y-175": -1.703,
    "y-176": -1.703,
    "y-177": -1.703,
    "y-178": -1.703,
    "y-179": -1.703,
    "y-180": -1.703,
    "y-181": -1.703,
    "y-182": -1.703,
    "y-183": -1.703,
    "y-184": -1.703,
    "y-185": -1.703,
    "y-186": -1.703,
    "y-187": -1.703,
    "y-188": -1.703,
    "y-189": -1.703,
    "y-190": -1.703,
    "y-191": -1.703,
    "y-192": -1.703,
    "y-193": -1.703,
    "y-194": -1.703,
    "y-195": -1.703,
    "y-196": -1.703,
    "y-197": -1.703,
    "y-198": -1.703,
    "y-199": -1.703,
    "y-200": -1.703,
    "y-201": -1.703,
    "y-202": -1.703,
    "y-203": -1.703,
    "y-204": -1.703,
    "y-205": -1.703,
    "y-206": -1.703,
    "y-207": -1.703,
    "y-208": -1.703,
    "y-209": -1.703,
    "y-210": -1.703,
    "y-211": -1.703,
    "y-212": -1.703,
    "y-213": -1.703,
    "y-214": -1.703,
    "y-215": -1.703,
    "y-216": -1.703,
    "y-217": -1.703,
    "y-218": -1.703,
    "y-219": -1.703,
    "y-220": -1.703,
    "y-221": -1.703,
    "y-222": -1.703,
    "y-223": -1.703,
    "y-224": -1.703,
    "y-225": -1.703,
    "y-226": -1.703,
    "y-227": -1.703,
    "y-228": -1.703,
    "y-229": -1.703,
    "y-230": -1.703,
    "y-231": -1.703,
    "y-232": -1.703,
    "y-233": -1.703,
    "y-234": -1.703,
    "y-235": -1.703,
    "y-236": -1.703,
    "y-237": -1.703,
    "y-238": -1.703,
    "y-239": -1.703,
    "y-240": -1.703,
    "y-241": -1.703,
    "y-242": -1.703,
    "y-243": -1.703,
    "y-244": -1.703,
    "y-245": -1.703,
    "y-246": -1.703,
    "y-247": -1.703,
    "y-248": -1.703,
    "y-249": -1.703,
    "y-250": -1.703,
    "y-251": -1.703,
    "y-252": -1.703,
    "y-253": -1.703,
    "y-254": -1.703,
    "y-255": -1.703,
  },
  {
    x: 1.325,
    "y-2": -1.787,
    "y-12": -1.666,
    "y-46": -1.641,
    "y-1000": -1.633,
    "y-0": -0.543,
    "y-1": -1.214,
    "y-3": -1.59,
    "y-4": -1.625,
    "y-5": -1.64,
    "y-6": -1.64,
    "y-7": -1.641,
    "y-8": -1.643,
    "y-9": -1.643,
    "y-10": -1.709,
    "y-11": -1.708,
    "y-13": -1.666,
    "y-14": -1.666,
    "y-15": -1.69,
    "y-16": -1.69,
    "y-17": -1.739,
    "y-18": -1.691,
    "y-19": -1.691,
    "y-20": -1.691,
    "y-21": -1.691,
    "y-22": -1.691,
    "y-23": -1.782,
    "y-24": -1.797,
    "y-25": -1.797,
    "y-26": -1.797,
    "y-27": -1.797,
    "y-28": -1.667,
    "y-29": -1.667,
    "y-30": -1.669,
    "y-31": -1.641,
    "y-32": -1.641,
    "y-33": -1.641,
    "y-34": -1.641,
    "y-35": -1.641,
    "y-36": -1.641,
    "y-37": -1.641,
    "y-38": -1.641,
    "y-39": -1.641,
    "y-40": -1.641,
    "y-41": -1.641,
    "y-42": -1.641,
    "y-43": -1.641,
    "y-44": -1.641,
    "y-45": -1.641,
    "y-47": -1.641,
    "y-48": -1.641,
    "y-49": -1.641,
    "y-50": -1.641,
    "y-51": -1.641,
    "y-52": -1.641,
    "y-53": -1.641,
    "y-54": -1.641,
    "y-55": -1.641,
    "y-56": -1.641,
    "y-57": -1.641,
    "y-58": -1.641,
    "y-59": -1.641,
    "y-60": -1.641,
    "y-61": -1.641,
    "y-62": -1.641,
    "y-63": -1.641,
    "y-64": -1.641,
    "y-65": -1.641,
    "y-66": -1.641,
    "y-67": -1.641,
    "y-68": -1.641,
    "y-69": -1.641,
    "y-70": -1.641,
    "y-71": -1.641,
    "y-72": -1.641,
    "y-73": -1.641,
    "y-74": -1.641,
    "y-75": -1.641,
    "y-76": -1.641,
    "y-77": -1.641,
    "y-78": -1.641,
    "y-79": -1.641,
    "y-80": -1.641,
    "y-81": -1.641,
    "y-82": -1.641,
    "y-83": -1.641,
    "y-84": -1.641,
    "y-85": -1.641,
    "y-86": -1.641,
    "y-87": -1.641,
    "y-88": -1.641,
    "y-89": -1.641,
    "y-90": -1.641,
    "y-91": -1.641,
    "y-92": -1.641,
    "y-93": -1.641,
    "y-94": -1.641,
    "y-95": -1.641,
    "y-96": -1.641,
    "y-97": -1.641,
    "y-98": -1.641,
    "y-99": -1.641,
    "y-100": -1.641,
    "y-101": -1.641,
    "y-102": -1.641,
    "y-103": -1.641,
    "y-104": -1.641,
    "y-105": -1.641,
    "y-106": -1.641,
    "y-107": -1.641,
    "y-108": -1.641,
    "y-109": -1.641,
    "y-110": -1.641,
    "y-111": -1.641,
    "y-112": -1.62,
    "y-113": -1.62,
    "y-114": -1.624,
    "y-115": -1.624,
    "y-116": -1.624,
    "y-117": -1.624,
    "y-118": -1.624,
    "y-119": -1.624,
    "y-120": -1.624,
    "y-121": -1.624,
    "y-122": -1.624,
    "y-123": -1.624,
    "y-124": -1.624,
    "y-125": -1.624,
    "y-126": -1.624,
    "y-127": -1.624,
    "y-128": -1.624,
    "y-129": -1.624,
    "y-130": -1.624,
    "y-131": -1.624,
    "y-132": -1.624,
    "y-133": -1.624,
    "y-134": -1.624,
    "y-135": -1.624,
    "y-136": -1.624,
    "y-137": -1.624,
    "y-138": -1.624,
    "y-139": -1.624,
    "y-140": -1.624,
    "y-141": -1.624,
    "y-142": -1.624,
    "y-143": -1.624,
    "y-144": -1.625,
    "y-145": -1.625,
    "y-146": -1.625,
    "y-147": -1.625,
    "y-148": -1.625,
    "y-149": -1.625,
    "y-150": -1.626,
    "y-151": -1.63,
    "y-152": -1.633,
    "y-153": -1.633,
    "y-154": -1.633,
    "y-155": -1.633,
    "y-156": -1.633,
    "y-157": -1.633,
    "y-158": -1.633,
    "y-159": -1.633,
    "y-160": -1.633,
    "y-161": -1.633,
    "y-162": -1.633,
    "y-163": -1.633,
    "y-164": -1.634,
    "y-165": -1.634,
    "y-166": -1.634,
    "y-167": -1.634,
    "y-168": -1.634,
    "y-169": -1.634,
    "y-170": -1.634,
    "y-171": -1.634,
    "y-172": -1.634,
    "y-173": -1.634,
    "y-174": -1.633,
    "y-175": -1.633,
    "y-176": -1.633,
    "y-177": -1.636,
    "y-178": -1.636,
    "y-179": -1.636,
    "y-180": -1.636,
    "y-181": -1.636,
    "y-182": -1.636,
    "y-183": -1.637,
    "y-184": -1.637,
    "y-185": -1.637,
    "y-186": -1.637,
    "y-187": -1.637,
    "y-188": -1.637,
    "y-189": -1.637,
    "y-190": -1.637,
    "y-191": -1.637,
    "y-192": -1.637,
    "y-193": -1.637,
    "y-194": -1.637,
    "y-195": -1.637,
    "y-196": -1.637,
    "y-197": -1.637,
    "y-198": -1.637,
    "y-199": -1.637,
    "y-200": -1.637,
    "y-201": -1.637,
    "y-202": -1.637,
    "y-203": -1.637,
    "y-204": -1.637,
    "y-205": -1.636,
    "y-206": -1.636,
    "y-207": -1.636,
    "y-208": -1.636,
    "y-209": -1.636,
    "y-210": -1.636,
    "y-211": -1.636,
    "y-212": -1.636,
    "y-213": -1.636,
    "y-214": -1.636,
    "y-215": -1.636,
    "y-216": -1.636,
    "y-217": -1.636,
    "y-218": -1.636,
    "y-219": -1.636,
    "y-220": -1.636,
    "y-221": -1.636,
    "y-222": -1.636,
    "y-223": -1.636,
    "y-224": -1.636,
    "y-225": -1.636,
    "y-226": -1.636,
    "y-227": -1.636,
    "y-228": -1.636,
    "y-229": -1.636,
    "y-230": -1.636,
    "y-231": -1.636,
    "y-232": -1.636,
    "y-233": -1.636,
    "y-234": -1.636,
    "y-235": -1.636,
    "y-236": -1.636,
    "y-237": -1.636,
    "y-238": -1.636,
    "y-239": -1.636,
    "y-240": -1.636,
    "y-241": -1.636,
    "y-242": -1.636,
    "y-243": -1.636,
    "y-244": -1.637,
    "y-245": -1.637,
    "y-246": -1.634,
    "y-247": -1.634,
    "y-248": -1.634,
    "y-249": -1.634,
    "y-250": -1.634,
    "y-251": -1.634,
    "y-252": -1.634,
    "y-253": -1.634,
    "y-254": -1.634,
    "y-255": -1.634,
  },
  {
    x: 1.35,
    "y-2": -1.655,
    "y-12": -1.55,
    "y-46": -1.58,
    "y-1000": -1.558,
    "y-0": -0.555,
    "y-1": -1.114,
    "y-3": -1.47,
    "y-4": -1.503,
    "y-5": -1.516,
    "y-6": -1.517,
    "y-7": -1.517,
    "y-8": -1.519,
    "y-9": -1.519,
    "y-10": -1.582,
    "y-11": -1.581,
    "y-13": -1.55,
    "y-14": -1.55,
    "y-15": -1.571,
    "y-16": -1.571,
    "y-17": -1.586,
    "y-18": -1.543,
    "y-19": -1.543,
    "y-20": -1.543,
    "y-21": -1.543,
    "y-22": -1.543,
    "y-23": -1.623,
    "y-24": -1.632,
    "y-25": -1.632,
    "y-26": -1.632,
    "y-27": -1.632,
    "y-28": -1.663,
    "y-29": -1.663,
    "y-30": -1.668,
    "y-31": -1.58,
    "y-32": -1.58,
    "y-33": -1.58,
    "y-34": -1.58,
    "y-35": -1.58,
    "y-36": -1.58,
    "y-37": -1.58,
    "y-38": -1.58,
    "y-39": -1.58,
    "y-40": -1.58,
    "y-41": -1.58,
    "y-42": -1.58,
    "y-43": -1.58,
    "y-44": -1.58,
    "y-45": -1.58,
    "y-47": -1.58,
    "y-48": -1.58,
    "y-49": -1.58,
    "y-50": -1.58,
    "y-51": -1.58,
    "y-52": -1.58,
    "y-53": -1.58,
    "y-54": -1.58,
    "y-55": -1.58,
    "y-56": -1.58,
    "y-57": -1.58,
    "y-58": -1.58,
    "y-59": -1.58,
    "y-60": -1.58,
    "y-61": -1.58,
    "y-62": -1.58,
    "y-63": -1.58,
    "y-64": -1.58,
    "y-65": -1.58,
    "y-66": -1.58,
    "y-67": -1.58,
    "y-68": -1.58,
    "y-69": -1.58,
    "y-70": -1.58,
    "y-71": -1.58,
    "y-72": -1.58,
    "y-73": -1.58,
    "y-74": -1.58,
    "y-75": -1.58,
    "y-76": -1.58,
    "y-77": -1.58,
    "y-78": -1.58,
    "y-79": -1.58,
    "y-80": -1.58,
    "y-81": -1.579,
    "y-82": -1.58,
    "y-83": -1.58,
    "y-84": -1.58,
    "y-85": -1.58,
    "y-86": -1.58,
    "y-87": -1.58,
    "y-88": -1.58,
    "y-89": -1.58,
    "y-90": -1.58,
    "y-91": -1.58,
    "y-92": -1.579,
    "y-93": -1.58,
    "y-94": -1.58,
    "y-95": -1.58,
    "y-96": -1.58,
    "y-97": -1.579,
    "y-98": -1.58,
    "y-99": -1.58,
    "y-100": -1.58,
    "y-101": -1.58,
    "y-102": -1.579,
    "y-103": -1.58,
    "y-104": -1.58,
    "y-105": -1.58,
    "y-106": -1.579,
    "y-107": -1.58,
    "y-108": -1.58,
    "y-109": -1.58,
    "y-110": -1.58,
    "y-111": -1.58,
    "y-112": -1.538,
    "y-113": -1.538,
    "y-114": -1.546,
    "y-115": -1.546,
    "y-116": -1.546,
    "y-117": -1.545,
    "y-118": -1.546,
    "y-119": -1.546,
    "y-120": -1.545,
    "y-121": -1.545,
    "y-122": -1.545,
    "y-123": -1.545,
    "y-124": -1.545,
    "y-125": -1.545,
    "y-126": -1.545,
    "y-127": -1.545,
    "y-128": -1.545,
    "y-129": -1.545,
    "y-130": -1.545,
    "y-131": -1.545,
    "y-132": -1.545,
    "y-133": -1.545,
    "y-134": -1.545,
    "y-135": -1.545,
    "y-136": -1.545,
    "y-137": -1.545,
    "y-138": -1.545,
    "y-139": -1.545,
    "y-140": -1.545,
    "y-141": -1.545,
    "y-142": -1.545,
    "y-143": -1.545,
    "y-144": -1.548,
    "y-145": -1.548,
    "y-146": -1.548,
    "y-147": -1.548,
    "y-148": -1.548,
    "y-149": -1.548,
    "y-150": -1.548,
    "y-151": -1.557,
    "y-152": -1.563,
    "y-153": -1.563,
    "y-154": -1.563,
    "y-155": -1.563,
    "y-156": -1.563,
    "y-157": -1.563,
    "y-158": -1.563,
    "y-159": -1.563,
    "y-160": -1.563,
    "y-161": -1.564,
    "y-162": -1.564,
    "y-163": -1.564,
    "y-164": -1.564,
    "y-165": -1.564,
    "y-166": -1.564,
    "y-167": -1.564,
    "y-168": -1.564,
    "y-169": -1.564,
    "y-170": -1.564,
    "y-171": -1.564,
    "y-172": -1.564,
    "y-173": -1.564,
    "y-174": -1.564,
    "y-175": -1.564,
    "y-176": -1.564,
    "y-177": -1.569,
    "y-178": -1.569,
    "y-179": -1.569,
    "y-180": -1.569,
    "y-181": -1.569,
    "y-182": -1.569,
    "y-183": -1.571,
    "y-184": -1.571,
    "y-185": -1.571,
    "y-186": -1.571,
    "y-187": -1.571,
    "y-188": -1.571,
    "y-189": -1.571,
    "y-190": -1.571,
    "y-191": -1.571,
    "y-192": -1.571,
    "y-193": -1.571,
    "y-194": -1.571,
    "y-195": -1.571,
    "y-196": -1.571,
    "y-197": -1.571,
    "y-198": -1.571,
    "y-199": -1.571,
    "y-200": -1.571,
    "y-201": -1.571,
    "y-202": -1.571,
    "y-203": -1.571,
    "y-204": -1.571,
    "y-205": -1.569,
    "y-206": -1.569,
    "y-207": -1.569,
    "y-208": -1.569,
    "y-209": -1.569,
    "y-210": -1.569,
    "y-211": -1.569,
    "y-212": -1.569,
    "y-213": -1.569,
    "y-214": -1.569,
    "y-215": -1.569,
    "y-216": -1.569,
    "y-217": -1.569,
    "y-218": -1.569,
    "y-219": -1.569,
    "y-220": -1.569,
    "y-221": -1.569,
    "y-222": -1.569,
    "y-223": -1.569,
    "y-224": -1.569,
    "y-225": -1.569,
    "y-226": -1.569,
    "y-227": -1.569,
    "y-228": -1.569,
    "y-229": -1.569,
    "y-230": -1.569,
    "y-231": -1.569,
    "y-232": -1.569,
    "y-233": -1.569,
    "y-234": -1.569,
    "y-235": -1.569,
    "y-236": -1.569,
    "y-237": -1.569,
    "y-238": -1.569,
    "y-239": -1.569,
    "y-240": -1.569,
    "y-241": -1.569,
    "y-242": -1.569,
    "y-243": -1.569,
    "y-244": -1.57,
    "y-245": -1.57,
    "y-246": -1.565,
    "y-247": -1.565,
    "y-248": -1.565,
    "y-249": -1.565,
    "y-250": -1.565,
    "y-251": -1.565,
    "y-252": -1.565,
    "y-253": -1.565,
    "y-254": -1.565,
    "y-255": -1.565,
  },
  {
    x: 1.375,
    "y-2": -1.524,
    "y-12": -1.434,
    "y-46": -1.518,
    "y-1000": -1.485,
    "y-0": -0.568,
    "y-1": -1.014,
    "y-3": -1.349,
    "y-4": -1.38,
    "y-5": -1.393,
    "y-6": -1.393,
    "y-7": -1.394,
    "y-8": -1.395,
    "y-9": -1.395,
    "y-10": -1.455,
    "y-11": -1.454,
    "y-13": -1.434,
    "y-14": -1.434,
    "y-15": -1.453,
    "y-16": -1.453,
    "y-17": -1.432,
    "y-18": -1.396,
    "y-19": -1.396,
    "y-20": -1.396,
    "y-21": -1.396,
    "y-22": -1.396,
    "y-23": -1.464,
    "y-24": -1.468,
    "y-25": -1.468,
    "y-26": -1.468,
    "y-27": -1.468,
    "y-28": -1.659,
    "y-29": -1.659,
    "y-30": -1.667,
    "y-31": -1.518,
    "y-32": -1.518,
    "y-33": -1.518,
    "y-34": -1.518,
    "y-35": -1.518,
    "y-36": -1.518,
    "y-37": -1.518,
    "y-38": -1.518,
    "y-39": -1.518,
    "y-40": -1.518,
    "y-41": -1.518,
    "y-42": -1.518,
    "y-43": -1.518,
    "y-44": -1.518,
    "y-45": -1.518,
    "y-47": -1.518,
    "y-48": -1.518,
    "y-49": -1.518,
    "y-50": -1.518,
    "y-51": -1.518,
    "y-52": -1.518,
    "y-53": -1.518,
    "y-54": -1.518,
    "y-55": -1.518,
    "y-56": -1.518,
    "y-57": -1.518,
    "y-58": -1.518,
    "y-59": -1.518,
    "y-60": -1.518,
    "y-61": -1.518,
    "y-62": -1.518,
    "y-63": -1.518,
    "y-64": -1.518,
    "y-65": -1.518,
    "y-66": -1.518,
    "y-67": -1.518,
    "y-68": -1.518,
    "y-69": -1.518,
    "y-70": -1.518,
    "y-71": -1.518,
    "y-72": -1.518,
    "y-73": -1.518,
    "y-74": -1.518,
    "y-75": -1.518,
    "y-76": -1.518,
    "y-77": -1.518,
    "y-78": -1.518,
    "y-79": -1.518,
    "y-80": -1.518,
    "y-81": -1.518,
    "y-82": -1.518,
    "y-83": -1.518,
    "y-84": -1.518,
    "y-85": -1.518,
    "y-86": -1.518,
    "y-87": -1.518,
    "y-88": -1.518,
    "y-89": -1.518,
    "y-90": -1.518,
    "y-91": -1.518,
    "y-92": -1.518,
    "y-93": -1.518,
    "y-94": -1.518,
    "y-95": -1.518,
    "y-96": -1.518,
    "y-97": -1.518,
    "y-98": -1.518,
    "y-99": -1.518,
    "y-100": -1.518,
    "y-101": -1.518,
    "y-102": -1.518,
    "y-103": -1.518,
    "y-104": -1.518,
    "y-105": -1.518,
    "y-106": -1.518,
    "y-107": -1.518,
    "y-108": -1.518,
    "y-109": -1.518,
    "y-110": -1.518,
    "y-111": -1.518,
    "y-112": -1.455,
    "y-113": -1.455,
    "y-114": -1.467,
    "y-115": -1.467,
    "y-116": -1.467,
    "y-117": -1.467,
    "y-118": -1.467,
    "y-119": -1.467,
    "y-120": -1.466,
    "y-121": -1.466,
    "y-122": -1.466,
    "y-123": -1.466,
    "y-124": -1.466,
    "y-125": -1.467,
    "y-126": -1.467,
    "y-127": -1.467,
    "y-128": -1.467,
    "y-129": -1.467,
    "y-130": -1.467,
    "y-131": -1.466,
    "y-132": -1.466,
    "y-133": -1.466,
    "y-134": -1.466,
    "y-135": -1.466,
    "y-136": -1.466,
    "y-137": -1.466,
    "y-138": -1.466,
    "y-139": -1.466,
    "y-140": -1.466,
    "y-141": -1.466,
    "y-142": -1.466,
    "y-143": -1.466,
    "y-144": -1.47,
    "y-145": -1.47,
    "y-146": -1.47,
    "y-147": -1.47,
    "y-148": -1.47,
    "y-149": -1.47,
    "y-150": -1.471,
    "y-151": -1.484,
    "y-152": -1.494,
    "y-153": -1.494,
    "y-154": -1.494,
    "y-155": -1.494,
    "y-156": -1.494,
    "y-157": -1.494,
    "y-158": -1.494,
    "y-159": -1.494,
    "y-160": -1.494,
    "y-161": -1.494,
    "y-162": -1.494,
    "y-163": -1.494,
    "y-164": -1.495,
    "y-165": -1.495,
    "y-166": -1.495,
    "y-167": -1.495,
    "y-168": -1.495,
    "y-169": -1.495,
    "y-170": -1.495,
    "y-171": -1.495,
    "y-172": -1.495,
    "y-173": -1.495,
    "y-174": -1.494,
    "y-175": -1.494,
    "y-176": -1.494,
    "y-177": -1.502,
    "y-178": -1.502,
    "y-179": -1.502,
    "y-180": -1.502,
    "y-181": -1.502,
    "y-182": -1.502,
    "y-183": -1.504,
    "y-184": -1.504,
    "y-185": -1.504,
    "y-186": -1.504,
    "y-187": -1.504,
    "y-188": -1.504,
    "y-189": -1.504,
    "y-190": -1.504,
    "y-191": -1.504,
    "y-192": -1.504,
    "y-193": -1.504,
    "y-194": -1.504,
    "y-195": -1.504,
    "y-196": -1.504,
    "y-197": -1.504,
    "y-198": -1.504,
    "y-199": -1.504,
    "y-200": -1.504,
    "y-201": -1.504,
    "y-202": -1.504,
    "y-203": -1.504,
    "y-204": -1.504,
    "y-205": -1.502,
    "y-206": -1.502,
    "y-207": -1.502,
    "y-208": -1.502,
    "y-209": -1.502,
    "y-210": -1.502,
    "y-211": -1.502,
    "y-212": -1.502,
    "y-213": -1.502,
    "y-214": -1.502,
    "y-215": -1.502,
    "y-216": -1.502,
    "y-217": -1.502,
    "y-218": -1.502,
    "y-219": -1.502,
    "y-220": -1.502,
    "y-221": -1.502,
    "y-222": -1.502,
    "y-223": -1.502,
    "y-224": -1.502,
    "y-225": -1.502,
    "y-226": -1.502,
    "y-227": -1.502,
    "y-228": -1.501,
    "y-229": -1.501,
    "y-230": -1.501,
    "y-231": -1.501,
    "y-232": -1.501,
    "y-233": -1.501,
    "y-234": -1.501,
    "y-235": -1.501,
    "y-236": -1.501,
    "y-237": -1.501,
    "y-238": -1.501,
    "y-239": -1.502,
    "y-240": -1.502,
    "y-241": -1.502,
    "y-242": -1.502,
    "y-243": -1.502,
    "y-244": -1.504,
    "y-245": -1.504,
    "y-246": -1.495,
    "y-247": -1.495,
    "y-248": -1.495,
    "y-249": -1.495,
    "y-250": -1.495,
    "y-251": -1.495,
    "y-252": -1.495,
    "y-253": -1.495,
    "y-254": -1.495,
    "y-255": -1.495,
  },
  {
    x: 1.4,
    "y-2": -1.392,
    "y-12": -1.318,
    "y-46": -1.456,
    "y-1000": -1.456,
    "y-0": -0.58,
    "y-1": -0.914,
    "y-3": -1.228,
    "y-4": -1.257,
    "y-5": -1.269,
    "y-6": -1.27,
    "y-7": -1.27,
    "y-8": -1.272,
    "y-9": -1.272,
    "y-10": -1.328,
    "y-11": -1.327,
    "y-13": -1.318,
    "y-14": -1.318,
    "y-15": -1.334,
    "y-16": -1.334,
    "y-17": -1.278,
    "y-18": -1.249,
    "y-19": -1.249,
    "y-20": -1.249,
    "y-21": -1.249,
    "y-22": -1.249,
    "y-23": -1.305,
    "y-24": -1.304,
    "y-25": -1.304,
    "y-26": -1.304,
    "y-27": -1.304,
    "y-28": -1.655,
    "y-29": -1.655,
    "y-30": -1.665,
    "y-31": -1.456,
    "y-32": -1.456,
    "y-33": -1.456,
    "y-34": -1.456,
    "y-35": -1.456,
    "y-36": -1.456,
    "y-37": -1.456,
    "y-38": -1.456,
    "y-39": -1.456,
    "y-40": -1.456,
    "y-41": -1.456,
    "y-42": -1.456,
    "y-43": -1.456,
    "y-44": -1.456,
    "y-45": -1.456,
    "y-47": -1.456,
    "y-48": -1.456,
    "y-49": -1.456,
    "y-50": -1.456,
    "y-51": -1.456,
    "y-52": -1.456,
    "y-53": -1.456,
    "y-54": -1.456,
    "y-55": -1.456,
    "y-56": -1.456,
    "y-57": -1.456,
    "y-58": -1.456,
    "y-59": -1.456,
    "y-60": -1.456,
    "y-61": -1.456,
    "y-62": -1.456,
    "y-63": -1.456,
    "y-64": -1.456,
    "y-65": -1.456,
    "y-66": -1.456,
    "y-67": -1.456,
    "y-68": -1.456,
    "y-69": -1.456,
    "y-70": -1.456,
    "y-71": -1.456,
    "y-72": -1.456,
    "y-73": -1.456,
    "y-74": -1.456,
    "y-75": -1.456,
    "y-76": -1.456,
    "y-77": -1.456,
    "y-78": -1.456,
    "y-79": -1.456,
    "y-80": -1.456,
    "y-81": -1.456,
    "y-82": -1.456,
    "y-83": -1.456,
    "y-84": -1.456,
    "y-85": -1.456,
    "y-86": -1.456,
    "y-87": -1.456,
    "y-88": -1.456,
    "y-89": -1.456,
    "y-90": -1.456,
    "y-91": -1.456,
    "y-92": -1.456,
    "y-93": -1.456,
    "y-94": -1.456,
    "y-95": -1.456,
    "y-96": -1.456,
    "y-97": -1.456,
    "y-98": -1.456,
    "y-99": -1.456,
    "y-100": -1.456,
    "y-101": -1.456,
    "y-102": -1.456,
    "y-103": -1.456,
    "y-104": -1.456,
    "y-105": -1.456,
    "y-106": -1.456,
    "y-107": -1.456,
    "y-108": -1.456,
    "y-109": -1.456,
    "y-110": -1.456,
    "y-111": -1.456,
    "y-112": -1.456,
    "y-113": -1.456,
    "y-114": -1.456,
    "y-115": -1.456,
    "y-116": -1.456,
    "y-117": -1.456,
    "y-118": -1.456,
    "y-119": -1.456,
    "y-120": -1.456,
    "y-121": -1.456,
    "y-122": -1.456,
    "y-123": -1.456,
    "y-124": -1.456,
    "y-125": -1.456,
    "y-126": -1.456,
    "y-127": -1.456,
    "y-128": -1.456,
    "y-129": -1.456,
    "y-130": -1.456,
    "y-131": -1.456,
    "y-132": -1.456,
    "y-133": -1.456,
    "y-134": -1.456,
    "y-135": -1.456,
    "y-136": -1.456,
    "y-137": -1.456,
    "y-138": -1.456,
    "y-139": -1.456,
    "y-140": -1.456,
    "y-141": -1.456,
    "y-142": -1.456,
    "y-143": -1.456,
    "y-144": -1.456,
    "y-145": -1.456,
    "y-146": -1.456,
    "y-147": -1.456,
    "y-148": -1.456,
    "y-149": -1.456,
    "y-150": -1.456,
    "y-151": -1.456,
    "y-152": -1.456,
    "y-153": -1.456,
    "y-154": -1.456,
    "y-155": -1.456,
    "y-156": -1.456,
    "y-157": -1.456,
    "y-158": -1.456,
    "y-159": -1.456,
    "y-160": -1.456,
    "y-161": -1.456,
    "y-162": -1.456,
    "y-163": -1.456,
    "y-164": -1.456,
    "y-165": -1.456,
    "y-166": -1.456,
    "y-167": -1.456,
    "y-168": -1.456,
    "y-169": -1.456,
    "y-170": -1.456,
    "y-171": -1.456,
    "y-172": -1.456,
    "y-173": -1.456,
    "y-174": -1.456,
    "y-175": -1.456,
    "y-176": -1.456,
    "y-177": -1.456,
    "y-178": -1.456,
    "y-179": -1.456,
    "y-180": -1.456,
    "y-181": -1.456,
    "y-182": -1.456,
    "y-183": -1.456,
    "y-184": -1.456,
    "y-185": -1.456,
    "y-186": -1.456,
    "y-187": -1.456,
    "y-188": -1.456,
    "y-189": -1.456,
    "y-190": -1.456,
    "y-191": -1.456,
    "y-192": -1.456,
    "y-193": -1.456,
    "y-194": -1.456,
    "y-195": -1.456,
    "y-196": -1.456,
    "y-197": -1.456,
    "y-198": -1.456,
    "y-199": -1.456,
    "y-200": -1.456,
    "y-201": -1.456,
    "y-202": -1.456,
    "y-203": -1.456,
    "y-204": -1.456,
    "y-205": -1.456,
    "y-206": -1.456,
    "y-207": -1.456,
    "y-208": -1.456,
    "y-209": -1.456,
    "y-210": -1.456,
    "y-211": -1.456,
    "y-212": -1.456,
    "y-213": -1.456,
    "y-214": -1.456,
    "y-215": -1.456,
    "y-216": -1.456,
    "y-217": -1.456,
    "y-218": -1.456,
    "y-219": -1.456,
    "y-220": -1.456,
    "y-221": -1.456,
    "y-222": -1.456,
    "y-223": -1.456,
    "y-224": -1.456,
    "y-225": -1.456,
    "y-226": -1.456,
    "y-227": -1.456,
    "y-228": -1.456,
    "y-229": -1.456,
    "y-230": -1.456,
    "y-231": -1.456,
    "y-232": -1.456,
    "y-233": -1.456,
    "y-234": -1.456,
    "y-235": -1.456,
    "y-236": -1.456,
    "y-237": -1.456,
    "y-238": -1.456,
    "y-239": -1.456,
    "y-240": -1.456,
    "y-241": -1.456,
    "y-242": -1.456,
    "y-243": -1.456,
    "y-244": -1.456,
    "y-245": -1.456,
    "y-246": -1.456,
    "y-247": -1.456,
    "y-248": -1.456,
    "y-249": -1.456,
    "y-250": -1.456,
    "y-251": -1.456,
    "y-252": -1.456,
    "y-253": -1.456,
    "y-254": -1.456,
    "y-255": -1.456,
  },
  {
    x: 1.425,
    "y-2": -1.261,
    "y-12": -1.202,
    "y-46": -1.388,
    "y-1000": -1.473,
    "y-0": -0.592,
    "y-1": -0.814,
    "y-3": -1.107,
    "y-4": -1.135,
    "y-5": -1.146,
    "y-6": -1.146,
    "y-7": -1.147,
    "y-8": -1.148,
    "y-9": -1.148,
    "y-10": -1.2,
    "y-11": -1.2,
    "y-13": -1.202,
    "y-14": -1.202,
    "y-15": -1.216,
    "y-16": -1.216,
    "y-17": -1.125,
    "y-18": -1.101,
    "y-19": -1.101,
    "y-20": -1.101,
    "y-21": -1.101,
    "y-22": -1.101,
    "y-23": -1.146,
    "y-24": -1.139,
    "y-25": -1.139,
    "y-26": -1.139,
    "y-27": -1.139,
    "y-28": -1.588,
    "y-29": -1.588,
    "y-30": -1.599,
    "y-31": -1.388,
    "y-32": -1.388,
    "y-33": -1.388,
    "y-34": -1.388,
    "y-35": -1.388,
    "y-36": -1.388,
    "y-37": -1.388,
    "y-38": -1.388,
    "y-39": -1.388,
    "y-40": -1.388,
    "y-41": -1.388,
    "y-42": -1.388,
    "y-43": -1.388,
    "y-44": -1.388,
    "y-45": -1.388,
    "y-47": -1.388,
    "y-48": -1.388,
    "y-49": -1.388,
    "y-50": -1.388,
    "y-51": -1.388,
    "y-52": -1.388,
    "y-53": -1.388,
    "y-54": -1.388,
    "y-55": -1.388,
    "y-56": -1.388,
    "y-57": -1.388,
    "y-58": -1.388,
    "y-59": -1.388,
    "y-60": -1.388,
    "y-61": -1.388,
    "y-62": -1.388,
    "y-63": -1.388,
    "y-64": -1.388,
    "y-65": -1.388,
    "y-66": -1.388,
    "y-67": -1.388,
    "y-68": -1.388,
    "y-69": -1.388,
    "y-70": -1.388,
    "y-71": -1.388,
    "y-72": -1.388,
    "y-73": -1.388,
    "y-74": -1.388,
    "y-75": -1.388,
    "y-76": -1.388,
    "y-77": -1.388,
    "y-78": -1.426,
    "y-79": -1.426,
    "y-80": -1.426,
    "y-81": -1.426,
    "y-82": -1.426,
    "y-83": -1.426,
    "y-84": -1.426,
    "y-85": -1.449,
    "y-86": -1.449,
    "y-87": -1.449,
    "y-88": -1.449,
    "y-89": -1.449,
    "y-90": -1.449,
    "y-91": -1.449,
    "y-92": -1.449,
    "y-93": -1.449,
    "y-94": -1.446,
    "y-95": -1.446,
    "y-96": -1.446,
    "y-97": -1.446,
    "y-98": -1.446,
    "y-99": -1.446,
    "y-100": -1.446,
    "y-101": -1.446,
    "y-102": -1.446,
    "y-103": -1.446,
    "y-104": -1.446,
    "y-105": -1.446,
    "y-106": -1.445,
    "y-107": -1.446,
    "y-108": -1.446,
    "y-109": -1.446,
    "y-110": -1.446,
    "y-111": -1.445,
    "y-112": -1.542,
    "y-113": -1.542,
    "y-114": -1.514,
    "y-115": -1.515,
    "y-116": -1.515,
    "y-117": -1.515,
    "y-118": -1.515,
    "y-119": -1.515,
    "y-120": -1.516,
    "y-121": -1.516,
    "y-122": -1.516,
    "y-123": -1.516,
    "y-124": -1.516,
    "y-125": -1.515,
    "y-126": -1.515,
    "y-127": -1.515,
    "y-128": -1.515,
    "y-129": -1.515,
    "y-130": -1.515,
    "y-131": -1.515,
    "y-132": -1.515,
    "y-133": -1.515,
    "y-134": -1.515,
    "y-135": -1.516,
    "y-136": -1.516,
    "y-137": -1.516,
    "y-138": -1.516,
    "y-139": -1.516,
    "y-140": -1.516,
    "y-141": -1.516,
    "y-142": -1.516,
    "y-143": -1.516,
    "y-144": -1.506,
    "y-145": -1.506,
    "y-146": -1.506,
    "y-147": -1.506,
    "y-148": -1.506,
    "y-149": -1.506,
    "y-150": -1.505,
    "y-151": -1.473,
    "y-152": -1.451,
    "y-153": -1.451,
    "y-154": -1.451,
    "y-155": -1.451,
    "y-156": -1.451,
    "y-157": -1.451,
    "y-158": -1.451,
    "y-159": -1.451,
    "y-160": -1.451,
    "y-161": -1.449,
    "y-162": -1.449,
    "y-163": -1.449,
    "y-164": -1.448,
    "y-165": -1.448,
    "y-166": -1.447,
    "y-167": -1.447,
    "y-168": -1.447,
    "y-169": -1.447,
    "y-170": -1.447,
    "y-171": -1.447,
    "y-172": -1.447,
    "y-173": -1.447,
    "y-174": -1.452,
    "y-175": -1.452,
    "y-176": -1.452,
    "y-177": -1.46,
    "y-178": -1.46,
    "y-179": -1.46,
    "y-180": -1.46,
    "y-181": -1.46,
    "y-182": -1.46,
    "y-183": -1.452,
    "y-184": -1.452,
    "y-185": -1.452,
    "y-186": -1.452,
    "y-187": -1.452,
    "y-188": -1.452,
    "y-189": -1.452,
    "y-190": -1.452,
    "y-191": -1.452,
    "y-192": -1.452,
    "y-193": -1.452,
    "y-194": -1.452,
    "y-195": -1.452,
    "y-196": -1.452,
    "y-197": -1.452,
    "y-198": -1.452,
    "y-199": -1.452,
    "y-200": -1.452,
    "y-201": -1.452,
    "y-202": -1.452,
    "y-203": -1.452,
    "y-204": -1.452,
    "y-205": -1.467,
    "y-206": -1.467,
    "y-207": -1.467,
    "y-208": -1.467,
    "y-209": -1.467,
    "y-210": -1.467,
    "y-211": -1.467,
    "y-212": -1.467,
    "y-213": -1.467,
    "y-214": -1.467,
    "y-215": -1.467,
    "y-216": -1.467,
    "y-217": -1.467,
    "y-218": -1.467,
    "y-219": -1.467,
    "y-220": -1.467,
    "y-221": -1.467,
    "y-222": -1.467,
    "y-223": -1.467,
    "y-224": -1.467,
    "y-225": -1.467,
    "y-226": -1.467,
    "y-227": -1.467,
    "y-228": -1.467,
    "y-229": -1.467,
    "y-230": -1.467,
    "y-231": -1.467,
    "y-232": -1.467,
    "y-233": -1.467,
    "y-234": -1.467,
    "y-235": -1.467,
    "y-236": -1.467,
    "y-237": -1.467,
    "y-238": -1.467,
    "y-239": -1.467,
    "y-240": -1.467,
    "y-241": -1.467,
    "y-242": -1.467,
    "y-243": -1.467,
    "y-244": -1.456,
    "y-245": -1.456,
    "y-246": -1.462,
    "y-247": -1.462,
    "y-248": -1.462,
    "y-249": -1.462,
    "y-250": -1.462,
    "y-251": -1.462,
    "y-252": -1.462,
    "y-253": -1.462,
    "y-254": -1.462,
    "y-255": -1.462,
  },
  {
    x: 1.45,
    "y-2": -1.129,
    "y-12": -1.086,
    "y-46": -1.3,
    "y-1000": -1.473,
    "y-0": -0.604,
    "y-1": -0.714,
    "y-3": -0.987,
    "y-4": -1.012,
    "y-5": -1.023,
    "y-6": -1.023,
    "y-7": -1.023,
    "y-8": -1.025,
    "y-9": -1.025,
    "y-10": -1.073,
    "y-11": -1.072,
    "y-13": -1.086,
    "y-14": -1.086,
    "y-15": -1.098,
    "y-16": -1.098,
    "y-17": -0.971,
    "y-18": -0.954,
    "y-19": -0.954,
    "y-20": -0.954,
    "y-21": -0.954,
    "y-22": -0.954,
    "y-23": -0.987,
    "y-24": -0.975,
    "y-25": -0.975,
    "y-26": -0.975,
    "y-27": -0.975,
    "y-28": -1.328,
    "y-29": -1.328,
    "y-30": -1.335,
    "y-31": -1.3,
    "y-32": -1.3,
    "y-33": -1.3,
    "y-34": -1.3,
    "y-35": -1.3,
    "y-36": -1.3,
    "y-37": -1.3,
    "y-38": -1.3,
    "y-39": -1.3,
    "y-40": -1.3,
    "y-41": -1.3,
    "y-42": -1.3,
    "y-43": -1.3,
    "y-44": -1.3,
    "y-45": -1.3,
    "y-47": -1.3,
    "y-48": -1.3,
    "y-49": -1.3,
    "y-50": -1.3,
    "y-51": -1.3,
    "y-52": -1.3,
    "y-53": -1.3,
    "y-54": -1.3,
    "y-55": -1.3,
    "y-56": -1.3,
    "y-57": -1.3,
    "y-58": -1.3,
    "y-59": -1.3,
    "y-60": -1.3,
    "y-61": -1.3,
    "y-62": -1.3,
    "y-63": -1.3,
    "y-64": -1.3,
    "y-65": -1.3,
    "y-66": -1.3,
    "y-67": -1.3,
    "y-68": -1.3,
    "y-69": -1.3,
    "y-70": -1.3,
    "y-71": -1.3,
    "y-72": -1.3,
    "y-73": -1.3,
    "y-74": -1.3,
    "y-75": -1.3,
    "y-76": -1.3,
    "y-77": -1.3,
    "y-78": -1.495,
    "y-79": -1.495,
    "y-80": -1.495,
    "y-81": -1.495,
    "y-82": -1.495,
    "y-83": -1.495,
    "y-84": -1.495,
    "y-85": -1.609,
    "y-86": -1.609,
    "y-87": -1.609,
    "y-88": -1.609,
    "y-89": -1.609,
    "y-90": -1.609,
    "y-91": -1.609,
    "y-92": -1.609,
    "y-93": -1.609,
    "y-94": -1.594,
    "y-95": -1.594,
    "y-96": -1.594,
    "y-97": -1.595,
    "y-98": -1.594,
    "y-99": -1.594,
    "y-100": -1.594,
    "y-101": -1.594,
    "y-102": -1.594,
    "y-103": -1.594,
    "y-104": -1.592,
    "y-105": -1.592,
    "y-106": -1.591,
    "y-107": -1.592,
    "y-108": -1.592,
    "y-109": -1.592,
    "y-110": -1.591,
    "y-111": -1.591,
    "y-112": -1.66,
    "y-113": -1.66,
    "y-114": -1.598,
    "y-115": -1.599,
    "y-116": -1.599,
    "y-117": -1.599,
    "y-118": -1.599,
    "y-119": -1.599,
    "y-120": -1.601,
    "y-121": -1.601,
    "y-122": -1.601,
    "y-123": -1.601,
    "y-124": -1.601,
    "y-125": -1.6,
    "y-126": -1.6,
    "y-127": -1.6,
    "y-128": -1.6,
    "y-129": -1.6,
    "y-130": -1.6,
    "y-131": -1.6,
    "y-132": -1.6,
    "y-133": -1.6,
    "y-134": -1.6,
    "y-135": -1.601,
    "y-136": -1.601,
    "y-137": -1.601,
    "y-138": -1.601,
    "y-139": -1.601,
    "y-140": -1.601,
    "y-141": -1.601,
    "y-142": -1.601,
    "y-143": -1.601,
    "y-144": -1.579,
    "y-145": -1.579,
    "y-146": -1.579,
    "y-147": -1.579,
    "y-148": -1.579,
    "y-149": -1.579,
    "y-150": -1.578,
    "y-151": -1.505,
    "y-152": -1.455,
    "y-153": -1.455,
    "y-154": -1.455,
    "y-155": -1.455,
    "y-156": -1.455,
    "y-157": -1.455,
    "y-158": -1.455,
    "y-159": -1.455,
    "y-160": -1.455,
    "y-161": -1.452,
    "y-162": -1.452,
    "y-163": -1.452,
    "y-164": -1.449,
    "y-165": -1.449,
    "y-166": -1.447,
    "y-167": -1.447,
    "y-168": -1.447,
    "y-169": -1.447,
    "y-170": -1.447,
    "y-171": -1.447,
    "y-172": -1.447,
    "y-173": -1.447,
    "y-174": -1.466,
    "y-175": -1.466,
    "y-176": -1.466,
    "y-177": -1.475,
    "y-178": -1.475,
    "y-179": -1.475,
    "y-180": -1.475,
    "y-181": -1.475,
    "y-182": -1.475,
    "y-183": -1.456,
    "y-184": -1.456,
    "y-185": -1.456,
    "y-186": -1.456,
    "y-187": -1.456,
    "y-188": -1.456,
    "y-189": -1.456,
    "y-190": -1.456,
    "y-191": -1.456,
    "y-192": -1.456,
    "y-193": -1.456,
    "y-194": -1.456,
    "y-195": -1.456,
    "y-196": -1.456,
    "y-197": -1.456,
    "y-198": -1.456,
    "y-199": -1.456,
    "y-200": -1.456,
    "y-201": -1.456,
    "y-202": -1.456,
    "y-203": -1.456,
    "y-204": -1.456,
    "y-205": -1.494,
    "y-206": -1.494,
    "y-207": -1.494,
    "y-208": -1.494,
    "y-209": -1.494,
    "y-210": -1.494,
    "y-211": -1.494,
    "y-212": -1.494,
    "y-213": -1.494,
    "y-214": -1.494,
    "y-215": -1.494,
    "y-216": -1.494,
    "y-217": -1.494,
    "y-218": -1.494,
    "y-219": -1.494,
    "y-220": -1.494,
    "y-221": -1.494,
    "y-222": -1.494,
    "y-223": -1.494,
    "y-224": -1.494,
    "y-225": -1.494,
    "y-226": -1.494,
    "y-227": -1.494,
    "y-228": -1.494,
    "y-229": -1.494,
    "y-230": -1.494,
    "y-231": -1.494,
    "y-232": -1.494,
    "y-233": -1.494,
    "y-234": -1.494,
    "y-235": -1.494,
    "y-236": -1.494,
    "y-237": -1.494,
    "y-238": -1.494,
    "y-239": -1.494,
    "y-240": -1.494,
    "y-241": -1.494,
    "y-242": -1.494,
    "y-243": -1.494,
    "y-244": -1.469,
    "y-245": -1.469,
    "y-246": -1.475,
    "y-247": -1.475,
    "y-248": -1.475,
    "y-249": -1.475,
    "y-250": -1.475,
    "y-251": -1.475,
    "y-252": -1.475,
    "y-253": -1.475,
    "y-254": -1.475,
    "y-255": -1.475,
  },
  {
    x: 1.475,
    "y-2": -0.998,
    "y-12": -0.97,
    "y-46": -1.213,
    "y-1000": -1.387,
    "y-0": -0.617,
    "y-1": -0.614,
    "y-3": -0.866,
    "y-4": -0.89,
    "y-5": -0.899,
    "y-6": -0.9,
    "y-7": -0.9,
    "y-8": -0.901,
    "y-9": -0.901,
    "y-10": -0.946,
    "y-11": -0.945,
    "y-13": -0.97,
    "y-14": -0.97,
    "y-15": -0.979,
    "y-16": -0.979,
    "y-17": -0.818,
    "y-18": -0.806,
    "y-19": -0.806,
    "y-20": -0.806,
    "y-21": -0.806,
    "y-22": -0.806,
    "y-23": -0.828,
    "y-24": -0.81,
    "y-25": -0.81,
    "y-26": -0.81,
    "y-27": -0.81,
    "y-28": -1.068,
    "y-29": -1.068,
    "y-30": -1.07,
    "y-31": -1.213,
    "y-32": -1.213,
    "y-33": -1.213,
    "y-34": -1.213,
    "y-35": -1.213,
    "y-36": -1.213,
    "y-37": -1.213,
    "y-38": -1.213,
    "y-39": -1.213,
    "y-40": -1.213,
    "y-41": -1.213,
    "y-42": -1.213,
    "y-43": -1.213,
    "y-44": -1.213,
    "y-45": -1.213,
    "y-47": -1.213,
    "y-48": -1.213,
    "y-49": -1.213,
    "y-50": -1.213,
    "y-51": -1.213,
    "y-52": -1.213,
    "y-53": -1.213,
    "y-54": -1.213,
    "y-55": -1.213,
    "y-56": -1.213,
    "y-57": -1.213,
    "y-58": -1.213,
    "y-59": -1.213,
    "y-60": -1.213,
    "y-61": -1.213,
    "y-62": -1.213,
    "y-63": -1.213,
    "y-64": -1.213,
    "y-65": -1.213,
    "y-66": -1.213,
    "y-67": -1.213,
    "y-68": -1.213,
    "y-69": -1.213,
    "y-70": -1.213,
    "y-71": -1.213,
    "y-72": -1.213,
    "y-73": -1.213,
    "y-74": -1.213,
    "y-75": -1.213,
    "y-76": -1.213,
    "y-77": -1.213,
    "y-78": -1.564,
    "y-79": -1.563,
    "y-80": -1.563,
    "y-81": -1.563,
    "y-82": -1.563,
    "y-83": -1.563,
    "y-84": -1.563,
    "y-85": -1.626,
    "y-86": -1.626,
    "y-87": -1.626,
    "y-88": -1.626,
    "y-89": -1.627,
    "y-90": -1.627,
    "y-91": -1.627,
    "y-92": -1.627,
    "y-93": -1.627,
    "y-94": -1.607,
    "y-95": -1.606,
    "y-96": -1.607,
    "y-97": -1.607,
    "y-98": -1.607,
    "y-99": -1.607,
    "y-100": -1.607,
    "y-101": -1.607,
    "y-102": -1.607,
    "y-103": -1.607,
    "y-104": -1.604,
    "y-105": -1.604,
    "y-106": -1.603,
    "y-107": -1.604,
    "y-108": -1.604,
    "y-109": -1.604,
    "y-110": -1.603,
    "y-111": -1.603,
    "y-112": -1.632,
    "y-113": -1.632,
    "y-114": -1.56,
    "y-115": -1.561,
    "y-116": -1.561,
    "y-117": -1.561,
    "y-118": -1.561,
    "y-119": -1.561,
    "y-120": -1.563,
    "y-121": -1.564,
    "y-122": -1.563,
    "y-123": -1.563,
    "y-124": -1.563,
    "y-125": -1.562,
    "y-126": -1.562,
    "y-127": -1.562,
    "y-128": -1.562,
    "y-129": -1.562,
    "y-130": -1.562,
    "y-131": -1.562,
    "y-132": -1.562,
    "y-133": -1.562,
    "y-134": -1.562,
    "y-135": -1.563,
    "y-136": -1.563,
    "y-137": -1.563,
    "y-138": -1.563,
    "y-139": -1.563,
    "y-140": -1.563,
    "y-141": -1.563,
    "y-142": -1.563,
    "y-143": -1.563,
    "y-144": -1.538,
    "y-145": -1.538,
    "y-146": -1.538,
    "y-147": -1.538,
    "y-148": -1.538,
    "y-149": -1.538,
    "y-150": -1.537,
    "y-151": -1.452,
    "y-152": -1.395,
    "y-153": -1.395,
    "y-154": -1.395,
    "y-155": -1.395,
    "y-156": -1.395,
    "y-157": -1.395,
    "y-158": -1.395,
    "y-159": -1.395,
    "y-160": -1.395,
    "y-161": -1.391,
    "y-162": -1.391,
    "y-163": -1.391,
    "y-164": -1.388,
    "y-165": -1.388,
    "y-166": -1.386,
    "y-167": -1.386,
    "y-168": -1.386,
    "y-169": -1.386,
    "y-170": -1.386,
    "y-171": -1.386,
    "y-172": -1.386,
    "y-173": -1.386,
    "y-174": -1.433,
    "y-175": -1.433,
    "y-176": -1.433,
    "y-177": -1.44,
    "y-178": -1.44,
    "y-179": -1.44,
    "y-180": -1.44,
    "y-181": -1.44,
    "y-182": -1.44,
    "y-183": -1.416,
    "y-184": -1.416,
    "y-185": -1.416,
    "y-186": -1.416,
    "y-187": -1.416,
    "y-188": -1.416,
    "y-189": -1.416,
    "y-190": -1.416,
    "y-191": -1.416,
    "y-192": -1.416,
    "y-193": -1.416,
    "y-194": -1.416,
    "y-195": -1.416,
    "y-196": -1.416,
    "y-197": -1.416,
    "y-198": -1.416,
    "y-199": -1.416,
    "y-200": -1.416,
    "y-201": -1.416,
    "y-202": -1.416,
    "y-203": -1.416,
    "y-204": -1.416,
    "y-205": -1.441,
    "y-206": -1.441,
    "y-207": -1.441,
    "y-208": -1.441,
    "y-209": -1.441,
    "y-210": -1.441,
    "y-211": -1.441,
    "y-212": -1.441,
    "y-213": -1.441,
    "y-214": -1.441,
    "y-215": -1.441,
    "y-216": -1.441,
    "y-217": -1.441,
    "y-218": -1.441,
    "y-219": -1.441,
    "y-220": -1.441,
    "y-221": -1.441,
    "y-222": -1.441,
    "y-223": -1.441,
    "y-224": -1.441,
    "y-225": -1.441,
    "y-226": -1.441,
    "y-227": -1.441,
    "y-228": -1.441,
    "y-229": -1.441,
    "y-230": -1.441,
    "y-231": -1.441,
    "y-232": -1.441,
    "y-233": -1.441,
    "y-234": -1.441,
    "y-235": -1.441,
    "y-236": -1.441,
    "y-237": -1.441,
    "y-238": -1.441,
    "y-239": -1.441,
    "y-240": -1.441,
    "y-241": -1.441,
    "y-242": -1.441,
    "y-243": -1.441,
    "y-244": -1.412,
    "y-245": -1.412,
    "y-246": -1.416,
    "y-247": -1.416,
    "y-248": -1.416,
    "y-249": -1.416,
    "y-250": -1.416,
    "y-251": -1.416,
    "y-252": -1.416,
    "y-253": -1.416,
    "y-254": -1.416,
    "y-255": -1.416,
  },
  {
    x: 1.5,
    "y-2": -0.866,
    "y-12": -0.854,
    "y-46": -1.125,
    "y-1000": -1.125,
    "y-0": -0.629,
    "y-1": -0.514,
    "y-3": -0.745,
    "y-4": -0.767,
    "y-5": -0.776,
    "y-6": -0.776,
    "y-7": -0.776,
    "y-8": -0.778,
    "y-9": -0.778,
    "y-10": -0.819,
    "y-11": -0.818,
    "y-13": -0.854,
    "y-14": -0.854,
    "y-15": -0.861,
    "y-16": -0.861,
    "y-17": -0.664,
    "y-18": -0.659,
    "y-19": -0.659,
    "y-20": -0.659,
    "y-21": -0.659,
    "y-22": -0.659,
    "y-23": -0.669,
    "y-24": -0.646,
    "y-25": -0.646,
    "y-26": -0.646,
    "y-27": -0.646,
    "y-28": -0.809,
    "y-29": -0.809,
    "y-30": -0.806,
    "y-31": -1.125,
    "y-32": -1.125,
    "y-33": -1.125,
    "y-34": -1.125,
    "y-35": -1.125,
    "y-36": -1.125,
    "y-37": -1.125,
    "y-38": -1.125,
    "y-39": -1.125,
    "y-40": -1.125,
    "y-41": -1.125,
    "y-42": -1.125,
    "y-43": -1.125,
    "y-44": -1.125,
    "y-45": -1.125,
    "y-47": -1.125,
    "y-48": -1.125,
    "y-49": -1.125,
    "y-50": -1.125,
    "y-51": -1.125,
    "y-52": -1.125,
    "y-53": -1.125,
    "y-54": -1.125,
    "y-55": -1.125,
    "y-56": -1.125,
    "y-57": -1.125,
    "y-58": -1.125,
    "y-59": -1.125,
    "y-60": -1.125,
    "y-61": -1.125,
    "y-62": -1.125,
    "y-63": -1.125,
    "y-64": -1.125,
    "y-65": -1.125,
    "y-66": -1.125,
    "y-67": -1.125,
    "y-68": -1.125,
    "y-69": -1.125,
    "y-70": -1.125,
    "y-71": -1.125,
    "y-72": -1.125,
    "y-73": -1.125,
    "y-74": -1.125,
    "y-75": -1.125,
    "y-76": -1.125,
    "y-77": -1.125,
    "y-78": -1.125,
    "y-79": -1.125,
    "y-80": -1.125,
    "y-81": -1.125,
    "y-82": -1.125,
    "y-83": -1.125,
    "y-84": -1.125,
    "y-85": -1.125,
    "y-86": -1.125,
    "y-87": -1.125,
    "y-88": -1.125,
    "y-89": -1.125,
    "y-90": -1.125,
    "y-91": -1.125,
    "y-92": -1.125,
    "y-93": -1.125,
    "y-94": -1.125,
    "y-95": -1.125,
    "y-96": -1.125,
    "y-97": -1.125,
    "y-98": -1.125,
    "y-99": -1.125,
    "y-100": -1.125,
    "y-101": -1.125,
    "y-102": -1.125,
    "y-103": -1.125,
    "y-104": -1.125,
    "y-105": -1.125,
    "y-106": -1.125,
    "y-107": -1.125,
    "y-108": -1.125,
    "y-109": -1.125,
    "y-110": -1.125,
    "y-111": -1.125,
    "y-112": -1.125,
    "y-113": -1.125,
    "y-114": -1.125,
    "y-115": -1.125,
    "y-116": -1.125,
    "y-117": -1.125,
    "y-118": -1.125,
    "y-119": -1.125,
    "y-120": -1.125,
    "y-121": -1.125,
    "y-122": -1.125,
    "y-123": -1.125,
    "y-124": -1.125,
    "y-125": -1.125,
    "y-126": -1.125,
    "y-127": -1.125,
    "y-128": -1.125,
    "y-129": -1.125,
    "y-130": -1.125,
    "y-131": -1.125,
    "y-132": -1.125,
    "y-133": -1.125,
    "y-134": -1.125,
    "y-135": -1.125,
    "y-136": -1.125,
    "y-137": -1.125,
    "y-138": -1.125,
    "y-139": -1.125,
    "y-140": -1.125,
    "y-141": -1.125,
    "y-142": -1.125,
    "y-143": -1.125,
    "y-144": -1.125,
    "y-145": -1.125,
    "y-146": -1.125,
    "y-147": -1.125,
    "y-148": -1.125,
    "y-149": -1.125,
    "y-150": -1.125,
    "y-151": -1.125,
    "y-152": -1.125,
    "y-153": -1.125,
    "y-154": -1.125,
    "y-155": -1.125,
    "y-156": -1.125,
    "y-157": -1.125,
    "y-158": -1.125,
    "y-159": -1.125,
    "y-160": -1.125,
    "y-161": -1.125,
    "y-162": -1.125,
    "y-163": -1.125,
    "y-164": -1.125,
    "y-165": -1.125,
    "y-166": -1.125,
    "y-167": -1.125,
    "y-168": -1.125,
    "y-169": -1.125,
    "y-170": -1.125,
    "y-171": -1.125,
    "y-172": -1.125,
    "y-173": -1.125,
    "y-174": -1.125,
    "y-175": -1.125,
    "y-176": -1.125,
    "y-177": -1.125,
    "y-178": -1.125,
    "y-179": -1.125,
    "y-180": -1.125,
    "y-181": -1.125,
    "y-182": -1.125,
    "y-183": -1.125,
    "y-184": -1.125,
    "y-185": -1.125,
    "y-186": -1.125,
    "y-187": -1.125,
    "y-188": -1.125,
    "y-189": -1.125,
    "y-190": -1.125,
    "y-191": -1.125,
    "y-192": -1.125,
    "y-193": -1.125,
    "y-194": -1.125,
    "y-195": -1.125,
    "y-196": -1.125,
    "y-197": -1.125,
    "y-198": -1.125,
    "y-199": -1.125,
    "y-200": -1.125,
    "y-201": -1.125,
    "y-202": -1.125,
    "y-203": -1.125,
    "y-204": -1.125,
    "y-205": -1.125,
    "y-206": -1.125,
    "y-207": -1.125,
    "y-208": -1.125,
    "y-209": -1.125,
    "y-210": -1.125,
    "y-211": -1.125,
    "y-212": -1.125,
    "y-213": -1.125,
    "y-214": -1.125,
    "y-215": -1.125,
    "y-216": -1.125,
    "y-217": -1.125,
    "y-218": -1.125,
    "y-219": -1.125,
    "y-220": -1.125,
    "y-221": -1.125,
    "y-222": -1.125,
    "y-223": -1.125,
    "y-224": -1.125,
    "y-225": -1.125,
    "y-226": -1.125,
    "y-227": -1.125,
    "y-228": -1.125,
    "y-229": -1.125,
    "y-230": -1.125,
    "y-231": -1.125,
    "y-232": -1.125,
    "y-233": -1.125,
    "y-234": -1.125,
    "y-235": -1.125,
    "y-236": -1.125,
    "y-237": -1.125,
    "y-238": -1.125,
    "y-239": -1.125,
    "y-240": -1.125,
    "y-241": -1.125,
    "y-242": -1.125,
    "y-243": -1.125,
    "y-244": -1.125,
    "y-245": -1.125,
    "y-246": -1.125,
    "y-247": -1.125,
    "y-248": -1.125,
    "y-249": -1.125,
    "y-250": -1.125,
    "y-251": -1.125,
    "y-252": -1.125,
    "y-253": -1.125,
    "y-254": -1.125,
    "y-255": -1.125,
  },
  {
    x: 1.525,
    "y-2": -0.735,
    "y-12": -0.738,
    "y-46": -1.037,
    "y-1000": -0.721,
    "y-0": -0.641,
    "y-1": -0.414,
    "y-3": -0.625,
    "y-4": -0.644,
    "y-5": -0.652,
    "y-6": -0.653,
    "y-7": -0.653,
    "y-8": -0.654,
    "y-9": -0.654,
    "y-10": -0.691,
    "y-11": -0.691,
    "y-13": -0.738,
    "y-14": -0.738,
    "y-15": -0.742,
    "y-16": -0.742,
    "y-17": -0.511,
    "y-18": -0.512,
    "y-19": -0.512,
    "y-20": -0.512,
    "y-21": -0.512,
    "y-22": -0.512,
    "y-23": -0.51,
    "y-24": -0.482,
    "y-25": -0.482,
    "y-26": -0.482,
    "y-27": -0.482,
    "y-28": -0.549,
    "y-29": -0.549,
    "y-30": -0.541,
    "y-31": -1.037,
    "y-32": -1.037,
    "y-33": -1.037,
    "y-34": -1.037,
    "y-35": -1.037,
    "y-36": -1.037,
    "y-37": -1.037,
    "y-38": -1.037,
    "y-39": -1.037,
    "y-40": -1.037,
    "y-41": -1.037,
    "y-42": -1.037,
    "y-43": -1.037,
    "y-44": -1.037,
    "y-45": -1.037,
    "y-47": -1.037,
    "y-48": -1.037,
    "y-49": -1.037,
    "y-50": -1.037,
    "y-51": -1.037,
    "y-52": -1.037,
    "y-53": -1.037,
    "y-54": -1.037,
    "y-55": -1.037,
    "y-56": -1.037,
    "y-57": -1.037,
    "y-58": -1.037,
    "y-59": -1.037,
    "y-60": -1.037,
    "y-61": -1.037,
    "y-62": -1.037,
    "y-63": -1.037,
    "y-64": -1.037,
    "y-65": -1.037,
    "y-66": -1.037,
    "y-67": -1.037,
    "y-68": -1.037,
    "y-69": -1.037,
    "y-70": -1.037,
    "y-71": -1.037,
    "y-72": -1.037,
    "y-73": -1.037,
    "y-74": -1.037,
    "y-75": -1.037,
    "y-76": -1.037,
    "y-77": -1.037,
    "y-78": -0.475,
    "y-79": -0.476,
    "y-80": -0.476,
    "y-81": -0.476,
    "y-82": -0.476,
    "y-83": -0.476,
    "y-84": -0.476,
    "y-85": -0.471,
    "y-86": -0.471,
    "y-87": -0.47,
    "y-88": -0.471,
    "y-89": -0.47,
    "y-90": -0.47,
    "y-91": -0.471,
    "y-92": -0.471,
    "y-93": -0.47,
    "y-94": -0.498,
    "y-95": -0.498,
    "y-96": -0.498,
    "y-97": -0.498,
    "y-98": -0.498,
    "y-99": -0.497,
    "y-100": -0.498,
    "y-101": -0.497,
    "y-102": -0.498,
    "y-103": -0.497,
    "y-104": -0.501,
    "y-105": -0.501,
    "y-106": -0.503,
    "y-107": -0.502,
    "y-108": -0.502,
    "y-109": -0.502,
    "y-110": -0.503,
    "y-111": -0.503,
    "y-112": -0.485,
    "y-113": -0.485,
    "y-114": -0.579,
    "y-115": -0.578,
    "y-116": -0.577,
    "y-117": -0.578,
    "y-118": -0.578,
    "y-119": -0.578,
    "y-120": -0.574,
    "y-121": -0.574,
    "y-122": -0.575,
    "y-123": -0.574,
    "y-124": -0.574,
    "y-125": -0.576,
    "y-126": -0.576,
    "y-127": -0.576,
    "y-128": -0.576,
    "y-129": -0.576,
    "y-130": -0.576,
    "y-131": -0.576,
    "y-132": -0.576,
    "y-133": -0.576,
    "y-134": -0.576,
    "y-135": -0.575,
    "y-136": -0.575,
    "y-137": -0.575,
    "y-138": -0.575,
    "y-139": -0.575,
    "y-140": -0.575,
    "y-141": -0.575,
    "y-142": -0.575,
    "y-143": -0.575,
    "y-144": -0.609,
    "y-145": -0.609,
    "y-146": -0.609,
    "y-147": -0.609,
    "y-148": -0.609,
    "y-149": -0.609,
    "y-150": -0.61,
    "y-151": -0.64,
    "y-152": -0.733,
    "y-153": -0.733,
    "y-154": -0.733,
    "y-155": -0.733,
    "y-156": -0.733,
    "y-157": -0.733,
    "y-158": -0.733,
    "y-159": -0.733,
    "y-160": -0.733,
    "y-161": -0.74,
    "y-162": -0.74,
    "y-163": -0.74,
    "y-164": -0.745,
    "y-165": -0.745,
    "y-166": -0.748,
    "y-167": -0.748,
    "y-168": -0.748,
    "y-169": -0.748,
    "y-170": -0.748,
    "y-171": -0.748,
    "y-172": -0.748,
    "y-173": -0.748,
    "y-174": -0.701,
    "y-175": -0.701,
    "y-176": -0.701,
    "y-177": -0.696,
    "y-178": -0.696,
    "y-179": -0.696,
    "y-180": -0.696,
    "y-181": -0.696,
    "y-182": -0.696,
    "y-183": -0.73,
    "y-184": -0.73,
    "y-185": -0.73,
    "y-186": -0.73,
    "y-187": -0.73,
    "y-188": -0.73,
    "y-189": -0.731,
    "y-190": -0.731,
    "y-191": -0.731,
    "y-192": -0.731,
    "y-193": -0.731,
    "y-194": -0.731,
    "y-195": -0.731,
    "y-196": -0.731,
    "y-197": -0.731,
    "y-198": -0.731,
    "y-199": -0.731,
    "y-200": -0.731,
    "y-201": -0.731,
    "y-202": -0.731,
    "y-203": -0.731,
    "y-204": -0.731,
    "y-205": -0.715,
    "y-206": -0.715,
    "y-207": -0.715,
    "y-208": -0.715,
    "y-209": -0.715,
    "y-210": -0.715,
    "y-211": -0.715,
    "y-212": -0.715,
    "y-213": -0.715,
    "y-214": -0.715,
    "y-215": -0.715,
    "y-216": -0.715,
    "y-217": -0.715,
    "y-218": -0.715,
    "y-219": -0.715,
    "y-220": -0.715,
    "y-221": -0.715,
    "y-222": -0.715,
    "y-223": -0.715,
    "y-224": -0.715,
    "y-225": -0.715,
    "y-226": -0.715,
    "y-227": -0.715,
    "y-228": -0.715,
    "y-229": -0.715,
    "y-230": -0.715,
    "y-231": -0.715,
    "y-232": -0.715,
    "y-233": -0.715,
    "y-234": -0.715,
    "y-235": -0.715,
    "y-236": -0.715,
    "y-237": -0.715,
    "y-238": -0.715,
    "y-239": -0.715,
    "y-240": -0.715,
    "y-241": -0.715,
    "y-242": -0.715,
    "y-243": -0.715,
    "y-244": -0.73,
    "y-245": -0.73,
    "y-246": -0.726,
    "y-247": -0.726,
    "y-248": -0.726,
    "y-249": -0.726,
    "y-250": -0.726,
    "y-251": -0.727,
    "y-252": -0.726,
    "y-253": -0.726,
    "y-254": -0.726,
    "y-255": -0.726,
  },
  {
    x: 1.55,
    "y-2": -0.604,
    "y-12": -0.622,
    "y-46": -0.95,
    "y-1000": -0.225,
    "y-0": -0.653,
    "y-1": -0.313,
    "y-3": -0.504,
    "y-4": -0.522,
    "y-5": -0.529,
    "y-6": -0.529,
    "y-7": -0.529,
    "y-8": -0.53,
    "y-9": -0.53,
    "y-10": -0.564,
    "y-11": -0.564,
    "y-13": -0.622,
    "y-14": -0.622,
    "y-15": -0.624,
    "y-16": -0.624,
    "y-17": -0.357,
    "y-18": -0.364,
    "y-19": -0.364,
    "y-20": -0.364,
    "y-21": -0.364,
    "y-22": -0.364,
    "y-23": -0.351,
    "y-24": -0.317,
    "y-25": -0.317,
    "y-26": -0.317,
    "y-27": -0.317,
    "y-28": -0.289,
    "y-29": -0.289,
    "y-30": -0.276,
    "y-31": -0.95,
    "y-32": -0.95,
    "y-33": -0.95,
    "y-34": -0.95,
    "y-35": -0.95,
    "y-36": -0.95,
    "y-37": -0.95,
    "y-38": -0.95,
    "y-39": -0.95,
    "y-40": -0.95,
    "y-41": -0.95,
    "y-42": -0.95,
    "y-43": -0.95,
    "y-44": -0.95,
    "y-45": -0.95,
    "y-47": -0.95,
    "y-48": -0.95,
    "y-49": -0.95,
    "y-50": -0.95,
    "y-51": -0.95,
    "y-52": -0.95,
    "y-53": -0.95,
    "y-54": -0.95,
    "y-55": -0.95,
    "y-56": -0.95,
    "y-57": -0.95,
    "y-58": -0.95,
    "y-59": -0.95,
    "y-60": -0.95,
    "y-61": -0.95,
    "y-62": -0.95,
    "y-63": -0.95,
    "y-64": -0.95,
    "y-65": -0.95,
    "y-66": -0.95,
    "y-67": -0.95,
    "y-68": -0.95,
    "y-69": -0.95,
    "y-70": -0.95,
    "y-71": -0.95,
    "y-72": -0.95,
    "y-73": -0.95,
    "y-74": -0.95,
    "y-75": -0.95,
    "y-76": -0.95,
    "y-77": -0.95,
    "y-78": 0.175,
    "y-79": 0.173,
    "y-80": 0.173,
    "y-81": 0.173,
    "y-82": 0.173,
    "y-83": 0.173,
    "y-84": 0.173,
    "y-85": 0.183,
    "y-86": 0.183,
    "y-87": 0.184,
    "y-88": 0.184,
    "y-89": 0.184,
    "y-90": 0.184,
    "y-91": 0.184,
    "y-92": 0.184,
    "y-93": 0.185,
    "y-94": 0.162,
    "y-95": 0.161,
    "y-96": 0.162,
    "y-97": 0.162,
    "y-98": 0.161,
    "y-99": 0.163,
    "y-100": 0.162,
    "y-101": 0.164,
    "y-102": 0.162,
    "y-103": 0.163,
    "y-104": 0.155,
    "y-105": 0.155,
    "y-106": 0.152,
    "y-107": 0.154,
    "y-108": 0.154,
    "y-109": 0.154,
    "y-110": 0.152,
    "y-111": 0.152,
    "y-112": 0.17,
    "y-113": 0.17,
    "y-114": -0.007,
    "y-115": 0.016,
    "y-116": 0.017,
    "y-117": 0.017,
    "y-118": 0.017,
    "y-119": 0.016,
    "y-120": 0.023,
    "y-121": 0.023,
    "y-122": 0.022,
    "y-123": 0.023,
    "y-124": 0.023,
    "y-125": 0.032,
    "y-126": 0.032,
    "y-127": 0.032,
    "y-128": 0.032,
    "y-129": 0.032,
    "y-130": 0.032,
    "y-131": 0.032,
    "y-132": 0.032,
    "y-133": 0.032,
    "y-134": 0.032,
    "y-135": 0.034,
    "y-136": 0.034,
    "y-137": 0.034,
    "y-138": 0.034,
    "y-139": 0.034,
    "y-140": 0.034,
    "y-141": 0.034,
    "y-142": 0.034,
    "y-143": 0.034,
    "y-144": -0.024,
    "y-145": -0.024,
    "y-146": -0.024,
    "y-147": -0.024,
    "y-148": -0.024,
    "y-149": -0.024,
    "y-150": -0.026,
    "y-151": 0.019,
    "y-152": -0.194,
    "y-153": -0.194,
    "y-154": -0.194,
    "y-155": -0.194,
    "y-156": -0.194,
    "y-157": -0.194,
    "y-158": -0.194,
    "y-159": -0.194,
    "y-160": -0.194,
    "y-161": -0.21,
    "y-162": -0.21,
    "y-163": -0.21,
    "y-164": -0.222,
    "y-165": -0.222,
    "y-166": -0.229,
    "y-167": -0.229,
    "y-168": -0.229,
    "y-169": -0.229,
    "y-170": -0.229,
    "y-171": -0.229,
    "y-172": -0.229,
    "y-173": -0.229,
    "y-174": -0.17,
    "y-175": -0.171,
    "y-176": -0.171,
    "y-177": -0.164,
    "y-178": -0.164,
    "y-179": -0.164,
    "y-180": -0.164,
    "y-181": -0.164,
    "y-182": -0.164,
    "y-183": -0.238,
    "y-184": -0.238,
    "y-185": -0.238,
    "y-186": -0.238,
    "y-187": -0.238,
    "y-188": -0.238,
    "y-189": -0.239,
    "y-190": -0.239,
    "y-191": -0.239,
    "y-192": -0.239,
    "y-193": -0.239,
    "y-194": -0.239,
    "y-195": -0.239,
    "y-196": -0.239,
    "y-197": -0.239,
    "y-198": -0.239,
    "y-199": -0.239,
    "y-200": -0.239,
    "y-201": -0.239,
    "y-202": -0.239,
    "y-203": -0.239,
    "y-204": -0.239,
    "y-205": -0.218,
    "y-206": -0.218,
    "y-207": -0.218,
    "y-208": -0.219,
    "y-209": -0.219,
    "y-210": -0.219,
    "y-211": -0.218,
    "y-212": -0.218,
    "y-213": -0.218,
    "y-214": -0.218,
    "y-215": -0.218,
    "y-216": -0.218,
    "y-217": -0.218,
    "y-218": -0.218,
    "y-219": -0.218,
    "y-220": -0.218,
    "y-221": -0.218,
    "y-222": -0.218,
    "y-223": -0.218,
    "y-224": -0.218,
    "y-225": -0.219,
    "y-226": -0.219,
    "y-227": -0.219,
    "y-228": -0.219,
    "y-229": -0.219,
    "y-230": -0.219,
    "y-231": -0.219,
    "y-232": -0.219,
    "y-233": -0.219,
    "y-234": -0.219,
    "y-235": -0.219,
    "y-236": -0.219,
    "y-237": -0.219,
    "y-238": -0.219,
    "y-239": -0.219,
    "y-240": -0.219,
    "y-241": -0.219,
    "y-242": -0.219,
    "y-243": -0.219,
    "y-244": -0.207,
    "y-245": -0.207,
    "y-246": -0.203,
    "y-247": -0.203,
    "y-248": -0.203,
    "y-249": -0.203,
    "y-250": -0.203,
    "y-251": -0.204,
    "y-252": -0.204,
    "y-253": -0.204,
    "y-254": -0.204,
    "y-255": -0.203,
  },
  {
    x: 1.575,
    "y-2": -0.472,
    "y-12": -0.505,
    "y-46": -0.334,
    "y-1000": 0.179,
    "y-0": -0.665,
    "y-1": -0.213,
    "y-3": -0.383,
    "y-4": -0.399,
    "y-5": -0.406,
    "y-6": -0.406,
    "y-7": -0.406,
    "y-8": -0.407,
    "y-9": -0.407,
    "y-10": -0.437,
    "y-11": -0.437,
    "y-13": -0.505,
    "y-14": -0.505,
    "y-15": -0.506,
    "y-16": -0.506,
    "y-17": -0.204,
    "y-18": -0.217,
    "y-19": -0.217,
    "y-20": -0.217,
    "y-21": -0.217,
    "y-22": -0.217,
    "y-23": -0.192,
    "y-24": -0.153,
    "y-25": -0.153,
    "y-26": -0.153,
    "y-27": -0.153,
    "y-28": -0.03,
    "y-29": -0.03,
    "y-30": -0.012,
    "y-31": -0.479,
    "y-32": -0.479,
    "y-33": -0.479,
    "y-34": -0.479,
    "y-35": -0.479,
    "y-36": -0.479,
    "y-37": -0.332,
    "y-38": -0.338,
    "y-39": -0.339,
    "y-40": -0.335,
    "y-41": -0.339,
    "y-42": -0.335,
    "y-43": -0.335,
    "y-44": -0.336,
    "y-45": -0.335,
    "y-47": -0.338,
    "y-48": -0.338,
    "y-49": -0.444,
    "y-50": -0.446,
    "y-51": -0.445,
    "y-52": -0.446,
    "y-53": -0.448,
    "y-54": -0.446,
    "y-55": -0.445,
    "y-56": -0.443,
    "y-57": -0.446,
    "y-58": -0.447,
    "y-59": -0.447,
    "y-60": -0.447,
    "y-61": -0.447,
    "y-62": -0.447,
    "y-63": -0.447,
    "y-64": -0.447,
    "y-65": -0.447,
    "y-66": -0.447,
    "y-67": -0.447,
    "y-68": -0.447,
    "y-69": -0.45,
    "y-70": -0.45,
    "y-71": -0.45,
    "y-72": -0.45,
    "y-73": -0.45,
    "y-74": -0.45,
    "y-75": -0.45,
    "y-76": -0.45,
    "y-77": -0.45,
    "y-78": 0.513,
    "y-79": 0.511,
    "y-80": 0.511,
    "y-81": 0.511,
    "y-82": 0.511,
    "y-83": 0.512,
    "y-84": 0.511,
    "y-85": 0.52,
    "y-86": 0.52,
    "y-87": 0.521,
    "y-88": 0.52,
    "y-89": 0.521,
    "y-90": 0.521,
    "y-91": 0.521,
    "y-92": 0.52,
    "y-93": 0.521,
    "y-94": 0.52,
    "y-95": 0.519,
    "y-96": 0.52,
    "y-97": 0.52,
    "y-98": 0.519,
    "y-99": 0.52,
    "y-100": 0.52,
    "y-101": 0.521,
    "y-102": 0.52,
    "y-103": 0.52,
    "y-104": 0.513,
    "y-105": 0.514,
    "y-106": 0.51,
    "y-107": 0.513,
    "y-108": 0.513,
    "y-109": 0.513,
    "y-110": 0.511,
    "y-111": 0.511,
    "y-112": 0.516,
    "y-113": 0.516,
    "y-114": 0.36,
    "y-115": 0.401,
    "y-116": 0.401,
    "y-117": 0.401,
    "y-118": 0.401,
    "y-119": 0.4,
    "y-120": 0.401,
    "y-121": 0.402,
    "y-122": 0.401,
    "y-123": 0.401,
    "y-124": 0.401,
    "y-125": 0.422,
    "y-126": 0.422,
    "y-127": 0.422,
    "y-128": 0.422,
    "y-129": 0.422,
    "y-130": 0.422,
    "y-131": 0.422,
    "y-132": 0.422,
    "y-133": 0.422,
    "y-134": 0.422,
    "y-135": 0.422,
    "y-136": 0.422,
    "y-137": 0.422,
    "y-138": 0.422,
    "y-139": 0.422,
    "y-140": 0.422,
    "y-141": 0.422,
    "y-142": 0.422,
    "y-143": 0.422,
    "y-144": 0.455,
    "y-145": 0.455,
    "y-146": 0.455,
    "y-147": 0.455,
    "y-148": 0.455,
    "y-149": 0.455,
    "y-150": 0.453,
    "y-151": 0.474,
    "y-152": 0.263,
    "y-153": 0.263,
    "y-154": 0.263,
    "y-155": 0.263,
    "y-156": 0.263,
    "y-157": 0.263,
    "y-158": 0.263,
    "y-159": 0.263,
    "y-160": 0.263,
    "y-161": 0.248,
    "y-162": 0.247,
    "y-163": 0.247,
    "y-164": 0.236,
    "y-165": 0.236,
    "y-166": 0.228,
    "y-167": 0.228,
    "y-168": 0.228,
    "y-169": 0.228,
    "y-170": 0.228,
    "y-171": 0.228,
    "y-172": 0.228,
    "y-173": 0.228,
    "y-174": 0.259,
    "y-175": 0.259,
    "y-176": 0.259,
    "y-177": 0.262,
    "y-178": 0.262,
    "y-179": 0.262,
    "y-180": 0.262,
    "y-181": 0.262,
    "y-182": 0.262,
    "y-183": 0.192,
    "y-184": 0.192,
    "y-185": 0.192,
    "y-186": 0.192,
    "y-187": 0.192,
    "y-188": 0.192,
    "y-189": 0.191,
    "y-190": 0.191,
    "y-191": 0.191,
    "y-192": 0.191,
    "y-193": 0.191,
    "y-194": 0.191,
    "y-195": 0.191,
    "y-196": 0.191,
    "y-197": 0.191,
    "y-198": 0.191,
    "y-199": 0.191,
    "y-200": 0.191,
    "y-201": 0.191,
    "y-202": 0.191,
    "y-203": 0.191,
    "y-204": 0.191,
    "y-205": 0.203,
    "y-206": 0.203,
    "y-207": 0.203,
    "y-208": 0.203,
    "y-209": 0.203,
    "y-210": 0.203,
    "y-211": 0.203,
    "y-212": 0.203,
    "y-213": 0.203,
    "y-214": 0.203,
    "y-215": 0.203,
    "y-216": 0.203,
    "y-217": 0.203,
    "y-218": 0.203,
    "y-219": 0.203,
    "y-220": 0.203,
    "y-221": 0.203,
    "y-222": 0.203,
    "y-223": 0.203,
    "y-224": 0.203,
    "y-225": 0.203,
    "y-226": 0.203,
    "y-227": 0.203,
    "y-228": 0.203,
    "y-229": 0.203,
    "y-230": 0.203,
    "y-231": 0.203,
    "y-232": 0.203,
    "y-233": 0.203,
    "y-234": 0.203,
    "y-235": 0.203,
    "y-236": 0.202,
    "y-237": 0.202,
    "y-238": 0.202,
    "y-239": 0.202,
    "y-240": 0.202,
    "y-241": 0.202,
    "y-242": 0.202,
    "y-243": 0.202,
    "y-244": 0.214,
    "y-245": 0.214,
    "y-246": 0.216,
    "y-247": 0.216,
    "y-248": 0.216,
    "y-249": 0.216,
    "y-250": 0.216,
    "y-251": 0.215,
    "y-252": 0.215,
    "y-253": 0.215,
    "y-254": 0.215,
    "y-255": 0.215,
  },
  {
    x: 1.6,
    "y-2": -0.341,
    "y-12": -0.389,
    "y-46": 0.396,
    "y-1000": 0.396,
    "y-0": -0.678,
    "y-1": -0.113,
    "y-3": -0.262,
    "y-4": -0.276,
    "y-5": -0.282,
    "y-6": -0.282,
    "y-7": -0.283,
    "y-8": -0.283,
    "y-9": -0.283,
    "y-10": -0.31,
    "y-11": -0.309,
    "y-13": -0.389,
    "y-14": -0.389,
    "y-15": -0.387,
    "y-16": -0.387,
    "y-17": -0.05,
    "y-18": -0.07,
    "y-19": -0.07,
    "y-20": -0.07,
    "y-21": -0.07,
    "y-22": -0.07,
    "y-23": -0.033,
    "y-24": 0.012,
    "y-25": 0.012,
    "y-26": 0.012,
    "y-27": 0.012,
    "y-28": 0.23,
    "y-29": 0.23,
    "y-30": 0.253,
    "y-31": 0.396,
    "y-32": 0.396,
    "y-33": 0.396,
    "y-34": 0.396,
    "y-35": 0.396,
    "y-36": 0.396,
    "y-37": 0.396,
    "y-38": 0.396,
    "y-39": 0.396,
    "y-40": 0.396,
    "y-41": 0.396,
    "y-42": 0.396,
    "y-43": 0.396,
    "y-44": 0.396,
    "y-45": 0.396,
    "y-47": 0.396,
    "y-48": 0.396,
    "y-49": 0.396,
    "y-50": 0.396,
    "y-51": 0.396,
    "y-52": 0.396,
    "y-53": 0.396,
    "y-54": 0.396,
    "y-55": 0.396,
    "y-56": 0.396,
    "y-57": 0.396,
    "y-58": 0.396,
    "y-59": 0.396,
    "y-60": 0.396,
    "y-61": 0.396,
    "y-62": 0.396,
    "y-63": 0.396,
    "y-64": 0.396,
    "y-65": 0.396,
    "y-66": 0.396,
    "y-67": 0.396,
    "y-68": 0.396,
    "y-69": 0.396,
    "y-70": 0.396,
    "y-71": 0.396,
    "y-72": 0.396,
    "y-73": 0.396,
    "y-74": 0.396,
    "y-75": 0.396,
    "y-76": 0.396,
    "y-77": 0.396,
    "y-78": 0.396,
    "y-79": 0.396,
    "y-80": 0.396,
    "y-81": 0.396,
    "y-82": 0.396,
    "y-83": 0.396,
    "y-84": 0.396,
    "y-85": 0.396,
    "y-86": 0.396,
    "y-87": 0.396,
    "y-88": 0.396,
    "y-89": 0.396,
    "y-90": 0.396,
    "y-91": 0.396,
    "y-92": 0.396,
    "y-93": 0.396,
    "y-94": 0.396,
    "y-95": 0.396,
    "y-96": 0.396,
    "y-97": 0.396,
    "y-98": 0.396,
    "y-99": 0.396,
    "y-100": 0.396,
    "y-101": 0.396,
    "y-102": 0.396,
    "y-103": 0.396,
    "y-104": 0.396,
    "y-105": 0.396,
    "y-106": 0.396,
    "y-107": 0.396,
    "y-108": 0.396,
    "y-109": 0.396,
    "y-110": 0.396,
    "y-111": 0.396,
    "y-112": 0.396,
    "y-113": 0.396,
    "y-114": 0.396,
    "y-115": 0.396,
    "y-116": 0.396,
    "y-117": 0.396,
    "y-118": 0.396,
    "y-119": 0.396,
    "y-120": 0.396,
    "y-121": 0.396,
    "y-122": 0.396,
    "y-123": 0.396,
    "y-124": 0.396,
    "y-125": 0.396,
    "y-126": 0.396,
    "y-127": 0.396,
    "y-128": 0.396,
    "y-129": 0.396,
    "y-130": 0.396,
    "y-131": 0.396,
    "y-132": 0.396,
    "y-133": 0.396,
    "y-134": 0.396,
    "y-135": 0.396,
    "y-136": 0.396,
    "y-137": 0.396,
    "y-138": 0.396,
    "y-139": 0.396,
    "y-140": 0.396,
    "y-141": 0.396,
    "y-142": 0.396,
    "y-143": 0.396,
    "y-144": 0.396,
    "y-145": 0.396,
    "y-146": 0.396,
    "y-147": 0.396,
    "y-148": 0.396,
    "y-149": 0.396,
    "y-150": 0.396,
    "y-151": 0.396,
    "y-152": 0.396,
    "y-153": 0.396,
    "y-154": 0.396,
    "y-155": 0.396,
    "y-156": 0.396,
    "y-157": 0.396,
    "y-158": 0.396,
    "y-159": 0.396,
    "y-160": 0.396,
    "y-161": 0.396,
    "y-162": 0.396,
    "y-163": 0.396,
    "y-164": 0.396,
    "y-165": 0.396,
    "y-166": 0.396,
    "y-167": 0.396,
    "y-168": 0.396,
    "y-169": 0.396,
    "y-170": 0.396,
    "y-171": 0.396,
    "y-172": 0.396,
    "y-173": 0.396,
    "y-174": 0.396,
    "y-175": 0.396,
    "y-176": 0.396,
    "y-177": 0.396,
    "y-178": 0.396,
    "y-179": 0.396,
    "y-180": 0.396,
    "y-181": 0.396,
    "y-182": 0.396,
    "y-183": 0.396,
    "y-184": 0.396,
    "y-185": 0.396,
    "y-186": 0.396,
    "y-187": 0.396,
    "y-188": 0.396,
    "y-189": 0.396,
    "y-190": 0.396,
    "y-191": 0.396,
    "y-192": 0.396,
    "y-193": 0.396,
    "y-194": 0.396,
    "y-195": 0.396,
    "y-196": 0.396,
    "y-197": 0.396,
    "y-198": 0.396,
    "y-199": 0.396,
    "y-200": 0.396,
    "y-201": 0.396,
    "y-202": 0.396,
    "y-203": 0.396,
    "y-204": 0.396,
    "y-205": 0.396,
    "y-206": 0.396,
    "y-207": 0.396,
    "y-208": 0.396,
    "y-209": 0.396,
    "y-210": 0.396,
    "y-211": 0.396,
    "y-212": 0.396,
    "y-213": 0.396,
    "y-214": 0.396,
    "y-215": 0.396,
    "y-216": 0.396,
    "y-217": 0.396,
    "y-218": 0.396,
    "y-219": 0.396,
    "y-220": 0.396,
    "y-221": 0.396,
    "y-222": 0.396,
    "y-223": 0.396,
    "y-224": 0.396,
    "y-225": 0.396,
    "y-226": 0.396,
    "y-227": 0.396,
    "y-228": 0.396,
    "y-229": 0.396,
    "y-230": 0.396,
    "y-231": 0.396,
    "y-232": 0.396,
    "y-233": 0.396,
    "y-234": 0.396,
    "y-235": 0.396,
    "y-236": 0.396,
    "y-237": 0.396,
    "y-238": 0.396,
    "y-239": 0.396,
    "y-240": 0.396,
    "y-241": 0.396,
    "y-242": 0.396,
    "y-243": 0.396,
    "y-244": 0.396,
    "y-245": 0.396,
    "y-246": 0.396,
    "y-247": 0.396,
    "y-248": 0.396,
    "y-249": 0.396,
    "y-250": 0.396,
    "y-251": 0.396,
    "y-252": 0.396,
    "y-253": 0.396,
    "y-254": 0.396,
    "y-255": 0.396,
  },
  {
    x: 1.625,
    "y-2": -0.209,
    "y-12": -0.273,
    "y-46": 1.126,
    "y-1000": 0.408,
    "y-0": -0.69,
    "y-1": -0.013,
    "y-3": -0.142,
    "y-4": -0.154,
    "y-5": -0.159,
    "y-6": -0.159,
    "y-7": -0.159,
    "y-8": -0.16,
    "y-9": -0.16,
    "y-10": -0.183,
    "y-11": -0.182,
    "y-13": -0.273,
    "y-14": -0.273,
    "y-15": -0.269,
    "y-16": -0.269,
    "y-17": 0.103,
    "y-18": 0.078,
    "y-19": 0.078,
    "y-20": 0.078,
    "y-21": 0.078,
    "y-22": 0.078,
    "y-23": 0.126,
    "y-24": 0.176,
    "y-25": 0.176,
    "y-26": 0.176,
    "y-27": 0.176,
    "y-28": 0.49,
    "y-29": 0.49,
    "y-30": 0.517,
    "y-31": 1.27,
    "y-32": 1.27,
    "y-33": 1.27,
    "y-34": 1.27,
    "y-35": 1.27,
    "y-36": 1.27,
    "y-37": 1.124,
    "y-38": 1.13,
    "y-39": 1.131,
    "y-40": 1.127,
    "y-41": 1.131,
    "y-42": 1.126,
    "y-43": 1.127,
    "y-44": 1.127,
    "y-45": 1.127,
    "y-47": 1.129,
    "y-48": 1.13,
    "y-49": 1.235,
    "y-50": 1.238,
    "y-51": 1.237,
    "y-52": 1.237,
    "y-53": 1.24,
    "y-54": 1.238,
    "y-55": 1.237,
    "y-56": 1.235,
    "y-57": 1.238,
    "y-58": 1.239,
    "y-59": 1.238,
    "y-60": 1.238,
    "y-61": 1.238,
    "y-62": 1.238,
    "y-63": 1.238,
    "y-64": 1.238,
    "y-65": 1.239,
    "y-66": 1.238,
    "y-67": 1.239,
    "y-68": 1.239,
    "y-69": 1.242,
    "y-70": 1.242,
    "y-71": 1.242,
    "y-72": 1.242,
    "y-73": 1.242,
    "y-74": 1.242,
    "y-75": 1.242,
    "y-76": 1.242,
    "y-77": 1.242,
    "y-78": 0.279,
    "y-79": 0.28,
    "y-80": 0.281,
    "y-81": 0.28,
    "y-82": 0.28,
    "y-83": 0.28,
    "y-84": 0.28,
    "y-85": 0.272,
    "y-86": 0.272,
    "y-87": 0.271,
    "y-88": 0.271,
    "y-89": 0.27,
    "y-90": 0.27,
    "y-91": 0.271,
    "y-92": 0.271,
    "y-93": 0.27,
    "y-94": 0.271,
    "y-95": 0.273,
    "y-96": 0.271,
    "y-97": 0.272,
    "y-98": 0.273,
    "y-99": 0.271,
    "y-100": 0.271,
    "y-101": 0.27,
    "y-102": 0.272,
    "y-103": 0.271,
    "y-104": 0.279,
    "y-105": 0.278,
    "y-106": 0.281,
    "y-107": 0.279,
    "y-108": 0.279,
    "y-109": 0.279,
    "y-110": 0.281,
    "y-111": 0.281,
    "y-112": 0.275,
    "y-113": 0.275,
    "y-114": 0.431,
    "y-115": 0.391,
    "y-116": 0.391,
    "y-117": 0.391,
    "y-118": 0.391,
    "y-119": 0.391,
    "y-120": 0.39,
    "y-121": 0.39,
    "y-122": 0.39,
    "y-123": 0.39,
    "y-124": 0.39,
    "y-125": 0.369,
    "y-126": 0.369,
    "y-127": 0.369,
    "y-128": 0.37,
    "y-129": 0.37,
    "y-130": 0.37,
    "y-131": 0.37,
    "y-132": 0.37,
    "y-133": 0.37,
    "y-134": 0.37,
    "y-135": 0.369,
    "y-136": 0.369,
    "y-137": 0.369,
    "y-138": 0.369,
    "y-139": 0.369,
    "y-140": 0.369,
    "y-141": 0.369,
    "y-142": 0.369,
    "y-143": 0.369,
    "y-144": 0.337,
    "y-145": 0.337,
    "y-146": 0.337,
    "y-147": 0.337,
    "y-148": 0.337,
    "y-149": 0.337,
    "y-150": 0.339,
    "y-151": 0.317,
    "y-152": 0.271,
    "y-153": 0.271,
    "y-154": 0.271,
    "y-155": 0.271,
    "y-156": 0.271,
    "y-157": 0.271,
    "y-158": 0.271,
    "y-159": 0.271,
    "y-160": 0.271,
    "y-161": 0.295,
    "y-162": 0.296,
    "y-163": 0.296,
    "y-164": 0.315,
    "y-165": 0.315,
    "y-166": 0.326,
    "y-167": 0.326,
    "y-168": 0.326,
    "y-169": 0.326,
    "y-170": 0.326,
    "y-171": 0.326,
    "y-172": 0.326,
    "y-173": 0.326,
    "y-174": 0.316,
    "y-175": 0.316,
    "y-176": 0.316,
    "y-177": 0.315,
    "y-178": 0.315,
    "y-179": 0.315,
    "y-180": 0.315,
    "y-181": 0.315,
    "y-182": 0.315,
    "y-183": 0.349,
    "y-184": 0.349,
    "y-185": 0.349,
    "y-186": 0.349,
    "y-187": 0.349,
    "y-188": 0.349,
    "y-189": 0.35,
    "y-190": 0.35,
    "y-191": 0.35,
    "y-192": 0.35,
    "y-193": 0.35,
    "y-194": 0.35,
    "y-195": 0.35,
    "y-196": 0.35,
    "y-197": 0.351,
    "y-198": 0.351,
    "y-199": 0.351,
    "y-200": 0.351,
    "y-201": 0.351,
    "y-202": 0.351,
    "y-203": 0.351,
    "y-204": 0.351,
    "y-205": 0.346,
    "y-206": 0.346,
    "y-207": 0.346,
    "y-208": 0.347,
    "y-209": 0.347,
    "y-210": 0.347,
    "y-211": 0.347,
    "y-212": 0.347,
    "y-213": 0.347,
    "y-214": 0.347,
    "y-215": 0.347,
    "y-216": 0.347,
    "y-217": 0.347,
    "y-218": 0.347,
    "y-219": 0.347,
    "y-220": 0.347,
    "y-221": 0.347,
    "y-222": 0.347,
    "y-223": 0.347,
    "y-224": 0.347,
    "y-225": 0.347,
    "y-226": 0.347,
    "y-227": 0.347,
    "y-228": 0.347,
    "y-229": 0.347,
    "y-230": 0.347,
    "y-231": 0.347,
    "y-232": 0.347,
    "y-233": 0.347,
    "y-234": 0.347,
    "y-235": 0.347,
    "y-236": 0.347,
    "y-237": 0.347,
    "y-238": 0.347,
    "y-239": 0.347,
    "y-240": 0.347,
    "y-241": 0.347,
    "y-242": 0.347,
    "y-243": 0.347,
    "y-244": 0.343,
    "y-245": 0.343,
    "y-246": 0.342,
    "y-247": 0.342,
    "y-248": 0.342,
    "y-249": 0.342,
    "y-250": 0.342,
    "y-251": 0.343,
    "y-252": 0.343,
    "y-253": 0.343,
    "y-254": 0.343,
    "y-255": 0.343,
  },
  {
    x: 1.65,
    "y-2": -0.078,
    "y-12": -0.157,
    "y-46": 1.856,
    "y-1000": 0.219,
    "y-0": -0.702,
    "y-1": 0.087,
    "y-3": -0.021,
    "y-4": -0.031,
    "y-5": -0.035,
    "y-6": -0.035,
    "y-7": -0.036,
    "y-8": -0.036,
    "y-9": -0.036,
    "y-10": -0.055,
    "y-11": -0.055,
    "y-13": -0.157,
    "y-14": -0.157,
    "y-15": -0.15,
    "y-16": -0.15,
    "y-17": 0.257,
    "y-18": 0.225,
    "y-19": 0.225,
    "y-20": 0.225,
    "y-21": 0.225,
    "y-22": 0.225,
    "y-23": 0.285,
    "y-24": 0.34,
    "y-25": 0.34,
    "y-26": 0.34,
    "y-27": 0.34,
    "y-28": 0.749,
    "y-29": 0.749,
    "y-30": 0.782,
    "y-31": 2.145,
    "y-32": 2.145,
    "y-33": 2.145,
    "y-34": 2.145,
    "y-35": 2.145,
    "y-36": 2.145,
    "y-37": 1.852,
    "y-38": 1.864,
    "y-39": 1.866,
    "y-40": 1.858,
    "y-41": 1.866,
    "y-42": 1.857,
    "y-43": 1.858,
    "y-44": 1.858,
    "y-45": 1.858,
    "y-47": 1.863,
    "y-48": 1.864,
    "y-49": 2.074,
    "y-50": 2.08,
    "y-51": 2.078,
    "y-52": 2.079,
    "y-53": 2.084,
    "y-54": 2.08,
    "y-55": 2.078,
    "y-56": 2.073,
    "y-57": 2.08,
    "y-58": 2.082,
    "y-59": 2.081,
    "y-60": 2.081,
    "y-61": 2.081,
    "y-62": 2.081,
    "y-63": 2.081,
    "y-64": 2.081,
    "y-65": 2.082,
    "y-66": 2.081,
    "y-67": 2.082,
    "y-68": 2.082,
    "y-69": 2.088,
    "y-70": 2.088,
    "y-71": 2.088,
    "y-72": 2.088,
    "y-73": 2.088,
    "y-74": 2.088,
    "y-75": 2.088,
    "y-76": 2.088,
    "y-77": 2.088,
    "y-78": 0.162,
    "y-79": 0.165,
    "y-80": 0.165,
    "y-81": 0.165,
    "y-82": 0.165,
    "y-83": 0.164,
    "y-84": 0.165,
    "y-85": 0.148,
    "y-86": 0.147,
    "y-87": 0.146,
    "y-88": 0.147,
    "y-89": 0.145,
    "y-90": 0.145,
    "y-91": 0.146,
    "y-92": 0.147,
    "y-93": 0.145,
    "y-94": 0.147,
    "y-95": 0.149,
    "y-96": 0.147,
    "y-97": 0.148,
    "y-98": 0.149,
    "y-99": 0.146,
    "y-100": 0.147,
    "y-101": 0.144,
    "y-102": 0.148,
    "y-103": 0.147,
    "y-104": 0.162,
    "y-105": 0.16,
    "y-106": 0.166,
    "y-107": 0.162,
    "y-108": 0.162,
    "y-109": 0.162,
    "y-110": 0.166,
    "y-111": 0.166,
    "y-112": 0.155,
    "y-113": 0.155,
    "y-114": 0.307,
    "y-115": 0.254,
    "y-116": 0.254,
    "y-117": 0.254,
    "y-118": 0.254,
    "y-119": 0.255,
    "y-120": 0.253,
    "y-121": 0.252,
    "y-122": 0.253,
    "y-123": 0.253,
    "y-124": 0.253,
    "y-125": 0.226,
    "y-126": 0.226,
    "y-127": 0.226,
    "y-128": 0.226,
    "y-129": 0.226,
    "y-130": 0.226,
    "y-131": 0.226,
    "y-132": 0.226,
    "y-133": 0.226,
    "y-134": 0.226,
    "y-135": 0.226,
    "y-136": 0.226,
    "y-137": 0.226,
    "y-138": 0.226,
    "y-139": 0.226,
    "y-140": 0.225,
    "y-141": 0.225,
    "y-142": 0.225,
    "y-143": 0.225,
    "y-144": 0.182,
    "y-145": 0.182,
    "y-146": 0.182,
    "y-147": 0.182,
    "y-148": 0.182,
    "y-149": 0.182,
    "y-150": 0.186,
    "y-151": 0.157,
    "y-152": 0.094,
    "y-153": 0.094,
    "y-154": 0.094,
    "y-155": 0.094,
    "y-156": 0.094,
    "y-157": 0.094,
    "y-158": 0.094,
    "y-159": 0.094,
    "y-160": 0.094,
    "y-161": 0.138,
    "y-162": 0.139,
    "y-163": 0.139,
    "y-164": 0.174,
    "y-165": 0.174,
    "y-166": 0.194,
    "y-167": 0.194,
    "y-168": 0.194,
    "y-169": 0.194,
    "y-170": 0.194,
    "y-171": 0.194,
    "y-172": 0.194,
    "y-173": 0.194,
    "y-174": 0.18,
    "y-175": 0.18,
    "y-176": 0.18,
    "y-177": 0.178,
    "y-178": 0.178,
    "y-179": 0.178,
    "y-180": 0.178,
    "y-181": 0.178,
    "y-182": 0.178,
    "y-183": 0.185,
    "y-184": 0.185,
    "y-185": 0.185,
    "y-186": 0.186,
    "y-187": 0.186,
    "y-188": 0.186,
    "y-189": 0.187,
    "y-190": 0.187,
    "y-191": 0.187,
    "y-192": 0.187,
    "y-193": 0.187,
    "y-194": 0.187,
    "y-195": 0.187,
    "y-196": 0.187,
    "y-197": 0.188,
    "y-198": 0.188,
    "y-199": 0.188,
    "y-200": 0.188,
    "y-201": 0.188,
    "y-202": 0.188,
    "y-203": 0.188,
    "y-204": 0.188,
    "y-205": 0.183,
    "y-206": 0.183,
    "y-207": 0.183,
    "y-208": 0.184,
    "y-209": 0.184,
    "y-210": 0.184,
    "y-211": 0.183,
    "y-212": 0.183,
    "y-213": 0.183,
    "y-214": 0.183,
    "y-215": 0.183,
    "y-216": 0.183,
    "y-217": 0.183,
    "y-218": 0.183,
    "y-219": 0.183,
    "y-220": 0.183,
    "y-221": 0.183,
    "y-222": 0.183,
    "y-223": 0.183,
    "y-224": 0.183,
    "y-225": 0.184,
    "y-226": 0.184,
    "y-227": 0.184,
    "y-228": 0.184,
    "y-229": 0.184,
    "y-230": 0.184,
    "y-231": 0.184,
    "y-232": 0.184,
    "y-233": 0.184,
    "y-234": 0.184,
    "y-235": 0.184,
    "y-236": 0.185,
    "y-237": 0.185,
    "y-238": 0.185,
    "y-239": 0.185,
    "y-240": 0.185,
    "y-241": 0.185,
    "y-242": 0.185,
    "y-243": 0.185,
    "y-244": 0.18,
    "y-245": 0.18,
    "y-246": 0.179,
    "y-247": 0.179,
    "y-248": 0.179,
    "y-249": 0.179,
    "y-250": 0.179,
    "y-251": 0.18,
    "y-252": 0.18,
    "y-253": 0.18,
    "y-254": 0.18,
    "y-255": 0.18,
  },
  {
    x: 1.675,
    "y-2": 0.054,
    "y-12": -0.041,
    "y-46": 2.586,
    "y-1000": -0.029,
    "y-0": -0.714,
    "y-1": 0.187,
    "y-3": 0.1,
    "y-4": 0.091,
    "y-5": 0.088,
    "y-6": 0.088,
    "y-7": 0.088,
    "y-8": 0.087,
    "y-9": 0.087,
    "y-10": 0.072,
    "y-11": 0.072,
    "y-13": -0.041,
    "y-14": -0.041,
    "y-15": -0.032,
    "y-16": -0.032,
    "y-17": 0.411,
    "y-18": 0.373,
    "y-19": 0.373,
    "y-20": 0.373,
    "y-21": 0.373,
    "y-22": 0.373,
    "y-23": 0.444,
    "y-24": 0.505,
    "y-25": 0.505,
    "y-26": 0.505,
    "y-27": 0.505,
    "y-28": 1.009,
    "y-29": 1.009,
    "y-30": 1.046,
    "y-31": 3.02,
    "y-32": 3.02,
    "y-33": 3.02,
    "y-34": 3.02,
    "y-35": 3.02,
    "y-36": 3.02,
    "y-37": 2.58,
    "y-38": 2.598,
    "y-39": 2.601,
    "y-40": 2.589,
    "y-41": 2.601,
    "y-42": 2.587,
    "y-43": 2.589,
    "y-44": 2.59,
    "y-45": 2.589,
    "y-47": 2.597,
    "y-48": 2.598,
    "y-49": 1.867,
    "y-50": 1.865,
    "y-51": 1.863,
    "y-52": 1.876,
    "y-53": 1.87,
    "y-54": 1.856,
    "y-55": 1.868,
    "y-56": 1.856,
    "y-57": 1.861,
    "y-58": 1.879,
    "y-59": 1.877,
    "y-60": 1.873,
    "y-61": 1.876,
    "y-62": 1.875,
    "y-63": 1.875,
    "y-64": 1.875,
    "y-65": 1.877,
    "y-66": 1.874,
    "y-67": 1.878,
    "y-68": 1.878,
    "y-69": 1.838,
    "y-70": 1.838,
    "y-71": 1.837,
    "y-72": 1.84,
    "y-73": 1.839,
    "y-74": 1.839,
    "y-75": 1.838,
    "y-76": 1.838,
    "y-77": 1.839,
    "y-78": -0.023,
    "y-79": -0.018,
    "y-80": -0.018,
    "y-81": -0.018,
    "y-82": -0.018,
    "y-83": -0.02,
    "y-84": -0.019,
    "y-85": -0.033,
    "y-86": -0.035,
    "y-87": -0.038,
    "y-88": -0.035,
    "y-89": -0.038,
    "y-90": -0.039,
    "y-91": -0.037,
    "y-92": -0.036,
    "y-93": -0.039,
    "y-94": -0.036,
    "y-95": -0.032,
    "y-96": -0.036,
    "y-97": -0.035,
    "y-98": -0.033,
    "y-99": -0.037,
    "y-100": -0.035,
    "y-101": -0.038,
    "y-102": -0.034,
    "y-103": -0.036,
    "y-104": -0.017,
    "y-105": -0.018,
    "y-106": -0.011,
    "y-107": -0.017,
    "y-108": -0.016,
    "y-109": -0.016,
    "y-110": -0.012,
    "y-111": -0.011,
    "y-112": -0.022,
    "y-113": -0.023,
    "y-114": -0.003,
    "y-115": -0.033,
    "y-116": -0.034,
    "y-117": -0.034,
    "y-118": -0.033,
    "y-119": -0.032,
    "y-120": -0.034,
    "y-121": -0.034,
    "y-122": -0.033,
    "y-123": -0.034,
    "y-124": -0.034,
    "y-125": -0.049,
    "y-126": -0.049,
    "y-127": -0.049,
    "y-128": -0.049,
    "y-129": -0.049,
    "y-130": -0.049,
    "y-131": -0.049,
    "y-132": -0.049,
    "y-133": -0.049,
    "y-134": -0.049,
    "y-135": -0.049,
    "y-136": -0.049,
    "y-137": -0.049,
    "y-138": -0.049,
    "y-139": -0.049,
    "y-140": -0.05,
    "y-141": -0.05,
    "y-142": -0.05,
    "y-143": -0.05,
    "y-144": -0.074,
    "y-145": -0.074,
    "y-146": -0.074,
    "y-147": -0.074,
    "y-148": -0.074,
    "y-149": -0.074,
    "y-150": -0.07,
    "y-151": -0.086,
    "y-152": -0.123,
    "y-153": -0.123,
    "y-154": -0.123,
    "y-155": -0.123,
    "y-156": -0.123,
    "y-157": -0.123,
    "y-158": -0.123,
    "y-159": -0.123,
    "y-160": -0.123,
    "y-161": -0.072,
    "y-162": -0.071,
    "y-163": -0.071,
    "y-164": -0.031,
    "y-165": -0.031,
    "y-166": -0.009,
    "y-167": -0.009,
    "y-168": -0.009,
    "y-169": -0.009,
    "y-170": -0.009,
    "y-171": -0.009,
    "y-172": -0.009,
    "y-173": -0.009,
    "y-174": -0.019,
    "y-175": -0.019,
    "y-176": -0.019,
    "y-177": -0.02,
    "y-178": -0.02,
    "y-179": -0.02,
    "y-180": -0.02,
    "y-181": -0.02,
    "y-182": -0.02,
    "y-183": -0.024,
    "y-184": -0.024,
    "y-185": -0.024,
    "y-186": -0.024,
    "y-187": -0.024,
    "y-188": -0.024,
    "y-189": -0.022,
    "y-190": -0.022,
    "y-191": -0.022,
    "y-192": -0.022,
    "y-193": -0.022,
    "y-194": -0.022,
    "y-195": -0.022,
    "y-196": -0.022,
    "y-197": -0.021,
    "y-198": -0.021,
    "y-199": -0.021,
    "y-200": -0.021,
    "y-201": -0.021,
    "y-202": -0.021,
    "y-203": -0.021,
    "y-204": -0.021,
    "y-205": -0.024,
    "y-206": -0.024,
    "y-207": -0.024,
    "y-208": -0.024,
    "y-209": -0.024,
    "y-210": -0.024,
    "y-211": -0.024,
    "y-212": -0.024,
    "y-213": -0.024,
    "y-214": -0.024,
    "y-215": -0.024,
    "y-216": -0.024,
    "y-217": -0.024,
    "y-218": -0.024,
    "y-219": -0.024,
    "y-220": -0.024,
    "y-221": -0.024,
    "y-222": -0.024,
    "y-223": -0.024,
    "y-224": -0.024,
    "y-225": -0.023,
    "y-226": -0.023,
    "y-227": -0.023,
    "y-228": -0.023,
    "y-229": -0.023,
    "y-230": -0.023,
    "y-231": -0.023,
    "y-232": -0.023,
    "y-233": -0.023,
    "y-234": -0.023,
    "y-235": -0.023,
    "y-236": -0.023,
    "y-237": -0.023,
    "y-238": -0.023,
    "y-239": -0.023,
    "y-240": -0.023,
    "y-241": -0.023,
    "y-242": -0.023,
    "y-243": -0.023,
    "y-244": -0.025,
    "y-245": -0.025,
    "y-246": -0.026,
    "y-247": -0.026,
    "y-248": -0.026,
    "y-249": -0.026,
    "y-250": -0.026,
    "y-251": -0.026,
    "y-252": -0.026,
    "y-253": -0.026,
    "y-254": -0.026,
    "y-255": -0.026,
  },
  {
    x: 1.7,
    "y-2": 0.185,
    "y-12": 0.1,
    "y-46": -0.187,
    "y-1000": -0.187,
    "y-0": -0.726,
    "y-1": 0.287,
    "y-3": 0.22,
    "y-4": 0.214,
    "y-5": 0.212,
    "y-6": 0.211,
    "y-7": 0.211,
    "y-8": 0.211,
    "y-9": 0.211,
    "y-10": 0.199,
    "y-11": 0.199,
    "y-13": 0.1,
    "y-14": 0.1,
    "y-15": 0.109,
    "y-16": 0.109,
    "y-17": -0.054,
    "y-18": -0.064,
    "y-19": -0.064,
    "y-20": -0.064,
    "y-21": -0.064,
    "y-22": -0.064,
    "y-23": -0.046,
    "y-24": -0.16,
    "y-25": -0.16,
    "y-26": -0.16,
    "y-27": -0.16,
    "y-28": -0.147,
    "y-29": -0.147,
    "y-30": -0.187,
    "y-31": -0.187,
    "y-32": -0.187,
    "y-33": -0.187,
    "y-34": -0.187,
    "y-35": -0.187,
    "y-36": -0.187,
    "y-37": -0.187,
    "y-38": -0.187,
    "y-39": -0.187,
    "y-40": -0.187,
    "y-41": -0.187,
    "y-42": -0.187,
    "y-43": -0.187,
    "y-44": -0.187,
    "y-45": -0.187,
    "y-47": -0.187,
    "y-48": -0.187,
    "y-49": -0.187,
    "y-50": -0.187,
    "y-51": -0.187,
    "y-52": -0.187,
    "y-53": -0.187,
    "y-54": -0.187,
    "y-55": -0.187,
    "y-56": -0.187,
    "y-57": -0.187,
    "y-58": -0.187,
    "y-59": -0.187,
    "y-60": -0.187,
    "y-61": -0.187,
    "y-62": -0.187,
    "y-63": -0.187,
    "y-64": -0.187,
    "y-65": -0.187,
    "y-66": -0.187,
    "y-67": -0.187,
    "y-68": -0.187,
    "y-69": -0.187,
    "y-70": -0.187,
    "y-71": -0.187,
    "y-72": -0.187,
    "y-73": -0.187,
    "y-74": -0.187,
    "y-75": -0.187,
    "y-76": -0.187,
    "y-77": -0.187,
    "y-78": -0.187,
    "y-79": -0.187,
    "y-80": -0.187,
    "y-81": -0.187,
    "y-82": -0.187,
    "y-83": -0.187,
    "y-84": -0.187,
    "y-85": -0.187,
    "y-86": -0.187,
    "y-87": -0.187,
    "y-88": -0.187,
    "y-89": -0.187,
    "y-90": -0.187,
    "y-91": -0.187,
    "y-92": -0.187,
    "y-93": -0.187,
    "y-94": -0.187,
    "y-95": -0.187,
    "y-96": -0.187,
    "y-97": -0.187,
    "y-98": -0.187,
    "y-99": -0.187,
    "y-100": -0.187,
    "y-101": -0.187,
    "y-102": -0.187,
    "y-103": -0.187,
    "y-104": -0.187,
    "y-105": -0.187,
    "y-106": -0.187,
    "y-107": -0.187,
    "y-108": -0.187,
    "y-109": -0.187,
    "y-110": -0.187,
    "y-111": -0.187,
    "y-112": -0.187,
    "y-113": -0.187,
    "y-114": -0.187,
    "y-115": -0.187,
    "y-116": -0.187,
    "y-117": -0.187,
    "y-118": -0.187,
    "y-119": -0.187,
    "y-120": -0.187,
    "y-121": -0.187,
    "y-122": -0.187,
    "y-123": -0.187,
    "y-124": -0.187,
    "y-125": -0.187,
    "y-126": -0.187,
    "y-127": -0.187,
    "y-128": -0.187,
    "y-129": -0.187,
    "y-130": -0.187,
    "y-131": -0.187,
    "y-132": -0.187,
    "y-133": -0.187,
    "y-134": -0.187,
    "y-135": -0.187,
    "y-136": -0.187,
    "y-137": -0.187,
    "y-138": -0.187,
    "y-139": -0.187,
    "y-140": -0.187,
    "y-141": -0.187,
    "y-142": -0.187,
    "y-143": -0.187,
    "y-144": -0.187,
    "y-145": -0.187,
    "y-146": -0.187,
    "y-147": -0.187,
    "y-148": -0.187,
    "y-149": -0.187,
    "y-150": -0.187,
    "y-151": -0.187,
    "y-152": -0.187,
    "y-153": -0.187,
    "y-154": -0.187,
    "y-155": -0.187,
    "y-156": -0.187,
    "y-157": -0.187,
    "y-158": -0.187,
    "y-159": -0.187,
    "y-160": -0.187,
    "y-161": -0.187,
    "y-162": -0.187,
    "y-163": -0.187,
    "y-164": -0.187,
    "y-165": -0.187,
    "y-166": -0.187,
    "y-167": -0.187,
    "y-168": -0.187,
    "y-169": -0.187,
    "y-170": -0.187,
    "y-171": -0.187,
    "y-172": -0.187,
    "y-173": -0.187,
    "y-174": -0.187,
    "y-175": -0.187,
    "y-176": -0.187,
    "y-177": -0.187,
    "y-178": -0.187,
    "y-179": -0.187,
    "y-180": -0.187,
    "y-181": -0.187,
    "y-182": -0.187,
    "y-183": -0.187,
    "y-184": -0.187,
    "y-185": -0.187,
    "y-186": -0.187,
    "y-187": -0.187,
    "y-188": -0.187,
    "y-189": -0.187,
    "y-190": -0.187,
    "y-191": -0.187,
    "y-192": -0.187,
    "y-193": -0.187,
    "y-194": -0.187,
    "y-195": -0.187,
    "y-196": -0.187,
    "y-197": -0.187,
    "y-198": -0.187,
    "y-199": -0.187,
    "y-200": -0.187,
    "y-201": -0.187,
    "y-202": -0.187,
    "y-203": -0.187,
    "y-204": -0.187,
    "y-205": -0.187,
    "y-206": -0.187,
    "y-207": -0.187,
    "y-208": -0.187,
    "y-209": -0.187,
    "y-210": -0.187,
    "y-211": -0.187,
    "y-212": -0.187,
    "y-213": -0.187,
    "y-214": -0.187,
    "y-215": -0.187,
    "y-216": -0.187,
    "y-217": -0.187,
    "y-218": -0.187,
    "y-219": -0.187,
    "y-220": -0.187,
    "y-221": -0.187,
    "y-222": -0.187,
    "y-223": -0.187,
    "y-224": -0.187,
    "y-225": -0.187,
    "y-226": -0.187,
    "y-227": -0.187,
    "y-228": -0.187,
    "y-229": -0.187,
    "y-230": -0.187,
    "y-231": -0.187,
    "y-232": -0.187,
    "y-233": -0.187,
    "y-234": -0.187,
    "y-235": -0.187,
    "y-236": -0.187,
    "y-237": -0.187,
    "y-238": -0.187,
    "y-239": -0.187,
    "y-240": -0.187,
    "y-241": -0.187,
    "y-242": -0.187,
    "y-243": -0.187,
    "y-244": -0.187,
    "y-245": -0.187,
    "y-246": -0.187,
    "y-247": -0.187,
    "y-248": -0.187,
    "y-249": -0.187,
    "y-250": -0.187,
    "y-251": -0.187,
    "y-252": -0.187,
    "y-253": -0.187,
    "y-254": -0.187,
    "y-255": -0.187,
  },
  {
    x: 1.725,
    "y-2": 0.317,
    "y-12": 0.244,
    "y-46": -1.954,
    "y-1000": -0.148,
    "y-0": -0.739,
    "y-1": 0.387,
    "y-3": 0.341,
    "y-4": 0.337,
    "y-5": 0.335,
    "y-6": 0.335,
    "y-7": 0.335,
    "y-8": 0.335,
    "y-9": 0.335,
    "y-10": 0.326,
    "y-11": 0.327,
    "y-13": 0.244,
    "y-14": 0.244,
    "y-15": 0.251,
    "y-16": 0.251,
    "y-17": -0.325,
    "y-18": -0.314,
    "y-19": -0.314,
    "y-20": -0.314,
    "y-21": -0.314,
    "y-22": -0.314,
    "y-23": -0.334,
    "y-24": -0.544,
    "y-25": -0.544,
    "y-26": -0.544,
    "y-27": -0.544,
    "y-28": -0.858,
    "y-29": -0.858,
    "y-30": -0.935,
    "y-31": -2.242,
    "y-32": -2.242,
    "y-33": -2.242,
    "y-34": -2.242,
    "y-35": -2.242,
    "y-36": -2.242,
    "y-37": -1.951,
    "y-38": -1.962,
    "y-39": -1.964,
    "y-40": -1.956,
    "y-41": -1.964,
    "y-42": -1.955,
    "y-43": -1.956,
    "y-44": -1.957,
    "y-45": -1.956,
    "y-47": -1.961,
    "y-48": -1.962,
    "y-49": -1.358,
    "y-50": -1.356,
    "y-51": -1.355,
    "y-52": -1.365,
    "y-53": -1.359,
    "y-54": -1.349,
    "y-55": -1.359,
    "y-56": -1.35,
    "y-57": -1.353,
    "y-58": -1.425,
    "y-59": -1.424,
    "y-60": -1.42,
    "y-61": -1.422,
    "y-62": -1.422,
    "y-63": -1.422,
    "y-64": -1.422,
    "y-65": -1.423,
    "y-66": -1.422,
    "y-67": -1.431,
    "y-68": -1.431,
    "y-69": -1.224,
    "y-70": -1.225,
    "y-71": -1.222,
    "y-72": -1.225,
    "y-73": -1.226,
    "y-74": -1.224,
    "y-75": -1.224,
    "y-76": -1.223,
    "y-77": -1.225,
    "y-78": -0.184,
    "y-79": -0.187,
    "y-80": -0.187,
    "y-81": -0.187,
    "y-82": -0.188,
    "y-83": -0.186,
    "y-84": -0.187,
    "y-85": -0.179,
    "y-86": -0.178,
    "y-87": -0.176,
    "y-88": -0.177,
    "y-89": -0.177,
    "y-90": -0.175,
    "y-91": -0.177,
    "y-92": -0.178,
    "y-93": -0.175,
    "y-94": -0.178,
    "y-95": -0.18,
    "y-96": -0.177,
    "y-97": -0.179,
    "y-98": -0.179,
    "y-99": -0.176,
    "y-100": -0.178,
    "y-101": -0.176,
    "y-102": -0.179,
    "y-103": -0.177,
    "y-104": -0.212,
    "y-105": -0.211,
    "y-106": -0.216,
    "y-107": -0.212,
    "y-108": -0.213,
    "y-109": -0.213,
    "y-110": -0.219,
    "y-111": -0.219,
    "y-112": -0.212,
    "y-113": -0.212,
    "y-114": -0.212,
    "y-115": -0.194,
    "y-116": -0.194,
    "y-117": -0.194,
    "y-118": -0.194,
    "y-119": -0.195,
    "y-120": -0.194,
    "y-121": -0.194,
    "y-122": -0.194,
    "y-123": -0.194,
    "y-124": -0.194,
    "y-125": -0.185,
    "y-126": -0.185,
    "y-127": -0.185,
    "y-128": -0.185,
    "y-129": -0.185,
    "y-130": -0.185,
    "y-131": -0.185,
    "y-132": -0.185,
    "y-133": -0.185,
    "y-134": -0.185,
    "y-135": -0.185,
    "y-136": -0.185,
    "y-137": -0.185,
    "y-138": -0.185,
    "y-139": -0.185,
    "y-140": -0.184,
    "y-141": -0.184,
    "y-142": -0.184,
    "y-143": -0.184,
    "y-144": -0.17,
    "y-145": -0.17,
    "y-146": -0.17,
    "y-147": -0.17,
    "y-148": -0.17,
    "y-149": -0.17,
    "y-150": -0.177,
    "y-151": -0.167,
    "y-152": -0.145,
    "y-153": -0.145,
    "y-154": -0.145,
    "y-155": -0.145,
    "y-156": -0.145,
    "y-157": -0.145,
    "y-158": -0.145,
    "y-159": -0.145,
    "y-160": -0.145,
    "y-161": -0.147,
    "y-162": -0.149,
    "y-163": -0.149,
    "y-164": -0.128,
    "y-165": -0.128,
    "y-166": -0.111,
    "y-167": -0.111,
    "y-168": -0.111,
    "y-169": -0.111,
    "y-170": -0.11,
    "y-171": -0.11,
    "y-172": -0.11,
    "y-173": -0.11,
    "y-174": -0.108,
    "y-175": -0.109,
    "y-176": -0.109,
    "y-177": -0.108,
    "y-178": -0.108,
    "y-179": -0.108,
    "y-180": -0.108,
    "y-181": -0.108,
    "y-182": -0.109,
    "y-183": -0.107,
    "y-184": -0.108,
    "y-185": -0.108,
    "y-186": -0.109,
    "y-187": -0.109,
    "y-188": -0.109,
    "y-189": -0.114,
    "y-190": -0.114,
    "y-191": -0.114,
    "y-192": -0.114,
    "y-193": -0.114,
    "y-194": -0.114,
    "y-195": -0.114,
    "y-196": -0.114,
    "y-197": -0.115,
    "y-198": -0.115,
    "y-199": -0.115,
    "y-200": -0.115,
    "y-201": -0.115,
    "y-202": -0.115,
    "y-203": -0.115,
    "y-204": -0.115,
    "y-205": -0.114,
    "y-206": -0.114,
    "y-207": -0.114,
    "y-208": -0.116,
    "y-209": -0.116,
    "y-210": -0.116,
    "y-211": -0.115,
    "y-212": -0.115,
    "y-213": -0.115,
    "y-214": -0.115,
    "y-215": -0.115,
    "y-216": -0.115,
    "y-217": -0.115,
    "y-218": -0.115,
    "y-219": -0.115,
    "y-220": -0.115,
    "y-221": -0.115,
    "y-222": -0.115,
    "y-223": -0.115,
    "y-224": -0.115,
    "y-225": -0.117,
    "y-226": -0.117,
    "y-227": -0.117,
    "y-228": -0.117,
    "y-229": -0.117,
    "y-230": -0.117,
    "y-231": -0.117,
    "y-232": -0.117,
    "y-233": -0.117,
    "y-234": -0.118,
    "y-235": -0.118,
    "y-236": -0.119,
    "y-237": -0.119,
    "y-238": -0.119,
    "y-239": -0.119,
    "y-240": -0.119,
    "y-241": -0.119,
    "y-242": -0.119,
    "y-243": -0.119,
    "y-244": -0.118,
    "y-245": -0.118,
    "y-246": -0.118,
    "y-247": -0.118,
    "y-248": -0.118,
    "y-249": -0.118,
    "y-250": -0.118,
    "y-251": -0.119,
    "y-252": -0.119,
    "y-253": -0.119,
    "y-254": -0.119,
    "y-255": -0.119,
  },
  {
    x: 1.75,
    "y-2": 0.448,
    "y-12": 0.387,
    "y-46": -1.159,
    "y-1000": 0.003,
    "y-0": -0.751,
    "y-1": 0.487,
    "y-3": 0.462,
    "y-4": 0.459,
    "y-5": 0.458,
    "y-6": 0.458,
    "y-7": 0.458,
    "y-8": 0.458,
    "y-9": 0.458,
    "y-10": 0.454,
    "y-11": 0.454,
    "y-13": 0.387,
    "y-14": 0.387,
    "y-15": 0.394,
    "y-16": 0.394,
    "y-17": -0.111,
    "y-18": -0.102,
    "y-19": -0.102,
    "y-20": -0.102,
    "y-21": -0.102,
    "y-22": -0.102,
    "y-23": -0.119,
    "y-24": -0.239,
    "y-25": -0.239,
    "y-26": -0.239,
    "y-27": -0.239,
    "y-28": -0.458,
    "y-29": -0.458,
    "y-30": -0.479,
    "y-31": -1.351,
    "y-32": -1.351,
    "y-33": -1.351,
    "y-34": -1.351,
    "y-35": -1.351,
    "y-36": -1.351,
    "y-37": -1.156,
    "y-38": -1.164,
    "y-39": -1.166,
    "y-40": -1.16,
    "y-41": -1.165,
    "y-42": -1.159,
    "y-43": -1.16,
    "y-44": -1.16,
    "y-45": -1.16,
    "y-47": -1.163,
    "y-48": -1.164,
    "y-49": -0.762,
    "y-50": -0.76,
    "y-51": -0.759,
    "y-52": -0.766,
    "y-53": -0.762,
    "y-54": -0.756,
    "y-55": -0.762,
    "y-56": -0.756,
    "y-57": -0.758,
    "y-58": -0.997,
    "y-59": -0.997,
    "y-60": -0.991,
    "y-61": -0.994,
    "y-62": -0.995,
    "y-63": -0.992,
    "y-64": -0.993,
    "y-65": -0.995,
    "y-66": -0.994,
    "y-67": -1.023,
    "y-68": -1.023,
    "y-69": -0.852,
    "y-70": -0.853,
    "y-71": -0.85,
    "y-72": -0.853,
    "y-73": -0.853,
    "y-74": -0.853,
    "y-75": -0.853,
    "y-76": -0.852,
    "y-77": -0.854,
    "y-78": -0.002,
    "y-79": -0.005,
    "y-80": -0.007,
    "y-81": -0.004,
    "y-82": -0.006,
    "y-83": -0.003,
    "y-84": -0.005,
    "y-85": 0.003,
    "y-86": 0.002,
    "y-87": 0.004,
    "y-88": 0.003,
    "y-89": 0.003,
    "y-90": 0.004,
    "y-91": 0.001,
    "y-92": 0.001,
    "y-93": 0.005,
    "y-94": 0.003,
    "y-95": 0.002,
    "y-96": 0.004,
    "y-97": 0.003,
    "y-98": 0.0,
    "y-99": 0.004,
    "y-100": 0.003,
    "y-101": 0.004,
    "y-102": 0.002,
    "y-103": 0.005,
    "y-104": -0.055,
    "y-105": -0.056,
    "y-106": -0.056,
    "y-107": -0.055,
    "y-108": -0.055,
    "y-109": -0.056,
    "y-110": -0.067,
    "y-111": -0.067,
    "y-112": -0.059,
    "y-113": -0.059,
    "y-114": -0.059,
    "y-115": -0.041,
    "y-116": -0.041,
    "y-117": -0.041,
    "y-118": -0.042,
    "y-119": -0.042,
    "y-120": -0.041,
    "y-121": -0.041,
    "y-122": -0.041,
    "y-123": -0.041,
    "y-124": -0.041,
    "y-125": -0.032,
    "y-126": -0.032,
    "y-127": -0.032,
    "y-128": -0.032,
    "y-129": -0.032,
    "y-130": -0.032,
    "y-131": -0.032,
    "y-132": -0.032,
    "y-133": -0.032,
    "y-134": -0.032,
    "y-135": -0.032,
    "y-136": -0.032,
    "y-137": -0.032,
    "y-138": -0.032,
    "y-139": -0.032,
    "y-140": -0.03,
    "y-141": -0.03,
    "y-142": -0.03,
    "y-143": -0.03,
    "y-144": -0.016,
    "y-145": -0.016,
    "y-146": -0.016,
    "y-147": -0.016,
    "y-148": -0.016,
    "y-149": -0.016,
    "y-150": -0.037,
    "y-151": -0.026,
    "y-152": 0.0,
    "y-153": 0.0,
    "y-154": 0.0,
    "y-155": 0.0,
    "y-156": 0.0,
    "y-157": 0.0,
    "y-158": 0.0,
    "y-159": 0.0,
    "y-160": 0.0,
    "y-161": 0.016,
    "y-162": 0.011,
    "y-163": 0.011,
    "y-164": 0.034,
    "y-165": 0.034,
    "y-166": 0.05,
    "y-167": 0.05,
    "y-168": 0.05,
    "y-169": 0.05,
    "y-170": 0.051,
    "y-171": 0.051,
    "y-172": 0.051,
    "y-173": 0.051,
    "y-174": 0.054,
    "y-175": 0.051,
    "y-176": 0.051,
    "y-177": 0.052,
    "y-178": 0.052,
    "y-179": 0.052,
    "y-180": 0.052,
    "y-181": 0.052,
    "y-182": 0.052,
    "y-183": 0.053,
    "y-184": 0.05,
    "y-185": 0.05,
    "y-186": 0.05,
    "y-187": 0.05,
    "y-188": 0.05,
    "y-189": 0.039,
    "y-190": 0.039,
    "y-191": 0.039,
    "y-192": 0.039,
    "y-193": 0.039,
    "y-194": 0.039,
    "y-195": 0.04,
    "y-196": 0.04,
    "y-197": 0.038,
    "y-198": 0.038,
    "y-199": 0.038,
    "y-200": 0.038,
    "y-201": 0.038,
    "y-202": 0.038,
    "y-203": 0.037,
    "y-204": 0.037,
    "y-205": 0.038,
    "y-206": 0.038,
    "y-207": 0.038,
    "y-208": 0.035,
    "y-209": 0.035,
    "y-210": 0.035,
    "y-211": 0.037,
    "y-212": 0.037,
    "y-213": 0.037,
    "y-214": 0.037,
    "y-215": 0.036,
    "y-216": 0.036,
    "y-217": 0.036,
    "y-218": 0.036,
    "y-219": 0.036,
    "y-220": 0.036,
    "y-221": 0.036,
    "y-222": 0.036,
    "y-223": 0.036,
    "y-224": 0.036,
    "y-225": 0.033,
    "y-226": 0.033,
    "y-227": 0.033,
    "y-228": 0.033,
    "y-229": 0.033,
    "y-230": 0.033,
    "y-231": 0.033,
    "y-232": 0.033,
    "y-233": 0.033,
    "y-234": 0.031,
    "y-235": 0.031,
    "y-236": 0.029,
    "y-237": 0.029,
    "y-238": 0.029,
    "y-239": 0.029,
    "y-240": 0.029,
    "y-241": 0.029,
    "y-242": 0.029,
    "y-243": 0.029,
    "y-244": 0.03,
    "y-245": 0.03,
    "y-246": 0.03,
    "y-247": 0.03,
    "y-248": 0.03,
    "y-249": 0.03,
    "y-250": 0.03,
    "y-251": 0.028,
    "y-252": 0.029,
    "y-253": 0.029,
    "y-254": 0.029,
    "y-255": 0.029,
  },
  {
    x: 1.775,
    "y-2": 0.58,
    "y-12": 0.531,
    "y-46": -0.363,
    "y-1000": 0.218,
    "y-0": -0.763,
    "y-1": 0.588,
    "y-3": 0.582,
    "y-4": 0.582,
    "y-5": 0.582,
    "y-6": 0.582,
    "y-7": 0.582,
    "y-8": 0.582,
    "y-9": 0.582,
    "y-10": 0.581,
    "y-11": 0.581,
    "y-13": 0.531,
    "y-14": 0.531,
    "y-15": 0.537,
    "y-16": 0.537,
    "y-17": 0.103,
    "y-18": 0.111,
    "y-19": 0.111,
    "y-20": 0.111,
    "y-21": 0.111,
    "y-22": 0.111,
    "y-23": 0.095,
    "y-24": 0.065,
    "y-25": 0.065,
    "y-26": 0.065,
    "y-27": 0.065,
    "y-28": -0.059,
    "y-29": -0.059,
    "y-30": -0.024,
    "y-31": -0.459,
    "y-32": -0.459,
    "y-33": -0.459,
    "y-34": -0.459,
    "y-35": -0.459,
    "y-36": -0.459,
    "y-37": -0.362,
    "y-38": -0.366,
    "y-39": -0.367,
    "y-40": -0.364,
    "y-41": -0.367,
    "y-42": -0.364,
    "y-43": -0.364,
    "y-44": -0.364,
    "y-45": -0.364,
    "y-47": -0.366,
    "y-48": -0.366,
    "y-49": -0.165,
    "y-50": -0.164,
    "y-51": -0.164,
    "y-52": -0.167,
    "y-53": -0.165,
    "y-54": -0.162,
    "y-55": -0.165,
    "y-56": -0.162,
    "y-57": -0.163,
    "y-58": -0.367,
    "y-59": -0.368,
    "y-60": -0.364,
    "y-61": -0.365,
    "y-62": -0.367,
    "y-63": -0.363,
    "y-64": -0.364,
    "y-65": -0.366,
    "y-66": -0.366,
    "y-67": -0.391,
    "y-68": -0.39,
    "y-69": -0.29,
    "y-70": -0.291,
    "y-71": -0.289,
    "y-72": -0.29,
    "y-73": -0.291,
    "y-74": -0.291,
    "y-75": -0.291,
    "y-76": -0.29,
    "y-77": -0.291,
    "y-78": 0.205,
    "y-79": 0.203,
    "y-80": 0.201,
    "y-81": 0.204,
    "y-82": 0.202,
    "y-83": 0.204,
    "y-84": 0.202,
    "y-85": 0.208,
    "y-86": 0.207,
    "y-87": 0.207,
    "y-88": 0.207,
    "y-89": 0.208,
    "y-90": 0.208,
    "y-91": 0.206,
    "y-92": 0.206,
    "y-93": 0.209,
    "y-94": 0.207,
    "y-95": 0.207,
    "y-96": 0.208,
    "y-97": 0.207,
    "y-98": 0.205,
    "y-99": 0.208,
    "y-100": 0.207,
    "y-101": 0.208,
    "y-102": 0.207,
    "y-103": 0.209,
    "y-104": 0.186,
    "y-105": 0.184,
    "y-106": 0.185,
    "y-107": 0.185,
    "y-108": 0.185,
    "y-109": 0.185,
    "y-110": 0.178,
    "y-111": 0.178,
    "y-112": 0.182,
    "y-113": 0.182,
    "y-114": 0.181,
    "y-115": 0.191,
    "y-116": 0.191,
    "y-117": 0.191,
    "y-118": 0.191,
    "y-119": 0.191,
    "y-120": 0.191,
    "y-121": 0.191,
    "y-122": 0.191,
    "y-123": 0.191,
    "y-124": 0.191,
    "y-125": 0.196,
    "y-126": 0.196,
    "y-127": 0.196,
    "y-128": 0.196,
    "y-129": 0.196,
    "y-130": 0.196,
    "y-131": 0.196,
    "y-132": 0.196,
    "y-133": 0.196,
    "y-134": 0.196,
    "y-135": 0.196,
    "y-136": 0.196,
    "y-137": 0.196,
    "y-138": 0.196,
    "y-139": 0.196,
    "y-140": 0.197,
    "y-141": 0.197,
    "y-142": 0.197,
    "y-143": 0.197,
    "y-144": 0.205,
    "y-145": 0.205,
    "y-146": 0.205,
    "y-147": 0.205,
    "y-148": 0.205,
    "y-149": 0.205,
    "y-150": 0.195,
    "y-151": 0.201,
    "y-152": 0.214,
    "y-153": 0.214,
    "y-154": 0.214,
    "y-155": 0.214,
    "y-156": 0.214,
    "y-157": 0.214,
    "y-158": 0.214,
    "y-159": 0.214,
    "y-160": 0.214,
    "y-161": 0.224,
    "y-162": 0.221,
    "y-163": 0.221,
    "y-164": 0.233,
    "y-165": 0.233,
    "y-166": 0.241,
    "y-167": 0.241,
    "y-168": 0.241,
    "y-169": 0.241,
    "y-170": 0.241,
    "y-171": 0.241,
    "y-172": 0.241,
    "y-173": 0.241,
    "y-174": 0.243,
    "y-175": 0.241,
    "y-176": 0.241,
    "y-177": 0.242,
    "y-178": 0.242,
    "y-179": 0.242,
    "y-180": 0.242,
    "y-181": 0.242,
    "y-182": 0.241,
    "y-183": 0.242,
    "y-184": 0.24,
    "y-185": 0.24,
    "y-186": 0.24,
    "y-187": 0.24,
    "y-188": 0.24,
    "y-189": 0.233,
    "y-190": 0.233,
    "y-191": 0.233,
    "y-192": 0.233,
    "y-193": 0.233,
    "y-194": 0.233,
    "y-195": 0.234,
    "y-196": 0.234,
    "y-197": 0.232,
    "y-198": 0.233,
    "y-199": 0.233,
    "y-200": 0.233,
    "y-201": 0.233,
    "y-202": 0.233,
    "y-203": 0.232,
    "y-204": 0.232,
    "y-205": 0.233,
    "y-206": 0.233,
    "y-207": 0.233,
    "y-208": 0.231,
    "y-209": 0.231,
    "y-210": 0.231,
    "y-211": 0.232,
    "y-212": 0.232,
    "y-213": 0.232,
    "y-214": 0.232,
    "y-215": 0.232,
    "y-216": 0.232,
    "y-217": 0.232,
    "y-218": 0.232,
    "y-219": 0.232,
    "y-220": 0.232,
    "y-221": 0.232,
    "y-222": 0.232,
    "y-223": 0.232,
    "y-224": 0.232,
    "y-225": 0.23,
    "y-226": 0.23,
    "y-227": 0.23,
    "y-228": 0.23,
    "y-229": 0.23,
    "y-230": 0.23,
    "y-231": 0.23,
    "y-232": 0.23,
    "y-233": 0.23,
    "y-234": 0.229,
    "y-235": 0.229,
    "y-236": 0.227,
    "y-237": 0.227,
    "y-238": 0.227,
    "y-239": 0.227,
    "y-240": 0.227,
    "y-241": 0.227,
    "y-242": 0.227,
    "y-243": 0.227,
    "y-244": 0.228,
    "y-245": 0.228,
    "y-246": 0.228,
    "y-247": 0.228,
    "y-248": 0.228,
    "y-249": 0.228,
    "y-250": 0.228,
    "y-251": 0.227,
    "y-252": 0.227,
    "y-253": 0.227,
    "y-254": 0.227,
    "y-255": 0.227,
  },
  {
    x: 1.8,
    "y-2": 0.711,
    "y-12": 0.675,
    "y-46": 0.432,
    "y-1000": 0.432,
    "y-0": -0.775,
    "y-1": 0.688,
    "y-3": 0.703,
    "y-4": 0.705,
    "y-5": 0.705,
    "y-6": 0.705,
    "y-7": 0.705,
    "y-8": 0.705,
    "y-9": 0.705,
    "y-10": 0.708,
    "y-11": 0.708,
    "y-13": 0.675,
    "y-14": 0.675,
    "y-15": 0.68,
    "y-16": 0.68,
    "y-17": 0.316,
    "y-18": 0.323,
    "y-19": 0.323,
    "y-20": 0.323,
    "y-21": 0.323,
    "y-22": 0.323,
    "y-23": 0.31,
    "y-24": 0.37,
    "y-25": 0.37,
    "y-26": 0.37,
    "y-27": 0.37,
    "y-28": 0.34,
    "y-29": 0.34,
    "y-30": 0.432,
    "y-31": 0.432,
    "y-32": 0.432,
    "y-33": 0.432,
    "y-34": 0.432,
    "y-35": 0.432,
    "y-36": 0.432,
    "y-37": 0.432,
    "y-38": 0.432,
    "y-39": 0.432,
    "y-40": 0.432,
    "y-41": 0.432,
    "y-42": 0.432,
    "y-43": 0.432,
    "y-44": 0.432,
    "y-45": 0.432,
    "y-47": 0.432,
    "y-48": 0.432,
    "y-49": 0.432,
    "y-50": 0.432,
    "y-51": 0.432,
    "y-52": 0.432,
    "y-53": 0.432,
    "y-54": 0.432,
    "y-55": 0.432,
    "y-56": 0.432,
    "y-57": 0.432,
    "y-58": 0.432,
    "y-59": 0.432,
    "y-60": 0.432,
    "y-61": 0.432,
    "y-62": 0.432,
    "y-63": 0.432,
    "y-64": 0.432,
    "y-65": 0.432,
    "y-66": 0.432,
    "y-67": 0.432,
    "y-68": 0.432,
    "y-69": 0.432,
    "y-70": 0.432,
    "y-71": 0.432,
    "y-72": 0.432,
    "y-73": 0.432,
    "y-74": 0.432,
    "y-75": 0.432,
    "y-76": 0.432,
    "y-77": 0.432,
    "y-78": 0.432,
    "y-79": 0.432,
    "y-80": 0.432,
    "y-81": 0.432,
    "y-82": 0.432,
    "y-83": 0.432,
    "y-84": 0.432,
    "y-85": 0.432,
    "y-86": 0.432,
    "y-87": 0.432,
    "y-88": 0.432,
    "y-89": 0.432,
    "y-90": 0.432,
    "y-91": 0.432,
    "y-92": 0.432,
    "y-93": 0.432,
    "y-94": 0.432,
    "y-95": 0.432,
    "y-96": 0.432,
    "y-97": 0.432,
    "y-98": 0.432,
    "y-99": 0.432,
    "y-100": 0.432,
    "y-101": 0.432,
    "y-102": 0.432,
    "y-103": 0.432,
    "y-104": 0.432,
    "y-105": 0.432,
    "y-106": 0.432,
    "y-107": 0.432,
    "y-108": 0.432,
    "y-109": 0.432,
    "y-110": 0.432,
    "y-111": 0.432,
    "y-112": 0.432,
    "y-113": 0.432,
    "y-114": 0.432,
    "y-115": 0.432,
    "y-116": 0.432,
    "y-117": 0.432,
    "y-118": 0.432,
    "y-119": 0.432,
    "y-120": 0.432,
    "y-121": 0.432,
    "y-122": 0.432,
    "y-123": 0.432,
    "y-124": 0.432,
    "y-125": 0.432,
    "y-126": 0.432,
    "y-127": 0.432,
    "y-128": 0.432,
    "y-129": 0.432,
    "y-130": 0.432,
    "y-131": 0.432,
    "y-132": 0.432,
    "y-133": 0.432,
    "y-134": 0.432,
    "y-135": 0.432,
    "y-136": 0.432,
    "y-137": 0.432,
    "y-138": 0.432,
    "y-139": 0.432,
    "y-140": 0.432,
    "y-141": 0.432,
    "y-142": 0.432,
    "y-143": 0.432,
    "y-144": 0.432,
    "y-145": 0.432,
    "y-146": 0.432,
    "y-147": 0.432,
    "y-148": 0.432,
    "y-149": 0.432,
    "y-150": 0.432,
    "y-151": 0.432,
    "y-152": 0.432,
    "y-153": 0.432,
    "y-154": 0.432,
    "y-155": 0.432,
    "y-156": 0.432,
    "y-157": 0.432,
    "y-158": 0.432,
    "y-159": 0.432,
    "y-160": 0.432,
    "y-161": 0.432,
    "y-162": 0.432,
    "y-163": 0.432,
    "y-164": 0.432,
    "y-165": 0.432,
    "y-166": 0.432,
    "y-167": 0.432,
    "y-168": 0.432,
    "y-169": 0.432,
    "y-170": 0.432,
    "y-171": 0.432,
    "y-172": 0.432,
    "y-173": 0.432,
    "y-174": 0.432,
    "y-175": 0.432,
    "y-176": 0.432,
    "y-177": 0.432,
    "y-178": 0.432,
    "y-179": 0.432,
    "y-180": 0.432,
    "y-181": 0.432,
    "y-182": 0.432,
    "y-183": 0.432,
    "y-184": 0.432,
    "y-185": 0.432,
    "y-186": 0.432,
    "y-187": 0.432,
    "y-188": 0.432,
    "y-189": 0.432,
    "y-190": 0.432,
    "y-191": 0.432,
    "y-192": 0.432,
    "y-193": 0.432,
    "y-194": 0.432,
    "y-195": 0.432,
    "y-196": 0.432,
    "y-197": 0.432,
    "y-198": 0.432,
    "y-199": 0.432,
    "y-200": 0.432,
    "y-201": 0.432,
    "y-202": 0.432,
    "y-203": 0.432,
    "y-204": 0.432,
    "y-205": 0.432,
    "y-206": 0.432,
    "y-207": 0.432,
    "y-208": 0.432,
    "y-209": 0.432,
    "y-210": 0.432,
    "y-211": 0.432,
    "y-212": 0.432,
    "y-213": 0.432,
    "y-214": 0.432,
    "y-215": 0.432,
    "y-216": 0.432,
    "y-217": 0.432,
    "y-218": 0.432,
    "y-219": 0.432,
    "y-220": 0.432,
    "y-221": 0.432,
    "y-222": 0.432,
    "y-223": 0.432,
    "y-224": 0.432,
    "y-225": 0.432,
    "y-226": 0.432,
    "y-227": 0.432,
    "y-228": 0.432,
    "y-229": 0.432,
    "y-230": 0.432,
    "y-231": 0.432,
    "y-232": 0.432,
    "y-233": 0.432,
    "y-234": 0.432,
    "y-235": 0.432,
    "y-236": 0.432,
    "y-237": 0.432,
    "y-238": 0.432,
    "y-239": 0.432,
    "y-240": 0.432,
    "y-241": 0.432,
    "y-242": 0.432,
    "y-243": 0.432,
    "y-244": 0.432,
    "y-245": 0.432,
    "y-246": 0.432,
    "y-247": 0.432,
    "y-248": 0.432,
    "y-249": 0.432,
    "y-250": 0.432,
    "y-251": 0.432,
    "y-252": 0.432,
    "y-253": 0.432,
    "y-254": 0.432,
    "y-255": 0.432,
  },
  {
    x: 1.825,
    "y-2": 0.843,
    "y-12": 0.819,
    "y-46": 1.227,
    "y-1000": 0.614,
    "y-0": -0.787,
    "y-1": 0.788,
    "y-3": 0.824,
    "y-4": 0.827,
    "y-5": 0.829,
    "y-6": 0.829,
    "y-7": 0.829,
    "y-8": 0.829,
    "y-9": 0.829,
    "y-10": 0.835,
    "y-11": 0.835,
    "y-13": 0.819,
    "y-14": 0.819,
    "y-15": 0.822,
    "y-16": 0.822,
    "y-17": 0.53,
    "y-18": 0.536,
    "y-19": 0.536,
    "y-20": 0.536,
    "y-21": 0.536,
    "y-22": 0.536,
    "y-23": 0.525,
    "y-24": 0.675,
    "y-25": 0.675,
    "y-26": 0.675,
    "y-27": 0.675,
    "y-28": 0.739,
    "y-29": 0.739,
    "y-30": 0.888,
    "y-31": 1.323,
    "y-32": 1.323,
    "y-33": 1.323,
    "y-34": 1.323,
    "y-35": 1.323,
    "y-36": 1.323,
    "y-37": 1.226,
    "y-38": 1.23,
    "y-39": 1.231,
    "y-40": 1.228,
    "y-41": 1.231,
    "y-42": 1.228,
    "y-43": 1.228,
    "y-44": 1.228,
    "y-45": 1.228,
    "y-47": 1.23,
    "y-48": 1.23,
    "y-49": 1.029,
    "y-50": 1.028,
    "y-51": 1.028,
    "y-52": 1.031,
    "y-53": 1.029,
    "y-54": 1.026,
    "y-55": 1.029,
    "y-56": 1.026,
    "y-57": 1.027,
    "y-58": 1.231,
    "y-59": 1.232,
    "y-60": 1.228,
    "y-61": 1.229,
    "y-62": 1.231,
    "y-63": 1.227,
    "y-64": 1.228,
    "y-65": 1.23,
    "y-66": 1.23,
    "y-67": 1.255,
    "y-68": 1.254,
    "y-69": 1.154,
    "y-70": 1.155,
    "y-71": 1.153,
    "y-72": 1.154,
    "y-73": 1.155,
    "y-74": 1.155,
    "y-75": 1.155,
    "y-76": 1.154,
    "y-77": 1.155,
    "y-78": 0.659,
    "y-79": 0.661,
    "y-80": 0.663,
    "y-81": 0.66,
    "y-82": 0.662,
    "y-83": 0.66,
    "y-84": 0.662,
    "y-85": 0.656,
    "y-86": 0.657,
    "y-87": 0.657,
    "y-88": 0.657,
    "y-89": 0.656,
    "y-90": 0.656,
    "y-91": 0.658,
    "y-92": 0.658,
    "y-93": 0.655,
    "y-94": 0.657,
    "y-95": 0.657,
    "y-96": 0.656,
    "y-97": 0.657,
    "y-98": 0.659,
    "y-99": 0.656,
    "y-100": 0.657,
    "y-101": 0.656,
    "y-102": 0.657,
    "y-103": 0.655,
    "y-104": 0.678,
    "y-105": 0.68,
    "y-106": 0.679,
    "y-107": 0.679,
    "y-108": 0.679,
    "y-109": 0.679,
    "y-110": 0.686,
    "y-111": 0.686,
    "y-112": 0.682,
    "y-113": 0.682,
    "y-114": 0.683,
    "y-115": 0.673,
    "y-116": 0.673,
    "y-117": 0.673,
    "y-118": 0.673,
    "y-119": 0.673,
    "y-120": 0.673,
    "y-121": 0.673,
    "y-122": 0.673,
    "y-123": 0.673,
    "y-124": 0.673,
    "y-125": 0.668,
    "y-126": 0.668,
    "y-127": 0.668,
    "y-128": 0.668,
    "y-129": 0.668,
    "y-130": 0.668,
    "y-131": 0.668,
    "y-132": 0.668,
    "y-133": 0.668,
    "y-134": 0.668,
    "y-135": 0.668,
    "y-136": 0.668,
    "y-137": 0.668,
    "y-138": 0.668,
    "y-139": 0.668,
    "y-140": 0.667,
    "y-141": 0.667,
    "y-142": 0.667,
    "y-143": 0.667,
    "y-144": 0.659,
    "y-145": 0.659,
    "y-146": 0.659,
    "y-147": 0.659,
    "y-148": 0.659,
    "y-149": 0.659,
    "y-150": 0.669,
    "y-151": 0.663,
    "y-152": 0.65,
    "y-153": 0.65,
    "y-154": 0.65,
    "y-155": 0.65,
    "y-156": 0.65,
    "y-157": 0.65,
    "y-158": 0.65,
    "y-159": 0.65,
    "y-160": 0.65,
    "y-161": 0.64,
    "y-162": 0.643,
    "y-163": 0.643,
    "y-164": 0.631,
    "y-165": 0.631,
    "y-166": 0.623,
    "y-167": 0.623,
    "y-168": 0.623,
    "y-169": 0.623,
    "y-170": 0.623,
    "y-171": 0.623,
    "y-172": 0.623,
    "y-173": 0.623,
    "y-174": 0.621,
    "y-175": 0.623,
    "y-176": 0.623,
    "y-177": 0.622,
    "y-178": 0.622,
    "y-179": 0.622,
    "y-180": 0.622,
    "y-181": 0.622,
    "y-182": 0.623,
    "y-183": 0.622,
    "y-184": 0.624,
    "y-185": 0.624,
    "y-186": 0.624,
    "y-187": 0.624,
    "y-188": 0.624,
    "y-189": 0.626,
    "y-190": 0.626,
    "y-191": 0.626,
    "y-192": 0.626,
    "y-193": 0.626,
    "y-194": 0.626,
    "y-195": 0.624,
    "y-196": 0.624,
    "y-197": 0.626,
    "y-198": 0.626,
    "y-199": 0.626,
    "y-200": 0.626,
    "y-201": 0.626,
    "y-202": 0.626,
    "y-203": 0.626,
    "y-204": 0.626,
    "y-205": 0.626,
    "y-206": 0.626,
    "y-207": 0.626,
    "y-208": 0.628,
    "y-209": 0.628,
    "y-210": 0.628,
    "y-211": 0.627,
    "y-212": 0.627,
    "y-213": 0.627,
    "y-214": 0.627,
    "y-215": 0.627,
    "y-216": 0.627,
    "y-217": 0.627,
    "y-218": 0.627,
    "y-219": 0.627,
    "y-220": 0.627,
    "y-221": 0.627,
    "y-222": 0.627,
    "y-223": 0.627,
    "y-224": 0.627,
    "y-225": 0.629,
    "y-226": 0.629,
    "y-227": 0.629,
    "y-228": 0.629,
    "y-229": 0.629,
    "y-230": 0.629,
    "y-231": 0.629,
    "y-232": 0.629,
    "y-233": 0.629,
    "y-234": 0.63,
    "y-235": 0.63,
    "y-236": 0.632,
    "y-237": 0.632,
    "y-238": 0.632,
    "y-239": 0.632,
    "y-240": 0.632,
    "y-241": 0.632,
    "y-242": 0.632,
    "y-243": 0.632,
    "y-244": 0.632,
    "y-245": 0.632,
    "y-246": 0.632,
    "y-247": 0.632,
    "y-248": 0.632,
    "y-249": 0.632,
    "y-250": 0.632,
    "y-251": 0.633,
    "y-252": 0.632,
    "y-253": 0.632,
    "y-254": 0.632,
    "y-255": 0.632,
  },
  {
    x: 1.85,
    "y-2": 0.974,
    "y-12": 0.962,
    "y-46": 1.284,
    "y-1000": 0.775,
    "y-0": -0.8,
    "y-1": 0.888,
    "y-3": 0.945,
    "y-4": 0.95,
    "y-5": 0.952,
    "y-6": 0.952,
    "y-7": 0.952,
    "y-8": 0.952,
    "y-9": 0.952,
    "y-10": 0.963,
    "y-11": 0.962,
    "y-13": 0.962,
    "y-14": 0.962,
    "y-15": 0.965,
    "y-16": 0.965,
    "y-17": 0.744,
    "y-18": 0.748,
    "y-19": 0.748,
    "y-20": 0.748,
    "y-21": 0.748,
    "y-22": 0.748,
    "y-23": 0.74,
    "y-24": 0.874,
    "y-25": 0.874,
    "y-26": 0.874,
    "y-27": 0.874,
    "y-28": 0.94,
    "y-29": 0.94,
    "y-30": 1.013,
    "y-31": 1.36,
    "y-32": 1.36,
    "y-33": 1.36,
    "y-34": 1.36,
    "y-35": 1.36,
    "y-36": 1.36,
    "y-37": 1.283,
    "y-38": 1.286,
    "y-39": 1.286,
    "y-40": 1.284,
    "y-41": 1.286,
    "y-42": 1.284,
    "y-43": 1.284,
    "y-44": 1.284,
    "y-45": 1.284,
    "y-47": 1.286,
    "y-48": 1.286,
    "y-49": 1.126,
    "y-50": 1.125,
    "y-51": 1.125,
    "y-52": 1.127,
    "y-53": 1.126,
    "y-54": 1.123,
    "y-55": 1.126,
    "y-56": 1.123,
    "y-57": 1.124,
    "y-58": 1.287,
    "y-59": 1.287,
    "y-60": 1.284,
    "y-61": 1.285,
    "y-62": 1.286,
    "y-63": 1.284,
    "y-64": 1.284,
    "y-65": 1.286,
    "y-66": 1.286,
    "y-67": 1.305,
    "y-68": 1.305,
    "y-69": 1.225,
    "y-70": 1.226,
    "y-71": 1.224,
    "y-72": 1.226,
    "y-73": 1.226,
    "y-74": 1.226,
    "y-75": 1.226,
    "y-76": 1.225,
    "y-77": 1.226,
    "y-78": 0.832,
    "y-79": 0.833,
    "y-80": 0.834,
    "y-81": 0.832,
    "y-82": 0.834,
    "y-83": 0.832,
    "y-84": 0.834,
    "y-85": 0.829,
    "y-86": 0.83,
    "y-87": 0.83,
    "y-88": 0.83,
    "y-89": 0.829,
    "y-90": 0.829,
    "y-91": 0.831,
    "y-92": 0.831,
    "y-93": 0.829,
    "y-94": 0.83,
    "y-95": 0.83,
    "y-96": 0.829,
    "y-97": 0.83,
    "y-98": 0.831,
    "y-99": 0.826,
    "y-100": 0.828,
    "y-101": 0.827,
    "y-102": 0.828,
    "y-103": 0.825,
    "y-104": 0.851,
    "y-105": 0.852,
    "y-106": 0.852,
    "y-107": 0.852,
    "y-108": 0.852,
    "y-109": 0.852,
    "y-110": 0.866,
    "y-111": 0.867,
    "y-112": 0.862,
    "y-113": 0.862,
    "y-114": 0.862,
    "y-115": 0.852,
    "y-116": 0.851,
    "y-117": 0.852,
    "y-118": 0.852,
    "y-119": 0.852,
    "y-120": 0.852,
    "y-121": 0.852,
    "y-122": 0.852,
    "y-123": 0.851,
    "y-124": 0.852,
    "y-125": 0.846,
    "y-126": 0.846,
    "y-127": 0.846,
    "y-128": 0.847,
    "y-129": 0.847,
    "y-130": 0.847,
    "y-131": 0.847,
    "y-132": 0.847,
    "y-133": 0.847,
    "y-134": 0.847,
    "y-135": 0.846,
    "y-136": 0.846,
    "y-137": 0.846,
    "y-138": 0.847,
    "y-139": 0.847,
    "y-140": 0.844,
    "y-141": 0.844,
    "y-142": 0.844,
    "y-143": 0.844,
    "y-144": 0.835,
    "y-145": 0.835,
    "y-146": 0.835,
    "y-147": 0.835,
    "y-148": 0.835,
    "y-149": 0.835,
    "y-150": 0.846,
    "y-151": 0.84,
    "y-152": 0.825,
    "y-153": 0.825,
    "y-154": 0.825,
    "y-155": 0.825,
    "y-156": 0.825,
    "y-157": 0.825,
    "y-158": 0.825,
    "y-159": 0.825,
    "y-160": 0.825,
    "y-161": 0.814,
    "y-162": 0.819,
    "y-163": 0.819,
    "y-164": 0.805,
    "y-165": 0.805,
    "y-166": 0.796,
    "y-167": 0.796,
    "y-168": 0.796,
    "y-169": 0.796,
    "y-170": 0.795,
    "y-171": 0.795,
    "y-172": 0.795,
    "y-173": 0.795,
    "y-174": 0.794,
    "y-175": 0.796,
    "y-176": 0.796,
    "y-177": 0.796,
    "y-178": 0.796,
    "y-179": 0.796,
    "y-180": 0.796,
    "y-181": 0.796,
    "y-182": 0.796,
    "y-183": 0.795,
    "y-184": 0.798,
    "y-185": 0.798,
    "y-186": 0.799,
    "y-187": 0.799,
    "y-188": 0.799,
    "y-189": 0.795,
    "y-190": 0.795,
    "y-191": 0.795,
    "y-192": 0.795,
    "y-193": 0.795,
    "y-194": 0.795,
    "y-195": 0.786,
    "y-196": 0.786,
    "y-197": 0.79,
    "y-198": 0.79,
    "y-199": 0.79,
    "y-200": 0.79,
    "y-201": 0.79,
    "y-202": 0.79,
    "y-203": 0.79,
    "y-204": 0.79,
    "y-205": 0.79,
    "y-206": 0.79,
    "y-207": 0.79,
    "y-208": 0.795,
    "y-209": 0.795,
    "y-210": 0.795,
    "y-211": 0.789,
    "y-212": 0.789,
    "y-213": 0.789,
    "y-214": 0.789,
    "y-215": 0.789,
    "y-216": 0.789,
    "y-217": 0.789,
    "y-218": 0.789,
    "y-219": 0.789,
    "y-220": 0.789,
    "y-221": 0.789,
    "y-222": 0.789,
    "y-223": 0.789,
    "y-224": 0.789,
    "y-225": 0.795,
    "y-226": 0.795,
    "y-227": 0.795,
    "y-228": 0.795,
    "y-229": 0.795,
    "y-230": 0.795,
    "y-231": 0.795,
    "y-232": 0.795,
    "y-233": 0.795,
    "y-234": 0.798,
    "y-235": 0.798,
    "y-236": 0.802,
    "y-237": 0.802,
    "y-238": 0.802,
    "y-239": 0.802,
    "y-240": 0.802,
    "y-241": 0.802,
    "y-242": 0.802,
    "y-243": 0.802,
    "y-244": 0.801,
    "y-245": 0.801,
    "y-246": 0.801,
    "y-247": 0.801,
    "y-248": 0.801,
    "y-249": 0.801,
    "y-250": 0.801,
    "y-251": 0.804,
    "y-252": 0.803,
    "y-253": 0.803,
    "y-254": 0.803,
    "y-255": 0.803,
  },
  {
    x: 1.875,
    "y-2": 1.106,
    "y-12": 1.106,
    "y-46": 1.221,
    "y-1000": 0.948,
    "y-0": -0.812,
    "y-1": 0.988,
    "y-3": 1.065,
    "y-4": 1.073,
    "y-5": 1.075,
    "y-6": 1.076,
    "y-7": 1.076,
    "y-8": 1.076,
    "y-9": 1.076,
    "y-10": 1.09,
    "y-11": 1.09,
    "y-13": 1.106,
    "y-14": 1.106,
    "y-15": 1.108,
    "y-16": 1.108,
    "y-17": 0.958,
    "y-18": 0.961,
    "y-19": 0.961,
    "y-20": 0.961,
    "y-21": 0.961,
    "y-22": 0.961,
    "y-23": 0.955,
    "y-24": 1.056,
    "y-25": 1.056,
    "y-26": 1.056,
    "y-27": 1.056,
    "y-28": 1.108,
    "y-29": 1.108,
    "y-30": 1.086,
    "y-31": 1.26,
    "y-32": 1.26,
    "y-33": 1.26,
    "y-34": 1.26,
    "y-35": 1.26,
    "y-36": 1.26,
    "y-37": 1.221,
    "y-38": 1.222,
    "y-39": 1.223,
    "y-40": 1.222,
    "y-41": 1.223,
    "y-42": 1.221,
    "y-43": 1.222,
    "y-44": 1.222,
    "y-45": 1.222,
    "y-47": 1.222,
    "y-48": 1.222,
    "y-49": 1.142,
    "y-50": 1.142,
    "y-51": 1.142,
    "y-52": 1.143,
    "y-53": 1.142,
    "y-54": 1.141,
    "y-55": 1.142,
    "y-56": 1.141,
    "y-57": 1.142,
    "y-58": 1.223,
    "y-59": 1.223,
    "y-60": 1.221,
    "y-61": 1.222,
    "y-62": 1.223,
    "y-63": 1.221,
    "y-64": 1.222,
    "y-65": 1.222,
    "y-66": 1.222,
    "y-67": 1.232,
    "y-68": 1.232,
    "y-69": 1.192,
    "y-70": 1.193,
    "y-71": 1.192,
    "y-72": 1.192,
    "y-73": 1.192,
    "y-74": 1.193,
    "y-75": 1.193,
    "y-76": 1.192,
    "y-77": 1.193,
    "y-78": 0.995,
    "y-79": 0.996,
    "y-80": 0.997,
    "y-81": 0.996,
    "y-82": 0.997,
    "y-83": 0.996,
    "y-84": 0.996,
    "y-85": 0.994,
    "y-86": 0.995,
    "y-87": 0.994,
    "y-88": 0.994,
    "y-89": 0.994,
    "y-90": 0.994,
    "y-91": 0.995,
    "y-92": 0.995,
    "y-93": 0.994,
    "y-94": 0.994,
    "y-95": 0.995,
    "y-96": 0.994,
    "y-97": 0.994,
    "y-98": 0.995,
    "y-99": 0.992,
    "y-100": 0.993,
    "y-101": 0.993,
    "y-102": 0.994,
    "y-103": 0.992,
    "y-104": 1.005,
    "y-105": 1.006,
    "y-106": 1.006,
    "y-107": 1.006,
    "y-108": 1.006,
    "y-109": 1.006,
    "y-110": 1.014,
    "y-111": 1.014,
    "y-112": 1.012,
    "y-113": 1.011,
    "y-114": 1.012,
    "y-115": 1.006,
    "y-116": 1.006,
    "y-117": 1.006,
    "y-118": 1.006,
    "y-119": 1.006,
    "y-120": 1.006,
    "y-121": 1.006,
    "y-122": 1.006,
    "y-123": 1.006,
    "y-124": 1.006,
    "y-125": 1.003,
    "y-126": 1.003,
    "y-127": 1.003,
    "y-128": 1.003,
    "y-129": 1.003,
    "y-130": 1.003,
    "y-131": 1.003,
    "y-132": 1.003,
    "y-133": 1.003,
    "y-134": 1.003,
    "y-135": 1.003,
    "y-136": 1.003,
    "y-137": 1.003,
    "y-138": 1.003,
    "y-139": 1.003,
    "y-140": 1.002,
    "y-141": 1.002,
    "y-142": 1.002,
    "y-143": 1.002,
    "y-144": 0.997,
    "y-145": 0.997,
    "y-146": 0.997,
    "y-147": 0.997,
    "y-148": 0.997,
    "y-149": 0.997,
    "y-150": 1.003,
    "y-151": 1.0,
    "y-152": 0.992,
    "y-153": 0.992,
    "y-154": 0.992,
    "y-155": 0.992,
    "y-156": 0.992,
    "y-157": 0.992,
    "y-158": 0.992,
    "y-159": 0.992,
    "y-160": 0.992,
    "y-161": 0.986,
    "y-162": 0.989,
    "y-163": 0.989,
    "y-164": 0.982,
    "y-165": 0.982,
    "y-166": 0.977,
    "y-167": 0.977,
    "y-168": 0.977,
    "y-169": 0.977,
    "y-170": 0.977,
    "y-171": 0.977,
    "y-172": 0.977,
    "y-173": 0.977,
    "y-174": 0.976,
    "y-175": 0.977,
    "y-176": 0.977,
    "y-177": 0.977,
    "y-178": 0.977,
    "y-179": 0.977,
    "y-180": 0.977,
    "y-181": 0.977,
    "y-182": 0.977,
    "y-183": 0.976,
    "y-184": 0.978,
    "y-185": 0.978,
    "y-186": 0.978,
    "y-187": 0.978,
    "y-188": 0.978,
    "y-189": 0.976,
    "y-190": 0.976,
    "y-191": 0.976,
    "y-192": 0.976,
    "y-193": 0.976,
    "y-194": 0.976,
    "y-195": 0.962,
    "y-196": 0.962,
    "y-197": 0.966,
    "y-198": 0.965,
    "y-199": 0.965,
    "y-200": 0.965,
    "y-201": 0.965,
    "y-202": 0.965,
    "y-203": 0.966,
    "y-204": 0.966,
    "y-205": 0.965,
    "y-206": 0.965,
    "y-207": 0.965,
    "y-208": 0.97,
    "y-209": 0.97,
    "y-210": 0.97,
    "y-211": 0.962,
    "y-212": 0.962,
    "y-213": 0.962,
    "y-214": 0.962,
    "y-215": 0.962,
    "y-216": 0.962,
    "y-217": 0.962,
    "y-218": 0.962,
    "y-219": 0.962,
    "y-220": 0.962,
    "y-221": 0.962,
    "y-222": 0.962,
    "y-223": 0.962,
    "y-224": 0.962,
    "y-225": 0.967,
    "y-226": 0.967,
    "y-227": 0.967,
    "y-228": 0.967,
    "y-229": 0.967,
    "y-230": 0.967,
    "y-231": 0.967,
    "y-232": 0.967,
    "y-233": 0.967,
    "y-234": 0.969,
    "y-235": 0.969,
    "y-236": 0.973,
    "y-237": 0.973,
    "y-238": 0.973,
    "y-239": 0.973,
    "y-240": 0.973,
    "y-241": 0.973,
    "y-242": 0.973,
    "y-243": 0.973,
    "y-244": 0.973,
    "y-245": 0.973,
    "y-246": 0.973,
    "y-247": 0.973,
    "y-248": 0.973,
    "y-249": 0.973,
    "y-250": 0.973,
    "y-251": 0.975,
    "y-252": 0.975,
    "y-253": 0.975,
    "y-254": 0.975,
    "y-255": 0.975,
  },
  {
    x: 1.9,
    "y-2": 1.237,
    "y-12": 1.25,
    "y-46": 1.159,
    "y-1000": 1.159,
    "y-0": -0.824,
    "y-1": 1.088,
    "y-3": 1.186,
    "y-4": 1.195,
    "y-5": 1.199,
    "y-6": 1.199,
    "y-7": 1.199,
    "y-8": 1.2,
    "y-9": 1.2,
    "y-10": 1.217,
    "y-11": 1.217,
    "y-13": 1.25,
    "y-14": 1.25,
    "y-15": 1.251,
    "y-16": 1.251,
    "y-17": 1.171,
    "y-18": 1.173,
    "y-19": 1.173,
    "y-20": 1.173,
    "y-21": 1.173,
    "y-22": 1.173,
    "y-23": 1.17,
    "y-24": 1.238,
    "y-25": 1.238,
    "y-26": 1.238,
    "y-27": 1.238,
    "y-28": 1.277,
    "y-29": 1.277,
    "y-30": 1.159,
    "y-31": 1.159,
    "y-32": 1.159,
    "y-33": 1.159,
    "y-34": 1.159,
    "y-35": 1.159,
    "y-36": 1.159,
    "y-37": 1.159,
    "y-38": 1.159,
    "y-39": 1.159,
    "y-40": 1.159,
    "y-41": 1.159,
    "y-42": 1.159,
    "y-43": 1.159,
    "y-44": 1.159,
    "y-45": 1.159,
    "y-47": 1.159,
    "y-48": 1.159,
    "y-49": 1.159,
    "y-50": 1.159,
    "y-51": 1.159,
    "y-52": 1.159,
    "y-53": 1.159,
    "y-54": 1.159,
    "y-55": 1.159,
    "y-56": 1.159,
    "y-57": 1.159,
    "y-58": 1.159,
    "y-59": 1.159,
    "y-60": 1.159,
    "y-61": 1.159,
    "y-62": 1.159,
    "y-63": 1.159,
    "y-64": 1.159,
    "y-65": 1.159,
    "y-66": 1.159,
    "y-67": 1.159,
    "y-68": 1.159,
    "y-69": 1.159,
    "y-70": 1.159,
    "y-71": 1.159,
    "y-72": 1.159,
    "y-73": 1.159,
    "y-74": 1.159,
    "y-75": 1.159,
    "y-76": 1.159,
    "y-77": 1.159,
    "y-78": 1.159,
    "y-79": 1.159,
    "y-80": 1.159,
    "y-81": 1.159,
    "y-82": 1.159,
    "y-83": 1.159,
    "y-84": 1.159,
    "y-85": 1.159,
    "y-86": 1.159,
    "y-87": 1.159,
    "y-88": 1.159,
    "y-89": 1.159,
    "y-90": 1.159,
    "y-91": 1.159,
    "y-92": 1.159,
    "y-93": 1.159,
    "y-94": 1.159,
    "y-95": 1.159,
    "y-96": 1.159,
    "y-97": 1.159,
    "y-98": 1.159,
    "y-99": 1.159,
    "y-100": 1.159,
    "y-101": 1.159,
    "y-102": 1.159,
    "y-103": 1.159,
    "y-104": 1.159,
    "y-105": 1.159,
    "y-106": 1.159,
    "y-107": 1.159,
    "y-108": 1.159,
    "y-109": 1.159,
    "y-110": 1.159,
    "y-111": 1.159,
    "y-112": 1.159,
    "y-113": 1.159,
    "y-114": 1.159,
    "y-115": 1.159,
    "y-116": 1.159,
    "y-117": 1.159,
    "y-118": 1.159,
    "y-119": 1.159,
    "y-120": 1.159,
    "y-121": 1.159,
    "y-122": 1.159,
    "y-123": 1.159,
    "y-124": 1.159,
    "y-125": 1.159,
    "y-126": 1.159,
    "y-127": 1.159,
    "y-128": 1.159,
    "y-129": 1.159,
    "y-130": 1.159,
    "y-131": 1.159,
    "y-132": 1.159,
    "y-133": 1.159,
    "y-134": 1.159,
    "y-135": 1.159,
    "y-136": 1.159,
    "y-137": 1.159,
    "y-138": 1.159,
    "y-139": 1.159,
    "y-140": 1.159,
    "y-141": 1.159,
    "y-142": 1.159,
    "y-143": 1.159,
    "y-144": 1.159,
    "y-145": 1.159,
    "y-146": 1.159,
    "y-147": 1.159,
    "y-148": 1.159,
    "y-149": 1.159,
    "y-150": 1.159,
    "y-151": 1.159,
    "y-152": 1.159,
    "y-153": 1.159,
    "y-154": 1.159,
    "y-155": 1.159,
    "y-156": 1.159,
    "y-157": 1.159,
    "y-158": 1.159,
    "y-159": 1.159,
    "y-160": 1.159,
    "y-161": 1.159,
    "y-162": 1.159,
    "y-163": 1.159,
    "y-164": 1.159,
    "y-165": 1.159,
    "y-166": 1.159,
    "y-167": 1.159,
    "y-168": 1.159,
    "y-169": 1.159,
    "y-170": 1.159,
    "y-171": 1.159,
    "y-172": 1.159,
    "y-173": 1.159,
    "y-174": 1.159,
    "y-175": 1.159,
    "y-176": 1.159,
    "y-177": 1.159,
    "y-178": 1.159,
    "y-179": 1.159,
    "y-180": 1.159,
    "y-181": 1.159,
    "y-182": 1.159,
    "y-183": 1.159,
    "y-184": 1.159,
    "y-185": 1.159,
    "y-186": 1.159,
    "y-187": 1.159,
    "y-188": 1.159,
    "y-189": 1.159,
    "y-190": 1.159,
    "y-191": 1.159,
    "y-192": 1.159,
    "y-193": 1.159,
    "y-194": 1.159,
    "y-195": 1.159,
    "y-196": 1.159,
    "y-197": 1.159,
    "y-198": 1.159,
    "y-199": 1.159,
    "y-200": 1.159,
    "y-201": 1.159,
    "y-202": 1.159,
    "y-203": 1.159,
    "y-204": 1.159,
    "y-205": 1.159,
    "y-206": 1.159,
    "y-207": 1.159,
    "y-208": 1.159,
    "y-209": 1.159,
    "y-210": 1.159,
    "y-211": 1.159,
    "y-212": 1.159,
    "y-213": 1.159,
    "y-214": 1.159,
    "y-215": 1.159,
    "y-216": 1.159,
    "y-217": 1.159,
    "y-218": 1.159,
    "y-219": 1.159,
    "y-220": 1.159,
    "y-221": 1.159,
    "y-222": 1.159,
    "y-223": 1.159,
    "y-224": 1.159,
    "y-225": 1.159,
    "y-226": 1.159,
    "y-227": 1.159,
    "y-228": 1.159,
    "y-229": 1.159,
    "y-230": 1.159,
    "y-231": 1.159,
    "y-232": 1.159,
    "y-233": 1.159,
    "y-234": 1.159,
    "y-235": 1.159,
    "y-236": 1.159,
    "y-237": 1.159,
    "y-238": 1.159,
    "y-239": 1.159,
    "y-240": 1.159,
    "y-241": 1.159,
    "y-242": 1.159,
    "y-243": 1.159,
    "y-244": 1.159,
    "y-245": 1.159,
    "y-246": 1.159,
    "y-247": 1.159,
    "y-248": 1.159,
    "y-249": 1.159,
    "y-250": 1.159,
    "y-251": 1.159,
    "y-252": 1.159,
    "y-253": 1.159,
    "y-254": 1.159,
    "y-255": 1.159,
  },
  {
    x: 1.925,
    "y-2": 1.369,
    "y-12": 1.393,
    "y-46": 1.097,
    "y-1000": 1.406,
    "y-0": -0.836,
    "y-1": 1.188,
    "y-3": 1.307,
    "y-4": 1.318,
    "y-5": 1.322,
    "y-6": 1.322,
    "y-7": 1.323,
    "y-8": 1.323,
    "y-9": 1.323,
    "y-10": 1.344,
    "y-11": 1.344,
    "y-13": 1.393,
    "y-14": 1.393,
    "y-15": 1.393,
    "y-16": 1.393,
    "y-17": 1.385,
    "y-18": 1.386,
    "y-19": 1.386,
    "y-20": 1.386,
    "y-21": 1.386,
    "y-22": 1.386,
    "y-23": 1.384,
    "y-24": 1.42,
    "y-25": 1.42,
    "y-26": 1.42,
    "y-27": 1.42,
    "y-28": 1.445,
    "y-29": 1.445,
    "y-30": 1.232,
    "y-31": 1.058,
    "y-32": 1.058,
    "y-33": 1.058,
    "y-34": 1.058,
    "y-35": 1.058,
    "y-36": 1.058,
    "y-37": 1.097,
    "y-38": 1.096,
    "y-39": 1.095,
    "y-40": 1.096,
    "y-41": 1.095,
    "y-42": 1.097,
    "y-43": 1.096,
    "y-44": 1.096,
    "y-45": 1.096,
    "y-47": 1.096,
    "y-48": 1.096,
    "y-49": 1.176,
    "y-50": 1.176,
    "y-51": 1.176,
    "y-52": 1.175,
    "y-53": 1.176,
    "y-54": 1.177,
    "y-55": 1.176,
    "y-56": 1.177,
    "y-57": 1.176,
    "y-58": 1.095,
    "y-59": 1.095,
    "y-60": 1.097,
    "y-61": 1.096,
    "y-62": 1.095,
    "y-63": 1.097,
    "y-64": 1.096,
    "y-65": 1.096,
    "y-66": 1.096,
    "y-67": 1.161,
    "y-68": 1.162,
    "y-69": 1.192,
    "y-70": 1.193,
    "y-71": 1.193,
    "y-72": 1.193,
    "y-73": 1.193,
    "y-74": 1.192,
    "y-75": 1.192,
    "y-76": 1.193,
    "y-77": 1.192,
    "y-78": 1.342,
    "y-79": 1.342,
    "y-80": 1.34,
    "y-81": 1.343,
    "y-82": 1.341,
    "y-83": 1.342,
    "y-84": 1.341,
    "y-85": 1.342,
    "y-86": 1.342,
    "y-87": 1.343,
    "y-88": 1.342,
    "y-89": 1.343,
    "y-90": 1.343,
    "y-91": 1.342,
    "y-92": 1.342,
    "y-93": 1.343,
    "y-94": 1.343,
    "y-95": 1.342,
    "y-96": 1.343,
    "y-97": 1.343,
    "y-98": 1.342,
    "y-99": 1.344,
    "y-100": 1.344,
    "y-101": 1.344,
    "y-102": 1.343,
    "y-103": 1.346,
    "y-104": 1.335,
    "y-105": 1.334,
    "y-106": 1.334,
    "y-107": 1.334,
    "y-108": 1.334,
    "y-109": 1.334,
    "y-110": 1.322,
    "y-111": 1.322,
    "y-112": 1.324,
    "y-113": 1.324,
    "y-114": 1.324,
    "y-115": 1.329,
    "y-116": 1.329,
    "y-117": 1.329,
    "y-118": 1.329,
    "y-119": 1.329,
    "y-120": 1.329,
    "y-121": 1.329,
    "y-122": 1.329,
    "y-123": 1.329,
    "y-124": 1.329,
    "y-125": 1.331,
    "y-126": 1.331,
    "y-127": 1.331,
    "y-128": 1.331,
    "y-129": 1.331,
    "y-130": 1.331,
    "y-131": 1.331,
    "y-132": 1.331,
    "y-133": 1.331,
    "y-134": 1.331,
    "y-135": 1.331,
    "y-136": 1.331,
    "y-137": 1.331,
    "y-138": 1.331,
    "y-139": 1.331,
    "y-140": 1.335,
    "y-141": 1.335,
    "y-142": 1.335,
    "y-143": 1.335,
    "y-144": 1.339,
    "y-145": 1.339,
    "y-146": 1.339,
    "y-147": 1.339,
    "y-148": 1.339,
    "y-149": 1.339,
    "y-150": 1.334,
    "y-151": 1.337,
    "y-152": 1.344,
    "y-153": 1.344,
    "y-154": 1.344,
    "y-155": 1.344,
    "y-156": 1.344,
    "y-157": 1.344,
    "y-158": 1.344,
    "y-159": 1.344,
    "y-160": 1.344,
    "y-161": 1.349,
    "y-162": 1.344,
    "y-163": 1.344,
    "y-164": 1.35,
    "y-165": 1.35,
    "y-166": 1.354,
    "y-167": 1.354,
    "y-168": 1.354,
    "y-169": 1.354,
    "y-170": 1.356,
    "y-171": 1.356,
    "y-172": 1.356,
    "y-173": 1.356,
    "y-174": 1.357,
    "y-175": 1.356,
    "y-176": 1.356,
    "y-177": 1.356,
    "y-178": 1.356,
    "y-179": 1.356,
    "y-180": 1.356,
    "y-181": 1.356,
    "y-182": 1.356,
    "y-183": 1.356,
    "y-184": 1.353,
    "y-185": 1.353,
    "y-186": 1.353,
    "y-187": 1.353,
    "y-188": 1.353,
    "y-189": 1.355,
    "y-190": 1.355,
    "y-191": 1.355,
    "y-192": 1.355,
    "y-193": 1.355,
    "y-194": 1.355,
    "y-195": 1.367,
    "y-196": 1.367,
    "y-197": 1.366,
    "y-198": 1.367,
    "y-199": 1.367,
    "y-200": 1.367,
    "y-201": 1.367,
    "y-202": 1.367,
    "y-203": 1.366,
    "y-204": 1.366,
    "y-205": 1.366,
    "y-206": 1.366,
    "y-207": 1.366,
    "y-208": 1.377,
    "y-209": 1.377,
    "y-210": 1.377,
    "y-211": 1.383,
    "y-212": 1.383,
    "y-213": 1.383,
    "y-214": 1.383,
    "y-215": 1.382,
    "y-216": 1.382,
    "y-217": 1.382,
    "y-218": 1.382,
    "y-219": 1.382,
    "y-220": 1.382,
    "y-221": 1.382,
    "y-222": 1.382,
    "y-223": 1.382,
    "y-224": 1.382,
    "y-225": 1.374,
    "y-226": 1.374,
    "y-227": 1.374,
    "y-228": 1.374,
    "y-229": 1.374,
    "y-230": 1.374,
    "y-231": 1.374,
    "y-232": 1.374,
    "y-233": 1.374,
    "y-234": 1.37,
    "y-235": 1.37,
    "y-236": 1.379,
    "y-237": 1.379,
    "y-238": 1.379,
    "y-239": 1.379,
    "y-240": 1.379,
    "y-241": 1.379,
    "y-242": 1.381,
    "y-243": 1.381,
    "y-244": 1.381,
    "y-245": 1.381,
    "y-246": 1.381,
    "y-247": 1.381,
    "y-248": 1.381,
    "y-249": 1.381,
    "y-250": 1.381,
    "y-251": 1.387,
    "y-252": 1.391,
    "y-253": 1.391,
    "y-254": 1.391,
    "y-255": 1.391,
  },
  {
    x: 1.95,
    "y-2": 1.5,
    "y-12": 1.537,
    "y-46": 1.374,
    "y-1000": 1.68,
    "y-0": -0.848,
    "y-1": 1.288,
    "y-3": 1.427,
    "y-4": 1.44,
    "y-5": 1.446,
    "y-6": 1.446,
    "y-7": 1.446,
    "y-8": 1.447,
    "y-9": 1.447,
    "y-10": 1.471,
    "y-11": 1.471,
    "y-13": 1.537,
    "y-14": 1.537,
    "y-15": 1.536,
    "y-16": 1.536,
    "y-17": 1.599,
    "y-18": 1.598,
    "y-19": 1.598,
    "y-20": 1.598,
    "y-21": 1.598,
    "y-22": 1.598,
    "y-23": 1.599,
    "y-24": 1.603,
    "y-25": 1.603,
    "y-26": 1.603,
    "y-27": 1.603,
    "y-28": 1.614,
    "y-29": 1.614,
    "y-30": 1.476,
    "y-31": 1.345,
    "y-32": 1.345,
    "y-33": 1.345,
    "y-34": 1.345,
    "y-35": 1.345,
    "y-36": 1.345,
    "y-37": 1.374,
    "y-38": 1.373,
    "y-39": 1.373,
    "y-40": 1.374,
    "y-41": 1.373,
    "y-42": 1.374,
    "y-43": 1.374,
    "y-44": 1.374,
    "y-45": 1.374,
    "y-47": 1.373,
    "y-48": 1.373,
    "y-49": 1.433,
    "y-50": 1.434,
    "y-51": 1.434,
    "y-52": 1.433,
    "y-53": 1.433,
    "y-54": 1.434,
    "y-55": 1.433,
    "y-56": 1.434,
    "y-57": 1.434,
    "y-58": 1.373,
    "y-59": 1.373,
    "y-60": 1.374,
    "y-61": 1.373,
    "y-62": 1.373,
    "y-63": 1.374,
    "y-64": 1.374,
    "y-65": 1.373,
    "y-66": 1.373,
    "y-67": 1.432,
    "y-68": 1.433,
    "y-69": 1.454,
    "y-70": 1.455,
    "y-71": 1.455,
    "y-72": 1.455,
    "y-73": 1.455,
    "y-74": 1.454,
    "y-75": 1.454,
    "y-76": 1.455,
    "y-77": 1.454,
    "y-78": 1.562,
    "y-79": 1.561,
    "y-80": 1.56,
    "y-81": 1.562,
    "y-82": 1.56,
    "y-83": 1.562,
    "y-84": 1.561,
    "y-85": 1.562,
    "y-86": 1.562,
    "y-87": 1.562,
    "y-88": 1.561,
    "y-89": 1.562,
    "y-90": 1.562,
    "y-91": 1.562,
    "y-92": 1.562,
    "y-93": 1.562,
    "y-94": 1.562,
    "y-95": 1.562,
    "y-96": 1.562,
    "y-97": 1.562,
    "y-98": 1.562,
    "y-99": 1.563,
    "y-100": 1.563,
    "y-101": 1.563,
    "y-102": 1.562,
    "y-103": 1.565,
    "y-104": 1.557,
    "y-105": 1.556,
    "y-106": 1.556,
    "y-107": 1.556,
    "y-108": 1.556,
    "y-109": 1.556,
    "y-110": 1.546,
    "y-111": 1.546,
    "y-112": 1.547,
    "y-113": 1.547,
    "y-114": 1.547,
    "y-115": 1.551,
    "y-116": 1.551,
    "y-117": 1.551,
    "y-118": 1.551,
    "y-119": 1.551,
    "y-120": 1.551,
    "y-121": 1.55,
    "y-122": 1.55,
    "y-123": 1.551,
    "y-124": 1.551,
    "y-125": 1.552,
    "y-126": 1.552,
    "y-127": 1.552,
    "y-128": 1.552,
    "y-129": 1.552,
    "y-130": 1.552,
    "y-131": 1.552,
    "y-132": 1.552,
    "y-133": 1.552,
    "y-134": 1.552,
    "y-135": 1.552,
    "y-136": 1.552,
    "y-137": 1.552,
    "y-138": 1.552,
    "y-139": 1.552,
    "y-140": 1.59,
    "y-141": 1.59,
    "y-142": 1.59,
    "y-143": 1.59,
    "y-144": 1.593,
    "y-145": 1.593,
    "y-146": 1.593,
    "y-147": 1.593,
    "y-148": 1.593,
    "y-149": 1.593,
    "y-150": 1.589,
    "y-151": 1.592,
    "y-152": 1.597,
    "y-153": 1.597,
    "y-154": 1.597,
    "y-155": 1.597,
    "y-156": 1.597,
    "y-157": 1.597,
    "y-158": 1.597,
    "y-159": 1.597,
    "y-160": 1.597,
    "y-161": 1.602,
    "y-162": 1.59,
    "y-163": 1.59,
    "y-164": 1.595,
    "y-165": 1.595,
    "y-166": 1.599,
    "y-167": 1.599,
    "y-168": 1.599,
    "y-169": 1.599,
    "y-170": 1.62,
    "y-171": 1.62,
    "y-172": 1.62,
    "y-173": 1.62,
    "y-174": 1.621,
    "y-175": 1.62,
    "y-176": 1.62,
    "y-177": 1.62,
    "y-178": 1.62,
    "y-179": 1.62,
    "y-180": 1.62,
    "y-181": 1.62,
    "y-182": 1.619,
    "y-183": 1.62,
    "y-184": 1.61,
    "y-185": 1.61,
    "y-186": 1.609,
    "y-187": 1.609,
    "y-188": 1.609,
    "y-189": 1.611,
    "y-190": 1.611,
    "y-191": 1.611,
    "y-192": 1.611,
    "y-193": 1.611,
    "y-194": 1.611,
    "y-195": 1.621,
    "y-196": 1.621,
    "y-197": 1.624,
    "y-198": 1.625,
    "y-199": 1.625,
    "y-200": 1.625,
    "y-201": 1.625,
    "y-202": 1.625,
    "y-203": 1.624,
    "y-204": 1.624,
    "y-205": 1.624,
    "y-206": 1.624,
    "y-207": 1.624,
    "y-208": 1.634,
    "y-209": 1.634,
    "y-210": 1.634,
    "y-211": 1.639,
    "y-212": 1.639,
    "y-213": 1.639,
    "y-214": 1.639,
    "y-215": 1.638,
    "y-216": 1.638,
    "y-217": 1.638,
    "y-218": 1.638,
    "y-219": 1.638,
    "y-220": 1.638,
    "y-221": 1.638,
    "y-222": 1.638,
    "y-223": 1.638,
    "y-224": 1.638,
    "y-225": 1.623,
    "y-226": 1.623,
    "y-227": 1.623,
    "y-228": 1.623,
    "y-229": 1.623,
    "y-230": 1.623,
    "y-231": 1.623,
    "y-232": 1.623,
    "y-233": 1.623,
    "y-234": 1.616,
    "y-235": 1.616,
    "y-236": 1.624,
    "y-237": 1.624,
    "y-238": 1.624,
    "y-239": 1.624,
    "y-240": 1.624,
    "y-241": 1.624,
    "y-242": 1.636,
    "y-243": 1.636,
    "y-244": 1.637,
    "y-245": 1.637,
    "y-246": 1.637,
    "y-247": 1.637,
    "y-248": 1.637,
    "y-249": 1.637,
    "y-250": 1.637,
    "y-251": 1.643,
    "y-252": 1.657,
    "y-253": 1.657,
    "y-254": 1.657,
    "y-255": 1.657,
  },
  {
    x: 1.975,
    "y-2": 1.632,
    "y-12": 1.681,
    "y-46": 1.687,
    "y-1000": 1.896,
    "y-0": -0.861,
    "y-1": 1.388,
    "y-3": 1.548,
    "y-4": 1.563,
    "y-5": 1.569,
    "y-6": 1.569,
    "y-7": 1.57,
    "y-8": 1.57,
    "y-9": 1.57,
    "y-10": 1.599,
    "y-11": 1.598,
    "y-13": 1.681,
    "y-14": 1.681,
    "y-15": 1.679,
    "y-16": 1.679,
    "y-17": 1.812,
    "y-18": 1.81,
    "y-19": 1.81,
    "y-20": 1.81,
    "y-21": 1.81,
    "y-22": 1.81,
    "y-23": 1.814,
    "y-24": 1.785,
    "y-25": 1.785,
    "y-26": 1.785,
    "y-27": 1.785,
    "y-28": 1.782,
    "y-29": 1.782,
    "y-30": 1.738,
    "y-31": 1.673,
    "y-32": 1.673,
    "y-33": 1.673,
    "y-34": 1.673,
    "y-35": 1.673,
    "y-36": 1.673,
    "y-37": 1.687,
    "y-38": 1.687,
    "y-39": 1.686,
    "y-40": 1.687,
    "y-41": 1.686,
    "y-42": 1.687,
    "y-43": 1.687,
    "y-44": 1.687,
    "y-45": 1.687,
    "y-47": 1.687,
    "y-48": 1.687,
    "y-49": 1.717,
    "y-50": 1.717,
    "y-51": 1.717,
    "y-52": 1.716,
    "y-53": 1.717,
    "y-54": 1.717,
    "y-55": 1.717,
    "y-56": 1.717,
    "y-57": 1.717,
    "y-58": 1.686,
    "y-59": 1.686,
    "y-60": 1.687,
    "y-61": 1.687,
    "y-62": 1.686,
    "y-63": 1.687,
    "y-64": 1.687,
    "y-65": 1.687,
    "y-66": 1.687,
    "y-67": 1.716,
    "y-68": 1.716,
    "y-69": 1.727,
    "y-70": 1.727,
    "y-71": 1.727,
    "y-72": 1.728,
    "y-73": 1.728,
    "y-74": 1.727,
    "y-75": 1.727,
    "y-76": 1.728,
    "y-77": 1.727,
    "y-78": 1.781,
    "y-79": 1.781,
    "y-80": 1.78,
    "y-81": 1.781,
    "y-82": 1.78,
    "y-83": 1.781,
    "y-84": 1.781,
    "y-85": 1.781,
    "y-86": 1.781,
    "y-87": 1.781,
    "y-88": 1.781,
    "y-89": 1.781,
    "y-90": 1.781,
    "y-91": 1.781,
    "y-92": 1.781,
    "y-93": 1.781,
    "y-94": 1.781,
    "y-95": 1.781,
    "y-96": 1.781,
    "y-97": 1.781,
    "y-98": 1.781,
    "y-99": 1.781,
    "y-100": 1.781,
    "y-101": 1.781,
    "y-102": 1.781,
    "y-103": 1.782,
    "y-104": 1.778,
    "y-105": 1.778,
    "y-106": 1.778,
    "y-107": 1.778,
    "y-108": 1.778,
    "y-109": 1.778,
    "y-110": 1.773,
    "y-111": 1.773,
    "y-112": 1.774,
    "y-113": 1.774,
    "y-114": 1.774,
    "y-115": 1.775,
    "y-116": 1.775,
    "y-117": 1.775,
    "y-118": 1.775,
    "y-119": 1.775,
    "y-120": 1.775,
    "y-121": 1.775,
    "y-122": 1.775,
    "y-123": 1.775,
    "y-124": 1.775,
    "y-125": 1.776,
    "y-126": 1.776,
    "y-127": 1.776,
    "y-128": 1.776,
    "y-129": 1.776,
    "y-130": 1.776,
    "y-131": 1.776,
    "y-132": 1.776,
    "y-133": 1.776,
    "y-134": 1.776,
    "y-135": 1.776,
    "y-136": 1.776,
    "y-137": 1.776,
    "y-138": 1.776,
    "y-139": 1.776,
    "y-140": 1.808,
    "y-141": 1.808,
    "y-142": 1.808,
    "y-143": 1.808,
    "y-144": 1.809,
    "y-145": 1.809,
    "y-146": 1.809,
    "y-147": 1.809,
    "y-148": 1.809,
    "y-149": 1.809,
    "y-150": 1.807,
    "y-151": 1.808,
    "y-152": 1.811,
    "y-153": 1.811,
    "y-154": 1.811,
    "y-155": 1.811,
    "y-156": 1.811,
    "y-157": 1.811,
    "y-158": 1.811,
    "y-159": 1.811,
    "y-160": 1.811,
    "y-161": 1.814,
    "y-162": 1.805,
    "y-163": 1.805,
    "y-164": 1.808,
    "y-165": 1.808,
    "y-166": 1.81,
    "y-167": 1.81,
    "y-168": 1.81,
    "y-169": 1.81,
    "y-170": 1.854,
    "y-171": 1.854,
    "y-172": 1.854,
    "y-173": 1.854,
    "y-174": 1.855,
    "y-175": 1.854,
    "y-176": 1.854,
    "y-177": 1.854,
    "y-178": 1.854,
    "y-179": 1.854,
    "y-180": 1.854,
    "y-181": 1.854,
    "y-182": 1.854,
    "y-183": 1.854,
    "y-184": 1.843,
    "y-185": 1.843,
    "y-186": 1.842,
    "y-187": 1.842,
    "y-188": 1.842,
    "y-189": 1.843,
    "y-190": 1.843,
    "y-191": 1.843,
    "y-192": 1.843,
    "y-193": 1.843,
    "y-194": 1.843,
    "y-195": 1.848,
    "y-196": 1.848,
    "y-197": 1.851,
    "y-198": 1.851,
    "y-199": 1.851,
    "y-200": 1.851,
    "y-201": 1.851,
    "y-202": 1.851,
    "y-203": 1.85,
    "y-204": 1.85,
    "y-205": 1.85,
    "y-206": 1.85,
    "y-207": 1.85,
    "y-208": 1.856,
    "y-209": 1.856,
    "y-210": 1.856,
    "y-211": 1.858,
    "y-212": 1.858,
    "y-213": 1.858,
    "y-214": 1.858,
    "y-215": 1.857,
    "y-216": 1.857,
    "y-217": 1.857,
    "y-218": 1.857,
    "y-219": 1.857,
    "y-220": 1.857,
    "y-221": 1.857,
    "y-222": 1.857,
    "y-223": 1.857,
    "y-224": 1.857,
    "y-225": 1.843,
    "y-226": 1.843,
    "y-227": 1.843,
    "y-228": 1.843,
    "y-229": 1.843,
    "y-230": 1.843,
    "y-231": 1.843,
    "y-232": 1.843,
    "y-233": 1.843,
    "y-234": 1.836,
    "y-235": 1.836,
    "y-236": 1.841,
    "y-237": 1.841,
    "y-238": 1.841,
    "y-239": 1.841,
    "y-240": 1.841,
    "y-241": 1.841,
    "y-242": 1.868,
    "y-243": 1.868,
    "y-244": 1.868,
    "y-245": 1.868,
    "y-246": 1.868,
    "y-247": 1.868,
    "y-248": 1.868,
    "y-249": 1.868,
    "y-250": 1.868,
    "y-251": 1.871,
    "y-252": 1.886,
    "y-253": 1.886,
    "y-254": 1.886,
    "y-255": 1.886,
  },
  {
    x: 2.0,
    "y-2": 1.763,
    "y-12": 1.825,
    "y-46": 2.0,
    "y-1000": 2.0,
    "y-0": -0.873,
    "y-1": 1.489,
    "y-3": 1.669,
    "y-4": 1.686,
    "y-5": 1.693,
    "y-6": 1.693,
    "y-7": 1.693,
    "y-8": 1.694,
    "y-9": 1.694,
    "y-10": 1.726,
    "y-11": 1.725,
    "y-13": 1.825,
    "y-14": 1.825,
    "y-15": 1.822,
    "y-16": 1.822,
    "y-17": 2.026,
    "y-18": 2.023,
    "y-19": 2.023,
    "y-20": 2.023,
    "y-21": 2.023,
    "y-22": 2.023,
    "y-23": 2.029,
    "y-24": 1.967,
    "y-25": 1.967,
    "y-26": 1.967,
    "y-27": 1.967,
    "y-28": 1.951,
    "y-29": 1.951,
    "y-30": 2.0,
    "y-31": 2.0,
    "y-32": 2.0,
    "y-33": 2.0,
    "y-34": 2.0,
    "y-35": 2.0,
    "y-36": 2.0,
    "y-37": 2.0,
    "y-38": 2.0,
    "y-39": 2.0,
    "y-40": 2.0,
    "y-41": 2.0,
    "y-42": 2.0,
    "y-43": 2.0,
    "y-44": 2.0,
    "y-45": 2.0,
    "y-47": 2.0,
    "y-48": 2.0,
    "y-49": 2.0,
    "y-50": 2.0,
    "y-51": 2.0,
    "y-52": 2.0,
    "y-53": 2.0,
    "y-54": 2.0,
    "y-55": 2.0,
    "y-56": 2.0,
    "y-57": 2.0,
    "y-58": 2.0,
    "y-59": 2.0,
    "y-60": 2.0,
    "y-61": 2.0,
    "y-62": 2.0,
    "y-63": 2.0,
    "y-64": 2.0,
    "y-65": 2.0,
    "y-66": 2.0,
    "y-67": 2.0,
    "y-68": 2.0,
    "y-69": 2.0,
    "y-70": 2.0,
    "y-71": 2.0,
    "y-72": 2.0,
    "y-73": 2.0,
    "y-74": 2.0,
    "y-75": 2.0,
    "y-76": 2.0,
    "y-77": 2.0,
    "y-78": 2.0,
    "y-79": 2.0,
    "y-80": 2.0,
    "y-81": 2.0,
    "y-82": 2.0,
    "y-83": 2.0,
    "y-84": 2.0,
    "y-85": 2.0,
    "y-86": 2.0,
    "y-87": 2.0,
    "y-88": 2.0,
    "y-89": 2.0,
    "y-90": 2.0,
    "y-91": 2.0,
    "y-92": 2.0,
    "y-93": 2.0,
    "y-94": 2.0,
    "y-95": 2.0,
    "y-96": 2.0,
    "y-97": 2.0,
    "y-98": 2.0,
    "y-99": 2.0,
    "y-100": 2.0,
    "y-101": 2.0,
    "y-102": 2.0,
    "y-103": 2.0,
    "y-104": 2.0,
    "y-105": 2.0,
    "y-106": 2.0,
    "y-107": 2.0,
    "y-108": 2.0,
    "y-109": 2.0,
    "y-110": 2.0,
    "y-111": 2.0,
    "y-112": 2.0,
    "y-113": 2.0,
    "y-114": 2.0,
    "y-115": 2.0,
    "y-116": 2.0,
    "y-117": 2.0,
    "y-118": 2.0,
    "y-119": 2.0,
    "y-120": 2.0,
    "y-121": 2.0,
    "y-122": 2.0,
    "y-123": 2.0,
    "y-124": 2.0,
    "y-125": 2.0,
    "y-126": 2.0,
    "y-127": 2.0,
    "y-128": 2.0,
    "y-129": 2.0,
    "y-130": 2.0,
    "y-131": 2.0,
    "y-132": 2.0,
    "y-133": 2.0,
    "y-134": 2.0,
    "y-135": 2.0,
    "y-136": 2.0,
    "y-137": 2.0,
    "y-138": 2.0,
    "y-139": 2.0,
    "y-140": 2.0,
    "y-141": 2.0,
    "y-142": 2.0,
    "y-143": 2.0,
    "y-144": 2.0,
    "y-145": 2.0,
    "y-146": 2.0,
    "y-147": 2.0,
    "y-148": 2.0,
    "y-149": 2.0,
    "y-150": 2.0,
    "y-151": 2.0,
    "y-152": 2.0,
    "y-153": 2.0,
    "y-154": 2.0,
    "y-155": 2.0,
    "y-156": 2.0,
    "y-157": 2.0,
    "y-158": 2.0,
    "y-159": 2.0,
    "y-160": 2.0,
    "y-161": 2.0,
    "y-162": 2.0,
    "y-163": 2.0,
    "y-164": 2.0,
    "y-165": 2.0,
    "y-166": 2.0,
    "y-167": 2.0,
    "y-168": 2.0,
    "y-169": 2.0,
    "y-170": 2.0,
    "y-171": 2.0,
    "y-172": 2.0,
    "y-173": 2.0,
    "y-174": 2.0,
    "y-175": 2.0,
    "y-176": 2.0,
    "y-177": 2.0,
    "y-178": 2.0,
    "y-179": 2.0,
    "y-180": 2.0,
    "y-181": 2.0,
    "y-182": 2.0,
    "y-183": 2.0,
    "y-184": 2.0,
    "y-185": 2.0,
    "y-186": 2.0,
    "y-187": 2.0,
    "y-188": 2.0,
    "y-189": 2.0,
    "y-190": 2.0,
    "y-191": 2.0,
    "y-192": 2.0,
    "y-193": 2.0,
    "y-194": 2.0,
    "y-195": 2.0,
    "y-196": 2.0,
    "y-197": 2.0,
    "y-198": 2.0,
    "y-199": 2.0,
    "y-200": 2.0,
    "y-201": 2.0,
    "y-202": 2.0,
    "y-203": 2.0,
    "y-204": 2.0,
    "y-205": 2.0,
    "y-206": 2.0,
    "y-207": 2.0,
    "y-208": 2.0,
    "y-209": 2.0,
    "y-210": 2.0,
    "y-211": 2.0,
    "y-212": 2.0,
    "y-213": 2.0,
    "y-214": 2.0,
    "y-215": 2.0,
    "y-216": 2.0,
    "y-217": 2.0,
    "y-218": 2.0,
    "y-219": 2.0,
    "y-220": 2.0,
    "y-221": 2.0,
    "y-222": 2.0,
    "y-223": 2.0,
    "y-224": 2.0,
    "y-225": 2.0,
    "y-226": 2.0,
    "y-227": 2.0,
    "y-228": 2.0,
    "y-229": 2.0,
    "y-230": 2.0,
    "y-231": 2.0,
    "y-232": 2.0,
    "y-233": 2.0,
    "y-234": 2.0,
    "y-235": 2.0,
    "y-236": 2.0,
    "y-237": 2.0,
    "y-238": 2.0,
    "y-239": 2.0,
    "y-240": 2.0,
    "y-241": 2.0,
    "y-242": 2.0,
    "y-243": 2.0,
    "y-244": 2.0,
    "y-245": 2.0,
    "y-246": 2.0,
    "y-247": 2.0,
    "y-248": 2.0,
    "y-249": 2.0,
    "y-250": 2.0,
    "y-251": 2.0,
    "y-252": 2.0,
    "y-253": 2.0,
    "y-254": 2.0,
    "y-255": 2.0,
  },
];
